const cs = {
  /* Zájemci, prohlídky a předání financím
     (pages/RealityZajemciPage.js + pages/ProhlidkaPrihlaskaPage.js).
     Klíče `ver*` mluví na ZÁJEMCE — bez odborných slov, krátké věty.
     Zbytek mluví na makléře. Znění samotných souhlasů tu NENÍ: chodí ze
     serveru (backend/lib/reality_souhlas.py), protože se ukládá jeho otisk
     a ten musí sedět s tím, co člověk doopravdy viděl. */
  realZaj: {
    nadpis: "Zájemci a prohlídky",
    nacitam: "Načítám…",
    chyba: "Nepovedlo se to. Zkuste to prosím znovu.",
    terminy: "Termíny prohlídek",
    terminyPopis: "Vypište jeden termín a pošlete odkaz. Zájemci se přihlásí sami.",
    vypsatTermin: "Vypsat termín",
    termin: "Termín",
    delka: "Minut",
    kapacita: "Kolik lidí",
    ulozit: "Uložit",
    zadneTerminy: "Zatím jste nevypsal žádný termín.",
    volno: "Volno {n} z {z}",
    neplatny: "Odkaz už neplatí",
    vDiari: "V diáři",
    kopirovat: "Kopírovat odkaz",
    zkopirovano: "Zkopírováno",
    zneplatnit: "Zneplatnit",
    zajemci: "Zájemci",
    pridatZajemce: "Přidat zájemce",
    rozesilka: "Další nabídky smí dostat {n} z {z} zájemců.",
    jmeno: "Jméno",
    telefon: "Telefon",
    email: "E-mail",
    rucneBezSouhlasu: "Ručně zapsaný zájemce nemá souhlas — ten dá jen sám na přihlášce.",
    nikdoTu: "Tady zatím nikdo není.",
    bezJmena: "Bez jména",
    stav: "Krok",
    financovani: "Financování",
    okamzik: "Kdy předat",
    predatPoradci: "Předat poradci",
    predanoPoradci: "Předáno poradci",
    bezSouhlasuNejde: "Bez souhlasu zájemce to nejde. Pošlete mu odkaz na přihlášku, kde si o to řekne sám.",
    odvolat: "Odvolat souhlas",
    smazatPotvrzeni: "Smazat zájemce i jeho údaje? Předávky zůstanou, ale bez osobních údajů.",
    souhlasPoradci: "Souhlas s poradcem",
    souhlasAno: "Souhlas s nabídkami",
    souhlasNe: "Bez souhlasu",
    souhlasNezeptano: "Nezeptáno",
    souhlasOdvolan: "Souhlas odvolán",
    souhlasImport: "Ze staré databáze",
    predani: "Předání financím",
    zadnePredavky: "Zatím jste nikoho nepředal.",
    odmenaNenastavena: "Odměna nenastavena",
    odmenaVysvetleni: "Dokud není vybrané, z čeho se podíl počítá, systém částku nedopočítá.",
    zpetNaNemovitost: "Zpět na nemovitost",
    smlouvaZalozit: "Rezervační smlouva",
    smlouvaOtevrit: "Otevřít rezervační smlouvu",
    smlouvaPodepsana: "Rezervační smlouva podepsaná",
    fin: {
      neptal_jsem_se: "Nezeptal jsem se",
      hotovost: "Hotovost",
      hypoteka: "Hypotéka",
      nevim: "Neví",
    },
    predavkaStav: {
      navrzena: "Čeká na poradce",
      odeslana: "Odesláno",
      prijata: "Poradce převzal",
      odmitnuta: "Poradce odmítl",
      propadla: "Propadlo",
    },
    verNadpis: "Přihláška na prohlídku",
    verNacitam: "Načítám…",
    verNeplatnyNadpis: "Odkaz neplatí",
    verNeplatny: "Termín už neplatí nebo je pryč. Ozvěte se prosím makléři.",
    verJazyk: "Jazyk",
    verJmeno: "Jméno a příjmení",
    verTelefon: "Telefon",
    verEmail: "E-mail",
    verPlno: "Tenhle termín je už plný. Ozvěte se makléři.",
    verOdeslat: "Přihlásit se na prohlídku",
    verOdesilam: "Odesílám…",
    verPovinne: "Bez prvního zaškrtnutí přihlášku uložit nemůžeme.",
    verChybiKontakt: "Nechte prosím telefon nebo e-mail, ať se vám máme jak ozvat.",
    verChyba: "Nepovedlo se to odeslat. Zkuste to prosím znovu.",
    verHotovo: "Máte to.",
    verHotovoPoradce: "Ozve se vám i hypoteční specialista.",
  },
  /* Kalkulačka na veřejné stránce nemovitosti
     (components/nemovitost/KalkulackaNemovitosti.js). Mluví na KLIENTA,
     ne na poradce — krátké věty, žádný odborný slovník. */
  nemKalk: {
    otazka: "Kupujete pro sebe, nebo jako investici?",
    proSebe: "Pro sebe",
    jakoInvestici: "Jako investici",
    vlastni: "Vlastní zdroje",
    sazba: "Úroková sazba",
    splatnost: "Splatnost",
    najem: "Očekávaný měsíční nájem",
    splatkaPopis: "měsíční splátka",
    vetaSplatka: "Při {podil} vlastních potřebujete {vlastni} a splátka bude {splatka} měsíčně.",
    hruby: "Hrubý výnos",
    cisty: "Čistý výnos",
    cashflow: "Měsíční cashflow",
    vetaMinus: "Nájem nepokryje splátku ani náklady — každý měsíc doplatíte {castka}.",
    vetaPlus: "Po splátce a nákladech vám z nájmu každý měsíc zbyde {castka}.",
    vetaNajem: "Zadejte očekávaný nájem — bez něj se výnos spočítat nedá.",
    predpoklady: "Počítáno s provozními náklady {naklady} měsíčně, obsazeností {mesicu} z 12 měsíců a s daní z nájmu 15 % ze 70 % příjmu.",
    orientacni: "Orientační propočet, ne nabídka ani garance. Skutečnou sazbu určí banka podle vaší bonity.",
    zaM2: "{cena} za m²",
    rokOne: "{n} rok",
    rokFew: "{n} roky",
    rokMany: "{n} let",
  },
  /* Realitni zakazky (/zakazky). Klice musi byt ve VSECH peti slovnicich —
     t() na chybejicim klici tise vrati klic a na obrazovce sviti `zakazky.nazev`.
     Hlida to frontend/src/__tests__/klicVeSlovniku.test.js. */
  /* Poptávka na NÁKUP nemovitosti — karta kupujícího (/poptavky/:id).
     Fáze musí sedět na `PRODUCT_FLOWS["koupe_nemovitosti"]` na serveru. */
  poptavka: {
    prohlidka: 'Prohlídka',
    dorazil: 'dorazil',
    nedorazil: 'nedorazil',
    teplotaVlazno: 'Stojí dlouho — ozvi se kupujícímu',
    teplotaHorko: 'Stojí moc dlouho — kupující se neozývá',
    stitek: 'Poptávka na nákup',
    zpetNaPipeline: 'Zpět na realitní pipeline',
    otevritObchod: 'Historie případu',
    otevritKlienta: 'Složka klienta',
    followUp: 'Follow-up',
    nenalezena: 'Tahle poptávka neexistuje nebo není tvoje.',
    faze0: 'Ozval se',
    faze1: 'Prohlídka domluvená',
    faze2: 'Byl na prohlídce',
    faze3: 'Vážný zájem',
    faze4: 'Rezervace',
    faze5: 'Kupní smlouva',
    faze6: 'Předání',
    ukol0: 'Zavolat a zjistit, co přesně hledá a z čeho to zaplatí.',
    ukol1: 'Potvrdit termín a poslat adresu.',
    ukol2: 'Zeptat se na financování a ozvat se do tří dnů.',
    ukol3: 'Než půjde rezervace, ať financování někdo řeší.',
    ukol4: 'Sepsat rezervační smlouvu k vybrané nemovitosti.',
    ukol5: 'Předat podklady advokátovi a hlídat termíny.',
    ukol6: 'Předat klíče a uzavřít případ.',
    akce0: 'Nabídnout nemovitost',
    akce1: 'Potvrdit termín prohlídky',
    akce2: 'Zapsat, z čeho to zaplatí',
    akce3: 'Zařídit hypotéku',
    akce4: 'Sepsat rezervační smlouvu',
    akce5: 'Poslat smlouvu advokátovi',
    akce6: 'Předat klíče',
    coHleda: 'Co hledá',
    doptatSe: 'Ještě se zeptat na:',
    typ: 'Druh nemovitosti',
    typNevybrano: 'Neurčeno',
    lokalita: 'Lokalita',
    lokalitaPlaceholder: 'Brno-střed, do 20 minut od centra…',
    rozpocet: 'Nejvíc chce dát',
    dispozice: 'Dispozice',
    dispoziceAtypicke: 'Atypické',
    nabidnoutPoradce: 'Hypotéku bude nejspíš potřebovat — domluv mu poradce dřív, než dojde na rezervaci.',
    nabidky: 'Co jsme mu nabídli',
    nabidnuto: 'Nabídnuto: {n}',
    zadneNabidky: 'Zatím jsme mu nic nenabídli.',
    coJesteMuzeme: 'Co mu ještě můžeme nabídnout',
    zadneDoporucene: 'Všechny tvoje nemovitosti už zná.',
    nabidnout: 'Nabídnout',
    stahnout: 'Stáhnout',
    nemovitostPryc: 'Nemovitost už není v systému',
    nabidkaStazena: 'Nabídka stažena.',
    ulozeno: 'Uloženo.',
    chybaUlozeni: 'Uložit se to nepodařilo.',
    chybaFaze: 'Fázi se nepodařilo posunout.',
    chybaNabidky: 'S nabídkou se něco nepovedlo.',
    chybaSeznamu: 'Poptávky na nákup se nepodařilo načíst.',
  },
  zakazky: {
    novaPoptavka: 'Nový kupující',
    filtrProdej: 'Prodej',
    filtrNakup: 'Nákup',
    nabidnutoKupujicim: 'Nabídnuto kupujícím',
    otevritPoptavku: 'Otevřít poptávku',
    poptavkaPryc: 'Poptávka už není',
    neaktivni: 'Prodej zastaven',
    tymUlozit: 'Uložit tým',
    neulozeno: 'Neuloženo',
    tymZavolat: 'Zavolat',
    osaOdkaz: 'Odkaz pro zájemce',
    historieVse: 'Zobrazit celou historii',
    historieMene: 'Zobrazit jen poslední',
    /* Realitni pipeline (/reality) + prokliky z karty. */
    /* Souhrnne dlazdice nad realitni pipeline (vzor: hypotecni pipeline). */
    bezNemovitosti: "K tomuhle obchodu není navázaná žádná nemovitost. Adresu, zájemce ani inzerát proto nemá kde vzít — založ nemovitost v realitním přehledu.",
    souhrnProdej: "V prodeji",
    souhrnProdejSub: "celkový objem {v}",
    souhrnNakup: "Kupující",
    souhrnNakupSub: "hledají nemovitost",
    souhrnStoji: "Stojí dlouho",
    souhrnStojiSub: "ozvi se, než se ozvou oni",
    souhrnHotovo: "Dokončeno",
    souhrnHotovoSub: "předáno a uzavřeno",
    souhrnNic: "—",
    pipelineNazev: 'Realitní pipeline',
    pipelinePodnadpis: 'Kde stojí každá nemovitost a jak dlouho už tam stojí',
    pipelineSeznam: 'Seznam a nová zakázka',
    pipelineOtevrit: 'Otevřít pipeline',
    prodatNechat: 'Prodat, nebo nechat?',
    prodatNechatSub: 'Orientační propočet pro majitele — prodat teď, nebo pronajímat',
    sloupecNemovitost: 'Nemovitost',
    sloupecFaze: 'Fáze',
    sloupecStani: 'Ve fázi',
    sloupecDalsiKrok: 'Další krok',
    sloupecCena: 'Cena',
    denOne: '{n} den',
    denFew: '{n} dny',
    denMany: '{n} dní',
    teplotaVlazno: 'Stojí dlouho — ozvi se majiteli',
    teplotaHorko: 'Stojí moc dlouho — majitel neví, co se děje',
    filtrVse: 'Vše',
    filtrStoji: 'Stojí dlouho',
    stojiPocet: 'Stojí dlouho: {n}',
    coTed: 'Co teď udělat',
    akce0: 'Vyžádat od majitele podklady',
    akce1: 'Domluvit fotografa',
    akce2: 'Zveřejnit inzerci',
    akce3: 'Vypsat termín prohlídky',
    akce4: 'Sepsat rezervační smlouvu',
    akce5: 'Předat smlouvu advokátovi',
    akce6: 'Předat kupujícího poradci',
    zajemci: 'Zájemci a prohlídky',
    smlouvy: 'Rezervační smlouva',
    tym: 'Kdo na tom dělá',
    tymSub: 'Fotograf, poradce, advokát. Ať víš, komu volat, když se to zadrhne.',
    tymPrazdno: 'Zatím nikdo.',
    tymPridat: 'Přidat člověka',
    tymRole: 'Role',
    tymJmeno: 'Jméno',
    tymTelefon: 'Telefon',
    tymOdebrat: 'Odebrat',
    tymUlozeno: 'Tým uložen',
    tymBezObchodu: 'Tým se ukládá k obchodu a ten téhle zakázce chybí.',
    roleMakler: 'Makléř',
    roleFotograf: 'Fotograf',
    rolePoradce: 'Finanční poradce',
    roleAdvokat: 'Advokát',
    roleJine: 'Jiná role',
    osa: 'Časová osa',
    osaSub: 'Kdy focení, kdy inzerce, kdy které prohlídky. Tohle odpovídá majiteli na otázku, co se děje.',
    osaHotovo: 'Hotovo',
    osaNestalo: 'Zatím se nestalo',
    osaUlozit: 'Uložit osu',
    osaProhlidky: 'Prohlídky',
    osaProhlidkyPrazdno: 'Zatím není vypsaný žádný termín.',
    osaPrihlaseno: 'přihlášeno',
    osaVypsat: 'Vypsat prohlídku',
    mkPriprava: 'Příprava a focení',
    mkInzerce: 'Inzerce na portálech',
    mkSite: 'Sociální sítě',
    mkPlacenaReklama: 'Placená reklama',
    mkPr: 'Offline PR',
    historie: 'Co komu odešlo',
    historieSub: 'Zápisy z obchodu — e-maily majiteli, posuny fází, tvoje poznámky.',
    historiePrazdno: 'Zatím nic.',
    historiePridat: 'Zapsat hovor nebo zprávu',
    historieUlozit: 'Zapsat',
    historieZapsano: 'Zapsáno do obchodu',
    nazev: 'Zakázky',
    podnadpis: 'Nemovitosti, které prodáváš, a kde v procesu jsou',
    nova: 'Nová zakázka',
    nacitam: 'Načítám…',
    chyba: 'Nepodařilo se načíst zakázky.',
    zadne: 'Zatím žádná zakázka',
    zadneSub: 'Založ první nemovitost — adresa, majitel, cena. Zbytek doplníš za pochodu.',
    hledat: 'Hledat adresu nebo majitele',
    typ: 'Typ nemovitosti',
    typByt: 'Byt',
    typDum: 'Dům',
    typPozemek: 'Pozemek',
    typKomercni: 'Komerční',
    vlastnictvi: 'Vlastnictví',
    vlastnictviOsobni: 'Osobní',
    vlastnictviDruzstevni: 'Družstevní',
    vlastnictviHint: 'Družstevní bydlení má jiný vzor rezervační smlouvy.',
    adresa: 'Adresa',
    adresaHint: 'Ulice, číslo popisné a město. Tohle pak čerpá smlouva i inzerát.',
    majitel: 'Majitel',
    vyberMajitele: 'Vyber majitele z kontaktů',
    majitelHint: 'Prodávající. Musí být v kontaktech — zakázka se na něj váže.',
    cenaNabidkova: 'Nabídková cena',
    cenaOdhad: 'Tržní odhad',
    cenaHint: 'Prázdné pole znamená nenaceněno, ne nula.',
    lvCislo: 'Číslo listu vlastnictví',
    katUzemi: 'Katastrální území',
    podepsano: 'Zprostředkovatelská podepsána',
    exkluzivitaDo: 'Exkluzivita do',
    exkluzivitaHint: 'Se spotřebitelem nejvýš 6 měsíců (§ 17 z. 39/2020).',
    provizePct: 'Provize (%)',
    stitek: 'Energetický štítek',
    stitekMa: 'Má ho',
    stitekChybi: 'Chybí',
    stitekObjednano: 'Objednán',
    poznamka: 'Poznámka',
    nezadano: 'Nezadáno',
    zalozit: 'Založit zakázku',
    zrusit: 'Zrušit',
    ulozit: 'Uložit',
    ulozeno: 'Uloženo',
    krok: 'Krok',
    dalsiKrok: 'Další krok',
    hotovoKrok: 'Hotovo, další krok',
    zpetKrok: 'O krok zpět',
    dokonceno: 'Zakázka dokončena',
    hotovoStav: 'hotovo',
    cekaStav: 'čeká',
    tedStav: 'teď',
    bezObchodu: 'Tahle zakázka nemá obchod, takže se fáze nemá kam zapsat. Založ ji znovu.',
    kdeJsme: 'Kde v procesu jsme',
    faze0: 'Nábor',
    faze1: 'Příprava',
    faze2: 'Inzerce',
    faze3: 'Prohlídky',
    faze4: 'Rezervace',
    faze5: 'Kupní smlouva',
    faze6: 'Předání',
    ukol0: 'Podepsat zprostředkovatelskou smlouvu, zkontrolovat katastr a vyžádat si od majitele podklady.',
    ukol1: 'Domluvit fotografa, připravit půdorys a home staging, zařídit energetický štítek.',
    ukol2: 'Zveřejnit nabídku na portálech a sítích. Odkazy si ulož k zakázce.',
    ukol3: 'Domlouvat prohlídky, ptát se na způsob financování a zapisovat zájemce.',
    ukol4: 'Sepsat rezervační smlouvu, vybrat blokační poplatek a poslat ji advokátovi.',
    ukol5: 'Advokát připravuje kupní smlouvu. Hlídej fázi a průběžně informuj majitele.',
    ukol6: 'Zapsat stavy měřidel, podepsat předávací protokol a přepsat smlouvy na nového vlastníka.',
    komunikace: 'Co pošleme majiteli',
    komunikaceSub: 'Text složí systém. Odeslat ho můžeš odsud, nebo si ho zkopíruj a pošli po svém.',
    podklady: 'Vyžádat podklady',
    podkladySub: 'Jeden odkaz, ve kterém majitel vyplní údaje z občanky, e-mail a telefon. Fotku dokladu po něm nechceme.',
    uvitani: 'Uvítání a plán',
    uvitaniSub: 'Majitel hned první den ví, co se bude dít — focení, inzerce, sítě, placená reklama, PR.',
    nahled: 'Náhled zprávy',
    kopirovat: 'Zkopírovat text',
    zkopirovano: 'Zkopírováno',
    vEmailu: 'Otevřít v e-mailu',
    odeslatJmenem: 'Odeslat mým jménem',
    odesilam: 'Odesílám…',
    odeslanoNa: 'Odesláno na',
    neodeslano: 'Neodesláno — nemáš připojený e-mail. Text si zkopíruj a pošli po svém.',
    bezEmailu: 'Majitel nemá v kontaktu e-mail. Doplň ho a zkus to znovu.',
    odkazProMajitele: 'Odkaz pro majitele',
    platiDo: 'Platí do',
    udaje: 'Údaje o zakázce',
    zpetNaSeznam: 'Zpět na zakázky',
    smazat: 'Smazat zakázku',
    smazatPotvrd: 'Smazat zakázku? Obchod s historií jednání zůstane.',
    smazano: 'Zakázka smazána',
    nenalezena: 'Zakázka nenalezena.',
  },
  /* Tri odkazy pro klienty (web nemovitosti /n/:slug, stav prodeje pro
     majitele /z/:token, podklady /f/:token) + obe verejne stranky. */
  nemWeb: {
    sekce: 'Odkazy pro klienty',
    sekceSub: 'Tři stránky, které si klient otevře bez přihlášení. Vyrobíš je jedním kliknutím.',
    nenacetlo: 'Odkazy se nepodařilo načíst. Zkus obnovit stránku.',
    webNazev: 'Web nemovitosti',
    webSub: 'Fotky, popis a propočet pro kupující. Adresu jde nadiktovat do telefonu.',
    majitelNazev: 'Stav prodeje pro majitele',
    majitelSub: 'Soukromá stránka, kde majitel vidí, co se děje. Píše se sama z toho, co odklikáš.',
    podkladyNazev: 'Podklady od majitele',
    podkladyZnovu: 'Ukázat znovu',
    zatimNevyrobeno: 'Zatím nevyrobeno',
    vyrobit: 'Vyrobit odkaz',
    vyrobeno: 'Vyrobeno',
    otevrit: 'Otevřít',
    kopirovat: 'Zkopírovat odkaz',
    odeslatMajiteli: 'Poslat majiteli',
    odeslano: 'Odesláno',
    zatimNeodeslano: 'Zatím neodesláno',
    zverejneno: 'Zveřejněno',
    jenProTebe: 'Zatím jen pro tebe',
    zverejnit: 'Zveřejnit',
    skryt: 'Skrýt',
    platny: 'Platný',
    propadly: 'Propadlý',
    obnovit: 'Vyrobit nový',
    obnovitPotvrd: 'Vyrobit nový odkaz? Ten starý přestane platit a majiteli se stránka z e-mailu už neotevře.',
    fotky: 'Fotky',
    fotkyPrazdno: 'Zatím žádná fotka.',
    fotkyPridat: 'Přidat fotky',
    fotkyOdebrat: 'Odebrat',
    fotkyOdmitnuto: 'Nenahrálo se:',
    /* Dotazník inzerátu — osm otázek, ze kterých server složí text.
       Příklad v `Hint` je OBSAH, ne ozdoba: je to jediné místo, kde se makléř
       dozví, jak podrobná odpověď se čeká. */
    dotaznikNadpis: 'Krátký dotazník',
    dotaznikSub: 'Odpověz krátce na osm otázek. Systém z nich složí nadpis i popis — a ty ho pak můžeš přepsat.',
    oDispozice: 'Dispozice',
    oDispoziceHint: 'např. 3+1, 2+kk, garsoniéra',
    oPlochaM2: 'Plocha (m²)',
    oPlochaM2Hint: 'např. 78',
    oPatro: 'Patro',
    oPatroHint: 'např. 2. patro z 5, výtah',
    oStav: 'Stav',
    oStavHint: 'např. po rekonstrukci 2023 / původní, k nastěhování',
    oNejlepsi: 'Co je na tom nejlepší?',
    oNejlepsiHint: 'např. velký balkon s výhledem do parku',
    oProKoho: 'Pro koho se to hodí?',
    oProKohoHint: 'např. rodina s jedním až dvěma dětmi',
    oOkoli: 'Co je v okolí?',
    oOkoliHint: 'např. školka 200 m, tramvaj, park',
    oProcProdava: 'Proč majitel prodává?',
    oProcProdavaHint: 'např. stěhují se za prací',
    oProcProdavaVarovani: 'Píše se to do inzerátu. Citlivý důvod (rozvod, dluhy) sem nepiš — sráží cenu a je to údaj o majiteli, ne o nemovitosti.',
    slozit: 'Složit text z odpovědí',
    slozeno: 'Text složil systém',
    slozenoRucne: 'Text jsi psal(a) ty',
    slozitPotvrd: 'Přepsat text, který jsi psal(a) ručně? Složí se znovu z odpovědí.',
    chybi: 'V textu chybí — doplň a slož znovu:',
    nadpisPole: 'Nadpis inzerátu',
    lokalita: 'Lokalita',
    fotkyPoradi: 'První fotka je hlavní. Přetáhni ji na začátek, nebo použij Dát jako hlavní.',
    fotkyHlavni: 'Hlavní',
    fotkyDatHlavni: 'Dát jako hlavní',
    cena: 'Cena',
    najem: 'Nájem v okolí',
    najemHint: 'Nájem se ukazuje jen v propočtu pro kupujícího. Když ho neznáš, nech pole prázdné.',
    popis: 'Popis nemovitosti',
    ulozitText: 'Uložit text inzerátu',
    nacitam: 'Načítám…',
    neplatny: 'Tahle nabídka není dostupná. Požádejte makléře o nový odkaz.',
    neplatnyMajitel: 'Tahle stránka není dostupná. Požádejte makléře o nový odkaz.',
    propocet: 'Co to znamená měsíčně',
    zajemNadpis: 'Chci na prohlídku',
    zajemSub: 'Nechte kontakt a makléř se vám ozve s termínem.',
    zajemHotovo: 'Děkujeme, makléř se vám ozve.',
    zajemOdeslat: 'Odeslat',
    odesilam: 'Odesílám…',
    jmeno: 'Jméno',
    telefon: 'Telefon',
    email: 'E-mail',
    vzkaz: 'Vzkaz (nepovinné)',
    chybiJmeno: 'Napište prosím jméno.',
    chybiKontakt: 'Nechte prosím telefon nebo e-mail, ať se vám máme jak ozvat.',
    chybaOdeslani: 'Odeslání se nepovedlo. Zkuste to prosím znovu.',
    kontaktNadpis: 'Nabídku vede',
    zavrit: 'Zavřít',
    majitelNadpis: 'Prodej vaší nemovitosti',
    majitelPata: 'Stránka se aktualizuje sama. Podívejte se, kdykoliv budete chtít.',
    zatimNic: 'Zatím tu není co ukázat. Jakmile se něco stane, uvidíte to tady.',
    veFazi: 'v téhle fázi',
    zajemceOne: 'zájemce',
    zajemceFew: 'zájemci',
    zajemceMany: 'zájemců',
    prohlidkaOne: 'proběhlá prohlídka',
    prohlidkaFew: 'proběhlé prohlídky',
    prohlidkaMany: 'proběhlých prohlídek',
    prohlidkyChystane: 'chystané:',
    prohlidkyNadpis: 'Prohlídky',
    prohlidkaChysta: 'chystá se',
    krokyNadpis: 'Co pro prodej děláme',
    krokChysta: 'chystá se',
    tymNadpis: 'Kdo se o prodej stará',
    inzeratOtevrit: 'Otevřít inzerát',
    inzeratPopis: 'Takhle nemovitost vidí zájemci',
  },
  webui: {
    bookNow: "Rezervovat",
    bookFree: "Domluvit schůzku zdarma",
    bookMeeting: "Domluvit schůzku",
    advisorRole: "Tvůj finanční poradce",
    freeSlots: "Volné termíny tento týden",
    downloadFree: "Stáhnout zdarma",
    services: "Služby",
    scroll: "scroll",
    readyToTalk: "Připraven si promluvit?",
    firstMeetingFree: "První schůzka je zdarma · 30 minut online",
    webNotFound: "Web nenalezen nebo není zveřejněn.",
    loadingError: "Chyba načítání",
    backHome: "Zpět na beplan University",
    retry: "Zkusit znovu",
    webLoadFailed: "Web se teď nepodařilo načíst. Zkontrolujte připojení a zkuste to znovu.",
    lmEmailLabel: "E-mail",
    bookingMeta: "Online přes Google Meet · Zdarma a nezávazně · Trvá zhruba 30 minut",
    bookingHint: "První schůzka zdarma. Stačí vybrat termín a připravit si své dotazy.",
    bookSlotBtn: "Rezervovat termín",
    // ovládací prvky (a11y)
    musicPlay: "Pustit hudbu",
    musicMute: "Ztlumit hudbu",
    themeToDark: "Přepnout na tmavý",
    themeToLight: "Přepnout na světlý",
    playIntroVideo: "Pustit intro video",
    whatsappWrite: "Napsat přes WhatsApp",
    // sekce
    servicesHeading: "S čím ti umím pomoct",
    aboutEyebrow: "O mně",
    dayEyebrow: "Den se mnou",
    dayHeading: "Takhle vypadá můj den",
    testimonialsEyebrow: "Reference",
    testimonialsHeading: "Co říkají klienti",
    testimonialItem: "Reference",
    testimonialPrev: "Předchozí reference",
    testimonialNext: "Další reference",
    quoteOpen: "„",
    quoteClose: "“",
    bookingEyebrow: "Rezervace",
    bookingHeading: "Vyber si termín schůzky",
    bookingInactive: "Online rezervace zatím není aktivní. Kontaktuj poradce přímo:",
    faqHeading: "Nejčastější otázky",
    partnersLabel: "Spolupracuji s",
    finalCtaHeading: "Pojďme si promluvit",
    writeEmail: "Napsat email",
    // patička
    digitalCard: "Digitální vizitka",
    privacy: "Soukromí",
    madeIn: "Vytvořeno v beplan University",
    // galerie / příběhy klientů (a11y)
    prev: "Předchozí",
    next: "Další",
    close: "Zavřít",
    storyPrev: "Předchozí příběh",
    storyNext: "Další příběh",
    storyItem: "Příběh",
    // proces (horizontální sekce)
    processEyebrow: "Jak spolupráce probíhá",
    processHeadingSuffix: "k jasným financím",
    processScrollHint: "Scrolluj dolů – karty plynou doprava",
    processNextStep: "Další krok",
    stepOne: "krok",
    stepFew: "kroky",
    stepMany: "kroků",
    // výchozí kroky procesu (poradce si je může přepsat v nastavení webu)
    step1Title: "První kontakt",
    step1Desc: "Stačí kliknout na rezervaci nebo zavolat. Řekneme si co řešíš.",
    step2Title: "Analýza tvé situace",
    step2Desc: "Zdarma ti sestavím přehled – kde jsi, co máš, co ti chybí.",
    step3Title: "Návrh plánu",
    step3Desc: "Dostaneš konkrétní kroky na míru – hypotéka, pojištění, investice.",
    step4Title: "Implementace",
    step4Desc: "Vyřídím za tebe papíry, banky i pojišťovny. Ty se věnuješ své práci.",
    step5Title: "Roční review",
    step5Desc: "Jednou za rok spolu projdeme jak se plán daří a co upravit.",
    // příběhy klientů
    storiesEyebrow: "Příběhy klientů",
    storiesHeading: "Jak jsem jim pomohl",
    storiesSubtitle: "Konkrétní situace. Konkrétní řešení. Konkrétní výsledky.",
    storyClient: "Klient",
    storyProblem: "Situace",
    storySolution: "Co jsme udělali",
    storyResult: "Výsledek",
    storyCta: "Chci podobný výsledek pro sebe",
    // galerie
    galleryEyebrow: "Galerie",
    galleryHeading: "Ze zákulisí",
    galleryPhotoAlt: "Foto {n}",
    // blog
    blogEyebrow: "Blog",
    blogHeading: "Tipy a myšlenky",
    blogRead: "Číst článek",
    blogLoading: "Načítám…",
    blogLoadError: "Nepodařilo se načíst článek.",
    // lead magnet (PDF za e-mail)
    lmBadge: "Stáhni zdarma",
    lmInstant: "Okamžitě ke stažení",
    lmNoSpam: "Žádný spam",
    lmDone: "Hotovo",
    lmDoneDesc: "PDF je staženo. Zkontroluj si i email.",
    lmNamePh: "Tvé jméno (volitelné)",
    lmEmailPh: "tvuj@email.cz",
    lmDownloading: "Stahuji…",
    lmDownload: "Stáhnout PDF zdarma",
    lmPrivacy: "Tvoje data používám jen pro poslání PDF. Nikdy nespamuji.",
    lmInvalidEmail: "Zadej platný email",
    lmSuccess: "PDF bylo staženo + poslali jsme ti ho do emailu",
    lmError: "Nepodařilo se stáhnout",
    // kalkulačky — společné
    calcEyebrow: "Spočítej si nezávazně",
    calcHeading: "Vyzkoušej mé kalkulačky",
    calcSubtitle: "Jednoduché, rychlé, bez registrace. Získej první odpovědi za minutu.",
    calcCompare: "Porovnání",
    calcBookCta: "Chci to spočítat přesně na schůzce",
    calcReset: "Zkusit jiné hodnoty",
    calcDisclaimer: "Orientační výpočet. Přesná čísla počítám na schůzce – zdarma a nezávazně.",
    calcUnitBn: "mld",
    calcUnitM: "mil",
    calcUnitK: "tis",
    calcUnitYears: "let",
    calcUnitPa: "% p.a.",
    calcUnitCount: "",
    // kalkulačka: hypotéka
    calcHypoTitle: "Hypoteční kalkulačka",
    calcHypoTagline: "Spočítej si měsíční splátku",
    calcHypoHint: "Za 60 vteřin víš kolik zaplatíš",
    calcHypoAmount: "Výše úvěru",
    calcHypoRate: "Úroková sazba",
    calcHypoYears: "Doba splácení",
    calcHypoSubmit: "Spočítat měsíční splátku",
    calcHypoResult: "Tvá měsíční splátka bude",
    calcHypoSubtitle: "Celkem za {years} {yearsUnit} zaplatíš {total}",
    calcHypoContext: "Orientační výpočet při rovnoměrné anuitě. Přesný úrok se liší podle LTV, bonity a aktuálních sazeb.",
    calcHypoBank: "Průměrná banka ({rate} %)",
    calcHypoMine: "S mojí pomocí ({rate} %)",
    calcHypoSavings: "Úspora {amount}",
    // kalkulačka: investice
    calcInvestTitle: "Investice",
    calcInvestTagline: "Kolik si vyděláš dlouhodobě?",
    calcInvestHint: "Složené úročení tě překvapí",
    calcInvestMonthly: "Měsíčně si odložím",
    calcInvestYears: "Investiční horizont",
    calcInvestRate: "Očekávané zhodnocení",
    calcInvestSubmit: "Spočítat budoucí hodnotu",
    calcInvestResult: "Za {years} {yearsUnit} budeš mít",
    calcInvestSubtitle: "Z toho tvoje vklady: {deposited}",
    calcInvestContext: "Výpočet počítá se stabilním průměrným zhodnocením – ve skutečnosti se bude lišit rok od roku.",
    calcInvestBank: "Spořicí účet v bance (2 %)",
    calcInvestInvested: "Investice ({rate} %)",
    calcInvestDelta: "O {amount} víc",
    // kalkulačka: životní pojištění
    calcLifeTitle: "Životní pojištění",
    calcLifeTagline: "Kolik krytí vážně potřebuješ",
    calcLifeHint: "Bez přeplácení zbytečností",
    calcLifeIncome: "Měsíční čistý příjem",
    calcLifeLoans: "Hypotéka + úvěry celkem",
    calcLifeKids: "Počet dětí",
    calcLifeSubmit: "Spočítat potřebnou pojistnou částku",
    calcLifeResult: "Ty bys měl mít krytou pojistnou částku",
    calcLifeSubtitle: "V případě úmrtí nebo trvalé invalidity",
    calcLifeContext: "Tvoje rodina by měla splacené závazky ({loans}), děti by měly na vzdělání ({kids}) a 10 let by přežila z úspor ({savings}). Většina lidí má kryto 10× méně – platí za pojistku co nic nezachrání.",
    // kalkulačka: finanční nezávislost
    calcFiTitle: "Finanční nezávislost",
    calcFiTagline: "Kdy už můžeš do důchodu?",
    calcFiHint: "Pravidlo 4 % ti to ukáže",
    calcFiTarget: "Chci měsíční pasivní příjem",
    calcFiCurrent: "Současné úspory / investice",
    calcFiYears: "Chci toho dosáhnout za",
    calcFiRate: "Očekávané zhodnocení",
    calcFiSubmit: "Spočítat mou cestu k nezávislosti",
    calcFiResult: "Pro finanční nezávislost potřebuješ nastřádat",
    calcFiSubtitle: "Stačí si měsíčně dávat {monthly} po dobu {years} {yearsUnit}",
    calcFiSubtitleDone: "Gratuluji – tvoje současné úspory to už samy zvládnou za {years} {yearsUnit} 🎉",
    calcFiContext: "Při pravidle 4 % ročního čerpání ti tento kapitál bude generovat {annual} ročně ({monthly} měsíčně) prakticky navždy – bez toho abys ubíral z jistiny.",
  },
  webtpl: {
    universal: {
      headline: "Tvoje finance, pod kontrolou.",
      subheadline: "Pomáhám klientům nastavit finance tak, aby se už nikdy nemuseli bát budoucnosti – hypotéky, investice, pojištění i důchod.",
      s1Title: "Hypotéka", s1Desc: "Najdu ti nejvýhodnější hypotéku ze všech bank a provedu tě celým procesem.",
      s2Title: "Investice", s2Desc: "Sestavím portfolio šité na míru tvým cílům a rizikovému profilu.",
      s3Title: "Pojištění", s3Desc: "Ochrana pro rodinu, majetek i příjem. Bez zbytečných smluv.",
      s4Title: "Důchod", s4Desc: "Ukážu ti kolik si musíš odkládat, abys měl pohodlný důchod.",
    },
    family: {
      headline: "Finance pro rodinu, která chce klid.",
      subheadline: "Starám se o rodiny, aby měly jasno – co je pojištěné, kam spoří dětem, a jak si užít důchod bez starostí.",
      s1Title: "Ochrana rodiny", s1Desc: "Životní a úrazová pojištění, která skutečně chrání – ne jen vybírají peníze.",
      s2Title: "Spoření pro děti", s2Desc: "Jak začít – a kolik stačí – aby měly děti v 18 jistotu.",
      s3Title: "Bydlení", s3Desc: "Hypotéka, pojištění nemovitosti, refinancování.",
      s4Title: "Zdraví", s4Desc: "Soukromé zdravotní pojištění, pokud chcete rychlejší péči.",
    },
    mortgage: {
      headline: "Hypotéka bez stresu. Za tebe udělám všechno.",
      subheadline: "13+ let zkušeností. Porovnám ti nabídky ze všech bank, vyjednám úrok a provedu podáním žádosti až k čerpání.",
      s1Title: "Nová hypotéka", s1Desc: "Od bytu po rodinný dům. Vyřídím za tebe papíry.",
      s2Title: "Refinancování", s2Desc: "Ušetři tisíce měsíčně přesunem do banky s lepšími podmínkami.",
      s3Title: "Kalkulačka", s3Desc: "Spočítáme, kolik si můžeš půjčit a za jaký úrok.",
      s4Title: "Konzultace zdarma", s4Desc: "První schůzka nic nestojí – posoudíme tvou situaci.",
    },
    corporate: {
      headline: "Firemní finance bez zbytečné složitosti.",
      subheadline: "Pomáhám majitelům firem a manažerům strukturovat odměny, benefity pro zaměstnance a vlastní investice.",
      s1Title: "Benefity pro zaměstnance", s1Desc: "Penzijko, životko, stravenky – daňově efektivně.",
      s2Title: "Odměňování majitele", s2Desc: "Optimální mix plat/dividenda/benefit pro majitele s.r.o.",
      s3Title: "Firemní investice", s3Desc: "Jak zhodnotit volné peníze ve firmě.",
      s4Title: "Pojištění odpovědnosti", s4Desc: "D&O, kybernetické pojištění, pojištění firemního majetku.",
    },
    investments: {
      headline: "Budování majetku. Dlouhodobě. Disciplinovaně.",
      subheadline: "Investiční portfolio postavené na datech, nízkých nákladech a tvých cílech – ne na slibech o jistých 20 % ročně.",
      s1Title: "Globální portfolio", s1Desc: "Diverzifikace napříč trhy, měnami a třídami aktiv.",
      s2Title: "Cílové investování", s2Desc: "Byt, důchod, vzdělání dětí – pro každý cíl vlastní strategie.",
      s3Title: "Rebalancing", s3Desc: "Pravidelná údržba portfolia, aby pracovalo pro tebe.",
      s4Title: "Finanční koučink", s4Desc: "Naučím tě, jak o penězích přemýšlet systematicky.",
    },
  },
  klienti: {
    srcDoporuceni: 'Doporučení',
    srcInzerat: 'Inzerát',
    srcJine: 'Jiné',
    srcNabor: 'Nábor',
    srcNavolavka: 'Navolávka přes Beplan',
    srcTipar: 'Přes tipaře',
    srcVlastni: 'Vlastní okruh',
    crm: "CRM",
    title: "Klienti",
    segmentace: "Segmentace",
    segmDesc: "zlato, platina, bronz, standard.",
    pipelineView: "Pipeline view",
    smartOnboarding: "Smart Onboarding",
    manual: "Přidat nového klienta",
    advanced: "Pokročilé",
    search: "Vyhledej klienta podle jména, telefonu, e-mailu nebo města…",
    totalClients: "klientů celkem",
    active: "aktivních",
    signedMonth: "podepsáno tento měsíc",
    pipelineFull: "Pipeline view (KPI, funnel, fáze)",
    noContact: "Bez kontaktu",
    fAll: "Vše",
    fActive: "Aktivní",
    fStagnation: "Stagnace 14+",
    fSigned: "Podpis tento měsíc",
    fNoContact: "Bez kontaktu 30+",
    fParked: "Bez zájmu",
    colClient: "Klient",
    colPhase: "Fáze",
    colDays: "Dní",
    colBj: "BJ",
    colAction: "AKCE",
    loading: "Načítám…",
    noClients: "Žádní klienti",
    mNew: "Nový klient",
    mSmartAdd: "Duplicity hlídám za pochodu — podle jména, telefonu, e-mailu i IČO.",
    mIdent: "Identifikace",
    mName: "Jméno *", mSurname: "Příjmení", mPhone: "Telefon", mEmail: "Email",
    mCity: "Město", mAge: "Věk", mIco: "IČO (volitelné)", mCompany: "Firma / OSVČ",
    mCheckingDup: "Hledám duplicity…",
    mSegSource: "Segmentace a zdroj",
    mDisc: "DISC typologie (Pavel Procházka)",
    mRecruit: "Kandidát na nábor (do týmu poradců)",
    mNotePh: "Kontext, kde jste se potkali, klíčové info…",
    mCancel: "Zrušit",
  },
  obchody: {
    addDealToPhase: 'Přidat obchod do fáze',
    addToPhase: 'Přidat do fáze',
    awaitingPayout: 'čeká na výplatu',
    dealFew: 'obchody',
    dealMany: 'obchodů',
    dealOne: 'obchod',
    phaseOfTotal: 'Fáze {poradi} ze {celkem}',
    progressLeftRight: 'Postup obchodu zleva doprava',
    weighted: 'vážená',
    label: "Obchody",
    caseOne: "případ", caseFew: "případy", caseMany: "případů",
    boardPre: "Obchodní", boardEm: "nástěnka",
    subtitle: "BJ v pipeline · barva karty = typ produktu · táhni kartou na Výhru/Prohru/Zrušeno",
    newDeal: "Nový obchod",
    search: "Hledat obchod, klienta…",
    fAll: "Vše", fHypo: "Hypotéka", fLoans: "Úvěry", fInsur: "Pojištění", fInv: "Investice", fPension: "Penze",
    fReality: "Nemovitosti",
    kanban: "Kanban", table: "Tabulka",
    loading: "Načítám obchody…",
    unknownClient: "Neznámý klient",
    stale: "bez aktivity", activeDeal: "aktivní",
    modalTitle: "Nový obchodní případ", whatAbout: "Čeho se to týká", clientFromCard: "Klient z karty",
    clientSearchPh: "Napiš jméno klienta, telefon nebo e-mail…", productType: "Typ produktu *", provider: "Poskytovatel",
    dealName: "Název obchodu *", dealNamePh: "Zadej název obchodu", phase: "Fáze", estBj: "Odhad BJ", valueCur: "Hodnota",
    note: "Poznámka", cancel: "Zrušit", create: "Vytvořit obchod", selectClient: "Vyber klienta", cantCreate: "Nelze vytvořit obchod",
  },
  /* Realitni obchod ve slozce klienta (components/crm/RealityVeSlozce.js
     + realitni rezim v NewDealModal). Prodavajici a kupujici maji jiny obsah,
     proto jsou popisky oddelene od `zakazky`, ktere mluvi na kartu zakazky. */
  realSlozka: {
    kterouNemovitostVolitelne: 'Kterou nemovitost (nepovinné)',
    zatimNevybrano: 'Zatím nevybráno',
    otevritPoptavku: 'Otevřít poptávku',
    prodejNem: "Prodej nemovitosti",
    koupeNem: "Koupě nemovitosti",
    nadpisProdej: "Prodává",
    nadpisKoupe: "Kupuje",
    bezAdresy: "Bez adresy",
    cenaChybi: "cena nezadaná",
    veFaziNeznamo: "Ve fázi — nevíme od kdy",
    bezObchodu: "Tahle zakázka nemá obchod, fáze se nedá určit.",
    koupeBezObchodu: "Bez obchodu — je tu jen rezervační smlouva.",
    zajemcu: "Zájemci",
    pristiProhlidka: "Nejbližší prohlídka",
    zadnaProhlidka: "Zatím žádný termín",
    prihlaseno: "přihlášeno",
    majitelOdkaz: "Stránka pro majitele",
    majitelOdkazSub: "Sám se podívá, v jaké jsme fázi a co pro prodej děláme.",
    majitelChybi: "Zatím nevyrobeno — vyrob ji na kartě zakázky.",
    odkazPropadly: "propadlý",
    otevrit: "Otevřít",
    kopirovat: "Zkopírovat odkaz",
    zkopirovano: "Odkaz zkopírován",
    nezkopirovano: "Zkopírovat se nepovedlo — vyber odkaz ručně.",
    otevritZakazku: "Otevřít zakázku",
    otevritObchod: "Otevřít obchod",
    zajemciAProhlidky: "Zájemci a prohlídky",
    inzeratOtevrit: "Otevřít inzerát",
    inzeratSkryty: "Inzerát (zatím jen pro tebe)",
    provize: "Provize z prodeje",
    provizeNenastavena: "nenastavená",
    postupZajemce: "Postup",
    rezervace: "Rezervační smlouva",
    rezervacePodepsana: "Podepsaná",
    rezervaceRozepsana: "Rozepsaná, nepodepsaná",
    rezervaceZadna: "Zatím žádná",
    rezervaceSepsat: "Sepsat rezervační smlouvu",
    rezervaceOtevrit: "Otevřít rezervační smlouvu",
    hypoteka: "Hypotéka",
    hypotekaZadna: "Žádný hypoteční případ",
    hypotekaZalozit: "Založit hypotéku",
    nemovitostNeznama: "Nemovitost už v systému není",
    predani: "Předání kontaktu",
    predaniSub: "Předání kontaktu jinému správci je zpracování osobních údajů. Vzniká jen se souhlasem a zůstává tady zapsané.",
    predaniTy: "Ty",
    predaniNekdo: "Někdo z týmu",
    predaniPoradce: "Poradce",
    souhlasDan: "Souhlas dán",
    souhlasNeznamy: "Souhlas bez záznamu času",
    vzniklObchod: "Vznikl obchod",
    vzniklObchodJinde: "Poradce si případ založil",
    vzniklObchodNe: "Obchod z toho zatím nevznikl",
    odmena: "Podíl",
    odmenaNenastavena: "Odměna nenastavená — dokud nevybereš základ a sazbu, nikdo neví, kolik to je.",
    chyba: "Realitní část se nepodařilo načíst. Obchody níž jsou v pořádku.",
    adresa: "Adresa nemovitosti",
    adresaPlaceholder: "Adresa nemovitosti — Kotlářská 12, Brno",
    adresaChybi: "Napiš adresu nemovitosti",
    typNemovitosti: "Druh nemovitosti",
    cenaNabidkova: "Nabídková cena",
    kterouNemovitost: "Kterou nemovitost",
    vyberNemovitost: "Vyber nemovitost",
    zadnaNemovitost: "Nemáš žádnou zakázku",
    nacitamNemovitosti: "Načítám…",
    nemovitostiChyba: "Nemovitosti se nenačetly",
    koupePrefix: "Koupě —",
    koupeFaze0: "Ozval se",
    koupeFaze1: "Prohlídka domluvená",
    koupeFaze2: "Byl na prohlídce",
    koupeFaze3: "Vážný zájem",
    koupeFaze4: "Rezervace",
    koupeFaze5: "Kupní smlouva",
    koupeFaze6: "Předání",
    predavkaStav: {
      navrzena: "Navržená",
      odeslana: "Odeslaná",
      prijata: "Přijatá",
      odmitnuta: "Odmítnutá",
      propadla: "Propadlá",
    },
  },
  dealmeta: {
    board: {
      analyza: "Fin. analýza / Nabídnuto",
      proces: "Žádost / V procesu",
      podpis: "Schválení / Podpis",
      cerpani: "Čerpání / Čekám na provize",
    },
    products: {
      hypoteka: "Hypotéka", refinancovani: "Refinancování", podnikatelsky_uver: "Podnikatelský úvěr",
      spotrebitelsky_uver: "Spotřební úvěr", uver: "Úvěr", pojisteni_zivot: "Životní", pojisteni_auta: "Auto",
      pojisteni_majetek: "Majetek", investice: "Investice", penzijko: "Penze", stavebni: "Stavební", jine: "Jiné",
      prodej_nemovitosti: "Prodej nemovitosti", koupe_nemovitosti: "Koupě nemovitosti",
    },
  },
  /* Vlajky živé bilance a kompletnost analýzy. Do 8/2026 byly oba texty
     natvrdo česky/slovensky uvnitř AnalyzaV2Page, takže vietnamský klient
     čte v TIŠTĚNÉ ANALÝZE „Rezerva na 4.8 měs." — a je to dokument, který
     si odnáší z schůzky domů. Desetinné číslo se formátuje podle jazyka,
     ne americkou tečkou. */
  /* BLOK:bilanceFlag START — generuje scratchpad/slovnik.py, ručně needitovat */
  bilanceFlag: {
    cfNegative: 'Výdaje a splátky převyšují příjmy o {castka}/měs',
    dstiHigh: 'Vysoká zadluženost — splátky {pct} % příjmů (doporučení ČNB do {max} %)',
    dstiHighBezRegulatora: 'Vysoká zadluženost — splátky {pct} % příjmů',
    kidsNoLife: 'Rodina s dětmi — ověř životní pojištění (krytí příjmu)',
    reserveLow: 'Likvidní rezerva jen na {n} měs. — ideál 6× výdajů',
    reserveMid: 'Rezerva na {n} měs. — doplnit do 6×',
    reserveOk: 'Rezerva na {n} měs. ✓',
  },
  /* BLOK:bilanceFlag END */
  /* Plovoucí panel živé bilance (vpravo dole na analýze). */
  bilancePanel: {
    title: "Živá bilance",
    close: "Zavřít",
    netWorth: "Čisté jmění",
    assets: "Majetek",
    debts: "Dluhy",
    zTohoFinNefin: "z toho finanční {fin} · nefinanční {nefin}",
    month: "Každý měsíc",
    income: "Příjmy",
    expenses: "Výdaje",
    repayments: "Splátky",
    free: "Volné",
    deficit: "Schodek",
    notEntered: "nezadáno",
    perMonth: "/měs",
    reserve: "Likvidní rezerva",
    reserveUnit: "× výdajů",
    dsti: "Zadluženost (DSTI)",
    /* Země bez závazného verdiktu DSTI (SK): jiná definice než NBS — AP-08, 19. 10. 2026. */
    dstiBezRegulatora: "Splátky / čistý příjem",
    savingRate: "Míra odkládání",
    cil: {
      reserve: "doporučeno {cil}×",
      dsti: "doporučení ČNB do {max} %",
      saving: "ideál {ideal} %",
    },
    stav: {
      reserveLow: "nízká rezerva",
      reserveMid: "doplnit do {cil}×",
      reserveOk: "splněno",
      dstiOk: "v pořádku",
      dstiHigh: "nad doporučením",
      dstiHighBezRegulatora: "vysoká zadluženost",
    },
    aria: {
      jmeni: "Čisté jmění {ciste}: majetek {majetek}, dluhy {dluhy}",
      mesic: "Měsíčně příjmy {prijmy}: výdaje {vydaje}, splátky {splatky}, volné peníze {volne}",
      mesicSchodek: "Měsíčně příjmy {prijmy}: výdaje {vydaje} a splátky {splatky} je převyšují o {schodek}",
    },
    chipNetWorth: "Čisté jmění",
    chipFreeCf: "Volné CF",
  },
  kompletnost: {
    jmeno: "Jméno a příjmení klienta",
    narozeni: "Datum narození (věk)",
    kontakt: "Kontakt (telefon / e-mail)",
    cil: "Aspoň jeden cíl s částkou",
    prijmy: "Příjmy domácnosti",
    vydaje: "Obvyklé měsíční výdaje",
    rezerva: "Likvidní rezerva (účty / hotovost)",
    investice: "Investice / spoření",
    rizika: "Pojištění / rizika",
  },
  crmdash: {
    greetMorning: "Dobré ráno", greetAfternoon: "Dobré odpoledne", greetEvening: "Dobrý večer",
    /* Věta pod pozdravem „co se dnes pohnulo“ + semafor čipy KPI (1. 11. 2026) — jen z dat. */
    kObvolani: "{n} k obvolání",
    poTerminuOne: "{n} úkol po termínu", poTerminuFew: "{n} úkoly po termínu", poTerminuMany: "{n} úkolů po termínu",
    otevrenychUkoluOne: "{n} otevřený úkol", otevrenychUkoluFew: "{n} otevřené úkoly", otevrenychUkoluMany: "{n} otevřených úkolů",
    podpisuOne: "{n} podpis tento měsíc", podpisuFew: "{n} podpisy tento měsíc", podpisuMany: "{n} podpisů tento měsíc",
    bezPodpisu: "zatím bez podpisu tento měsíc", cistyStul: "Dnes nic nečeká — čistý stůl.",
    cipSplneno: "Plán splněn", cipVTempu: "V tempu", cipZbyvaBj: "Zbývá {n} BJ", cipBezPlanu: "Bez plánu",
    cipPrazdnaPipeline: "Nic rozpracováno", cipPoTerminu: "{n} po termínu", cipNicPoTerminu: "Nic po termínu", cipVolno: "Žádné úkoly",
    metrPlneni: "Plnění měsíčního plánu BJ", metrMesic: "Uběhlá část měsíce",
    rozvrzeni: "Rozvržení", rozvrzeniKlasicke: "Klasické", rozvrzeniDenMesic: "Den → Měsíc", sekceDnes: "Dnes", sekceMesic: "Měsíc",
    monthProgress: "Postup měsíce", day: "den", of: "z",
    kpiBj: "BJ tento měsíc", planNotSet: "Plán nenastaven", plan: "Plán",
    kpiProvize: "Provize měsíc", coef: "Koef.",
    kpiPipeline: "Aktivní pipeline", openDeals: "otevřených obchodů", contactsTotal: "kontaktů celkem",
    kpiTasks: "Úkoly k řešení", noTasks: "Žádné úkoly", doneOf: "hotových z",
    dealsPipeline: "Obchodní pipeline", openBoard: "Otevřít nástěnku", loadingDeals: "Načítám obchody…", noDeals: "Žádné obchody", more: "dalších",
    todayCalls: "Dnes k volání", upcomingTasks: "Nadcházející úkoly", stageDistribution: "Rozložení fází",
    leadSources: "Zdroje leadů", noData: "Žádná data", pipelineByStage: "Pipeline po fázích", recentActivity: "Poslední aktivita",
    callAction: "Volat", meetingAction: "Schůzka", noInterestAction: "Nemá zájem",
    funnelCalling: "Volání", funnelSigned: "Podpis",
    saved: "Uloženo", saveFailed: "Nepodařilo se uložit", loadFailed: "Nepodařilo se načíst data CRM",
    noTasksYet: "Žádné úkoly", noCallsToday: "Dnes nikdo k volání", inPipeline: "V pipeline",
    subtitle: "Přehled portfolia, diáře a klientů — na jednom místě.",
    openDiary: "Otevřít diář", adviser: "Poradce", adviserRole: "Poradce",
    topClients: "Top klienti dle AUM", topClientsSub: "Vaše nejsilnější portfolia", allClients: "Všichni",
    kpiClients: "Klienti", kpiClientsHint: "Aktivní portfolio", kpiVip: "VIP", kpiVipHint: "Zlatý tier",
    kpiWeek: "Tento týden", kpiWeekHint: "Naplánovaných schůzek", kpiAum: "AUM / BJ", kpiAumHint: "Pod správou",
    noTopClients: "Zatím žádní klienti",
    /* Hromadné akce na sekci „Po termínu" v Ranním brífinku. Poradce se 143
       zmeškanými úkoly je nedoklikal jeden po druhém — tohle to srovná najednou. */
    bulkToday: "Na dnes",
    bulkWeek: "O týden",
    bulkTodayHint: "Přesunout všechny úkoly po termínu na dnešek",
    bulkWeekHint: "Odložit všechny úkoly po termínu o týden",
    bulkConfirmToday: "Přesunout {n} úkolů po termínu na dnešek?",
    bulkConfirmWeek: "Odložit {n} úkolů po termínu o týden?",
    bulkRunning: "Přesouvám…",
    bulkDoneOne: "Přesunut {n} úkol",
    bulkDoneFew: "Přesunuty {n} úkoly",
    bulkDoneMany: "Přesunuto {n} úkolů",
    bulkPartial: "{ok} přesunuto, {err} se nepovedlo",
    bulkFailed: "Přesun se nepovedl",
  /* PANELY NÁSTĚNKY — dřív mapy PANEL_*_SK v pages/crm/CRMDashboardPage.js,
     které uměly jen cs+sk (Vietnamec i Ukrajinec dostal češtinu). */
  panelKat: {
    vse: 'Vše',
    prehledy: 'Rychlé přehledy',
    obchod: 'Obchodní případy',
    klienti: 'Klienti & servis',
    nastroje: 'Nástroje',
  },
  panel: {
    zrcadlo: {
      title: 'Zrcadlo volání — koho dnes obvolat',
      desc: 'Fronta volání: kdo čeká nejdéle, odkud je, zavolat na jedno kliknutí.',
      helpLabel: 'Zrcadlo volání',
      helpText: 'Kdo čeká na obvolání — stejná fronta jako stránka Zrcadlo volání, jen zkrácená. Nahoře kolik lidí čeká, pod tím pět nejdéle čekajících (kdo čeká nejdéle, je první), u každého odkud lead je a telefon. Zavolat otevře telefon, Domluveno posune kontakt do fáze Představení a z fronty zmizí.',
    },
    brifink: {
      title: 'Ranní brífink',
      desc: 'Co dnes · co je po termínu · co je hotové · co přijde.',
      helpLabel: 'Ranní brífink',
      helpText: 'Čtyři otázky na jednom místě: co dnes, co je po termínu, co je hotové, co přijde. U položky je vidět klient a obchod, kterého se týká. Vše z diáře, klientů a obchodů — když nic není, sekce to řekne. U položky: + přidat do plánu, hodiny odložit na později, × smazat z dnešního brífinku.',
    },
    diar: {
      title: 'Diář — týden',
      desc: 'Schůzky a úkoly na celý týden pohromadě.',
      helpLabel: 'Diář — týden',
      helpText: 'Schůzky a úkoly celého týdne. Číslo u dne = počet úkolů; klik otevře diář.',
    },
    radar: {
      title: 'Servisní radar',
      desc: 'Klienti, u kterých se blíží servisní schůzka.',
      helpLabel: 'Servisní radar',
      helpText: 'Klienti, u kterých se blíží konec fixace, výročí nebo dožití — komu se ozvat kvůli servisu.',
    },
    prilezitosti: {
      title: 'Radar příležitostí',
      desc: 'Mezery v portfoliu a příležitosti k oslovení.',
      helpLabel: 'Radar příležitostí',
      helpText: 'Mezery v portfoliu klientů seřazené podle skóre — kde je největší příležitost k oslovení.',
    },
    kpi: {
      title: 'KPI dlaždice',
      desc: 'Klíčová čísla měsíce: BJ, provize, pipeline, úkoly.',
      helpLabel: 'KPI dlaždice',
      helpText: 'Klíčová čísla měsíce (BJ, provize, pipeline, úkoly). Klik na dlaždici otevře detail v Obchodech nebo Diáři.',
    },
    pipeline: {
      title: 'Obchodní pipeline',
      desc: 'Obchody rozdělené podle fází pipeline.',
      helpLabel: 'Obchodní pipeline',
      helpText: 'Otevřené obchody podle fází (analýza → čerpání) včetně vážené prognózy provizí. Klik → Obchody.',
    },
    akce: {
      title: 'Vyžaduje akci dnes',
      desc: 'Co dnes hoří a čeká na vaši akci.',
      helpLabel: 'Vyžaduje akci dnes',
      helpText: 'Fronta na dnes: úkoly po termínu i obchody bez naplánovaného dalšího kroku. Klik → detail.',
    },
    volani: {
      title: 'Dnes k volání',
      desc: 'Kontakty, které je dnes potřeba obvolat.',
      helpLabel: 'Dnes k volání',
      helpText: 'Kontakty k obvolání dle priority VIP → A → B → C. Tlačítka: telefon = zavolat · ✓ domluvena schůzka · ✗ nemá zájem.',
    },
    ukoly: {
      title: 'Nadcházející úkoly',
      desc: 'Nejbližší úkoly seřazené podle termínu.',
      helpLabel: 'Nadcházející úkoly',
      helpText: 'Nejbližší nesplněné úkoly podle termínu. Klik → Diář.',
    },
    emaily: {
      title: 'E-maily',
      desc: 'Nepřečtené e-maily rovnou na nástěnce.',
      helpLabel: 'E-maily',
      helpText: 'Poslední nepřečtené e-maily z připojeného Gmailu. Klik → Pošta.',
    },
    klienti: {
      title: 'Poslední aktivita klientů',
      desc: 'Poslední pohyb u vašich klientů.',
      helpLabel: 'Klienti',
      helpText: 'Naposledy upravení klienti — rychlý přístup ke složce. Klik → Klienti.',
    },
    topklienti: {
      title: 'Top klienti dle AUM',
      desc: 'Nejhodnotnější klienti podle objemu majetku.',
      helpLabel: 'Top klienti dle AUM',
      helpText: 'Nejhodnotnější klienti podle objemu majetku (BJ). Klik → Klienti.',
    },
    faze: {
      title: 'Rozložení fází',
      desc: 'Rozložení kontaktů podle fáze obchodu.',
      helpLabel: 'Rozložení fází',
      helpText: 'Počet kontaktů v jednotlivých fázích obchodu — kde se hromadí práce.',
    },
    zdroje: {
      title: 'Zdroje leadů',
      desc: 'Odkud vám chodí nejvíce leadů.',
      helpLabel: 'Zdroje leadů',
      helpText: 'Odkud vám chodí nejvíce kontaktů (leadovač, doporučení, web…).',
    },
    nastroje: {
      title: 'Rychlé nástroje',
      desc: 'Rychlé zkratky na kalkulačky a nástroje.',
      helpLabel: 'Rychlé nástroje',
      helpText: 'Zkratky na kalkulačky a nástroje rozdělené do kategorií.',
    },
    poznamky: {
      title: 'Poznámky',
      desc: 'Prázdný papír na rychlé poznámky se štítky.',
      helpLabel: 'Poznámky',
      helpText: 'Prázdný papír na cokoli — text se ukládá sám. Štítkem si poznámky roztřídíte a nahoře podle něj filtrujete.',
    },
    vyvoj: {
      title: 'Vývoj obchodů',
      desc: 'Vývoj uzavřených obchodů v čase.',
      helpLabel: 'Vývoj obchodů',
      helpText: 'Uzavřené obchody v čase — trend podepsaných BJ po měsících. Období přepnete tlačítky.',
    },
    plan: {
      title: 'Plnění plánu',
      desc: 'Jak se blížíte měsíčnímu plánu BJ.',
      helpLabel: 'Plnění plánu',
      helpText: 'Jak se blížíte měsíčnímu plánu BJ; ručička ukazuje % splnění a odhad provize.',
    },
    trychtyr: {
      title: 'Prodejní trychtýř',
      desc: 'Kolik máte rozobchodováno v jednotlivých fázích.',
      helpLabel: 'Prodejní trychtýř',
      helpText: 'Kolik obchodů a BJ máte v jednotlivých fázích a jak dlouho v nich průměrně leží.',
    },
  },
  },
  /* BLOK:diar START — generuje scratchpad/slovnik.py, ručně needitovat */
  diar: {
    activity: 'Aktivita',
    agenda: 'Seznam',
    agendaSub: 'Seznam aktivit',
    agendaTitle: 'Nadcházející',
    allDay: 'Celodenní',
    calls: 'hovorů',
    dFri: 'Pá',
    dMon: 'Po',
    dSat: 'So',
    dSun: 'Ne',
    dThu: 'Čt',
    dTue: 'Út',
    dWed: 'St',
    day: 'Den',
    days: 'dní',
    editActivity: 'Editace aktivity',
    filters: 'Filtry',
    hintKlik: 'Klikni do mřížky',
    hintKlikZbytek: 'pro rychlou událost.',
    hintTah: 'Přetažením',
    hintTahZbytek: 'přesuneš, tažením za spodní hranu změníš délku.',
    m01: 'leden',
    m02: 'únor',
    m03: 'březen',
    m04: 'duben',
    m05: 'květen',
    m06: 'červen',
    m07: 'červenec',
    m08: 'srpen',
    m09: 'září',
    m10: 'říjen',
    m11: 'listopad',
    m12: 'prosinec',
    meetings: 'schůzek',
    month: 'Měsíc',
    monthOverview: 'Měsíční přehled',
    newActivity: 'Nová aktivita',
    nextWeek: 'Další týden',
    prevWeek: 'Předchozí týden',
    refreshed: 'Diář obnoven',
    sync: 'Synchronizace',
    tDopis: 'Dopis',
    tEmail: 'Email',
    tSchuzka: 'Schůzka',
    tTelefonat: 'Telefonát',
    tUdalost: 'Událost',
    tUkol: 'Úkol',
    tasks: 'úkoly',
    tip: 'Tip',
    today: 'Dnes',
    week: 'Týden',
    weekNo: 'týden',
  },
  /* BLOK:diar END */
  hypo: {
    active: "Aktivních", waitOdhad: "Čeká na odhad", naKatastru: "Na katastru", blizkoCerpani: "Blízko čerpání", cerpanoMesic: "Čerpáno (měsíc)",
    search: "Hledat hypotéku…", colClient: "Klient", colBank: "Banka", colPhase: "Fáze procesu", colWaiting: "Čeká na", colNextStep: "Další krok", aiWatch: "AI HLÍDÁ", colAmount: "Výše / LTV", loading: "Načítám hypotéky…", shown: "Zobrazeno", activeMortgages: "aktivních hypoték",
  },
  deal: {
    notFound: "Obchod nenalezen", dealValue: "Hodnota obchodu", caseProgress: "Postup případu",
    save: "Uložit", edit: "Upravit", nextStep: "Další krok případu",
    subject: "Předmět", price: "Cena", ownFunds: "Vlastní vklad", note: "Poznámka",
    purchasePrice: "Kupní cena", ownResources: "Vlastní zdroje", monthlyPayment: "Měsíční splátka",
    keyParam: "Klíčový parametr", keyPh: "Klíč (např. LTV)", valuePh: "Hodnota",
    people: "Lidé v případu", addRole: "Rychle přidat roli",
    resWon: "Výhra", resLost: "Prohra", resCancelled: "Zrušeno", resOpen: "V procesu",
    cantSave: "Nelze uložit", cantChangeStage: "Nelze změnit fázi", cantAddNote: "Nelze přidat poznámku",
    cantWin: "Nelze potvrdit výhru", error: "Chyba", cancelled: "Zrušeno", deleted: "Smazáno",
    roleRealitni: "Realitní makléř", roleProdejce: "Prodejce", roleKupujici: "Kupující", roleOdhadce: "Odhadce",
    roleBanker: "Bankéř", rolePravnik: "Právník / notář", roleDruhyKlient: "Druhý klient", roleDeveloper: "Developer", roleHlavniKlient: "Hlavní klient", rolePlaceholder: "Role (např. Bankéř)", roleSystemovaHint: "Tuhle roli drží systém — přepsat nejde.",
  },
  /* Levá lišta + chrome aplikace. Dřív to byl SK-only overlay `SK_NAV`,
   * takže vietnamec i ukrajinec viděli českou navigaci na KAŽDÉ obrazovce. */
  /* Uvítací modal po prvním přihlášení (components/FirstLoginWizard.js).
   * {jmeno} se dosazuje v komponentě — nesmí se z překladu vypustit. */
  wizard: {
    /* Zástupné slovo, když poradce nemá vyplněné jméno. Do 23. 8. 2026
       bylo v FirstLoginWizard.js natvrdo české „svoji“, takže Vietnamec
       četl „danh thiếp số của svoji“. */
    zastupneJmeno: 'svoji',
    vitej: 'Vítej v BEplan University',
    nadpis: 'Nastav si {jmeno} digitální vizitku',
    popisA: 'Vizitka je tvoje veřejná stránka — klienti odsud zarezervují schůzku, zavolají, najdou tě na LinkedIn.',
    popisZvyraznene: 'Zabere to 30 vteřin',
    popisB: 'a pak ti začnou fungovat všechny Leadovač odkazy i karta doporučení.',
    slugLabel: 'Tvoje URL adresa (slug)',
    nahled: 'Náhled:',
    nastavitVizitku: 'Nastavit vizitku',
    preskocit: 'Zatím přeskočit',
    pozdejiA: 'Pokud teď přeskočíš, můžeš si vizitku nastavit kdykoli v',
    pozdejiKde: 'Nastavení → Vizitka',
    pozdejiB: 'Ale doporučujeme to udělat hned — bez slugu ti nepoběží Leadovač.',
    hotovo: 'Hotovo!',
    vrhnemeSe: 'Vrhneme se na CRM…',
    ulozeno: 'Vizitka uložena!',
    chyba: 'Uložení slugu selhalo. Můžeš to zkusit znovu v Nastavení → Vizitka.',
  },
  lista: {
    nastenka: 'Nástěnka',
    klienti: 'Klienti',
    obchody: 'Obchody',
    diar: 'Diář',
    posta: 'Pošta',
    manazer: 'Manažer',
    vzdelavani: 'Vzdělávání',
    nastroje: 'Nástroje',
    adresar: 'Adresář',
    zrcadloVolani: 'Zrcadlo volání',
    pipelineKlientu: 'Pipeline klientů',
    radarPrilezitosti: 'Radar příležitostí',
    mapaKlientu: 'Mapa klientů',
    leadyProjekt100: 'Leady (Projekt 100)',
    obchodniNastenka: 'Obchodní nástěnka',
    hypotecniPipeline: 'Hypoteční pipeline',
    naborovaPipeline: 'Náborová pipeline',
    naborovyRadar: 'Náborový radar',
    zakazkyReality: 'Zakázky (reality)',
    realitniPipeline: 'Realitní pipeline',
    rezervacniSmlouva: 'Rezervační smlouva',
    prehledTymu: 'Přehled týmu',
    ikKonzultace: 'IK konzultace',
    mojiPoradci: 'Moji poradci',
    vyhlaseniVysledku: 'Vyhlášení výsledků',
    tymoveAkce: 'Týmové akce',
    diarTymu: 'Diář týmu',
    startNovacka: 'Start nováčka (Cesta 90 dní)',
    adaptace7: '7denní adaptace',
    adaptaceTymu: 'Adaptace týmu',
    akademieModuly: 'Akademie — moduly & infografiky',
    metodikaPlan: 'Metodika: Sestavení plánu',
    zkouskaCertifikat: 'Zkouška & certifikát',
    skriptyNamitky: 'Skripty & námitky',
    kdeShanetKlienty: 'Kde shánět klienty',
    videaKurzy: 'Videa & kurzy',
    rozcestnikNastroju: 'Rozcestník nástrojů',
    financniMatematika: 'Finanční matematika',
    kalkulacky21: 'Kalkulačky (20)',
    penzijniKalkulacka: 'Penzijní kalkulačka',
    zivotniPojisteni: 'Životní pojištění',
    historickaKalkulacka: 'Historická kalkulačka',
    investicniStrategie: 'Investiční strategie',
    srovnavacFondu: 'Srovnávač fondů',
    nemovitostPronajem: 'Nemovitost na pronájem',
    provizniKalkulacka: 'Provizní kalkulačka',
    hledat: 'Hledat',
    hledatVCeleAplikaci: 'Hledat v celé aplikaci',
    naNastenku: 'Na nástěnku',
    profilPoradce: 'Profil poradce (fotku nastavíš v Nastavení)',
    zavritMenu: 'Zavřít menu',
    sbalit: 'Sbalit',
    pripnout: 'Připnout',
    sbalitListu: 'Sbalit lištu',
    pripnoutRozbalene: 'Připnout rozbalené',
    novyZaznam: 'Nový záznam — klient, lead, obchod, úkol…',
    novyZaznamTlacitko: 'Nový záznam',
    ucet: 'Účet',
    novyKlient: 'Nový klient',
    novyKlientSub: 'Přidat do pipeline',
    novyLead: 'Nový lead',
    novyLeadSub: 'Příležitost / vlažný kontakt',
    obchodniPripad: 'Obchodní případ',
    obchodniPripadSub: 'Rovnou založit obchod',
    naborKandidat: 'Nábor — kandidát',
    naborKandidatSub: 'Rovnou založit kandidáta',
    ukolSchuzka: 'Úkol / Schůzka',
    ukolSchuzkaSub: 'Otevřít Diář',
    leadZDoporuceni: 'Lead z doporučení',
    leadZDoporuceniSub: 'Odkaz pro klienta',
    // horní lišta záložek (GlobalTabBar) — zbylých 28; ostatní sdílí klíče výše
    tabLeady: 'Leady',
    tabServisRadar: 'Servis radar',
    tabKomunikace: 'Komunikace',
    tabDoporuceni: 'Doporučení',
    tabCile: 'Cíle',
    tabVyhlaseni: 'Vyhlášení',
    tabSmlouva: 'Smlouva',
    tabHypoteky: 'Hypotéky',
    tabNabor: 'Nábor',
    tabHlasovyRezim: 'Hlasový režim',
    tabRezervace: 'Rezervace',
    tabTrychtyre: 'Trychtýře',
    tabHistoricka: 'Historická',
    tabFinMatematika: 'Fin. matematika',
    tabInvesticniStudio: 'Investiční studio',
    tabStrategie: 'Strategie',
    tabPenze: 'Penze',
    tabIzp: 'Analýza pro Vietnamce',
    tabRentaPorovnavac: "Renta — porovnávač",
    tabAnalyza: "Analýza",
    tabFixace: "Fixace pod kontrolou",
    tabSvoboda: "Kdy budeš volný",
    tabHypotekaRozhodnuti: "Hypotéka — rozhodnutí",
    tabPortfolioDoktor: 'Portfolio doktor',
    tabReality: 'Reality',
    tabZakazky: 'Zakázky',
    tabRezervacniSmlouva: 'Rezervační smlouva',
    tabNemovitost: 'Nemovitost',
    tabKalkulackaVizual: 'Kalkulačka vizuál',
    tabProvize: 'Provize',
    tabDesignLab: 'Design Lab',
    tabAdmin: 'Admin',
    tabAiKnowledge: 'AI Knowledge',
    tabHlasovky: 'Hlasovky',
    tabHromadnyEmail: 'Hromadný email',
    tabPortfolioAdmin: 'Portfolio (admin)',
    tabTrzniData: 'Tržní data',
    tabMesicnikAdmin: 'Měsíčník (admin)',
    tabMesicnik: 'Měsíčník',
    tabDataHygiena: 'Data hygiena',
    tabNastaveni: 'Nastavení',
    tabNovinky: 'Co je nového',
  },
  nav: { dashboard: "Nástěnka", calculators: "Kalkulačky", tools: "Nástroje", admin: "Admin", logout: "Odhlásit se", theme: "Změnit motiv" },
  login: { subtitle: "Vzdělávací systém pro finanční poradce", welcomePre: "Vítej v", welcomeEm: "univerzitě", name: "Jméno a příjmení", accessCode: "Přístupový kód", registerClosed: "Registrace je momentálně zavřená. Požádej správce o pozvánku nebo o zapnutí registrace.", email: "E-mail", password: "Heslo", submit: "Přihlásit se", register: "Registrovat", loading: "Načítání...", loginOk: "Přihlášení úspěšné!", registerOk: "Registrace úspěšná!", loginErr: "Neplatný e-mail nebo heslo", hasAccount: "Již máte účet? Přihlásit se", noAccount: "Nemáte účet? Registrovat se", forgot: "Zapomněli jste heslo?", forgotTitle: "Obnovení hesla", sendCode: "Poslat kód na e-mail", codeSent: "Pokud e-mail existuje, poslali jsme na něj kód.", codeLabel: "Obnovovací kód z e-mailu", newPass: "Nové heslo (min. 8 znaků)", resetBtn: "Nastavit nové heslo", resetOk: "Heslo obnoveno — přihlaste se", backToLogin: "Zpět na přihlášení" },
  dash: { welcome: "Vítejte v beplan University", subtitle: "Váš vzdělávací systém pro finanční poradenství", progress: "Celkový postup", completedVids: "Dokončená videa", activeSeries: "Aktivní série", totalProgress: "Celkový postup", series: "Vzdělávací série", done: "DOKONČENO", inProgress: "PROBÍHÁ", vidsDone: "videí dokončeno", lastWatch: "Poslední sledované" },
  detail: { notFound: "Série nenalezena", locked: "Série zamčena", lockedDesc: "Dokončete předchozí sérii pro odemčení.", back: "Zpět na Dashboard", seriesLabel: "Série", markDone: "Označit jako dokončené", isDone: "Dokončeno", download: "Stáhnout materiály", noMaterial: "Materiály nedostupné", comments: "Komentáře", writeComment: "Napište komentář nebo zpětnou vazbu...", send: "Odeslat", sending: "Odesílám...", noComments: "Zatím žádné komentáře. Buďte první!", reply: "Odpovědět", del: "Smazat", writeReply: "Napište odpověď...", vidDone: "Video označeno jako dokončené!", saveErr: "Chyba při ukládání", commentOk: "Komentář přidán!", commentErr: "Chyba při přidávání komentáře", replyOk: "Odpověď přidána!", delOk: "Komentář smazán", delErr: "Chyba při mazání" },
  calcPage: { title: "Finanční kalkulačky", subtitle: "Profesionální nástroje pro finanční plánování a poradenství", all: "Vše", realestate: "Nemovitosti", investment: "Investice", insurance: "Pojištění & Důchod", personal: "Osobní finance", open: "Otevřít kalkulačku" },
  toolsPage: { title: "Nástroje pro finanční poradce", subtitle: "Profesionální nástroje pro efektivní práci", open: "Otevřít", catObchod: "Obchod & provize", catKalkulacky: "Kalkulačky & výpočty", catVzdelavani: "Vzdělávání", tileObchod: "Obchod", tileKalkulacka: "Kalkulačka", tileVzdelavani: "Vzdělávání", },
  admin: { loading: "Načítám…", title: "Administrace", codeTitle: "Přístupový kód", codeDesc: "Tento kód potřebují noví uživatelé pro registraci. Můžete ho kdykoli změnit.", save: "Uložit", curCode: "Aktuální kód:", users: "Uživatelé", videoTitle: "Správa videí", videoDesc: "Vložte YouTube odkazy a materiály ke stažení (Google Drive) pro každé video.", vids: "videí", ytUrl: "YouTube URL", matUrl: "Materiály (Google Drive)", saving: "Ukládám...", saved: "Video aktualizováno!", saveErr: "Chyba při ukládání", loadErr: "Chyba při načítání", codeOk: "Přístupový kód aktualizován!", codeErr: "Chyba při aktualizaci", noName: "Bez jména", confirmDelete: "Opravdu smazat tohoto uživatele?", userDeleted: "Uživatel smazán", deleteErr: "Chyba při mazání uživatele", deleteUser: "Smazat uživatele" },
  common: { reset: "Reset", start: "Start", pause: "Pauza", min: "min", progress: "Postup", phase: "Fáze", search: "Hledat pojem...", noResults: "Žádné výsledky", example: "Příklad", save: "Uložit", saving: "Ukládám…", cancel: "Zrušit", delete: "Smazat", edit: "Upravit", add: "Přidat", close: "Zavřít", back: "Zpět", next: "Další", yes: "Ano", no: "Ne", confirm: "Potvrdit", loading: "Načítám…", copy: "Kopírovat", copied: "Zkopírováno", open: "Otevřít", new: "Nové", today: "dnes", week: "týden", total: "celkem", name: "Jméno", phone: "Telefon", email: "Email", note: "Poznámka", required: "Povinné", optional: "Volitelné", submit: "Odeslat", submitting: "Odesílám…", detail: "Detail", settings: "Nastavení", backToSettings: "Zpět do nastavení" },
  crm: {
    title: "CRM Poradce",
    advisorWord: "Poradce",
    subtitle: "Kontakty, pipeline, volání a IK — všechno na jednom místě.",
    beginner: "Začátečník",
    overview: "Přehled",
    p100: "Projekt 100",
    calls: "Zrcadlo volání",
    pipeline: "Pipeline",
    ik: "IK konzultace",
    goals: "Cíle & Rocks",
    team: "Moji poradci",
    leadovac: "Leadovač",
    stages: { lead: "Lead", calling: "K obvolání", meeting: "Schůzka domluvena", onboarding: "Onboarding", proposal: "Návrh", contract: "Smlouva", active: "Aktivní klient", lost: "Ztracený" },
    actions: { call: "Zavolat", schedule: "Schůzka", callback: "Zpětné volání", later: "Později", noInterest: "Nezájem", addContact: "Přidat kontakt", newLead: "Nový lead" },
  },
  leadovac: {
    title: "Leadovač",
    subtitle: "Prodejní trychtýř pro získávání leadů. Pošli klientovi odkaz na WhatsApp — on si projde téma, spočítá si benefit kalkulačkou a zanechá poptávku. Ty máš nový lead v Zrcadle volání.",
    latestLeads: "Poslední leady",
    latestLeadsSub: "Aktualizuje se každých 20 s · příchozí poptávky napříč tématy",
    live: "live",
    today: "dnes",
    week: "týden",
    total: "celkem",
    filter: { all: "Vše" },
    tools: "Tvoje leadovač nástroje",
    toolsSub: "4 hotové prémiové trychtýře — klikni a sdílej s klientem.",
    setSlugFirst: "Nejdřív nastav slug v profilu →",
    open: "Otevřít",
    detail: "Detail & sdílet →",
    detailRef: "Vytvořit odkaz pro klienta →",
    noLeads: "Zatím žádné leady. Pošli klientovi odkaz a uvidíš.",
    moreLeads: "dalších — otevři kartu tématu",
    badgeLead: "lead",
    badgeLeads: "leadů",
    badgeLink: "odkaz",
    badgeLinks: "odkazů",
  },
  leadForm: {
    eyebrowConsult: "30 minut zdarma",
    yourName: "Vaše jméno",
    yourNamePh: "Jan Novák",
    yourPhone: "Telefon",
    yourPhonePh: "+420 777 000 000",
    yourEmail: "Email (volitelné)",
    yourEmailPh: "jmeno@example.cz",
    note: "Krátká zpráva (volitelné)",
    notePh: "Co je pro Vás nejdůležitější, kdy Vám zavolat, atd.",
    preferredTime: "Preferovaný čas schůzky",
    preferredTimePh: "např. všední den odpoledne",
    consent: "Odesláním souhlasím se zpracováním údajů za účelem kontaktu.",
    successTitle: "Děkuji!",
    successSubtitle: "Ozvu se Vám do 24 hodin.",
    successHint: "Mějte u sebe telefon — obvykle se ozývám ještě týž den.",
    bookHeading: "Nebo si rovnou vyberte termín",
    bookSubtitle: "Vyberte si den a čas, který Vám sedí. Bez závazků, bez tlaku.",
    bookCta: "Vybrat termín konzultace",
    /* Leadgen stránka (LeadGenPage) — do 8/2026 měla tyhle texty napsané
       ternárem `lang === "sk" ? … : …`, takže Ukrajinec i Vietnamec dostal
       češtinu. Obsah tématu (nadpisy, benefity, FAQ) je pořád cs+sk v
       data/leadgenTopics*.js — to je samostatná práce. */
    ctaTryCalc: "Zkusit kalkulačku",
    ctaWantConsult: "Chci konzultaci",
    notFound: "Stránka nenalezena",
    unknownTopic: "Neznámé téma",
    errName: "Zadejte celé jméno",
    errPhone: "Zadejte platné telefonní číslo",
    errSend: "Odeslání selhalo, zkuste to znovu.",
    calcEyebrow: "Vyzkoušejte sami",
    calcTitle: "Kalkulačka {tema}",
    calcSub: "Posuňte parametry a uvidíte čísla v reálném čase. Není to vědecký výpočet, ale dostatečně přesný odhad pro orientaci.",
    howEyebrow: "Jak to funguje",
    howTitle: "Čtyři kroky od dotazu k řešení",
    examplesEyebrow: "Modelové příklady",
    examplesTitle: "Jak to může vypadat ve Vaší situaci",
    examplesNote: "Ilustrativní scénáře — pro představu, co konkrétně lze řešit. Reálný výsledek vždy závisí na Vaší konkrétní situaci.",
    exSituation: "Situace:",
    exSolution: "Řešení:",
    preparedBy: "Tuto stránku Vám připravil",
    bookPoint1: "30-45 minut, online přes Google Meet nebo osobně",
    bookPoint2: "Žádný tlak na uzavření smlouvy",
    bookPoint3: "Po schůzce máte písemný přehled do 48 hodin",
    nextWeek: "Příští týden",
    freeEyebrow: "Bez závazků · Zdarma",
    getTitle: "Co získáte",
    get1: "Výpočet na míru z vašich čísel — zdarma",
    get2: "Ozvu se do 24 hodin, v čase který vám vyhovuje",
    get3: "Nezávazně — rozhodnutí je vždy na vás",
    timeMorning: "Dopoledne (11–13)",
    timeAfternoon: "Odpoledne (13–17)",
    timeEvening: "Večer (17–20)",
    timeAnytime: "Kdykoliv",
    privacy: "Ochrana osobních údajů",
    weekdayShort: "Po,Út,St,Čt,Pá,So,Ne",
    midCtaHeading: "Stačí Vám 30 minut. Beze ztráty.",
    midCtaSub: "Bez tlaku, bez slibů. Jen čísla a jasná hlava.",
    whatToExpect: "Co od spolupráce čekat",
    wantToDiscuss: "Chcete to probrat?",
    freeConsult30: "30 min konzultace zdarma · bez závazku",
    term: "Termín",
    inquiry: "Poptávka",
  },
  vizitka: {
    title: "Digitální vizitka",
    subtitle: "URL slug, QR kód, barvy a tisk fyzické vizitky — všechno na jednom místě.",
    slug: "URL slug",
    slugHelp: "3–40 znaků, malá písmena, čísla, pomlčka.",
    qrTitle: "URL slug & QR kód",
    qrSaveHint: "Ulož QR do podpisu emailu, na vizitku, na web…",
    print: "Vygenerovat tiskovou vizitku (A4)",
    colors: "Barvy vizitky",
    custom: "Vlastní",
    bg: "Pozadí",
    accent: "Akcent",
    save: "Uložit vizitku",
  },
  booking: {
    /* Veřejná rezervační stránka (pages/booking/PublicBookingPage.js).
     * Dívá se na ni KLIENT, ne poradce — proto musí být ve všech pěti
     * jazycích. Dřív měla texty v ternáru `lang === "sk" ? … : …`, takže
     * Ukrajinec i Vietnamec četli češtinu. */
    pub: {
      inactive: "Tento poradce zatím neaktivoval online rezervace.",
      notFound: "Poradce nenalezen nebo odkaz neplatný.",
      loading: "Načítám…",
      notAvailable: "Rezervace není dostupná",
      meeting: "Schůzka",
      chooseService: "Vyber typ schůzky",
      changeService: "Změnit typ schůzky",
      pickHeading: "Vyber datum a čas",
      pickDate: "Vyber datum v kalendáři",
      loadingSlots: "Načítám volné časy…",
      noSlots: "Tento den nemá volné termíny.",
      prevMonth: "Předchozí měsíc",
      nextMonth: "Další měsíc",
      tzLabel: "Časové pásmo",
      reservingFor: "Rezervuješ termín",
      changeTime: "Změnit čas",
      detailsHeading: "Tvoje údaje",
      nameLabel: "Jméno a příjmení",
      emailLabel: "E-mail",
      phoneLabel: "Telefon",
      noteLabel: "Co chceš řešit?",
      submitBtn: "Potvrdit rezervaci",
      submitting: "Rezervuji…",
      fillRequired: "Vyplň jméno a e-mail",
      badEmail: "Zadej platný e-mail",
      bookingFailed: "Rezervace selhala",
      gdprInfo: "Odesláním rezervace předáváš své jméno, e-mail, telefon a poznámku poradci, který si je uloží do své klientské evidence, aby se na schůzku připravil a mohl tě kontaktovat. Kdykoli můžeš požádat o výmaz.",
      confirmedTitle: "Schůzka potvrzena",
      date: "Termín",
      sentTo: "Potvrzení odesláno na",
      sentNone: "E-mailové potvrzení jsme teď odeslat nemohli — poznamenej si prosím termín. Poradce se ti ozve.",
      advisorContact: "V případě potřeby napiš poradci na",
      meetLink: "Odkaz na Google Meet",
    },
    svc: {
      uvod15: "Úvodní představení", uvod15d: "Rychlé nezávazné seznámení — kdo jsem, jak pracuji a zda si sedneme.",
      analyza45: "Finanční analýza", analyza45d: "Projdeme vaše cíle, příjmy a výdaje — základ pro finanční plán.",
      hypoteka: "Hypoteční konzultace", hypotekad: "Spočítáme hypotéku a porovnáme nabídky více bank.",
      servis60: "Servisní schůzka", servis60d: "Revize stávajících smluv a aktualizace vašeho plánu.",
    },
    title: "Online rezervace — nastavení",
    subtitle: "Propoj Google Calendar, nastav pracovní hodiny, buffer a délku schůzky. Klienti si rezervují přímo do tvého kalendáře.",
    enable: "Zapnout online rezervace",
    embedTitle: "Zobrazit Cal.com embed na vizitce",
    embedSub: "Klient si rezervuje přímo na vizitce (vyžaduje Calendar URL v profilu).",
    googleConnected: "Google Calendar propojen",
    connectGoogle: "Propojit Google Calendar",
    workHours: "Pracovní hodiny",
    meetingLength: "Délka schůzky (min)",
    buffer: "Pauza mezi schůzkami (min)",
    save: "Uložit nastavení",
    publicLink: "Veřejný rezervační odkaz",
    upcoming: "Nadcházející schůzky",
  },
  settings: {
    /* Vzhled aplikace + jazyk + země. Dřív to byly ternáry `lang === "sk"`
     * přímo v SettingsPage — znaly jen dva jazyky z pěti. */
    jazykAplikace: 'Jazyk aplikace',
    jazykNeniMena: 'Jazyk mění jen texty. Měna se řídí zemí (Česko → Kč, Slovensko → €), ne jazykem.',
    menaAplikace: 'Měna celé aplikace: {kod} ({symbol}). Přepnutí jazyka měnu NEMĚNÍ a částky se nepřepočítávají — aplikace nezná kurz. Změna země přeznačí jen nově zadávané částky, stará data zůstávají ve své původní měně.',
    motivAktivni: 'Aktivní motiv: ',
    motivJenHotove: 'V nabídce jsou jen dokončené motivy. Elite Light byl odebrán a tmavý motiv nikdy nebyl dotažený, proto je tu nenajdeš.',
    motivPoznamka: ' · Motiv je tvoje osobní nastavení v tomhle prohlížeči, klientům se neposílá. Barvy klientské vizitky se jím NEMĚNÍ — ty najdeš v Digitální vizitce.',
    oMne: 'O mně (zobrazí se na vizitce)',
    oMnePlaceholder: 'Pomáhám lidem dosáhnout finanční svobody...',
    vzhledSub: 'Vyber motiv aplikace — barvy se přepíšou okamžitě a volba ti zůstane i po obnovení stránky.',
    zeme: 'Země (určuje měnu)',
    zemeCZ: 'Česko',
    zemeSK: 'Slovensko',
    title: "Nastavení",
    profile: "Profil",
    web: "Moje webová stránka",
    webSub: "Profi mini-web s rezervací — šablona, služby, reference, FAQ.",
    booking: "Rezervace schůzek",
    bookingSub: "Google Calendar, pracovní hodiny, buffer, délka schůzky.",
    vizitka: "Digitální vizitka",
    vizitkaSub: "URL slug, QR kód, barvy, tisková A4 vizitka.",
    active: "AKTIVNÍ",
    saveProfile: "Uložit profil",
    tabZakladni: "Základní údaje", tabVzhled: "Vzhled aplikace", tabManazer: "Můj manažer", tabSocialni: "Sociální sítě",
    tabModelace: "Modelace", tabVideo: "Video intro", tabStatistiky: "Statistiky", tabHeslo: "Změna hesla", tabRezervace: "Rezervace schůzek",
    fJmeno: "Jméno *", fTelefon: "Telefon", fEmail: "Veřejný email", fSpolecnost: "Společnost",
    stareHeslo: "Staré heslo", noveHeslo: "Nové heslo", potvrditHeslo: "Potvrdit nové", zmenitHeslo: "Změnit heslo",
    fFotka: "Fotka poradce", fLogo: "Logo společnosti (volitelné)", fEmailManazera: "Email manažera",
  },
  cui: {
    mortgageModeling: "Hypoteční modelace",
    loanSummary: "Souhrn úvěru",
    amortTableTitle: "Splátkový kalendář (po letech)",
    tableYear: "Rok",
    remaining: "Zbývá doplatit",
    interestOfWhich: "Z toho na úrocích",
    disclaimerMortgagePdf: "Propočet je orientační. Skutečná nabídka banky se může lišit dle bonity klienta, LTV a aktuálních podmínek trhu. Modelace nenahrazuje závaznou nabídku úvěru.",
    modelReady: "Modelace připravena",
    pdfFailed: "Nepodařilo se vygenerovat PDF. Zkus to prosím znovu.",
    narrativeRate: "Výši splátky i celkové náklady úvěru zásadně určuje úroková sazba a délka fixace — vyplatí se je pravidelně porovnávat.",
    narrativeInterest: "Za celou dobu splácení zaplatíte na úrocích výrazně víc, než je samotná výše úvěru; kratší doba splácení přeplatek snižuje.",
    live: "Živý výpočet",
    exportPdf: "Export PDF pro klienta",
    mortgageHeadline: "Kolik tě bude stát <em>vlastní</em> bydlení?",
    propertyPrice: "Cena nemovitosti",
    downPayment: "Vlastní zdroje",
    rate: "Úroková sazba",
    years: "Doba splácení",
    yearsUnit: "let",
    monthsUnit: "měsíců",
    monthlyPayment: "Měsíční splátka",
    annuitySub: "Anuitní splátka při pevné sazbě",
    overpayment: "Přeplatek",
    overPrincipal: "přes jistinu",
    times: "×",
    loanAmount: "Výše úvěru",
    totalPaid: "Celkem zaplatíte",
    interestPaid: "Z toho úrok",
    ltvLow: "Nízké LTV — vyjednáš lepší úrok.",
    ltvStd: "Standardní LTV — bez problémů u většiny bank.",
    ltvHigh: "Nad závazným limitem {limit} — vlastních zdrojů je potřeba aspoň {castka}.",
    applicantAge: "Věk žadatele",
    ltvLimit: "Závazný limit {regulator}: {limit}.",
    ltvBezVeku: "Bez věku platí přísnější limit {limit} (mladší 36 let: {mladi}).",
    principal: "Jistina",
    interest: "Úrok",
    investmentHeadline: "Kde můžou být tvé peníze za <em>X</em> let?",
    monthlyDeposit: "Měsíční vklad",
    initialAmount: "Počáteční částka",
    horizon: "Investiční horizont",
    expectedReturn: "Očekávaný výnos",
    portfolioValue: "Hodnota portfolia",
    deposited: "Vloženo",
    earned: "Zhodnocení úroky",
    chartLegendDeposit: "Vklady",
    chartLegendValue: "Hodnota portfolia",
    disclaimer: "Propočet je orientační. Skutečná nabídka banky se může lišit dle bonity klienta, LTV a aktuálních podmínek trhu.",
    disclaimerInv: "Minulé výnosy nejsou zárukou budoucích. Propočet je orientační.",
    investmentModeling: "Investiční modelace",
    oneTimeInvest: "Jednorázová investice",
    monthlyInvest: "Měsíční investice",
    investHorizon: "Plánovaná délka investování",
    riskProfile: "Rizikový profil",
    expectedValue: "Očekávaná hodnota",
    expectedValueSub: "Očekávaná hodnota na konci investování",
    optimistic: "Optimistický scénář",
    pessimistic: "Pesimistický scénář",
    totalDeposited: "Celkem vloženo",
    today: "Dnes",
    yearN: "rok",
    deposit: "Vklad",
    zhodnoceni: "Zhodnocení",
    poslatKlientovi: "Poslat klientovi",
    rizikoPopis: "Vyšší rizikový profil může přinést vyšší výnos, ale i větší kolísání hodnoty. Hodnoty vycházejí z historických výnosů globálních akciových trhů.",
    narrativeInv1: "Pravidelné investování využívá sílu složeného úročení — čím dříve začnete, tím víc za vás pracuje čas.",
    narrativeInv2: "Jde o modelový odhad podle zvoleného rizikového profilu; výnosy nejsou zaručené a hodnota investice v čase kolísá.",
  },
  s: [null,
    { t: "Mindset & Start", st: "Základy podnikání a hodnoty beplan", v: ["Vítejte v beplan University","Proč beplan — hodnoty a smysl","Co je podnikání vs zaměstnání","Jak vypadá váš den v beplan","Kariéra a projekty v beplan","Jak funguje odměňování"], d: ["Úvodní video do vzdělávacího systému beplan University.","Jaké hodnoty stojí za beplan a proč to děláme.","Rozdíl v myšlení podnikatele a zaměstnance.","Typický den finančního poradce v beplan.","Kariérní cesta a možnosti růstu.","Systém odměňování, provize a bonusy."] },
    { t: "Finanční plán & Systém", st: "Základy finančního plánování a CRM", v: ["Co je finanční plán a proč ho každý potřebuje","7 oblastí finančního plánu","Jak vypadá reálné portfolio klienta","CRM a systém práce","Compliance a etika"], d: ["Proč je finanční plán základem každého poradenství.","Kompletní přehled 7 klíčových oblastí.","Praktické příklady portfolií reálných klientů.","Jak efektivně používat CRM systém.","Etický kodex a regulatorní požadavky."] },
    { t: "Obchodní proces & Dovednosti", st: "Od prvního telefonu po uzavření smlouvy", v: ["Proč finanční poradenství — hodnota pro klienta","První schůzka A1","Finanční analýza A2","Prezentace plánu P1 a podpis","Kde hledat klienty","Projekt 100","LinkedIn a Instagram","První telefon — skript","Strach z odmítnutí","Struktura hovoru a námitky","Jak žádat o doporučení","Zkoušky ČNB"], d: ["Jak prezentovat hodnotu finančního poradenství.","Struktura a průběh první schůzky.","Jak provést komplexní finanční analýzu.","Jak prezentovat finanční plán a uzavřít smlouvu.","Strategie pro získávání nových klientů.","Metodika Projekt 100 pro budování klientské základny.","Využití sociálních sítí pro získávání klientů.","Ověřený skript pro první telefonát.","Jak překonat strach z odmítnutí.","Jak strukturovat hovor a reagovat na námitky.","Techniky pro získávání doporučení.","Příprava na zkoušky České národní banky."] },
    { t: "Produkty", st: "Přehled finančních produktů", v: ["Životní pojištění","Neživotní pojištění","Hypotéky a úvěry","Stavební spoření","Investice","Penzijní spoření","Bankovní služby"], d: ["Kompletní průvodce životním pojištěním.","Majetkové pojištění a pojištění odpovědnosti.","Jak funguje hypoteční trh.","Stavební spoření — státní příspěvky a výhody.","Základy investování — fondy, akcie, dluhopisy.","III. pilíř penzijního systému.","Přehled bankovních produktů a služeb."] },
    { t: "Případové studie", st: "Reálné příklady z praxe", v: ["Případ 1 — Mladý single","Případ 2 — Rodina s hypotékou","Případ 3 — Klient s existujícími smlouvami","Případ 4 — Senior před důchodem","Nejčastější chyby nováčků"], d: ["Finanční plán pro mladého člověka bez závazků.","Komplexní řešení pro rodinu s hypotékou a dětmi.","Jak revidovat a optimalizovat stávající smlouvy.","Finanční plánování pro klienty blízko důchodu.","Jak se vyhnout nejčastějším chybám."] },
    { t: "Pokročilé", st: "Expertní témata a vedení týmu", v: ["Pokročilé nastavení životního pojištění","Investiční portfolio — sestavení a správa","Refinancování hypotéky — celý proces","Daňová optimalizace","Jak vést a školit vlastní tým"], d: ["Detailní nastavení produktů životního pojištění.","Jak sestavit a spravovat investiční portfolio.","Kompletní průvodce refinancováním hypotéky.","Legální způsoby optimalizace daňové zátěže.","Leadership a management v rámci finančního poradenství."] },
  ],
  c: [
    { t: "Hypoteční kalkulačka", s: "Výpočet měsíční splátky a celkového přeplatku hypotéky.", d: "Zjistěte výši měsíční splátky, celkový přeplatek a rozložení jistiny a úroků v čase.", i: ["Výše úvěru","Úroková sazba","Délka splatnosti"], o: ["Měsíční splátka","Celkem zaplaceno","Celkový přeplatek","Přeplatek %"], ds: ["Jistina","Úroky"] },
    { t: "Kalkulačka refinancování", s: "Porovnejte starou a novou hypotéku a zjistěte úsporu.", d: "Porovnejte stávající a novou hypotéku. Zjistěte měsíční a celkovou úsporu.", i: ["Zbývající jistina","Stávající sazba","Nová sazba","Zbývající splatnost"], o: ["Úspora měsíčně","Celková úspora","Stará splátka","Nová splátka"], ds: ["Stará hypotéka","Nová hypotéka"] },
    { t: "Doplacení hypotéky předčasně", s: "Zjistěte úsporu při mimořádných splátkách.", d: "Zjistěte, o kolik let zkrátíte hypotéku díky mimořádným splátkám.", i: ["Výše hypotéky","Úroková sazba","Délka splatnosti","Mimořádná splátka ročně"], o: ["Zkrácení o","Úspora na úrocích","Původní doba","Nová doba"], ds: ["Bez mimořádných splátek","S mimořádnými splátkami"] },
    { t: "Kalkulačka LTV", s: "Poměr úvěru k hodnotě nemovitosti.", d: "LTV ukazuje poměr úvěru k hodnotě nemovitosti. Čím nižší LTV, tím lepší sazbu získáte.", i: ["Hodnota nemovitosti","Výše úvěru"], o: ["LTV","Vlastní prostředky","Hodnocení sazby"], ds: ["Vlastní prostředky","Úvěr"] },
    { t: "Nájem vs koupě", s: "Porovnání celkových nákladů nájmu a koupě.", d: "Porovnejte celkové náklady na nájem a na koupi nemovitosti.", i: ["Cena nemovitosti","Měsíční nájem","Úroková sazba hypotéky","Horizont","Růst ceny nemovitosti ročně"], o: ["Celkové náklady nájmu","Čisté náklady koupě","Měsíční splátka","Hodnota nemovitosti"], ds: ["Nájem (kumulativně)","Koupě (čisté náklady)"] },
    { t: "Investiční kalkulačka — pravidelná", s: "Růst portfolia při pravidelném investování.", d: "Pravidelné investování je nejdostupnější cesta k budování majetku.", i: ["Měsíční investice","Roční výnos","Horizont","Počáteční vklad"], o: ["Výsledná hodnota","Celkem vloženo","Zhodnocení","Zhodnocení %"], ds: ["Vloženo","Hodnota portfolia"] },
    { t: "Složené úročení", s: "Síla složeného úročení v čase.", d: "Složené úročení je osmý div světa — úroky se přičítají k jistině.", i: ["Jednorázová investice","Roční výnos","Horizont"], o: ["Výsledná hodnota","Počáteční vklad","Celkový výnos","Výnos %"], ds: ["Hodnota investice"] },
    { t: "DCA vs jednorázová investice", s: "Srovnání strategií investování.", d: "Dollar Cost Averaging znamená pravidelné investování bez ohledu na vývoj trhu.", i: ["Měsíční částka DCA","Horizont","Průměrný výnos","Výnos spořicí účet"], o: ["DCA výsledek","Jednorázová investice","Spořicí účet","Celkem vloženo"], ds: ["DCA","Jednorázová","Spořicí účet"] },
    { t: "Inflační kalkulačka", s: "Jak inflace snižuje hodnotu vašich peněz.", d: "Inflace každý rok snižuje reálnou hodnotu peněz.", i: ["Současná částka","Průměrná inflace","Horizont"], o: ["Reálná hodnota","Ztráta kupní síly","Ztráta v %"], ds: ["Nominální hodnota","Reálná hodnota"] },
    { t: "FIRE kalkulačka", s: "Kolik potřebujete pro finanční nezávislost.", d: "FIRE — kolik kapitálu potřebujete k finanční nezávislosti? Pravidlo 4 %.", i: ["Měsíční výdaje v důchodu","Současný věk","Předpokládaný věk FIRE","Výnos portfolia"], o: ["Potřebný FIRE kapitál","Měsíční úspora","Roky do FIRE"], ds: ["Akumulace kapitálu","Cíl"] },
    { t: "Kalkulačka spoření na cíl", s: "Jak dlouho budete spořit na konkrétní cíl.", d: "Máte konkrétní cíl? Zjistěte, jak dlouho budete spořit.", i: ["Cílová částka","Počáteční vklad","Roční výnos","Měsíční úspora"], o: ["Dosažení cíle za","Celkem vloženo","Výnos navíc"], ds: ["Úspory","Cíl"] },
    { t: "Penzijní kalkulačka", s: "Kolik naspořite ve III. pilíři.", d: "Průměrný státní důchod nahradí pouze 40–54 % vaší mzdy.", i: ["Věk","Věk odchodu do důchodu","Měsíční příspěvek","Příspěvek zaměstnavatele","Výnos fondu"], o: ["Naspořená částka","Státní příspěvky celkem","Měsíční renta (20 let)"], ds: ["Vlastní","Zaměstnavatel","Stát","Výnosy"] },
    { t: "Kalkulačka důchodové mezery", s: "Zjistěte svoji důchodovou mezeru.", d: "Státní důchod nestačí na udržení životního standardu.", i: ["Současný čistý příjem","Odhadovaný státní důchod","Věk odchodu do důchodu","Délka důchodu"], o: ["Měsíční mezera","Celková mezera","Potřebný kapitál"], ds: ["Současný příjem (70 %)","Státní důchod","Mezera"] },
    { t: "Kalkulačka životního pojištění", s: "Doporučené krytí pro vaši situaci.", d: "Správně nastavená pojistná částka kryje výpadek příjmu.", i: ["Měsíční příjem","Měsíční výdaje rodiny","Výše hypotéky","Počet let krytí"], o: ["Krytí při smrti","Invalidita 3. stupně","Pracovní neschopnost/měs"], ds: ["Doporučené krytí"] },
    { t: "Stavební spoření", s: "Státní příspěvek až 1 000 Kč ročně.", d: "Stavební spoření je jediný produkt s garantovaným státním příspěvkem.", i: ["Měsíční vklad","Délka spoření","Úroková sazba"], o: ["Výsledná částka","Vlastní vklady","Státní příspěvky","Efektivní výnos p.a."], ds: ["Vklady","Státní příspěvky","Úroky"] },
    // POZOR: pořadí musí 1:1 sedět s CALCULATOR_CONFIGS — CalculatorsPage indexuje
    // slovník POZICÍ (`c.${CALCULATOR_CONFIGS.indexOf(calc)}.t`). DIP tady dřív chyběl,
    // takže se od této pozice dál všechny české popisky posunuly o jedna.
    { t: "Investiční kalkulačka — DIP", s: "Dlouhodobý investiční produkt.", d: "DIP — dlouhodobý investiční produkt s daňovým odpočtem až 48 000 Kč ročně. Pravidlo 120/60: výběr po 10 letech A v 60 letech věku.", i: ["Měsíční vklad","Příspěvek zaměstnavatele","Doba investice","Výnos","Sazba daně"], o: ["Hodnota portfolia","Roční daňová úspora","Daň. úspora celkem","Příspěvek zaměstnavatele"], ds: ["Portfolio"] },
    { t: "Cash flow kalkulačka", s: "Zdraví vašeho měsíčního cash flow.", d: "Zdravé cash flow je základ finančního plánu.", i: ["Čistá mzda","Ostatní příjmy","Bydlení","Jídlo a domácnost","Doprava","Pojistky","Zábava a koníčky","Spoření a investice","Ostatní výdaje"], o: ["Volné cash flow","Celkové příjmy","Celkové výdaje","Hodnocení"], ds: ["Bydlení","Jídlo","Doprava","Pojistky","Zábava","Spoření","Ostatní","Volné"] },
    { t: "Čistá hodnota majetku", s: "Nejdůležitější číslo vašeho finančního zdraví.", d: "Čistá hodnota majetku = aktiva minus pasiva.", i: ["Nemovitosti","Investice a fondy","Penzijní spoření","Hotovost a spořicí účty","Auto a ostatní","Hypotéka (zůstatek)","Spotřebitelské úvěry","Ostatní závazky"], o: ["Čistá hodnota","Celková aktiva","Celková pasiva"], ds: ["Aktiva","Pasiva"] },
    { t: "Kalkulačka daňové úspory", s: "Maximální daňová úspora z finančních produktů.", d: "Správně nastavené finanční produkty vám mohou ušetřit tisíce korun ročně.", i: ["Hrubá mzda měsíčně","Životní pojištění/měs","Penzijní spoření/měs","Úroky z hypotéky ročně","Dary a ostatní odpočty"], o: ["Daňová úspora ročně","Odpočty celkem","Daň bez odpočtů","Daň s odpočty"], ds: ["Životní poj.","Penzijní sp.","Úroky hypo.","Dary"] },
    { t: "Úvěrová kalkulačka — RPSN", s: "Skutečná cena úvěru včetně všech poplatků.", d: "RPSN ukazuje skutečnou cenu úvěru. Vždy porovnávejte RPSN.", i: ["Výše úvěru","Úroková sazba","Měsíční poplatek","Splatnost"], o: ["Měsíční splátka","Celkový přeplatek","RPSN","Celkem zaplaceno"], ds: ["Jistina","Úroky","Poplatky"] },
    { t: "Finanční zdraví skóre", s: "Komplexní hodnocení finanční situace.", d: "Komplexní hodnocení finanční situace v 5 dimenzích.", i: ["Likvidní rezerva (měsíce výdajů)","Zadluženost (% příjmu)","Míra spoření (% příjmu)","Pojištění","Investice"], o: ["Celkové skóre","Kategorie","Doporučení"], ds: ["Vaše skóre"] },
  ],
  tools: {
    /* Nástroje ke schůzce — dlaždice na /nastroje. Bez těchhle klíčů by
       titulek i popis zůstaly česky ve všech jazycích (fallback). */
    "kalk-zlato": { t: "Zlato — kolik zbyde klientovi", d: "Kdy padne první gram, kolik sní poplatek a rozdíl nákup/výkup, měnové riziko dolaru zvlášť a srovnání s jinými aktivy. Gramy i v chỉ a lượng.", short: "Gramy, poplatek a kurz dolaru" },
    "kalk-konsolidace": { t: "Konsolidace úvěrů", d: "Celkem teď vs. celkem po — ne dvě splátky. Dopočítá sazbu každého úvěru a umí ukázat i případ, kdy se konsolidace NEVYPLATÍ.", short: "Celkem teď vs. celkem po" },
    "kalk-podpojisteni": { t: "Podpojištění provozovny", d: "Kolik pojišťovna doopravdy vyplatí, když je pojistná částka nižší než hodnota majetku (§ 2854). Se sezónní špičkou zásob před Tết a Vánoci.", short: "Kolik pojišťovna fakt vyplatí" },
    "kalk-doplaceni": { t: "Doplacení hypotéky dřív", d: "Mimořádné splátky vs. investice na stejném cashflow. Graf dvou křivek a jejich průsečík, tři čísla pro klienta, scénář „trh nedá nic“ a klesající krytí. Prezentační režim pro schůzku.", short: "Splácet navíc, nebo investovat?" },
    provize: { t: "Provizní kalkulačka", d: "201 produktů z katalogu BJ. Zadej pozici + produkty → provize za 1. rok i opakovaně. Pro poradce i nábor.", short: "201 produktů z katalogu BJ" },
    analyza: { t: "Finanční analýza", d: "Řízená 45min schůzka — hodnoty, cíle, zdroje, rizika. Skripty vedou i nováčka. Vyber klienta nebo založ nového.", short: "Řízená 45min schůzka od A do Z" },
    posta: { t: "Pošta + AI Email", d: "Tvůj Gmail v CRM. Hlas/text příkaz → AI vygeneruje email + odešle. Hromadné AI kampaně.", short: "Gmail v CRM + AI e-maily" },
    leadgen: { t: "Leadovač", d: "15 leadgen funnelů — Hypotéka, Investice, OSVČ, Rodina a další. Sdílej link, dostávej leady do CRM.", short: "15 leadgen funnelů → CRM" },
    trychtyre: { t: "Trychtýře", d: "15 hotových funnel landingů ve stylu Konverzky (hodnota zdarma → kontakt). Dej Náhled, zkopíruj svůj odkaz, sdílej. Lead padne do CRM.", short: "15 funnel landingů ke sdílení" },
    "funnel-knihovna": { t: "Knihovna funnelů", d: "53 hotových funnelů kompletně: landing texty, e-mailové sekvence, reklamy, ebooky, scénáře webinářů i hovorů. Plus formulář, který z tvých odpovědí složí zadání na nový funnel.", short: "53 funnelů + skládač zadání" },
    mesicnik: { t: "Měsíčník pro klienty", d: "Vydané číslo měsíčníku pošleš klientům se souhlasem s marketingem: náhled e-mailu i webové verze, odhlášení jedním klikem. Data z veřejných zdrojů (ECB, centrální banky a další).", short: "Číslo měsíčníku klientům" },
    "byznys-plan": { t: "Můj byznys plán", d: "Roční plán poradce podle vzoru z kurzu Jak budovat poradenský byznys: loňská čísla z CRM, vize, podnikatelské a osobní cíle, marketing, měsíční cíle s odměnou, denní návyky, termíny revize. Ukládá se na server, tisk na A4.", short: "Vize, cíle, marketing, měsíční plán" },
    trychtyrBuilder: { t: "Trychtýř od A do Z", d: "Průvodce 7 kroky podle metodiky Konverzky: magnet, stránka, děkovačka, telefonní skript, mini-webinář, e-mailová sekvence, reklama a měření (pixel). Šablony k vyplnění bez AI, uložené pro tebe; hotové leadovače, trychtýře a web jen zapojíš.", short: "7 kroků od magnetu po pixel" },
    "fin-matematika": { t: "Finanční matematika", d: "Úvěr / Hypotéka, Investice a Renta. Vlajka = dopočítej cokoliv. Velký graf, validace, frekvence úroku.", short: "Úvěr, investice, renta — dopočet" },
    penze: { t: "Penzijní kalkulačka (DPS/DIP)", d: "Penzijko a DIP: modelace do budoucna se státní podporou a daněmi, historická kalkulačka na skutečných výnosech fondů, srovnání fondů a plán renty.", short: "DPS + DIP, historie, fondy, renta" },
    izp: { t: "Analýza pro Vietnamce", d: "Vysvětlí klientovi, proč má mít životní pojištění: příjem, balíček 10/20/30 %, rizika, graf do 60/65/70 let, co dostane rodina a co zbyde.", short: "Pojištění a investice krok za krokem" },
    "zivotni-pojisteni": { t: "Životní pojištění", d: "Doporučené krytí za pár vteřin: smrt, invalidita, pracovní neschopnost (PN), trvalé následky, závažná onemocnění. Pro snadný prodej i nováčkem.", short: "Doporučené krytí za pár vteřin" },
    "rodinny-plan": { t: "Rodinný finanční plán (CZ/VI)", d: "Patnáct minut s klientem: příjem → výdaje → co zbývá → co se stane při výpadku → kolik ochrany a kolik na majetek. Dvojjazyčně česky a vietnamsky, režim pro klienta. Nezačíná produktem.", short: "Patnáct minut s klientem" },
    historicka: { t: "Historická kalkulačka", d: "Na reálných datech 1926–2026 ukaž klientovi, jak by investice dopadla. S&P 500, dluhopisy, zlato, inflace.", short: "Reálná data 1926–2026" },
    "svoboda": { t: 'Kdy budeš volný', d: 'Peníze přeložené na čas. Místo pěti procent nad inflací uslyší klient, o kolik let dřív přestane muset chodit do práce. Posuvník navíc → značka na ose se rozjede doleva. Plus cena za čekání.', short: 'Peníze přeložené na čas' },
    "hypoteka-rozhodnuti": { t: 'Hypotéka — čtyři rozhodnutí', d: 'Konec fixace, 20 vs. 30 let, kolik dát vlastních, vliv času. Porovnává celé měsíční zatížení, ne jen splátku — proto to často vyjde obráceně, než klient čeká. Každá záložka končí jednou větou.', short: 'Fixace, splatnost, vlastní, čas' },
    fixace: { t: 'Fixace pod kontrolou', d: 'Co se stane PO fixaci. Krátká fixace vs. dlouhá na jedné ose, splátka proti rozpočtu domácnosti a jedno číslo: sazba, nad kterou to praskne. Na reálných sazbách ČNB 2006–2026 — včetně toho, jak často v Česku sazba po refixaci vyskočila.', short: 'Co se stane PO fixaci' },
    "renta-porovnavac": { t: "Čerpání renty — tři způsoby", d: "Kolik klient dostane měsíčně u pevného %, klouzavého průměru a mantinelů. Vidí i cenu: kdy a o kolik by se muselo snížit. Portfolio poučené Nobelovou nadací, doloženo roky 1966 a 2000.", short: "Pevné % vs. průměr vs. mantinely" },
    "investicni-strategie": { t: "Investiční strategie", d: "Jak investují největší fondy a nejbohatší — Norský fond, Nobelova nadace, Ray Dalio, Core-Satellite. Pro klienty + složené úročení a nekonečná renta.", short: "Jak investují největší fondy" },
    "srovnavac-fondu": { t: "Srovnávač fondů", d: "Porovnej dva fondy/ETF — kolik z výnosu si vezmou poplatky. Katalog ETF + českých fondů, graf, rozdíl v částce. Pro klienta, bez AI.", short: "Dva fondy a co vezmou poplatky" },
    "portfolio-doktor": { t: "Portfolio doktor", d: "Celé portfolio klienta najednou: vážená nákladovost (a z kolika % majetku je spočítaná), kolik udělá rozdíl za horizont, rozložení, verdikt u každé položky — včetně „ponechat“. Nákladovost zadáváš z KID, aplikace si nic nevymýšlí.", short: "Nákladovost celého portfolia" },
    "investicni-studio": { t: "Investiční studio (DEMO)", d: "Školící prezentace pro klienta: HWM Lab (poplatek za výkon), Dnes vs. návrh, Portfolio Composer, historické krize, rozpad nákladů. Modelový klient, ne osobní doporučení.", short: "Školící prezentace pro klienta" },
    "nemovitost-pronajem": { t: "Nemovitost na pronájem", d: "Kolik byt na nájem SKUTEČNĚ vynáší — cash flow v čase, kolik let ho dotuješ, efektivní výnos, stress test. Rozbije růžové představy klienta.", short: "Kolik byt na nájem vynáší" },
    calculators: { t: "Kalkulačky", d: "20 finančních kalkulaček — hypotéka, investice, pojištění, důchod, osobní finance.", short: "20 finančních kalkulaček" },
    "portfolio-doctor": { t: "Portfolio Doctor", d: "Diagnostika klientského portfolia — ISIN → ETF alternativa + AI brief.", short: "ISIN → ETF alternativa + AI brief" },
    "akademie-produkty": { t: "Produktová akademie pro nováčky", d: "10 modulů: produkty, navolávání, argumentace, uzavírání — s kvízy a skripty. Z nováčka profík.", short: "10 modulů s kvízy a skripty" },
    akademie: { t: "Akademie poradce (videa)", d: "Vzdělávací série videí — Mindset, Finanční plán, Obchodní proces a další.", short: "Vzdělávací série videí" },
    income: { t: "Cílový příjem", d: "Zpětný výpočet od požadovaného příjmu k počtu schůzek a telefonátů.", labels: ["Požadovaný měsíční příjem","Průměrná provize/smlouva","Konverze schůzka → smlouva","Konverze telefon → schůzka"], funnel: ["Telefonátů za den","Telefonátů za měsíc","Schůzek za měsíc","Smluv za měsíc"] },
    objections: { t: "Námitky & odpovědi", d: "Klikněte na kartu pro zobrazení doporučené odpovědi.", q: ["Nemám zájem","Mám poradce","Nemám čas","Nemám peníze","Pošlete email","Musím se poradit s manželem/kou","Zkusím to sám","Mám smlouvy v pořádku","Teď není dobrý čas","Jak víte že jste lepší?"], a: ["Chápu. Mohu se zeptat, co přesně vám přijde nezajímavé?","To je skvělé! Jak často vám váš poradce dělá revizi finančního plánu?","Rozumím, čas je vzácný. Nabízím efektivní schůzku na 45 minut.","Právě proto je důležité se potkat. Pomáháme najít úspory ve stávajících smlouvách.","Rád pošlu. Nicméně každá situace je unikátní. Můžeme se setkat na 30 minut?","Samozřejmě! Budete na schůzce oba — je důležité, aby rozhodování bylo společné.","Respektuji to. Víte, že průměrný člověk bez poradce ztrácí ročně 15–30 tisíc?","To je skvělé! Kdy naposledy jste je revidovali? Trh se mění.","Rozumím. Kdy by to bylo lepší? Rád se ozvu.","Neděláme si nárok na to, že jsme nejlepší. Naše síla je v komplexním přístupu."] },
    checklist: { t: "Kontrolní seznam schůzky A1", d: "Kompletní checklist pro první schůzku.", cols: ["Před schůzkou","Během schůzky","Po schůzce"], before: ["Připravit prezentaci","Zkontrolovat CRM údaje","Připravit smlouvy k podpisu","Ověřit dostupnost klienta","Připravit vizitky a materiály","Nastavit budík/připomínku"], during: ["Ice break a budování vztahu","Zjištění očekávání klienta","Představení beplan","Finanční analýza (7 oblastí)","Prezentace řešení","Dohodnutí dalšího kroku","Požádat o doporučení"], after: ["Zapsat poznámky do CRM","Odeslat shrnutí emailem","Připravit návrh smluv","Naplánovat follow-up","Aktualizovat pipeline"] },
    timer: { t: "Časovač schůzky", d: "Časovač s 5 fázemi pro strukturovanou schůzku.", phases: ["Ice break","Zjištění očekávání","Představení","Princip komplexnosti","Závěr a termín"] },
    pyramid: { t: "Pyramida osobních financí", d: "Klikněte na vrstvu pro zobrazení detailu.", layers: [{ n: "Investování", d: "Aktivní budování majetku — akcie, fondy, nemovitosti." },{ n: "Ostatní potřeby", d: "Spořicí účty, stavební spoření, účelové spoření." },{ n: "Bydlení", d: "Vlastní bydlení nebo investice do nemovitosti." },{ n: "Budoucí příjmy (penzijní)", d: "III. pilíř penzijního spoření se státními příspěvky." },{ n: "Zajištění příjmů", d: "Životní pojištění, úrazové pojištění, nemocenská." }] },
    compare: { t: "Porovnání produktů", d: "Srovnání finančních produktů vedle sebe." },
    glossary: { t: "Slovník pojmů", d: "Prohledávatelný slovník finančních pojmů." },
  },
  g: [
    { t: "RPSN", d: "Roční procentní sazba nákladů — ukazuje skutečnou cenu úvěru včetně všech poplatků.", e: "Banka nabízí úvěr se sazbou 5 %, ale RPSN je 6,2 % kvůli poplatkům." },
    { t: "LTV", d: "Loan to Value — poměr výše úvěru k hodnotě nemovitosti.", e: "Při koupi bytu za 5 mil. Kč s hypotékou 4 mil. Kč je LTV 80 %." },
    { t: "Invalidita 1. stupně", d: "Pokles pracovní schopnosti o 35–49 %. Nárok na částečný invalidní důchod.", e: "Klient s chronickým onemocněním, který může pracovat na částečný úvazek." },
    { t: "Invalidita 2. stupně", d: "Pokles pracovní schopnosti o 50–69 %.", e: "Klient po vážném úraze, který může vykonávat pouze lehkou práci." },
    { t: "Invalidita 3. stupně", d: "Pokles pracovní schopnosti o 70 % a více. Plný invalidní důchod.", e: "Klient, který není schopen žádné práce." },
    { t: "DPS", d: "Doplňkové penzijní spoření — III. pilíř penzijního systému se státními příspěvky.", e: "Při spoření 1 000 Kč měsíčně získáte státní příspěvek 230 Kč." },
    { t: "Transformovaný fond", d: "Původní penzijní fondy s garancí nezáporného zhodnocení.", e: "Staré penzijní připojištění před rokem 2013." },
    { t: "Volatilita", d: "Míra kolísání hodnoty investice v čase.", e: "Akcie mají vyšší volatilitu než dluhopisy." },
    { t: "Diverzifikace", d: "Rozložení investice do více aktiv pro snížení rizika.", e: "Investovat do akcií, dluhopisů i nemovitostí zároveň." },
    { t: "Složené úročení", d: "Úroky se přičítají k jistině a dál vydělávají další úroky.", e: "100 000 Kč při 7 % p.a. za 20 let = 386 968 Kč." },
    { t: "Cash flow", d: "Tok peněz — rozdíl mezi příjmy a výdaji za určité období.", e: "Měsíční příjem 55 000 Kč minus výdaje 42 000 Kč = volné cash flow 13 000 Kč." },
    { t: "Finanční plán", d: "Komplexní dokument mapující finanční situaci klienta a navrhující optimální řešení.", e: "Plán zahrnuje pojištění, investice, spoření a důchod." },
    { t: "Pojistná událost", d: "Náhodná událost, na kterou se pojištění vztahuje.", e: "Úraz, nemoc, poškození majetku živelní pohromou." },
    { t: "Pojistné plnění", d: "Částka vyplacená pojišťovnou při pojistné události.", e: "Při úraze s trvalými následky pojišťovna vyplatila 500 000 Kč." },
    { t: "Fixace", d: "Období, po které je úroková sazba hypotéky neměnná.", e: "Fixace na 5 let znamená, že sazba se 5 let nezmění." },
    { t: "Anuitní splátka", d: "Stejná měsíční splátka po celou dobu úvěru.", e: "Splátka 15 000 Kč měsíčně po celou dobu hypotéky." },
    { t: "Bonita", d: "Schopnost klienta splácet úvěr, hodnocená bankou.", e: "Banka posuzuje příjem, výdaje a stávající závazky." },
    { t: "ETF", d: "Exchange Traded Fund — fond obchodovaný na burze, sledující index.", e: "S&P 500 ETF sleduje 500 největších amerických firem." },
    { t: "Dluhopis", d: "Cenný papír, kterým emitent slibuje splacení jistiny a úroků.", e: "Státní dluhopisy jsou považovány za bezpečnou investici." },
    { t: "Portfolio", d: "Souhrn všech investic a aktiv klienta.", e: "Portfolio složené z 60 % akcií a 40 % dluhopisů." },
    { t: "Rebalancing", d: "Pravidelné přizpůsobení složení portfolia cílové alokaci.", e: "Pokud akcie vyrostly na 70 %, prodat část a dokoupit dluhopisy." },
    { t: "TER", d: "Total Expense Ratio — celkové náklady fondu v procentech.", e: "Fond s TER 0,5 % si ročně strhne 0,5 % z investice." },
    { t: "Státní příspěvek", d: "Příspěvek státu k penzijnímu nebo stavebnímu spoření.", e: "Max. 230 Kč měsíčně k penzijnímu spoření při vkladu 1 700 Kč." },
    { t: "Vinkulace", d: "Omezení nakládání s finančními prostředky ve prospěch třetí strany.", e: "Vinkulace pojistky ve prospěch banky u hypotéky." },
    { t: "Odkladná doba", d: "Období od vzniku pojistné události do začátku výplaty.", e: "Odkladná doba 28 dnů u pracovní neschopnosti." },
    { t: "Konsolidace dluhů", d: "Sloučení více úvěrů do jednoho s výhodnějšími podmínkami.", e: "Nahrazení 3 spotřebitelských úvěrů jedním s nižší splátkou." },
    { t: "FIRE", d: "Financial Independence, Retire Early — hnutí za finanční nezávislost.", e: "Cíl: naspořit 25násobek ročních výdajů a žít z 4% výběru." },
    { t: "Compliance", d: "Soulad s právními a regulatorními požadavky v oboru.", e: "Dodržování pravidel ČNB pro finanční poradce." },
  ],
  // Poznámkový blok na nástěnce (panel „Poznámky") — prázdný papír + štítky.
  poznamky: {
    title: "Poznámky",
    new: "Nová poznámka",
    placeholder: "Pište…",
    emptyTitle: "Zatím žádná poznámka",
    emptyDesc: "Klikněte a pište — prázdný papír, který se uloží sám.",
    allTags: "Vše",
    addTag: "Přidat štítek",
    removeTag: "Odebrat štítek",
    tagPlaceholder: "štítek",
    filterEmpty: "S tímto štítkem nic není.",
    clearFilter: "Zrušit filtr",
    delete: "Smazat poznámku",
    deleteConfirm: "Opravdu smazat?",
    saving: "Ukládám…",
    saved: "Uloženo",
    saveFailed: "Neuloženo — úložiště prohlížeče je plné",
  },
  /* === NASTROJE: ruční převod jazykových ternárů (dávka „nastroje") === */
  nastroje: {
    /* === RYCHLÉ NÁSTROJE V LIŠTĚ ANALÝZY (boční pruh ikon) ===
     * Kalkulačky, které poradci vyjedou PŘES rozdělanou analýzu, předvyplněné
     * čísly toho klienta. Texty jsou kratší než na /kalkulacka — poradce je
     * čte u stolu, ne v klidu před schůzkou.
     * ⚠️ Modelace se NEUKLÁDÁ (patička panelu) a hlášky enginu doplacení jedou
     * na už přeložených klíčích `nastroje.schuzka.doplaceni.hlaska*`, ať se
     * znění v celé appce nerozejde. */
    pruh: {
      nadpis: "Rychlé nástroje",
      otevrit: "Otevřít rychlé nástroje",
      zavrit: "Zavřít",
      tabHypo: "Hypotéka",
      tabDoplaceni: "Hypotéka s investicí",
      tabZivot: "Životní pojištění",
      tabInvestice: "Investice",
      znovuZAnalyzy: "Načíst čísla znovu z analýzy",
      neukladaSeTuk: "Modelace se neukládá.",
      neukladaSeText: "Čísla z tohoto panelu nejdou do analýzy ani do plánu a po obnovení stránky jsou pryč. Co chceš klientovi nechat, přepiš do analýzy nebo do návrhu řešení.",
      padTuk: "Nástroj se nepodařilo zobrazit.",
      padText: "Analýza je v pořádku a zůstala otevřená. Zkus jiný nástroj a chybu nahlas — podrobnost je v konzoli prohlížeče.",
      /* Štítky pod poli. `zAnalyzy` zakládá lištu pro všechny nástroje. */
      zAnalyzy: "z analýzy",
      zPrebytku: "z přebytku v analýze",
      bezPrijmu: "Bez čistého příjmu v analýze se zadluženost spočítat nedá.",
      chybiNadpis: "Chybí údaj",
      chybiObecne: "Některý vstup chybí nebo je mimo rozsah — zkontroluj zadání.",
      skriptNadpis: "Co říct klientovi",
      hypo: {
        zadani: "Nemovitost a úvěr",
        cena: "Cena nemovitosti",
        vlastni: "Vlastní zdroje",
        sazba: "Úroková sazba",
        splatnost: "Splatnost",
        dosaditPrumer: "Dosadit průměr trhu {sazba} ({obdobi})",
        prumerNeniNabidka: "Průměrná nabídková sazba trhu, ne nabídka konkrétní banky.",
        vysledek: "Splátka a limity",
        splatka: "Měsíční splátka",
        splatkaNote: "Stejná splátka po celou splatnost při zadané sazbě.",
        uver: "Výše úvěru",
        ltv: "LTV — úvěr k ceně",
        ltvLimit: "Závazný limit {limit}.",
        /* Přilepuje se za limit oddělovačem, proto malé písmeno a bez tečky. */
        bezVeku: "věk v analýze chybí, počítá se s přísnějším limitem {limit}",
        ltvNad: "Nad limitem — vlastních zdrojů je potřeba aspoň {castka}.",
        dsti: "DSTI — splátky k příjmu",
        dstiLimit: "Doporučený limit {limit} čistého příjmu, započtené jsou i stávající splátky.",
        dti: "DTI — dluh k příjmu",
        dtiLimit: "Doporučený limit {limit}× čistý roční příjem.",
        celkemZaplaceno: "Celkem zaplaceno bance",
        zTohoUroky: "Z toho úroky",
        stavajiciSplatky: "Stávající splátky z analýzy",
        skript: "Banka se dívá na tři čísla: kolik si berete proti ceně nemovitosti, kolik vám splátky ukrojí z příjmu a kolik dlužíte proti ročnímu příjmu. Podívejme se, jak na tom jste — a kde by bylo potřeba přidat vlastní zdroje.",
        chybiCena: "Doplň cenu nemovitosti.",
        chybiSazba: "Doplň úrokovou sazbu — bez ní splátka nevznikne.",
        chybiSplatnost: "Doplň splatnost v letech.",
        chybiVlastni: "Doplň vlastní zdroje — bez nich se nedá spočítat výše úvěru.",
        bezVlastnich: "Klient nemá vlastní zdroje",
        chybiVlastniNadCenu: "Vlastní zdroje jsou vyšší než cena nemovitosti — na úvěr pak nezbývá nic.",
      },
      doplaceni: {
        zadani: "Hypotéka a peníze navíc",
        jistina: "Zbývající jistina",
        sazba: "Úrok hypotéky",
        splatnost: "Splatnost",
        volnaCastka: "Volné peníze měsíčně",
        vynos: "Očekávaný výnos investice",
        horizont: "Chce doplatit za",
        predpoklad: "předpoklad poradce",
        neniVAnalyze: "v analýze není — doplň",
        predpokladyPoznamka: "Počítá se s poplatkem fondu {ter} ročně a s daní z prodeje při doplacení. Výnos zadávej nominálně, tedy stejně jako úrok hypotéky — jinak by investice dostala zadarmo celou inflaci.",
        stitkyPoznamka: "Štítky u polí říkají, odkud číslo přišlo, když se panel otevřel. Co přepíšeš, je tvůj předpoklad.",
        chybiJistina: "Doplň zbývající jistinu hypotéky.",
        chybiSazba: "Doplň úrokovou sazbu hypotéky. Nula není sazba, a bez sazby by investice vyhrála vždycky.",
        vysledek: "Za {roky}: co klientovi zůstane",
        cestaSplaceni: "Splácet navíc",
        cestaSplaceniNote: "Hypotéka doplacená za {kdy}, pak se stejná částka investuje.",
        cestaInvestice: "Investovat a doplatit naráz",
        cestaInvesticeNote: "Portfolio po dani {portfolio} minus zbývající dluh {dluh}.",
        vitezInvestice: "Lépe vychází investovat",
        vitezInvesticeText: "Za {roky} zůstane klientovi o {castka} víc než při splácení navíc. Platí to jen tehdy, když trh výnos doopravdy dodá.",
        vitezSplaceni: "Lépe vychází splácet navíc",
        vitezSplaceniText: "Za {roky} zůstane klientovi o {castka} víc, když peníze pošle do hypotéky. Splátka je jistá, výnos ne.",
        remiza: "Obě cesty vyjdou nastejno",
        remizaText: "Za {roky} je rozdíl mezi cestami zanedbatelný. Rozhoduje tedy jistota, ne výnos — a jistá je mimořádná splátka.",
        splatka: "Splátka hypotéky",
        vydajObe: "Z rozpočtu odejde v obou cestách",
        usporaSplaceni: "Úspora na úrocích — splácet navíc",
        usporaInvestice: "Úspora na úrocích — investovat",
        danPriDoplaceni: "Daň z prodeje při doplacení",
        poplatky: "Poplatky investice celkem",
        hranice: "Hraniční výnos investice",
        hraniceNote: "Pod tímhle výnosem investice prohrává — už po dani a poplatcích. Nad ním vydělá.",
        hraniceNikdy: "Investice mimořádnou splátku nepřekoná ani při velmi vysokém výnosu — typicky kvůli krátkému horizontu, poplatkům nebo dani.",
        prusecikText: "Portfolio poprvé pokryje zbývající dluh za {roky}. Doplácelo by se {castka} — od té chvíle se klient může rozhodnout.",
        prusecikNikdy: "Portfolio na pokrytí dluhu v zadaném horizontu nedosáhne.",
        urokyPoznamka: "Úspora na úrocích se porovnává až do úplného splacení, ne jen k datu doplacení — jinak by cesta, která ještě dluží, vypadala úspornější, než je.",
        orientacniNadpis: "Orientační modelace",
        orientacni: "Není to nabídka úvěru ani příslib plnění a nepočítá s podmínkami konkrétní smlouvy. Limit bezplatné mimořádné splátky, poplatky banky a sazbu po fixaci ověř ve smlouvě; daňová pravidla se do data doplacení mohou změnit.",
        plnaKalkulacka: "Scénáře propadu trhu, fixaci a klesající krytí spočítá plná kalkulačka v Nástrojích.",
        skript: "Máte dvě možnosti, jak se hypotéky zbavit. Buď do ní posíláte navíc, nebo ty peníze investujete a doplatíte ji naráz. Spočítejme obojí — a hlavně to, co se stane, když trh nevydělá tolik, kolik čekáme.",
      },
      zivot: {
        zadani: "Rodina a závazky",
        nezbytne: "Nezbytné výdaje domácnosti",
        horizont: "Na kolik let krýt",
        dluhy: "Dluhy celkem",
        rezerva: "Likvidní rezerva",
        vdovsky: "Vdovský důchod",
        sirotci: "Sirotčí důchod celkem",
        davkaSablona: "šablona země — přepiš podle klienta",
        varianta: "Varianta krytí",
        smrt: "Pojistná částka — smrt",
        invalidita: "Pojistná částka — invalidita",
        zavazne: "Závažná onemocnění",
        tnu: "Trvalé následky úrazu",
        pn: "Pracovní neschopnost",
        /* Lepí se hned za částku, proto ta mezera na začátku. */
        denne: " / den",
        rozpad: "Z toho dluhy {dluhy}, cíle {cile} a výdaje domácnosti {vydaje}.",
        chybiPrijem: "V analýze nemá příjem nikdo — kapitálová metoda pak nemá z čeho počítat.",
        chybiVydaje: "Doplň nezbytné výdaje domácnosti.",
        chybiHorizont: "Doplň, na kolik let má krytí vystačit.",
        chybiPozustalostni: "Pro tuhle zemi nemáme ověřenou pozůstalostní dávku — bez ní by krytí smrti vyšlo podstřelené. Doplň ji do pojistných limitů.",
        skript: "Spočítám vám to obráceně, než jak to dělá pojišťovna. Ne kolik si můžete dovolit platit, ale kolik by rodina potřebovala, aby žila dál stejně a dodělala to, co jste si naplánovali. Od toho čísla se pak teprve bavíme o ceně.",
      },
      invest: {
        zadani: "Vklady a horizont",
        mesicne: "Měsíčně",
        jednorazove: "Jednorázově dnes",
        rezervaNeni: "likvidní rezerva se sem nedosazuje",
        roky: "Doba investování",
        vynos: "Očekávaný výnos",
        vynosPredpoklad: "předpoklad poradce",
        vysledek: "Kolik z toho bude",
        konecnaHodnota: "Hodnota na konci",
        vDnesnichCenach: "Nominálně, bez přepočtu na dnešní ceny — inflace kupní sílu sníží.",
        vlozeno: "Vloženo celkem",
        vynosCelkem: "Z toho výnos",
        neniGaranceNadpis: "Výnos není garantovaný.",
        neniGarance: "Je to předpoklad, ne příslib. Trh může několik let klesat a hodnota může být i nižší než vložená částka. Řekni to klientovi dřív, než mu ukážeš konečné číslo.",
        skript: "Tohle je to, co vám každý měsíc zbývá. Nechte to ležet na účtu a za deset let to bude pořád stejná částka, jen si za ni koupíte méně. Tady je druhá možnost — a hned u ní i věta, kterou vám musím říct: výnos je předpoklad, ne příslib.",
        chybiVklad: "Doplň měsíční vklad nebo jednorázovou částku.",
        chybiRoky: "Doplň dobu investování v letech.",
        chybiVynos: "Doplň očekávaný výnos.",
      },
    },
    /* === NÁSTROJE KE SCHŮZCE (zlato / konsolidace / podpojištění) ===
     * Klientské kalkulačky na /kalkulacka/:nastroj. Texty jsou psané tak, aby
     * je poradce mohl na schůzce ŘÍCT NAHLAS — proto tu jsou celé věty, ne
     * jen štítky. Vietnamská verze nese české odborné termíny v závorce,
     * protože klient i úřad je uvidí na smlouvě.
     * ⚠️ Čísla v kalkulačkách jsou ŠABLONA, ne nabídka — viz `sablonaText`. */
    schuzka: {
      sekce: "Nástroje ke schůzce",
      titulek: "Kalkulačky, které klient vidí na stole",
      podtitulek: "Čtyři výpočty, na kterých se schůzka láme: kolik zlata klientovi opravdu zbyde, jestli se konsolidace vyplatí — i když se nevyplatí — kolik pojišťovna doopravdy vyplatí, a jestli hypotéku splácet navíc, nebo investovat a doplatit ji naráz. Měna se bere ze země tvého tenanta, ne z jazyka.",
      zpet: "Zpět na Nástroje",
      tabZlato: "Zlato",
      tabKonsolidace: "Konsolidace úvěrů",
      tabPodpojisteni: "Podpojištění",
      tabDoplaceni: "Doplacení hypotéky",
      zadani: "Zadání",
      vysledek: "Výsledek",
      vetaNaSchuzku: "Věta na schůzku — řekni ji doslova",
      kdyNedoporucit: "Kdy tohle NEDOPORUČUJ",
      postup: "Krok za krokem",
      orientacniTuk: "Orientační výpočet, ne nabídka.",
      orientacniText: "Modelace slouží k vysvětlení, jak produkt funguje. Není to nabídka, příslib plnění ani individuální doporučení. Závazná čísla dá až smlouva, ceník a pojistné podmínky.",
      sablonaTuk: "Čísla jsou šablona — ověř je před schůzkou.",
      sablonaText: "Ceny, sazby i poplatky se mění. Vytáhni si aktuální hodnoty z partnerského portálu nebo ze sazebníku ke dni schůzky a přepiš je tady.",
      mesicOne: "měsíc",
      mesicFew: "měsíce",
      mesicMany: "měsíců",
      rokOne: "rok",
      rokFew: "roky",
      rokMany: "let",
      zlato: {
        popis: "Klient nekupuje jen zlato — kupuje zlato, poplatek, rozdíl mezi nákupní a výkupní cenou a k tomu cizí měnu. Ukaž mu to všechno najednou, ať za dva roky nemá překvapení.",
        jednorazove: "Jednorázový vklad",
        mesicne: "Měsíční platba",
        roky: "Horizont",
        typ: "Typ smlouvy — kolik z platby jde na poplatek",
        typJednorazovy: "Jednorázový nákup",
        typPopis100: "100/0 — dokud není poplatek splacený, nekupuje klient ani gram. Tohle mu řekni jako první.",
        typPopis7030: "70/30 — sedmdesát procent platby jde na poplatek, třicet na kov. Gram přibývá od začátku, poplatek je ale vyšší.",
        typPopis5050: "50/50 — polovina na poplatek, polovina na kov. Nejrychlejší start, nejdražší poplatek.",
        typPopisJednorazovy: "Jednorázový nákup — z plateb se nestrhává žádný poplatek, klient platí jen cenu kovu a rozdíl nákup/výkup.",
        vstupniPoplatek: "Vstupní poplatek",
        vstupniPoplatekHint: "U programů, kde se poplatek platí za každý kus zvlášť, sečti všechny kusy.",
        cenaNakup: "Nákupní cena za gram",
        cenaVykup: "Výkupní cena za gram",
        cenyHint: "Obě ceny vytáhni z portálu ke dni schůzky. Rozdíl mezi nimi je náklad, který v žádném ceníku poplatků nenajdeš.",
        rustKov: "Růst ceny kovu (v USD) % p.a.",
        zmenaKurzu: "Změna kurzu USD/{mena} % p.a.",
        kurzHint: "Zlato se kotuje v dolarech, klient žije v domácí měně. Když domácí měna posílí, dolarový zisk se cestou ztratí. Proto jsou tu dva posuvníky, ne jeden.",
        gramy: "Kolik zlata bude mít",
        jednotky: "{chi} chỉ · {luong} lượng (vietnamské jednotky)",
        vlozeno: "Vloženo celkem",
        hodnota: "Hodnota při výkupu",
        rozdil: "Rozdíl: {castka}",
        naklady: "Zaplaceno na poplatku a rozdílu cen",
        spread: "Rozdíl nákup / výkup",
        vynosPa: "Výnos p.a. (vnitřní výnosové procento)",
        nedoplaceno: "Vstupní poplatek zůstane nedoplacený",
        prvniGramNadpis: "První gram zlata",
        prvniGramHned: "Klient kupuje kov už z první platby.",
        prvniGramZa: "Klient koupí první gram až ve {mesic}. měsíci. Do té doby platí jen poplatek.",
        prvniGramNikdy: "Za celý zvolený horizont klient nekoupí ani gram — poplatek se nestihne splatit. Zkrať cíl, nebo zvyš platbu.",
        bodZvratuNadpis: "Kdy je klient na svém",
        bodZvratu: "Ve {mesic}. měsíci, tedy zhruba za {roky} roku.",
        bodZvratuNikdy: "Za zvolený horizont se klient na vložené peníze nedostane. Řekni mu to dřív, než podepíše.",
        menoveRizikoNadpis: "Měnové riziko — klient nekupuje jen zlato",
        menoveRizikoText: "Cena zlata je v dolarech, klient ji ale platí a inkasuje v {mena}. Kdo koupil zlato při slabé domácí měně, o část zisku přišel, jakmile měna posílila. Tohle číslo ukazuje, kolik z výsledku udělal kurz — ne kov.",
        kurzUdelal: "Z výsledku udělal kurz",
        kurzScenareNadpis: "Co když se kurz pohne jinak",
        kurzScenarLabel: "Kurz {proc} p.a.",
        grafNadpis: "Vložené peníze proti hodnotě kovu",
        grafVlozeno: "Vloženo",
        grafHodnota: "Hodnota při výkupu",
        grafRok: "Rok",
        porovnaniNadpis: "Stejné peníze v jiných aktivech",
        porovnaniText: "Dlouhodobé nominální průměry z veřejných dat (1928–2024, v dolarech), bez poplatků a daní na obou stranách. Slouží k porovnání řádu, ne k výběru produktu — a rozhodně ne jako slib výnosu.",
        aktivumAkcie: "Široký akciový index",
        aktivumZlato: "Zlato (historický průměr)",
        aktivumDluhopisy: "Dluhopisy",
        aktivumNemovitosti: "Nemovitosti",
        aktivumHotovost: "Hotovost a spořicí účet",
        aktivumTentoPlan: "Tento plán se zlatem",
        mesicuInfo: "Modelace počítá po měsících, celkem {mesicu}.",
        skript: "„Než cokoli podepíšeme, ukážu vám tři čísla. Za prvé: první gram zlata koupíte až v měsíci, který vidíte tady na obrazovce — do té doby platíte poplatek. Za druhé: mezi nákupní a výkupní cenou je rozdíl, takže hned po nákupu má vaše zlato nižší hodnotu než to, co jste zaplatil. A za třetí: zlato je v dolarech, vy žijete v domácí měně — když měna posílí, část zisku vám sebere kurz. Když vám tohle sedí, jdeme dál. Když ne, mám pro vás jiné řešení.“",
        kdyNe: [
          "Klient nemá likvidní rezervu na tři až šest měsíců výdajů. Zlato není rezerva — výkup trvá dny a cena může být zrovna dole.",
          "Klient má drahé dluhy. Kreditní karta za dvacet procent ročně porazí jakýkoli očekávaný výnos zlata. Nejdřív konsolidace, potom kov.",
          "Horizont je kratší než pět až sedm let. Vstupní poplatek a rozdíl nákup/výkup se za tu dobu nestihnou umořit.",
          "Klient nemá vyřešené zajištění příjmu a bydlení. Zlato nezaplatí hypotéku, když po úrazu nemůže pracovat.",
          "Klient chce dát do zlata většinu majetku nebo z toho chce žít. Zlato nenese žádný úrok ani dividendu — renta ze zlata je rozprodávání majetku.",
        ],
      },
      konsolidace: {
        popis: "Nižší splátka není levnější úvěr. Porovnávají se dvě celkové částky, ne dvě splátky. Kalkulačka umí ukázat i případ, kdy se konsolidace nevyplatí — a právě ten z tebe udělá poradce, kterému klient věří.",
        predlohy: "Předvyplněné situace",
        predlohaVyplati: "Ukázka: vyplatí se",
        predlohaNevyplati: "Ukázka: nevyplatí se",
        predlohyHint: "Modelová čísla pro trénink, ne data reálného klienta. Klikni a přepiš je podle toho, co klient přinesl.",
        uveryNadpis: "Co klient splácí dnes",
        pridat: "Přidat úvěr",
        smazat: "Odebrat úvěr",
        zustatek: "Zůstatek",
        splatka: "Měsíční splátka",
        zbyva: "Zbývá splátek",
        poplatekPredcasne: "Poplatek za předčasné splacení",
        dopoctenaSazba: "Dopočtená sazba",
        sazbaNelze: "nelze dopočítat",
        /* ⚠️ SCHVÁLNĚ „Kreditka“, ne „Kreditní karta“. Analýza 2.0 má v
         `lib/analyzaV2/zavazkyTaby.js` záložku „Kreditní karta“ napsanou
         natvrdo česky (nejde přes t()), takže ji Vietnamec vidí česky.
         Kdyby tu byl stejný řetězec, hlídač `jazykBezCestiny` by ho
         začal hlásit i tady a vypadalo by to, že ten dluh máme my.
         Až se `zavazkyTaby.js` převede na t(), může se to vrátit. */
      nazevKreditka: "Kreditka",
        nazevNebankovni: "Nebankovní půjčka",
        nazevSplatkovyProdej: "Nákup na splátky",
        nazevBankovniPujcka: "Bankovní půjčka",
        nazevAutoUver: "Úvěr na auto",
        nazevNovy: "Další závazek",
        nabidkaNadpis: "Co nabízí banka",
        novaSazba: "Nová sazba",
        novaSplatnost: "Nová splatnost",
        poplatekZaSjednani: "Poplatek za sjednání",
        splatkaRucne: "Splátka od banky",
        splatkaRucneHint: "Nech nulu a splátka se dopočítá. Když ji banka řekla, napiš ji sem.",
        celkemTed: "Celkem zaplatí teď",
        celkemTedNote: "Dnešní splátky: {splatka}",
        celkemPo: "Celkem zaplatí po konsolidaci",
        celkemPoNote: "Nová splátka: {splatka}",
        uspora: "Úspora",
        zaplatiNavic: "Zaplatí navíc",
        ulevaMesicne: "Úleva na splátce",
        prodlouzeni: "Prodloužení splácení",
        prodlouzeniZadne: "neprodlužuje se",
        odsunuto: "Kolik z úlevy je jen odsunuté",
        sazbaTed: "Dnešní vážená sazba",
        novaJistina: "Nová jistina včetně poplatků",
        poplatkyCelkem: "Poplatky celkem",
        verdiktVyhra: "Vyplatí se",
        verdiktVyhraText: "Klient platí míň měsíčně i celkem. Zkontroluj poplatky za předčasné splacení a nech si od každého věřitele potvrdit nulový zůstatek.",
        verdiktLevnejsi: "Celkem levnější, ale splátka bude vyšší",
        verdiktLevnejsiText: "Klient zaplatí méně, ale musí měsíčně utáhnout víc. Ověř, že mu to rozpočet dovolí — jinak jsi ho posunul k prodlení.",
        verdiktUleva: "Nižší splátka, ale zaplatí víc",
        verdiktUlevaText: "To může být správné rozhodnutí, když jde o to nespadnout do prodlení a do registrů. Ale musí to zaznít nahlas: klient si kupuje úlevu a platí za ni. Nikdy to neprodávej jako úsporu.",
        verdiktNevyplati: "Nevyplatí se",
        verdiktNevyplatiText: "Ani celkem, ani na splátce. Řekni to klientovi rovnou a nabídni něco jiného — mimořádnou splátku, jinou splatnost nebo sloučení jen těch nejdražších závazků.",
        hranice: "Aby konsolidace vyšla nákladově aspoň nastejno, nesmí být splatnost delší než {mesicu}.",
        hraniceNelze: "Při této sazbě nevyjde konsolidace nákladově lépe v žádné splatnosti. Poptej jinou nabídku.",
        skript: "„Podívejte se na tahle dvě čísla. Vlevo je, kolik zaplatíte, když necháte všechno tak, jak to je. Vpravo je, kolik zaplatíte po konsolidaci. Splátka vám klesne — to je pravda. Ale rozhodujeme se podle těch dvou celkových čísel, ne podle splátky. Když vyjde vpravo víc, znamená to, že si kupujete klid a platíte za něj. To je legitimní rozhodnutí, jen musíte vědět, že ho děláte.“",
        kroky: [
          "Sepiš každý závazek: zůstatek, splátku, počet zbývajících splátek, sazbu a poplatek za předčasné splacení.",
          "Nech si od klienta donést výpisy z registrů. Dva až tři závazky si obvykle nevybaví — bez nich počítáš špatně.",
          "Spočítej obě celkové částky a teprve pak mluv o splátce.",
          "Podej žádost s doklady: doklad totožnosti, smlouvy ke všem slučovaným úvěrům, doložení příjmu nebo výpisy z účtu.",
          "Po vyplacení si od každého původního věřitele vyžádej potvrzení o nulovém zůstatku. Tohle je nejčastější chyba celé konsolidace.",
          "Zruš uvolněné kreditní karty a kontokorenty. Jinak se klient do roka zadluží znovu a tys mu nepomohl.",
        ],
        kdyNe: [
          "Nová sazba je stejná nebo vyšší a jediná změna je delší splatnost.",
          "Klient by sloučil i závazky, které za pár měsíců doplatí — u nich už skoro žádný úrok nezbývá.",
          "Poplatky za předčasné splacení a za sjednání sežerou celou úsporu.",
          "Klient si nechá kreditní karty a kontokorenty otevřené.",
          "Část dluhů je v exekuci, po splatnosti, vůči státu nebo u soukromých osob — ty banka do konsolidace nevezme, i když rozpočet zatěžují.",
        ],
      },
      podpojisteni: {
        popis: "Když je pojistná částka nižší než skutečná hodnota majetku, pojišťovna krátí plnění ve stejném poměru — a krátí i malou škodu. U obchodu s potravinami to bývá rozdíl statisíců.",
        polozkyNadpis: "Sečti, co v provozovně doopravdy je",
        polozkyHint: "Většina podpojištění vzniká tím, že se na něco zapomnělo. Projděte to spolu položku po položce.",
        stavebniUpravy: "Stavební úpravy a vestavby",
        vybaveni: "Vybavení a stroje",
        elektronika: "Elektronika a pokladna",
        zasoby: "Zásoby zboží",
        hotovost: "Hotovost v provozovně",
        veciKlientu: "Věci převzaté od zákazníků",
        polozkyCelkem: "Hodnota celkem",
        dosadit: "Dosadit do výpočtu",
        hodnota: "Skutečná hodnota majetku",
        hodnotaHint: "Kolik by stálo pořídit to znovu, ne kolik to stálo tehdy.",
        castka: "Pojistná částka ve smlouvě",
        castkaHint: "Opiš ji z pojistky, ne z paměti.",
        skoda: "Výše škody",
        spoluucast: "Spoluúčast",
        sezonni: "Sezónní špička zásob",
        sezonniHint: "Před Tết a před Vánoci má obchod na skladě násobek běžných zásob. Pojistná částka zůstala z doby sjednání — a škoda vzniká právě tehdy.",
        podpojisteni: "Podpojištění",
        pomerNote: "Kryto je {pomer} hodnoty",
        vyplati: "Pojišťovna vyplatí",
        doplaci: "Klient doplácí ze svého",
        hodnotaVeSpicce: "Hodnota majetku ve špičce",
        chybiVCastce: "O kolik zvednout pojistnou částku",
        ztrataProti: "Ztráta proti správně sjednané smlouvě",
        varovaniTuk: "Tahle smlouva je podpojištěná.",
        varovaniText: "Pojišťovna sníží plnění ve stejném poměru, v jakém je pojistná částka k hodnotě majetku. Platí to i pro malou škodu. Zvedni pojistnou částku, nebo klientovi rovnou řekni, kolik bude doplácet.",
        vporadkuTuk: "Krytí odpovídá hodnotě majetku.",
        vporadkuText: "Plnění se krátit nebude. Ověřuj to znovu při každé servisní schůzce — ceny stavby i zásob rostou a pojistná částka sama nenaskočí.",
        tabulkaNadpis: "Krátí se i malá škoda",
        tabSkoda: "Škoda",
        tabPlneni: "Vyplatí",
        tabDoplaci: "Doplatí klient",
        zakonNadpis: "Odkud to plyne",
        zakonText: "Občanský zákoník (89/2012 Sb.), § 2854: je-li pojistná částka v době pojistné události nižší než pojistná hodnota pojištěného majetku, pojistitel sníží pojistné plnění ve stejném poměru — ledaže je ve smlouvě ujednáno, že plnění sníženo nebude. Vždy ověř konkrétní pojistné podmínky.",
        skript: "„Pojistnou částku máte nižší, než kolik ten obchod doopravdy stojí. To neznamená, že vám pojišťovna nezaplatí — znamená to, že vám z každé škody zaplatí jen tolik procent, na kolik procent je obchod pojištěný. Ukážu vám to: tady je vaše škoda a tady je, co doopravdy přijde na účet. A před Tết, když máte plný sklad, je ten rozdíl ještě větší. Pojďme to srovnat teď, dokud se nic nestalo.“",
        kdyNe: [
          "Klient nechce nebo nemůže doložit hodnotu majetku — pak pojistnou částku nevymýšlej, nech ji dopočítat z účetnictví nebo od znalce.",
          "Ve smlouvě je ujednáno, že se plnění nekrátí. Pak tenhle výpočet neplatí a musíš vyjít z konkrétních pojistných podmínek.",
          "Klient chce zvýšit pojistnou částku, ale nemá splněné zabezpečení, revize nebo hygienické povinnosti — pojišťovna může krátit z jiného důvodu a vyšší částka mu nepomůže.",
          "Jde o věci zvláštní hodnoty, například cennosti a drahé kovy — ty mají v pojištění vlastní podlimity a tenhle výpočet je nepokrývá.",
        ],
      },
      /* === DOPLACENÍ HYPOTÉKY (mimořádné splátky vs. investice) ===
       * Nástroj, kterým se klient přemlouvá, aby NESPLÁCEL dluh. Texty proto
       * musí unést i opačný závěr: `verdiktSplaceni`, `rizikoText`, scénáře
       * a `kdyNe` nejsou zdvořilostní vata — bez nich je to slib výnosu.
       * Odborné termíny nechávej v závorce česky, klient je uvidí na smlouvě. */
      doplaceni: {
        popis: "Klient má hypotéku a pár tisíc měsíčně navíc. Buď je pošle do hypotéky, nebo je investuje a po dohodnuté době dluh jednorázově doplatí. Obě cesty utratí z rozpočtu úplně stejně — liší se jen tím, co klientovi na konci zbyde. A hlavně je vidět okamžik, kdy investice zbývající dluh poprvé pokryje.",
        prezentace: "Spustit prezentaci",
        zadaniHypoteka: "Hypotéka",
        jistina: "Kolik zbývá doplatit",
        jistinaHint: "Zbývající jistina, ne původní výše úvěru. Vytáhni ji z výpisu, ne z paměti klienta.",
        sazba: "Úroková sazba",
        splatnost: "Splatnost",
        horizont: "Za kolik let chce doplatit",
        horizontHint: "Datum doplacení je pevné. Trh se ho neptá — proto je vedle úspory i panel rizika.",
        fixace: "Fixace",
        fixaceHint: "Nula = jedna sazba po celou dobu. Jinak se po fixaci přepočítá i splátka, stejně jako v bance.",
        sazbaPoFixaci: "Sazba po fixaci",
        splatkaInfo: "Měsíční splátka {splatka} · hypotéka doběhne sama za {splatnost}.",
        zadaniInvestice: "Peníze navíc a investice",
        volnaCastka: "Volná částka měsíčně",
        volnaCastkaHint: "Tytéž peníze jdou v obou cestách — jednou do hypotéky, podruhé do investice. Bez toho by srovnání nebylo férové.",
        jednorazovyVklad: "Jednorázově dnes",
        vynos: "Očekávaný výnos",
        rezim: "Zadaný výnos je",
        rezimNominalni: "Nominální (jako úrok)",
        rezimRealny: "Reálný (nad inflací)",
        rezimHint: "Úrok hypotéky je nominální. Postavit reálných 6 % proti nominálním 4,9 % znamená dát investici zadarmo celou inflaci — proto se tady musí vybrat, ne odhadnout.",
        poplatekVstupni: "Vstupní poplatek z každého vkladu",
        poplatekRocni: "Průběžný poplatek (TER)",
        poplatkyHint: "Reálný fond stojí 1–2 % ročně. Nula je nejrychlejší způsob, jak výsledek investice nadhodnotit.",
        trojiceNadpis: "Co klientovi zbyde za {roky}",
        cestaSplaceni: "Splácím navíc",
        cestaSplaceniNote: "Hypotéka je pryč za {kdy}, pak se investuje uvolněná splátka.",
        cestaInvestice: "Investuji a pak doplatím",
        cestaInvesticeNote: "Portfolio po zdanění {portfolio} minus zbývající dluh {dluh}.",
        rozdilZisk: "Investicí navíc",
        rozdilZtrata: "Investicí méně",
        rozdilNote: "Rozdíl čistého jmění obou cest.",
        vydajObe: "Z rozpočtu odejde v obou cestách",
        urokyBezZasahu: "Úroky, když se nedělá nic",
        urokySplaceni: "Úroky při mimořádných splátkách",
        urokyInvestice: "Úroky při investici",
        usporaSplaceni: "Ušetřeno na úrocích — splácení navíc",
        usporaInvestice: "Ušetřeno na úrocích — investice",
        danPriDoplaceni: "Daň při prodeji na doplacení",
        poplatkyCelkem: "Poplatky investice celkem",
        urokyPoznamka: "Úroky se počítají do chvíle, než je hypotéka doopravdy pryč — ne jen do zvoleného roku. Cesta, která v cílovém roce ještě dluží, by se jinak chlubila úsporou, kterou jenom ještě nezaplatila.",
        verdiktInvestice: "Investice vychází lépe — a klient musí vědět proč",
        verdiktInvesticeText: "Rozdíl dělá výnos nad úrokem hypotéky, a ten není zaručený. Projdi s klientem panel rizika hned pod tím a řekni mu i hraniční výnos.",
        verdiktSplaceni: "Mimořádná splátka vychází lépe",
        verdiktSplaceniText: "Úspora úroku je jistá a nezdaněná, výnos investice ani jedno. Tady není co vysvětlovat — doporuč splácení.",
        verdiktRemiza: "Obě cesty vycházejí nastejno",
        verdiktRemizaText: "Když je rozdíl v řádu korun, rozhoduje jistota a klid klienta, ne tabulka. Splátka je jistá, výnos ne.",
        grafNadpis: "Dluh klesá, investice roste",
        grafDluh: "Zbývající dluh",
        grafPortfolio: "Hodnota investice po zdanění",
        grafRok: "Rok",
        grafJednotka: "Svislá osa je v tisících {mena}. Přesnou částku ukáže bublina po najetí na křivku.",
        prusecikNadpis: "Okamžik, kdy je na doplacení",
        prusecikText: "Zhruba za {rok} investice poprvé pokryje zbývající dluh ({castka}). Od té chvíle si klient může vybrat, jestli doplatí, nebo nechá peníze pracovat dál.",
        prusecikNikdy: "Za zvolený horizont investice zbývající dluh nepokryje. Zvyš volnou částku nebo posuň datum doplacení — a řekni to klientovi dřív, než se rozhodne.",
        rizikoNadpis: "A co když trh nedá nic",
        rizikoText: "Splátka hypotéky je jistá, výnos investice ne. Ukaž klientovi obě strany — poradce, který přinese i špatný scénář, je ten, kterému se věří. Kladné číslo znamená, že vychází lépe investice, záporné mimořádná splátka.",
        scenarBezVynosu: "Trh nedá nic",
        scenarPesimisticky: "Pesimistický výnos",
        scenarZadani: "Podle zadání",
        scenarPropad: "Propad trhu v roce doplacení",
        hraniceNadpis: "Hraniční výnos",
        hraniceText: "Pod {nominalni} nominálně (tedy {realni} nad inflací) je mimořádná splátka výhodnější. Všimni si, že hranice leží NAD úrokem hypotéky — rozdíl si berou daň a poplatky.",
        hraniceNelze: "Hraniční výnos se u tohoto zadání spočítat nedá — investice mimořádnou splátku nepřekoná ani při extrémním výnosu.",
        pojNadpis: "Klesající krytí",
        pojPopis: "Kdyby klient zemřel nebo zůstal invalidní, pojistka dorovná zbytek dluhu. Částka klesá spolu s dluhem — je to plocha pod křivkou. Pojistná částka se počítá kapitálovou metodou z příjmu a výdajů domácnosti; hypotéka je jen její klesající část.",
        pojZapnout: "Počítat",
        pojVypnout: "Vynechat",
        pojPrijem: "Čistý měsíční příjem",
        pojVydaje: "Nezbytné výdaje domácnosti",
        pojVydajeHint: "Kolik musí domácnost utratit každý měsíc, aby fungovala — bez spoření a bez cílů.",
        pojDeti: "Počet dětí",
        pojSmrt: "Pojistná částka — smrt",
        pojInvalidita: "Pojistná částka — invalidita",
        pojZToho: "Z toho hypotéka {hypoteka} (klesá) a domácnost {domacnost} (zůstává).",
        pojCena: "Orientační pojistné",
        pojCenaNote: "Měsíčně, šablona sazeb. Není to nabídka.",
        pojGrafKryti: "Pojistná částka",
        pojPrumerSplaceni: "Průměrný nesplacený dluh — splácení navíc",
        pojPrumerInvestice: "Průměrný nesplacený dluh — investice",
        pojRozdilText: "Tohle je cena strategie, kterou nikdo neříká nahlas: investiční cesta drží dluh vysoko celou dobu, takže klesající pojistka musí běžet déle a vyjde dráž. Skutečná díra pro pozůstalé je u ní naopak menší, protože portfolio je majetek. Poradce potřebuje obě čísla, ne to příznivější.",
        pojSablona: "Pojistné částky i sazby jsou šablona z praxe poradce, ne nabídka ani garance. Konkrétní limity a cenu ověř u pojišťovny.",
        pojBezPrijmu: "Bez zadaného příjmu nemá kapitálová metoda z čeho počítat, takže se ukazuje jen klesající krytí na hypotéku. Doplň čistý příjem a nezbytné výdaje a spočítá se i část, která drží domácnost v chodu.",
        skript: "„Vy dneska posíláte navíc {volna} do hypotéky. Ukážu vám druhou možnost: ty samé peníze necháte pracovat a hypotéku doplatíte najednou. Podívejte se na graf — tady dluh klesá, tady investice roste a tady se protnou. To je okamžik, kdy si můžete vybrat. A hned vám ukážu i druhou stranu: kdyby trh nedal nic, dopadnete takhle. Proto k tomu patří pojistka, která ten dluh dorovná, kdyby se vám něco stalo.“",
        kroky: [
          "Vytáhni z výpisu zbývající jistinu, sazbu, splátku a konec fixace. Ne z paměti klienta — rozdíl bývá statisíce.",
          "Zeptej se, kolik má měsíčně navíc a jestli to vydrží posílat i za pět let. Nestabilní částka celý výpočet boří.",
          "Nastav, za kolik let chce mít hypotéku pryč. Tohle datum se pak už nemění.",
          "Řekni nahlas, jestli je zadaný výnos nominální, nebo nad inflací. Je to nejčastější chyba v tomhle typu výpočtu.",
          "Doplň poplatky fondu z dokumentu KID. Bez nich je výsledek investice nadhodnocený.",
          "Ukaž graf a průsečík. Teprve potom čísla.",
          "Projdi panel rizika včetně scénáře, kde trh nedá nic. Nepřeskakuj ho.",
          "Zapni klesající krytí a spočítej, co se stane, kdyby klient vypadl. Bez toho je celá strategie nekrytá.",
          "Ověř ve smlouvě limit bezplatného předčasného splacení a poplatky za mimořádnou splátku.",
        ],
        kdyNe: [
          "Klient nemá rezervu na tři až šest měsíců výdajů. Nejdřív rezerva, teprve potom tohle.",
          "Očekávaný výnos je nižší nebo blízko úroku hypotéky. Pak nemá investice jak vyhrát a mimořádná splátka je jasně lepší.",
          "Klient by neusnul, kdyby portfolio spadlo o třicet procent. Datum doplacení je pevné a trh se ho neptá.",
          "Volná částka je nejistá — proměnlivý příjem, OSVČ v sezóně, čerstvá rodičovská. Splácení navíc výpadek přežije, investice s pevným datem hůř.",
          "Fixace končí za rok nebo dva a nová sazba není známá. Nejdřív si sežeň sazbu, pak počítej.",
          "Klient nemá krytí pro případ smrti a invalidity. Bez něj strategie stojí na tom, že se nic nestane.",
          "Banka za mimořádnou splátku účtuje náhradu nad zákonný limit. Ověř to ve smlouvě — výpočet ji nemodeluje.",
        ],
        metodika: "Daň z prodeje se počítá po jednotlivých nákupech podle práva platného dnes. Prodej v roce {rok} se tedy posuzuje podle dnešních pravidel a zákon se do té doby může několikrát změnit. Výsledek je orientační, není to nabídka ani individuální doporučení.",
        hlaskaJistina: "Zadej zbývající jistinu hypotéky.",
        hlaskaSazbaChybi: "Zadej úrokovou sazbu hypotéky.",
        hlaskaHorizontChybi: "Zadej, za kolik let chce klient hypotéku doplatit.",
        hlaskaHorizontNekladny: "Horizont doplacení musí být aspoň jeden rok.",
        hlaskaSplatnost: "Zadej splatnost hypotéky v letech.",
        hlaskaNicNavic: "Klient nemá nic navíc — není co porovnávat. Zadej měsíční volnou částku nebo jednorázový vklad.",
        hlaskaZapornaAmortizace: "Splátka nepokryje ani měsíční úrok — dluh by rostl a hypotéka by se nikdy nesplatila. Zkontroluj jistinu, sazbu a splatnost.",
        hlaskaVynosPodUrokem: "Očekávaný výnos {vynos} je nižší nebo roven úroku hypotéky {sazba}. Investice nemá jak vyhrát ani před zdaněním a poplatky — doporuč mimořádnou splátku.",
        hlaskaDoplaceniNevyslo: "Portfolio na doplacení nestačí. Po prodeji a zdanění chybí {castka} a klientovi zůstává dluh. Zvyš volnou částku nebo posuň datum doplacení.",
        hlaskaHorizontZaSplatnosti: "Hypotéka doběhne sama za {roky}, tedy dřív, než chce klient doplácet. Není co doplácet.",
        hlaskaSplatnostNedosazena: "Při zadané splátce se hypotéka nesplatí ani za celý modelovaný horizont. Zkontroluj zadání.",
        hlaskaNad25: "Roční objem mimořádných splátek přesahuje čtvrtinu původní jistiny. Bez náhrady je ze zákona jen splacení do 25 % ročně v měsíci před výročím smlouvy; nad to může banka účtovat náhradu nákladů. Ověř to ve smlouvě.",
        hlaskaPrepocetNaNominalni: "Zadaný reálný výnos se pro srovnání s hypotékou přepočetl na {vynos} nominálně (inflace {inflace}). Úrok hypotéky je nominální.",
        hlaskaPoplatkyNezadany: "Poplatky investice nejsou zadané — počítá se s nulou. Reálný fond stojí 1–2 % ročně a výsledek investice je tím nadhodnocený.",
        hlaskaFixaceBezDelky: "Zadal jsi sazbu po fixaci, ale ne délku fixace — jiná sazba se proto nikdy neuplatní.",
        hlaskaSok: "Modeluje se propad trhu o {propad} v {rok}. roce.",
        hlaskaObecna: "Výpočet narazil na hodnotu, kterou neumí zpracovat. Zkontroluj zadání.",
        krokDluh: "DLUH",
        krokCesta: "CESTA",
        krokVysledek: "VÝSLEDEK",
        krokRiziko: "RIZIKO",
        krokOchrana: "OCHRANA",
        prezRok: "Rok",
        prezZavrit: "Zavřít prezentaci",
        prezNapoveda: "klik / → dál · Esc konec",
        prezKonec: "Pojďme to spočítat na míru",
        prezDisclaimer: "Orientační modelace, ne nabídka ani příslib plnění. Závazná čísla dá až smlouva, ceník a pojistné podmínky.",
        prezDluhStitek: "Dnes dlužíte",
        prezDluhVeta: "Splátka {splatka} měsíčně při sazbě {sazba}.",
        prezDluhUroky: "Na úrocích zaplatíte {castka}, když se nic nezmění",
        prezProtnutoTuk: "Tady už na doplacení máte",
        prezProtnutoText: "Investice poprvé pokryla zbývající dluh — zhruba v {rok}. roce.",
        prezCestaBezi: "Sledujte — dluh dolů, investice nahoru…",
        prezCestaHotovo: "Zhruba v {rok}. roce se křivky protnou. Tam si můžete vybrat. Klikněte na výsledek →",
        prezCestaNikdy: "Za zvolenou dobu se křivky neprotnou — na doplacení to zatím nestačí. Klikněte dál →",
        prezVysledekStitek: "Co vám zbyde za {roky}",
        prezVysledekVeta: "Obě cesty utratí z rozpočtu úplně stejně. Liší se jen tím, kde ty peníze mezitím byly.",
        prezRizikoStitek: "A co když trh nedá nic",
        prezRizikoVeta: "Nejhorší z propočtených scénářů: {scenar}. Záporné číslo znamená, že by investice dopadla hůř než mimořádná splátka.",
        prezRizikoNeznamo: "Scénáře se pro tohle zadání nepodařilo spočítat.",
        prezOchranaStitek: "Kdyby se vám něco stalo",
        prezOchranaRozpad: "Z toho hypotéka {hypoteka} — ta klesá spolu s dluhem. Zbytek {domacnost} drží rodinu v chodu.",
        prezOchranaVeta: "Orientačně {cena} měsíčně. Šablona sazeb, ne nabídka.",
        prezOchranaVypnuto: "Klesající krytí není zapnuté. Zapněte ho v kalkulačce a projděte s klientem i tuhle část — bez ní stojí celá strategie na tom, že se nic nestane.",
      },
    },
    finMat: {
      freqCtvrtletni: 'Čtvrtletní',
      freqDenni: 'Denní',
      freqMesicni: 'Měsíční',
      freqRocni: 'Roční',
      rokFew: 'roky',
      rokMany: 'let',
      rokOne: 'rok',
      tabInvestice: 'Investice',
      tabRenta: 'Renta',
      tabUver: 'Úvěr / Hypotéka',
      varovaniNekonecnaRenta: 'Renta je nižší/rovna výnosu → kapitál se nikdy nevyčerpá (nekonečná renta). 🎉',
      varovaniZapornaAmortizace: 'Splátka je nižší než měsíční úrok → úvěr se nikdy nesplatí (záporná amortizace). Zvyš splátku.',
    },
    investStrategie: {
      aktivaAkcie: 'Akcie (S&P 500)',
      aktivaBtc: 'Bitcoin',
      aktivaDluhopisy: 'Dluhopisy',
      aktivaMsci: 'MSCI World',
      aktivaPt: 'Hotovost / PT',
      aktivaReit: 'Nemovitosti',
      aktivaZlato: 'Zlato',
      akumulacniInsight: 'Čas mazlí riziko. Na 15+ let akcie historicky vždy porazily vše ostatní.',
      akumulacniKdo: 'Pro mladé a dlouhý horizont',
      akumulacniName: 'Akumulační (100 % akcie)',
      akumulacniStory: '100 % akcie v akumulačních ETF — dividendy se automaticky reinvestují (daňově efektivní). Čím delší horizont, tím víc akcií.',
      coreInsight: 'Levně a pasivně to hlavní, špetka na vyšší výnos. Nejlepší poměr nákladů a výsledku.',
      coreKdo: 'Standard profesionálů a fondů',
      coreName: 'Core–Satellite',
      coreStory: 'Jádro (80 %) = levný globální index, který nuda-spolehlivě roste. Satelity (20 %) = koření — témata, zlato, krypto.',
      dalioInsight: 'Když přijde krize, spíš klidně. Menší výkyvy = míň panických chyb.',
      dalioKdo: 'Bridgewater, největší hedge fond světa',
      dalioName: 'Ray Dalio — All Weather',
      dalioStory: 'Portfolio „pro každé počasí“ — vyvážené tak, aby přežilo růst, recesi, inflaci i deflaci. Vyvážené na riziko, ne na peníze.',
      milionariInsight: 'Bohatství nevzniká spořením, ale vlastnictvím aktiv, která rostou a vyplácí.',
      milionariKdo: 'UBS / Knight Frank Wealth Report',
      milionariName: 'Jak investují dolaroví milionáři',
      milionariStory: 'Bohatí nedrží hromady hotovosti — vlastní aktiva: akcie, nemovitosti, byznys, zlato. Široká diverzifikace napříč vším.',
      nobelInsight: 'Tohle je rentiérské portfolio: vyplácíš a kapitál neklesá. Přesně jako vaše budoucí renta.',
      nobelKdo: 'Vyplácí Nobelovy ceny 120+ let',
      nobelName: 'Nobelova nadace',
      nobelStory: 'Každý rok rozdá miliony na Nobelovy ceny — a kapitál má dnes větší než na začátku. Protože peníze investuje, nenechá je ležet.',
      norskyInsight: 'Stát, který má z čeho rozhazovat, místo toho globálně investuje. Diverzifikace a trpělivost.',
      norskyKdo: 'Největší státní fond světa (1,8 bil. $)',
      norskyName: 'Norský ropný fond',
      norskyStory: 'Norsko neutrácí peníze z ropy — investuje je pro budoucí generace do ~9 000 firem po celém světě. Přes 70 % v akciích.',
      rokFew: 'roky',
      rokMany: 'let',
      rokOne: 'rok',
    },
    pdDisclaimer: {
      titulek: 'Co musí klient vědět',
    },
    pdGraf: {
      let: 'let',
      popisGrafu: 'Vývoj hodnoty obou variant v čase',
      zdroj: 'Zdroj: modelový výpočet ze vstupů poradce — nejde o historický vývoj ani předpověď.',
    },
    pdModel: {
      horizont: 'Horizont (let)',
      horizontAria: 'Horizont v letech',
      jenPorovnatelna: '— jen ta část portfolia, kterou umíme porovnat s naší variantou ve stejné kategorii.',
      kurzPouzit: 'Cizí měny přepočteny kurzem z {datum} ({seznam}). Zdroj: {zdroj}.',
      kurzNepouzit: 'Cizí měny se nepřepočítávají — {duvod} Částky v různých měnách se proto nesčítají.',
      kurzStary: 'kurzovní lístek z {datum} je starší než 30 dní.',
      kurzChybi: 'chybí kurz pro {meny}.',
      kurzBezListku: 'chybí platný kurzovní lístek.',
      tisk: 'Tisk / PDF',
      tiskTitle: 'Vytiskne stránku nebo ji uloží jako PDF',
      smazat: 'Smazat zadání',
      smazatTitle: 'Vymaže tabulky i nastavení modelu',
      mena: 'Domácí měna',
      menaNapoveda: 'podle země organizace, ne podle jazyka',
      nepocitaSe: 'nepočítá se',
      pocatecniHodnota: 'Počáteční hodnota modelu',
      popis: 'Modelový výnos je TVŮJ vstupní předpoklad, ne předpověď. Aplikace žádný výnos nenavrhuje — bez vyplnění se modelace nepočítá.',
      titulek: '3 · Nastavení modelu',
      vklad: 'Měsíční vklad',
      vkladNapoveda: 'prázdné = žádné pravidelné vklady',
      vstupni: 'Vstupní poplatek současného portfolia %',
      vstupniAria: 'Vstupní poplatek současného portfolia',
      vstupniNapoveda: 'platí jen pro BUDOUCÍ vklady — z už investovaných peněz se neúčtuje znovu',
      vynos: 'Modelový hrubý výnos % p. a.',
      vynosAria: 'Modelový hrubý výnos',
      vynosNapoveda: 'vyplň ty — aplikace nic nenavrhuje',
    },
    pdPrazdny: {
      krok1Nadpis: 'Opiš položky klienta',
      krok1Popis: 'Z výpisu z účtu nebo z portálu distributora. ISIN je volitelný — když ho zadáš, zkontroluje se kontrolní číslice.',
      krok2Nadpis: 'Doplň nákladovost z KID',
      krok2Popis: 'Ke každému fondu existuje KID (Sdělení klíčových informací). Průběžné poplatky a náklady na vstupu jsou v sekci Náklady, rizikový stupeň 1–7 v sekci Souhrnný ukazatel rizika.',
      krok3Nadpis: 'Zadej naši variantu a model',
      krok3Popis: 'Nákladovost naší strategie zadáváš ty — aplikace ji nezná. Pak nastav horizont a modelový hrubý výnos.',
      pridatPrvni: 'Přidat první položku',
      proc: 'Aplikace nezná nákladovost žádného fondu — nedohledá ji podle ISINu ani neodhadne podle kategorie. Všechna čísla zadáváš ty z doložitelného zdroje. Díky tomu je výstup obhajitelný před klientem i před dohledem.',
      titulek: 'Zatím není co počítat',
    },
    pdRozlozeni: {
      bezKategorie: 'Bez určené kategorie',
      bezMeny: 'Bez vyplněné měny',
      kategoriePopis: 'Podle kategorií, které jsi zadal. Překryv konkrétních akcií ve fondech nepočítáme — bez skutečného složení fondů by to bylo vymyšlené číslo.',
      kategorieTitulek: 'Rozložení podle kategorií',
      menyPopis: 'Jen z vyplněného. Chybějící měna se nedoplňuje na koruny — jde do „neurčeno“.',
      menyTitulek: 'Měnové rozložení',
    },
    pdTabulka: {
      hodnota: 'Hodnota',
      hodnotaNapoveda: 'kolik v tom klient má',
      isin: 'ISIN',
      isinNapoveda: 'volitelné — z výpisu nebo z KID',
      kategorie: 'Kategorie',
      kategorieNapoveda: 'srovnává se jen v rámci stejné',
      mena: 'Měna',
      menaNapoveda: 'měna pozice',
      nazev: 'Název fondu',
      nazevNapoveda: 'přesně jak je na výpisu',
      neuveden: 'neuveden',
      prazdno: 'Zatím nic — přidej první řádek.',
      pridatRadek: 'Přidat řádek',
      smazatRadek: 'Smazat řádek',
      sri: 'Riziko 1–7',
      sriNapoveda: 'KID, souhrnný ukazatel rizika',
      ter: 'TER % p. a.',
      terNapoveda: 'KID, sekce Náklady — průběžné poplatky',
      vstupni: 'Vstupní %',
      vstupniNapoveda: 'KID, sekce Náklady — náklady na vstupu',
      zdroj: 'Zdroj čísla',
      zdrojEmt: 'EMT (doložené)',
      zdrojKatalog: 'katalog — orientační',
      zdrojKid: 'KID (doložené)',
      zdrojNapoveda: 'doložitelné je jen KID nebo EMT',
      zdrojPoradce: 'zadal poradce',
    },
    pdVerdikt: {
      hodnota: 'hodnota',
      hodnotaPonechat: 'Hodnota s verdiktem ponechat',
      keZvazeni: 'ke zvážení',
      nakladovostPolozky: 'Nákladovost položky',
      naseVarianta: 'naše varianta',
      nescitaSe: 'nesčítá se (víc měn)',
      popis: 'Podklad pro rozhovor s klientem, ne investiční doporučení ani pokyn k prodeji. Srovnává se jen v rámci stejné kategorie.',
      rozdil: 'rozdíl',
      stitekNelze: 'Nelze posoudit',
      stitekPonechat: 'Ponechat',
      stitekZvazit: 'Zvážit změnu',
      stretZajmu: 'Střet zájmů: srovnáváme s produktem, který zprostředkováváme a za jehož sjednání dostáváme odměnu.',
      titulek: 'Verdikt po položkách',
    },
    /* VĚTY Z JÁDRA (lib/portfolio/*). Skládají se mimo React, proto se čtou
     * přes lib/i18n/textMimoReact.js, ne přes t(). Zástupné symboly {n}, {z}…
     * se dosazují až na místě — věta se NESMÍ lámat na kusy a skládat v JSX,
     * v ukrajinštině a vietnamštině by se rozbil slovosled.
     * Trojice One/Few/Many jsou množné číslo (Intl.PluralRules). */
    pdVety: {
      aDalsi: 'a další {n}',
      bezHodnoty: 'U {n} {polozek} není vyplněná hodnota.',
      bezKategorie: 'U {n} {polozek} není určená kategorie.',
      bezMeny: 'U {n} {polozek} není vyplněná měna.',
      bezTer: 'U {n} {polozek} nákladovost neznáme.',
      duvodBezReference: 'Nemáme naši variantu s vyplněnou nákladovostí — bez ní se nesrovnává. Doplň ji z KID.',
      duvodMichaneMeny: 'Porovnatelné položky jsou ve více měnách bez přepočtu. Kurzy jádro nezná, takže se nesčítají — sjednoť měnu, nebo modeluj každou zvlášť.',
      duvodNulovaHodnota: 'Všechny porovnatelné položky mají nulovou hodnotu a nákladovosti se liší — vážit nejde.',
      duvodPrazdno: 'Portfolio je prázdné — modelace se nepočítá.',
      duvodZadnaShoda: 'Žádná položka klienta nemá naši variantu ve stejné kategorii se známou nákladovostí. Napříč kategoriemi se nesrovnává — přidej naši variantu do té kategorie, kterou chceš posuzovat.',
      koncentrace: 'Je to koncentrace — není to chyba, ale zeptej se na ni.',
      menySeznam: 'Měny: {seznam}. Podíly nejde spočítat — chybí hodnoty.',
      modelujeCast: 'Modeluje se jen porovnatelná část portfolia — {z} % jeho hodnoty.',
      modelujeVse: 'Modeluje se celé portfolio.',
      nakladovostNejde: 'Nákladovost portfolia nejde spočítat — neznáme ji ani u jedné položky.',
      nakladovostNulaHodnot: 'Nákladovost nejde zvážit — všechny položky mají nulovou hodnotu.',
      nejvetsiKategorie: 'Největší kategorie „{kategorie}“ tvoří {podil} portfolia.',
      nevstupujeFew: 'nevstupují',
      nevstupujeMany: 'nevstupují',
      nevstupujeOne: 'nevstupuje',
      orientacniHlavniCislo: 'Část nákladovostí není doložená z KID ani EMT — hlavní číslo je proto jen orientační.',
      orientacniTer: 'U {n} {polozek} je nákladovost orientační — ověř ji v KID.',
      podilyNejdou: 'Podíly nejde spočítat — chybí hodnoty.',
      polozkaBezNazvu: 'položka bez názvu',
      polozkaBezNazvuCislo: 'Položka bez názvu{cislo}',
      polozkaFew: 'položky',
      polozkaMany: 'položek',
      polozkaOne: 'položka',
      porovnaniVKategorii: 'Každá položka se porovnává s naší variantou ve své kategorii — napříč kategoriemi se nesrovnává.',
      prazdnePortfolio: 'Portfolio je prázdné.',
      rokFew: 'roky',
      rokMany: 'let',
      rokOne: 'rok',
      rozdilZa: 'Rozdíl za {roky} {rok}',
      souhrnNelze: '{n}× nelze posoudit',
      souhrnPonechat: '{n}× ponechat',
      souhrnZvazit: '{n}× zvážit změnu',
      spocitanoZ: 'Spočítáno z {z} % hodnoty portfolia.',
      uPolozkyFew: 'položek',
      uPolozkyMany: 'položek',
      uPolozkyOne: 'položky',
      vazenaNakladovostVeta: 'Vážená nákladovost portfolia {pct} % p. a.',
      viceMenHodnoty: 'Hodnoty jsou ve více měnách bez přepočtu — podíly jsou orientační.',
      viceMenPodily: 'Portfolio je ve více měnách bez přepočtu — podíly jsou orientační.',
      viceMenVahy: 'Portfolio je ve více měnách bez přepočtu — váhy jsou jen orientační.',
      vynechaneVeta: '{n} {polozek} do modelace {nevstupuje}: {vypis}.',
      vynechanoBezHodnoty: 'není vyplněná hodnota',
      vynechanoBezKategorie: 'bez určené kategorie',
      vynechanoBezReference: 'v její kategorii nemáme variantu k porovnání',
      vynechanoBezTer: 'neznáme nákladovost',
      vynechanoBezTerReference: 'neznáme nákladovost naší varianty',
      vynechanoJineRiziko: 'výrazně jiný rizikový stupeň',
      zadnaMena: 'Měna není vyplněná ani u jedné položky.',
    },
    pdVysledek: {
      doModelaceVstupuje: 'Do modelace vstupuje',
      doplnVstupy: 'Doplň vstupy modelu.',
      hodnotaNaKonci: 'hodnota na konci',
      hodnotyPortfolia: 'hodnoty portfolia',
      klientVyhral: 'Současné portfolio je v nákladech levnější. Nákladovost tedy důvod k přesunu nedává.',
      lepeVychazi: 'Lépe vychází: {popis}',
      nepocitaSe: 'Modelace se zatím nepočítá',
      neuvedeno: 'neuvedeno',
      porovnatelnaNase: 'Porovnatelná část — naše varianty',
      porovnatelnaSoucasne: 'Porovnatelná část — současné portfolio',
      referenceBezNakladu: 'Reference bez jakýchkoli nákladů',
      rozdilPorovnatelne: 'Rozdíl v porovnatelné části',
      rozpadModelace: 'Rozpad modelace',
      rozpadPopis: 'Zaplacené poplatky a ušlý výnos jsou DVĚ RŮZNÁ čísla. Ušlý výnos obsahuje i to, co by zaplacené peníze dál vydělaly — nemluv o něm jako o poplatku. Vstupní poplatek, který klient kdysi při vstupu zaplatil, se do současného portfolia NEPOČÍTÁ znovu — je to utopený náklad.',
      spocitanoZ: 'spočítáno z',
      stejnyVynosPoznamka: 'Obě varianty počítáme se stejným hrubým výnosem {vynos} p. a. Model tedy porovnává NÁKLADY, ne schopnost fondů vydělat. Modelová kalkulace, ne příslib výnosu.',
      uslyVynos: 'ušlý výnos (včetně složeného úročení)',
      vazenaNakladovost: 'Vážená nákladovost portfolia',
      vazenaPopis: 'Váží se hodnotou pozice. Položka bez známé nákladovosti se do průměru NEZAPOČÍTÁ — nedosazuje se nula.',
      vlozenoCelkem: 'Vloženo celkem',
      vyvojVCase: 'Vývoj hodnoty v čase',
      zanedbatelny: 'Rozdíl je zanedbatelný',
      zaplacenePoplatky: 'skutečně zaplacené poplatky',
    },
    portfolioDoktor: {
      karta1: '1 · Portfolio klienta',
      karta1Popis: 'Píše se rovnou do tabulky — žádné modály, žádné klikání na detail. Prázdné pole znamená „nevíme“, ne nulu.',
      karta2: '2 · Naše strategie k porovnání',
      karta2Popis: 'Nákladovost naší varianty zadáváš ty — není nikde natvrdo. Srovnává se vždy jen v rámci stejné kategorie, proto přidej řádek pro každou kategorii, kterou chceš posuzovat.',
      kteraVarianta: 'Která varianta jde do modelace',
      nadrazenaSekce: 'Nástroje',
      naseVarianty: 'Naše varianty (podle kategorií)',
      porovnatelnaCast: 'Porovnatelná část současného portfolia',
      pridejVariantu: 'Přidej naši variantu, jinak se nedá porovnávat.',
      soucasnePortfolio: 'Současné portfolio',
      stretZajmu: 'Střet zájmů: srovnáváme s produktem, který zprostředkováváme a za jehož sjednání dostáváme odměnu. Nástroj proto smí skončit verdiktem „ponechat“ — a když vyjde, tak to i napíše.',
      titulek: 'Portfolio doktor',
      uvod1: 'Opiš, co klient drží, doplň nákladovost z KID a uvidíš, kolik ho portfolio stojí a kolik z toho udělá rozdíl za horizont.',
      uvod2: 'Aplikace nezná nákladovost žádného fondu',
      uvod3: '— čísla zadáváš ty z doložitelného zdroje.',
      vseZKid: 'Vše z KID',
      vseZKidTitle: 'Označí vyplněné nákladovosti jako doložené z KID',
    },
    provize: {
      add: 'Přidat produkt',
      amount: 'částka',
      koef: 'Koeficient',
      kpi1: 'Provize 1. rok',
      kpi5: 'Za 5 let celkem',
      kpi5Sub: '1. rok + 4× opakovaně',
      kpiRep: 'Opakovaně / rok',
      kpiRepSub: 'pečovatelské + fee',
      notFound: 'Nic nenalezeno',
      note: '💡 Orientační výpočet dle katalogu. Přesné podmínky dle provizních dodatků na portálu. „Opakovaně“ = pečovatelské BJ (auto/majetek od 2. roku, investice management fee, ŽP od 6. roku).',
      pick: '— vyber produkt —',
      pos: 'Tvoje pozice',
      repeat: 'opakovaně',
      sample: 'vzor',
      sub: 'Zadej pozici a produkty → uvidíš provizi za 1. rok i opakovaně. 201 produktů z katalogu BJ · provize = BJ × koeficient.',
      title: 'Provizní kalkulačka',
      tools: 'Nástroje',
      year1: '1. rok',
    },
    srovnavacFondu: {
      coSniPoplatky: 'Co sní poplatky',
      disclaimer: 'Sazby TER a vstupní poplatky jsou orientační — ověř je v aktuálním KIID / sazebníku. Stejný hrubý výnos pro oba slouží k izolaci nákladů; reálné fondy mohou sledovat různé indexy. Minulá výkonnost není zárukou budoucí.',
      disclaimerTuk: 'Modelová kalkulace, ne slib výnosu.',
      hintA: 'náš fond / ETF',
      hintB: 'fond klienta',
      hledatPlaceholder: 'Napiš fond klienta… (např. „dynamický“)',
      hrubyVynos: 'Hrubý výnos',
      nadrazenaSekce: 'Nástroje',
      nicNenalezeno: 'Nic nenalezeno — zvol vlastní fond a zadej TER ručně.',
      rok: 'Rok',
      ter: 'TER (roční náklad)',
      uvod1: 'Najdi fond klienta v našeptávači (stačí napsat část názvu, i bez diakritiky) a porovnej ho s naším fondem — kolik z výnosu si vezmou poplatky. Stejný předpokládaný hrubý výnos pro oba, takže vidíš čistě',
      uvod2: 'rozdíl v nákladech',
      uvod3: '. Bez AI, počítá se rovnou tady.',
      vicNaKonci: 'VÍC NA KONCI',
      vlastniFond: 'Vlastní fond',
      vlastniFondRucne: 'Vlastní fond (zadat TER ručně)',
      vlozenoCelkem: 'Vloženo celkem',
      vstupni: 'vstupní',
      vstupniPoplatek: 'Vstupní poplatek',
      vstupniProc: 'Vstupní %',
      vyvojHodnoty: 'Vývoj hodnoty',
      zisk: 'Zisk',
    },
  },
  /* === /NASTROJE === */
  /* === ANALÝZA V2+ — stavová lišta ukládání (lib/analyzaV2/stavUkladani.js) ===
   * Zelená smí svítit JEN tehdy, když na serveru sedí přesně to, co je na
   * obrazovce. Texty musí být krátké — jedou v liště vedle tlačítek. */
  /* BLOK:analyza START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyza: {
    instituceVyber: {
      nabidka: 'Nabídka institucí',
      sipka: 'Zobrazit celý seznam',
    },
    propis: {
      ceka: 'Čeká na propsání do složky: {n}',
      chyba: 'Do složky se teď nepodařilo propsat, zkusím to znovu',
      hotovo: 'Přeneseno do složky',
      hotovoNove: 'nové: {n}',
      hotovoUpravene: 'upravené: {n}',
      klid: 'Složka klienta je srovnaná s analýzou',
      nehotove: 'Rozepsané řádky čekají na doplnění: {n}',
      nepropisovane: 'Účty a hotovost se zatím do složky nepropisují: {n}',
      probiha: 'Propisuji do složky klienta…',
      smazane: 'Řádek smazaný z analýzy zůstává ve složce: {n}',
    },
    uklad: {
      ceka: 'Čeká na uložení',
      cekaDetail: 'Poslední změna ještě není na serveru.',
      nepovedlo: 'Neuloženo — zkouším znovu',
      nepovedloDetail: '{n}. pokus, další za {s} s',
      nepovedloPokus: '{n}. pokus',
      obnova: 'Našli jsme neuložené změny — obnovit?',
      obnovaAno: 'Obnovit',
      obnovaNe: 'Zahodit',
      obnovaSCasem: 'Našli jsme neuložené změny z {cas} — obnovit?',
      uklada: 'Ukládám…',
      ulozeno: 'Uloženo',
      zastaveno: 'Neukládám — analýza se nenačetla',
      zastavenoDetail: 'Načti stránku znovu, ať se nepřepíšou data.',
    },
  },
  /* BLOK:analyza END */
  /* KRIZOVÝ PLÁN — „co dělat, když se stane".
   * Čte to klient, kterému se něco stalo. Někdy pozůstalý. Proto: klidně,
   * konkrétně, bez marketingu a bez vykřičníků.
   * ⚠️ NIC TU NESMÍ SLIBOVAT CHOVÁNÍ POJIŠŤOVNY. Popisujeme POSTUP
   *    („co udělat, koho volat"), ne záruky plnění. Lhůty, které jsou
   *    v zákoně, jsou v `krize.pravni.*` i s odkazem na předpis. */
  krize: {
    nadpis: 'Krizový plán',
    podnadpis: 'Co dělat, když se něco stane',
    uvod1: 'Tuhle část si schovejte. Není na dnešek — je na den, kdy ji budete potřebovat.',
    uvod2: 'Není tu nic, co musíte stihnout hned. Pořadí je vždycky stejné: postarat se o sebe, ozvat se mi, nahlásit to pojišťovně.',
    proKoho: 'Krizový plán pro {jmeno}',
    platnost: 'Sestaveno {datum} podle smluv, které tehdy byly v podkladech.',

    kontaktNadpis: 'Nejdřív zavolejte mně',
    kontaktText: 'Nemusíte vědět, co kde máte sjednané, ani co komu psát. Od toho jsem tady.',
    kontaktRole: 'Váš poradce',
    kontaktFirma: 'Společnost',
    kontaktTelefon: 'Telefon',
    kontaktEmail: 'E-mail',
    kontaktWeb: 'Web',
    kontaktRezervace: 'Domluvit schůzku',

    krokyNadpis: 'Postup',
    podkladyNadpis: 'Co si připravit',
    pozorNadpis: 'Na co pozor',
    smlouvyNadpis: 'Smlouvy, které se k tomu můžou vztahovat',
    smlouvaBezCisla: 'číslo smlouvy zatím nemám',
    smlouvaBezInstituce: 'instituci zatím nemám',
    bezSmluv: 'K tomuhle riziku nemám ve vašich podkladech evidovanou žádnou smlouvu. Neznamená to, že žádnou nemáte — znamená to, že ji spolu musíme dohledat.',
    bezSmluvVse: 'V podkladech nemám evidovanou ani jednu pojistnou smlouvu. Postup níž platí i tak; jen si nejdřív spolu projdeme, co máte sjednané.',
    navrhNavic: 'Návrh navíc',

    pravniNadpis: 'Odkud to víme',
    pravniOvereno: 'ověřeno',
    disclaimer1: 'Tenhle přehled říká, CO udělat. Neříká, jestli a kolik pojišťovna vyplatí — to se řídí zněním vaší smlouvy a jejími výlukami. Projdeme je spolu.',
    disclaimer2: 'Uvedené paragrafy jsou obecná pravidla, ne příslib plnění. Lhůty i podmínky má každá smlouva vlastní.',
    disclaimer3: 'Postup vychází z české právní úpravy. Pro smlouvy sjednané v jiné zemi platí tamní pravidla.',

    chybiNadpis: 'Než to pošlete klientovi',
    chybiKontaktVse: 'V profilu poradce není telefon ani veřejný e-mail. Krizový plán bez kontaktu nedává smysl — doplňte je v Nastavení.',
    chybiJmeno: 'Chybí jméno poradce.',
    chybiTelefon: 'Chybí telefon poradce.',
    chybiEmail: 'Chybí veřejný e-mail poradce.',
    chybiWeb: 'Chybí web poradce.',
    chybiRezervace: 'Chybí odkaz na rezervaci schůzky — doplňte vizitku nebo kalendář.',
    chybiSmlouvy: 'V podkladech nejsou evidované žádné pojistné smlouvy.',
    chybiCislaSmluv: 'U některých smluv chybí číslo. Klient ho v krizi hledat nebude.',

    pravni: {
      oznameni: 'Pojistnou událost je třeba oznámit pojistiteli bez zbytečného odkladu.',
      setreni: 'Pojistitel po oznámení zahájí bez zbytečného odkladu šetření. Výsledek i odůvodnění výše plnění, případně důvod zamítnutí, sděluje v textové podobě.',
      splatnost: 'Není-li splatnost ujednána ve smlouvě, je pojistné plnění splatné do patnácti dnů ode dne SKONČENÍ šetření. Není to lhůta na vyřízení celé události.',
      zaloha: 'Nelze-li šetření ukončit do tří měsíců od oznámení, pojistitel sdělí důvody v textové podobě a na žádost poskytne přiměřenou zálohu.',
      stupne: 'Stupně invalidity se určují podle poklesu pracovní schopnosti: I. stupeň 35–49 %, II. stupeň 50–69 %, III. stupeň nejméně 70 %.',
      nahradaMzdy: 'Za prvních 14 kalendářních dnů dočasné pracovní neschopnosti náleží zaměstnanci náhrada mzdy od zaměstnavatele.',
      zadostID: 'Žádost o invalidní důchod se sepisuje na územní správě sociálního zabezpečení nebo se podává elektronicky. Zdravotní stav posuzuje posudkový lékař, zpravidla z dokumentace. Zákonná lhůta pro rozhodnutí je 90 dnů.',
    },

    uraz_nemoc: {
      nadpis: 'Úraz nebo nemoc — krátká pracovní neschopnost',
      kdy: 'Jste doma na neschopence a počítáte s tím, že se za pár týdnů vrátíte.',
      kroky: [
        { n: 'Nechte si vystavit neschopenku', d: 'Vystaví ji ošetřující lékař elektronicky. Papír zaměstnavateli nenosíte.' },
        { n: 'Dejte vědět zaměstnavateli', d: 'Stačí zpráva, od kterého dne jste v pracovní neschopnosti.' },
        { n: 'Ozvěte se mi', d: 'Projdeme spolu vaše smlouvy a řekneme si, které z nich se na tohle vztahují.' },
        { n: 'Nahlaste to pojišťovně', d: 'Hlásit bez zbytečného odkladu ukládá § 2796 občanského zákoníku. Když nevíte jak, nahlásíme to spolu.' },
        { n: 'Schovávejte si doklady', d: 'Zprávy od lékaře, účtenky za léky, potvrzení o délce neschopnosti. Zpětně se shánějí hůř.' },
      ],
      podklady: [
        'Číslo pojistné smlouvy',
        'Doklad totožnosti',
        'Číslo účtu, kam poslat plnění',
        'Potvrzení o pracovní neschopnosti — od kdy do kdy',
        'Lékařské zprávy k úrazu nebo nemoci',
      ],
      pozor: 'Prvních 14 kalendářních dnů hradí náhradu mzdy zaměstnavatel, od 15. dne vyplácí nemocenské správa sociálního zabezpečení. Osoba samostatně výdělečně činná dostane nemocenské jen tehdy, když si platí dobrovolné nemocenské pojištění. Karenční doba u pojistky je něco jiného — má ji každá smlouva vlastní a najdeme ji ve vaší.',
    },

    dlouhodoba_pn: {
      nadpis: 'Dlouhodobá pracovní neschopnost',
      kdy: 'Neschopnost se táhne měsíce a je jasné, že to nebude na dva týdny.',
      kroky: [
        { n: 'Ozvěte se mi dřív, než dojdou peníze', d: 'Čím dřív to víme, tím víc se dá s rozpočtem a se splátkami udělat.' },
        { n: 'Spočítáme, kolik měsíčně chybí', d: 'Nemocenské nahrazuje jen část čistého příjmu. Rozdíl je přesně to, co musíme pokrýt.' },
        { n: 'Uplatněte denní dávku z pojistky', d: 'Pracovní neschopnost i denní odškodné se hlásí zvlášť — i když jste jednou hlásili úraz.' },
        { n: 'Řekněte to bance včas', d: 'O odklad splátek se žádá dřív, než splátka propadne. Po nezaplacené splátce je to výrazně těžší.' },
        { n: 'Domluvíme si kontrolní schůzku', d: 'U dlouhé neschopnosti se situace mění každý měsíc. Nechci, abyste to sledovali sami.' },
      ],
      podklady: [
        'Rozhodnutí o dočasné pracovní neschopnosti',
        'Průběžné lékařské zprávy',
        'Čísla pojistných smluv',
        'Přehled splátek a trvalých příkazů',
        'Výpisy z účtu za poslední měsíce',
      ],
      pozor: 'Nemocenské se nevyplácí donekonečna — podpůrčí doba je omezená a její délku i případné prodloužení posuzuje správa sociálního zabezpečení podle vaší situace. Zjistíme ji spolu, ať víme, kdy začít řešit další krok.',
    },

    zavazne_onemocneni: {
      nadpis: 'Závažné onemocnění',
      kdy: 'Padla diagnóza typu nádorové onemocnění, infarkt nebo mrtvice. Takové bývají v pojistkách vyjmenované.',
      kroky: [
        { n: 'Nejdřív se léčte', d: 'Nic z toho, co je níž, není na dnešní odpoledne. Papíry pár dnů počkají.' },
        { n: 'Zavolejte mi', d: 'Podíváme se, jestli je vaše diagnóza mezi krytými. Seznam je v každé smlouvě jiný.' },
        { n: 'Vyžádejte si lékařskou zprávu s diagnózou', d: 'Včetně data, kdy byla stanovena. Bez ní se pojistná událost nedá doložit.' },
        { n: 'Nahlaste to pojišťovně', d: 'Bez zbytečného odkladu, § 2796 občanského zákoníku. Formulář vyplníme spolu.' },
        { n: 'Řešte i výpadek příjmu', d: 'Závažné onemocnění bývá i dlouhá pracovní neschopnost. Uplatňujeme obojí, ne jen jedno.' },
      ],
      podklady: [
        'Lékařská zpráva s diagnózou a datem',
        'Propouštěcí zpráva z nemocnice',
        'Výsledky vyšetření, na která se zpráva odvolává',
        'Číslo pojistné smlouvy a doklad totožnosti',
        'Číslo účtu, kam poslat plnění',
      ],
      pozor: 'Každá smlouva má vlastní seznam diagnóz, vlastní definice a vlastní čekací dobu. Co platí u vás, přečteme přímo ve vaší smlouvě — obecně se to říct nedá.',
    },

    invalidita: {
      nadpis: 'Invalidita',
      kdy: 'Zdravotní stav je dlouhodobě špatný a návrat do práce v původním rozsahu není reálný.',
      kroky: [
        { n: 'Zavolejte mi hned na začátku, ne až na konci', d: 'Než přijde rozhodnutí, uběhnou měsíce. Během nich se dá se splátkami a rozpočtem udělat hodně.' },
        { n: 'Podejte žádost o invalidní důchod', d: 'Sepíše se na územní správě sociálního zabezpečení, nebo se podá elektronicky.' },
        { n: 'Připravte lékařské zprávy dopředu', d: 'Zdravotní stav posuzuje posudkový lékař, zpravidla z dokumentace. Čím úplnější podklady, tím plynulejší řízení.' },
        { n: 'Vězte, o čem se rozhoduje', d: 'O stupni invalidity podle poklesu pracovní schopnosti: I. stupeň 35–49 %, II. stupeň 50–69 %, III. stupeň nejméně 70 %. Zákonná lhůta pro rozhodnutí je 90 dnů.' },
        { n: 'Rozhodnutí odneste pojišťovně', d: 'Většina smluv se na přiznaný stupeň invalidity odvolává. Rozhodnutí si schovejte, je to klíčový dokument.' },
      ],
      podklady: [
        'Doklad totožnosti',
        'Kompletní lékařské zprávy',
        'Doklady o vzdělání a přehled dosavadní práce',
        'Profesní dotazník, který pošle správa sociálního zabezpečení',
        'Rozhodnutí o invaliditě a číslo pojistné smlouvy',
      ],
      pozor: 'Přiznání invalidity od státu a plnění z pojistky jsou dvě samostatná řízení. Pojišťovna posuzuje podle znění vaší smlouvy a může dojít k jinému závěru než stát. Právě proto to nenechávejte na sobě.',
    },

    umrti: {
      nadpis: 'Úmrtí',
      kdy: 'Tuhle část čte někdo blízký. Není tu nic, co je potřeba stihnout dnes.',
      kroky: [
        { n: 'Zařiďte jen to nutné', d: 'Úmrtní list vydá matrika, obvykle to zařídí pohřební služba. Vyžádejte si víc stejnopisů, budou potřeba na několika místech.' },
        { n: 'Zavolejte mi', d: 'Nemusíte vědět, co kde bylo sjednané. Mám přehled smluv, které jsme dělali, a projdu je s vámi.' },
        { n: 'Nahlaste to pojišťovnám', d: 'Ohlásit bez zbytečného odkladu ukládá § 2796 občanského zákoníku. Nahlásíme to spolu, i u smluv u jiných institucí.' },
        { n: 'Požádejte o pozůstalostní důchody', d: 'Vdovský, vdovecký ani sirotčí důchod nevzniká sám — o všechny se žádá na správě sociálního zabezpečení.' },
        { n: 'Nespěchejte s velkými rozhodnutími', d: 'Prodej bytu, výpovědi smluv, splacení úvěru. Nic z toho není na první týdny.' },
      ],
      podklady: [
        'Úmrtní list — raději víc stejnopisů',
        'Doklad totožnosti pozůstalého',
        'Čísla pojistných a úvěrových smluv',
        'Oddací list, rodné listy dětí',
        'Číslo účtu, kam poslat plnění',
      ],
      pozor: 'Závazky úmrtím samy nezanikají, řeší se v dědickém řízení. U některých úvěrů bývá pojištění schopnosti splácet sjednané přímo v úvěrové smlouvě, ne v životní pojistce. Proto se ozveme i bance.',
    },

    skoda_na_majetku: {
      nadpis: 'Škoda na majetku',
      kdy: 'Vytopení, požár, vichřice, vloupání — nebo škoda, kterou jste způsobili někomu jinému.',
      kroky: [
        { n: 'Zastavte škodu, pokud to jde bezpečně', d: 'Zavřít vodu, vypnout elektřinu. Když hrozí nebezpečí, volejte 112.' },
        { n: 'Vyfoťte všechno dřív, než začnete uklízet', d: 'Fotky a video jsou nejsilnější důkaz. Poškozené věci nevyhazujte, dokud je pojišťovna neviděla.' },
        { n: 'U vloupání a u nehody volejte policii', d: 'Bez policejního záznamu se taková škoda dokládá obtížně.' },
        { n: 'Nahlaste to pojišťovně a ozvěte se mi', d: 'Bez zbytečného odkladu, § 2796 občanského zákoníku. Se soupisem škody i s formulářem pomůžu.' },
        { n: 'Sepište škodu položku po položce', d: 'Co to bylo, kdy pořízené, za kolik. Účtenky, faktury, záruční listy — cokoli máte.' },
      ],
      podklady: [
        'Fotografie a video poškození',
        'Soupis poškozených věcí s cenami',
        'Účtenky, faktury, záruční listy',
        'Číslo pojistné smlouvy a doklad totožnosti',
        'Policejní protokol u vloupání nebo nehody',
      ],
      pozor: 'Nezačínejte s opravou dřív, než se domluvíte s pojišťovnou — řada smluv má prohlídku technikem jako podmínku. A pokud jste škodu způsobili někomu jinému, nic neuznávejte ani neplaťte dřív, než si to spolu projdeme.',
    },
  },

  /* === AUTO: klíče vytažené z jazykových ternárů (scripts/i18n-ternary-codemod.js) === */
  /* BLOK:auto START — generuje scratchpad/slovnik.py, ručně needitovat */
  auto: {
    aIEmailBulkModal: {
      aiFiltrujePise: 'AI filtruje + píše…',
      cileni: 'Cílení:',
      hromadnyAiMailSmartemailing: 'Hromadný AI mail (Smartemailing zdarma)',
      jmeno: 'Jméno',
      klientu: 'klientů',
      klientuOdpovidaFiltru: 'klientů odpovídá filtru',
      klientumOtazka: 'klientům?',
      n2NahledEmailuPlaceholders: '2. Náhled emailu (placeholders nahrazeny při odeslání)',
      odeslano: 'Odesláno:',
      opravduOdeslatEmail: 'Opravdu odeslat email',
      osloveni: 'Oslovení',
      poradce: 'Poradce',
      posliVsemCoNemaji: 'Pošli všem co nemají penzijko že je akce + CTA na hovor…',
      prepsano: 'Přepsáno',
      prijemci: 'Příjemci',
      prijmeni: 'Příjmení',
      prikladyPosliVipKlientum: 'Příklady: „pošli VIP klientům newsletter o ČNB“ · „pošli všem co podepsali ŽP info o životním pojištění partner“ · „všem aktivním tip k daním 2026“',
      selhalo: 'selhalo',
      skrytSeznamPrijemcu: 'Skrýt seznam příjemců',
      spustitKampan: 'Spustit kampaň →',
      teloTemplate: 'Tělo (template):',
      uspesne: 'úspěšně',
      vybratVse: 'Vybrat vše',
      vyfiltrovatKlientyNapsatEmail: 'Vyfiltrovat klienty + Napsat email',
      zadniKlientiNeodpovidajiFiltru: 'Žádní klienti neodpovídají filtru',
      zadny: 'Žádný',
      zobrazitUpravitSeznam: 'Zobrazit / upravit seznam',
    },
    aIEmailDraftModal: {
      aiEmailKlientovi: 'AI Email klientovi',
      aiPise: 'AI píše…',
      aiVygenerujEmail: 'AI vygeneruj email',
      emailOdeslanSipka: 'Email odeslán',
      emailOhledne: 'email ohledně...',
      klientNemaEmailVCrm: '(klient nemá e-mail v CRM)',
      klienta: 'klienta',
      komu: 'Komu:',
      komuKlientACeho: 'Komu (klient) a čeho se týká (obchod)',
      n2NahledEmailu: '2. Náhled emailu',
      obchod: 'obchod',
      odeslatNa: 'Odeslat na',
      odeslatZMehoGmailu: 'Odeslat z mého Gmailu',
      odpovezNaEmailOd: 'Odpověz na email od',
      posliPavloviInfoO: 'Pošli Pavlovi info o servisní schůzce v úterý 14:00…',
      posliPredJmenem: 'Pošli',
      prepsanoKlikniAiVygeneruj: 'Přepsáno — klikni AI vygeneruj',
      sPredmetem: 's předmětem',
      spustitNahravani: 'Spustit nahrávání',
      telo: 'Tělo:',
      volitelneObchod: 'Volitelně: obchod…',
      zastavitNahravani: 'Zastavit nahrávání',
    },
    academyLayout: {
    },
    analyzaTiskPage: {
      analyza: 'Analýza',
      castka: 'Částka',
      celkem: 'Celkem',
      cisteJmeni: 'Čisté jmění',
      coBudemeResit: 'Co spolu budeme řešit',
      coBudemeResitUvod: 'Z čísel, která jsme spolu prošli, vyplývají tato témata. Projdeme je při přípravě vašeho plánu.',
      coJeProVasDulezite: 'Co je pro vás důležité',
      coOcekavate: 'Co od spolupráce očekáváte',
      coOdVasPotrebuji: 'Co od vás potřebuji',
      coZnamenajiPenize: 'Co pro vás znamenají peníze',
      dalsiKrok: 'Další krok',
      dedictviBudouciProdej: 'Dědictví / budoucí prodej',
      dluhy: 'Dluhy',
      dobryDenPosilamShrnuti: 'Dobrý den, posílám shrnutí naší finanční analýzy. Mrkněte a kdyžtak se ozvěte.',
      financniAnalyza: 'Finanční analýza',
      financniMajetek: 'Finanční majetek',
      firmaPodnikani: 'Firma / podnikání',
      investiceOpfEtfAkcie: 'Investice (OPF/ETF, akcie)',
      majetekCelkem: 'Majetek celkem',
      naZakladeTechtoCisel: 'Na základě těchto čísel navrhneme další kroky ve finančním plánu — ozvěte se a projdeme je společně.',
      nasobekVydaju: '{n}× výdajů',
      nemovitostiAutoCennosti: 'Nemovitosti / auto / cennosti',
      nezavazne: 'Tento přehled je nezávazný. Slouží jako podklad k přípravě finančního plánu. Konkrétní řešení, produkty a jejich podmínky probereme a odsouhlasíme až při realizaci.',
      penzijniDip: 'Penzijní / DIP',
      pocetCilu: 'Počet cílů',
      prijmyMes: 'Příjmy / měs',
      pripravujiAnalyzu: 'Připravuji analýzu…',
      registrace: 'Registrace {regulator}: {cislo}',
      rezerva: 'Rezerva',
      schuzkaDne: 'Schůzka dne {datum}',
      shrnutiNasiAnalyzy: 'Shrnutí naší analýzy: čisté jmění {jmeni}, finanční rezerva {rezerva}× měsíčních výdajů a volný cash-flow {cf} měsíčně.',
      shrnutiSchuzky: 'Shrnutí schůzky',
      splatkaMes: 'Splátka/měs',
      stavebniSporeni: 'Stavební spoření',
      strucneOSituaci: 'Stručně o vaší situaci',
      terminDomluvime: 'Termín další schůzky spolu domluvíme.',
      uctyAHotovost: 'Účty a hotovost',
      vaseCile: 'Vaše cíle',
      volnyCashFlowMes: 'Volný cash-flow / měs',
      vydajeMes: 'Výdaje / měs',
      zavazkyCelkem: 'Závazky celkem',
      zaznamZAnalyzy: 'Záznam z analýzy ze dne {datum} v dnešních cenách. Slouží jako podklad pro finanční plán; aktualizujeme při změně situace.',
      /* Vzhled zeleného PDF (25. 10. 2026): podnadpisy, velká karta volných peněz, pata listu. */
      dulezitUpozorneni: 'Důležité upozornění',
      majetekAZavazky: 'Majetek a závazky',
      prijmyAVydaje: 'Příjmy a výdaje',
      volneProstredky: 'Volné prostředky',
      volneProstredkyPopis: 'Kolik vám každý měsíc zbude po výdajích a splátkách.',
      vydajePodleKategorii: 'Výdaje podle kategorií',
      vytvoreno: 'Vytvořeno {datum}',
    },
    businessCharts: {
      celkemBj: 'Celkem BJ',
      cil: 'cíl',
      nastavMesicniPlanBj: 'Nastav měsíční plán BJ v Cíle & Rocks.',
      plneniPlanuBj: 'Plnění plánu (BJ)',
      provize: 'Provize',
    },
    cashflowGraf: {
      cashflowVCaseMesicni: 'Cashflow v čase — měsíční přebytek',
      naKonci: 'na konci',
      nastupHypoteky: 'nástup hypotéky',
      poNastupuHypoteky: 'po nástupu hypotéky',
      prebytekKlesneJenO: '). Přebytek klesne jen o rozdíl splátka − odpadající nájem, ne o celou splátku.',
      splatkaHypotekySeV: 'Splátka hypotéky se v cashflow projeví až od čerpání (r. ',
      start: 'start',
    },
    casovaOsaCilu: {
      casovaOsa: 'Časová osa',
      casovaOsaCiluOd: 'Časová osa cílů od dneška do roku',
      chybi: 'chybí',
      dnes: 'dnes',
      dosahne: 'dosáhne',
      kdySeKteryCil: 'Kdy se který cíl splní',
      let: 'let',
      letech: 'letech',
      letos: 'letos',
      seNesplniChybiCelkem: 'se nesplní — chybí celkem',
      ve: 've',
      vekKlientaUMilniku: 'Věk klienta u milníků chybí — v analýze není datum narození.',
      zatimZadnyCilOsa: 'Zatím žádný cíl — osa se naplní, jakmile přidáš první.',
    },
    cilCinema: {
      dalsi: 'Další',
      poznamkaPoradce: 'Poznámka poradce ',
      poznamkaPoradceN: 'Poznámka poradce (N)',
      prehrat: 'Přehrát',
      proKlientskyRezimTu: 'Pro klientský režim tu zatím není schválený obsah',
      scenyTohotoCileCekaji: 'Scény tohoto cíle čekají na schválení metodiky. V poradenském režimu je přehrát lze — klientovi je zatím neukazujeme.',
      zavrit: 'Zavřít',
      zpet: 'Zpět',
    },
    clientDealsTab: {
      archiv: 'Archiv',
      archivovane: 'Archivované',
      klikniNovyObchodPro: 'Klikni „Nový obchod“ pro založení.',
      nacitam: 'Načítám…',
      nelzeNacistObchodyKlienta: 'Nelze načíst obchody klienta',
      obchodySeNepodariloNacist: 'Obchody se nepodařilo načíst',
      otevritDetail: 'Otevřít detail',
      prohraZruseno: 'Prohra/Zrušeno',
      rozjednane: 'Rozjednané',
      rozjednaneObchody: 'Rozjednané obchody',
      vProcesu: 'v procesu',
      vyhrane: 'Vyhrané',
      vyhraneSmlouvy: 'Vyhrané → smlouvy',
      zadneObchodyVTeto: 'Žádné obchody v této kategorii',
      zkusToZnovuNejde: 'Zkus to znovu — nejde o prázdný seznam, ale o chybu spojení.',
    },
    clientMapPage: {
      kratkyServis: 'Krátký servis',
      seznamKlientu: 'Seznam klientů ({n})',
      vTrase: 'v trase {n}',
      zavritSeznam: 'Zavřít seznam',
      shlukKlientuOne: '{n} klient',
      shlukKlientuFew: '{n} klienti',
      shlukKlientuMany: '{n} klientů',
      shlukAOkoli: '{mesto} a okolí',
      shlukStejneMisto: 'Na stejném místě',
      shlukPriblizit: 'Přiblížit na všechny',
      shlukZavrit: 'Zavřít seznam shluku',
      shlukTip: '{pocet} — klikněte pro seznam',
      shlukZpet: 'Zpět na seznam ({n})',
      shlukSeznam: 'Klienti ve shluku',
      typKlient: 'Klient',
      typNabor: 'Nábor',
      typLead: 'Lead',
      typOstatni: 'Ostatní',
    },
    composeEmailModal: {
      dobryDen: 'Dobrý den,…',
      eMailOdeslan: 'E-mail odeslán',
      komuNapisJakykolivE: 'Komu * — napiš jakýkoliv e-mail (klienta vybírat nemusíš)',
      neboVyberKlientaVolitelne: '…nebo vyber klienta (volitelné — doplní e-mail + uloží do jeho historie)',
      nelzeOdeslat: 'Nelze odeslat',
      novyEMail: 'Nový e-mail',
      obchodniPripadVolitelneVazba: 'Obchodní případ (volitelně — vazba pro pozdější dohledání)',
      odeslat: 'Odeslat',
      predmet: 'Předmět *',
      predmetEMailu: 'Předmět e-mailu',
      teloZpravy: 'Tělo zprávy *',
      zadejPredmet: 'Zadej předmět',
      zadejPrijemce: 'Zadej příjemce',
      zadejTextEMailu: 'Zadej text e-mailu',
      zavrit: 'Zavřít',
      zrusit: 'Zrušit',
    },
    dashboardPage: {
      akademieProNovackyKlikaci: 'Akademie pro nováčky · klikací průvodce',
      coJePoradenstviEtika: 'Co je poradenství, etika, proces, produkty, navolávání, argumentace, uzavírání + kvízy.',
      vitejteVBeplan: 'Vítejte v beplan ',
      zNovackaProfikKrok: 'Z nováčka profík — krok za krokem',
    },
    dealAutocomplete: {
      najdiObchodniPripadKlienta: 'Najdi obchodní případ klienta…',
      nejprveVyberKlienta: 'Nejprve vyber klienta…',
      obchodniPripad: 'Obchodní případ',
      vymazat: 'Vymazat',
      zadnyOtevrenyObchodniPripad: 'Žádný otevřený obchodní případ klienta.',
    },
    dealResultModal: {
      datumUzavreni: 'Datum uzavření',
      duvodVolitelneZapiseSe: 'Důvod (volitelné — zapíše se do historie)',
      konecnaCenaBj: 'Konečná cena (BJ)',
      naprKlientZustalU: 'Např. klient zůstal u stávající banky…',
      zpet: 'Zpět',
    },
    diarPageV3: {
      adresatJmenoAdresa: 'Adresát (jméno + adresa)',
      aktivitaUlozena: 'Aktivita uložena',
      aktivitaVytvorena: 'Aktivita vytvořena',
      aktualizovano: 'aktualizováno',
      bezKlienta: 'Bez klienta?',
      cehoSeToTyka: 'Čeho se to týká',
      celodenni: 'Celodenní',
      celyDen: ' · celý den',
      dalsiMesic: 'Další měsíc',
      dalsiUcastniciVolitelneOddelene: 'Další účastníci (volitelně, oddělené čárkou)',
      dalsich: 'dalších',
      datum: 'Datum *',
      delkaUpravena: 'Délka upravena',
      diarVeTvemKalendari: 'Diář ve tvém kalendáři',
      dnesVelke: 'Dnes',
      doba: 'Doba',
      doplnitKlienta: 'Doplnit klienta',
      editaceAktivity: 'Editace aktivity',
      editovat: 'Editovat',
      importZGoogleCalendar: 'Import z Google Calendar do Diáře',
      importovano: 'Importováno',
      jindeOnline: 'Jinde / online',
      kalendar: 'Kalendář',
      kalendarSeAktualizujeKazdou: 'Kalendář se aktualizuje ~každou hodinu.',
      kdeSeSchuzkaKona: 'Kde se schůzka koná',
      klient: 'Klient',
      klientNemaVyplnenouAdresu: 'Klient nemá vyplněnou adresu — napiš ji a vyber z našeptávače.',
      kopirovat: 'Kopírovat',
      mistoAdresa: 'Místo / adresa',
      mistoVolitelne: 'Místo (volitelně)',
      nacitam: 'Načítám…',
      nacitamOdkaz: 'Načítám odkaz…',
      nacitamStav: 'Načítám stav…',
      nacteSchuzkyAUdalosti: 'Načte schůzky a události z tvého Google kalendáře (-7 dní až +6 měsíců) a zobrazí je v Diáři jako aktivity. Schůzky vytvořené přes beplan se nedublují.',
      napisAdresuMestoMisto: 'napiš adresu / město / místo…',
      nastaveni: 'Nastavení',
      nastaveniKalendare: 'Nastavení kalendáře',
      neboJenExportApple: 'Nebo jen export (Apple / Outlook)',
      nelzeNacistUkoly: 'Nelze načíst úkoly',
      nelzePresunoutUkol: 'Nelze přesunout úkol',
      nelzeUlozit: 'Nelze uložit',
      nelzeVratit: 'Nelze vrátit',
      nenaplanovano: 'Nenaplánováno',
      nepodariloSeNacistOdkaz: 'Nepodařilo se načíst odkaz',
      nepodariloSeVytvoritKlienta: 'Nepodařilo se vytvořit klienta',
      nepovedloSe: 'Nepovedlo se',
      nizka: 'Nízká',
      nova: 'Nová',
      novaAktivita: 'Nová aktivita',
      novouPridasTlacitkemAktivita: 'Novou přidáš tlačítkem „Aktivita“.',
      novyBezpecnostniKodVytvoren: 'Nový bezpečnostní kód vytvořen',
      obchodniPripadVolitelne: 'Obchodní případ (volitelně)',
      obnovit: 'Obnovit',
      odchozi: 'Odchozí',
      odkazNaTvujKalendar: 'Odkaz na tvůj kalendář',
      polozkaUzNeniDostupna: 'Položka už není dostupná',
      pracovniDobaDo: 'Pracovní doba do',
      pracovniDobaOd: 'Pracovní doba od',
      predchoziMesic: 'Předchozí měsíc',
      preskoceno: 'přeskočeno',
      presunuto: 'Přesunuto',
      presunutoDoCasu: 'Přesunuto do času',
      prichozi: 'Příchozí',
      pridatDoAppleOutlook: 'Přidat do Apple / Outlook',
      pridatDoGoogle: 'Přidat do Google',
      priorita: 'Priorita',
      resitel: 'Řešitel',
      schovatRealizovane: 'Schovat realizované',
      smerHovoru: 'Směr hovoru',
      soukromaAktivita: '(soukromá aktivita)',
      soukromaAktivita2: 'Soukromá aktivita',
      stavPropojeniSeNepodarilo: 'Stav propojení se nepodařilo zjistit.',
      stredni: 'Střední',
      synchronizace: 'Synchronizace',
      synchronizaceSelhala: 'Synchronizace selhala',
      synchronizovatDoGoogleApple: 'Synchronizovat do Google / Apple / Outlook',
      synchronizovatTed: 'Synchronizovat teď',
      synchronizuji: 'Synchronizuji…',
      tahniProCas: '⇅ táhni pro čas',
      telefonniCislo: 'Telefonní číslo',
      tentoDen: 'Tento den',
      typAktivity: 'Typ aktivity',
      uKlienta: 'U klienta',
      uKlientaProste: 'U klienta',
      uNas: 'U nás',
      uNasVKancelari: 'U nás v kanceláři',
      ucet: 'Účet',
      ukladam: 'Ukládám…',
      ukolNaplanovan: 'Úkol naplánován',
      uloziSeDoDiare: 'Uloží se do diáře',
      ulozitJakoSoukromou: 'Uložit jako soukromou',
      ulozitZmeny: 'Uložit změny',
      vice: 'Více',
      volnoAiZavolejA: 'Volno · zavolej A-leadům',
      vraceno: 'Vráceno',
      vratit: 'Vrátit',
      vseNaplanovano: 'Vše naplánováno.',
      vychoziDelkaAktivity: 'Výchozí délka aktivity',
      vychoziTypNoveAktivity: 'Výchozí typ nové aktivity',
      vychoziZobrazeni: 'Výchozí zobrazení',
      vysledekHovoruPoDokonceni: 'Výsledek hovoru (po dokončení)',
      vysoka: 'Vysoká',
      vytvorit: 'Vytvořit',
      zacatek: 'Začátek *',
      zadejDatumACas: 'Zadej datum a čas',
      zadejNazevPredmet: 'Zadej název / předmět',
      zadneNadchazejiciAktivity: 'Žádné nadcházející aktivity',
      zavritFiltry: 'Zavřít filtry',
      zitra: 'Zítra',
      zkopirovano: 'Zkopírováno',
      zkopirujOdkazRucne: 'Zkopíruj odkaz ručně',
      zkusitZnovu: 'Zkusit znovu',
      zmenitBezpecnostniKod: 'Změnit bezpečnostní kód',
      zmenitBezpecnostniKodStary: 'Změnit bezpečnostní kód? Starý odkaz přestane fungovat a kalendáře bude nutné přidat znovu.',
      zmeskany: 'Zmeškaný',
      zobrazeni: 'Zobrazení',
      zobrazitZrusene: 'Zobrazit zrušené',
      zrusit: 'Zrušit',
    },
    dotaznikCteni: {
      definiceDotaznikuSeNenacetla: 'Definice dotazníku se nenačetla.',
      hodnotuSeNepodariloNacist: 'Hodnotu se nepodařilo načíst.',
      rodneCisloACislaDokladu: 'Rodné číslo a čísla dokladů jsou skryté. Zobrazení je vědomý krok a po 20 sekundách se hodnota zase schová.',
      skryt: 'Skrýt',
      zobraziSeNa20Sekund: 'Zobrazí se na 20 sekund',
      zobrazit: 'Zobrazit',
    },
    editableGoals: {
      akontace: 'Akontace %',
      akontace2: 'Akontace',
      akontaceSplnenaNa: 'Akontace splněna na',
      budouciNavyseniVkladu: 'Budoucí navýšení vkladů',
      castJeVProduktech: 'část je v produktech',
      cil: 'Cíl',
      cilSplnen: 'cíl splněn',
      dleProfiluVolnaHotovost: '(dle profilu). Volná hotovost',
      dobaSplaceniLet: 'Doba splácení (let)',
      financniNezavislostRenta: 'Finanční nezávislost — renta',
      horizont: 'horizont',
      horizontLet: 'Horizont (let)',
      hypotecniCil: 'Hypoteční cíl',
      jakNasetritAkontaci: 'Jak našetřit akontaci',
      jednorazove: 'Jednorázově',
      jednorazoveDnes: 'Jednorázově dnes',
      kombinace: 'Kombinace',
      ktereSeMusiZrusit: 'které se musí zrušit (často nevýhodné). Lepší investovat',
      let: 'let',
      letDosahnes: 'let dosáhneš',
      letDriv: 'let dřív!',
      letDvojtecka: 'let:',
      letPrida: 'let přidá',
      mesicne: 'Měsíčně',
      navrhniPravidelne: 'Navrhni pravidelně',
      navrhniZMajetku: 'Navrhni z majetku',
      nutnoRusitZvazPravidelne: 'nutno rušit. Zvaž pravidelně.',
      o: 'o',
      pocitanoSVynosem: 'Počítáno s výnosem',
      potrebnyKapital: 'Potřebný kapitál',
      pravidelne: 'Pravidelně',
      pravidelne2: 'pravidelně',
      pridatNavyseniNapr: 'Přidat navýšení (např. po zvýšení platu)',
      realne: '% reálně',
      renta: 'renta',
      splatka: 'splátka',
      splneni: 'Splnění',
      splneni2: 'splnění',
      tolikVolneHotovostiKlient: 'Tolik volné hotovosti klient nemá',
      uver: 'úvěr',
      volneMaKlientJen: 'Volně má klient jen',
      za: 'za',
      zaLet: 'Za (let)',
      zaVelke: 'Za',
      zadneCileZAnalyzy: 'Žádné cíle z analýzy. Doplň cíle v analýze a vrať se sem doladit, jak se splní.',
      zamcenoVProduktech: 'zamčeno v produktech',
      zbytekJeVeStavebku: '— zbytek je ve stavebku/penzijku',
    },
    finMatematikaPage: {
      cerpaniNekonecna: '♾️ nekonečná',
      chartRok: 'Rok',
      dobaCerpani: 'Doba čerpání',
      dobaCerpaniRenty: 'Doba čerpání renty',
      dobaSplaceni: 'Doba splácení',
      dopocitatPole: 'Dopočítat toto pole',
      financniMatematika: 'Finanční matematika',
      frekvenceUroku: 'Frekvence připisování úroku',
      hodnotaInvestice: 'Hodnota investice',
      jednorazovyVklad: 'Jednorázový vklad',
      jednotkaLet: 'let',
      kartaCelkemVlozite: 'Celkem vložíte',
      vstupniPoplatek: 'Vstupní poplatek z cílové částky',
      kartaPoplatek: 'Poplatek',
      kartaCilovaCastka: 'Cílová částka',
      vetaPoplatek: 'Z cílové částky {cilova} je vstupní poplatek {poplatek} ({pct} %), strhne se hned na začátku.',
      dipPrepinac: 'Daňový odpočet DIP',
      dipBez: 'Bez DIP',
      dipS: 'S DIP',
      kartaStatDip: 'Stát vrátí (DIP)',
      kartaSDip: 'S DIP celkem',
      vetaDip: 'S DIP stát za {roky} let vrátí na dani {stat} (15 % z vkladů, max 7 200 Kč ročně). Reinvestováno naroste na {hodnota}, z toho {vynos} výnos. Podmínka: výběr nejdřív v 60 letech a po 10 letech smlouvy, jinak se odpočet dodaní.',
      rozpisPoLetech: 'Rozpis po letech',
      thSplaceno: 'Splaceno',
      thUrok: 'Úrok',
      thJistina: 'Jistina',
      thZustatek: 'Zůstatek',
      thVlozeno: 'Vloženo celkem',
      thVynos: 'Výnos celkem',
      thHodnota: 'Hodnota',
      thVyplaceno: 'Vyplaceno celkem',
      thCelkem: 'Celkem',
      tiskZadani: 'Zadání',
      tiskVysledek: 'Výsledek',
      tiskPripraveno: 'Připraveno {datum}',
      upozorneniUver: 'Modelový výpočet anuitní splátky při neměnné sazbě po celou dobu. Skutečnou splátku, RPSN a poplatky určí nabídka banky.',
      upozorneniInvestice: 'Modelace s pevným ročním zhodnocením, ne záruka. Skutečné výnosy kolísají a mohou být i záporné; minulé ani modelové výnosy nezaručují budoucí.',
      upozorneniRenta: 'Modelace čerpání s pevným zhodnocením, ne záruka. Skutečné výnosy kolísají, renta může vydržet kratší dobu.',
      kartaCelkemZaplatite: 'Celkem zaplatíte',
      kartaDoba: 'Doba',
      kartaDobaCerpani: 'Doba čerpání',
      kartaJednorazovyVklad: 'Jednorázový vklad',
      kartaKonecnaHodnota: 'Konečná hodnota',
      kartaMesicniRenta: 'Měsíční renta',
      kartaMesicniSplatka: 'Měsíční splátka',
      kartaPocatecniHodnota: 'Počáteční hodnota',
      kartaPravidelnaMes: 'Pravidelná měs.',
      kartaRentaCelkem: 'Renta celkem',
      kartaSplatnost: 'Splatnost',
      kartaUrokPa: 'Úrok p.a.',
      kartaVyseUveru: 'Výše úvěru',
      kartaZTohoUroky: 'Z toho úroky',
      kartaZhodnoceniPa: 'Zhodnocení p.a.',
      konecnaHodnotaInvestice: 'Konečná hodnota investice',
      mesZkratka: 'měs',
      mesicniSplatka: 'Měsíční splátka',
      pocatecniHodnota: 'Počáteční hodnota',
      pravidelnaMesInvestice: 'Pravidelná měs. investice',
      splatnost: 'Splatnost',
      urokovaSazba: 'Úroková sazba',
      vetaInvestice: 'Z {vlozeno} vložených uděláte {konec} — to je {navic} navíc díky složenému úročení. Čas dělá práci za vás.',
      vetaRenta: '{kapital} vám vyplácí {renta}/{mes} po {roky} {rok} (celkem {celkem}).',
      vetaRentaNekonecna: '{kapital} při {sazba} % vynáší víc, než kolik čerpáte — renta je NEKONEČNÁ. To je finanční nezávislost. 🎉',
      vetaUver: 'Úvěr {castka} na {roky} {rok} při {sazba} % — celkem zaplatíte {celkem}, z toho {uroky} jsou úroky.',
      vlozenoCelkem: 'Vloženo celkem',
      vyseMesicniRenty: 'Výše měsíční renty',
      vyseUveru: 'Výše úvěru',
      vyvojHodnotyInvestice: 'Vývoj hodnoty investice',
      vyvojRentyCerpaniKapitalu: 'Vývoj renty (čerpání kapitálu)',
      vyvojZustatkuUveru: 'Vývoj zůstatku úvěru',
      zhodnoceniPA: 'Zhodnocení p.a.',
      zhodnoceniRentyPA: 'Zhodnocení renty p.a.',
      zustatek: 'Zůstatek',
      zustatekUveru: 'Zůstatek úvěru',
    },
    funnelCalc: {
      casPrida: 'Čas přidá ',
      cil: 'cíl',
      coJsiVlozil: 'Co jsi vložil',
      investiceNeseRizikoHodnota: 'Investice nese riziko — hodnota kolísá a může klesnout; minulé výnosy nezaručují budoucí.',
      jakByToRostlo: 'Jak by to rostlo v čase',
      mesicnePotrebujesOdkladat: 'Měsíčně potřebuješ odkládat',
      orientacniVypocetZeSlozeneho: 'Orientační výpočet ze složeného úročení.',
      potrebnyKapitalNaRentu: 'Potřebný kapitál na rentu: ',
      spocitejSiToNazivo: 'Spočítej si to — naživo',
    },
    globalSearch: {
      beplanGlobalniHledani: 'Beplan · globální hledání',
      chytreHledani: 'Chytré hledání',
      hledat: 'Hledat…',
      hledatCmdCtrlK: 'Hledat (Cmd/Ctrl + K)',
      hledatKlientaUkolHashtag: 'Hledat klienta, úkol, #hashtag, telefon…',
      navigaceOtevritEscZavrit: '↑↓ navigace · ↵ otevřít · ESC zavřít',
      otevrit: 'Otevřít',
      ukoly: 'Úkoly',
      zadneVysledkyPro: 'Žádné výsledky pro',
      zavrit: 'Zavřít',
    },
    globalTabBar: {
      hledat: 'Hledat',
      nastaveni: 'Nastavení',
      odhlasit: 'Odhlásit',
      zavritVse: 'Zavřít vše',
      zavritVsechnyZalozky: 'Zavřít všechny záložky',
    },
    gmailConnectCard: {
      gmailOdpojen: 'Gmail odpojen',
      gmailPropojen: 'Gmail propojen',
      nacitamStavGmailPropojeni: 'Načítám stav Gmail propojení…',
      odpojeniSelhalo: 'Odpojení selhalo',
      odpojit: 'Odpojit',
      opravduOdpojitGmailNebudes: 'Opravdu odpojit Gmail? Nebudeš moct posílat emaily přímo z CRM.',
      pripojSvujGmail: 'Připoj svůj Gmail',
      pripojitGmail: 'Připojit Gmail',
      propojeniGmailuZatimNeni: 'Propojení Gmailu zatím není zapnuté',
      serverNeodpovedelNevimeJestli: 'Server neodpověděl. Nevíme, jestli je Gmail připojený — zkus obnovit stránku.',
      stavEMailuSe: 'Stav e-mailu se nepodařilo zjistit',
    },
    gmailMessageDetail: {
      komu: 'Komu',
      kopie: 'Kopie',
      nepodariloSeNacistEmail: 'Nepodařilo se načíst email',
      odpovedetAi: 'Odpovědět AI',
      otevritVGmailu: 'Otevřít v Gmailu',
      textZpravyTadyNezobrazime: 'Text zprávy tady nezobrazíme',
    },
    hypotecniPipelinePage: {
      excelLikePrehledVsech: 'Excel-like přehled všech otevřených hypoték a refinancování · klik na řádek otevře obchodní případ',
      hypotekaZalozena: 'Hypotéka založena',
      kanbanPohledPouzivaObchodni: 'Kanban pohled používá Obchodní nástěnka — pro hypotéky doporučujeme Tabulkový pohled. ',
      klikNaRadekDetail: 'Klik na řádek → detail obchodního případu',
      nelzeNacistHypoteky: 'Nelze načíst hypotéky',
      otevritObchodniNastenku: 'Otevřít Obchodní nástěnku ›',
      pripraveno: 'připraveno',
      tabulka: 'Tabulka',
      tentoTyden: 'Tento týden',
      urgentni: 'urgentní',
      uverovaPipeline: 'Úvěrová pipeline',
      vLimitu: 'v limitu',
      vReseni: 'v řešení',
      vse: 'Vše',
      vyzadujeAkci: 'Vyžaduje akci',
      zadneHypotekyNeodpovidajiFiltru: 'Žádné hypotéky neodpovídají filtru.',
    },
    investicniStrategiePage: {
      celkemVlozi: 'Celkem vloží',
      cenaNecinnosti: 'Cena nečinnosti',
      citat: '„Kolik je dost? Tolik, aby výnos pokryl vaše výdaje. Pak jste finančně nezávislí — peníze pracují za vás.“',
      coSiKlientOdnese: 'Co si klient odnese',
      doba: 'Doba',
      hodnotaLegenda: 'Hodnota',
      inflaceNiciHotovost: 'Inflace ničí hotovost',
      inflaceText: 'Peníze v hotovosti tiše ztrácejí hodnotu. Za {roky} {rok} při 3% inflaci z {vlozeno} zbude kupní síla jen ~{realne}. Nedělat nic je taky rozhodnutí — jen to nejdražší.',
      investicniStrategie: 'Investiční strategie',
      kapital: 'Kapitál',
      kapitalZustava: '…a kapitál {kapital} zůstává nedotčený pro děti.',
      kino: 'Kino',
      kinoTooltip: 'Spustit kino prezentaci',
      klientTip: 'Nezáleží ani tak na tom „kolik“ — důležité je začít a nechat čas pracovat.',
      mes: 'měs',
      mesSlash: '/měs',
      mesicniVklad: 'Měsíční vklad',
      naKonciMa: 'Na konci má',
      nekonecnaMesicniRenta: 'Nekonečná měsíční renta ({sazba} p.a.)',
      nekonecnaRentaSazba: 'Nekonečná renta ({sazba} p.a.)',
      nevymyslimeNicNovehoKopirujeme: 'Nevymýšlíme nic nového — kopírujeme nejlepší',
      odklada: 'Odkládá',
      odkladaHodnota: '{castka}/{mes} × {roky} {rok}',
      podnadpisA: 'Ukažte klientovi, že jeho plán stojí na strategiích, které léta fungují největším fondům světa. Klik na strategii → spočítáte ji na 100 letech reálných dat. Nebo spusťte ',
      podnadpisB: ' s interaktivní mapou světa.',
      podnadpisTucne: 'kino prezentaci',
      prezentovatKlientovi: 'Prezentovat klientovi',
      procInvestovat: 'Proč investovat',
      procNedojde: 'Proč renta nikdy nedojde',
      rentaMilion: 'každý milion = ~{naMilion} {symbol} měsíčně navždy',
      rentaNavzdy: 'Renta navždy',
      rentaText: 'Z {kapital} při {sazba} ročně máte rentu {renta}/{mes} — navždy a kapitál zůstává. To je finanční nezávislost.',
      rentaVetaA: 'Když si vybíráte jen ',
      rentaVetaB: ' (ne podstatu), kapitál se nikdy nevyčerpá. Při {sazba} ročně ',
      rentaVetaC: ' — a milion vám pořád zůstává.',
      rentaVynos: 'výnos',
      silaSlozeneho: 'Síla složeného úročení',
      spocitat: 'Spočítat na 100 letech',
      svoboda: 'Svoboda',
      urokText: 'Za {roky} {rok} vaše peníze samy vydělají {rust}. Čím dřív začnete, tím déle pracuje složené úročení za vás.',
      urokZUroku: 'Úrok z úroku',
      vlozenoLegenda: 'Vloženo',
      vynosPa: 'Výnos p.a.',
      zTohoVydelaly: 'Z toho vydělaly samy peníze',
      zadejteVklad: 'Zadejte vklad — ukažte klientovi jeho růst',
    },
    klientiPage: {
      aresNapoviADoplni: 'ARES napoví a doplní',
      chybaPriUkladani: 'Chyba při ukládání: ',
      coMaUMe: 'Co má u mě',
      coVlastni: 'Co vlastní',
      dnes: 'dnes',
      jmeno: 'Jméno',
      jmenoJePovinne: 'Jméno je povinné',
      jmenoNazev: 'Jméno / název',
      karty: 'Karty',
      kategorie: 'Kategorie',
      kategorieKlienta: 'Kategorie klienta',
      klientPridan: 'Klient přidán',
      klientTrvaleSmazan: 'Klient trvale smazán',
      klientVracenDoPipeline: 'Klient vrácen do pipeline',
      kos: 'Koš',
      kosJePrazdny: 'Koš je prázdný',
      kosOdstraneniKlientiKdykoli: 'Koš — odstranění klienti; kdykoli je lze obnovit',
      kosSeNepodariloNacist: 'Koš se nepodařilo načíst',
      moznaDuplicita: 'Možná duplicita',
      moznaDuplicitaPotvrdZe: 'Možná duplicita — potvrď, že chceš přesto přidat',
      naborKandidat: 'Nábor — kandidát',
      nacitamKos: 'Načítám koš…',
      nactenoZAres: 'Načteno z ARES',
      napisteJmenoNeboNazev: 'Napište jméno nebo název klienta…',
      nepovedloSeUlozit: 'Nepovedlo se uložit',
      neznamaChyba: 'neznámá chyba',
      obnoveniSeNezdarilo: 'Obnovení se nezdařilo',
      obnovit: 'Obnovit',
      odlozenDoSkupinyBez: 'odložen do skupiny bez zájmu',
      odlozitZatimBezZajmu: 'Odložit — zatím bez zájmu',
      odstraneniKlientiSeObjevi: 'Odstranění klienti se objeví tady — kdykoli je můžeš obnovit zpět do pipeline.',
      otevrit: '→ otevřít',
      poznamkaPriZakladani: 'Poznámka při zakládání',
      pridejKlientaVCrm: 'Přidej klienta v CRM Pipeline.',
      prijmeni: 'Příjmení',
      resetovatFiltry: 'Resetovat filtry',
      smazaniSeNezdarilo: 'Smazání se nezdařilo: ',
      smazatNavzdy: 'Smazat navždy',
      tabulka: 'Tabulka',
      telefon: 'Telefon',
      titoKlientiSeVelmi: 'Tito klienti se velmi podobají — otevři některého z nich, nebo potvrď, že chceš opravdu vytvořit nový záznam.',
      trvaToDlouhoKlikni: 'Trvá to dlouho? Klikni pro obnovu',
      trvaleSmazatNevratne: 'Trvale smazat — nevratné',
      typologie: 'Typologie',
      ukladam: 'Ukládám…',
      ulozit: 'Uložit',
      ulozitAOtevrit: 'Uložit a otevřít',
      vKosiKlientiNejsou: 'v koši · klienti nejsou smazaní — kdykoli je obnovíš',
      vKosiOd: 'v koši od',
      vimZeToNeni: 'Vím, že to není duplicita — chci založit nový záznam',
      volat: 'Volat',
      vratitDoPipeline: 'Vrátit do pipeline',
      vratitKlientaZpetDo: 'Vrátit klienta zpět do pipeline',
      vse: 'Vše',
      vymazat: 'Vymazat',
      vymazatVsechnyPokrocileFiltry: '× Vymazat všechny pokročilé filtry',
      zadniKlienti: 'Žádní klienti.',
      zadnyKlientNeodpovidaHledani: 'Žádný klient neodpovídá hledání.',
      zadnyKlientNeodpovidaKombinaci: 'Žádný klient neodpovídá kombinaci filtrů. Zkus zúžit výběr nebo filtry resetovat.',
      zdroj: 'Zdroj',
      zpetNaKlienty: 'Zpět na klienty',
    },
    leadgenCalculatorPremium: {
      orientacniVypocetPresnouNabidku: '* Orientační výpočet. Přesnou nabídku Vám připravím po krátké konzultaci.',
    },
    newDealModal: {
      klientaSeNepodariloZalozit: 'Klienta se nepodařilo založit',
      krokAnalyza: 'Analýza',
      krokCerpani: 'Čerpání',
      krokPodpis: 'Podpis',
      krokProces: 'Proces',
      napisNejdrivJmenoNoveho: 'Napiš nejdřív jméno nového klienta do vyhledávání',
      pravdepodobnostUzavreni: 'Pravděpodobnost uzavření',
      ulozitAOtevrit: 'Uložit a otevřít',
      zadejNazevObchodnihoPripadu: 'Zadej název obchodního případu',
    },
    notFoundPage: {
      strankaNenalezena: 'Stránka nenalezena',
      tatoAdresaNeexistujeNebo: 'Tato adresa neexistuje nebo se přesunula.',
      zpetNaHlavniStranku: 'Zpět na hlavní stránku',
    },
    notesPanel: {
      klikneteAPistePrazdny: 'Klikněte a pište — prázdný papír, který se uloží sám.',
      neulozenoUlozisteProhlizeceJe: 'Neuloženo — úložiště prohlížeče je plné',
      sTimtoStitkemNic: 'S tímto štítkem nic není.',
      ulozeno: 'Uloženo',
      vse: 'Vše',
      zatimZadnaPoznamka: 'Zatím žádná poznámka',
    },
    notificationCenter: {
      celyDen: 'celý den',
      pripominkySeNepodariloNacist: 'Připomínky se nepodařilo načíst.',
      tohleNeniStavMas: 'Tohle NENÍ stav „máš čisto“ — data se nenačetla.',
    },
    obchodyPage: {
      akce: 'Akce',
      akciSeNepodariloDokoncit: 'Akci se nepodařilo dokončit',
      archivSoftDelete: 'Archiv · Soft-delete',
      cekaNaVyplatu: 'čeká na výplatu',
      cekamNaProvizi: 'Čekám na provizi',
      duvod: 'Důvod',
      faze: 'Fáze',
      kategorieKlienta: 'Kategorie klienta',
      klient: 'Klient',
      klientObchod: 'Klient · Obchod',
      n1SchuzkaPredstaveni: '1. schůzka — představení',
      nacitamOdlozeneObchody: 'Načítám odložené obchody…',
      nelzeNacistArchiv: 'Nelze načíst archiv',
      nelzePresunoutObchod: 'Nelze přesunout obchod',
      nelzeReaktivovat: 'Nelze reaktivovat',
      nelzeSmazat: 'Nelze smazat',
      obchod: 'Obchod',
      obchodVytvoren: 'Obchod vytvořen',
      odlozene: 'Odložené',
      odlozeneObchodySoftDelete: 'Odložené obchody — soft-delete archiv, ze kterého se dají obchody znovu reaktivovat',
      odlozeno: 'Odloženo',
      odlozenychObchoduMuzesKdykoliv: 'odložených obchodů — můžeš kdykoliv reaktivovat',
      otevritSlozku: 'Otevřít složku',
      otevritSlozkuKlienta: 'Otevřít složku klienta',
      planUzavreni: 'Plán — uzavření',
      prejitNaSloupec: 'Přejít na sloupec',
      presunutoDo: 'Přesunuto do',
      pretahnoutObchodSem: 'Přetáhnout obchod sem',
      pridatAktivitu: 'Přidat aktivitu',
      produkt: 'Produkt',
      prohra: 'Prohra',
      prohraUzavrenoK: 'Prohra — uzavřeno k',
      reaktivovat: 'Reaktivovat',
      spustitPrezentaciFinancnihoPlanu: 'Spustit prezentaci finančního plánu — vede klienta k podpisu',
      spustitPrezentaciPro1: 'Spustit prezentaci pro 1. schůzku — vede klienta k finanční analýze',
      trvaleSmazatZDatabaze: 'Trvale smazat z databáze (nevratné)',
      typ: 'Typ',
      vazena: 'Vážená:',
      vratitObchodDoAktivni: 'Vrátit obchod do aktivní pipeline',
      vyhraSmlouva: 'Výhra → Smlouva',
      vyhraUzavrenoK: 'Výhra — uzavřeno k',
      zadneObchody: 'Žádné obchody',
      zadneOdlozeneObchody: 'Žádné odložené obchody',
      zruseno: 'Zrušeno',
      zrusenoK: 'Zrušeno k',
    },
    onePagePlanPage: {
      dnesSPlanemAz: 'dnes · s plánem až',
      dobryDenPosilamVas: 'Dobrý den, posílám váš finanční plán. Mrkněte a kdyžtak se ozvěte.',
      financniNezavislost: 'Finanční nezávislost',
      financniPlan: 'Finanční plán',
      financniPlanNaJedne: 'Finanční plán na jedné straně',
      financniZdravi: 'Finanční zdraví',
      financniZdraviDnesS: 'Finanční zdraví (dnes → s plánem)',
      hypotekouSplatka: 'hypotékou · splátka',
      jednorazove: 'jednorázově',
      kapital: 'kapitál',
      kapitalProRentu: 'Kapitál pro rentu',
      klesajiciCastkyKryjeDeficit: 'klesající částky · kryje deficit rodiny, dluhy i cíle',
      mesicneNaCileA: 'Měsíčně na cíle a rentu',
      mesicneProCile: 'Měsíčně pro cíle (odsouhlaseno)',
      naAnalyzu: 'Na analýzu',
      naplneniFinancniNezavislosti: 'Naplnění finanční nezávislosti',
      naplneno: 'naplněno',
      narativCislaVDnesnichCenach: 'Čísla jsou v dnešních cenách. Reálné výnosy nad inflací: akcie {akcie} %, dluhopisy {dluhopisy} %, hotovost {cash} %; průměrný výnos akumulace ≈ {prumer} % ročně. Rentu čerpáme {renta} % ročně z kapitálu. Minulé výnosy nezaručují budoucí.',
      narativPlanNaJednuStranu: 'Finanční plán na jednu stranu — vaše proč, tři kroky na příštích 90 dní a jak naplníte cíle i rentu.',
      navrhReseni: 'Návrh řešení',
      nepodariloSeNacistData: 'Nepodařilo se načíst data',
      oLetDrive: ' · o {n} let dříve',
      ochranaPrijmuVarianta: 'Ochrana příjmů ({varianta})',
      planJeVDnesnich: 'Plán je v dnešních cenách. Reálné výnosy nad inflací: akcie {akcie} %, dluhopisy {dluhopisy} %, hotovost {cash} %; průměrný výnos akumulace ≈ {prumer} % ročně. Renta se čerpá {renta} % ročně z kapitálu. Doporučení závisí na poskytnutých údajích; aktualizujeme každé ~3 roky nebo při změně situace. Minulé výnosy nezaručují budoucí.',
      prijmyRodiny: 'Příjmy rodiny',
      pripravujiPlan: 'Připravuji plán…',
      procToVsechnoDelame: 'Proč to všechno děláme — vaše slova',
      rentaFinancniNezavislost: 'Renta (finanční nezávislost)',
      vDnesnichCenachRealne: 'v dnešních cenách (reálně, nad inflací)',
      vasPoradce: 'Váš poradce',
      vaseBilance: 'Vaše bilance',
      vaseCileAJak: 'Vaše cíle a jak je naplníme',
      volnyCashFlow: 'Volný cash-flow',
      vydajeSplatky: 'Výdaje + splátky',
      zkontrolujtePripojeni: 'Zkontrolujte připojení a zkuste to znovu.',
      zkusitZnovu: 'Zkusit znovu',
    },
    pipelineFunnelCompact: {
      bjVPipeline: 'BJ v pipeline',
      pipelinePoFazich: 'Pipeline po fázích',
      vymazatFiltr: 'Vymazat filtr',
    },
    planPrehled: {
      azPoCilovemDatu: ' — až po cílovém datu',
      rentaOdVekuPenzijka: ' — do renty od {vek} let: renta +{castka}',
      bezCerpaniZdroju: 'bez čerpání zdrojů',
      cerpani: 'Čerpání',
      doraziV: 'dorazí v ',
      finMajetek: 'Fin. majetek',
      investice: 'Investice',
      jednorazove: 'jednorázově',
      let: 'let',
      letech: ' letech',
      likvidni: 'Likvidní',
      likvidni2: 'likvidní',
      mesice: 'měsíce',
      nefinancni: 'Nefinanční',
      nezapojeno: 'Nezapojeno',
      od: 'od',
      ostatniUcty: 'Ostatní účty',
      penzijkoRenta: 'Penzijko → renta',
      poPlanu: 'Po plánu:',
      pravidelne: 'pravidelně',
      prebytek: 'Přebytek',
      precerpanoO: 'přečerpáno o',
      precerpanoTolikKlient: '— přečerpáno, tolik klient nemá',
      prubeznyPrehled: 'Průběžný přehled',
      stavebko: 'Stavebko',
      stavebko2: 'stavebko',
      volnyPrebytek: 'volný přebytek',
      za: 'za',
      zbyva: 'zbývá',
      zbyvaLikvidni: 'zbývá likvidní',
    },
    planPrezentacePage: {
      abysteDosahliSvychCilu: '„…abyste dosáhl svých cílů **co nejbezpečnější cestou**.“',
      abysteNemuselRusit: '„Abyste nemusel rušit strategické investice se ztrátou kvůli nečekaným výdajům. Jde na spořicí účet (~3 %) — tady **nejde o zbohatnutí, jde o klid**. Šest výplat v záloze = nic vám nesáhne na plán.“',
      akcie: 'akcie',
      akciePodilyVNejvetsich: '„Akcie = podíly v největších firmách světa. Krátkodobě kolísají, ale jsou **jediné, co dlouhodobě spolehlivě poráží inflaci** — a peníze na účtu mezitím jistě ztrácí kupní sílu.“',
      aleJePotrebaPro: '„…ale je potřeba pro to něco udělat.“',
      anoCimZacneme: 'Ano — čím začneme?',
      barva: 'barva',
      bezJednorazovehoVkladu: 'bez jednorázového vkladu',
      bezPlanuUcetInflace: 'Bez plánu (účet + inflace)',
      chtelJsteVeta: 'Chtěl jste **{castka}** za **{roky}**.',
      chtelJsteVetaBezTerminu: 'Chtěl jste **{castka}**. Termín jsme si zatím neřekli.',
      chtelJsteVetaHned: 'Chtěl jste **{castka}** — a to **hned**.',
      chybi: 'chybí',
      chybiCastka: 'chybí {castka}',
      cilPokryt: '✓ cíl pokryt',
      ciluFinancnePodlozeno: 'cílů finančně podloženo',
      coDnesPlanOhrozuje: 'Co dnes plán ohrožuje',
      coToCelkemStoji: 'Co to celkem stojí',
      coZaToMate: 'Co za to máte',
      dalsiZpetNamitkyEsc: '→ další · ← zpět · ? námitky · Esc konec',
      davaVamToSmysl: 'Dává vám to **smysl?**',
      deficitBezOchrany: 'Deficit bez ochrany',
      den: '/den',
      dluhopisy: 'dluhopisy',
      dnesSiVymenimeRole: 'Dnes si vyměníme role.',
      doRokaBudeteMit: 'Do roka budete mít',
      dobraZpravaMatePlan: 'Dobrá zpráva: **máte plán.**',
      dobreALevneZajistit: 'Dobře a levně zajistit majetek a budoucí příjmy',
      domluvenoCoKdoPripravi: 'Domluveno — co kdo připraví',
      doplnitLikvidniRezervu: 'Doplnit likvidní rezervu',
      dotazySiProsimNechte: '„Dotazy si prosím nechte na závěr — nejdřív chci, abyste viděl celkový obrázek, celou strategii.“',
      druhaBezpecnejsiCesta: 'A druhá je ještě lepší: **půjdeme bezpečnější cestou.**',
      druhaNezavislostDrive: 'A druhá je ještě lepší: **nezávislost o {roky} dříve.**',
      dveBudoucnostiVyberteSi: 'Dvě budoucnosti — vyberte si',
      financniMajetekCelkem: 'Finanční majetek celkem',
      glideRokTooltip: 'rok {rok}: akcie {akcie} % · dluhopisy {dluhopisy} % · hotovost {hotovost} %',
      hotovost: 'hotovost',
      iVNejhorsimObdobi: 'I v **nejhorším** ze {pocet} historických období skončil plán na **{vysledek}** — pořád {kde} vloženými {vlozeno}. __Čas rozhoduje, ne odhad trhu.__',
      invalidita: 'invalidita',
      investice: 'investice',
      jaPoradce: 'Já (poradce)',
      jedenZOsmiInvalidita: 'Dlouhodobá invalidita — kryjeme **výplatu, ne smrt**',
      jednorazoveOdkud: 'Jednorázově — odkud',
      jenVicNavic: 'Jen **{vklad}** navíc → za {roky} **{kdobru}** k dobru. To dělá čas, ne vy.',
      kazdyCilSiVezme: 'Každý cíl si vezme svůj díl — a **vidíte, co zbude**.',
      kazdyMilionRentaMesicne: '„každý milion = {naMilion} měsíčně, navždy“',
      kdeJsteDnesStartovni: 'Kde jste dnes — startovní čára',
      kdybysteInvestovalPred20: '„Kdybyste investoval před 20 lety…“ — 100 let historie',
      kdybysteTenhlePlanJel: 'Kdybyste tenhle plán jel **{roky}** kdykoli za posledních 100 let…',
      kdybysteTohleInvestoval: 'Kdybyste tohle investoval posledních **{roky}**, podle **reálných dat** dnes máte:',
      krok_bezVsSPlanem: 'BEZ vs. S PLÁNEM',
      krok_cile: 'CÍLE',
      krok_coDelateDobre: 'CO DĚLÁTE DOBŘE',
      krok_dveZpravy: 'DVĚ ZPRÁVY',
      krok_kdeJsteDnes: 'KDE JSTE DNES',
      krok_kroky: 'KROKY',
      krok_motivace: 'MOTIVACE',
      krok_proc: 'PROČ',
      krok_rezerva: 'REZERVA',
      krok_rizika: 'RIZIKA',
      krok_rozpocet: 'ROZPOČET',
      krok_silaCasu: 'SÍLA ČASU',
      krok_souhrn: 'SOUHRN',
      krok_uvod: 'ÚVOD',
      krok_vaseCesta: 'VAŠE CESTA',
      krok_zaver: 'ZÁVĚR',
      krytiInvalidita: 'Invalidita',
      krytiInvaliditaProc: 'dlouhodobý výpadek příjmu, který rezerva nepokryje — a výdaje navíc rostou',
      krytiOdskodne: 'Denní odškodné úrazem',
      krytiOdskodneProc: 'úraz zastaví příjem od 1. dne — bez karence',
      krytiPn: 'Pracovní neschopnost',
      krytiPnProc: 'nemocenská kryje jen část příjmu; dávka dorovná rozpočet od {mesic}. měsíce',
      krytiSmrt: 'Smrt',
      krytiSmrtProc: 'nahradí příjem rodině — výdaje, splátky i cíle; klesající částka = levněji',
      krytiTrvaleHodnota: '{castka} s progresí',
      krytiTrvaleNasledky: 'Trvalé následky úrazu',
      krytiTrvaleProc: 'vážnější následky = vyšší plnění (v našem modelu nejvýš 2,8× částky — u pojišťoven se liší)',
      mamProVasDve: 'Mám pro vás dvě zprávy',
      mate: 'Máte:',
      mateZCehoStavet: 'máte z čeho stavět — to je obrovská výhoda',
      mesicneNaStejnouRentu: 'měsíčně na stejnou rentu',
      mezernik: 'MEZERNÍK',
      minuleJsemSePtal: '„Minule jsem se ptal já a vy jste povídal — dnes budu mluvit já.“',
      motivAplikace: 'Motiv aplikace',
      motorPlanu: 'To je motor plánu — **{rok}/rok**, se kterým budeme dál pracovat. Nic navíc.',
      moznaJeTechCisel: 'Možná je těch čísel moc — ale je to jednoduché',
      naCileARentu: ' na cíle a rentu',
      naNavrh: 'Na návrh',
      naZacatkuJsteRekl: '„Na začátku jste řekl, že nejdůležitější je pro vás **„{hodnota}“** — a přesně tohle je plán, jak to splnit. Pokud dává smysl, pojďme se domluvit, čím začneme.“',
      nadPrebytek: 'Volné cash flow máte {prebytek} měsíčně — plán je o {rozdil} vyšší. Projdeme spolu, odkud ten rozdíl vzít.',
      nadVlozenymi: 'nad',
      namitka1: '„Musím si to rozmyslet.“',
      namitka1Odpoved: '„Rozumím — co konkrétně vám v hlavě leží? Čísla, pojištění, nebo částka? Pojďme to vyřešit teď, ať nemusíte přemýšlet sám.“ (Zjisti SKUTEČNOU námitku — „rozmyslet“ je zástěrka.)',
      namitka2: '„Proberu to s manželkou/manželem.“',
      namitka2Odpoved: '„Naprosto správně — tohle je rodinné rozhodnutí. Pojďme rovnou domluvit schůzku ve třech, ať to partnerovi vysvětlím já a vy nemusíte obhajovat čísla, která nejsou vaše.“ (Nikdy nenech klienta prodávat za tebe.)',
      namitka3: '„Teď na to nemám peníze.“',
      namitka3Odpoved: '„Plán nestojí nic navíc — pracuje jen s přebytkem, který jste mi sám odsouhlasil. A pokud je menší, začneme menší částkou. Kdy je lepší začít: dnes, nebo za 5 let o 40 % dráž?“ (Ukaž slide Cena za čekání.)',
      namitka4: '„Pojištění je vyhazování peněz.“',
      namitka4Odpoved: '„Souhlasím — špatné pojištění ano. Proto rušíme drahé smlouvy a necháváme jen ochranu výplaty, aby deficit v rozpočtu nikdy nenastal. Je to padák — neplatíte za pád, platíte za přežití.“ (Vrať se na slide Rizika.)',
      namitka5: '„Akcie jsou hazard / bojím se krize.“',
      namitka5Odpoved: '„Krátkodobě máte pravdu — proto má plán rezervu a brzdu. Ale ukážu vám 100 let dat: každá krize skončila a trh se vrátil. Hazard je nechat peníze ležet a jistě je dát inflaci.“ (Otevři historickou kalkulačku — let krizemi.)',
      nasporenoZaLet: 'Naspořeno za {roky}',
      navrhKrytiJeV: 'návrh krytí je v analýze',
      nejdrivToCoUz: 'Nejdřív to, co už děláte dobře',
      nejdrivVyplnAnalyzu: 'Nejdřív vyplň analýzu',
      nemateZadneSpatneDluhy: 'Nemáte žádné špatné dluhy',
      nepojisteno: 'Nepojištěno: {co}',
      nesplaceneZavazky: 'Nesplacené závazky',
      neuplnaRezerva: 'Neúplná rezerva',
      nezSePustimeDo: '„Než se pustíme do zajišťování cílů, doporučuji ochránit váš **majetek** a především **budoucí příjmy**.“',
      nezUkazuPlan: 'Než ukážu plán, ukážu **odkud startujeme**.',
      nezZacnemeInvestovatOchranime: 'Než začneme investovat — ochráníme vás',
      nicJsmeSiNevymysleli: '„Nic jsme si nevymysleli — začali jsme s tím, co máte dnes, a rozdělili to mezi vaše cíle. Když na posledním řádku svítí nula, znamená to, že každá vaše koruna i každý měsíční přebytek mají svůj úkol.“',
      nikdyNebudeteMitVice: '„Nikdy nebudete mít **více času než právě dnes**. Každé odkládání je finančně nevýhodné.“',
      oMinMene: 'O **{vklad}** míň → za {roky} **{mene}** méně. Vidíte ten rozdíl?',
      ochrana: 'ochrana',
      osvc: ' · OSVČ',
      pilirMajetek: 'majetek a odpovědnost',
      pilirPrace: 'práce',
      pilirPrijem: 'váš příjem (životní pojištění)',
      poKazdemCiliVidite: 'Po každém cíli vidíte, **kolik vám zbývá**.',
      poblizVlozenym: 'poblíž',
      pochvalaMajetek: 'Vybudoval jste finanční majetek {castka}',
      pochvalaOdkladate: 'Odkládáte {pct} % příjmů ({castka})',
      pochvalaRezerva: 'Máte rezervu na {pct} %',
      posunteSiSamiMesicni: 'Posuňte si sami — měsíční investice:',
      povinne: 'povinné',
      pravidelne: 'pravidelně',
      pravidelneInvestovatVolneCash: 'Pravidelně investovat volné cash flow',
      prebytekNeznamy: 'Volné cash flow zatím nemáme spočítané — doplníme výdaje a částku srovnáme.',
      prezentaceFinancnihoPlanu: 'Prezentace finančního plánu',
      prijem: 'příjem',
      pripravujiPrezentaci: 'Připravuji prezentaci…',
      proTentoHorizontA: 'Pro tento horizont a vklady zatím nemáme dost historických oken.',
      projitZnovu: 'Projít znovu',
      protiPlanu: 'proti plánu',
      prvniJeDobra: 'První je dobrá: **vaše cíle se podaří naplnit.**',
      realneVynosyNadInflaci: 'Reálné výnosy nad inflací (SBBI 1926–2026). Minulé výnosy nejsou zárukou budoucích — jde o rozpětí, ne o garanci.',
      renta: 'renta',
      rentaJeZatimNa: 'Renta je zatím na **{pct} %** — a přesně víme, co s tím.',
      rentierskePortfolio5035: 'rentiérské portfolio 50 / 35 / 15',
      rentierskePortfolioDrziSe: 'Rentiérské portfolio (drží se i v čerpání)',
      rizikoDluhy: '{castka} — v případě události zůstávají rodině',
      rizikoInvalidita: 'při invaliditě chybí {castka}',
      rizikoRezerva: 'krytá na {pct} % ze 6 výplat',
      rocneRealne: 'ročně reálně',
      rodinaZajistenaAtSe: 'ochrana příjmu rodiny',
      rozdilProtiPlanu: 'Rozdíl proti plánu',
      rozdilZaLet: 'Rozdíl za {roky}: {castka}',
      rozkliknoutNa100Letech: 'Rozkliknout na 100 letech historie + strategie',
      rozlozeniVCaseGlide: 'Rozložení v čase — ke konci méně akcií',
      rozlozitSoucasneUsporyNa: 'Rozložit současné úspory na cíle',
      rozpocetPlanuKamJdou: 'Rozpočet plánu — kam jdou vaše peníze',
      sNefinancnim: 's nefinančním',
      sPlanem: 'S plánem',
      scenarOptimisticky: 'Optimistický scénář',
      scenarOptimistickyPozn: 'nejlepších 5 % období',
      scenarPesimisticky: 'Pesimistický scénář',
      scenarPesimistickyPozn: 'nejhorších 5 % období (i velké krize)',
      scenarRealisticky: 'Realistický scénář',
      scenarRealistickyPozn: 'medián — polovina období dopadla lépe',
      silaCasuCoRika: 'Síla času — co říká 100 let historie',
      silaSlozenehoUroceniRoste: 'Síla složeného úročení roste s časem',
      smrt: 'smrt',
      souhrnDoporuceniCelehoPlanu: 'Souhrn doporučení celého plánu',
      splneno: 'splněno',
      spravneZajisteniJeZaklad: '„Správné zajištění je základ plánu — nechráníme pojistku, chráníme to, co jste označil za nejdůležitější: **„{hodnota}“**.“',
      stavimeNaDobrychZakladech: '„Stavíme na dobrých základech — teď je pojďme dotáhnout.“',
      stejnePenizeStejnyClovek: '„Stejné peníze, stejný člověk — jiná rozhodnutí.“',
      styl: 'styl',
      tahakNaNamitkyJen: 'Tahák na námitky (jen pro tebe)',
      tahakNaNamitkyKlient: 'Tahák na námitky (klient nevidí)',
      takhleToDopadneKdyz: '„Takhle to dopadne, když neuděláme nic…“ — klikněte',
      toNedela8Z: 'pravidelné odkládání je základ všeho dalšího',
      tohleJeVaseCestaRok: 'Tohle je vaše cesta — **rok po roce**.',
      tohleJeVychoziBod: '„Tohle je výchozí bod. Teď vám ukážu, jak z něj postavíme celý plán.“',
      tohleNejsouStatistiky: '„Tohle nejsou statistiky — tohle je **váš rozpočet**. V den, kdy nepřijde výplata, chybí rodině __{castka}__. Každý měsíc.“',
      uCileBezTrzniho: 'u cíle bez tržního rizika',
      udelJstePrvniKrok: 'Uděl jste první krok — necháváte si udělat plán',
      ukazuVamCoUz: 'Ukážu vám **co už děláte dobře**, **kde možná přicházíte o peníze** — a hlavně __na kolik procent se podaří dosáhnout vašich cílů__ a co je pro to potřeba udělat.',
      ukolKlient1: 'naskenovat stávající smlouvy (do pátku)',
      ukolKlient2: 'vyplnit investiční dotazník',
      ukolKlient3: 'dotazy k plánu poslat mailem',
      ukolPoradce1: 'pojistné smlouvy v souladu s plánem',
      ukolPoradce2: 'komisionářská smlouva (cesta k investování)',
      ukolPoradce3: 'nastavení portfolií dle plánu',
      vasMajetek: 'Váš majetek',
      vaseCestaKamTecou: 'Vaše cesta — kam tečou vaše peníze',
      vaseCestaKdySe: 'Vaše cesta — kdy se který cíl splní',
      vaseCileJedenPo: 'Vaše cíle — jeden po druhém',
      vaseCileStojiNa: '▲ vaše cíle stojí na…',
      ve25MajiLide: '„Ve 25 mají lidé pocit, že si mají užívat. Ve 35 jde příjem na hypotéku. Ve 45 platí dětem školy. A v 60 zjistí, že **už je pozdě**. Vy začínáte dnes.“',
      vejdeSeDoPrebytku: '= vejde se do volného cash flow {prebytek} měsíčně, které jsme si spočítali.',
      vetsinaLidiFinanceOdklada: 'první krok bývá ten nejtěžší',
      vetsinaRodinNemaAni: 'rezerva je základ, na kterém stojí celý plán',
      vkladNavicNeZ: 'vklad navíc, ne z dnešních úspor',
      vlozenoCelkem: 'Vloženo celkem **{celkem}** ({jedn} jednorázově + {mes}) · strategie {akcie} % akcie / {dluhopisy} % dluhopisy',
      volneCashFlow: 'Volné cash flow',
      volnyPrebytekKazdyMesic: 'Volný přebytek každý měsíc',
      vy: 'Vy',
      vyhovujeVamSchuzkaZase: '„Vyhovuje vám schůzka zase ve středu ve stejném čase?“',
      vypadekPrijmu: 'Výpadek příjmu',
      vzacnostGratuluji: 'vzácnost — gratuluji',
      zPrebytkuDokudNedoplnime: 'z přebytku, dokud nedoplníme',
      zToho: 'z toho',
      zaLet: ' (za {roky} let)',
      zaLetBudeteMit: 'Za {roky} budete mít',
      zaLetProste: 'za {roky} let',
      zacnuDnes: 'začnu DNES',
      zadneZasadniRizikoZ: 'Žádné zásadní riziko z analýzy — skvělý výchozí stav.',
      zdrojInvestice: 'Investice a spoření',
      zdrojInvesticePozn: 'pracuje pro vás',
      zdrojLikvidni: 'Likvidní (účty, hotovost)',
      zdrojLikvidniPozn: 'hned k dispozici',
      zdrojNefinancni: 'Nefinanční majetek',
      zdrojNefinancniPozn: 'nemovitosti, firma, dědictví',
      zivotniStyl: 'životní styl',
      zmeniloSeZaTen: '„Změnilo se za ten týden něco důležitého?“',
    },
    planVystupPage: {
      akceKoupit: 'Koupit',
      akceNavysit: 'Navýšit',
      akcePonechat: 'Ponechat',
      akceProdat: 'Prodat',
      akcie2: 'Akcie',
      alokaceDela92Vysledku: 'alokace dělá ~92 % výsledku',
      alokaceRadek: 'akcie {akcie} % · dluhopisy {dluhopisy} % · hotovost {penize} %',
      alokaceStartGlide: 'Rozložení na startu. Čím blíž je cíl, tím víc plán přesouvá z akcií do dluhopisů a hotovosti — poslední rok před cílem je celý v hotovosti.',
      casuDost: 'Času dost…',
      co: 'Co',
      coKdyProc: 'co / kdy / proč',
      davkyOdhadPozn: 'Invalidní důchod je orientační odhad podle příjmu; skutečnou výši určuje ČSSZ podle doby pojištění.',
      dluhopisy: 'Dluhopisy',
      dnes: 'dnes',
      doporucenaAlokace: 'Doporučená alokace',
      doporucenePortfolio: 'Doporučené portfolio',
      doporuceniProVas: 'Doporučení pro Vás',
      doporuceniVychazejiZPoskytnutych: 'Doporučení vycházejí z poskytnutých údajů. Reálné výnosy nad inflací: akcie {akcie} %, dluhopisy {dluhopisy} %, hotovost {cash} %; průměrný výnos akumulace ≈ {prumer} % ročně. Renta se čerpá {renta} % ročně z kapitálu. Dokument slouží jako podklad; je nutné ho pravidelně aktualizovat. Minulé výnosy nezaručují budoucí.',
      doporucujemeDiverzifikovatMenove: 'Doporučujeme diverzifikovat měnově i regionálně (svět ~72 % USA), fondy velkých správců s ratingem Morningstar. Inspirace: Norský fond, Nobelova nadace.',
      financniNezavislost: 'Finanční nezávislost',
      financniNezavislostPoRealizaci: 'Finanční nezávislost po realizaci',
      horizont: 'Horizont',
      hotovost2: 'Hotovost',
      invalidita: 'Invalidita',
      kapitalovaMetodaKlesajiciPojistn: 'Kapitálová metoda (klesající pojistné částky): kryje deficit příjmu, dluhy a cíle po odečtení majetku a přebytku pozůstalé domácnosti. Kapitál renty se počítá jen u invalidity — po úmrtí ji už nikdo nečerpá.',
      kdy: 'Kdy',
      klient: 'Klient',
      klient1: 'Klient 1',
      klient2: 'Klient 2',
      konkretniProdukty: 'konkrétní produkty',
      likvidniRezerva: 'Likvidní rezerva',
      mesicneInvestovatNaCile: 'Měsíčně investovat na cíle a rentu',
      narativ1: 'Tohle je váš finanční plán — kolik měsíčně odkládat a jak rozložit investice, abyste dosáhli finanční nezávislosti a dalších cílů.',
      narativ2: 'Čísla jsou v dnešních cenách. Reálné výnosy nad inflací: akcie {akcie} %, dluhopisy {dluhopisy} %, hotovost {cash} %; průměrný výnos akumulace ≈ {prumer} % ročně. Rentu čerpáme {renta} % ročně z kapitálu; plán spolu pravidelně aktualizujeme. Minulé výnosy nezaručují budoucí.',
      naseDoporuceni: 'Naše doporučení',
      nehledejteVymluvy: 'NEHLEDEJTE VÝMLUVY',
      nejdrivVyplnAnalyzu: 'Nejdřív vyplň analýzu',
      nepodariloSeNacistData: 'Nepodařilo se načíst data',
      oSveBudoucnostiRozhodnete: 'O své budoucnosti rozhodněte už DNES.',
      planProDosazeniFinancni: 'Plán pro dosažení finanční nezávislosti a dalších cílů',
      planVytvorenDne: 'Plán vytvořen dne',
      poRealizaci: 'po realizaci',
      poznamka: 'Poznámka:',
      prijmyCelkem: 'Příjmy celkem',
      proc: 'Proč',
      produkt: 'Produkt',
      profilDynamicky: 'Dynamický',
      profilKonzervativni: 'Konzervativní',
      profilVychozi: 'výchozí — jiný profil nebyl zvolen',
      profilVyvazeny: 'Vyvážený',
      riziko: 'Riziko',
      rizikovyProfil: 'Rizikový profil',
      rizikovyProfil2: 'rizikový profil',
      skorePlanuDnesS: 'Skóre plánu (dnes → s plánem)',
      smrt: 'Smrt',
      socialniDavky: ' Sociální dávky: invalidní důchod {inval}/měs{davka}.',
      socialniDavkyStarobni: ', starobní {starobni}/měs',
      soucasnePortfolio: 'Současné portfolio',
      souhrnMajetkuADluhu: 'Souhrn majetku a dluhů',
      splatkyUveru: 'Splátky úvěrů',
      vaseHodnoty: 'Vaše hodnoty',
      vaseStrategickeCile: 'Vaše strategické cíle',
      vasichHodnotACilu: 'vašich hodnot a cílů',
      vekNejlepsiCas: 'Vám je dnes {vek} — nejlepší čas začít je teď.',
      vstupniInformace: 'vstupní informace',
      vydajeSpotreba: 'Výdaje (spotřeba)',
      vymluva25: 'Jsme mladí a začínáme. Ještě si moc nevyděláváme. Není z čeho spořit.',
      vymluva35: 'Na splátku hypotéky a výdaje padnou všechny příjmy. A na dovolenou máme přece taky nárok!',
      vymluva45: 'Nemůžeme si dovolit spořit. Děti jsou ve škole — nejlépe zahraniční.',
      vymluva55: 'Není jednoduché začít v tomto věku.',
      vymluva65: 'Měli jsme začít před mnoha lety. Dnes už je pozdě.',
      zajisteniPrijmuVPripade: 'zajištění příjmu v případě nečekané události',
      zivotniPojisteni: 'Životní pojištění',
    },
    popisZdroje: {
      jednorazovyVklad: 'jednorázový vklad',
    },
    portfolioDoctorPage: {
      aktualniTerAVstupni: '— aktuální TER a vstupní z webů správců',
      bezJmena: '(bez jména)',
      briefProSchuzkuClaude: 'Brief pro schůzku · Claude Haiku 4.5',
      briefSCnbCompliant: 'Brief s ČNB-compliant slovníkem',
      celkovyModelovyRozdilVe: 'Celkový modelový rozdíl ve prospěch ETF · ',
      coDoctorUmi: 'Co Doctor umí',
      diagnostikaSelhalaZkusTo: 'Diagnostika selhala. Zkus to znovu.',
      doporuceni: 'Doporučení',
      etfAlternativa: 'ETF alternativa:',
      fondIsinNeboNazev: 'Fond — ISIN nebo název',
      hledamFondyNaWebu: 'Hledám fondy na webu… (15–30 s)',
      ie00b4l5y983NeboConseqActive: 'IE00B4L5Y983 nebo „Conseq Active Invest Dynamický“',
      investovanaCastkaKc: 'Investovaná částka (Kč)',
      janNovak: 'Jan Novák',
      kategorieFonduUrcujeEtf: 'Kategorie fondu (určuje ETF náhradu)',
      klientJmeno: 'Klient (jméno)',
      klientovyPoziceIsinCastky: 'Klientovy pozice (ISIN + částky)',
      knihovna35NejcastejsichCz: 'Knihovna 35+ nejčastějších CZ fondů s reálnými parametry',
      knihovnaFondu: 'knihovna fondů',
      marketingoveSdeleniCnbEsma: 'Marketingové sdělení · ČNB / ESMA disclaimer',
      mesicneDaleKc: 'Měsíčně dále (Kč)',
      modelovaKalkulaceMinulaVykonnost: 'Modelová kalkulace. Minulá výkonnost není zárukou budoucí výkonnosti.',
      modelovyRozdilVeProspech: 'Modelový rozdíl ve prospěch ETF:',
      naprConseqActiveInvest: 'Např. „Conseq Active Invest Dynamický“',
      naprKlientSeBoji: 'Např. „Klient se bojí volatility, manželka chce penzi v 60.“',
      nazevFondu: 'Název fondu',
      nepodariloSeNacistDiagnostiku: 'Nepodařilo se načíst diagnostiku.',
      odebratFond: 'Odebrat fond',
      otevritZdroj: 'Otevřít zdroj ↗',
      overenoNaWebu: 'Ověřeno na webu:',
      posledniDiagnostiky: 'Poslední diagnostiky',
      pozice: 'Pozice',
      poznamkaProAiBrief: 'Poznámka pro AI brief (volitelné)',
      prepocitanoSTvymiHodnotami: 'Přepočítáno s tvými hodnotami',
      prepocitatSMymiHodnotami: 'Přepočítat s mými hodnotami',
      pridatIsin: 'Přidat ISIN',
      pridejAlesponJednuPozici: 'Přidej alespoň jednu pozici.',
      rozpoznaUcitsEtfPres: 'Rozpozná UCITS ETF přes justETF (~2 800 fondů)',
      rucniZadani: 'ruční zadání',
      smazaniSelhalo: 'Smazání selhalo.',
      smazano: 'Smazáno',
      smazat: 'Smazat',
      smazatTutoDiagnostiku: 'Smazat tuto diagnostiku?',
      spocita20LetyDopad: 'Spočítá 20-letý dopad poplatků v Kč',
      spustitDiagnostikuPortfolia: 'Spustit diagnostiku portfolia',
      tentoFondJeUz: 'Tento fond je už kvalitní.',
      terEtfCelkem: 'TER ETF celkem',
      terFondCelkem: 'TER fond celkem',
      terMusiByt0: 'TER musí být 0–10 %',
      terPod05: 'TER pod 0,5 % a akumulační ETF — měnit nedoporučujeme.',
      tvojeKnihovna: 'tvoje knihovna',
      ulozeniSelhalo: 'Uložení selhalo',
      uloziFondDoKnihovny: 'Uloží fond do knihovny — od příště ho Doctor pozná automaticky',
      ulozitDoKnihovny: 'Uložit do knihovny',
      upravit: 'Upravit',
      upravitParametryFondu: 'Upravit parametry fondu',
      upravitRucne: 'Upravit ručně',
      veProspechEtf: 've prospěch ETF',
      vek: 'Věk',
      vlozenoCelkem: 'Vloženo celkem:',
      vstupni: 'Vstupní (%)',
      vstupni010: 'Vstupní 0–10 %',
      vstupni2: 'Vstupní',
      vstupniPop: 'Vstupní pop.',
      vyberKategorii: 'Vyber kategorii',
      vyplnNazevTerA: 'Vyplň název, TER a vstupní',
      zadejteFondIsinNebo: 'Zadejte fond (ISIN nebo název), kolik klient drží a horizont. Během 30 sekund získáte modelovou diagnostiku poplatků, srovnání s UCITS ETF alternativou a 3-odstavcový brief pro schůzku.',
      zatimZadneUlozeneDiagnostiky: 'Zatím žádné uložené diagnostiky.',
      zavrit: 'Zavřít',
      zrusit: 'Zrušit',
    },
    postaPage: {
      aHlasTextPrikazem: 'a hlas/text příkazem vygeneruj nový mail.',
      aiEmailKlientovi: 'AI email klientovi',
      bezPristupuKeGoogle: 'Aplikace nemá od správce přístup ke Google — na Gmail se čekat nedá.',
      firemniEmailSmtp: 'firemní e-mail (SMTP)',
      gmailPrepojenyPredek: 'Tvůj Gmail je sice propojený, ale pro',
      gmailPrepojenyTucne: 'čtení pošty v CRM',
      gmailPrepojenyZadek: 'potřebujeme rozšířit oprávnění. Stačí znovu projít OAuth obrazovku — trvá to 10 vteřin.',
      gmailZatimPripojitNejde: 'Gmail zatím připojit nejde',
      hledatVGmailu: 'Hledat v Gmailu…',
      klikneTeToNa: 'Klikne tě to na Google obrazovku, kde jen odsouhlasíš „Číst poštu“.',
      nacteniEmailuSelhalo: 'Načtení emailů selhalo',
      neboKlikniNa: 'Nebo klikni na',
      neboSpojka: ', nebo',
      nepodariloSeOveritGmail: 'Nepodařilo se ověřit Gmail',
      nepodariloSeSpustitReconnect: 'Nepodařilo se spustit reconnect',
      noveOpravneniPosta: 'Nové oprávnění Pošta',
      obnovit: 'Obnovit',
      otevritNastaveni: 'Otevřít Nastavení',
      postaSeObjeviZde: 'Pošta se objeví zde, jakmile si v Nastavení připojíš e-mail. Máš dvě možnosti:',
      pripojSiEMail: 'Připoj si e-mail',
      pripojitFiremniEMail: 'Připojit firemní e-mail',
      sLibovolnouAdresou: 'a s libovolnou adresou (Seznam, Microsoft 365, @beplan.cz…). Připojíš ho za pár minut a budeš odtud psát i číst.',
      slozkaDorucene: 'Doručené',
      slozkaHvezdickovane: 'Hvězdičkované',
      slozkaKoncepty: 'Koncepty',
      slozkaKos: 'Koš',
      slozkaOdeslane: 'Odeslané',
      slozkaVse: 'Vše',
      slozky: 'Složky',
      smtpFungujeHned: 'Firemní e-mail (SMTP) funguje hned',
      spojeniNaChviliSelhalo: 'Spojení na chvíli selhalo. Zkus to znovu — tvůj Gmail je nejspíš stále připojený.',
      tenFungujeSLibovolnou: '— ten funguje s libovolnou adresou a nečeká na Google.',
      vyberEmail: 'Vyber email',
      zadneEmailyVeSlozce: 'Žádné emaily ve složce',
      zkusitZnovu: 'Zkusit znovu',
      znovuPripojitGmail1: 'Znovu připojit Gmail (1-klik)',
      zpetNaSeznam: 'Zpět na seznam',
    },
    publicBookingPage: {
      vybratTermin: 'Vybrat termín',
    },
    radarPrilezitostiPage: {
      dalsi: 'další',
      detailMezer: 'Detail mezer',
      kdeMaKlientMezeru: 'Kde má klient mezeru — vyber, napiš, dořeš.',
      klientuKOsloveni: 'klientů k oslovení',
      kritickychMezer: 'kritických mezer',
      napsatEMail: 'Napsat e-mail',
      napsatNaWhatsapp: 'Napsat na WhatsApp',
      obchodSeNepodariloZalozit: 'Obchod se nepodařilo založit.',
      obchodniPripadZalozen: 'Obchodní případ založen.',
      obnovit: 'Obnovit',
      odlozenoO30Dni: 'Odloženo o 30 dní.',
      odlozitNa30Dni: 'Odložit na 30 dní',
      otevritSlozkuKlienta: 'Otevřít složku klienta',
      prilezitostiCelkem: 'příležitostí celkem',
      radarPrilezitosti: 'Radar příležitostí',
      radarSeNepodariloNacist: 'Radar se nepodařilo načíst. Zkus to za chvíli.',
      radarSeNepodariloNacist2: 'Radar se nepodařilo načíst',
      sbalit: 'Sbalit',
      skenujiSmlouvyAAnalyzy: 'Skenuji smlouvy a analýzy…',
      skorePrilezitostiKlikniPro: 'Skóre příležitosti — klikni pro detail',
      terminyFixaceVyrociHlida: 'Termíny (fixace, výročí) hlídá Servisní radar. Odložené mezery se vrátí za 30 dní.',
      tohleNeniZadnePrilezitosti: 'Tohle NENÍ „žádné příležitosti“ — data se nenačetla.',
      ukol: 'Úkol',
      ukolSeNepodariloVytvorit: 'Úkol se nepodařilo vytvořit.',
      ukolVytvorenZa3: 'Úkol vytvořen (za 3 dny).',
      vse: 'Vše',
      zadneOtevrenePrilezitosti: 'Žádné otevřené příležitosti.',
      zkusitZnovu: 'Zkusit znovu',
    },
    reseniCilu: {
      akcie: 'akcie',
      akontacePct: 'akontace {pct} %',
      bezRustuNeboKroku: 'Bez růstu nebo bez kroků — šablona nic nepředvyplní.',
      bezpecneCerpani4: 'bezpečné čerpání 4 %',
      castka: 'Částka',
      chybi: 'Chybí',
      chybiProkazatelnyPrijem: 'V analýze není prokazatelný příjem — z čeho má mzda růst, appka neví.',
      cil: 'cíl',
      cilJeVTomhle: 'Cíl je v tomhle nastavení nedosažitelný — číslo je jen orientační strop.',
      cilKrytyJednorazoveBez: 'Cíl krytý jednorázově — bez pravidelné investice.',
      cilVelke: 'Cíl',
      cilovaCastka: 'Cílová částka',
      cimSeCilPoridi: 'Čím se cíl pořídí',
      cnbDo36Let: 'ČNB: do 36 let stačí 10 % vlastních zdrojů (LTV 90 %), jinak 20 %. 100% financování je rozhodnutí poradce — 10 % ceny kryje úvěr ze stavebního spoření. Splátka se v cashflow projeví až od čerpání úvěru',
      dluhopisy: 'dluhopisy',
      dopocitat: 'dopočítat',
      dopocteno: 'dopočteno',
      dynamicky: 'Dynamický',
      glidePathAlokaceV: 'Postupné snižování rizika v čase',
      horizontVLetech: 'Horizont v letech',
      hotovost: 'hotovost',
      hypotekou: 'hypotékou',
      inflacePct: 'Inflace (%)',
      jakToVyresit: 'Jak to vyřešit',
      jeNadVolnymPrebytkem: 'je nad volným přebytkem domácnosti',
      jednorazove: 'Jednorázově',
      jednorazoveDnesNavic: 'Jednorázově dnes (navíc)',
      jednorazovy: 'jednorázový',
      kCili: 'K cíli',
      kapital: 'kapitál',
      kazdychLet: 'Každých (let)',
      konzervativni: 'Konzervativní',
      krokuRustu: 'kroků',
      ktereSeTuNezapocitava: ', které se tu nezapočítává.',
      let: 'let',
      mesice: 'měsíce',
      mesicne: 'Měsíčně',
      mesicniRentaKlienta: 'Měsíční renta klienta',
      mimoradnyPrijem: 'mimořádný příjem',
      navrh: 'návrh',
      nbsAkontace: 'NBS: běžně 20 % vlastních zdrojů (LTV 80 %), 10 % jen výjimečně. 100% financování je rozhodnutí poradce — 10 % ceny kryje úvěr ze stavebního spoření. Splátka se v cashflow projeví až od čerpání úvěru',
      neresiSe: 'neřeší se',
      nominalne: 'nominálně',
      nominalneMinusInflace: 'nominálně − inflace',
      nominalneNeprekonaInflaci: 'nominálně nepřekoná inflaci',
      oboji: 'Obojí',
      od: 'od',
      odR: 'od r.',
      odebratPritok: 'Odebrat přítok',
      planSlibujeVicNez: '— plán slibuje víc, než na co klient dnes má.',
      pocetKroku: 'Počet kroků',
      pocitaSeJakoSporeni: 'Počítá se jako SPOŘENÍ: klient má našetřit celou částku {castka}. S úvěrem spoří jen akontaci.',
      polovina: 'polovina',
      posledni: 'poslední',
      posledniRok100Hotovost: '— poslední rok 100 % hotovost: žádné tržní riziko',
      pravidelnaInvestice: 'Pravidelná investice',
      pridat: 'Přidat',
      pridatBudouciPritok: 'Přidat budoucí přítok',
      pripadnyKoncikiNajem: '; případný končící nájem splátku částečně vykryje.',
      realneNadInflaci: 'reálně (nad inflací)',
      realneTempoDoKroku: 'reálně — tohle tempo jde do kroků růstu mzdy.',
      renta: 'renta',
      rentaDrziRentierskePortfolio: '— renta drží rentiérské portfolio 50/35/15 i v čerpání',
      rentaVCerpaniPortfolio: '— v čerpání renta drží portfolio {a}/{d}/{c}',
      posledniRokTabulka: '— poslední rok {c} % hotovost a {d} % dluhopisy',
      rentierskePortfolio: 'rentiérské portfolio',
      resiSeUverem: 'Spoří se jen akontace, zbytek řeší úvěr — splátka nastupuje od čerpání.',
      resimeJenZeZdroju: 'Řešíme jen ze zdrojů a měsíčně.',
      rocniRustPct: 'Růst (%)',
      rok: 'rok',
      rustMzdy: 'růst mzdy',
      rustVkladuNastaveni: 'Růst vkladu — nastavení',
      sablonaNicNepredvyplni: 'Šablona teď nic nepředvyplní.',
      sablonaPredvyplniPritoky: 'Šablona předvyplní budoucí přítoky mzdy napříč plánem — poradce je pak upraví.',
      splatka: 'splátka',
      splatnost: 'splatnost',
      splatnostHypotekyLet: 'Splatnost hypotéky v letech',
      typ: 'Typ',
      urok: 'úrok',
      urokHypotekyPa: 'Úrok hypotéky v % p.a.',
      uverZeStavebka: 'úvěr ze stavebka',
      uverem: 'úvěrem',
      vR: 'v r.',
      vkladNadRamecZdroju: 'Vklad nad rámec zdrojů — měsíční platba se dopočítá.',
      vlastniZdroje: 'vlastní zdroje',
      vlozenoCelkem: '— vloženo celkem',
      vybrano: 'vybráno',
      vychazi: 'vychází',
      vychozi: 'výchozí',
      vychoziHodnoty: 'výchozí hodnoty',
      vychoziParametryHypo: 'Nevyplněno = plán počítá s výchozími {sazba} % p.a. na {roky} let, ne s nabídkou banky. Úvěr ze stavebního spoření ve variantě 100 % má vlastní sazbu a tahle pole s ní nehýbou.',
      vyvazeny: 'Vyvážený',
      zAnalyzy: 'z analýzy',
      zTohoVlastni: 'z toho vlastní zdroje',
      zTohoVyjde: 'Z toho vyjde',
      zVlastnichPenez: 'z vlastních peněz',
      za: 'za',
      zaLet: 'Za (let)',
      zadanePctJe: 'Zadané % je',
      zadano: 'zadáno',
      zadat: 'zadat',
      zadneCilSeResi: 'Žádné — cíl se řeší pravidelnou investicí z přebytku.',
      zadnyRealnyRust: 'reálný růst je nula, šablona nic nepředvyplní.',
      zahoditKroky: 'Zahodit kroky růstu mzdy',
      zpetNaHodnotuZ: 'Zpět na hodnotu z analýzy',
      zpetNaVychozi: 'zpět na výchozí',
      zpetNaVychoziRust: 'zpět na výchozí',
      zrusit: 'Zrušit',
    },
    rezerva: {
      poznKlientuvCilNezbytne: 'Metodika doporučuje 6× nezbytné výdaje a splátky, tedy {metodika}. Váš cíl je {nasobek}× tohoto základu.',
      poznKlientuvCilObvykle: 'Metodika doporučuje 6× nezbytné výdaje a splátky. Nezbytné výdaje v analýze nejsou, takže z obvyklých výdajů a splátek vychází {metodika} — váš cíl je {nasobek}× tohoto základu.',
      poznNeznamy: 'Cíl rezervy zatím nemáme z čeho spočítat — chybí výdaje.',
      poznObvykle: 'Nezbytné výdaje nejsou v analýze zadané — počítáno z obvyklých výdajů. Doplňte je a částka se upřesní.',
      titulKlientuvCil: 'Rezerva — váš cíl',
      titulNezbytne: 'Rezerva (6× nezbytné výdaje + splátky)',
      titulNeznamy: 'Rezerva',
      titulObvykle: 'Rezerva (6× obvyklé výdaje + splátky)',
    },
    rozpocetPlanu: {
      aniTakToAleNa: 'Ani tak to ale na všechny cíle nestačí —',
      cekaNaCil: ' čeká na cíl.',
      chybiCelkem: 'chybí celkem',
      doraziAzPoCilovem: 'dorazí až PO cílovém datu — na cílovou částku nemá vliv',
      financniMajetekJednorazove: 'Finanční majetek — jednorázově',
      hned: 'hned',
      jePenzijniSporeniDps: ' je penzijní spoření (DPS/DIP) — je to majetek klienta a plán s ním celým počítá na rentu, jen do cíle dorazí ',
      jePenzijniSporeniDps2: ' je penzijní spoření (DPS/DIP). Je to majetek klienta, ale zatím ho nečerpá žádný cíl — patří do renty a klient cíl finanční nezávislosti nemá. Zůstává v „zbývá“.',
      jednorazove: 'jednorázově',
      jednorazoveA: ' jednorázově a ',
      jednorazoveO: 'jednorázově o',
      jesteNeniRozdelenoVsechno: 'Ještě není rozděleno všechno: ',
      kolikZbyvaPoKazdem: 'Kolik zbývá po každém cíli',
      let: 'let',
      letech: 'letech',
      mesicneO: 'měsíčně o',
      mesicniPrebytekPravidelne: 'Měsíční přebytek — pravidelně',
      mesicu: 'měsíců',
      miraUspor: 'Míra úspor',
      necerpaZRozpoctu: 'nečerpá z rozpočtu',
      planJeHotovy: ' Plán je hotový.',
      planJednorazovePrerozdeluje: 'Plán jednorázově přerozděluje likvidní účty, stavební spoření a penzijko. Mimo zůstává ',
      planNemaZCeho: 'plán nemá z čeho platit. Nejdřív rozpočet domácnosti.',
      podiloveFondyKzpOstatni: ' (podílové fondy, KŽP, ostatní účty) — celý finanční majetek ',
      povinneVydaje: 'Povinné výdaje',
      pravidelne: 'pravidelně',
      prebytek: 'Přebytek',
      prebytekJeVAnalyze: 'Přebytek je v analýze zadaný ručně — nesedí přesně na příjmy mínus výdaje.',
      prebytekNesediNaRozpad: 'Přebytek nesedí na příjmy mínus výdaje a splátky — zkontrolujte rozpočet v analýze.',
      prebytekNulaKlientskyVystup: 'Měsíční přebytek je nula — klientský plán se z nuly nesestaví. Doplňte v analýze částku, kterou jste si s klientem odsouhlasili.',
      precerpano: 'Přečerpáno',
      precerpanoPlanNevychazi: 'Přečerpáno — plán nevychází',
      prideleno: 'Přiděleno',
      prijmy: 'Příjmy',
      rozpocetPlanu: 'Rozpočet plánu',
      tolikKlientNema: ' — tolik klient nemá.',
      v: 'v',
      vydajeASplatkyPrevysuji: 'Výdaje a splátky převyšují příjmy o ',
      vyrovnanoVsePrideleno: 'Vyrovnáno — vše přiděleno',
      zBudoucihoPritoku: 'z budoucího přítoku (mimo rozpočet)',
      zPenzijkaDpsDip: 'z penzijka (DPS/DIP) · dorazí ',
      zToho: 'Z toho ',
      za: 'za',
      zatimNeniCoRozdelovat: 'Zatím není co rozdělovat — klient nemá volný finanční majetek ani měsíční přebytek. Plán začíná rozpočtem domácnosti, ne produktem.',
      zatimZadnyCilRozpocet: 'Zatím žádný cíl — rozpočet se naplní, jakmile přidáš první.',
      zbyva: 'Zbývá',
      zbyva0A0: 'Zbývá 0 a 0 — každá koruna i každý měsíční přebytek má svůj úkol.',
    },
    sekceCinema: {
      dalsi: 'Další',
      prehrat: 'Přehrát',
      tvojeVeta: 'Vaše věta ',
      zavrit: 'Zavřít',
      zpet: 'Zpět',
    },
    spolecne: {
      aiGeneraceSelhala: 'AI generace selhala',
      chybaPrepisu: 'Chyba přepisu',
      chybaSite: 'Chyba sítě',
      cil: 'Cíl',
      jedMes: '/měs',
      klient: 'klient',
      klientu: 'klientů',
      let: ' let',
      mikrofonNeniDostupny: 'Mikrofon není dostupný',
      n1HlasovyNeboTextovy: '1. Hlasový nebo textový příkaz',
      napisNeboNahrajPrikaz: 'Napiš nebo nahraj příkaz',
      napsatEMail: 'Napsat e-mail',
      nevimeCile: 'V analýze zatím nejsou žádné cíle s částkou — proto tu není procento.',
      nevimeHorizont: 'U cíle chybí horizont — doplňte, za kolik let ho chcete.',
      nevimeRenta: 'Cíl renty není zadaný — doplňte, kolik chce klient měsíčně a od kdy.',
      nevimeRezerva: 'Cíl rezervy neznáme — v analýze chybí výdaje domácnosti.',
      nevimeSkore: 'Skóre nejde spočítat — v analýze chybí základní údaje.',
      nevimeVydaje: 'Výdaje domácnosti nejsou v analýze zadané — volné cashflow se nedá spočítat.',
      odesilam: 'Odesílám…',
      odeslaniSelhalo: 'Odeslání selhalo',
      poradce: 'poradce',
      poslatKlientovi: 'Poslat klientovi',
      prazdnaAnalyzaText: 'V analýze zatím nejsou příjmy, výdaje, majetek ani cíle. Doplňte je a plán se spočítá z dat klienta — vymyšlená čísla do klientského výstupu nepatří.',
      prazdnaAnalyzaTitul: 'Z téhle analýzy plán sestavit nejde',
      prebytekChybiTextDopocet: 'Z příjmů, výdajů a splátek vychází měsíční přebytek nula. Plán z nuly nesestavíme. Zkontrolujte v analýze rozpočet domácnosti — nebo doplňte přebytek, který jste si s klientem odsouhlasili.',
      prebytekChybiTextNezadano: 'Měsíční přebytek zatím nevíme — v analýze chybí výdaje, ze kterých by se dal spočítat. Doplňte je, nebo rovnou zapište částku, kterou jste si s klientem odsouhlasili.',
      prebytekChybiTextNula: 'Odsouhlasený měsíční přebytek je nula. Plán z nuly nesestavíme — nekreslíme grafy z peněz, které nejsou, a klientovi nebudeme tvrdit, že mu měsíční řešení sedí na přebytek. Doplňte v analýze částku, na které jste se s klientem shodli, nebo nejdřív proberte rozpočet domácnosti.',
      prebytekChybiTitul: 'Kolik měsíčně jsme si odsouhlasili?',
      predmet: 'Předmět:',
      prepisSeNezdarilNapis: 'Přepis se nezdařil — napiš příkaz ručně',
      rentaOdvozena: 'Cíl renty není zadaný — počítáme s dnešními výdaji klienta.',
      ukladam: 'Ukládám…',
      ulozit: 'Uložit',
      vytisknoutUlozitPdf: 'Vytisknout / uložit PDF',
      zavrit: 'Zavřít',
      zkusitZnovu: 'Zkusit znovu',
      zmenitPrikaz: 'Změnit příkaz',
      zrusitFiltr: 'Zrušit filtr',
    },
    srovnavacFonduPage: {
      horizont: 'Horizont: {roky} {rok}',
      jednorazoveKc: 'Jednorázově ({mena})',
      mesicneKc: 'Měsíčně ({mena})',
      rozdilVeProspech: 'Rozdíl za {roky} {rok} ve prospěch:',
      srovnavacFondu: 'Srovnávač fondů',
      vlastniA: 'Vlastní A',
      vlastniB: 'Vlastní B',
    },
    tokPenez: {
      beznyUcet: 'Běžný účet',
      budouciPritok: 'Budoucí přítok',
      chybi: 'chybí',
      chybiPrecerpano: 'chybí / přečerpáno',
      coKlientDnesNema: 'co klient dnes nemá',
      dnesniMajetek: 'dnešní majetek',
      doraziAzPoCilovem: 'dorazí až PO cílovém datu',
      doraziAzPoCilovem2: 'dorazí až PO cílovém datu — na cílovou částku nemá vliv',
      doraziV: 'dorazí v',
      hotovost: 'Hotovost',
      jednorazoveZFinancniho: 'Jednorázově — z finančního majetku',
      klikniZnovuZpetNa: 'Klikni znovu = zpět na vypočtený návrh',
      letech: 'letech',
      mesicneZPrebytku: 'Měsíčně — z přebytku',
      mesicniPrebytek: 'Měsíční přebytek',
      mesicniPrebytek2: 'měsíční přebytek',
      najedteNaProudUkaze: 'Najeďte na proud — ukáže se odkud, kam a kolik.',
      nezarazenyZdroj: 'Nezařazený zdroj',
      odkudKamTecouVase: 'Odkud kam tečou vaše peníze',
      penzijkoAzPozdeji: 'penzijko — až později',
      penzijkoDpsDip: 'Penzijko DPS/DIP',
      posliCelyTenhleZdroj: 'Pošli celý tenhle zdroj na tento cíl',
      posliSem: 'pošli sem',
      precerpanoTolikKlient: 'Přečerpáno — tolik klient nemá',
      splneno: 'splněno',
      sporiciUcet: 'Spořicí účet',
      stavebniSporeni: 'Stavební spoření',
      tokPenez: 'Tok peněz',
      uvolnenePenizeARustMzdy: 'Uvolněné peníze a růst mzdy',
      vkladNavic: 'Vklad navíc',
      zatimNeniCoRozdelovat: 'Zatím není co rozdělovat — klient nemá volný finanční majetek ani měsíční přebytek.',
    },
    whatsAppSender: {
      klientNemaTelefonDopln: 'Klient nemá telefon — doplň ho v kontaktu.',
      navrhDleFazeKlienta: 'Návrh dle fáze klienta',
      otevreWhatsappSTimto: 'Otevře WhatsApp s tímto textem — ještě dáš odeslat ručně (zdarma, žádné API).',
      otevritWhatsapp: 'Otevřít WhatsApp',
      sablona: 'Šablona',
      zpravaUpravPodlePotreby: 'Zpráva (uprav podle potřeby)',
      zrusit: 'Zrušit',
    },
  },
  /* BLOK:auto END */
  /* === /AUTO === */
  /* KLIENTSKÉ „PROČ" u životního pojištění (lib/zivotko/procKlientovi.js).
   * Čte to KLIENT — na sdílené modelaci /m/:token, v PDF i v kalkulačce.
   * ⚠️ NIC TU NESMÍ SLIBOVAT CHOVÁNÍ POJIŠŤOVNY ani lhůtu plnění. Popisujeme
   *    VÝPOČET a jeho důvody, ne záruky. Ceny jsou vždy „potvrdí pojišťovna".
   * ⚠️ Placeholdery {…} musí být ve všech pěti jazycích STEJNÉ — hlídá to
   *    data/translations/__tests__/slovnikyKompletni.test.js. */
  /* VEŘEJNÁ SDÍLENÁ MODELACE /m/:token — čte to KLIENT, ne poradce.
   * Snapshot je uložený natrvalo, ale texty jsou KLÍČE, takže se přeloží do
   * jazyka toho, KDO SE DÍVÁ — ne toho, kdo modelaci vytvořil. */
  modelace: {
    nacitam: 'Načítám modelaci…',
    neplatnyOdkaz: 'Tento odkaz je neplatný nebo vypršel.',
    proVas: 'Modelace pro vás',
    vaseModelace: 'Vaše modelace',
    pripravenoPro: 'Připraveno pro',
    jakRozumet: 'Jak tomu rozumět',
    vasPoradce: 'Váš poradce',
    paticka: 'Orientační modelace. Minulé výnosy nejsou zárukou budoucích.',
    ctaSchuzka: 'Domluvit schůzku',
    ctaWhatsApp: 'Napsat na WhatsApp',
    ctaSpojit: 'Spojit se',
    chybaNacteni: 'Modelaci se teď nepodařilo načíst. Zkontrolujte připojení a zkuste to znovu.',
    zkusitZnovu: 'Zkusit znovu',
    prehrat: 'Přehrát',
    zastavit: 'Zastavit',
    nahledKlient: 'Co klient uvidí',
  },
  /* Popisky snapshotu životní kalkulačky pro /m/:token (a PDF).
   * ⚠️ Placeholder {castka} musí být ve všech pěti jazycích STEJNÝ. */
  zivotkoModelace: {
    heroSmrt: 'Kolik rodina potřebuje (smrt živitele)',
    pocetOsob: 'Počet osob',
    nezbytneVydaje: 'Nezbytné výdaje',
    zaMesic: '{castka}/měs',
    zaDen: '{castka}/den',
    variantaKryti: 'Varianta krytí',
    varianta_narocna: 'Pro náročné',
    varianta_stredni: 'Zlatá střední',
    varianta_uskromnit: 'Uskromnit se',
    varianta_cena: 'Řeším jen cenu',
    krytiSmrt: 'Krytí pro případ smrti',
    krytiInvalidita: 'Krytí pro případ invalidity',
    pnRodina: 'Pracovní neschopnost (rodina)',
    narativ1: 'Čísla říkají, kolik by rodina dostala, kdyby se stalo to nejhorší — aby mohla dál bydlet, žít ve svém standardu a děti dostudovaly.',
    narativ2: 'Invalidita má vyšší částku než smrt, protože nemocný člověk doma potřebuje navíc péči a úpravy. Pracovní neschopnost dorovnává výpadek příjmu při krátké nemoci nebo úrazu.',
    narativ3: 'Nezávazný orientační návrh. Konkrétní podmínky a ceny upřesníme společně.',
  },
  zivotkoProc: {
    nadpis: 'Proč je invalidita nejdůležitější',
    podnadpis: 'Krok za krokem, z vašich vlastních čísel',
    osloveni: '{kdo}, tohle je vaše modelace — a hlavně to, PROČ zrovna tahle čísla.',
    proOsobu: 'Počítáno pro: {kdo}.',
    proOsobuVice: 'Počítáno pro: {kdo} — z rodiny má nejvyšší příjem. Ostatní mají svůj vlastní výpočet.',
    proOsobuViceBezJmena: 'Počítáno pro člena rodiny s nejvyšším příjmem. Ostatní mají svůj vlastní výpočet.',
    k1Nadpis: 'Dnes',
    k1Popis: 'Rodina má {prijem} měsíčně a na nezbytné věci z toho potřebuje {vydaje}.',
    k1PopisBezVydaju: 'Rodina má dnes {prijem} měsíčně.',
    k2Nadpis: 'Příjem vypadne',
    k2Popis: '{kdo} už nemůže pracovat. Z příjmů rodiny zůstane {zbytek} měsíčně.',
    k2PopisBezJmena: 'Tenhle příjem už nepřijde. Z příjmů rodiny zůstane {zbytek} měsíčně.',
    k2PopisNic: '{kdo} už nemůže pracovat. Žádný další pracovní příjem rodině nezůstane.',
    k2PopisNicBezJmena: 'Tenhle příjem už nepřijde. Žádný další pracovní příjem rodině nezůstane.',
    k3Nadpis: 'Výdaje ale NAROSTOU',
    k3Popis: 'Účty nezmizí — naopak přibude péče, léky, doprava k lékaři, úpravy bydlení. Model počítá s nárůstem o {pct} %, tedy {vydaje} měsíčně. Tohle je ten rozdíl proti smrti: člověk žije dál a jeho život něco stojí.',
    k3PopisBezNarustu: 'Účty nezmizí. Rodina dál potřebuje {vydaje} měsíčně.',
    k4Nadpis: 'Stát pokryje jen část',
    k4Popis: 'Invalidní důchod je {duchod} měsíčně. Když se sečtou všechny zbylé příjmy a dávky, každý měsíc pořád chybí {chybi}.',
    k4PopisBezDiry: 'Invalidní důchod je {duchod} měsíčně. Běžné výdaje by rodina ze zbylých příjmů a dávek pokryla — potřeba vzniká až u dluhů a cílů.',
    k5Nadpis: 'A chybí to každý měsíc, {roky} let',
    k5Popis: 'Aby byla díra zalepená celých {roky} let, je potřeba kapitál {kapital}. Není to prostý součet {naivne} — peníze se mezitím zhodnocují, takže stačí méně. Počítá se s {sazba} % ročně nad inflaci.',
    k5PopisBezSazby: 'Aby byla díra zalepená celých {roky} let, je potřeba kapitál {kapital}.',
    k6Nadpis: 'K tomu dluhy a cíle',
    k6NadpisDluhy: 'K tomu dluhy',
    k6NadpisCile: 'K tomu cíle rodiny',
    k6Popis: 'Kapitál na výdaje je jedna část. Druhá jsou závazky a plány. Dluhy se přitom nekrátí nikdy — hypotéku nejde doplatit na 80 %.',
    k6PopisBezDluhu: 'Kapitál na výdaje je jedna část. Druhá jsou plány rodiny, které se nemají zastavit.',
    k6Dluhy: 'Dluhy k doplacení: {castka}',
    k6Cile: 'Cíle rodiny: {castka}',
    souhrnNadpis: 'Celkem na invaliditu',
    souhrnNadpisOsoba: 'Na invaliditu — {kdo}',
    souhrnNadpisJedna: 'Na invaliditu — tato osoba',
    souhrnPopis: 'Tolik má být na smlouvě, aby rodina zvládla dalších {roky} let žít dál a nepřišla o bydlení.',
    souhrnPopisBezLet: 'Tolik má být na smlouvě, aby rodina zvládla žít dál a nepřišla o bydlení.',
    srovnaniVyssi: 'Pro případ smrti vychází {smrt}. Invalidita je o {rozdil} vyšší — a to je celý důvod, proč je první. Mrtvý člověk nejí, nebydlí a nepotřebuje péči. Živý ano.',
    srovnaniStejne: 'Pro případ smrti vychází {smrt}. U vás jsou obě čísla blízko sebe — rozhoduje pak to, co se stane dřív.',
    pausalNadpis: 'Proč ne „pětinásobek ročního příjmu“',
    pausalMene: 'Pravidlo z příruček — pětinásobek ročního příjmu — by u vás dalo {pausal}. To je o {rozdil} méně, než vychází z vašich vlastních výdajů, dávek a let. Paušál nezná vaši hypotéku ani vaše děti, proto tady žádný není.',
    pausalVice: 'Pravidlo z příruček — pětinásobek ročního příjmu — by u vás dalo {pausal}, tedy o {rozdil} víc, než vychází z vašich čísel. Paušál nezná vaše výdaje ani vaše dávky, proto tady žádný není.',
    rizikaNadpis: 'Ostatní rizika — a co řeší',
    rizikaNadpisOsoba: 'Ostatní rizika — {kdo}',
    rizikaNadpisJedna: 'Ostatní rizika — a co řeší u téže osoby',
    coJe: 'Co to je',
    bez: 'Co se stane bez pojištění',
    resi: 'Kolik to řeší',
    smrtNazev: 'Smrt',
    smrtCoJe: 'Živitel zemře — úrazem nebo nemocí.',
    smrtBez: 'Výdaje a dluhy zůstanou, jeden příjem zmizí. Rodina pak řeší prodej bydlení zrovna v roce, kdy na to má nejmíň sil.',
    trvNazev: 'Trvalé následky úrazu',
    trvCoJe: 'Úraz, po kterém zůstane trvalé omezení — ruka, noha, zrak, páteř.',
    trvBez: 'Jednorázové náklady (rehabilitace, bezbariérové úpravy, jiné auto) jdou z rezervy. Když nestačí, z úvěru.',
    trvResiPopisek: 'Progresivní plnění: čím vážnější následek, tím vyšší výplata — v našem modelu až {nasobek}× sjednaná částka, u pojišťoven se liší.',
    pnNazev: 'Pracovní neschopnost',
    pnCoJe: 'Nemoc nebo úraz na týdny až měsíce. Pak se člověk vrátí do práce.',
    pnBez: 'Příjem spadne na nemocenskou, výdaje zůstanou stejné. Rezerva se rozpustí během pár měsíců.',
    pnBezOsvc: 'OSVČ bez nemocenského pojištění nedostane od státu nic. Výdaje běží dál a rezerva se rozpustí během pár měsíců.',
    pnResiDen: '{castka} / den',
    pnKarenceOd: 'Rezerva pokryje první měsíce, dávka je navržená od {od}. měsíce.',
    pnKarenceHned: 'Navrženo od prvního dne.',
    zavNazev: 'Závažné onemocnění',
    zavCoJe: 'Rakovina, infarkt, mrtvice a další diagnózy ze seznamu pojišťovny.',
    zavBez: 'Léčba a doléčení trvá měsíce až roky. Člověk pracuje míň, platí víc — a nemá čas řešit peníze.',
    zavResiPopisek: 'Jednorázově, ve výši {nasobek}násobku ročního příjmu.',
    ditNazev: 'Vážná událost u dítěte',
    ditCoJe: 'Dítě zůstane po úrazu nebo nemoci trvale závislé na péči.',
    ditBez: 'Největší díra není léčba — je to rodič, který kvůli péči natrvalo vypadne z práce.',
    ditResiPopisek: 'Částka na smlouvě každého dítěte. Počítá se z výpadku příjmu rodiče, který by o dítě pečoval.',
    ditResiStrop: 'Částka na smlouvě každého dítěte. Část potřeby ({castka}) neupíše na dítě žádná pojišťovna — ta patří do rezervy a do investic.',
    cenaNadpis: 'Cena',
    cenaZadana: 'Ochrana vychází na {cena} měsíčně. Je to částka z nabídky, kterou zadal poradce — konečnou cenu potvrdí pojišťovna ve smlouvě, až posoudí zdravotní stav. Do té doby je to odhad, ne nabídka.',
    cenaChybi: 'Cena v tomhle dokumentu záměrně není. Doplní ji poradce podle konkrétní pojišťovny — dokud není podepsaná smlouva, žádné číslo tu není nabídka.',
    cenaDen: 'Na den to dělá {denne}.',
    cenaPct: 'Z čistého příjmu rodiny je to {pct} %.',
    poznamkaModelace: 'Tohle je modelace, ne pojistná smlouva ani osobní doporučení. Čísla vycházejí z toho, co jste uvedli — když se změní příjem, výdaje nebo cíle, změní se i výsledek.',
    poznamkaSablona: 'Částky u trvalých následků, závažných onemocnění a rizika dítěte jsou orientační vzor z praxe poradce. Konkrétní limity, výluky a čekací doby určuje pojišťovna.',
    poznamkaDavky: 'Invalidní důchod a nemocenská jsou odhad podle českých pravidel. Skutečnou výši určuje ČSSZ.',
    poznamkaMetodika: 'Metodika {verze}.',
  },

  /* Klientské formuláře (/f/:token) — JEDINÁ obrazovka appky, kterou otvírá
   * klient, ne poradce. Otevře ji v telefonu, bez přihlášení, a může to být
   * Vietnamec nebo Ukrajinec — proto tu nesmí být ani jeden dvoujazyčný ternár.
   *
   * ZNĚNÍ OTÁZEK TU NENÍ. Popisky polí, nápovědy i texty souhlasu chodí ze
   * serveru přeložené (backend/lib/formulare/*). Backend je jediný zdroj pravdy
   * o tom, jaká pole formulář má a která z nich jsou citlivá; kdyby si seznam
   * držel frontend, stačila by jedna překlepnutá klíčovka a rodné číslo by
   * skončilo v nešifrované části dokumentu.
   */
  formKlient: {
    castZ: "Část {n} z {celkem}",
    /* Příjmy a výdaje — obrazovka skupiny výdajů a „Váš přehled“ (26. 10. 2026). */
    pv: {
      prehledNadpis: "Váš přehled",
      prehledPodnadpis: "Zkontrolujte čísla a pošlete je poradci. Co nesedí, upravte.",
      prijmy: "Příjmy",
      vydaje: "Výdaje",
      mesicne: "měsíčně",
      zbyva: "Zbývá měsíčně",
      zbyvaPopis: "příjmy − výdaje − splátky",
      zbyvaZaporne: "Výdaje a splátky jsou vyšší než příjmy.",
      bezPrijmu: "Bez příjmů nejde spočítat, kolik zbývá.",
      rozpad: "Kam peníze odcházejí",
      rozpadPrazdno: "Výdaje jste zatím nevyplnili.",
      rozpadAria: "Měsíční výdaje po skupinách, největší je {skupina}: {castka}",
      porovnaniAria: "Příjmy {prijmy}, výdaje {vydaje}",
      splatky: "Splátky úvěrů",
      sporeni: "Spoření a investice",
      neniVydaj: "nepočítá se do výdajů",
      firma: "Podnikání (vede se zvlášť, mimo domácnost)",
      minimum: "nezbytné minimum",
      minimumCelkem: "Nezbytné minimum celkem",
      osoba1: "Vy",
      osoba2: "Partner / partnerka",
      dalsiPrijmy: "Nájem, výnosy, bonusy",
      pravidlo: "Orientační pravidlo 50 / 30 / 20",
      pravidloPopis: "Povinné výdaje a splátky 50–60 %, život 20–30 %, budoucnost ideálně 20 % z příjmů. Je to orientace, ne hodnocení.",
      povinne: "Povinné",
      zivot: "Život",
      budoucnost: "Budoucnost",
      cil: "cíl {rozsah}",
      skupinaCelkem: "Celkem za skupinu",
      vydajeZatim: "Výdaje zatím",
      podrobnosti: "Podrobnosti: nezbytné minimum",
      podrobnostiSkryt: "Skrýt podrobnosti",
      minimumPopis: "Kolik z toho je nezbytné minimum — částka, bez které se v měsíci bez příjmu neobejdete.",
    },
    nacitam: "Načítám formulář…",
    neplatnyNadpis: "Odkaz už neplatí",
    neplatnyText: "Odkazy na formulář mají omezenou platnost. Napište svému poradci a pošle vám nový.",
    chybaNadpis: "Formulář se nepodařilo načíst",
    chybaText: "Zkuste stránku načíst znovu. Pokud to nepomůže, ozvěte se svému poradci.",
    hotovoNadpis: "Odesláno, děkujeme",
    hotovoText: "{poradce} se vám ozve. Co jste nevyplnili, doplníte spolu.",
    hotovoTextBezJmena: "Váš poradce se vám ozve. Co jste nevyplnili, doplníte spolu.",
    jazyk: "Jazyk",
    krokZ: "Otázka {n} z {celkem}",
    sekceOtazek: "Otázek v této části: {n}",
    zacit: "Začít",
    pokracovat: "Pokračovat",
    zpet: "Zpět",
    dale: "Další",
    preskocit: "Přeskočit",
    nepovinne: "Nepovinné",
    ukladam: "Ukládám…",
    ulozeno: "Uloženo — můžete zavřít a vrátit se později.",
    chybaUlozeni: "Poslední změny se nepodařilo uložit. Zkusíme to znovu při další úpravě.",
    chybaUlozeniOdkaz: "Odkaz už neplatí — ozvěte se prosím svému poradci.",
    zamek: "Ukládáme zašifrovaně",
    ulozenoZasifrovane: "Uloženo zašifrovaně: {maska}. Nechte prázdné, pokud se nemá měnit.",
    platiDo: "Odkaz platí do {datum}.",
    vyberte: "Vyberte",
    nevyplneno: "Nevyplněno",
    pridatRadek: "Přidat řádek",
    smazatRadek: "Smazat řádek",
    zvlastniKategorie: "Zvláštní kategorie údajů",
    souhlasNadpis: "Než začneme",
    souhlasPokracovat: "Souhlasím a chci pokračovat",
    souhlasOdmitnout: "Nesouhlasím",
    souhlasNutny: "Bez souhlasu formulář vyplňovat nelze.",
    souhlasOdmitnutoNadpis: "Rozumíme",
    souhlasOdmitnutoText: "Nic jsme neuložili a odkaz jsme uzavřeli. Když si to rozmyslíte, poradce vám pošle nový.",
    odvolatSouhlas: "Odvolat souhlas a zavřít odkaz",
    rekapitulaceNadpis: "Zkontrolujte a odešlete",
    rekapitulacePodnadpis: "Co jste nevyplnili, doplníte s poradcem. Nemusí tu být všechno.",
    upravit: "Upravit",
    prazdno: "Zatím jste nic nevyplnili.",
    odeslat: "Odeslat poradci",
    odesilam: "Odesílám…",
    chybiPovinne: "K odeslání ještě chybí: {pole}.",
    chybaOdeslani: "Odeslání se nepodařilo. Zkuste to prosím ještě jednou.",
    poradce: {
      /* Příjmy a výdaje — banner v analýze a složka (26. 10. 2026). */
      pv: {
        banner: "Klient poslal příjmy a výdaje ({datum})",
        prevzit: "Převzít do analýzy",
        prevzato: "Převzato do analýzy",
        zobrazit: "Zobrazit",
        skryt: "Skrýt",
        coSeZapise: "Co se zapíše do analýzy",
        drivTed: "dřív {pred} → teď {po}",
        partnerChybi: "Klient vyplnil i partnera, ale v analýze druhá osoba není. Zapíše se jen osoba 1 — doplňte partnera a převezměte znovu.",
        splatkySporeni: "Splátky a spoření klient uvedl jen pro přehled — do výdajů se nezapisují (patří do Závazků a Zdrojů).",
        nicKPrevzeti: "Formulář je prázdný — není co převzít.",
        hotovo: "Příjmy a výdaje převzaty do analýzy.",
        chybaRazitka: "Čísla jsou v analýze, ale označení „převzato“ se neuložilo — upozornění se může ukázat znovu.",
        chyba: "Převzetí se nepodařilo.",
        chybaNacteni: "Odpovědi klienta se nepodařilo načíst.",
        pole: {
          prokaz1: "Osoba 1 — doložitelný příjem",
          ostatni1: "Osoba 1 — podnikání / ostatní",
          prokaz2: "Osoba 2 — doložitelný příjem",
          ostatni2: "Osoba 2 — podnikání / ostatní",
          pasivni: "Pasivní příjmy",
          bonusyRok: "Bonusy za rok",
          obvykle: "Obvyklé výdaje (včetně pojistného z analýzy)",
          minimalni: "Nezbytné výdaje",
          rozpis: "Položek v rozpisu výdajů",
        },
      },
      nadpis: "Formuláře pro klienta",
      popis: "Vyberte typ, vygenerujte odkaz a pošlete ho klientovi svým kanálem. Aplikace nic neodesílá sama.",
      typ: "Typ formuláře",
      platnost: "Platnost odkazu",
      dnu: "{n} dní",
      vytvorit: "Vytvořit odkaz",
      vytvarim: "Vytvářím…",
      zkopirovat: "Zkopírovat odkaz",
      zkopirovano: "Zkopírováno",
      zkopirovatZpravu: "Zkopírovat zprávu klientovi",
      zneplatnit: "Zneplatnit",
      zneplatnitPotvrzeni: "Opravdu zneplatnit? Klient odkaz už neotevře.",
      stavCeka: "Čeká na klienta",
      stavRozpracovano: "Rozpracováno",
      stavVyplneno: "Vyplněno",
      stavVyprselo: "Odkaz vypršel",
      stavZneplatneno: "Zneplatněno",
      stavOdvolano: "Klient odvolal souhlas",
      zobrazit: "Zobrazit odpovědi",
      skryt: "Skrýt odpovědi",
      zvlastniKategorie: "Zvláštní kategorie — údaje o zdraví",
      zvlastniHint: "Odpovědi jsou šifrované celé a v náhledu se nezobrazují. Každé otevření se zapíše do auditu.",
      kUklidu: "Údaje tu leží déle než {n} dní. Zvažte, jestli je ještě potřebujete.",
      bezFormularu: "Zatím jste klientovi žádný formulář neposlali.",
      chybaNacteni: "Formuláře se nepodařilo načíst.",
      chybaVytvoreni: "Odkaz se nepodařilo vytvořit.",
      chybaOdpovedi: "Odpovědi se nepodařilo načíst.",
      odhalit: "Odhalit",
      platiDo: "Platí do {datum}",
      vyplneno: "Vyplněno {n} z {celkem} polí",
      jazykOdkazu: "Jazyk pro klienta",
      nicNeodesilame: "Odkaz se jen vyrobí. Zprávu pošlete svým kanálem, ať víte, komu jde.",
    },
  },
  /* Porovnávač tří způsobů čerpání renty (/renta-porovnavac).
   * 🔴 PRÁVNÍ: „poučené Nobelovou nadací“ NIKDY ne „portfolio Nobelovy nadace“;
   * modelace ≠ investiční doporučení; historie ≠ příslib budoucího výnosu. */
  /* Kdy budeš volný (KFP 20) — peníze přeložené na čas.
   * 🔴 PRÁVNÍ: modelace ≠ investiční doporučení; výnos je NAD inflací,
   * takže renta je v dnešních penězích. Nesmí se to podat jako příslib. */
  /* Hypotéka — čtyři rozhodnutí (KFP 02, 10, 11, 13).
   * 🔴 PRÁVNÍ: modelace, NE úvěrová ani investiční nabídka. Sazby zadává
   * poradce. Porovnává se celé měsíční zatížení, ne jen splátka. */
  hypoR: {
    zalRefixace: 'Konec fixace',
    zalSplatnost: '20 nebo 30 let',
    zalVyse: 'Kolik vlastních',
    zalCas: 'Vliv času',
    vyseMeneVlastnich: 'Míň vlastních, víc investovat',
    vyseVicVlastnich: 'Víc vlastních, menší úvěr',
    chybiVstupy: 'Doplň vstupy vlevo. Dokud nejsou vyplněné, nic se nedopočítává — prázdné pole není nula.',
    zpet: 'Nástroje',
    nadpis: 'Hypotéka — čtyři rozhodnutí',
    podnadpis: 'Čtyři otázky, které klient u hypotéky opravdu položí. Každá končí jednou větou, ne tabulkou. Porovnává se celé měsíční zatížení — jinak by to bylo srovnávání jablek s hruškami.',
    vstupyLabel: 'Hypotéka klienta',
    cena: 'Cena nemovitosti',
    vlastniA: 'Varianta A — vlastní peníze',
    sazbaA: 'Varianta A — sazba',
    vlastniB: 'Varianta B — vlastní peníze',
    sazbaB: 'Varianta B — sazba',
    sazbaBHint: 'Banka dává lepší sazbu při nižším LTV. Právě o tenhle rozdíl tady jde — bez něj by výpočet neměl smysl.',
    jistina: 'Výše úvěru',
    sazba: 'Sazba',
    splatnost: 'Splatnost',
    let: 'let',
    fixace: 'Fixace',
    kratsi: 'Kratší varianta',
    kratsiHint: 'Delší varianta = pole Splatnost výš. Rozdíl ve splátce se u ní investuje od prvního měsíce.',
    prijem: 'Čistý příjem měsíčně',
    vydaje: 'Ostatní výdaje měsíčně',
    zaLet: 'Podívat se za',
    rustPrijmu: 'Růst příjmu',
    vynos: 'Výnos investice',
    inflace: 'Inflace',
    inflaceHint: 'Každý rozdíl se ukazuje dvakrát: v budoucích penězích (velké číslo) a v dnešních (co si za to klient opravdu koupí).',
    refVerdiktLabel: 'Až skončí fixace',
    refVerdiktVeta: 'měsíčně navíc, kdyby sazba stoupla o 1 p.b. Za zbývajících {roky} let to je {celkem}.',
    refTabulka: 'Splátka podle nové sazby',
    refDnes: 'Dnes',
    refPoznamka: 'Za {roky} let fixace klient splatí {splaceno} z jistiny ({pct} %). Zbytek se přeúvěruje novou sazbou — proto skok ve splátce.',
    splVerdiktLabel: 'Při stejném měsíčním zatížení vyhrává',
    splRemiza: 'shoda',
    splRemizaVeta: 'Obě varianty vycházejí prakticky stejně. Rozhodne, co je klientovi příjemnější.',
    splVerdiktVeta: 'O {rozdil} v budoucích penězích — to je {dnes} v dnešních. Obě varianty stojí klienta stejně {zatizeni} měsíčně.',
    splMajetek: 'Majetek na konci',
    splRadek: '{let} let · splátka {splatka}',
    splPoznamka: 'U delší varianty se rozdíl ve splátce ({rozdil} měsíčně) investuje od prvního měsíce. U kratší se po doplacení začne investovat celá splátka. Proto obě stojí stejně a rozdíl je jen ve výsledku.',
    vyseVerdiktLabel: 'Za {roky} let vyjde líp',
    vyseVerdiktVeta: 'O {rozdil}, což je {dnes} v dnešních penězích.',
    vyseTabulka: 'Obě varianty vedle sebe',
    vyseVlastni: 'Vlastní',
    vyseUver: 'Úvěr',
    vyseSazba: 'Sazba',
    vyseSplatka: 'Splátka',
    vyseVolne: 'Volné na investice',
    vyseMajetek: 'Majetek na konci',
    casVerdiktLabel: 'Splátka se nemění, všechno ostatní ano',
    casVerdiktVeta: 'Podíl splátky na příjmu za {roky} let. Z dluhu přitom {umazala} umaže samotná inflace — bez jediné splátky navíc.',
    casRozpocet: 'Měsíční rozpočet',
    casDnes: 'Dnes',
    casPozdeji: 'Za {roky} let',
    casPrijem: 'Příjem',
    casSplatka: 'Splátka',
    casVydaje: 'Ostatní výdaje',
    casZbyva: 'Zbyde',
    casZatizeni: 'Splátka zabírá z příjmu',
    casPoznamka: 'Zbývající dluh za {roky} let: {nom} nominálně, ale jen {real} v dnešních penězích. Rozdíl {umazala} je práce inflace, ne klienta.',
    disclaimer: 'Modelace, ne úvěrová ani investiční nabídka. Sazby zadává poradce — aplikace netvrdí, že je klient dostane. Výnos investice není zaručený a skutečný výsledek závisí na trzích, daních a poplatcích.',
  },

  svoboda: {
    rok: 'rok',
    roky: 'roky',
    let: 'let',
    mesic: 'měsíc',
    mesice: 'měsíce',
    mesicu: 'měsíců',
    hned: 'hned teď',
    zpet: 'Nástroje',
    nadpis: 'Kdy budeš volný',
    podnadpis: 'Peníze přeložené na čas. Přidej cokoliv navíc a uvidíš, o kolik dřív ti majetek začne platit účty místo práce.',
    nedosazitelneNadpis: 'Takhle se tam nedojde.',
    zNedosazitelnehoNadpis: 'Teď už se tam dojít dá.',
    nedosazitelneText: 'Z toho, co se dnes odkládá, cíl nevyjde ani za celý život. Není to chyba výpočtu — je to zpráva. Zkus zvýšit měsíční odkládání nebo snížit cílovou rentu.',
    zNedosazitelnehoText: 'Původně cíl nevycházel vůbec. Po tomhle navýšení už ano — o kolik dřív se ale říct nedá, protože dřív nebyl žádný termín.',
    ziskLabel: 'Tohle navýšení ti přinese',
    zatimNic: 'zatím nic',
    ziskDovetek: 'dřív, než kdyby všechno zůstalo, jak je',
    ziskVyzva: 'posuň posuvníky dole a uvidíš, co to udělá',
    dnesPlan: 'Dnešní plán',
    sNavysenim: 'S navýšením',
    osaLabel: 'Cesta k nezávislosti',
    zaStropem: 'Termín je za koncem osy — značka stojí na hraně.',
    dnes: 'dnes',
    cilKapital: 'Cíl',
    cilVysvetleni: '= renta {renta} měsíčně v dnešních penězích',
    vstupyLabel: 'Jak to má dnes',
    renta: 'Renta, kterou chce měsíčně',
    rentaHint: 'V dnešních penězích. Kolik by musel dostávat, aby nemusel chodit do práce.',
    majetek: 'Co na to už má',
    majetekHint: 'Investice a úspory, které jsou opravdu na tenhle cíl — ne rezerva a ne peníze na auto.',
    mesicne: 'Kolik odkládá měsíčně',
    vynos: 'Výnos nad inflací',
    vynosHint: 'NAD inflací, ne celkový. Proto jsou čísla nižší, než klient čeká — a proto je renta v dnešních penězích.',
    coKdyby: 'A co kdyby přidal',
    jednorazove: 'Jednorázově teď',
    skokNula: 'nic',
    navic: 'Měsíčně navíc',
    pomerLabel: 'Co za to',
    pomerText: 'Za {penize} navíc dostane {cas} života, ve kterém nemusí.',
    cokdybyPrazdno: 'Posuvníky jsou na nule. Zvedni jeden a sleduj, jak se akcentová značka na ose rozjede doleva.',
    cekaniLabel: 'Cena za čekání',
    cekaniText: 'Kdyby se začalo až později. Peníze zatím leží na účtu — nominálně stejné, reálně je užírá inflace. Právě proto je ztráta větší než samotné čekání.',
    inflace: 'Inflace',
    cekaniOdklad: 'Začne o {doba} později',
    cekaniNedosazitelne: 'už to nevyjde',
    cekaniDovetek: 'déle než dnes',
    disclaimer: 'Modelace, ne investiční doporučení a ne příslib výnosu. Počítá se v dnešních penězích (výnos je zadaný nad inflací). Skutečný výsledek závisí na vývoji trhů, daních a poplatcích.',
  },

  rentaPorov: {
    zPlanuOdkaz: "Porovnat tři způsoby čerpání",
    zaMesic: "/měs",
    zpusobPevne: "Pevné procento",
    zpusobKlouzavy: "Klouzavý průměr",
    zpusobMantinely: "Mantinely",
    jakPevne: "{pct} z hodnoty, jaká právě je",
    jakKlouzavy: "{pct} z průměru za {let} let",
    jakMantinely: "start {pct}, pak úprava dle pravidel",
    vyhodaPevne: "Kapitál teoreticky nikdy nedojde — bere se vždycky jen část.",
    vyhodaKlouzavy: "Renta je klidnější, jeden špatný rok ji nestrhne celou.",
    vyhodaMantinely: "Nejvyšší renta na začátku.",
    presetPoucene: "Poučené Nobelem",
    presetOpatrne: "Opatrné",
    presetDynamicke: "Dynamické",
    cenaPevne: "Renta kolísá s trhem naplno a hned.",
    cenaKlouzavy: "Po propadu vyplácí víc, než odpovídá hodnotě portfolia.",
    cenaMantinely: "Škrty, když trh nevyjde. Není to lepší pravidlo — je to jiné riziko.",
    rok: "Rok",
    mil: "mil.",
    tis: "tis.",
    zpet: "Zpět na Nástroje",
    kicker: "Čerpání renty",
    title: "Tři způsoby čerpání vedle sebe",
    subtitle: "Stejný kapitál, tři pravidla výběru. Kolik klient dostane měsíčně, co mu zbude — a co ho to bude stát.",
    zPlanu: "Kapitál převzatý z plánu klienta",
    pouceneTitul: "Portfolio poučené Nobelovou nadací",
    pouceneText: "Nobelova nadace cílí na 3 % reálného výnosu ročně a vedle akcií, dluhopisů a hotovosti drží zhruba pětinu v alternativách a desetinu v nemovitostech a infrastruktuře. Ty tady nemodelujeme. Alokace níž je naše zjednodušení pro klienta, který je nemá — není to portfolio Nobelovy nadace.",
    jenModelace: "Je to modelace, ne investiční doporučení.",
    vstupyTitul: "Z čeho se čerpá",
    vstupyPopis: "Všechny částky jsou reálné, v dnešních cenách — výnosy jsou už nad inflací a renta se nevalorizuje.",
    kapital: "Kapitál k čerpání",
    roky: "Jak dlouho čerpat",
    letPocet: "{n} let",
    alokace: "Alokace portfolia",
    vynosPortfolia: "Reálný výnos portfolia",
    paNadInflaci: "p.a. nad inflací",
    akcie: "Akcie",
    dluhopisy: "Dluhopisy",
    penezniTrh: "Peněžní trh",
    scenar: "Scénář výnosů",
    scenarModel: "Modelový výnos",
    scenarHistorie: "Skutečná historie",
    scenarPoradi: "Tytéž roky pozpátku",
    scenarModelHint: "Každý rok stejně: {pct}. Ukazuje princip, ne realitu — trh takhle nikdy nejde.",
    scenarHistorieHint: "Roky {od}–{do} tak, jak opravdu proběhly. Reálně, po inflaci. Není to předpověď, jen odpověď na otázku „co kdyby se to zopakovalo“.",
    scenarPoradiHint: "Stejná množina výnosů, stejný průměr — jen obrácené pořadí. Ukazuje riziko pořadí výnosů.",
    startRok: "Start v roce",
    historieKratsi: "Od roku {rok} má historie jen {let} let. Počítá se kratší běh — nic se nedopočítává modelem.",
    cpiNespolehliva: "Data o inflaci jsou v letech 1927–1946 plochá. Reálné výnosy z takhle starého startu proto nejsou spolehlivé.",
    pokrocile: "Pokročilé nastavení",
    sazbaCerpani: "Sazba čerpání",
    startMantinelu: "Start mantinelů",
    oknoLet: "Okno klouzavého průměru",
    naStartuMes: "Na startu měsíčně",
    rozpetiRenty: "Rozpětí renty",
    zbudePo: "Zbude po {let} letech",
    celkemVyplaceno: "Celkem vyplaceno",
    nejhlubsiPropad: "Nejhlubší propad renty",
    vRoce: "{rok}. rok",
    bezPropadu: "renta neklesla",
    kapitalDosel: "Kapitál došel v {rok}. roce",
    pocetSkrtu: "{n}× škrt",
    pocetZvyseni: "{n}× zvýšení",
    nadvyplata: "Za celý horizont je to {castka} navíc oproti pevnému procentu.",
    cenaTitul: "Co stojí vyšší renta na začátku",
    cenaPopis: "Mantinely nejsou „lepší 4% pravidlo“. Vyměňujete menší riziko, že peníze dojdou, za střední riziko velkých škrtů na mnoho let.",
    cenaPridano: "Na startu navíc",
    cenaOprotiPevnemu: "oproti pevnému procentu",
    cenaSkrtStitek: "Cena, kterou to má",
    cenaSkrtVeta: "V {rok}. roce by se renta musela snížit o {pct}",
    cenaSkrtZNa: "z {z} na {na} měsíčně",
    cenaSkrtuCelkem: "za celý horizont {n} škrtů",
    cenaDno: "Nejhlouběji: {pct} pod nejvyšší rentou ({rok}. rok) — {castka} měsíčně",
    cenaBezSkrtuStitek: "V tomhle scénáři se neškrtá",
    cenaBezSkrtu: "To ale neznamená, že by se nemuselo škrtat nikdy. Podívejte se na doložené roky níž — v nich se škrtat muselo.",
    cenaVycerpano: "V tomhle scénáři by kapitál došel v {rok}. roce.",
    dolozenoTitul: "Doloženo na skutečných letech",
    dolozenoKdo: "Kdo začal čerpat v roce {rok}",
    dolozenoKratsi: "tolik dat historie má",
    dolozenoDno: "dno renty −{pct}",
    dolozenoSkrty: "{n} škrtů, první v {rok}. roce, dno −{pct}",
    dolozenoBezSkrtu: "bez škrtů",
    dolozeno1966: "V sedmdesátých letech neztrácely jen akcie — inflace sežrala i dluhopisy a peněžní trh. Diverzifikace tehdy nepomohla.",
    dolozeno2000: "Rok 2000 byl problém akcií. Dluhopisy a peněžní trh tehdy vydělávaly, takže portfolio s jejich podílem drželo líp.",
    dolozenoObecne: "Historická řada z tohoto startu, reálně po inflaci.",
    grafRenta: "Měsíční renta v čase",
    grafRentaPopis: "Tohle klient opravdu dostane na účet. V dnešních cenách.",
    grafKapital: "Kapitál v čase",
    grafKapitalPopis: "Co zbývá na účtu. Nula znamená, že peníze došly.",
    poradiTitul: "Riziko pořadí výnosů",
    poradiPopis: "Stejné roky, stejný průměrný výnos — jen v jiném pořadí. Propad na začátku čerpání je zabiják, protože se prodává dole.",
    poradiVpred: "Jak roky {od}–{do} opravdu proběhly",
    poradiVzad: "Tytéž roky pozpátku",
    poradiVyplaceno: "Klient dostal celkem",
    poradiKapital: "Na konci zbylo",
    poradiDno: "Dno renty",
    poradiSkrtu: "Škrtů u mantinelů",
    poradiZaverShoda: "Na konci zbude úplně stejný kapitál, ale do ruky klient dostal {pomer}× jiné peníze. Celé to riziko sedí v příjmu, ne na výpisu z účtu.",
    poradiZaverObecne: "Pořadí let změnilo výplatu {pomer}×.",
    prehledTitul: "Všechny historické starty",
    prehledPopis: "{n} běhů dlouhých {let} let, roky {od}–{do}. Reálně, po inflaci.",
    prehledSelhani: "Skončilo bez peněz",
    prehledSelhaniPocet: "{n} z {celkem}",
    prehledZadne: "žádný",
    prehledMedianDno: "Obvyklý propad renty",
    prehledNejhorsiDno: "Nejhlubší propad",
    prehledNejhorsiStart: "Nejhorší start",
    prehledDoslo: "{rok} — došlo v {kdy}. roce",
    prehledPozor: "Nula selhání není důkaz bezpečnosti. U pevného procenta se bere vždycky jen část toho, co zbylo — účet nedojde, ani kdyby renta spadla skoro na nulu. Proto vedle počtu selhání čtěte propad renty.",
    pravniTitul: "Co tahle stránka je a co není",
    pravni1: "Modelace, ne investiční doporučení. Neposuzuje situaci, znalosti ani cíle konkrétního klienta.",
    pravni2: "Historická data nejsou příslibem budoucího výnosu. Trhy mohou klesnout a klesat budou.",
    pravni3: "Portfolio poučené Nobelovou nadací — ne portfolio Nobelovy nadace. Nobel drží i alternativy (~20 %) a nemovitosti (~9 %), které tady nejsou, a cílí na 3 % reálně.",
    pravni4: "Všechny částky jsou reálné, v dnešních cenách. Výnosy jsou už nad inflací, renta se nevalorizuje.",
    pravni5: "Historická řada jsou americká data (akcie, státní dluhopisy, pokladniční poukázky) přepočtená na reálné výnosy americkou inflací. České portfolio se chová jinak.",
  },
  manazerUi: {
    obnovit: 'Obnovit',
    pozvankyDole: 'Vytvořené pozvánky najdeš dole mezi kartami poradců — i s odkazem a hotovým textem zprávy.',
    pridatPoradce: 'Přidat poradce do týmu',
    pridatPoradceHint: 'Zadej email poradce. Vytvoří se pozvánka, kterou musí sám přijmout v Nastavení — teprve pak uvidíš jeho klienty, pipeline, diář a cíle. E-mail zatím neposíláme, řekni mu to.',
    vytvoritPozvanku: 'Vytvořit pozvánku',
    zadnyTym: 'Zatím žádný tým',
    zadnyTymHint: 'Pozvi poradce tlačítkem výše. Objeví se tady, jakmile pozvánku ve svém Nastavení přijme — do té doby jeho data nevidíš. Pak uvidíš jeho výkon a budeš mu moct zadávat úkoly.',
  },
  naborUi: {
    hledatKandidata: 'Hledat kandidáta…',
    nikdoSeNenasel: 'Nikdo se nenašel',
    klikniAUvidis: 'Klikni a uvidíš, o koho jde',
    coJeNabor: '📣 Co je nábor:',
    coJeNaborText: 'lákáš zkušené poradce z konkurence.',
    eyebrow: 'Náborová pipeline',
    inProc: 'v procesu',
    kpiPipe: 'V náboru',
    krok1: 'přidej kandidáta',
    krok2: 'vyplň jeho čísla (produkce, síť, kmen) — spočítáme skóre 🔥',
    krok3: 'pošleš mu neodmítnutelnou nabídku na jeho čísla',
    krok4: 'táhneš kartu pipelinou až po „aktivní“.',
    prvniKandidat: 'Přidej prvního kandidáta',
    sub: 'Nábor poradců z konkurence · skóre = produkce × síť × kmen · táhni kartou mezi fázemi',
    title: 'Nábor',
    zadnyKandidat: 'Zatím žádný kandidát',
    zadnyKandidatHint: 'Začni s jedním jménem z konkurence, koho bys chtěl v týmu. Přidáš ho, vyplníš jeho čísla a spočítáme, jak moc se mu vyplatí jít k tobě.',
  },
  motivApp: {
    aktivni: 'Aktivní',
    midnight: 'Tmavý — na večerní práci',
    violet: 'Výrazné, mladistvé, jiné',
    lime: 'Technické, kontrastní, ostré',
    cobalt: 'Studený akcent, teplá plocha',
    indigo: 'Čisté, datasy, fintech',
    legenda: 'Motiv aplikace',
    sage: 'Teplé, organické, jistota',
    vybrat: 'Přepnout motiv aplikace na',
  },
  pojVar: {
    cena: 'Řeším jen cenu',
    cenaPopis: 'nezbytné výdaje, cíle −60 %',
    narocna: 'Pro náročné',
    narocnaPopis: 'cíle i výdaje v plné výši',
    sablonaUpozorneni: 'Šablonové částky z praxe poradce — orientační vzor, ne nabídka ani garance. Konkrétní limity a ceny ověří poradce u pojišťovny.',
    stredni: 'Zlatá střední',
    stredniPopis: 'cíle −30 %, výdaje beze změny',
    uskromnit: 'Uskromnit se',
    uskromnitPopis: 'nezbytné výdaje, cíle −50 %',
    variantaBezKratceni: 'varianta škrtá CÍLE, ne životní úroveň. Dluhy se nekrátí nikdy.',
  },
  davkyUi: {
    invalidI: 'Invalidní důchod I. stupně',
    invalidIHint: 'částečné omezení práce',
    invalidII: 'Invalidní důchod II. stupně',
    invalidIIHint: 'vážné omezení práce',
    invalidIII: 'Invalidní důchod III. stupně',
    invalidIIIHint: 'úplná invalidita — nemůžete pracovat',
    nemocenska: 'Nemocenská (od 15. dne)',
    nemocenskaHint: 'krátká nemoc / úraz — 60 % redukovaného základu',
    poznamka: 'Orientační odhad podle pravidel platných od 1. 1. 2025. Hodnoty se každý leden mění — poradce ověří aktuální čísla ČSSZ. Není garance ani nabídka.',
    starobni: 'Starobní důchod',
    starobniHint: 'odhad, kdybyste šel do penze s dnešním příjmem (bez valorizace)',
  },
  duchodCil: {
    nazev: 'Do důchodu — udržet standard',
  },
  zdrojAnalyza: {
    naposledy: 'Naposledy aktualizováno',
    vysvetleni: 'Přeneseno z finanční analýzy. Částky a název přepisuje analýza, poznámky a adresu si drží poradce.',
    zaklad: 'z analýzy',
  },
  osaObchodu: {
    bezData: 'bez data',
    bezDataHlavicka: 'Bez data',
    diar: 'diář',
    dnes: 'Dnes',
    faze: 'fáze',
    naplanovano: 'naplánováno',
    poznamkaChyba: 'Úpravu se nepodařilo uložit',
    poznamkaDlouha: 'Poznámka je příliš dlouhá ({delka} z max {max} znaků).',
    poznamkaPrazdna: 'Poznámka nemůže být prázdná.',
    poznamkaUlozena: 'Poznámka upravena',
    prazdna: 'Žádná aktivita zatím. Přidej první poznámku níže.',
    stav: { deleted: 'zrušeno', detached: 'odpojeno', done: 'splněno', planned: 'čeká' },
    typ: { call: 'hovor', email: 'e-mail', note: 'poznámka', sms: 'SMS', system: 'systém' },
    ulozit: 'Uložit',
    upraveno: 'upraveno',
    upravenoTitul: 'Upraveno',
    upravitPoznamku: 'Upravit poznámku',
    zaznamu: 'záznamů',
    zeZalozeni: 'ze založení',
    zobrazitStarsi: 'Zobrazit starší ({pocet})',
    zrusit: 'Zrušit',
  },
  /* M13 · rizika samotného dítěte v Návrhu řešení — components/plan/DetskaRizikaBlok.js */
  /* BLOK:detiRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  detiRizika: {
    deti: 'Děti ({n}×)',
    dite: 'Dítě',
    hlavicka: 'dětská smlouva',
    hlavickaKazde: 'částky na každé dítě',
    hospitalizace: 'Hospitalizace',
    hospitalizacePozn: 'za každou noc v nemocnici — rodič je u dítěte a nepracuje, ošetřovné kryje jen část',
    kojenec: 'do 1 roku',
    naDite: ' / dítě',
    nadpis: 'Pojistná ochrana dítěte ({n}×)',
    odskodne: 'Denní odškodné za dobu léčení úrazu',
    odskodnePozn: 'od prvního dne léčení, bez karence — doléčení doma stojí rodiče další dny v práci',
    odskodneStrop: 'Denní dávky jsou nad čistým denním příjmem pečujícího rodiče ({strop}) — nad upisovacím stropem, ověřte u pojišťovny.',
    pc: 'Pojistná částka na smlouvě dítěte',
    pcPozn: 'součet obou položek výše, oříznutý stropem pojistitelnosti',
    radekTrvale: 'Trvalé následky a péče',
    rodic: 'rodič',
    sablona: 'ŠABLONA',
    sablonaPozn: 'Částky jsou vzor z praxe poradce, ne nabídka ani garance. Konkrétní limity, výluky a cenu ověří poradce u pojišťovny.',
    sekceTrvale: 'Když dítě zůstane trvale závislé na péči',
    sekceVlastni: 'Rizika samotného dítěte — samostatné připojistky',
    stitekNadStropem: 'nad stropem',
    stitekSablona: 'šablona',
    strop: 'Celá potřeba je {potreba}; pojišťovny na dětské smlouvě upíšou řádově do {strop}. Zbytek {zbytek} patří do rezervy a investičního plánu, ne do pojistky.',
    tnu: 'Trvalé následky úrazu dítěte',
    tnuPozn: 'progresivní plnění po pásmech — v našem modelu nejvýš 2,8× částky, u pojišťoven se liší',
    uvod: 'U dítěte se nepojišťuje jeho příjem — ten zatím žádný nemá. Pojišťuje se to, co rodinu reálně stojí peníze: rodič, který kvůli péči nebo léčbě vypadne z práce, a náklady léčby.',
    vekFew: '{n} roky',
    vekMany: '{n} let',
    vekOne: '{n} rok',
    vypadekRodice: 'Výpadek příjmu pečujícího rodiče',
    vypadl: 'vypadl by {kdo}',
    vypadlAuto: 'vypadl by {kdo} — předpoklad, počítá se rodič s nižším příjmem',
    zaDen: '/den',
    zaNoc: '/noc',
    zavazne: 'Závažná onemocnění',
    zavazneBezZakladu: 'Pečující rodič nemá v analýze vyplněný příjem — částku doplní poradce, systém si ji nevymýšlí.',
    zavaznePozn: 'leukémie, nádory, cukrovka I. typu, epilepsie — jednorázová výplata na léčbu a na to, aby rodič mohl zůstat s dítětem doma',
    zavazneStrop: 'Spočítaná potřeba z příjmu pečujícího rodiče je {potreba}; dětské smlouvy kryjí řádově do {strop}. Zbytek {zbytek} patří do rezervy.',
  },
  /* BLOK:detiRizika END */

  /* BLOK:zivotkoKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoKalk: {
    celkemMesicne: 'Celkem měsíčně',
    cenaNadpis: 'Cena krytí (pojistné)',
    cenaPopis: 'Zadej reálné měsíční pojistné z vybrané pojišťovny — spočítá se celková cena ochrany.',
    cil: 'Cíl',
    cilBydleni: 'Doplatit bydlení',
    cilDuchod: 'Důchod',
    cilVzdelani: 'Vzdělání dětí',
    cileMale: 'cíle',
    cilePlanNadpis: 'Cíle — kolik měsíčně investovat',
    cilePlanPopis: 'Při výnosu {vynos} % ročně. Renta se přepočte na kapitál koeficientem ×{nasobek} — to je {pct} % bezpečného čerpání ročně (1 mil. = {koef}).',
    cilePripocet: 'Částka se připočte ke krytí (smrt/invalidita). Fin. nezávislost = renta → investiční plán níže (kolik měsíčně investovat).',
    cileRodiny: 'Cíle rodiny',
    cileZadanych: 'Cíle: zadaných',
    cilovaCastka: 'Cílová částka',
    cistyPrijem: 'Čistý měsíční příjem',
    cistyPrijemMaly: 'čistý příjem',
    davkyNadpis: 'Přehled státních dávek a výpadky příjmu',
    davkyPopis: 'Kolik klient reálně dostane od státu — a kolik mu každý měsíc chybí. Orientační odhad z příjmu a věku.',
    davkyPoznamka: 'Orientační odhad (skutečnost dle ČSSZ se může lišit). Doplň věk u osoby pro přesnější odhad.',
    davkyPoznamkaKratka: 'Orientační odhad (skutečnost dle ČSSZ se může lišit).',
    den: 'den',
    denNaHlavu: 'den na hlavu',
    denniDavkyPn: 'Denní dávky (PN)',
    dluhy: 'Dluhy (k doplacení)',
    dluhyMale: 'dluhy',
    dnesniHodnota: 'dnešní hodnota',
    do1Roku: 'do 1 roku',
    grafNadpis: 'Co zbude, když ubude příjem',
    grafPopis: 'Zelené je polštář — co zbyde, když se zaplatí to, co se zaplatit musí.',
    hned: 'hned',
    invDuchodPodleZakona: 'podle zákona',
    invalidita: 'Invalidita',
    invalidniDuchodMaly: 'invalidní důchod',
    invalidniDuchodMes: 'Invalidní důchod / měs',
    jehoPodil: 'jeho podíl',
    klient: 'Klient',
    likvidniRezerva: 'Likvidní rezerva',
    mesTecka: 'měs.',
    mesZkratka: 'měs',
    mesicneInvestovat: 'Měsíčně investovat',
    naXLet: 'na {roky} let',
    navrhOchrany: 'Návrh ochrany rodiny',
    nazevCile: 'Název cíle',
    nejvetsiDopad: 'Největší dopad',
    nemocenska: 'nemocenská',
    nezbytneVydaje: 'Nezbytné výdaje / měs',
    odMesice: 'od {n}. měsíce',
    odPrvnihoDne: 'od 1. dne',
    odkazTitle: 'Poslat klientovi odkaz na tuto modelaci',
    osoba: 'Osoba',
    osobaN: 'Osoba {n}',
    osobaPlaceholder: 'Osoba {n} — jméno',
    osvc: 'OSVČ',
    osvcPlne: 'OSVČ (bez nemocenského)',
    osvcVarovani: 'Při pracovní neschopnosti nedostane od státu nic → vyšší potřeba PN.',
    paramKoefRenty: 'Koeficient renty',
    paramKoefRentyHint: '= {pct} % bezpečného čerpání ročně · renta → kapitál ×{nasobek} (nižší částka = vyšší násobek)',
    paramNarust: 'Nárůst výdajů při invaliditě',
    paramNarustHint: 'péče, úpravy bytu, léky',
    paramPokles: 'Pokles výdajů při úmrtí',
    paramPoklesHint: 'rodina po ztrátě člena utratí méně',
    paramTnPrah: 'TN práh (od kolika % plní)',
    paramTnPrahHint: 'pod prahem se neplní; plné krytí cca při 60 %',
    paramVynos: 'Výnos investice (p. a.)',
    paramVynosHint: 'pro výpočet měsíční investice na cíle',
    parametryMetodiky: 'Parametry metodiky',
    patickaDavky: 'Sociální dávky (vdovský {vdovsky}{sirotci}, invalidní důchod) jsou ORIENTAČNÍ ODHAD z příjmu — ne příslib státu. Skutečnou výši ověří poradce.',
    patickaMetodika: 'Orientační doporučené krytí dle metodiky beplan (metodika {verze}): invalidita/smrt kapitálovou metodou @ 4 % reálně — výdaje domácnosti po události minus příjmy, které rodině zůstanou, minus státní dávky. PN = čistý příjem − nemocenská. Konkrétní pojistné a podmínky dle vybrané pojišťovny. Poradce má poslední slovo.',
    patickaSirotci: ', sirotčí celkem {castka}',
    pdfInvaliditaPopis: 'když už nemůžete pracovat',
    pdfJakRozumet: '<b>Jak tomu rozumět:</b> Čísla říkají, kolik by rodina dostala, kdyby se stalo to nejhorší — aby mohla dál bydlet, žít ve svém standardu a děti dostudovaly. <b>Invalidita</b> má vyšší částku než smrt, protože nemocný člověk doma potřebuje navíc péči a úpravy. <b>Pracovní neschopnost</b> dorovnává výpadek příjmu při krátké nemoci nebo úrazu.',
    pdfPaticka: 'Nezávazný orientační návrh. Konkrétní podmínky a ceny upřesníme společně.',
    pdfPnPopis: 'krátká nemoc nebo úraz',
    pdfSmrtPopis: 'aby se rodina o nic nemusela bát',
    pdfTitle: 'Stáhnout / vytisknout PDF pro klienta',
    pdfTnuPopis: 'vážnější úraz = vyšší výplata',
    pdfZavaznePopis: 'rakovina, infarkt, mrtvice…',
    perex: 'Zadej příjmy a výdaje rodiny → spočítám doporučené krytí: invalidita, smrt, pracovní neschopnost, trvalé následky a závažná onemocnění.',
    pnCelkem: 'Rodina potřebuje PN celkem',
    pnUraz: 'Prac. neschopnost / úraz',
    pocetDeti: 'Počet dětí',
    podPrahem: '→ pod prahem',
    podilDluhu: 'podíl dluhů',
    podilNezbytnych: 'podíl nezbytných',
    pojistnaCastka: 'Pojistná částka:',
    poskozeni: 'poškození',
    poslatKlientovi: 'Poslat klientovi',
    potrebnyKapital: 'Potřebný kapitál',
    pozustalostniDavky: 'pozůstalostní dávky',
    pracNeschopnost: 'Prac. neschopnost',
    pracovniNeschopnost: 'Pracovní neschopnost',
    prezentovat: 'Prezentovat',
    pridatCil: 'Přidat cíl',
    pridatOsobu: 'Přidat osobu',
    prijemMaly: 'příjem',
    prijmyOstatnich: 'příjmy ostatních',
    procInvalidita: 'Příjem zmizí napořád a výdaje NAROSTOU (pečovatel, úpravy). Často zničí rodinu rychleji než smrt — proto je č. 1.',
    procNadpis: 'Proč je tahle ochrana důležitá',
    procPn: 'Nemoc či úraz na pár měsíců: stát dá málo (OSVČ nic). Denní dávka dorovná výpadek — doma řešíte uzdravení, ne účty.',
    procSmrt: 'Aby po živiteli zůstala rodině jistota, ne dluhy a hypotéka. Děti dostudují, partner nemusí měnit život.',
    procTnu: 'Vážný úraz = trvalé omezení. Progresivní plnění: čím vážnější, tím vyšší jednorázová výplata na úpravy a život.',
    progresivni: 'progresivní',
    renta: 'renta',
    rentaMes: 'Renta / měs',
    rezervaHint: 'vydrží ~{mes} měs.',
    rezervaPokryje: 'rezerva pokryje prvních {mes} měs., dávka navržena od {odMes}. měsíce',
    rodina: 'Rodina',
    sloupecChybi: 'Chybí /měs',
    sloupecChybiMes: 'Chybí / měs',
    sloupecDokryt: 'Dokrýt pojistkou',
    sloupecDostane: 'Dostane od státu',
    sloupecSituace: 'Situace',
    sloupecStat: 'Stát /měs',
    sloupecStupen: 'Stupeň',
    smrt: 'Smrt',
    stupneNadpis: 'Invalidita podle stupně',
    stupneNota: 'Sloupec dokrýt pojistkou = kapitál, aby výpadek pokryl na {roky} let.',
    stupnePopis: 'Vyšší stupeň = vyšší dávka od státu, ale i vyšší ztráta příjmu → víc dokrýt pojistkou. III. = úplná invalidita (nemůže pracovat), I. = částečné omezení.',
    tela: 'těla',
    titul: 'Kalkulačka životního pojištění',
    tnuNadpis: 'Trvalé následky — progresivní plnění',
    tnuPrah: 'Plní se od {prah} % poškození, plné potřebné krytí cca při 60 %.',
    tnuVzorec: 'Výplata = částka × násobek × %.',
    tnuZeCastky: 'Z pojistné částky',
    toJePctPrijmu: 'to je {pct} % čistého příjmu rodiny',
    trvaleNasledky: 'Trvalé následky',
    trvaleNasledkyUrazu: 'Trvalé následky úrazu',
    typCastka: 'Částka',
    typRenta: 'Fin. nezávislost',
    uvodniZprava: 'Dobrý den, posílám návrh ochrany vaší rodiny — kolik by rodina potřebovala, kdyby se něco stalo. Mrkněte a kdyžtak se ozvěte.',
    variantaKryti: 'Varianta krytí (smrt + invalidita)',
    variantaKrytiKratce: 'Varianta krytí',
    variantaSlovo: 'varianta',
    vek: 'Věk (let)',
    vekHint: 'pro přehled státních dávek',
    vekPrijem: '{vek} let · příjem {castka}',
    vydajeRodiny: 'výdaje rodiny',
    vyssiVydaje: 'o {pct} % vyšší výdaje (péče, úpravy)',
    waTitle: 'Poslat návrh klientovi přes WhatsApp',
    xLet: '{n} let',
    xOsob: '{n} osob',
    xRocniPrijem: '{n}× roční příjem',
    zaKolikLet: 'Za kolik let',
    zadejPrijem: 'Zadej aspoň jeden příjem.',
    zajistitNa: 'Zajistit na (let)',
    zamestnanec: 'Zaměstnanec',
    zavazneOnemocneni: 'Závažná onemocnění',
  },
  /* BLOK:zivotkoKalk END */
  rozvahaGraf: {
    bezOceneni: 'Bez ocenění zůstává {pocet} {polozka} — do součtu se nepočítají.',
    cisteJmeni: 'Čisté jmění',
    cisteJmeniPod: 'co vlastní minus co dluží',
    coDluzi: 'Co dluží',
    coVlastni: 'Co vlastní',
    financni: 'Finanční majetek',
    nefinancni: 'Nemovitosti a věci',
    podilDluhu: 'Dluh tvoří {pct} % majetku — zbytek je opravdu jeho.',
    vecnyMajetek: 'Z toho věcný majetek',
    zavazky: 'Závazky',
  },
  menaAnalyzy: {
    bezRazitka: 'Tahle analýza je z doby, kdy se měna do dat neukládala — čteme ji jako {mena}. Účet dnes pracuje v {ucet}.',
    neprepocitava: 'Částky se NEPŘEPOČÍTÁVAJÍ — zůstávají tak, jak byly zadané, aplikace nezná kurz. Popisky níž ukazují {symbol}. Než čísla ukážete klientovi, ověřte je.',
    pozor: 'Pozor na měnu.',
    ulozena: 'Analýza je uložená v {mena}, účet dnes pracuje v {ucet}.',
  },
  zivotkoGraf: {
    celyPrijem: '— celý příjem',
    cenaDenne: '{castka} na den na každého z {hlav} členů rodiny.',
    cenaInvalidita: 'invalidita',
    cenaPctPrijmu: 'To je {pct} % vašeho příjmu.',
    cenaPresahuje: 'Přesahuje ho — a schovávat se to nebude.',
    cenaSablona: 'Řádový odhad z našeho vzorníku sazeb — ŠABLONA, ne nabídka. Přesnou cenu dá pojišťovna podle věku a zdravotního dotazníku.',
    cenaSmrt: 'smrt',
    cenaStrop: 'Strop {pct} % příjmu = {castka}.',
    cenaVejde: 'Vejde se do něj.',
    cenaZavira: 'Zavírá to díru, kterou jste viděli:',
    davkaInvalidIII: 'Invalidní důchod',
    davkaNemocenska: 'Nemocenská',
    davkaObecna: 'Dávka',
    davkaPozustalostni: 'Vdovský + sirotčí',
    mesZkr: 'měs.',
    mesZkratka: 'měs',
    nazevDnes: 'Dnes',
    nazevInvalidita3: 'Invalidita III. stupně',
    nazevMzda5: 'Šéf ubere 5 %',
    nazevPn: 'Dlouhá nemoc',
    nazevSmrt: 'Smrt živitele',
    popisChybi: 'Chybí každý měsíc.',
    popisDnes: 'Tolik vám zbývá, když je všechno v pořádku.',
    popisDnesNapjato: 'Rozpočet je napnutý už dnes — polštář žádný není.',
    popisNastve: 'Naštve vás to. Ale vyřešíte to sami.',
    popisRezervaMesice: 'Rezerva to utáhne {mes} měsíce.',
    popisRezervaZadna: 'Rezerva na to není žádná.',
    popisZvladnete: 'Zvládnete to. Skončí spoření a dovolená.',
    proporceNecerpa: 'Rezerva se nečerpá — příjem a dávky výdaje pokryjí.',
    proporceRezerva: 'Vaše rezerva',
    proporceSchodek: 'Při schodku {castka} měsíčně pokryje rezerva {pct} % té doby.',
    proporceStat: 'Stát u nemoci — podpůrčí doba',
    proporceStrop: 'Nemocenská má strop {dni} dnů.',
    proporceTrvani: 'Do důchodu zbývá',
    proporceVek: '{vek} let, do důchodu ({duchodVek}) zbývá {roky} let.',
    vynechanoCena: 'Krok s cenou je vynechaný: cena krytí není zadaná ani ji nejde odhadnout.',
    vynechanoHlavy: 'Denní rozklad ceny se neukáže: není z čeho spočítat počet osob v rodině.',
    vynechanoMena: 'Graf se nezobrazí: státní dávky umí appka zatím jen pro ČR. České dávky vydělené kurzem nejsou slovenské dávky.',
    vynechanoPoDuchodu: 'Krok „jak dlouho to trvá“ je vynechaný: hlavní osoba je v důchodovém věku.',
    vynechanoPrijem: 'Graf se nezobrazí: není zadaný ani jeden příjem. Bez příjmu by všechny schody byly nula.',
    vynechanoVek: 'Krok „jak dlouho to trvá“ je vynechaný: u hlavní osoby chybí věk.',
    vynechanoVydaje: 'Graf se nezobrazí: nejsou zadané nezbytné výdaje. Bez nich není proti čemu příjem měřit.',
  },
  navrhVystupy: {
    jednaStrana: '1 strana',
    jednaStranaTitul: 'Plán na jednu stranu',
    plnyPlan: 'Plný plán',
    plnyPlanTitul: 'Plný finanční plán',
    poznamka: 'Poznámka k návrhu',
  },
  /* Klientská složka. Všech 17 klíčů níž bylo do 21. 8. 2026 psáno jako
   * ternár s DVĚMA STEJNÝMI větvemi (`lang === "sk" ? "Kraj" : "Kraj"`) —
   * čirý balast: nepřekládaly ani do slovenštiny, kvůli které vznikly. */
  slozkaKlienta: {
    adresyKontakty: 'Adresy a kontakty',
    aktivita: 'Aktivita',
    analyza: 'Analýza',
    kraj: 'Kraj',
    mobil: 'mobil',
    nabor: 'NÁBOR',
    odhadPotencialu: 'Odhad potenciálu klienta',
    prijmeniPriklad: 'Novák',
    sidloKlienta: 'Sídlo klienta',
    stitky: 'Štítky',
    vlastnik: 'Vlastník',
    vztahKlient: 'Klient',
    vztahPartner: 'Partner',
    zalozkyKlienta: 'Záložky klienta',
    zdrojKontaktu: 'Zdroj kontaktu',
    zdrojLeadovac: 'Leadovač',
    zdrojReklama: 'Reklama',
  },
  duchodKarta: {
    aktualizovatCil: 'Aktualizovat cíl',
    bezVeku: 'doplň věk, jinak se horizont spoření nedá spočítat (a hádat ho nebudeme).',
    chceMitMesicne: 'Chce mít měsíčně',
    chybi: 'Chybí',
    cilovyStandard: 'Cílový standard v důchodu',
    daStat: 'Dá stát',
    disclaimer: 'Státní důchod je ORIENTAČNÍ ODHAD z příjmu a věku, bez valorizace — ne příslib státu. Cílový standard je volba poradce, ne měření. Částky jsou v dnešních penězích.',
    doDuchodu: '· do důchodu {roky} let',
    duchodovyVek: 'Důchodový věk',
    kapitalRadek: 'kapitál {castka} · {roky} let · {vynos} % p. a.',
    mesicneOdkladat: 'Měsíčně odkládat',
    nadpis: 'Do důchodu — udržet životní standard',
    nahradiPct: 'nahradí {pct} % čistého příjmu',
    odPoradce: 'od poradce',
    osoba: 'Osoba',
    poDuchodovemVeku: 'Věk je už za důchodovým — na spoření nezbývá čas, částka je potřeba hned.',
    popis: 'Kolik z příjmu nahradí stát a kolik si musí klient doplnit sám. Tlačítkem se z toho stane cíl typu Fin. nezávislost.',
    prepsatDuchod: 'Přepsat státní důchod',
    pridatJakoCil: 'Přidat jako cíl',
    radekVek: '{vek} let · {castka}/měs',
    sablona: 'Šablona',
    standardHint: '% dnešního čistého příjmu. Míň než 100 %, protože v důchodu odpadá to, co klient platí PROTO, že pracuje a spoří si na penzi.',
    statNeodhadujeme: 'Státní důchod tu neodhadujeme',
    statNeodhadujemeHint: 'odhad platí jen pro ČR. Zadej částku a dopočítám zbytek.',
    statPokryjeCely: 'stát pokryje celý cíl',
    statPokryvaPct: 'stát pokryje {pct} % cíle',
    vekHint: 'odhad, přepiš',
  },
  /* Srovnávač fondů (/srovnavac-fondu). Doplněno 23. 8. 2026 — klíče se
     volaly, ale nebyly v žádném slovníku, takže vietnamský i ukrajinský
     poradce viděl český fallback. */
  fondy: {
    export: {
      chyba: "Graf se nepodařilo připravit.",
      hotovo: "Staženo.",
      pngChyba: "PNG se nepovedlo vyrobit. Zkus SVG — to jde otevřít v prohlížeči.",
      nese: "Obrázek si nese zdroj, datum i upozornění.",
      csvSrovnani: "Stáhnout CSV se srovnáním",
      csvRady: "Stáhnout CSV s řadami",
    },
    tabulka: {
      popisek: "Šest kritérií vedle sebe. Aplikace fondy neseřazuje podle kvality a žádný z nich nedoporučuje — výběr je na poradci.",
    },
    prazdno: {
      nadpis: "V katalogu zatím nejsou žádná data o fondech",
      veta: "Srovnávač je připravený — čeká jen na dodaná data. Historické hodnoty se sem neopisují z grafů, nahrávají se importem tří CSV souborů podle návodu v docs/penze/JAK-DODAT-DATA.md. Prázdná obrazovka je poctivější než vymyšlená čísla.",
      demo: "Ukázat na demo datech",
    },
    srovnavac: {
      nadpis: "Historický srovnávač fondů",
      kotva: "Období se počítá zpět od posledního dne dodaných dat, ne ode dneška — jinak by v pětiletém okně byly jen čtyři roky.",
    },
    filtr: {
      obdobi: "Období",
      zobrazeni: "Zobrazit",
      jednotlive: "Jednotlivé fondy",
      prumeryNapoveda: "Průměr se počítá jen z fondů, které pokrývají celé období.",
      prumery: "Průměry strategií",
      strategie: "Strategie",
      skupiny: "Investiční skupiny",
      spolecnost: "Penzijní společnost",
      historie: "Kratší historie",
      jenPlna: "Vyloučit fondy bez celé historie",
      zrusit: "Zrušit filtry",
      prazdno: {
        nadpis: "Filtru nevyhovuje žádný fond",
        veta: "Zkus odebrat některé z omezení — nebo se v katalogu takový fond zatím nenachází.",
      },
    },
    vyloucene: "Ze srovnání jsi vyloučil:",
    varianty: {
      metrika: "POROVNAT PODLE",
    },
    vyber: {
      nadpis: "Jak vybrat fond",
      veta: "Nejvyšší historický výnos není kritérium. Vedle sebe patří horizont klienta, kolísání, jak dlouhou historii fond vůbec má, jeho velikost, zákonná rizikovost SRI a náklady. Aplikace ukazuje čísla; posoudit, co z toho sedí na konkrétního klienta, umí jenom poradce.",
    },
    prumery: {
      nadpis: "Z čeho jsou průměry spočítané",
    },
    demo: {
      odznak: "DEMO DATA",
      veta: "Ukázková smyšlená čísla. Nepoužívat s klientem.",
      vysvetleni: "Tyhle řady nikdo nezveřejnil — jsou vymyšlené, aby šlo vyvíjet obrazovky. Rostou každý rok o stejné procento, což se v realitě nestává. Skutečná data se dodávají importem, návod je v docs/penze/JAK-DODAT-DATA.md.",
    },
  },

  /* Kalkulačka penze — popisky řad, mostu a cest.
   * Klíče volá pages/penze/{ui,stav,vypocty}.js. Do 23. 8. 2026 tenhle
   * jmenný prostor ve slovníku CHYBĚL, takže by se na obrazovku vykreslil
   * holý klíč (`penzeUi.rada.vlastni`). Nevšimlo si toho nic — `t()` bez
   * fallbacku vrací klíč tiše. Hlídá to teď __tests__/klicVeSlovniku.test.js. */
  penzeUi: {
    zaklad: { nominalne: "Nominálně", dnesniCeny: "V dnešních cenách", nominalneKratce: "nominálně", dnesniCenyKratce: "v dnešních cenách" },
    rada: { vlastni: "Vlastní vklady", zamestnavatel: "Zaměstnavatel", stat: "Státní příspěvek", zhodnoceni: "Zhodnocení" },
    most: { vklad: "Vlastní vklad", zamestnavatel: "Zaměstnavatel", strategie: "Strategie" },
    strategie: { konzervativni: "Konzervativní", vyvazena: "Vyvážená", dynamicka: "Dynamická", stare: "Staré penzijko" },
    cesta: { dnes: "Dnešní stav", kombinace: "Kombinace DPS + DIP", zamestnavatel: "Se zaměstnavatelem" },
  },
  /* Pojištění osob (Návrh řešení + prezentace plánu).
     Druhá osoba se počítá jen tehdy, když je partner v analýze — rozpor
     mezi vyplněným příjmem a chybějící identitou se poradci NEZAMLČUJE. */
  /* BLOK:pojisteniOsob START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniOsob: {
    bezPrijmu: 'Bez závislého příjmu — výpadek kryje přebytek domácnosti.',
    cena: '≈ Orientační pojistné',
    cenaCelkem: '≈ Orientační pojistné osob celkem',
    denni: '/den',
    diteRozporText: 'V analýze je řádek dítěte, kde chybí jméno i datum narození. Sirotčí důchod za dítě, které v analýze není, by pojistné částky snížil — proto se takový řádek nezapočítal. Doplňte dítě do analýzy, nebo prázdný řádek smažte.',
    diteRozporTitul: 'Dítě bez jména se nepočítá',
    doplnitNarozeni: 'Doplnit datum narození',
    invalidita: 'Invalidita (2.–3. st.)',
    klient1: 'Klient 1',
    klient2: 'Klient 2',
    mesicni: '/měs',
    metodika: 'Kapitálová metoda @ 4 % reálně: výdaje domácnosti po události − příjmy, které rodině zůstanou − státní dávky, na {roky} let + dluhy ({dluhy}) + cíle − likvidní majetek. Varianta {varianta} počítá cíle ×{kCile} a {vydaje}; dluhy se nekrátí nikdy. Částky jsou návrh — poradce má poslední slovo.',
    odskodne: 'Denní odškodné úrazem',
    osvc: 'OSVČ',
    partnerNespocteno: '{jmeno}: zajištění nespočteno — chybí datum narození',
    partnerNespoctenoText: 'Plán partnera nepojišťuje ani nepočítá cenu jeho pojištění.',
    pn: 'Pracovní neschopnost',
    pnPozn: 'od {mesic}. měsíce — do té doby drží rezerva',
    pnPoznNic: 'rezerva + nemocenská výpadek pokryjí',
    pnPoznOsvc: 'od {mesic}. měsíce — do té doby drží rezerva',
    popisInvalidita: 'Invalidita = dlouhodobý výpadek příjmu, který rezerva nepokryje — a výdaje navíc rostou (péče, úpravy bydlení). Finančně větší riziko než smrt.',
    popisOdskodne: 'Úraz zastaví příjem od prvního dne — bez karence. Denní dávka dorovnává výpadek příjmu po dobu léčení.',
    popisPn: 'Krátkodobý výpadek příjmu nad rámec rezervy: nemocenská kryje jen část čistého příjmu, dávka dorovnává rozpočet. Prvních pár měsíců drží rezerva → delší karence = nižší pojistné.',
    popisSmrt: 'Nahrazuje příjem rodině: pokryje běžné výdaje, splátky i rozjeté cíle, aby rodina nemusela měnit život ze dne na den. Jen do finanční nezávislosti, klesající částka = levněji.',
    popisTnu: 'Trvalé poškození po úrazu = trvale vyšší výdaje. Progresivní plnění po pásmech: čím vážnější následky, tím vyšší výplata (v našem modelu nejvýš 2,8× částky — u pojišťoven se liší).',
    popisZavazne: 'Rakovina, infarkt, mrtvice: léčba trvá měsíce, příjem spadne a výdaje vzrostou. Jednorázová výplata dovolí přestat pracovat a léčit se, aniž rodina rozpustí rezervu nebo investice.',
    prijem: 'příjem',
    rozporText: 'U druhé osoby je vyplněný příjem {castka}, ale chybí jméno i datum narození. Krytí pro člověka, který v analýze není, by před klientem neobstálo. Doplňte partnera do analýzy, nebo příjem opravte.',
    rozporTitul: 'Druhá osoba se nepočítá — v analýze není',
    smrt: 'Smrt',
    titul: 'Pojištění osob — dimenzované na splnění všech cílů',
    tnu: 'Trvalé následky úrazu',
    tnuPozn: 'progresivní plnění po pásmech — v našem modelu nejvýš 2,8× částky, u pojišťoven se liší',
    tnuPrilepek: ' s progresí',
    zavazne: 'Závažná onemocnění',
    zavaznePozn: '{nasobek}× roční příjem',
    zavaznePoznVyplata: 'Jednorázová výplata na léčbu a na dobu, kdy klient nemůže pracovat.',
  },
  /* BLOK:pojisteniOsob END */
  /* RUČNÍ HODNOTY PORADCE — přepis pojistných částek a cen v Návrhu řešení.
     Metodika se nemaže: spočítaná hodnota zůstává vedle a jde se k ní vrátit. */
  rucniPojisteni: {
    chip: "ručně",
    upravit: "Upravit ručně",
    hotovo: "Hotovo",
    vratit: "Vrátit na spočítané",
    system: "Systém počítá {castka}",
    titul: "Ceny a částky přepíšete podle skutečné nabídky",
    vysvetleni: "Klikněte na tužku u kterékoli částky nebo ceny a zadejte, co má klient reálně sjednané. Ruční hodnota je označená a spočítaná zůstává vedle ní, takže rozdíl jde kdykoli ukázat i vrátit zpět.",
    pocet: "{n}× ručně",
    vratitVse: "Vrátit vše na spočítané",
    cenaOsoby: "Orientační pojistné",
    /* CENA JE PER VARIANTA, LIMITY SPOLEČNÉ (24. 9. 2026). Majitel modeluje
       v pojišťovně čtyři nabídky a u klienta mezi nimi přepíná — viz
       lib/rucniPojisteni.js, pravidlo 3. */
    nezadanaVarianta: "Pro tuhle variantu cena zadaná není",
    perVarianta: "Limity i ceny se ukládají KE KAŽDÉ VARIANTĚ ZVLÁŠŤ (teď {varianta}). Namodelujte varianty v pojišťovně a ke každé zadejte její limity a cenu — u klienta pak přepínáte a ukazujete limit i cenu vedle sebe.",
    odhadSablona: "odhad ze šablony sazeb, ne nabídka pojišťovny",
    ukladam: "Ukládám ruční hodnoty…",
    ulozeno: "Ruční hodnoty uloženy",
    chyba: "Ruční hodnoty se nepodařilo uložit — zkuste tlačítko Uložit návrh",
  },
  /* SROVNÁNÍ POJIŠTĚNÍ „PŘED A PO" (24. 9. 2026) — prodejní moment majitele.
     „On měl limit 8 mil. a já mu nabízím náročnou variantu 31 mil.; platil
     6 400 a bude platit 8 200 — limit je 3× vyšší, ale cena o tolik vyšší
     není." Čísla počítá lib/srovnaniPojisteni.js, tady jsou jen slova.
     PRÁZDNO SE POJMENOVÁVÁ: `nezadano` a věty v `chybi` říkají poradci, CO
     a KDE doplnit — nikdy se místo nich nedosadí nula. */
  /* BLOK:srovnaniPojisteni START — generuje scratchpad/slovnik.py, ručně needitovat */
  srovnaniPojisteni: {
    aspon: 'min.',
    celkem: 'Celkem',
    chybi: {
      cena: '{kdo}: pro variantu {varianta} není zadaná cena. Namodelujte ji v pojišťovně a zapište tužkou v kartě Pojištění osob — cena se ukládá ke každé variantě zvlášť.',
      cenaBezVarianty: '{kdo}: pro zvolenou variantu není zadaná cena. Namodelujte ji v pojišťovně a zapište tužkou v kartě Pojištění osob — cena se ukládá ke každé variantě zvlášť.',
      cenaCastecna: 'Cena je zadaná jen u části osob, takže celek je dopočítaný odhadem. Doplňte ji tužkou i u zbylých osob v kartě Pojištění osob.',
      cenaDetske: 'V návrhu je i dětská smlouva a její pojistné umí appka jen odhadnout — součet cen dospělých proto není cena celého návrhu. Zadejte celkovou cenu z nabídky pojišťovny.',
      limitRizika: '{kdo}: u stávající smlouvy chybí pojistná částka — {riziko}. Doplňte ji v analýze u pojistky.',
      platba: '{kdo}: u stávající smlouvy chybí měsíční platba — bez ní nejde říct, kolik platí dnes.',
      platbaCastecna: '{kdo}: u smluv {smlouvy} chybí měsíční platba, takže „platí dnes“ je nižší než skutečnost.',
      prirazeni: 'Smlouvy {smlouvy} mají rizika zapsaná bez osoby, proto se počítají živiteli. Po osobách se rozdělí, až v analýze u smlouvy vyberete, komu rizika patří (Pojistné smlouvy → Rizika ve smlouvách).',
      smlouvaPartnera: 'Smlouvy {smlouvy} jsou přiřazené partnerovi, který v analýze není — do srovnání se nepočítají.',
      smlouvaPartneraNespocteno: 'Smlouvy {smlouvy} patří partnerovi, jehož zajištění plán nespočítal (chybí datum narození) — do srovnání se nepočítají a plán je neruší.',
      smlouvaSpolecnaBezPartnera: 'Ze společných smluv {smlouvy} se počítá jen část klienta — partner v analýze není.',
      smlouvaSpolecnaNespocteno: 'Smlouvy {smlouvy} můžou krýt i partnera, jehož zajištění plán nespočítal (chybí datum narození) — plán je proto neruší. Doplňte v analýze datum narození partnera.',
      zadneSmlouvy: 'V analýze není žádná pojistná smlouva s pojistnou částkou.',
    },
    dnesNekryty: 'dnes nekrytý',
    dnesNeplati: 'dnes neplatí',
    domacnost: 'Domácnost (obě osoby)',
    doplnKde: 'Doplňte ji v analýze: Závazky a smlouvy → Pojistné smlouvy → Rizika ve smlouvách → invalidita / smrt u osoby. Teprve pak jde klientovi ukázat, že nový limit je násobně vyšší a cena ne.',
    doplnTitul: 'Bez pojistné částky staré smlouvy to není srovnání, ale zdražení',
    doplnTlacitko: 'Doplnit v analýze',
    hlavicka: {
      budePlatit: 'Bude platit',
      nasobekCeny: 'Cena',
      nasobekKryti: 'Krytí',
      novy: 'Nový limit',
      platil: 'Platí dnes',
      puvodni: 'Limit dnes',
      riziko: 'Riziko',
    },
    nezadano: 'nezadáno',
    novyNula: 'krytí se nenavrhuje',
    podtitul: 'varianta {varianta}',
    poznamka: '„Bude platit“ je cena z nabídky pojišťovny, kterou jste zadali ručně k téhle variantě — appka ji nedoplňuje ze šablony sazeb. Prázdné pole znamená zatím nezadáno, ne nulu.',
    prirazenoZiviteli: 'rizika bez osoby — počítají se živiteli, upřesněte v analýze',
    riziko: {
      invalidita: 'Invalidita',
      smrt: 'Smrt',
    },
    titul: 'Před a po — co má dnes a co bude mít',
    vyhra: '{kdo}: krytí roste {pomer}× rychleji než cena.',
    zivitel: 'živitel rodiny',
  },
  /* BLOK:srovnaniPojisteni END */
  /* POJIŠTĚNÍ MAJETKU A ODPOVĚDNOSTI (karta v Návrhu řešení).
     Násobek u odpovědnosti vůči zaměstnavateli je ZÁKONNÝ STROP a v každé zemi
     jiný (CZ 4,5× / SK 4×) — do vět chodí parametrem `{nasobek}`, NIKDY ho sem
     nepiš natvrdo. Zdroj předpisu drží lib/odpovednostZamestnavateli.js. */
  pojisteniMajetku: {
    titul: "Pojištění majetku a odpovědnosti",
    nemovitost: "Nemovitost",
    nemovitostPopis: "Na plnou hodnotu z analýzy — pojistná částka = cena pořízení znovu (pozor na podpojištění).",
    domacnost: "Domácnost",
    domacnostPopis: "Vybavení — nábytek, elektronika, cennosti. Odhad dle vybavení, uprav podle klienta.",
    odpovednost: "Odpovědnost občanská",
    odpovednostPopis: "Škoda způsobená jiným nemá strop (zdraví, vytopení, sražený cyklista) — limit co nejvyšší.",
    zamestnavatel: "Odpovědnost vůči zaměstnavateli",
    zamestnavatelOsoba: "Odpovědnost vůči zaměstnavateli — {jmeno}",
    zamestnavatelPopis: "Zaměstnavatel po vás může chtít náhradu škody až do {nasobek}násobku průměrného měsíčního výdělku — limit se počítá z hrubé mzdy. U škody způsobené úmyslně nebo v opilosti strop neplatí.",
    zamestnavatelPopis2: "Vlastní smlouva pro druhou osobu — limit se počítá z JEJÍ hrubé mzdy, ne z příjmu domácnosti. I tady platí {nasobek}násobek průměrného měsíčního výdělku.",
    hrubaMzda: "Hrubá mzda",
    limit: "Limit {nasobek}×",
    zdrojLimitu: "Násobek je zákonný strop, ne náš odhad: {predpis}. Ověřeno {datum}. Základem je průměrný měsíční výdělek — s prémiemi bývá vyšší než hrubá mzda, limit proto ber jako spodní hranici.",
    pravni: "Právní ochrana",
    pravniPopis: "Právník a soudní výlohy při sporech — pracovní, sousedské, spotřebitelské.",
    nabidnout: "nabídnout",
    nenabizet: "nenabízet",
    osvcTitul: "Podnikání — OSVČ a firma",
    osvcPodtitul: "V analýze je příjem z podnikání nebo firma v majetku. Projděte s klientem, co doopravdy má a co by ho položilo.",
    podnikatelske: "Podnikatelské pojištění",
    podnikatelskePopis: "Profesní odpovědnost, majetek firmy, přerušení provozu. Pojistka domácnosti tohle nekryje — škoda na zakázce se z ní neplatí.",
    resit: "řešit",
    neresit: "neřešit",
    zasoby: "Zásoby",
    zasobyPopis: "Materiál, zboží a rozpracovaná zakázka na skladě i v autě. Když sklad vyhoří, bez téhle položky nedostane klient ani korunu.",
    moviteVeci: "Movité věci a vybavení",
    moviteVeciPopis: "Nářadí, stroje, technika, vybavení provozovny. Sečtěte, co by klient musel koupit znovu, aby mohl zítra pracovat.",
    odpovednostPodnikatele: "Odpovědnost podnikatele",
    odpovednostPodnikatelePopis: "Škoda způsobená při podnikání zákazníkovi nebo třetí osobě. Doporučené minimum {limit} — jedna vytopená provozovna nebo úraz zákazníka jde snadno přes milion.",
    bezLimitu: "neřešit",
    mil: "mil.",
    odhadTitul: "Orientační pojistné majetku celkem",
    disclaimer: "Orientační odhad ze šablony sazeb — není nabídka ani garance ceny. Konkrétní pojistné upřesní poradce dle věku, zdravotního stavu, tarifu, spoluúčasti a výluk vybrané pojišťovny.",
    mesic: "/měs",
    patka: "Vždy se spoluúčastí — malé škody kryje rezerva, pojistka je levnější. Konkrétní tarify a výluky vybírá poradce.",
  },
  /* DOPORUČENÍ KE KAŽDÉMU CÍLI — návrh systému z čísel plánu + text poradce.
     Diktát majitele 25. 8. 2026: „aby bylo možnost upravit u všech cílů, aby
     tam mohli zadávat nějaký text doporučení — co my mu doporučíme a co vlastně
     náš systém mu doporučí při prodeji, aby poradce mohl pak popřípadě upravit."
     Věty NIKDY neobsahují číslo, které systém nespočítal, ani referenci nebo
     jméno (regulované poradenství). Ukládá se JEN text poradce — návrh systému
     se skládá znovu, aby seděl na jazyk čtenáře i na aktuální čísla. */
  /* HORIZONT CILE — jedno misto pro "hned" a pro sklonovani let (audit R13).
   * Do 25. 8. 2026 si horizont dopocitavalo osm mist a kazde jinak: rezerva
   * "hned" (roky = 0) byla na karte "za 1 let", v tisku "—" a na slajdu
   * "za 0 let". Sklonovani dela t.plural (Intl.PluralRules podle jazyka),
   * ne ceske pravidlo 1 / 2-4 / 5+ — jinak ukrajinstina cte "za 21 rokiv".
   * Trojice One/Few/Many musi byt ve vsech peti slovnicich. */
  /* SHRNUTI — ROZDELOVNIK PLANU (predloha majitele, obrazovka „Shrnutí“ z FIP).
   * Tri pocitadla nahore, radek na cil. Texty NIKDY netvrdi nulu tam, kde je
   * neznamo: „bez vkladu“ / „doplň termín cíle“ misto „0“ a misto „0 %“.
   * Presplneny cil se rika slovem („splněno · přebývá X“), ne minusem —
   * predloha psala −749 471 a majitel si to sam vytkl. */
  /* BLOK:shrnutiPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  shrnutiPlan: {
    azPoCilovemDatu: 'až po cílovém datu — do cílové částky se nepočítá',
    bezCiluKde: 'Doplň je v analýze v sekci Cíle — bez cílové částky se cíl do plánu vůbec nedostane.',
    bezCiluTitul: 'Plán zatím nemá ani jeden cíl.',
    bezVkladu: 'bez vkladu',
    dnesPosle: 'dnes klient pošle {kc}',
    doplnCastku: 'doplň cílovou částku',
    doplnTermin: 'doplň termín cíle',
    doplnenoEnginem: 'doplněno výpočtem',
    doraziPozdeji: 'z toho {kc} dorazí později',
    doraziVeVeku: 'z toho {kc} dorazí v {vek} letech',
    dorovnat: 'dorovnat',
    dorovnatJednJak: 'Přibije měsíční platbu a jednorázový vklad k ní dopočítá appka, aby cíl vyšel celý.',
    dorovnatPravJak: 'Přibije jednorázový vklad a měsíční platbu k němu dopočítá appka, aby cíl vyšel celý.',
    editaceJak: 'Čísla ve sloupcích „Jednorázový vklad“ a „Pravidelný vklad“ se dají přepsat rovnou v řádku — přepsané číslo se odečte z hrnce nahoře a to druhé k němu dopočítá appka. ↺ vrátí vypočtený návrh.',
    financni: 'Finanční majetek',
    kapital: 'kapitál',
    mesicne: '/měs',
    nadKapacitu: 'nad kapacitu domácnosti',
    neboJednorazove: 'nebo {kc} jednorázově',
    neboPravidelne: 'nebo {kc} měsíčně',
    nedosazitelne: 'cíl nelze dorovnat',
    nefinancni: 'Nefinanční majetek',
    nefinancniJak: 'Nemovitosti a firma. Dědictví se do čísla nesčítá — je zvlášť jako budoucí majetek. Do cílů se dostanou teprve jako budoucí přítok (prodej) — ten se zadává v Návrhu řešení u Řešení cílů.',
    nelzeInvestovat: 'Není možné využít k investici.',
    nezapojeno: 'Nezapojeno',
    nezapojenoJak: 'Podílové fondy, KŽP, termínovaný vklad a cizí měny. Plán je jednorázově nepřerozděluje, proto nejsou ani v „Přiděleno“, ani v „Zbývá“.',
    nicNeni: 'nic navíc',
    plusKroky: '+ stupňovité navýšení ({n})',
    pocitam: 'Počítám shrnutí…',
    podtitul: 'Tři hrnce nahoře, řádek na cíl. Rozdávej ze zdrojů, dokud u obou nesvítí „Zbývá 0“. Čísla jsou táž jako v Návrhu řešení — tahle obrazovka je druhý pohled na ně a rozdává se rovnou v ní.',
    poradce: 'Poradce',
    poznPlaceholder: 'Poznámka ke cíli pro klienta…',
    poznPrebiji: 'přebíjí návrh systému ve výstupech',
    poznZpet: 'zpět na návrh',
    prebytek: 'Měsíční přebytek',
    prebytekNeznamy: 'Přebytek neznáme — doplň výdaje v analýze',
    prebyva: 'přebývá {kc}',
    precerpano: 'Přečerpáno — tolik klient nemá',
    pridatJenJedn: '← řeší se jednorázově',
    pridatJenPrav: 'řeší se pravidelně →',
    prideleno: 'Přiděleno',
    rezervaJednNelze: 'Rezervu plán řeší ze zdrojů a z přebytku — jednorázový vklad se u ní nepřibíjí.',
    rezimJednorazove: 'Jednorázově',
    rezimMesicne: 'Měsíčně',
    rezimOboji: 'Obojí',
    rezimZpet: 'vypočtený návrh',
    rozdano: 'Rozdáno — zbývá 0',
    schodek: 'Výdaje a splátky převyšují příjmy — plán se nedá platit',
    splneno: 'splněno',
    systemBezVkladu: 'Systém sám žádný vklad navíc nepočítá.',
    thCil: 'Popis cíle (co?)',
    thDosazeno: 'Dosažená hodnota',
    thJedn: 'Jednorázový vklad',
    thKdy: 'Za kolik roků? (kdy?)',
    thKolik: 'Hodnota (kolik?)',
    thPozn: 'Poznámka',
    thPrav: 'Pravidelný vklad',
    thPridatJedn: 'Přidat jednorázově',
    thPridatPrav: 'Přidat pravidelně',
    titul: 'Tabulka — rozdělovník plánu',
    tlacitko: 'Tabulka',
    uklada: 'Ukládám…',
    ulozeniJak: 'Čísla se ukládají sama — po chvilce klidu a při odchodu ze stránky. „Uloženo“ svítí, teprve až je má server. Návrh řešení zůstává vedle: ukazuje týž plán, jen v kartách.',
    ulozeniSelhalo: 'Uložení selhalo — změna zůstala jen na obrazovce.',
    ulozeno: 'Uloženo',
    vkladNavic: 'navíc nad zdroje',
    vysvetlivka: '„Přidat“ = kolik by ještě bylo potřeba, aby cíl vyšel celý — nad tím, co mu plán už přidělil. Není to platba, je to chybějící část. Splněný cíl tu nemá číslo, ale slovo.',
    vysvetlivkaRezim: '„Přidat“ nese jen ten sloupec, který odpovídá tomu, jak se cíl řeší: jednorázový vklad, nebo pravidelný. Když se řeší obojí, jsou obě čísla ALTERNATIVA — buď jednorázově, NEBO měsíčně. Nesčítej je: každé z nich platí jen tak, že ten druhý vklad zůstane, jak je.',
    zPritoku: '+ {kc} z budoucího přítoku',
    zadneZdroje: 'Není co rozdělovat — klient nemá volný finanční majetek',
    zbyva: 'Zbývá',
    zdrojeDoRentyJak: 'Penzijko i DIP se dají zrušit, ale většinou míří na dlouhý cíl. „Do renty“ je pošle na rentu — a když klient rentu nemá, na cíl s nejdelším horizontem.',
    zdrojeDoRentyTitul: 'Stavebko a penzijko',
    zdrojeDoRentyVyp: 'na nejbližší cíl',
    zdrojeDoRentyZap: 'do renty',
    zpetNaNavrh: 'Zpět na návrh řešení',
  },
  /* BLOK:shrnutiPlan END */
  /* POŘADÍ KROKŮ — JEDNO PRO CELOU APPKU (diktát majitele 24. 9. 2026).
     Kroky i jejich stavy drží lib/poradiKroku.js; tady jsou jen jejich názvy
     a věty. Čísla kroků se do textů NEPÍŠÍ — dopočítá je `poradiKroku(id)`,
     jinak by text po přeskládání lhal. Věty `chybi*` vidí JEN PORADCE na své
     obrazovce: je to jeho domácí úkol, ne text pro klienta. */
  /* BLOK:poradiKroku START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiKroku: {
    chybiMajetkove: 'Krok {cislo} — majetkové pojištění: vyplňte a uložte kartu Pojištění majetku výš.',
    chybiRezerva: 'Krok {cislo} — rezerva: doplňte v analýze nezbytné výdaje. Bez nich cíl rezervy nevznikne a řádek by lhal nulou.',
    chybiTitulek: 'Do tabulky se nedostaly kroky, na které chybí podklad:',
    chybiZivotni: 'Krok {cislo} — životní pojištění: bez příjmů a výdajů v analýze není z čeho spočítat pojistné částky.',
    cile: 'Cíle',
    cilePozn: 'pravidelně investovat volné zdroje na cíle a na rentu',
    dluhy: 'Zbavit se špatných dluhů',
    dluhyPozn: 'drahé úvěry a kreditky umazat první — úrok platíte jistě, výnos investic jistý není',
    majetkove: 'Majetkové pojištění',
    majetkovePozn: 'nemovitost, domácnost, auto, odpovědnost a u podnikatele i firemní majetek',
    na90Dni: 'Kroky na příštích 90 dní',
    rezerva: 'Vytvořit rezervu',
    rezervaPozn: '3–6 měsíců nezbytných výdajů po ruce, aby plán nezastavila první nečekaná oprava',
    slideZaver: '„K vaší rentě a finanční nezávislosti vedou tyhle kroky — a v tomhle pořadí.“',
    tabMajetekCo: 'Pojistit majetek a odpovědnost ({kryti}) — orientačně {cena} měsíčně.',
    tabMajetekKdy: 'Ihned',
    tabMajetekProc: 'Jedna škoda na nemovitosti nebo způsobená jiným stáhne celý plán ke dnu.',
    tabRezervaCo: 'Doplnit likvidní rezervu na {cil} — dnes chybí {gap}.',
    tabRezervaCoFondy: 'Doplnit likvidní rezervu na {cil} — dnes chybí {gap}, z toho {fondy} se doplní z fondů (prodej podílových fondů, ETF nebo akcií).',
    tabRezervaHotovo: 'Rezervu {cil} držet naplněnou — hotovo.',
    tabRezervaKdy: 'Před investováním',
    tabRezervaProc: 'Polštář na nečekané výdaje. Bez něj se první porucha řeší dluhem nebo rozpuštěním investice.',
    ukolCile: 'Spustit pravidelné investice {castka} na cíle a rentu',
    ukolDluhy: 'Zbavit se špatných dluhů — dnes {castka}',
    ukolMajetkove: 'Sjednat pojištění majetku a odpovědnosti — orientačně {cena}',
    ukolOsoba: '{jmeno}: invalidita {invalidita}, smrt {smrt}',
    ukolOsobaBezInvalidity: '{jmeno}: smrt {smrt}',
    ukolRezerva: 'Doplnit rezervu na {cil} (chybí {gap})',
    ukolRezervaFondy: 'Doplnit rezervu na {cil} (chybí {gap} — {fondy} se doplní z fondů)',
    ukolRezervaHotovo: 'Rezerva {cil} je naplněná — držet ji',
    ukolZivotni: 'Sjednat rizikové pojištění — invalidita {invalidita}, smrt {smrt}',
    ukolZivotniBezInvalidity: 'Sjednat rizikové pojištění — smrt {smrt}; krytí invalidity bez příjmu nepočítáme',
    ukolZivotniOsoby: 'Sjednat rizikové pojištění — {osoby}',
    ukolZivotniOsobyBezInvalidity: 'Sjednat rizikové pojištění — {osoby}; krytí invalidity bez příjmu nepočítáme',
    uvod: '…ale je potřeba pro to něco udělat. V tomhle pořadí:',
    zivotni: 'Životní pojištění',
    zivotniPozn: 'dobře a levně pojistit invaliditu a smrt — výpadek příjmu nesmí položit rodinu',
  },
  /* BLOK:poradiKroku END */
  cilHorizont: {
    hned: "hned",
    bezTerminu: "termín zatím není stanovený",
    zaOne: "za {n} rok",
    zaFew: "za {n} roky",
    zaMany: "za {n} let",
    rokOne: "rok",
    rokFew: "roky",
    rokMany: "let",
  },
  /* NAVRH — TABULKY „NASE DOPORUCENI" A „PRODUKTY" (audit R11).
   * Skladaji se ZIVE z aktualnich cisel planu; ukladaji se jen prepisy poradce.
   * Radky jednotlivych cilu tu nejsou schvalne — ty ma plan ve vlastni, taky
   * zive pocitane sekci (dopCil.*). Viz lib/navrhTabulky.js. */
  /* BLOK:navrhTabulky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhTabulky: {
    alokaceCo: 'Investovat dle profilu: akcie {akcie} %, dluhopisy {dluhopisy} %, hotovost {penize} %.',
    alokaceKdy: 'Ihned',
    alokaceProc: 'Alokace dělá ~92 % výsledku; inspirace Norským fondem / Nobelovou nadací.',
    alokaceZProfilu: 'Rozložení na startu podle zvoleného profilu (Řešení cílů výš). K cíli se samo postupně posouvá do bezpečí.',
    davkyOdhadPodlePrijmu: 'Orientační odhad podle příjmu — totéž číslo, ze kterého vycházejí pojistné částky.',
    diverzifikaceCo: 'Diverzifikovat měnově a regionálně (svět ~72 % USA, …).',
    diverzifikaceKdy: 'Ihned',
    diverzifikaceProc: 'Větší stabilita portfolia, ochrana před lokálním propadem.',
    dluhyCo: 'Zbavit se drahých dluhů (dnes {castka}).',
    dluhyKdy: 'Co nejdřív',
    dluhyProc: 'Úrok platíte jistě, výnos investic jistý není.',
    pojisteniCo: 'Zajistit příjem pojištěním — invalidita {invalidita}, smrt {smrt} (klesající částky).',
    pojisteniCoBezInvalidity: 'Zajistit pojištěním — smrt {smrt} (klesající částky). Krytí invalidity bez příjmu nepočítáme, doplňte příjem.',
    pojisteniCoOsoby: 'Zajistit příjem pojištěním — {osoby} (klesající částky).',
    pojisteniCoOsobyBezInvalidity: 'Zajistit pojištěním — {osoby} (klesající částky). Krytí invalidity bez příjmu nepočítáme, doplňte příjem.',
    pojisteniKdy: 'Ihned',
    pojisteniProc: 'Při výpadku příjmu nesmí rodina spadnout z životní úrovně ani přijít o cíle.',
    produktAkcie: 'Akciové ETF (svět, MSCI World)',
    produktDluhopisy: 'Dluhopisové ETF (svět)',
    produktPenize: 'Peněžní trh / spořicí (rezerva + hotovost)',
    upravenoPoradcem: 'upraveno poradcem',
    zivyNavrh: 'návrh systému — přepočítává se z aktuálních čísel plánu',
    zpetNaNavrh: 'Zpět na návrh systému',
  },
  /* BLOK:navrhTabulky END */
  /* RESENI U POJISTKY — navrh systemu + text poradce (lib/doporuceniPojisteni.js).
   * Sklada se ZIVE z cisel srovnani „pred a po“; uklada se jen prepis poradce
   * (navrh.solver.doporuceniPojisteni). Zadny produkt ani pojistovna — je to
   * regulovany vystup (IDD), navrh rika CO chybi, ne u koho to sjednat. */
  dopPoj: {
    titul: "Řešení u pojistky",
    podtitul: "Systém navrhne z čísel srovnání, poradce má poslední slovo.",
    domacnost: "Celá domácnost",
    titulVystup: "Co doporučujeme k pojištění",
    odSystemu: "návrh systému",
    odPoradce: "text poradce",
    upravit: "Upravit text",
    zpetNaNavrh: "Zpět na návrh systému",
    placeholder: "Co klientovi u pojištění doporučujeme…",
    hint: "Návrh systému je poskládaný z čísel tohoto srovnání. Poradce má poslední slovo — jeho text se tiskne do plánu i do prezentace pro klienta.",
    prazdneVarovani: "Prázdné doporučení se klientovi nevytiskne. Vraťte se na návrh systému, nebo napište vlastní text.",
    nicKRict: "Zatím není z čeho doporučení složit — doplňte dnešní pojistné částky a cenu varianty.",
    rizikoSmrt: "Smrt",
    rizikoInvalidita: "Invalidita",
    bezSmlouvy: "Klient dnes nemá žádnou smlouvu s pojistnou částkou — zajištění příjmu je potřeba postavit od nuly.",
    nekrytyRiziko: "{riziko}: dnes bez krytí, potřeba {novy}.",
    nekrytyRizikoBezCastky: "{riziko}: dnes bez krytí.",
    nizkyLimit: "{riziko}: dnešní {puvodni} je pod potřebou {novy} — chybí {rozdil}.",
    pokrytoRiziko: "{riziko}: dnešních {puvodni} potřebu {novy} pokrývá.",
    argument: "Krytí roste ×{kryti}, cena ×{cena}.",
    argumentVyhra: "Krytí roste ×{kryti}, cena jen ×{cena} — za nepoměrně méně peněz nepoměrně víc krytí.",
    brzdaLimit: "{riziko}: doplňte do analýzy dnešní pojistnou částku — bez ní se nedá říct, co klientovi chybí.",
    brzdaNovy: "{riziko}: ve zvolené variantě zatím není spočítaná pojistná částka.",
    brzdaPlatba: "Doplňte, kolik klient za stávající smlouvy platí dnes — bez toho se cena nedá srovnat.",
    brzdaPlatbaCastecna: "U některé stávající smlouvy chybí platba — srovnání ceny je proto jen částečné.",
    brzdaCena: "Doplňte cenu zvolené varianty — bez ní nelze říct, co klient bude platit.",
  },
  /* REZERVA — na kolik mesicu (majitel 25. 9. 2026: „rezerva bud 3 - 6 - 12
   * mesicu, no to je jedno“). Jeden prepinac, tri volby: pocet mesicu plati na
   * CELY zaklad, tedy nezbytne vydaje i splatky. Prepinac stoji u cile rezervy,
   * ne v nastaveni; volby 18 / 24 / 36 se zrusily i s rozdelenym zakladem. */
  rezervaMesicu: {
    titul: "Rezerva na",
    m3: "3 měsíce",
    m6: "6 měsíců",
    m12: "12 měsíců",
    hint: "Kolik měsíců rezerva vydrží. Počítá se z nezbytných výdajů i splátek — v krizi běží obojí dál.",
  },
  /* ZTRATA Z PREDCASNEHO ZRUSENI PENZIJKA (planSolver, ztrata.kody).
   * ZADNE CISLO — engine nezna sazbu ani kolik uz klient dostal, takze veta
   * mluvi o tom, CO se vraci, nikdy o kolik. */
  ztrataPenzijka: {
    titul: "Co stojí vzít si to dřív",
    statniPrispevek: "Předčasné zrušení znamená vrátit státní příspěvky.",
    danovaVyhoda: "Předčasné zrušení znamená dodanit dřív uplatněnou daňovou výhodu.",
    druhNeznamy: "U některé smlouvy není vybraný druh (DPS / DIP) — doplňte ho, ať je jasné, o co přesně klient přijde.",
  },
  /* BLOK:dopCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  dopCil: {
    brzdaBezCastky: 'Cíl nemá zadanou částku — doplňte ji v analýze.',
    brzdaBezHorizontu: 'Cíl nemá horizont — doplňte, za kolik let ho klient chce. Bez toho se nedá rozpočítat ani zařadit do plánu.',
    brzdaKapacita: 'Pozor: {prav} měsíčně je nad volným přebytkem domácnosti ({kapacita} měsíčně) — buď delší horizont, nižší cíl, nebo místo v rozpočtu.',
    brzdaNedosazitelne: 'V tomhle nastavení cíl nevychází ani při maximálním vkladu — je potřeba delší horizont nebo nižší částka.',
    hint: 'Návrh systému je poskládaný z čísel tohoto plánu. Poradce má poslední slovo — jeho text se tiskne do plánu, jednostránkového plánu i do prezentace pro klienta.',
    jakGlide: 'Investičně: první rok {start}, poslední rok {konec} (akcie/dluhopisy/hotovost) — riziko se ke konci vypíná.',
    jakJedn: 'Řešení: {jedn} jednorázově, měsíčně nic navíc.',
    jakNic: 'Řešení: z peněz, které máte dnes, cíl vychází i bez dalších vkladů.',
    jakNicNevychazi: 'Řešení: na tenhle cíl zatím není z čeho platit — plán mu nevyčlenil ani jednorázový vklad, ani měsíční částku.',
    jakOboji: 'Řešení: {jedn} jednorázově a {prav} měsíčně.',
    jakPrav: 'Řešení: {prav} měsíčně.',
    jakRenta: 'Rentiérské portfolio {alokace} (akcie/dluhopisy/hotovost) se drží i v čerpání — renta jde z výnosů.',
    jakRezerva: 'Rezerva se neinvestuje — patří na spořicí účet, aby byla k dispozici ze dne na den.',
    jakStabilni: 'Investičně {start} (akcie/dluhopisy/hotovost) po celý horizont.',
    nicKRict: 'Zatím není z čeho doporučení složit — doplňte částku a horizont cíle.',
    odPoradce: 'text poradce',
    odSystemu: 'návrh systému',
    placeholder: 'Co klientovi u tohoto cíle doporučujeme…',
    prazdneVarovani: 'Prázdné doporučení se klientovi nevytiskne. Vraťte se na návrh systému, nebo napište vlastní text.',
    titul: 'Doporučení k cíli',
    titulVystup: 'Co doporučujeme k jednotlivým cílům',
    upravit: 'Upravit text',
    vysledekChybi: 'Za {roky} let z toho vychází {konec} — chybí {chybi} ({pct} % cíle).',
    vysledekChybiHned: 'Do roka z toho vychází {konec} — chybí {chybi} ({pct} % cíle).',
    vysledekOk: 'Za {roky} let z toho vychází {konec} — cíl pokrytý na {pct} %.',
    vysledekOkHned: 'Do roka z toho vychází {konec} — cíl pokrytý na {pct} %.',
    zadaniBezne: 'Cíl {cil} za {roky} let.',
    zadaniBezneBezLet: 'Cíl {cil}.',
    zadaniHypo: 'Vlastní zdroje {cil} za {roky} let (varianta {varianta}). Splátka pak {splatka} měsíčně.',
    zadaniHypoBezLet: 'Vlastní zdroje {cil} (varianta {varianta}). Splátka pak {splatka} měsíčně.',
    zadaniRenta: 'Renta {renta} měsíčně znamená kapitál {cil} — z něj se dá trvale čerpat 4 % ročně. Horizont {roky} let.',
    zadaniRentaBezLet: 'Renta {renta} měsíčně znamená kapitál {cil} — z něj se dá trvale čerpat 4 % ročně.',
    zadaniRezerva: 'Likvidní rezerva {cil} — polštář na nečekané výdaje. Má přednost před investováním.',
    zdroje: 'Jednorázově z: {zdroje}.',
    zdrojeFondyRezerva: 'Chybějících {fondy} se doplní z fondů — prodej podílových fondů, ETF nebo akcií, které klient už má.',
    zpetNaNavrh: 'Zpět na návrh systému',
  },
  /* BLOK:dopCil END */
  /* ── boLab — NÁHLED MOTIVU „beplan“ (design-lab/beplan-orange) ───────────
   * Texty interní náhledové stránky /design-lab/beplan-orange. NENÍ v produkční
   * navigaci a NEPŘEBARVUJE aplikaci — tokeny motivu jsou zavřené v `.bo-scope`
   * (frontend/src/design-lab/brand-orange/motiv.css).
   * Klíč po klíči shodné ve všech pěti jazycích (214 klíčů) — hlídá
   * design-lab/brand-orange/__tests__/klicePetJazyku.test.js.
   * ⚠️ Barva se jmenuje neutrálně „brand oranžová“. Pracovní název ze zadání se
   * nepoužívá: koliduje s historickým pojmem z války ve Vietnamu a aplikaci
   * používají vietnamští poradci i klienti.
   * ──────────────────────────────────────────────────────────────────────── */
  boLab: {
    boLab: {
      cil: {
        brzda: "Brzda plánu",
        brzdaText: "Cíle si žádají",
        brzdaText2: "ale volný přebytek je jen",
        brzdaText3: "Chybí",
        bydleniText: "ČNB: do 36 let stačí 10 % vlastních zdrojů (LTV 90 %). Z ceny 4 500 000 Kč to je 450 000 Kč.",
        chybi: "Chybí",
        cilova: "Cílová částka",
        cilu: "cíle",
        dnes: "Dnes",
        historie: "Historie změn",
        hned: "hned",
        let: "let",
        mesicne: "Měsíčně",
        plneni: "Plnění",
        prebytek: "Volný přebytek",
        prepocitat: "Přepočítat plán",
        prijem: "Čistý příjem",
        rezervaText: "Rezerva vydrží necelé 2 měsíce výdajů místo doporučených 6. Do vytvoření rezervy nemá smysl navyšovat investice.",
        rozdeleno: "Rozděleno",
        srovnat: "Srovnat priority",
        stavNevime: "Nevíme",
        stavNevychazi: "Nevychází",
        stavSplneno: "Vychází",
        stavTesne: "Těsně",
        titul: "Plán — cíle",
        upravit: "Upravit cíl",
        zaHorizont: "Za horizont",
        zbyva: "Zbývá",
      },
      jedMes: "/měs",
      klient: {
        bezneVydaje: "Běžné výdaje",
        chybiPrijemPartnera: "Chybí příjem partnera",
        chybiUdaje: "Chybí 3 údaje",
        cistyPrijem: "Čistý příjem",
        deti: "Děti",
        domacnost: "Domácnost",
        dopad: "Co to znamená",
        dopadHorniOdhad: "horní odhad, státní dávku zatím nikdo nedohledal.",
        dopadText: "Při invaliditě 3. stupně vypadne celý příjem. Chybí krytí zhruba",
        dps: "Penzijní spoření",
        fazeRealizace: "Fáze: Realizace",
        hotovo: "Hotovo",
        invalidita: "Invalidita 3. stupně",
        investice: "Investice",
        jmeno: "Jméno",
        kOvereni: "K ověření",
        klientOd: "klient od",
        let: "let",
        majetekZavazky: "Majetek a závazky",
        mezera: "Mezera",
        narozeni: "Narození",
        nekryto: "nekryto",
        overeno: "ověřeno",
        partner: "Partner",
        pn: "Pracovní neschopnost",
        pojisteni: "Pojištění",
        prijemPartnera: "Příjem partnera",
        prijmyVydaje: "Příjmy a výdaje",
        rezerva: "Likvidní rezerva",
        roky: "roky",
        sdeleno: "sděleno",
        sekce: "Sekce klienta",
        servis: "Servis 14. 11. 2026",
        smrt: "Smrt",
        splatkyUveru: "Splátky úvěrů",
        spotrebitelsky: "Spotřebitelský úvěr",
        statniDavka: "Invalidní důchod od státu",
        stavSmlouva: "Ve smlouvě",
        telefon: "Telefon",
        telefonPartner: "Telefon partnera",
        tisk: "Tisk",
        ulozit: "Uložit",
        zalozkaAnalyza: "Analýza",
        zalozkaDokumenty: "Dokumenty",
        zalozkaHistorie: "Historie",
        zalozkaObchody: "Obchody",
        zalozkaPlan: "Plán",
      },
      lab: {
        coJeVidet: "Co je na téhle obrazovce vidět",
        dnes: "Dnešek",
        dnesBezTmave: "Dnešek tmavou variantu NEMÁ — appka žádnou nemá, takže vlevo zůstává světlá. Není to chyba náhledu.",
        dnesPopis: "Sage & Clay — co poradce vidí teď",
        jenDnes: "Jen dnešek",
        jenNavrh: "Jen návrh",
        miraTitul: "Šířka obsahu vs šířka rámu. Když obsah přeteče, stránka jde do vodorovného scrollu.",
        motiv: "Motiv",
        navrh: "Návrh",
        navrhPopis: "brand oranžová + navy — světlá",
        navrhPopisTmava: "brand oranžová + navy — tmavá",
        notebook: "Notebook 1440",
        obrazovky: "Obrazovky",
        odznak: "Náhled — appka se nemění",
        preteka: "přetéká",
        sedi: "sedí",
        sirka: "Šířka",
        svetla: "Světlá",
        telefon: "Telefon 390",
        titul: "Design Lab · motiv beplan",
        tmava: "Tmavá",
        vedleSebe: "Vedle sebe",
        zobrazeni: "Zobrazení",
        zpet: "Zpět",
      },
      login: {
        claim: "Finanční plán, kterému klient rozumí.",
        claimSub: "Analýza, plán a servis na jednom místě — pro poradce i pro klienta.",
        email: "E-mail",
        heslo: "Heslo",
        prihlasit: "Přihlásit se",
        sso: "nebo přes firemní účet",
        zalozkaPrihlaseni: "Přihlášení",
        zalozkaRegistrace: "Registrace",
        zapomenute: "Zapomenuté heslo",
        zpusob: "Způsob přihlášení",
      },
      mesic: {
        cerven: "Č",
        cervenec: "Č",
        kveten: "V",
        rijen: "Ř",
        srpen: "S",
        zari: "Z",
      },
      nastenka: {
        bj: "Body (BJ)",
        bjZPlanu: "BJ z měsíčního plánu",
        diar: "Diář — dnes",
        dnesUkoly: "dnes 5 úkolů",
        kpi: "Klíčová čísla měsíce",
        mezera: "Mezera",
        mezeraText: "Hájek — invalidita 3. stupně nekrytá.",
        mezeraText2: "Dvořáková — rezerva pod 2 měsíce výdajů.",
        nadKapacitu: "Plán je nad kapacitou domácnosti.",
        novyKlient: "Nový klient",
        obchodu: "9 obchodů",
        pipeline: "Pipeline",
        plneniPlanu: "Plnění plánu",
        poTerminu: "po termínu 11 dní",
        podtitul: "Úterý 25. srpna · 3 schůzky · 2 úkoly po termínu",
        prebytek: "Rozpracovaný plán — Hájek",
        prilezitosti: "Radar příležitostí",
        provize: "Provize",
        radar: "Servisní radar",
        rozdeleno: "Rozděleno do cílů",
        rust: "+18 %",
        titul: "Dobré ráno, Pane Čungu",
        typPlan: "Plán",
        typPrvni: "První schůzka",
        typServis: "Servis",
        ukoly: "Po termínu",
        vejdeSe: "Vejde se do přebytku.",
        volnyPrebytek: "Volný přebytek",
        vyplaceno: "vyplaceno 15. 8.",
        vyvoj: "Vývoj obchodů",
        zPlanu: "68 % plánu",
        za2mesice: "servis za 2 měsíce",
        za3tydny: "servis za 3 týdny",
        zbyva: "Do konce měsíce zbývá 6 pracovních dnů.",
      },
      nav: {
        diar: "Diář",
        hlavni: "Hlavní navigace",
        klienti: "Klienti",
        nastenka: "Nástěnka",
        nastroje: "Nástroje",
        obchody: "Obchody",
        plan: "Plán",
        poradce: "Pan Čung",
      },
      nevyplneno: "nevyplněno",
      neznamo: "neznámo",
      obrazovka: {
        cil: "Karta cíle",
        klient: "Karta klienta",
        nastenka: "Nástěnka",
        prihlaseni: "Přihlášení",
        verejna: "Veřejná stránka",
        vystup: "Klientský výstup",
      },
      pozn: {
        cil: "Nejsložitější obrazovka. Čtyři cíle vzorového klienta, kapacitní brzda nahoře (plán je o 5 300 Kč měsíčně nad možnostmi domácnosti) a problém, dopad, krok pod čísly.",
        cilSazba: "Jediné místo náhledu, kde se liší i sazba, ne jen barvy. Přepni šířku na Telefon 390 a porovnej měřáky nad panely.",
        klient: "Formulářová hustota. Hranice polí, čitelnost malých popisků a hlavně rozdíl mezi nevyplněno a nula: prázdná pole jsou čárkovaná a jantarová, ne nulová.",
        nastenka: "Kolik oranžové obrazovka unese. Pravidlo: jedna sytá oranžová plocha na obrazovku (tlačítko Nový klient). Stavy jsou zelená, jantarová, červená a modrá jako tmavý text na světlém tónu — akce a stav se pak nepletou už tvarem.",
        prihlaseni: "První dojem. Logo, oranžové tlačítko, podtržená aktivní záložka. Fotka pláže z předlohy je nahrazená navy plochou se šipkou z loga — text na fotce má neznámou světlost, takže kontrast nejde zaručit.",
        verejna: "To, co klient vidí jako první. Jediná obrazovka, kde smí být oranžová velká — je to plocha značky, ne ovládací prvek. Text na ní je navy, ne bílý.",
        vystup: "Nejpřísnější místo motivu. Papír zůstává bílý i v tmavém režimu, oranžová je na něm vždy tmavší odstín a každý pruh má vedle sebe číslo i slovo, aby černobílý tisk nepřišel o informaci.",
      },
      vystup: {
        castka: "Částka",
        chybi: "chybí",
        cil: "Cíl",
        disclaimer: "Doporučení vycházejí z údajů poskytnutých klientem k datu zpracování. Nejde o investiční doporučení ani o příslib výnosu. Uvedené modelace jsou orientační.",
        eyebrow: "Finanční plán",
        kdeJsteDnes: "Kde jste dnes",
        mesice: "měsíce",
        mesicneCelkem: "Měsíčně celkem",
        pokryto: "pokryto",
        poslat: "Poslat klientovi",
        prebytek: "Volný přebytek",
        prijem: "Čistý příjem",
        prvniKrok: "První krok",
        prvniKrokText: "Dorovnat likvidní rezervu na 168 000 Kč. Do té doby má rezerva přednost před investováním — bez ní by každý nečekaný výdaj rozbil zbytek plánu.",
        rezervaMa: "Rezerva vydrží",
        splneniCilu: "Splnění vašich cílů",
        tisk: "Vytisknout / uložit PDF",
        vaseCile: "Vaše cíle",
        vytvoreno: "Zpracoval Pan Čung · 25. srpna 2026",
      },
      web: {
        claim: "Ať vaše peníze mají plán, ne náhodu.",
        claimSub: "První schůzka je zdarma a nezávazně. Trvá zhruba 30 minut, online přes Google Meet.",
        oMne: "O mně",
        online: "Online, 30 minut",
        otazky: "Otázky",
        reference: "Reference",
        referenceSablona: "Místo na reference, které si poradce vyplní sám. Náhled je schválně nevyplňuje — vymyšlená reference se jménem je právní riziko.",
        rezervace: "Rezervace",
        rezervovat: "Domluvit schůzku",
        role: "Tvůj finanční poradce",
        sCimPomuzu: "S čím ti umím pomoct",
        sluzba1: "Rezerva a rozpočet",
        sluzba1Sub: "Aby vás nečekaný výdaj nepoložil.",
        sluzba2: "Vlastní bydlení",
        sluzba2Sub: "Kolik potřebujete a kdy to vyjde.",
        sluzba3: "Renta a nezávislost",
        sluzba3Sub: "Kolik odkládat, aby to jednou stačilo.",
        sluzby: "Služby",
        volneTerminy: "Volné termíny tento týden",
        vyberTermin: "Vyber si termín schůzky",
        vybratTermin: "Vybrat termín",
        zdarma: "Zdarma",
      },
    },
  },
  /* Rezervační smlouva (/rezervacni-smlouva). Text SMLOUVY zůstává česky —
     řídí se českým právem a strojově překládaný právní text je chyba, ne
     služba. Pětijazyčně je obsluha kolem něj. */
  rezSmlouva: {
    nazev: 'Rezervační smlouva',
    podnadpis: 'Vyplň hlavičku, cenu a blokační poplatek. Zbytek se doplní a systém smlouvu zkontroluje dřív, než ji vytiskneš.',
    zpetNaZakazku: 'Zpět na zakázku',
    jizRozepsane: 'Na téhle nemovitosti už je rozepsaná smlouva:',
    bezKupujiciho: 'bez kupujícího',
    vzorLabel: 'Vzor smlouvy',
    pracovniVzor: 'Pracovní vzor — text zatím neschválil advokát. U klienta ho zatím nepoužívej.',
    skupina_penize: 'Peníze a doba',
    skupina_hlavicka: 'Hlavička',
    skupina_strany: 'Smluvní strany',
    skupina_nemovitost: 'Nemovitost',
    skupina_kancelar: 'Realitní kancelář',
    skupina_ostatni: 'Další údaje',
    doplneno: 'doplněno',
    vyber: '— vyber —',
    ano: 'Ano',
    ne: 'Ne',
    neniVyplneno: 'nevyplněno',
    odvozeneNadpis: 'Spočítá systém',
    slovyPopis: 'Částku slovy, doplatek i konec rezervace píše systém. Proto se nemůžou rozejít s číslem.',
    odvozene_kupni_cena_slovy: 'Kupní cena slovy',
    odvozene_blokacni_poplatek_slovy: 'Blokační poplatek slovy',
    odvozene_doplatek: 'Doplatek kupní ceny',
    odvozene_doplatek_slovy: 'Doplatek slovy',
    odvozene_rezervace_do: 'Rezervace platí do',
    kontrolaNadpis: 'Kontrola před tiskem',
    kontrolaCisto: 'Bez nálezu. Můžeš tisknout.',
    kontrolaBlokuje: 'Dokud tohle neopravíš, tisk je zavřený.',
    pocitam: 'Počítám…',
    nahledNadpis: 'Náhled smlouvy',
    ulozit: 'Uložit',
    ulozeno: 'Uloženo',
    vytisknout: 'Vytisknout',
    podepsano: 'Označit za podepsanou',
    jePodepsana: 'Podepsáno',
    podepsanaZamek: 'podepsanou smlouvu už nejde měnit',
    advokat: 'E-mail advokátovi',
    advokatHotovo: 'Zpráva je jen připravená. Odešli ji ze svého e-mailu i s přílohou.',
    zkopirovat: 'Zkopírovat',
    zkopirovano: 'Zkopírováno',
    nejdrivUloz: 'Nejdřív smlouvu ulož.',
    tiskZablokovan: 'Prohlížeč zablokoval tiskové okno. Povol vyskakovací okna a zkus to znovu.',
    chybaNacteni: 'Nepodařilo se načíst. Zkus to znovu.',
    chybaUlozeni: 'Neuložilo se.',
    chybaKopie: 'Zkopírovat se nepovedlo.',
  },

  /* BLOK:izp START — generuje scratchpad/slovnik.py, ručně needitovat */
  izp: {
    argumenty: {
      jak1: 'Platí se jedna měsíční částka. Její část jde na krytí rizik, zbytek do investiční složky.',
      jak2: 'Rozsah krytí se dá v průběhu měnit — přidat riziko, zvýšit nebo snížit částku.',
      jak3: 'Z investiční části se obvykle dá vybrat nebo ji snížit. Lhůty a podmínky se u smluv liší.',
      jak4: 'Smlouvu je možné ukončit. Co přesně se v takovém případě vyplácí, určují její podmínky.',
      jak5: 'Když se změní příjem, dá se upravit i to, kolik jde na ochranu a kolik na investici.',
      jakNadpis: 'Jak to obecně funguje',
      nadpis: 'Proč to mít a jak to obecně funguje',
      nasobekCeny: 'cena ×{x}',
      nasobekKryti: 'krytí ×{x}',
      oci: 'Argumenty',
      pomerChybi: 'Doplňte u rizik, co klient má dnes — krytí a cenu. Bez toho se poměr krytí a ceny spočítat nedá.',
      pomerNadpis: 'Krytí proti ceně',
      pomerNejslabsi: 'Bere se nejslabší z porovnaných rizik (počet: {pocet}).',
      pomerVyhra: 'Krytí roste rychleji než cena.',
      pomerZdroj: 'Počítáno z rizik, kde je zadané dnešní i nové krytí (počet: {pocet}). Bere se nejslabší riziko, ne to nejlepší.',
      popis: 'Obecný princip, ne podmínky konkrétní smlouvy.',
      potvrdiKratce: 'Obecný princip, ne podmínky konkrétní smlouvy. Co smlouva dovolí, potvrdí poradce podle nabídky.',
      potvrdiText: 'Tohle je obecný princip, ne podmínky konkrétní smlouvy. Co přesně smlouva dovolí — změny, výběry, ukončení a jejich podmínky — potvrdí poradce podle konkrétní nabídky.',
      potvrdiTuk: 'Co potvrdí poradce',
      proc1: 'Příjem je motor rodiny. Když vypadne, výdaje zůstanou a některé ještě narostou.',
      proc2: 'Stát dává jen část, a ne hned. Zbytek řeší rodina sama.',
      proc3: 'Závazky se neplatí z odhodlání, ale z peněz. Hypotéka běží dál, i když příjem ne.',
      proc4: 'Ochranu i odkládání řešíte jednou částkou, kterou si sami rozdělíte.',
      procNadpis: 'Proč to mít',
    },
    davka: {
      pozustalostni: 'Pozůstalostní důchody — vdovský a sirotčí',
    },
    diagnoza: {
      detskeChronicke: 'Chronická onemocnění vzniklá v dětství, například cukrovka prvního typu nebo epilepsie',
      detskeNadory: 'Dětská nádorová onemocnění, například leukémie',
      infarkt: 'Infarkt myokardu',
      mozkovaPrihoda: 'Cévní mozková příhoda (mrtvice)',
      nadory: 'Nádorová onemocnění',
      neurologicka: 'Neurologická onemocnění — roztroušená skleróza, Parkinsonova a Alzheimerova nemoc',
      ochrnuti: 'Ochrnutí po úrazu nebo nemoci',
      operaceSrdce: 'Operace srdce a velkých tepen',
      selhaniOrganu: 'Selhání orgánů — ledvin, jater, dýchací soustavy',
      smysly: 'Ztráta zraku, sluchu nebo řeči',
      transplantace: 'Transplantace životně důležitého orgánu',
      zenska: 'Onemocnění, která se týkají jen žen, a komplikace v těhotenství',
    },
    diagnozy: {
      deti: 'U dětské smlouvy je seznam jiný — jsou v něm diagnózy, které se objevují v dětství.',
      nadpis: 'Jaké nemoci se kryjí',
      smlouva: 'Přesný výčet diagnóz, jejich definice, stadia i čekací doby určuje pojistná smlouva a u každé pojišťovny se liší. Co je pojištěné u vás, projdeme v pojistných podmínkách.',
      uvod: 'Tohle jsou skupiny diagnóz, o kterých se u závažných onemocnění mluví nejčastěji.',
    },
    graf: {
      aria: 'Graf: zaplatíte celkem {zaplaceno}, z toho do investic {investice}. Hodnota investic v modelu za {roky}: {hodnota}. Model, ne garance.',
      celkemVlozeno: 'Celkem vloženo',
      dnesnimiOcima: 'Dnešními očima {hodnota} (inflace {inflace})',
      hodnotaVModelu: 'Hodnota investic v modelu',
      horizonty: {
        d: {
          hodnota: 'Hodnota v modelu',
          nasobek: 'Násobek vkladů',
          vlozeno: 'Vloženo',
          vlozenoPoplatek: 'z toho poplatek {poplatek}',
          vynos: 'Z toho výnos',
        },
        detailNadpis: 'Za {roky}',
        maStitek: 'má',
        nadpis: 'Čím déle, tím víc',
        oci: 'Čas',
        poPoplatkuStitek: 'vloženo po poplatku',
        predpoklad: 'Při modelovém výnosu {vynos} ročně',
        sloupec: '{roky}: modelová hodnota {hodnota}, vloženo {vlozeno}',
        vlozenoStitek: 'vloženo',
        vrstvy: {
          nadpis: 'Síla složeného úročení',
          vklady: 'Vklady',
          vkladyPoPoplatku: 'Vklady po poplatku',
          zVkladu: 'Výnos z vkladů',
          zVynosu: 'Výnos z výnosů',
        },
        vyber: 'Vyberte, za kolik let',
      },
      konec: {
        hodnota: 'Model',
        investice: 'Do investic',
        zaplaceno: 'Zaplaceno',
      },
      krivka: {
        hodnota: 'Hodnota v modelu',
        investice: 'Do investic',
        ochrana: 'Ochrana (nevrací se)',
        zaplaceno: 'Zaplaceno celkem',
      },
      legendaHodnota: 'Modelová hodnota',
      legendaVlozeno: 'Vloženo',
      milnik: {
        kratce: {
          plnoletost: '18',
          vysoka: 'VŠ',
        },
        plnoletost: '{jmeno}: 18 let',
        vysoka: '{jmeno}: vysoká škola',
      },
      modelText: 'Graf je modelový výpočet ze zadané částky a zvoleného výnosu. Budoucí výnos není garantovaný, skutečný vývoj může být nižší i vyšší. Konkrétní řešení potvrdí poradce.',
      modelTuk: 'Modelový scénář, ne garance',
      modelovaHodnota: 'Modelová hodnota',
      modeloveZhodnoceni: 'Modelové zhodnocení',
      nadpis: 'Co s investiční částí do vybraného věku',
      oci: 'Graf',
      osaRok: 'Rok {rok}',
      osaVekKonec: '{vek} let',
      popis: 'Vyberte věk a očekávaný výnos. Graf ukazuje modelový průběh, ne zaručený výsledek.',
      poplatek: {
        naKonci: 'Na konci',
        naKorunu: 'Na 1 {symbol} poslaných peněz',
        nadpis: 'Tři způsoby, jak zaplatit poplatek',
        navic: 'z toho {poplatek} poplatek hned navíc',
        oci: 'Vstupní poplatek',
        pole: 'Vstupní poplatek (% z cílové částky)',
        poleHint: 'obvykle {min}–{max} %',
        poslano: 'Poslané peníze celkem',
        radek: {
          expres: 'Poplatek {poplatek} · z plateb ({mesicu} měs.)',
          expresHned: 'Poplatek {poplatek} · zaplatíte navíc hned',
          pulNaPul: 'Poplatek {poplatek} · napůl z plateb ({mesicu} měs.)',
        },
        souhrn: '{pct} z cílové částky {cilova} je {poplatek}',
        varianta: {
          expres: {
            nazev: 'Expres z plateb',
            popis: 'Celá platba jde na poplatek, dokud není splacený ({mesicu} měs.).',
          },
          expresHned: {
            nazev: 'Zaplatí hned',
            popis: 'Poplatek zvlášť, investuje se celá platba od prvního měsíce.',
          },
          pulNaPul: {
            nazev: '50/50 z plateb',
            popis: 'Polovina platby na poplatek, polovina se hned investuje ({mesicu} měs.).',
          },
        },
        zToho: 'z toho {poplatek} na poplatek',
      },
      poradcePozn: 'Přepněte věk i výnos před klientem — ať vidí, jak se číslo mění.',
      priVynosu: 'Při výnosu {vynos}',
      rizika: {
        deti: 'Děti',
        doplnte: 'doplňte v Rizicích',
        doporucene: 'Doporučené krytí spočítané z údajů rodiny. Výběr rizik a přesné částky upraví poradce v Rizicích.',
        klient: 'Klient',
        nadpis: 'Za ochranu {cena} měsíčně rodina dostane, když se něco stane',
        nadpisBezCeny: 'Co rodina dostane, když se něco stane',
        podminky: 'Plnění podle pojistných podmínek. Částky se nesčítají.',
        zadna: 'Rizika zatím nejsou vybraná — doplňte v Rizicích.',
      },
      tooltip: {
        dnes: 'Dnes · věk {vek}',
        vek: 'Věk {vek} · za {roky}',
        vynos: 'Výnos v modelu {castka}',
      },
      vek60: '60 let',
      vek65: '65 let',
      vek70: '70 let',
      vekLabel: 'Do kolika let',
      vekVlastni: 'do {vek} let',
      vekVlastniLabel: 'Nebo zadej věk',
      vynos4: '4 % ročně',
      vynos7: '7 % ročně',
      vynos9: '9 % ročně',
      vynosLabel: 'Očekávaný výnos',
      vynosProti: 'proti {investice} do investic · {vynos} ročně',
      vynosVModelu: 'Výnos v modelu',
      zaplaceno: {
        investice: 'Z toho do investic',
        investicePopis: '{mesicne} měsíčně',
        ochrana: 'Z toho ochrana',
        ochranaPopis: 'cena krytí, nevrací se',
        popis: '{mesicne} měsíčně × 12 × {roky}',
        popisPoplatek: '{mesicne} měsíčně × 12 × {roky} + poplatek {poplatek}',
        stitek: 'Zaplatíte celkem',
      },
    },
    hadani: {
      odkryt: 'Odkrýt skutečnost',
      pole: 'Váš tip (měsíčně)',
      rozdil: 'Rozdíl proti vašemu tipu',
      skutecnost: 'Stát dá měsíčně',
      vyzva: 'Kolik myslíte, že vám stát dá? Tipněte si, než to odkryjeme.',
    },
    hranice: {
      davkyOdhad: 'Státní dávky jsou orientační odhad. Skutečnou výši určuje úřad.',
      modelace: 'Tohle je modelový scénář, ne pojistná smlouva ani osobní doporučení.',
      odhadKlienta: 'Váš tip je jen pro srovnání. Do výpočtu ani do tisku nevstupuje.',
      potvrdiPoradce: 'Konkrétní řešení, limity i cenu potvrdí poradce u pojišťovny.',
      sablona: 'Označené částky jsou orientační vzor z praxe poradce, ne nabídka ani garance.',
      vynosNeniGarantovan: 'Budoucí výnos není garantován. Skutečný vývoj může být jiný, i výrazně.',
    },
    jednotka: {
      denni: 'denní dávka',
      jednorazova: 'jednorázová částka',
      renta: 'měsíční renta',
      zaDen: 'na den',
      zaMesic: 'za měsíc',
    },
    karta: {
      cenaHint: 'Opište z modelace pojišťovny. Když ji ještě nemáte, nechte prázdné.',
      cenaNezadana: 'Cena nezadaná — tohle riziko se do součtu nepočítá.',
      cenaPole: 'Cena za měsíc',
      dnesCenaPole: 'Platí dnes',
      dnesHint: 'Opište z jeho současné smlouvy. Bez toho se poměr nespočítá.',
      dnesKrytiPole: 'Krytí dnes',
      dnesNadpis: 'Co má dnes',
      formaNezadana: 'Forma příjmu nezadaná — nemocenská je spočítaná jako u zaměstnance.',
      jakSePocita: 'Jak se to počítá',
      jenZeny: 'jen ženy',
      krytiPole: 'Krytí',
      nezadano: 'nezadáno',
      osvcBezNemocenske: 'Jako OSVČ bez dobrovolného nemocenského pojištění nemocenskou nedostáváte.',
      otazka: 'Otázka na klienta',
      oznacProbrano: 'Označit jako probrané',
      poOsobach: 'Po osobách',
      pomerCena: 'cena',
      pomerKryti: 'krytí',
      pomerNadpis: 'Poměr proti dnešnímu stavu',
      potreba: 'Kolik je potřeba',
      preskoceno: 'Přeskočeno',
      preskocit: 'Přeskočit',
      proDeti: 'i pro děti',
      probrano: 'Probráno',
      radekPotreba: 'potřeba',
      sbalit: 'Sbalit',
      statDa: 'Co dá stát',
      tvar: 'Tvar plnění',
      vCene: 'v ceně',
      varianty: 'Varianty krytí',
      vratit: 'Vrátit',
      vyradit: 'Vyřadit',
      zapsat: 'Zapsat čísla',
      zaradit: 'Zařadit',
    },
    neznamo: 'Nezadáno',
    poznamka: {
      cenaOdPoradce: 'Cenu a konkrétní řešení potvrdí poradce podle nabídky pojišťovny.',
      hodnotaDnesnimaOcima: 'Dnešními očima při inflaci {inflace} % ročně to je',
      investiceVynesla: 'Investiční část podle modelu vynesla',
      modelovyScenar: 'Modelový scénář, ne pojistná smlouva ani osobní doporučení.',
      nezbytneJsouCeleVydaje: 'Potřeba krytí se počítá z celých výdajů domácnosti. Nezbytné výdaje bývají nižší — přesné číslo spočítá plná kalkulačka životního pojištění.',
      odhadKlientaNeniUdaj: 'Váš tip je jen pro srovnání — do výpočtu ani na papír nevstupuje.',
      vlozenoDoOchrany: 'Za {roky} let jste do ochrany vložili',
      vynosNeniGarantovan: 'Budoucí výnos není garantovaný. Hodnota investice může klesat i stoupat.',
    },
    prehled: {
      balicekVysvetleni: 'Balíček je procento z příjmu, ne ze zbytku. Proto je vidět, jestli se do volných peněz vejde. Modelový scénář, konkrétní řešení potvrdí poradce.',
      balicky: 'Kolik by šlo odkládat',
      balickyPodnadpis: 'Klikněte na balíček. Část jde do ochrany, zbytek se investuje — rozdělení nastavíte hned pod tím.',
      chybi: 'Chybí',
      doporuceno: 'Nejvyšší, co se vejde',
      nadVolnymi: 'Není to zákaz — klient si smí vybrat víc. Znamená to jen, že spolu musíme najít, odkud ty peníze vzít.',
      nadpis: 'Kolik projde rukama',
      podnadpis: 'Dvě čísla, která o sobě klient ví. A jedno, které obvykle nezná.',
      prijem: 'Čistý příjem domácnosti',
      prijemNotePar: 'Manžel a manželka dohromady.',
      vejdeSe: 'Vejde se do volných peněz.',
      vlastni: 'Vlastní částka',
      vlastniHint: 'Zapište číslo, které klient řekl.',
      vlastniLabel: 'Kolik chce odkládat',
      vlastniPopis: 'kolik řekne klient',
      vlastniPrazdna: 'Napište částku, kterou klient řekl — jinak není z čeho počítat.',
      volne: 'Zbývá volných',
      volneKratce: 'Příjem minus výdaje.',
      volneNote: 'Příjem minus výdaje. Z tohohle se dá odkládat.',
      volneZaporne: 'Domácnost prožije víc, než vydělá. Než se budeme bavit o pojistce, musíme najít, kde peníze utíkají.',
      vybrano: 'Vybráno',
      vydaje: 'Výdaje domácnosti',
      vydajeNote: 'Včetně splátek úvěrů.',
      zPrijmu: 'z příjmu',
      zTohoRodine: 'z toho rodičům / rodině {castka}',
    },
    prezentace: {
      dal: 'Dál: {nazev}',
      krok: {
        cas: {
          nadpis: 'Jak platit poplatek a co udělá čas',
          otazka: 'Co se stane, když peníze necháte pracovat déle?',
          say: 'Vyberte si sloupec. Uvidíte, kolik jste vložili a kolik z toho udělal čas.',
          stitek: 'Poplatek a čas',
          tip: 'Ať klikne klient sám. Model, ne slib.',
        },
        cisla: {
          nadpis: 'Vaše čísla',
          otazka: 'Kolik vám doma měsíčně přijde a kolik z toho zase odejde?',
          say: 'Stačí zhruba, přesně to doladíme spolu.',
          stitek: 'Čísla',
          tip: 'Volné peníze klient většinou nezná — nechte ho, ať si je přečte sám.',
        },
        investice: {
          nadpis: 'Zbytek balíčku pracuje',
          otazka: 'Kolik let by ty peníze mohly pracovat?',
          say: 'Graf je model, ne slib. Ukazuje, co udělá čas.',
          stitek: 'Investice',
          tip: 'Věk ať vybere klient sám.',
        },
        konecne: {
          brana: 'Nejdřív zapište rozhodnutí klienta: Ano, chci, Upravit, nebo Zatím ne.',
          nadpis: 'Konečné rozhodnutí',
          otazka: 'Teď znáte cenu i podmínky. Chcete tuhle ochranu?',
          say: 'Ano, úprava i zatím ne jsou v pořádku.',
          stitek: 'Potvrzení',
          tip: 'U „Upravit“ se zeptejte, co změnit.',
          volba: {
            ano: 'Ano, chci',
            upravit: 'Upravit',
            zatimNe: 'Zatím ne',
          },
        },
        potvrzeni: {
          celkem: 'Ochrana celkem',
          cena: 'Cena',
          cenaUTemat: 'Cena je zatím u {n} z {celkem} témat.',
          kryti: 'Krytí',
          nadpis: 'Vaše ochrana',
          otazka: 'Sedí vám tahle ochrana, nebo chcete něco upravit?',
          riziko: 'Riziko',
          rucne: 'V rozdělení balíčku je ochrana upravená ručně na {castka}.',
          say: 'Krytí i cenu ještě potvrdí nabídka pojišťovny.',
          stitek: 'Ochrana',
          tip: 'Když je to drahé, snižte pojistné částky a řekněte nahlas, o jaké krytí klient přijde.',
        },
        predstaveni: {
          say: 'Představím se a řeknu, jak pracuji.',
          tip: 'Registr si klient může ověřit hned na telefonu.',
        },
        rizika: {
          dalsi: 'Další riziko',
          nadpis: 'Co by se mohlo stát',
          otazkaSmrtBezUveru: 'Z čeho by rodina žila, kdybyste se jednou nevrátili domů?',
          otazkaZavazkyBezCastky: 'Máte úvěr, který by po vás někdo musel doplácet?',
          poradi: 'Riziko {n} / {celkem}',
          predchozi: 'Předchozí riziko',
          say: 'Tipněte si a pak se podíváme, jak to je doopravdy.',
          smysl: 'Dává vám to smysl?',
          stitek: 'Rizika',
          tip: 'Po odkrytí se zeptejte, jestli to dává smysl.',
          vsePreskoceno: 'Žádné riziko k probrání — všechna jsou přeskočená.',
        },
        smlouva: {
          nadpis: 'Jak funguje smlouva',
          otazka: 'Co vás na smlouvě zajímá, než se rozhodnete?',
          say: 'Říkám to dopředu, ať vás později nic nepřekvapí.',
          stitek: 'Smlouva',
          tip: 'Zdravotní dotazník čtěte s klientem otázku po otázce.',
        },
        souhlas: {
          brana: 'Nejdřív zapište odpověď klienta: Ano, Později, nebo Ne.',
          nadpis: 'Rozhodnutí je na vás',
          otazka: 'Chcete si příjem rodiny pojistit?',
          say: 'Ano, později i ne jsou v pořádku.',
          stitek: 'Rozhodnutí',
          tip: 'Po otázce mlčte a nechte klienta odpovědět.',
        },
        svoleni: {
          nadpis: 'Co dnes probereme',
          otazka: 'Můžu se zeptat na pár věcí, ať vám ukážu, jak na tom je vaše rodina?',
          say: 'Zabere to pár minut a rozhodnutí je vždycky na vás.',
          stitek: 'Úvod',
          tip: 'Počkejte na odpověď, nespěchejte.',
        },
        zaver: {
          balicek: 'Kolik měsíčně',
          dalsiKrok: 'Další krok',
          dalsiKrokText: {
            ano: 'Připravíme návrh na míru a projdeme ho spolu. Krytí a cenu potvrdí pojišťovna.',
            ne: 'Rozhodnutí je vaše. Kdykoli se k tomu můžeme vrátit.',
            nezadano: 'Další krok domluvíme spolu.',
            pozdeji: 'Domluvíme se, kdy se k tomu vrátíme.',
            upravit: 'Upravíme návrh podle vás a projdeme ho spolu znovu. Krytí a cenu potvrdí pojišťovna.',
            zatimNe: 'Rozhodnutí je vaše. Kdykoli se k tomu můžeme vrátit.',
          },
          nadpis: 'Na závěr',
          otazka: 'Jaký další krok vám dává smysl?',
          poznamka: 'Poznámka',
          rozhodnuti: 'Vaše odpověď',
          say: 'Tady jsou dvě čísla. Závěr je na vás.',
          sayBez: 'Děkuju za váš čas. Rozhodnutí je vaše a platí.',
          stitek: 'Závěr',
          termin: 'Termín',
          terminKlient: 'Domluvený termín: {kdy}',
          tip: 'Čísla nespojujte do jedné věty.',
          tipBez: 'Nepřesvědčujte — jen se domluvte, kdy se ozvete.',
        },
      },
      predstaveni: {
        jakText: 'Ukážu vám, jak na tom je vaše rodina. Jestli a jak se pojistit, rozhodnete vy.',
        odmenaText: 'Jak jsem za svou práci odměňován, vám řeknu a před podpisem to dostanete písemně.',
      },
      uvod: {
        nadpis: 'Jak na tom je vaše rodina',
        rodina: 'Vaše rodina',
        slib: 'Ukážeme si to, zeptáte se a rozhodnete se sami.',
      },
    },
    rizika: {
      nadpis: 'Rizika',
    },
    riziko: {
      bezmocnost: {
        coJe: 'Stav, kdy se sám neobsloužíte — nenajíte se, neumyjete, nedojdete si. Někdo u vás musí být každý den.',
        nazev: 'Úplná závislost na péči',
        pozn: 'V modelacích se tomu říká nejvyšší stupeň. Co přesně plnění spustí, určuje pojistná smlouva.',
      },
      denniOdskodne: {
        coJe: 'Dávka za každý den léčení po úrazu. Kryje okno, kdy dávka za pracovní neschopnost ještě neplní.',
        nazev: 'Denní odškodné za dobu léčení úrazu',
      },
      detiHospitalizace: {
        coJe: 'Dávka za každou noc, kterou dítě leží v nemocnici. Rodič je u něj a nepracuje.',
        nazev: 'Pobyt dítěte v nemocnici',
      },
      detiOdskodne: {
        coJe: 'Dávka za každý den léčení dítěte po úrazu — týž výpadek rodiče, jen doma.',
        nazev: 'Denní odškodné dítěte za dobu léčení',
      },
      detiPeceRodice: {
        coJe: 'Dítě zůstane po úrazu nebo nemoci trvale závislé na péči. Největší díra není léčba — je to rodič, který kvůli péči natrvalo vypadne z práce.',
        nazev: 'Vážná událost u dítěte — výpadek příjmu rodiče',
        pozn: 'Částka stojí na smlouvě každého dítěte. Část potřeby na dítě neupíše žádná pojišťovna — ta patří do rezervy a do investic.',
      },
      detiTrvale: {
        coJe: 'Jednorázová částka na rehabilitaci, pomůcky a úpravy bydlení, když dítěti po úrazu zůstane trvalé omezení.',
        nazev: 'Trvalé následky úrazu u dítěte',
      },
      detiZavazne: {
        coJe: 'Jednorázová výplata při vyjmenované diagnóze u dítěte — na léčbu a na to, aby rodič mohl zůstat doma.',
        nazev: 'Závažná onemocnění dítěte',
        pozn: 'Kolik na dítě pojišťovna upíše, je omezené. Zbytek potřeby patří do rezervy a do investic.',
      },
      hospitalizace: {
        coJe: 'Dávka za každou noc v nemocnici. Krátkodobá věc — u dospělého ji obvykle zastoupí rezerva.',
        nazev: 'Pobyt v nemocnici',
      },
      invalidita1Klesajici: {
        coJe: 'Částečné omezení práce se sjednanou částkou, která se v čase snižuje.',
        nazev: 'Invalidita 1. stupně — klesající částka',
      },
      invalidita1Konstantni: {
        coJe: 'Částečné omezení práce. Příjem klesne, výdaje zůstanou.',
        nazev: 'Invalidita 1. stupně — konstantní částka',
      },
      invalidita2Klesajici: {
        coJe: 'Vážné omezení práce se sjednanou částkou, která se v čase snižuje.',
        nazev: 'Invalidita 2. stupně — klesající částka',
      },
      invalidita2Konstantni: {
        coJe: 'Vážné omezení práce: něco zvládnete, svoji profesi na plný úvazek ale ne.',
        nazev: 'Invalidita 2. stupně — konstantní částka',
      },
      invalidita3Klesajici: {
        coJe: 'Úplná invalidita, ale pojistná částka rok po roce klesá.',
        nazev: 'Invalidita 3. stupně — klesající částka',
        pozn: 'Levnější varianta. Má smysl jen tehdy, když opravdu investujete a majetek díru postupně zaplní — jinak krytí klesá a potřeba ne.',
      },
      invalidita3Konstantni: {
        coJe: 'Úplná invalidita: pracovat nemůžete vůbec. Sjednaná částka zůstává celou dobu stejná.',
        nazev: 'Invalidita 3. stupně — konstantní částka',
      },
      pece12: {
        coJe: 'Denní dávka na dobu, kdy většinu věcí zvládnete sám, ale u některých potřebujete pomoc.',
        nazev: 'Dlouhodobá péče — nižší stupně závislosti',
      },
      pece34: {
        coJe: 'Měsíční renta po celou dobu, kdy potřebujete každodenní péči druhé osoby.',
        nazev: 'Dlouhodobá péče — vyšší stupně závislosti',
        pozn: 'Potřebnou výši renty tahle appka nepočítá — částku doplní poradce z modelace.',
      },
      pnOd29: {
        coJe: 'Denní dávka, která začne po čtyřech týdnech neschopnosti. První měsíc pokryje rezerva.',
        nazev: 'Pracovní neschopnost od 29. dne',
      },
      pnOd61: {
        coJe: 'Denní dávka až po dvou měsících. Nejlevnější varianta — má smysl, když rezerva dva měsíce utáhne.',
        nazev: 'Pracovní neschopnost od 61. dne',
      },
      pnPlus: {
        coJe: 'Denní dávka s mírnějšími podmínkami — plní i v situacích, které základní varianta vylučuje.',
        nazev: 'Pracovní neschopnost s rozšířeným plněním',
        pozn: 'Co přesně je zahrnuté a co vyloučené, stojí v pojistných podmínkách. Projděte je s poradcem.',
      },
      smrtInvaliditaKombinace: {
        coJe: 'Jedna pojistná částka, která se vyplatí podle toho, co přijde dřív — úmrtí, nebo invalidita.',
        nazev: 'Smrt nebo invalidita v jedné částce',
        pozn: 'Kombinace plní jednou. Kdo chce pokrýt obě situace v plné výši, potřebuje dvě částky, ne jednu.',
      },
      smrtKlesajici: {
        coJe: 'Pojistná částka rok po roce klesá, protože klesá i zůstatek hypotéky a roste váš majetek.',
        nazev: 'Smrt — klesající částka',
        pozn: 'Levnější varianta. Sedí na dluh, který splácíte — ne na životní úroveň rodiny, ta neklesá.',
      },
      smrtKonstantni: {
        coJe: 'Pojistná částka zůstává stejná celou dobu. Rodina dostane totéž v prvním i v posledním roce.',
        nazev: 'Smrt — konstantní částka',
      },
      smrtKratsiDoba: {
        coJe: 'Krytí na kratší dobu, než je celá smlouva. Typicky do splacení úvěru nebo do dospělosti dětí.',
        nazev: 'Smrt — krytí jen na několik let',
        pozn: 'Vlastní kratší dobu appka nepočítá — pracuje s jedním horizontem pro celou analýzu. Částku i dobu doplní poradce.',
      },
      smrtUraz: {
        coJe: 'Plní jen tehdy, když je příčinou úraz. Proto je levná — a proto to nesmí být hlavní krytí: smrt z nemoci z ní neplní vůbec.',
        nazev: 'Smrt následkem úrazu',
      },
      trvaleOd1: {
        coJe: 'Plní i u malého trvalého poškození. Dražší varianta, ale má nejširší rozsah plnění.',
        nazev: 'Trvalé následky úrazu od nejnižších procent',
      },
      trvaleOd10: {
        coJe: 'Drobná poškození vynechá a plní teprve u těch, která vám opravdu změní život.',
        nazev: 'Trvalé následky úrazu od deseti procent',
      },
      trvalePremium: {
        coJe: 'Čím vážnější následek, tím vyšší výplata — u těžkých poškození několikanásobek sjednané částky.',
        nazev: 'Trvalé následky úrazu s vyšší progresí',
        pozn: 'Jak rychle progrese roste a kde má strop, určuje pojistná smlouva.',
      },
      zavazkyDluh: {
        coJe: 'Podíl na hypotéce a ostatních splátkách, které nezmizí. Je to složka částky u smrti a u invalidity, ne krytí navíc.',
        nazev: 'Závazky — kdo je doplatí',
        pozn: 'Dluhy se nekrátí v žádné variantě krytí. Hypotéku nelze doplatit na osmdesát procent.',
      },
      zavazneKlesajici: {
        coJe: 'Totéž krytí s částkou, která se rok po roce snižuje. Levnější, pokud zároveň roste váš majetek.',
        nazev: 'Závažná onemocnění — klesající částka',
      },
      zavazneOpakovane: {
        coJe: 'Plní víc než jednou — když po vyléčení přijde jiná vyjmenovaná diagnóza, vyplatí se znovu.',
        nazev: 'Závažná onemocnění s opakovaným plněním',
        pozn: 'Celkový strop opakovaného plnění určuje pojistná smlouva.',
      },
      zavazneRozsirene: {
        coJe: 'Totéž krytí, jen s delším seznamem diagnóz a mírnějšími podmínkami plnění. Co přesně je zahrnuté, stojí ve smlouvě.',
        nazev: 'Závažná onemocnění — rozšířený rozsah',
      },
      zavazneZakladni: {
        coJe: 'Jednorázová výplata při diagnóze ze seznamu ve smlouvě. Ty peníze nejsou na účty — jsou na to, abyste mohl přestat pracovat a léčit se.',
        nazev: 'Závažná onemocnění — základní rozsah',
      },
      zavazneZeny: {
        coJe: 'Doplněk zaměřený na onemocnění, která se týkají jen žen, a na komplikace v těhotenství.',
        nazev: 'Závažná onemocnění pro ženy',
      },
    },
    rokFew: '{n} roky',
    rokMany: '{n} let',
    rokOne: '{n} rok',
    rozdeleni: {
      balicek: 'Měsíční balíček:',
      chybiBalicekTuk: 'Balíček zatím není vybraný',
      investice: 'Investice',
      nadpis: 'Kolik na ochranu a kolik na investici',
      ochrana: 'Ochrana',
      podilOchrany: 'Na ochranu jde {pct} balíčku',
      popis: 'Balíček se dělí na dvě části. Posuvníkem si to můžete osahat sami.',
      posuvnik: 'Kolik z balíčku jde na ochranu',
      prekrocenoText: 'Na investici by nezbylo nic a do balíčku chybí {chybi}. Buď se sníží krytí, nebo se zvýší částka, kterou klient odkládá.',
      prekrocenoTuk: 'Ochrana je dražší než balíček',
      skript: 'Máte {balicek} měsíčně. Kolik z toho chcete dát na ochranu rodiny a kolik nechat vydělávat? Zkuste to posunout sami.',
      skriptNadpis: 'Věta na schůzku',
      zdrojNeznamy: 'Cena ochrany zatím není zadaná u žádného rizika.',
      zdrojPosuvnik: 'Částku jste nastavili posuvníkem.',
      zdrojSoucet: 'Ze součtu cen u rizik: {soucet} · rizik s cenou: {pocet}',
      zpetNaSoucet: 'Zpět na součet cen',
    },
    rozpad: {
      cile: 'Cíle',
      deficitMes: 'Chybí měsíčně',
      detiCelkem: 'Potřeba rodiny',
      detiNepojistitelne: 'Z toho nepojistitelné',
      detiSoucet: 'Součet smluv',
      detiZavazne: 'Závažná onemocnění dítěte',
      diskont: 'Přepočteno na dnešek sazbou',
      dluhy: 'Dluhy',
      karence: 'Rezerva pokryje (měsíců)',
      naDite: 'Na jedno dítě',
      nasobekPrijmu: 'Násobek ročního příjmu',
      prijem: 'Příjem',
      statniDavka: 'Státní dávka',
      tnuSablona: 'Trvalé následky — šablona',
      vydaje: 'Kapitál na výdaje do konce horizontu',
      vydajePoUdalosti: 'Výdaje po události',
    },
    skupina: {
      deti: {
        nazev: 'Děti',
        otazka: 'Kdo z vás dvou by zůstal doma, kdyby dítě onemocnělo na celý rok?',
        podtitul: 'Nemoc dítěte je výpadek příjmu rodiče',
      },
      invalidita: {
        nazev: 'Invalidita',
        otazka: 'Kolik myslíte, že vám stát měsíčně dá, kdybyste už nemohl pracovat?',
        podtitul: 'Když už nemůžete pracovat — a žijete dál',
      },
      neschopnost: {
        nazev: 'Dlouhá pracovní neschopnost',
        otazka: 'Kolik vám stát pošle za měsíc na neschopence? Tipněte si.',
        podtitul: 'Měsíce doma, výdaje běží dál',
      },
      pece: {
        nazev: 'Dlouhodobá péče',
        otazka: 'Kdo by se o vás staral — a z čeho byste tu péči platili?',
        podtitul: 'Když se sám neobsloužíte',
      },
      smrt: {
        nazev: 'Smrt',
        otazka: 'Kdo doplatí hypotéku, když se nevrátíte domů?',
        podtitul: 'Co zůstane rodině a co zůstane bance',
      },
      uraz: {
        nazev: 'Úraz',
        otazka: 'Co by se u vás doma změnilo, kdybyste po úrazu nemohl dělat svou práci jako dřív?',
        podtitul: 'Trvalé následky a dny léčení',
      },
      zavazky: {
        nazev: 'Závazky',
        otazka: 'Kdo doplatí těch {castka}?',
        podtitul: 'Splátky, které nezmizí',
      },
      zavazne: {
        nazev: 'Závažné onemocnění',
        otazka: 'Kdyby vám zítra řekli diagnózu — z čeho byste žili ten rok, kdy chcete jen léčit se?',
        podtitul: 'Diagnóza, po které se léčíte měsíce až roky',
      },
    },
    smlouva: {
      dlouhodoba: {
        nadpis: 'Pojistka je na roky',
        odstoupeni: 'Odstoupení krátce po podpisu',
        odstoupeniText: 'Krátce po uzavření můžete od smlouvy odstoupit i bez udání důvodu. Lhůtu stanoví zákon a najdete ji ve smlouvě.',
        preruseni: 'Když přestanete platit',
        preruseniText: 'Co se stane, určují pojistné podmínky.',
        text: 'Smysl dává dlouhodobě, ne na pár měsíců.',
        ukonceni: 'Když smlouvu ukončíte',
        ukonceniDusledek: 'V prvních letech, dokud se splácí vstupní poplatek, můžete při ukončení dostat zpět málo nebo nic.',
        ukonceniText: 'Můžete. Krytí končí dnem ukončení. Co dostanete zpět, určují pojistné podmínky.',
        znovu: 'Nová smlouva později znamená nový zdravotní dotazník — podle věku a zdraví v tu dobu.',
      },
      dotaznik: {
        nadpis: 'Zdravotní dotazník: pravdivě a úplně',
        podpis: 'Nepodepisujte nic, čemu nerozumíte.',
        spolu: 'Projdeme ho spolu, otázku po otázce. Čemu nerozumíte — i kvůli jazyku — na to se zeptejte.',
        text: 'Nepravdivá nebo neúplná odpověď může znamenat, že pojišťovna nezaplatí, nebo zaplatí méně — i po letech placení.',
      },
      investice: {
        dny: 'obvykle do {dny} dnů',
        dnyPodleSmlouvy: 'Přesnou lhůtu najdete ve smlouvě.',
        dostupne: 'Peníze k dispozici',
        nadpis: 'Investiční část se dá měnit',
        pozastavit: 'Pozastavit',
        pozastavitText: 'na čas přestat investovat',
        pridat: 'Přidat',
        pridatText: 'vyšší platba nebo vklad navíc',
        ubrat: 'Ubrat',
        ubratText: 'výběr části peněz',
      },
      nadpis: 'Jak funguje smlouva',
      oci: 'Smlouva',
      platba: {
        investice: 'Investice',
        investiceText: 'Má hodnotu a dá se z ní brát. Kdy a jak, určuje smlouva.',
        nadpis: 'Platba má dvě části',
        ochrana: 'Ochrana',
        ochranaText: 'Cena za krytí. Nevrací se — jako povinné ručení u auta.',
      },
      vyluky: {
        nadpis: 'Kdy pojišťovna neplatí',
        text: 'Každá smlouva má výluky — případy, kdy pojišťovna neplní. Jsou v pojistných podmínkách a projdeme je spolu.',
      },
    },
    souhrn: {
      cenaMesic: 'Cena za měsíc',
      cenaNezadana: 'Cenu zadá poradce z modelace',
      cenaUTemat: 'Cena je zatím u {s} z {z} témat.',
      nadpis: 'Souhrn',
      osoba: 'Osoba',
      pozn: 'Cenu a konkrétní řešení potvrdí poradce podle nabídky pojišťovny.',
      preskoceno: 'Přeskočeno',
      probrano: 'Probráno',
      sCenou: 'S cenou',
      vybrano: 'Vybráno',
      zbyva: 'Zbývá',
    },
    spolecne: {
      let: 'let',
      nezadano: 'nezadáno',
      podtitulek: 'Od příjmu přes rizika ke dvěma číslům: co rodina dostane, když se něco stane — a co zbyde, když ne.',
      rezimKlient: 'Ukázat klientovi',
      rezimPoradce: 'Zpět k poradci',
      sekce: 'Životní pojištění',
      titulek: 'Analýza pro Vietnamce',
      ukazka: 'Ukázkový klient',
      ukazkaJmeno: 'Ukázka',
      ukazkaZnacka: 'Ukázková čísla na nácvik schůzky — nejsou to údaje klienta, který tu sedí.',
      vycistit: 'Nový klient',
      zaDen: '/ den',
      zaMesic: '/ měsíc',
      zpet: 'Zpět na nástroje',
    },
    stav: {
      doplniPoradce: 'Chybí vstup. Doplní ho poradce — nedopočítáváme.',
      jeSlozka: 'Je to složka částky u smrti a u invalidity, ne krytí navíc.',
      kombinace: 'Kombinace plní jednou. Skládá se z: {rizika}',
      neumimeSpocitat: 'Tohle krytí appka nepočítá — částku doplní poradce z modelace.',
    },
    stop: {
      bezBalicku: 'Vyberte balíček, nebo napište vlastní částku.',
      bezCastky: 'Doplňte částku.',
      bezCenyOchrany: 'Cena ochrany zatím není známá — doplňte ji u rizik, nebo ji nastavte posuvníkem.',
      bezHorizontu: 'Vyberte, do kolika let se má počítat.',
      bezKapitalu: 'Bez modelové hodnoty investice se renta nepočítá.',
      bezKatalogu: 'Katalog rizik se nenačetl.',
      bezPoplatku: 'Vstupní poplatek investice není zadaný.',
      bezPrijmu: 'Doplňte čistý měsíční příjem — bez něj se balíčky nedají spočítat.',
      bezRizik: 'Zatím není vybrané žádné riziko.',
      bezVeku: 'Doplňte věk klienta a cílový věk.',
      bezVydaju: 'Doplňte měsíční výdaje — jinak nevíme, kolik doopravdy zbývá.',
      cilovyVekNizsi: 'Cílový věk {vekCilovy} je nižší než dnešní věk {vekDnes} — vyberte pozdější.',
      pctMimoRozsah: 'Odkládat jde {min} až {max} procent příjmu.',
      poplatekMimoRozsah: 'Vstupní poplatek mimo rozsah — obvykle {min} až {max} % z cílové částky.',
      rokyMimoRozsah: 'Počítat jde na {min} až {max} let.',
      vynosMimoRozsah: 'Očekávaný výnos musí být mezi 0 a {max} procenty ročně.',
    },
    tvar: {
      klesajici: 'klesající',
      konstantni: 'konstantní',
    },
    varovani: {
      balicekNadVolne: 'Balíček {pct} % je o {chybi} vyšší než to, co dnes zbývá. Není to zákaz — hledání peněz je práce poradce.',
      cenaChybiUNekterych: 'U {pocet} vybraných rizik není zadaná cena — v součtu chybí.',
      denniCenaJenPodPrahem: 'Denní cena na osobu je nad {prah} — jako prodejní věta se neukazuje, jen jako informace.',
      ochranaNadBalicek: 'Ochrana je o {chybi} dražší než celý balíček — na investici nezbývá nic.',
      poplatekNadObvykly: 'Poplatek {pct} % je mimo obvyklé pásmo {min}–{max} % z cílové částky.',
      poplatekNesplacenyVHorizontu: 'V zadaném horizontu se poplatek nesplatí celý.',
      poplatekNezadan: 'Vstupní poplatek nezadán — číslo je hrubé, bez poplatku.',
      splatkyNadPolovinu: 'Splátky přerostly polovinu příjmu — čísla je potřeba dotáhnout ručně.',
      splatkyNadRozpocet: 'Splátky úvěrů spotřebují víc, než kolik po odkládání zbývá — pravidlo na tuhle domácnost nesedí.',
      vlastniNadPrijem: 'Zadaná částka je vyšší než celý měsíční příjem — není to překlep?',
      vynosMimoScenare: 'Výnos {vynos} % není jeden ze tří modelových scénářů (4 / 7 / 9 %).',
      zadnaCenaZadana: 'Cena není zadaná ani u jednoho vybraného rizika — cenu doplní poradce.',
    },
    vstupy: {
      bezJmena: 'Klient',
      bezPartnera: 'Bez partnera',
      deti: 'Počet dětí',
      detiHint: 'Děti, které domácnost živí.',
      diteJmeno: 'Jméno dítěte',
      diteN: '{n}. dítě',
      diteVek: 'Věk dítěte',
      domacnost: 'Domácnost',
      dvojice: '{a} a {b}',
      forma: 'Forma příjmu',
      formaOsvc: 'OSVČ',
      formaZamestnanec: 'Zaměstnanec',
      jistina: 'Jistina závazků',
      jistinaHint: 'Kolik ještě zbývá doplatit — hypotéka a další úvěry dohromady.',
      jistinaZbyva: 'Zbývající jistina všech úvěrů',
      jmenoOsoby: 'Jméno',
      klient: 'Klient',
      klientka: 'Klientka',
      manzel: 'Manžel',
      manzelka: 'Manželka',
      muz: 'Muž',
      nadpis: 'Koho modelujeme',
      oci: 'Vstupy',
      partnerHint: 'Partnera dělá jméno, ne příjem. Bez jména se s jeho příjmem nepočítá.',
      podnadpis: 'Osm údajů a jde se na věc. Zbytek doplníme, až na něj přijde řeč.',
      podporaRodine: 'Posílá rodičům / rodině měsíčně',
      pohlavi: 'Pohlaví',
      pohlaviHint: 'Ovlivňuje rizikovou sazbu, ne oslovení.',
      prijem: 'Čistý příjem měsíčně',
      prijemHint: 'Kolik doopravdy přijde na účet.',
      souhrnNadpis: 'Modelace pro',
      vek: 'Věk',
      vekCil: 'Věk finanční nezávislosti',
      vekCilHint: 'Do kdy se odkládá. Od té chvíle má vydělávat portfolio, ne klient.',
      vydaje: 'Výdaje domácnosti měsíčně',
      vydajeHint: 'Včetně splátek úvěrů — všechno, co z účtu odejde.',
      vydajeVcSplatek: 'Výdaje domácnosti měsíčně vč. splátek úvěrů',
      zena: 'Žena',
    },
    vysledek: {
      bezKrytiStitek: 'Bez zadaného krytí: {pocet}',
      chybiKryti: 'U probraných rizik chybí krytí (počet: {pocet}). Dokud tam částka není, riziko se v plnění neukáže.',
      hodnotaInvestice: 'Hodnota investiční části v modelu',
      hodnotaPopis: 'vloženo do investic {castka}',
      iddKratce: 'Modelový výnos není garantovaný a nejde o příslib návratnosti zaplaceného pojistného.',
      iddText: 'Vlevo je krytí, které poradce zadal, vpravo modelový vývoj investiční části. Obě čísla stojí samostatně: modelový výnos není garantovaný a nejde o příslib návratnosti zaplaceného pojistného. Závěr je na klientovi, konkrétní řešení potvrdí poradce.',
      iddTuk: 'Dvě samostatná čísla',
      nescitajiSe: 'Rizika se neplní společně, proto se částky nesčítají.',
      nestaloNadpis: 'Co zůstane na konci',
      nestaloOci: 'Kdyby se nic nestalo',
      ochranaZaplatite: 'Za ochranu zaplatíte za {roky}',
      ochranaZaplatiteBezRoku: 'Za ochranu zaplatíte celkem',
      poradceNadpis: 'Pro poradce',
      poradcePozn: 'Čísla nespojujte do jedné věty. Nechte klienta, ať si závěr udělá sám.',
      renta: 'Modelová měsíční renta z této částky',
      rentaPozn: 'Renta při bezpečném čerpání {sazba} ročně. Modelový výpočet, ne garantovaná výplata.',
      rizikoBezNazvu: 'Riziko bez názvu',
      staloNadpis: 'Co rodina dostane',
      staloOci: 'Kdyby se něco stalo',
      staloPodnadpis: 'Po jednotlivých rizicích, která jste vybrali:',
      staloZdroj: 'Částky jsou z krytí, které jste zadali u rizik. Rizika se neplní společně, proto se nesčítají.',
      zadnaRizika: 'Zatím není vybrané žádné riziko se zadaným krytím.',
    },
    zaRokFew: 'za {n} roky',
    zaRokMany: 'za {n} let',
    zaRokOne: 'za {n} rok',
  },
  /* BLOK:izp END */
  /* BLOK:prodejKit START — generuje scratchpad/slovnik.py, ručně needitovat */
  prodejKit: {
    namitky: {
      analyza: {
        mamPoradce: {
          n: 'Už mám svého poradce.',
          o: 'To je dobře, nic měnit nemusíte. Analýza vám ukáže, jak na tom dnes jste, a s výsledkem můžete klidně zajít i za ním.',
        },
        nechciNicKupovat: {
          n: 'Nechci si nic kupovat.',
          o: 'Rozumím. Dnes nic nepodepisujete — ukážu vám čísla, a jestli s nimi něco uděláte, rozhodnete jen vy.',
        },
        nemamCas: {
          n: 'Nemám na to čas.',
          o: 'Rozumím, čas je vzácný — kolik ho dnes máte? Projdeme jen to podstatné a zbytek domluvíme jindy.',
        },
        partner: {
          n: 'Musím to probrat s partnerem.',
          o: 'Určitě, týká se to vás obou. Sejdeme se příště spolu, ať partner slyší totéž co vy?',
        },
        prijmyNereknu: {
          n: 'Příjmy vám říkat nebudu.',
          o: 'Chápu, je to vaše rozhodnutí. Stačí přibližný rozsah — a co nevyplníme, zůstane prázdné, nic si nedomýšlím.',
        },
        procToChcete: {
          n: 'Proč to všechno potřebujete vědět?',
          o: 'Bez vašich čísel bych vám radil naslepo. Na co odpovídat nechcete, to přeskočíme.',
        },
      },
      jenPoradce: 'vidí jen poradce',
      kontext: {
        analyza: 'Analýza',
        pojisteni: 'Pojištění',
      },
      pojisteni: {
        drahe: {
          n: 'Je to drahé.',
          o: 'Chápu, rozpočet znáte nejlíp vy. Můžeme snížit pojistné částky tam, kde výpadek ustojíte z rezervy — a nahlas si řekneme, o jaké krytí tím přijdete.',
        },
        mamPojisteni: {
          n: 'Pojištění už mám.',
          o: 'To je dobře — započítáme ho, ať neplatíte dvakrát za totéž. Podíváme se do smlouvy, kolik vyplatí a jestli kryje i invaliditu, ne jen úmrtí?',
        },
        manzel: {
          n: 'Musím se poradit s manželem / manželkou.',
          o: 'Určitě, je to rozhodnutí vás obou. Sejdeme se příště spolu, ať vidí stejná čísla jako vy — kdy by vám to vyhovovalo?',
        },
        nechciSeVazat: {
          n: 'Nechci se vázat na dlouho.',
          o: 'Rozumím — smlouvu můžete ukončit, jen v prvních letech, dokud se splácí vstupní poplatek, můžete dostat zpět málo nebo nic. Dlouhodobě dává smysl proto, že cena i přijetí se řídí věkem a zdravím v den sjednání, a zdraví se zpětně dokoupit nedá.',
        },
        nicSeMiNestane: {
          n: 'Mně se nic nestane.',
          o: 'Přeju vám to a nejspíš máte pravdu. Nepojišťuju to, co je pravděpodobné, pojišťuju to, co by bylo nevratné — kolik měsíců by rodina vydržela, kdyby se to přece jen stalo?',
        },
        rozmyslim: {
          n: 'Rozmyslím si to.',
          o: 'Jasně, je to rozhodnutí na roky a nikam nespěcháme. Jen ať vím, co vám poslat — chcete si rozmyslet, jestli to riziko řešit, nebo kolik do toho dát?',
        },
      },
      titul: 'Námitky',
    },
    ram: {
      brana: 'Tenhle krok ještě není hotový.',
      dalsi: 'Další',
      hotovo: 'Hotovo',
      hotovyKrok: 'hotovo',
      klavesy: '→ nebo mezerník: další · ←: zpět · Esc: konec',
      klient: 'Klient',
      krok: 'Krok {n} / {celkem}',
      poradce: 'Poradce',
      prejitNa: 'Krok {n}: {nazev}',
      prezentace: 'Prezentace',
      rozbalit: 'Rozbalit',
      skryt: 'Skrýt',
      tahak: 'Tahák',
      tip: 'Tip',
      zavrit: 'Zavřít prezentaci',
      zpet: 'Zpět',
    },
    souhlas: {
      ano: 'Ano',
      ne: 'Ne',
      nezadano: 'Nezadáno',
      pozdeji: 'Později',
      poznamka: 'Poznámka (nepovinná)',
      vymazat: 'Vymazat odpověď',
      zapsano: 'Zapsáno {kdy}',
    },
  },
  /* BLOK:prodejKit END */
  /* BLOK:planPojistne START — generuje scratchpad/slovnik.py, ručně needitovat */
  planPojistne: {
    budouci: 'v budoucnu {castka} — zatím se nepočítá',
    driveNe: 'Klient dříve řekl, že zajištění řešit nechce — plán pojistné neodečítá.',
    nadPrebytek: 'Pojištění {cena} stojí víc než měsíční přebytek {prebytek} — na cíle nezbývá nic.',
    nezadana: 'Cena pojištění nezadaná — plán s ní nepočítá.',
    nula: 'Cena pojištění 0 — z přebytku se nic neodečítá.',
    odmitnuto: 'Klient zajištění příjmu zatím nechce.',
    prebytekBezPrijmu: 'Měsíční přebytek zatím nevíme — v analýze chybí příjmy. Doplňte je, nebo rovnou zapište částku, kterou jste si s klientem odsouhlasili.',
    segment: 'Pojištění',
    tokPrebytek: 'Přebytek po pojištění',
    zToho: 'z toho pojištění {pojisteni} · na cíle {naCile}',
  },
  /* BLOK:planPojistne END */
  /* BLOK:analyzaProdej START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaProdej: {
    cas: {
      ano: 'Ano, má čas',
      drivejsiZapis: 'Dřívější zápis',
      potvrzeno: 'Klient potvrdil 45 minut',
    },
    cesta: {
      dnes: 'DNES',
      popis: 'Cíle naskočí postupně, jak poběží čas',
      prehrat: 'Přehrát',
      preskocit: 'Přeskočit',
      vek: '{n} let',
      za: 'za {n} let',
      znovu: 'Přehrát znovu',
    },
    dedictvi: {
      druh: 'Typ',
      druhJine: 'Jiné',
      druhNemovitost: 'Nemovitost po rodičích',
      nadpis: 'Budoucí majetek (dědictví)',
      nepocita: 'v budoucnu — zatím se nepočítá',
      panel: 'Budoucí majetek',
    },
    forma: {
      jiny: 'Jiný zdroj',
      majitel: 'Majitel firmy',
      osvc: 'OSVČ',
      zamestnanec: 'Zaměstnanec',
    },
    majetek: {
      nefinPod: 'nemovitosti, firma',
    },
    oceneni: {
      do: 'do',
      ebitda: 'Roční provozní zisk (EBITDA)',
      ebitdaPopis: 'Zisk před úroky, daněmi a odpisy — ne zisk před zdaněním.',
      horni: 'Horní hranice',
      majetkove: 'Majetkově',
      nasobek: 'Násobek',
      nezadano: 'nezadáno',
      od: 'od',
      otevrit: 'Pomocník ocenění',
      pouzit: 'Použít jako hodnotu',
      spodni: 'Spodní hranice',
      stred: 'Střed',
      substance: 'Kolik by stálo firmu celou vybavit',
      upozorneni: 'Orientační odhad, ne znalecký posudek.',
      vynosove: 'Výnosově',
      ztrata: 'Při nulovém nebo záporném zisku se výnosově neoceňuje.',
    },
    podklady: {
      dotaznik: 'Investiční dotazník',
      investicni: 'Investiční smlouvy',
      pojistne: 'Pojistné smlouvy',
      uverove: 'Úvěrové smlouvy',
      vypisy: 'Výpisy z účtů',
    },
    prebytek: {
      nicNezbyva: 'Z příjmů dnes nic nezbývá — volné cash flow je {castka}.',
    },
    predstaveni: {
      jakText: 'Dnes jen poznám vaši situaci a cíle. Návrh přinesu příště — rozhodnutí je vždy na vás.',
      jakTitul: 'Jak pracuji',
      kdoText: 'Moji registraci v registru {dohled} si můžete veřejně ověřit.',
      kdoTitul: 'Kdo jsem',
      kicker: 'Než začneme',
      odmenaText: 'Za sjednanou smlouvu mi provizi platí finanční instituce. Podrobnosti dostanete písemně před podpisem.',
      odmenaTitul: 'Moje odměna',
    },
    prez: {
      dialog: 'Prezentace analýzy',
      predstaveni: {
        q: 'Než začneme: kdo jsem a jak pracuji',
        tab: 'Představení',
        tahak: 'Co je pro vás důležité vědět o tom, jak pracuji?',
        tip: 'Registr si klient může ověřit hned na telefonu.',
      },
    },
    reference: {
      gdprPotvrzeno: '✓ Potvrzeno {datum}',
      gdprText: 'Klient potvrzuje, že kontakty předává se souhlasem doporučených osob, nebo bere na vědomí, že je poradce při prvním oslovení informuje o zdroji a zpracování osobních údajů dle čl. 14 GDPR.',
      gdprTitul: 'GDPR souhlas:',
      tahak: '„Mám jednu prosbu. Když Vám dnešní schůzka dávala smysl, pošlete mi tip na dva tři lidi, kteří teď něco řeší: bydlení, rodinu, práci? Nemusíte je přemlouvat. Stačí jméno a telefon a zavolám jen jednou.“',
    },
    rizika: {
      chybi: 'Chybí',
      chybiHorizont: 'roky u cílů',
      chybiPozustalostni: 'pozůstalostní dávka pro tuto zemi',
      chybiPrijem: 'příjem',
      chybiUdaje: 'Pro výpočet chybí',
      chybiVydaje: 'nezbytné výdaje',
      kicker: 'Kdyby nešlo pracovat',
      krytiInvalidita: 'Krytí invalidity',
      krytiSmrt: 'Krytí úmrtí',
      mesicne: 'za měsíc',
      potrebujete: 'Potřebujete',
      poznamka: 'Model z vašich čísel, ne garance. Státní dávky jsou odhad.',
      statDa: 'Stát dá',
      stavajici: 'Stávající pojistky · invalidita',
      zustane: 'Zůstane příjem',
    },
    tabulky: {
      budouciPrijmyPopis: 'Příjem, který přibude za dva, tři nebo pět let. Plán s ním počítá u renty.',
      zatimNic: 'Zatím nic.',
    },
    tisk: {
      dalsiSchuzka: 'Další schůzka',
      nadpis: 'Závěr schůzky',
      nezadano: 'nezadáno',
      podklady: 'Podklady k dodání',
      prebytek: 'Odsouhlasený měsíční přebytek',
      shrnutiJenJmeni: 'Shrnutí naší analýzy: čisté jmění {jmeni}.',
    },
    vydaje: {
      podpora: 'Podpora rodičům / rodině',
    },
    zastava: {
      popis: 'Nemovitost po rodičích může zajistit úvěr — jen se souhlasem vlastníka. Nic se tím nepřepočítává.',
      titul: 'Možná zástava k úvěru',
      zvoleno: 'zvoleno jako zástava',
      zvolit: 'zvolit jako zástavu',
    },
    zaver: {
      bezDat: 'Až doplníme čísla, ukáže se tu, co řešit.',
      diarPoPrezentaci: 'Zapsat termín do diáře po prezentaci',
      diarPoPrezentaciAno: '✓ Diář se otevře po ukončení prezentace',
      model: 'Model z vašich čísel, ne garance.',
      nadpis: 'Co spolu řešíme',
      rizikaNadpis: 'Zajištění příjmu',
      rizikaText: '{jmeno}: při invaliditě chybí {castka} za měsíc.',
      terminOtevrit: 'Otevřít schůzku v diáři',
      terminRadek: 'Další schůzka: {kdy}',
      terminVAnalyze: 'zapsáno v analýze',
      terminVDiari: 'v diáři',
      vseOk: 'Z čísel teď nic k řešení nevyplývá.',
    },
  },
  /* BLOK:analyzaProdej END */
  /* BLOK:nastenkaGrafy START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastenkaGrafy: {
    trychtyr: {
      otevrenychFew: 'otevřené',
      otevrenychMany: 'otevřených',
      otevrenychOne: 'otevřený',
      prumerDniFew: 'Ø {n} dny ve fázi',
      prumerDniMany: 'Ø {n} dní ve fázi',
      prumerDniOne: 'Ø {n} den ve fázi',
    },
    vyvoj: {
      mesiceFew: '{n} měsíce',
      mesiceMany: '{n} měsíců',
      mesiceOne: '{n} měsíc',
      obchodyFew: '{n} obchody',
      obchodyMany: '{n} obchodů',
      obchodyOne: '{n} obchod',
      popisGrafu: 'Vývoj obchodů: za {obdobi} {obchody}, {bj}, nejvíc v měsíci {mesic}',
      slovoObchoduFew: 'obchody',
      slovoObchoduMany: 'obchodů',
      slovoObchoduOne: 'obchod',
    },
  },
  /* BLOK:nastenkaGrafy END */
  /* BLOK:analyzaPrezentace START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrezentace: {
    chip: {
      bydleni: 'Bydlení',
      deti: 'Děti',
      dluhy: 'Dluhy',
      duchod: 'Důchod',
      investice: 'Investice',
      plan: 'Celkový plán',
      pojisteni: 'Pojištění',
      rezerva: 'Rezerva',
    },
    chybi: {
      a: 'a',
      castka: 'částka',
      castka4: 'částku',
      horizont: 'horizont',
      horizont4: 'horizont',
      limity4: 'limity krytí',
      platba4: 'měsíční platbu',
      pojistovna4: 'pojišťovnu',
    },
    cislo: {
      mil: '{n} mil.',
      tis: '{n} tis.',
    },
    hlaska: {
      cashflowIncomplete: 'Volné cashflow zatím nelze vypočítat.',
      cashflowNic: 'Zatím nejsou zadané příjmy ani výdaje.',
      cashflowPrijmy: 'Doplňte příjmy domácnosti.',
      cashflowVydaje: 'Doplňte běžné výdaje, abychom mohli vypočítat volné cashflow.',
      cilIncomplete: 'Cíl je rozpracovaný. Doplňte {chybi}.',
      hypotekaIncomplete: 'Hypotéka je evidovaná. Doplňte zůstatek a měsíční splátku.',
      investiceIncomplete: 'Smlouva je evidovaná. Doplňte aktuální hodnotu nebo pravidelný vklad.',
      investiceIncompleteVice: 'Smlouvy jsou evidované. Doplňte aktuální hodnotu nebo pravidelný vklad.',
      majetekNeuplny: 'Zatím nejsou zadané: {chybi}. Čisté jmění je proto jen orientační a neúplné.',
      pojistkaIncomplete: 'Pojistná smlouva je evidovaná. Doplňte {chybi}.',
      pojistkaIncompleteVice: 'Pojistné smlouvy jsou evidované. Doplňte {chybi}.',
      rezervaIncomplete: 'Pro výpočet rezervy doplňte: {chybi}.',
      rizikoOrientacni: 'Orientační měsíční rozdíl mezi výdaji rodiny a příjmem, který by po výpadku zůstal. Není to pojistná potřeba — tu dopočítáme po započtení rezerv, sociálních dávek a stávajícího pojištění.',
      zavazkyEmpty: 'Nejsou evidované žádné závazky.',
      zavazkyIncomplete: 'Závazek je evidovaný. Doplňte zůstatek a měsíční splátku.',
      zavazkyIncompleteVice: 'Závazky jsou evidované. Doplňte zůstatky a měsíční splátky.',
    },
    horizont: {
      bezTerminu: 'Termín zatím není stanovený',
    },
    krok: {
      cile: {
        q: 'Co chcete dokázat? CO / KDY / KOLIK',
        tab: 'Cíle',
      },
      hodnoty: {
        q: 'Čím jsou pro vás peníze důležité?',
        tab: 'Hodnoty',
      },
      ocekavani: {
        q: 'Co očekáváte od dnešní schůzky?',
        tab: 'Očekávání',
      },
      prijmy: {
        q: 'Kolik vyděláte a kolik zbyde?',
        tab: 'Příjmy a výdaje',
      },
      rizika: {
        q: 'Co může plán ohrozit?',
        tab: 'Rizika',
      },
      rodina: {
        q: 'Koho dnes plánujeme?',
        tab: 'Rodina',
      },
      zavazky: {
        q: 'Co dnes splácíte a jaké máte smlouvy?',
        tab: 'Závazky a smlouvy',
      },
      zaver: {
        q: 'Pojďme si to shrnout.',
        tab: 'Závěr',
      },
      zdroje: {
        q: 'Jaké máte zdroje pro své cíle?',
        tab: 'Zdroje',
      },
    },
    pasmo: {
      dlouhodoby: 'Dlouhodobý',
      kratkodoby: 'Krátkodobý',
      strednedoby: 'Střednědobý',
    },
    pasmoPopis: {
      dlouhodoby: '10 let a víc',
      kratkodoby: 'do 3 let',
      strednedoby: '4–9 let',
    },
    platno: {
      cesta: {
        nadpis: 'Cesta života',
        orientacniPozn: 'Finanční nezávislost je přepočtena na kapitál přes 4 % pravidlo — metodika není schválená, číslo berte jako orientační.',
        orientacniTitul: 'Přepočet renty na kapitál (4 % pravidlo) není schválená metodika — číslo je orientační.',
      },
      citat: '„{text}“',
      hodnoty: {
        nadpis: 'Co je pro vás důležité',
        prazdno: 'Napište vlevo, co pro klienta znamenají peníze…',
      },
      ocekavani: {
        cil: 'Mým cílem je ověřit, **co už dnes děláte dobře**, kde možná **přicházíte o peníze** a co případně **můžete dělat lépe**.',
        nadpis: 'Co od dneška očekáváte',
        prazdno: 'Zapište vlevo klientova slova…',
      },
      prijmy: {
        poznamka503020: '50 / 30 / 20 je orientace, ne závazné pravidlo — reálné rozdělení závisí na životě rodiny.',
        rozdilNezadano: 'Rozdíl ukážeme, jakmile budeme mít vypočtený přebytek i částku, kterou klient odsouhlasil.',
      },
      rizika: {
        kino: 'Spustit kino: Zajištění rizik',
      },
      rodina: {
        cilKicker: 'Co je dnes cílem',
        cilText: 'Pojďme společně **ověřit, co už děláte dobře** — a kde se ve financích dá **něco zlepšit**. Žádné prodávání, jen jasný obrázek a doporučení.',
        nadpis: 'Rodina, pro kterou plánujeme',
        prazdno: 'Vyplňte vlevo jména klientů a dětí…',
      },
      zavazky: {
        dodaPozdeji: 'klient dodá později: {n}',
        fixace: 'nejbližší fixace {datum}',
        konec: 'konec splácení {datum}',
        splatka: 'splátka {castka}',
      },
      zdroje: {
        bezKurzu: 'V souhrnu není {n} položek v cizí měně — chybí k nim použitelný kurz. Radši je neuvádíme, než abychom řekli číslo, které nikdo neověřil.',
        bezKurzuKat: '{n}× cizí měna bez kurzu — nezapočítáno',
      },
    },
    pole: {
      bonusy: 'Bonusy ročně',
      cas: 'Čas',
      cilCo: 'CO — popis cíle',
      cilCoPh: 'Např. větší bydlení',
      cilKdy: 'KDY — za kolik let',
      cilKolik: 'KOLIK — cílová částka',
      cilTyp: 'Typ cíle',
      coDodat: 'Co má dodat klient',
      dalsiSchuzka: 'Další schůzka',
      datum: 'Datum',
      doslovne: 'Doslovný zápis…',
      formaKlient: 'Forma příjmu — klient {n}',
      katOpf: 'Investice (OPF / ETF / akcie)',
      klientEmail: 'Klient {n} — e-mail',
      klientJmeno: 'Klient {n} — jméno',
      klientN: 'Klient {n}',
      klientTelefon: 'Klient {n} — telefon',
      mamDnes: 'Mám dnes',
      navrh: 'Návrh',
      nezbytne: 'Nezbytné měsíční výdaje',
      obvykle: 'Obvyklé měsíční výdaje',
      ocekavani: 'Co klient očekává (jeho slova)',
      pasivni: 'Pasivní příjmy',
      penize: 'Co pro klienta znamenají peníze? (jeho slova)',
      penizePh: 'svoboda, jistota, klid, čas s rodinou…',
      poznPrijmy: 'Poznámka k příjmům',
      predvyplnitZCrm: 'Kliknutím předvyplníte údaje z karty v CRM',
      refTelefon: 'Telefon / kontakt',
      refVztah: 'Vztah / poznámka',
      vlastniPh: 'např. výpis z penzijka',
      vlastniPolozka: 'Vlastní položka',
      vydajePozn: 'Splátky jsou v závazcích — nezapočítávejte je podruhé. Nezbytné výdaje jsou minimum pro případ výpadku příjmu.',
      zDomacnosti: 'Z domácnosti:',
    },
    riziko: {
      evidovano: 'Evidováno',
      nezadano: 'Nezadáno',
      proverit: 'Prověřit',
      vyreseno: 'Vyřešeno',
    },
    role: {
      dite: {
        m: 'Syn',
        z: 'Dcera',
      },
      klient: {
        m: 'Klient',
        z: 'Klientka',
      },
      manzel: {
        m: 'Manžel',
        z: 'Manželka',
      },
      partner: {
        m: 'Partner',
        z: 'Partnerka',
      },
    },
    sablona: {
      c1: 'Povinná likvidní rezerva',
      c2: 'Bydlení / rekonstrukce',
      c3: 'Vzdělání pro děti / start do života',
      c4: 'Finanční nezávislost',
      d1: 'Dědictví',
      f1: 'Firma / podnikání',
      kz1: 'Kapitálové životní pojištění',
      kz2: 'Investiční životní pojištění',
      n1: 'Byt / rodinný dům',
      n2: 'Komerční prostory',
      n3: 'Pozemky / lesy / pole',
      n4: 'Auto / vozidla',
      n5: 'Cennosti (hodinky, umění, sbírky…)',
      n6: 'Zlato a drahé kovy',
      o1: 'OPF/ETF akciové',
      o2: 'OPF/ETF dluhopisové',
      o3: 'OPF/ETF peněžní trh',
      o4: 'OPF/ETF realitní a jiné',
      o5: 'Jednotlivé akcie',
      o6: 'Korporátní dluhopisy',
      o8: 'Kryptoměny',
      pj1: 'Rizikové životní pojištění',
      pj2: 'Úrazové pojištění',
      pj3: 'Pojištění nemovitosti / domácnosti',
      pj4: 'Pojištění odpovědnosti',
      pj5: 'Povinné ručení / havarijní',
      pj6: 'Pojištění právní ochrany',
      pz1: 'Staré penzijní připojištění',
      pz2: 'Doplňkové penzijní spoření',
      pz3: 'Dlouhodobý investiční produkt',
      r1: 'Pojištění nemovitosti / stavby',
      r2: 'Pojištění domácnosti',
      r3: 'Pojištění odpovědnosti',
      r4: 'Povinné ručení',
      r5: 'Havarijní pojištění',
      s1: 'Stavební spoření',
      u1: 'Termínovaný vklad',
      u2: 'Spořicí účet',
      u3: 'Běžný účet',
      u4: 'Hotovost pod polštářem',
      u5: 'Cizí měny',
      zb1: 'Hypoteční úvěr / úvěr na bydlení',
      zb2: 'Spotřebitelské úvěry',
      zb3: 'Leasing',
      zb4: 'Kreditky',
      zo1: 'Podnikatelský úvěr',
      zo2: 'Revolvingový úvěr',
    },
    smluvFew: '{n} smlouvy',
    smluvMany: '{n} smluv',
    smluvOne: '{n} smlouva',
    tab: {
      bydleni: {
        celkem: 'Celkové závazky',
        konec: 'Konec splácení',
        mesicne: 'Měsíční splátky',
        nadpis: 'Bydlení',
        nejblizsi: 'Nejbližší fixace',
        pocet: 'Úvěrů',
      },
      investicni: {
        celkem: 'Současná hodnota',
        mesicne: 'Pravidelné vklady',
        nadpis: 'Investiční smlouvy',
        nejblizsi: 'Nejbližší výročí',
        pocet: 'Produktů',
      },
      ostatni: {
        celkem: 'Ostatní úvěry',
        mesicne: 'Měsíční splátky',
        nadpis: 'Ostatní úvěry',
        nejblizsi: 'Nejbližší splatnost',
        pocet: 'Úvěrů',
      },
      pojistky: {
        mesicne: 'Měsíční pojistné',
        nadpis: 'Pojistky',
        nejblizsi: 'Nejbližší výročí',
        pocet: 'Smluv',
      },
    },
    tahak: {
      cile: {
        say1: 'Podívejme se na vaše strategické cíle ve struktuře CO – KDY – KOLIK.',
        say2: 'Co budete potřebovat financovat? Kdy peníze potřebujete? Kolik bude cíl stát?',
        say3: 'Pokud klient nezmíní sám, vždy ověřte: bydlení, budoucnost dětí a finanční nezávislost.',
        tip: 'U cíle, který klient podceňuje, pusťte Kino — ukáže mu to číslo místo přesvědčování.',
      },
      hodnoty: {
        say1: 'Pokud klient řekne například svoboda, zeptejte se: Co pro vás znamená svoboda?',
        say2: 'Co dalšího vás napadne? Proč je to pro vás důležité právě teď?',
        say3: 'Můstek: Pokud vám finanční plán zajistí {slovaKlienta}, bude to pro vás správné řešení?',
        tip: 'Neptejte se na částky. Tady jde o důvod, ne o čísla.',
      },
      ocekavani: {
        say1: 'Co očekáváte od dnešní schůzky?',
        say2: 'Zopakujte klientova slova a navažte: Mým cílem je ověřit, co už dnes děláte dobře, kde možná přicházíte o peníze a co případně můžete dělat lépe.',
        tip: 'Zapisujte doslova. Klientova vlastní slova použijete v závěru i na příští schůzce.',
      },
      prijmy: {
        say1: 'Dalším důležitým zdrojem pro naplnění vašich cílů jsou vaše příjmy.',
        say2: 'Podle zadaných čísel vám vychází přibližně {castka}. Kolik jste skutečně a dlouhodobě ochotni používat pro váš finanční plán?',
        tip: 'Odsouhlasený přebytek je klientovo číslo, ne vaše. Radši nižší a udržitelné.',
      },
      rizika: {
        say1: 'V rámci finančního plánu se podíváme i na vaše zajištění — co máte dnes, co kryje a co ne.',
        say2: 'Ověříme, jestli se dá ušetřit nebo pojistit chytřeji, a ukážeme, jak bude zajištění vypadat v celém plánu: rodina, cíle, rezerva.',
        tip: 'Nehodnoťte a nestrašte. Jen zaznamenejte stav a co je potřeba prověřit.',
      },
      rodina: {
        say1: 'Po telefonu jsme se domlouvali, že budeme mít 45 minut. U mě se nic nezměnilo. Jen si chci ověřit, že také počítáte přibližně se 45 minutami.',
        say2: 'Nejdřív si jen ověřím základní údaje o vás a vaší rodině.',
        tip: 'Čas si potvrďte hned na začátku — pak se nikdo nedívá na hodinky.',
      },
      zavazky: {
        say1: 'Důležitou informací pro naplnění vašich cílů jsou závazky a smlouvy, které už dnes máte.',
        say2: 'Nejdřív se podíváme na hypotéky a další úvěry, potom na stávající investiční, penzijní a pojistné smlouvy.',
        tip: 'Datum konce fixace a výročí smlouvy jsou nejcennější údaje celé schůzky — bez nich nejde načasovat návrh.',
      },
      zaver: {
        say1: 'Napadá vás něco důležitého, na co jsem se vás zapomněl zeptat?',
        say2: 'Nyní máme potřebné údaje pro zpracování vaší finanční strategie a finančního plánu.',
        say3: 'Na další schůzce vám ukážeme: co doporučujeme, kolik to bude stát, v jakém pořadí jednotlivé kroky uděláme a jak plán povede k vašim cílům.',
        tip: 'Nekonkretizujte řešení. Dnes se domlouvá jen termín a podklady.',
      },
      zdroje: {
        say1: 'Nyní už známe vaše cíle. Pojďme se podívat na zdroje, které pro jejich naplnění máte k dispozici.',
        tip: 'Ptejte se po kategoriích, ne obecně — jinak klient na polovinu zapomene.',
      },
    },
    typCile: {
      auto: 'Auto',
      bydleni: 'Bydlení',
      deti: 'Budoucnost dětí',
      investice: 'Investice',
      nezavislost: 'Finanční nezávislost',
      ostatni: 'Ostatní cíle',
      podnikani: 'Podnikání',
      podnikatelsky: 'Podnikatelský úvěr',
      rekonstrukce: 'Rekonstrukce',
      rezerva: 'Rezerva',
      spotrebitelsky: 'Spotřebitelský úvěr',
      uver: 'Úvěr',
    },
    vydajKat: {
      bydleni: 'Bydlení (nájem / SVJ / fond)',
      deti: 'Děti, škola, kroužky',
      doprava: 'Doprava / auto / MHD',
      dovolena: 'Dovolená (měsíční průměr)',
      energie: 'Energie (elektřina, plyn, voda)',
      jidlo: 'Jídlo a domácnost',
      ostatni: 'Ostatní',
      pojisteni: 'Pojištění (mimo splátky)',
      predplatne: 'Předplatné a služby',
      telekom: 'Telefon, internet, TV',
      volnyCas: 'Volný čas, koníčky, restaurace',
      zdravi: 'Zdraví, léky, drogerie',
    },
    zaver: {
      bezTerminu: 'Termín další schůzky zatím nemáme domluvený. Jakmile si ho domluvíme, projdeme si připravený plán společně.',
      sTerminem: 'Plán připravím a projdeme si ho společně na další schůzce {kdy}.',
      vHodin: '{datum} v {cas}',
    },
  },
  /* BLOK:analyzaPrezentace END */
  /* BLOK:planKlient START — generuje scratchpad/slovnik.py, ručně needitovat */
  planKlient: {
    letFew: '{n} roky',
    letMany: '{n} let',
    letOne: '{n} rok',
    metodika: 'Řešení cílů: reálné výnosy nad inflaci dle tříd aktiv (akcie {akcie} / dluhopisy {dluhopisy} / hotovost {cash} % p.a., s postupným snižováním rizika k cíli). Pojistné částky: kapitálová metoda @ 4 % reálně. Sociální dávky (vdovský, sirotčí celkem za rodinu, invalidní důchod) jsou ORIENTAČNÍ ODHAD ze šablony — ne příslib státu; poradce je ověří. Poradce má poslední slovo.',
    shrnuti: {
      podtitul: 'Tři hrnce nahoře, řádek na cíl. Čísla jsou táž jako v Návrhu řešení.',
      rozdavej: 'Rozdávej ze zdrojů přímo v tabulce, dokud u obou hrnců nesvítí „Zbývá 0“.',
    },
    tahak: 'Tahák pro poradce',
    uvod: {
      dobraCile: 'První je dobrá: [[tvoje cíle se podaří naplnit.]]',
      dobraPlan: 'Dobrá zpráva: [[máš plán.]]',
      lepsiCesta: 'Ta ještě lepší: jdeš k nim [[bezpečnější cestou]].',
      lepsiDrive: 'Ta ještě lepší: rentiér můžeš být [[už za {za}]] — o {o} dřív.',
      rentaNa: 'Renta je zatím na [[{pct} %]] — a přesně vidíme, co s tím udělat.',
      rentaNezadana: 'Cíl renty zatím není zadaný.',
    },
  },
  /* BLOK:planKlient END */
  /* BLOK:denniCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  denniCrm: {
    chybaPopis: 'Data nezmizela — jen se teď nepodařilo spojit se serverem.',
    klientiNenacteno: 'Klienty se nepodařilo načíst',
    nacitam: 'Načítám…',
    obchodyNenacteno: 'Obchody se nepodařilo načíst',
    offlineKopie: 'offline kopie z {cas}',
    offlineKopieBezCasu: 'offline kopie',
    zavritZalozku: 'Zavřít záložku {nazev}',
    zkusitZnovu: 'Zkusit znovu',
  },
  /* BLOK:denniCrm END */
  /* BLOK:nastrojeBezSlibu START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastrojeBezSlibu: {
    namitkaRizikoOdpoved: 'Naprosto chápu. Riziko se dá snížit, ale výnos nad inflací vám předem nikdo zaručit nemůže. Ukážu vám konzervativní možnosti — spořicí účet, dluhopisové fondy, konzervativní fond penzijka — a u každé, co od ní reálně čekat. Vyberete si, co je vám blízké.',
    pojisteniVkladu: 'Pojištění vkladů',
  },
  /* BLOK:nastrojeBezSlibu END */
  /* BLOK:penzeBezKavy START — generuje scratchpad/slovnik.py, ručně needitovat */
  penzeBezKavy: {
    aRentu: 'a rentu',
    podleModeluVDuchodu: 'Podle modelu máte v důchodu naspořeno',
  },
  /* BLOK:penzeBezKavy END */
  /* BLOK:funnelReference START — generuje scratchpad/slovnik.py, ručně needitovat */
  funnelReference: {
    sablona: '[Sem vložte skutečnou referenci se souhlasem klienta]',
    titul: 'Reference (jen skutečné, se souhlasem klienta)',
  },
  /* BLOK:funnelReference END */
  /* BLOK:ikony START — generuje scratchpad/slovnik.py, ručně needitovat */
  ikony: {
    aktivita: {
      cesta: 'Cesta',
      dopis: 'Dopis',
      email: 'E-mail',
      hotovo: 'Hotovo',
      misto: 'Místo',
      narozeniny: 'Narozeniny',
      obchod: 'Obchod',
      pripominka: 'Připomínka',
      radar: 'Radar příležitostí',
      schuzka: 'Schůzka',
      servis: 'Servisní termín',
      sms: 'SMS',
      telefonat: 'Telefonát',
      udalost: 'Událost',
      ukol: 'Úkol',
      whatsapp: 'WhatsApp',
    },
    cil: {
      auto: 'Auto',
      budoucnostDeti: 'Budoucnost dětí',
      bydleni: 'Bydlení',
      investice: 'Investice',
      nezavislost: 'Finanční nezávislost',
      obecny: 'Cíl',
      ostatni: 'Ostatní cíle',
      podnikani: 'Podnikání',
      podnikatelskyUver: 'Podnikatelský úvěr',
      rekonstrukce: 'Rekonstrukce',
      rezerva: 'Rezerva',
      spotrebitelskyUver: 'Spotřebitelský úvěr',
      uver: 'Úvěr',
    },
    produkt: {
      analyza: 'Analýza',
      hypoteka: 'Hypotéka',
      investice: 'Investice',
      jine: 'Jiné',
      penzijko: 'Penzijní spoření',
      pojisteni_auta: 'Pojištění auta',
      pojisteni_majetek: 'Pojištění majetku',
      pojisteni_odpovednost: 'Pojištění odpovědnosti',
      pojisteni_ostatni: 'Ostatní pojištění',
      pojisteni_zivot: 'Životní pojištění',
      rezerva: 'Rezerva',
      stavebni: 'Stavební spoření',
      uver: 'Úvěr',
      zdravotni: 'Zdravotní pojištění',
    },
    profil: {
      dynamicky: 'Dynamický',
      konzervativni: 'Konzervativní',
      vyvazeny: 'Vyvážený',
    },
    riziko: {
      dite: 'Pojištění dítěte',
      hospitalizace: 'Hospitalizace',
      invalidita: 'Invalidita',
      odskodne: 'Denní odškodné',
      pn: 'Pracovní neschopnost',
      rodicovska: 'Rodičovská',
      smrt: 'Úmrtí',
      stari: 'Stáří',
      tnu: 'Trvalé následky úrazu',
      zavazne: 'Závažná onemocnění',
    },
    stav: {
      chyba: 'Chyba',
      info: 'Informace',
      ok: 'V pořádku',
      pozor: 'Pozor',
    },
  },
  /* BLOK:ikony END */
  /* BLOK:vzorkovna START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzorkovna: {
    ikony: {
      doplnky: 'Doplňkové kresby',
      doplnkyPopis: 'Co lucide nemá. Převzaté i s licencí.',
      mena: 'Měna podle země tenanta',
      velikosti: 'Velikost a vybraný stav',
      vybrany: 'Vybraný',
    },
    motivNahledu: 'Náhled v motivu',
    motivy: {
      kino: 'Plátno prezentace',
      popis: 'Přehled cílů a rezervy',
      titulek: 'Finanční plán',
      tlacitko: 'Uložit',
    },
    nadpis: 'Vzorkovna',
    obsah: 'Obsah vzorkovny',
    pismo: {
      cisla: 'Čísla pod sebou',
      jazyky: 'Pět jazyků, jedno písmo',
      nadpisUkazka: 'Finanční plán domácnosti',
      nadpisy: 'Nadpisy',
      stupnice: 'Stupnice velikostí',
      ukazka: 'Rezerva pokrývá šest měsíců výdajů domácnosti.',
    },
    prazdny: {
      akce: 'Naplánovat schůzku',
      kratky: 'Zatím žádné úkoly.',
      text: 'Na dnešek nemáte naplánovanou žádnou schůzku.',
    },
    sekce: {
      ikony: 'Ikony v čipech',
      motivy: 'Šest motivů',
      pismo: 'Písmo',
      prazdny: 'Prázdný stav',
      stavy: 'Stavy',
      tokeny: 'Barvy',
      vystup: 'Výstupní sada',
    },
    skupina: {
      aktivity: 'Aktivity',
      cile: 'Cíle',
      produkty: 'Produkty',
      profily: 'Investiční profil',
      rizika: 'Rizika',
      stavy: 'Stavy',
    },
    stavy: {
      bezTextu: 'Bez textu',
      chyba: 'Změny se nepodařilo uložit',
      ikona: 'Ikona',
      info: 'Údaje z minulé schůzky',
      ok: 'Rezerva pokrývá 6 měsíců výdajů',
      pozor: 'Chybí krytí invalidity',
      stitek: 'Štítek',
      tecka: 'Tečka',
    },
    stitek: 'Design lab · interní náhled',
    tokeny: {
      akcent: 'Akcent',
      kategorie: 'Kategorie',
      plochy: 'Plochy',
      stavy: 'Stavy',
      text: 'Text',
    },
    uvod: 'Písmo, barvy, ikony a stavy na jednom místě. Obrazovky si berou jen to, co je tady.',
    zpet: 'Zpět',
  },
  /* BLOK:vzorkovna END */
  /* BLOK:novyCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  novyCrm: {
    akce: {
      otevrit: 'Otevřít: {nazev}',
      otevritVAppce: 'Otevřít v současném CRM',
      vPrototypu: 'V prototypu zatím nejde',
      zkusitZnovu: 'Zkusit znovu',
      zobrazitDalsi: 'Zobrazit dalších {n}',
      zrusitFiltr: 'Zrušit filtr',
    },
    aktivita: {
      dopis: 'Dopis',
      email: 'E-mail',
      schuzka: 'Schůzka',
      telefonat: 'Telefonát',
      udalost: 'Událost',
      ukol: 'Úkol',
    },
    analyza: {
      bezAnalyzy: 'Analýza zatím není. Založte ji v současné appce, tady se pak ukáže celá.',
      chybaBloku: 'Tuhle část analýzy se nepodařilo spočítat',
      chybi: {
        cil: 'Cíl „{nazev}“: doplňte {co}',
        dalsiNaRade: 'na řadě',
        dalsichFew: 'a další {n} v appce',
        dalsichMany: 'a dalších {n} v appce',
        dalsichOne: 'a další {n} v appce',
        deti: 'Řádek dítěte bez jména a data narození se do výpočtů nepočítá',
        faze: 'Části analýzy',
        fazeSouhrn: 'Hotovo {n} z {celkem} částí analýzy',
        hotovo: 'Analýza je vyplněná, nic nechybí',
        nadpis: 'Co chybí vyplnit',
        nezbytne: 'Nezbytné výdaje — bez nich není rozpad 50 / 30 / 20 ani potřeba zajištění',
        partner: 'Příjem partnera je vyplněný, ale partner v analýze není (chybí jméno nebo datum narození)',
        rezerva: 'Účty a hotovost — bez nich nejde spočítat rezerva',
        zadnaPolozka: 'Žádný konkrétní údaj nechybí — dokončete zbylé části analýzy',
        zajisteni: 'Zajištění příjmu nejde spočítat — chybí: {co}',
        zavaznost: {
          nizka: 'Drobnost',
          stredni: 'Doplnit',
          vysoka: 'Důležité',
        },
      },
      chybiUdajuFew: 'Chybí {n} údaje',
      chybiUdajuMany: 'Chybí {n} údajů',
      chybiUdajuOne: 'Chybí {n} údaj',
      cile: {
        chybi: 'chybí {co}',
        mesicne: '{mena}/měs.',
        pocetFew: '{n} cíle podle termínu',
        pocetMany: '{n} cílů podle termínu',
        pocetOne: '{n} cíl podle termínu',
        uverem: 'úvěrem',
      },
      doplnitVAppce: 'Doplnit v appce',
      faze: {
        cile: 'Cíle',
        hodnoty: 'Hodnoty',
        prijmy: 'Příjmy a výdaje',
        rizika: 'Rizika',
        uvod: 'Úvod',
        zavazky: 'Závazky',
        zdroje: 'Zdroje',
      },
      majetek: {
        budouci: 'Dědictví a budoucí majetek',
        budouciStitek: 'v budoucnu · zatím se nepočítá',
        cisteJmeni: 'čisté jmění (majetek dnes − dluhy)',
        dluhy: 'dluhy (zůstatky)',
        dnes: 'majetek dnes',
        dsti: 'splátky jsou {pct} % příjmů',
        fixace: 'nejbližší fixace {datum}',
        nadpis: 'Majetek a dluhy',
        prazdno: 'Majetek ani dluhy zatím nejsou zapsané',
        splatky: 'splátky {castka} měsíčně',
        uveruFew: '{n} úvěry',
        uveruMany: '{n} úvěrů',
        uveruOne: '{n} úvěr',
        vysokeZadluzeni: 'Vysoké zadlužení (nad 40 % příjmů)',
      },
      menaJina: 'Analýza je vedená v {mena}',
      menaStara: 'Starší analýza bez měny — čísla jsou v {mena}',
      nadpis: 'Analýza',
      penize: {
        chybiDo20: 'Do ideálu 20 % chybí {castka} měsíčně',
        nadpis: 'Příjmy a výdaje',
        odklada: 'Odkládá {pct} % příjmů · ideál 20 % = {castka}',
        rozpadBezNezbytnych: 'Rozpad 50 / 30 / 20 se ukáže, až budou zadané nezbytné výdaje.',
        splneno: 'Odkládá ideálních 20 % příjmů a víc',
      },
      rezerva: {
        bezVydaju: 'Bez nezbytných výdajů nejde spočítat, na kolik měsíců rezerva vystačí',
        castkaPopisek: 'na účtech a v hotovosti',
        dnes: 'Rezerva dnes',
        doporuceno: 'Doporučeno {n} měsíců',
        grafPopis: 'Rezerva vystačí na {n} měsíců z doporučených {cil}',
        jednotka: 'měs.',
        mesicuPopisek: 'na tolik měsíců nezbytných výdajů a splátek vystačí',
        nadpis: 'Rezerva',
        nezapsana: 'Účty a hotovost zatím nejsou zapsané',
        stav: {
          reserve_low: 'Pod 3 měsíce',
          reserve_mid: 'Doplnit do 6 měsíců',
          reserve_ok: 'Aspoň 6 měsíců',
        },
      },
      rodina: {
        bezDeti: 'bez dětí',
        detiFew: '{n} děti',
        detiMany: '{n} dětí',
        detiOne: '{n} dítě',
        dospelychFew: '{n} dospělí',
        dospelychMany: '{n} dospělých',
        dospelychOne: '{n} dospělý',
        nadpis: 'Rodina a profil',
        prazdno: 'Rodina v analýze zatím není vyplněná',
        prijem: 'příjem {castka} měsíčně',
        vekNezadany: 'věk nezadaný',
      },
      upraveno: 'Upraveno {datum}',
      upravitVAppce: 'Upravit v appce',
      zacit: 'Začít analýzu v appce',
      zajisteni: {
        bezDiry: 'Měsíční příjem je pokrytý',
        dira: 'Měsíčně chybí {castka}',
        domacnost: 'Krytí za domácnost',
        mesicne: 'Při invaliditě: rodina potřebuje {potreba} měsíčně · zůstane {zustane} · stát dá {stat}',
      },
      zpetNaKlienta: 'Zpět na klienta',
    },
    cas: {
      dnes: 'dnes',
      predFew: 'před {n} dny',
      predMany: 'před {n} dny',
      predOne: 'před {n} dnem',
      vcera: 'včera',
    },
    cesta: {
      hotovo: 'hotovo',
      krokZ: '{n} z {celkem}',
      kroky: {
        analyza: 'Analýza',
        plan: 'Plán',
        predstaveni: 'Představení',
        realizace: 'Realizace',
        servis: 'Servis',
      },
      nadpis: 'Cesta klienta',
      vseHotovo: 'Všechny kroky hotové',
      ziskani: 'Získání · před první schůzkou',
      ztraceno: 'Ztraceno',
    },
    chyba: {
      aktivity: 'Poznámky a úkoly se nepodařilo načíst',
      analyza: 'Analýzu se nepodařilo načíst',
      analyzaTvar: 'Data analýzy mají nečekaný tvar',
      cile: 'Plán se nepodařilo načíst',
      fixace: 'Fixace se nepodařilo načíst',
      klient: 'Klienta se nepodařilo načíst',
      klienti: 'Klienty se nepodařilo načíst',
      obchody: 'Obchody se nepodařilo načíst',
      obecne: 'Data se nepodařilo načíst',
      pipeline: 'Souhrn obchodů se nepodařilo načíst',
      plan: 'Návrh řešení se nepodařilo načíst',
      radar: 'Radar příležitostí se nepodařilo načíst',
      rizika: 'Potřebu krytí se nepodařilo spočítat',
      ukoly: 'Diář se nepodařilo načíst',
    },
    diar: {
      aDalsichFew: 'a další {n}',
      aDalsichMany: 'a dalších {n}',
      aDalsichOne: 'a další {n}',
      agenda: 'Agenda dne',
      akciFew: '{n} aktivity',
      akciMany: '{n} aktivit',
      akciOne: '{n} aktivita',
      bezCasu: 'Bez času',
      celyDen: 'celý den',
      dalsiTyden: 'Další týden',
      drive: 'Dřív',
      drivePocet: 'Dřív: {n}',
      hodiny: 'Hodiny dne',
      hotovo: 'hotovo',
      minut: '{n} min',
      naDnes: 'Dnes',
      naplanovat: 'Naplánovat v diáři',
      nejblizsi: 'nejbližší',
      nicPoTerminu: 'Nic po termínu',
      odskrtnout: 'Odškrtnout jako hotové',
      otevrit: 'Otevřít v diáři',
      otevritPolozku: 'Otevřít v diáři',
      poTerminu: 'Po termínu',
      poTerminuPocetFew: '{n} po termínu',
      poTerminuPocetMany: '{n} po termínu',
      poTerminuPocetOne: '{n} po termínu',
      pozdeji: 'Později',
      pozdejiPocet: 'Později: {n}',
      prazdnoDen: 'Na tento den není nic naplánované',
      prazdnoDnes: 'Dnes nemáte nic naplánovaného',
      predchoziTyden: 'Předchozí týden',
      schuzekFew: '{n} schůzky',
      schuzekMany: '{n} schůzek',
      schuzekOne: '{n} schůzka',
      souhrn: 'Souhrn dne',
      souhrnPoTerminu: 'po termínu ze všech dní',
      souhrnSchuzky: 'schůzky',
      souhrnUkoly: 'úkoly, hovory a e-maily',
      tyden: 'Týden',
      typ: {
        dopis: 'Dopis',
        email: 'E-mail',
        poznamka: 'Poznámka',
        schuzka: 'Schůzka',
        telefonat: 'Telefonát',
        udalost: 'Událost',
        ukol: 'Úkol',
      },
      ukoluFew: '{n} úkoly',
      ukoluMany: '{n} úkolů',
      ukoluOne: '{n} úkol',
    },
    faze: {
      a1: 'Představení',
      a2: 'Analýza',
      calling: 'Volání',
      done: 'Dokončeno',
      lead: 'Lead',
      lost: 'Ztraceno',
      p1: 'Finanční plán',
      p2: 'Prezentace',
      servis: 'Servis',
      signed: 'Podpis',
    },
    fazeObchodu: {
      analyza: 'Analýza',
      cerpani: 'Čerpání',
      podpis: 'Podpis',
      proces: 'V procesu',
    },
    graf: {
      oblouk: {
        nastavit: 'Nastavit plán v appce',
        nenastaveno: 'Plán není nastavený',
        popisek: 'Plnění plánu BJ',
        zPlanu: '{bj} z {plan} BJ',
      },
      rozpad: {
        cile: 'Cíle',
        nezbytne: 'Nezbytné',
        zivotniStyl: 'Životní styl',
      },
      trychtyr: {
        popis: 'Otevřené obchody podle fáze',
      },
    },
    hlavicka: {
      hledat: 'Hledat klienta ({zkratka})',
    },
    klient: {
      aktivity: {
        bezDalsiho: 'Další krok není naplánovaný',
        dalsiKrok: 'Další krok',
        diar: 'Otevřít diář',
        nadpis: 'Poznámky a další krok',
        naplanovat: 'Naplánovat v diáři',
        napsat: 'Napsat poznámku',
        posledni: 'Poslední aktivity',
        zadne: 'Zatím žádné poznámky ani aktivity',
      },
      analyza: 'Analýza',
      bezAnalyzy: 'Analýza zatím není. Bilance, cíle a majetek se ukážou, až ji vyplníte.',
      bezUdaju: 'Věk ani město nejsou zadané',
      bilance: 'Bilance',
      bilancePrazdna: 'Příjmy a výdaje zatím nejsou vyplněné',
      cile: {
        bezCastkyFew: '{n} cíle bez částky',
        bezCastkyMany: '{n} cílů bez částky',
        bezCastkyOne: '{n} cíl bez částky',
        bezNazvu: 'Cíl bez názvu',
        bezTerminu: 'bez termínu',
        chybi: 'Chybí',
        cil: 'Cíl',
        cilKlienta: 'cíl {castka}',
        dalsichFew: 'a další {n} cíle v návrhu',
        dalsichMany: 'a dalších {n} cílů v návrhu',
        dalsichOne: 'a další {n} cíl v návrhu',
        definice: 'Už má = dnešní peníze k termínu cíle.',
        dnes: 'hned',
        grafPopis: '{nazev}: už má {uzMa} z {cil}',
        jenBezCastkyFew: 'Cíle zatím nemají částku ({n})',
        jenBezCastkyMany: 'Cíle zatím nemají částku ({n})',
        jenBezCastkyOne: 'Cíl zatím nemá částku ({n})',
        nadpis: 'Cíle',
        prazdno: 'Cíle zatím nejsou zadané',
        regulace: 'Orientační přehled podle plánu, ne nabídka.',
        renta: 'renta {castka} měsíčně',
        uverem: 'vlastní zdroje k úvěru',
        uzMa: 'Už má',
        vlastniZdroje: 'Vlastní zdroje',
        zaFew: 'za {n} roky',
        zaMany: 'za {n} let',
        zaOne: 'za {n} rok',
      },
      doplnitVAnalyze: 'Doplnit v analýze',
      kategorie: 'Kategorie {k}',
      kontaktNezadany: 'Telefon ani e-mail nejsou zadané',
      krok: {
        analyza: 'Analýza',
        navrh: 'Návrh řešení',
        plan: 'Plán',
        prezentace: 'Prezentace',
      },
      majetek: {
        celkem: 'celkem',
        dluhy: 'Dluhy: {castka}',
        grafPopis: 'Majetek celkem {celkem}: {dily}',
        kategorie: {
          firma: 'Firma',
          kzp: 'Životní pojištění se spořením',
          nemovitosti: 'Nemovitosti a auta',
          opf: 'Fondy a akcie',
          ostatni: 'Ostatní',
          penzijko: 'Penzijní spoření',
          stavebko: 'Stavební spoření',
          ucty: 'Účty a hotovost',
        },
        nadpis: 'Majetek',
        prazdno: 'Majetek zatím není zapsaný',
      },
      nadpis: 'Klient',
      napsat: 'Napsat e-mail: {email}',
      nenalezen: 'Klient v CRM není — mohl být smazaný.',
      neuplnaData: 'Část dat analýzy má nečekaný tvar',
      obchody: {
        bezBj: 'BJ nezadané',
        nadpis: 'Obchody klienta',
        novy: 'Nový obchod v appce',
        prazdno: 'Klient nemá otevřený obchod',
        vsechny: 'Všechny obchody',
      },
      otevritAnalyzu: 'Otevřít analýzu',
      otevritNavrh: 'Otevřít návrh řešení',
      otevritPlan: 'Otevřít plán',
      pokracovat: 'Pokračovat: {krok}',
      prijmy: 'příjmy měsíčně',
      profil: 'Profil',
      regulace: 'Orientační přehled z analýzy, ne nabídka.',
      rizika: {
        chybi: {
          horizont: 'doba zajištění',
          pozustalostni: 'dávky pro pozůstalé',
          prijem: 'příjem',
          vydaje: 'nezbytné výdaje',
        },
        chybiCastka: 'do doporučeného krytí chybí {castka}',
        domacnost: 'domácnost',
        grafPopis: '{riziko}, {kdo}: dnešní smlouvy {kryti} z doporučeného krytí {potreba}',
        invalidita: 'Invalidita',
        klient1: 'Klient',
        klient2: 'Partner',
        kryti: 'Dnešní smlouvy',
        krytiSpolecne: 'smlouva bez osoby — v analýze u Rizik ve smlouvách vyberte, komu patří',
        model: 'Doporučené krytí spočítala kalkulačka analýzy (kapitálová metoda) — model, ne nabídka. Plán ukazuje pojistné částky varianty zvolené v Návrhu, proto se mohou lišit.',
        nadpis: 'Zajištění příjmu',
        nelzeSpocitat: 'Potřebu krytí zatím nejde spočítat. Chybí: {co}.',
        pokryto: 'pokryto',
        potreba: 'Doporučené krytí',
        prazdno: 'Potřeba krytí ani stávající smlouvy zatím v analýze nejsou',
        radek: 'Doporučené krytí {potreba} · dnešní smlouvy {kryti}',
        smrt: 'Smrt',
      },
      splatky: 'splátky měsíčně',
      vekFew: '{n} roky',
      vekMany: '{n} let',
      vekOne: '{n} rok',
      volneCf: 'volné cash flow měsíčně',
      vydaje: 'výdaje měsíčně',
      zacitAnalyzu: 'Začít analýzu',
      zavolat: 'Zavolat: {cislo}',
      zpet: 'Zpět na klienty',
    },
    klienti: {
      bezJmena: 'Bez jména',
      filtr: {
        faze: 'Fáze',
        kategorie: 'Kategorie',
        produkt: 'Produkt',
        vse: 'Vše',
      },
      hledat: 'Hledat jméno, telefon, e-mail…',
      hledatPopisek: 'Hledat klienta',
      kpi: {
        bezKontaktu: 'Bez kontaktu 90+ dní',
        celkem: 'Celkem',
        podepsano: 'Podepsáno tento měsíc',
        skupina: 'Rychlé filtry',
        vBehu: 'V běhu',
      },
      nalezenoFew: 'Nalezeni {n} klienti',
      nalezenoMany: 'Nalezeno {n} klientů',
      nalezenoOne: 'Nalezen {n} klient',
      odebratFiltr: 'Zrušit filtr: {nazev}',
      odhad: 'odhad',
      otevrit: 'Otevřít klienta: {jmeno}',
      popis: 'Seznam klientů',
      prazdno: 'Zatím tu nejsou žádní klienti',
      pridat: 'Přidat v appce',
      seznam: 'Všichni klienti',
      skupina: {
        klient: 'Klient',
        proces: 'V procesu',
        ziskani: 'Získání',
        ztraceno: 'Ztraceno',
      },
      sloupec: {
        akce: 'Otevřít',
        bj: 'BJ',
        dalsiKrok: 'Další krok',
        faze: 'Fáze',
        klient: 'Klient',
        kontakt: 'Poslední kontakt',
        produkty: 'Produkty',
      },
      vymazat: 'Vymazat hledání',
      zrusitVse: 'Zrušit vše',
    },
    legendaObchodu: {
      plna: 'Čerpá se',
      srafa: 'Rozpracováno',
      tecky: 'Zájem',
    },
    nastroje: {
      cekani: {
        cenaPopisek: 'o tolik méně bude mít v cíli, když začne o {roky} později',
        dohnat: 'Dohnat to znamená odkládat',
        grafPopis: 'Model: když začne hned, bude mít za {roky} {hned}; když počká, {pozdeji}.',
        hned: 'Začne hned',
        horizont: 'Cíl je za',
        legendaModel: 'Tečkovaně = modelový výpočet',
        letFew: '{n} roky',
        letMany: '{n} let',
        letOne: '{n} rok',
        mesicne: 'Měsíčně investuje',
        mesicnePole: 'Měsíční částka',
        model: 'Model při stálém výnosu {pct} % ročně, bez poplatků a daní — ne garance. Při výnosu {od}–{do} % vychází cena {nizsi} až {vyssi}.',
        nadpis: 'Cena za čekání',
        neplatne: 'Odklad musí být kratší než doba do cíle.',
        neposlano: 'Neposlané vklady',
        nominalne: 'Nominální částky, bez vlivu inflace',
        odklad: 'Začne později o',
        otazka: 'Kolik klienta stojí, když s pravidelným investováním počká?',
        pasmo: 'Pásmo: výnos {od}–{do} %',
        pozdeji: 'Začne za {roky}',
        ukazka: 'Ukázka',
        uslyVynos: 'Ušlý výnos',
        vynos: 'Očekávaný výnos',
        vynosText: '{pct} % ročně',
        zaLetFew: 'za {n} roky',
        zaLetMany: 'za {n} let',
        zaLetOne: 'za {n} rok',
        zaMesic: 'měsíčně',
      },
      dlazdice: {
        finMatematika: {
          nazev: 'Finanční matematika',
          popis: 'Úvěr, investice a renta — dopočítá kteroukoli hodnotu.',
        },
        funnely: {
          nazev: 'Knihovna funnelů',
          popis: 'Hotové funnely a skládač zadání.',
        },
        historicka: {
          nazev: 'Historická kalkulačka',
          popis: 'Jak by rostly peníze klienta ve skutečných trzích od roku 1926.',
        },
        hypoteky: {
          nazev: 'Hypotéky',
          popis: 'Rozpracované hypotéky na jednom místě.',
        },
        investicniStrategie: {
          nazev: 'Investiční strategie',
          popis: 'Slavné strategie a síla složeného úročení.',
        },
        investicniStudio: {
          nazev: 'Investiční studio',
          popis: 'Portfolio dnes a po návrhu, krize a náklady.',
        },
        kalkulacky: {
          nazev: 'Kalkulačky',
          popis: 'Hypotéka, investice a další rychlé výpočty.',
        },
        mapa: {
          nazev: 'Mapa klientů',
          popis: 'Klienti na mapě a cesta na schůzku.',
        },
        penze: {
          nazev: 'Penzijní kalkulačka',
          popis: 'Kolik si klient naspoří na penzi a kolik přidá stát.',
        },
        provize: {
          nazev: 'Provize',
          popis: 'Kolik BJ a peněz přinese obchod.',
        },
        radar: {
          nazev: 'Radar příležitostí',
          popis: 'Klienti s mezerou v zajištění nebo financích.',
        },
      },
      novyStyl: 'Kalkulačka v novém stylu',
      proMe: 'Pro mě',
      uStolu: 'Pro klienta u stolu',
    },
    nav: {
      diar: 'Diář',
      hlavni: 'Navigace nového CRM',
      klienti: 'Klienti',
      nastroje: 'Nástroje',
      obchody: 'Obchody',
      poradce: 'Přihlášený poradce: {jmeno}',
      prehled: 'Přehled',
      preskocit: 'Přeskočit na obsah',
      rezimSvetly: 'Přepnout na světlý režim',
      rezimTmavy: 'Přepnout na tmavý režim',
      znacka: 'Nový CRM – přehled',
      zpet: 'Zpět do současného CRM',
      zpetKratce: 'Zpět do CRM',
    },
    nazev: 'Nový CRM',
    nenalezeno: {
      akce: 'Zpět na přehled',
      nadpis: 'Stránka nenalezena',
      text: 'Tahle adresa v novém CRM není.',
    },
    obchody: {
      bezKlienta: 'Klient nezadaný',
      bezNazvu: 'Obchod bez názvu',
      dnyFew: 'Ve fázi {n} dny',
      dnyMany: 'Ve fázi {n} dní',
      dnyOne: 'Ve fázi {n} den',
      dnyZkratka: '{n} d',
      fazeVyber: 'Fáze obchodu',
      kpi: {
        bjVBehu: 'BJ v běhu',
        cekaPodpis: 'Čeká na podpis',
        pocetFew: '{n} obchody',
        pocetMany: '{n} obchodů',
        pocetOne: '{n} obchod',
        uzavreno: 'Uzavřeno tento měsíc',
      },
      nicVeFazi: 'Nic v této fázi',
      novy: 'Nový obchod v appce',
      otevrit: 'Otevřít obchod: {nazev}',
      prazdno: 'Zatím tu nejsou žádné rozpracované obchody',
      trychtyr: 'Obchody podle fáze',
    },
    plan: {
      bezAnalyzy: 'Analýza zatím není. Plán vznikne až z analýzy.',
      bezNavrhu: 'Návrh řešení zatím není uložený. Až ho v appce uložíte, ukáže se tady.',
      chybaBloku: 'Tuhle část plánu se nepodařilo spočítat',
      chybaVypoctu: 'Plán se nepodařilo spočítat',
      cile: {
        bezCastky: 'Částka cíle není zadaná — plnění nejde spočítat',
        bezHorizontu: 'Termín cíle není zadaný — plnění nejde spočítat',
        chybi: 'chybí {castka}',
        dalsichFew: 'a další {n} cíle v Návrhu',
        dalsichMany: 'a dalších {n} cílů v Návrhu',
        dalsichOne: 'a další {n} cíl v Návrhu',
        dnes: 'dnes {pct}',
        grafPopis: '{nazev}: dnes {dnes}, s plánem {po} z cíle {cil}',
        jednorazove: '{castka} jednorázově',
        legendaChybi: 'chybí i s plánem',
        legendaMa: 'má už dnes',
        legendaPlan: 'doplní plán',
        mesicne: '{castka} měsíčně',
        nadpis: 'Plnění cílů',
        prazdno: 'V návrhu zatím nejsou žádné cíle',
        prepocetProfil: 'Vlastní profil cíle — plnění s ním spočítá Návrh',
        prepocetRucni: 'Ruční měsíční částka — plnění s ní spočítá Návrh',
        sPlanem: 's plánem {pct}',
        souhrn: 'S plánem splněno: {n} z {m}',
        splneno: 's plánem splněno',
        vlastniZdroje: 'z toho vlastní zdroje {castka}',
        zAnalyzy: 'upraveno v Návrhu · z analýzy {castka} · {termin}',
      },
      kroky: {
        chybi: {
          majetkove: 'Majetkové pojištění — v Návrhu vyplňte a uložte kartu Pojištění majetku',
          rezerva: 'Rezerva — v analýze chybí nezbytné výdaje, cíl rezervy bez nich nevznikne',
          zivotni: 'Životní pojištění — bez příjmů a výdajů v analýze nejdou spočítat pojistné částky',
        },
        chybiTitulek: 'Kroky, na které chybí podklad:',
        hotovo: 'Hotovo',
        naRade: 'Na řadě',
        nadpis: 'Nejbližší kroky realizace',
        prazdno: 'Plán zatím nemá kroky k realizaci',
      },
      majetek: {
        grafPopis: 'Naspořeno na cíle podle plánu, v dnešních cenách: nejvíc {castka} v roce {rok}. Model, ne garance.',
        legenda: 'tečky a čárkovaně = model podle plánu',
        model: 'Součet naspořeného na cíle podle plánu při {vynos} výnosu, v dnešních cenách (výnosy jsou po odečtení inflace) — model, ne garance, výnos není zaručen. Když cíl doběhne, peníze se utratí a křivka klesne.',
        nadpis: 'Vývoj majetku v čase',
        nula: 'Podle plánu se na cíle s termínem zatím nic nespoří',
        prazdno: 'Plán zatím nemá cíle s termínem',
        rada: 'Naspořeno na cíle',
        rokVek: '{rok} · {vek}',
        vrchol: 'Nejvíc {castka} v roce {rok}',
      },
      nadpis: 'Plán',
      navrh: 'Návrh řešení',
      ochrana: {
        bezCastek: 'Pojistné částky zatím nejde spočítat — chybí příjmy nebo výdaje',
        castky: 'invalidita {invalidita} · smrt {smrt}',
        cenaDoplni: 'měsíčně za domácnost — cenu doplní poradce',
        cenaNeznama: 'Cena ochrany zatím není známá',
        cenaNula: 'Cena od poradce 0 — z přebytku se nic neodečítá',
        cenaPoradce: 'měsíčně za domácnost, cena od poradce',
        cenaPoradceCast: 'měsíčně, cena od poradce — zatím jen část ceny',
        nadpis: 'Ochrana rodiny',
        odhadOrientacne: '≈ {castka} měsíčně — jen orientační odhad',
        odmitnuto: 'Klient zajištění příjmu zatím nechce',
        rozdil: 'Dnes platí {stara} → nově {nova} ({rozdil}). Stará smlouva se ruší, plán odečte jen rozdíl.',
        rucne: 'upraveno poradcem',
        staraNeznama: 'U rušené smlouvy chybí platba — v rozdílu zatím není odečtená.',
        varianta: 'Varianta krytí v návrhu',
        zdroj: 'Pojistné částky varianty {varianta} z Návrhu. Doporučené krytí v Analýze počítá kalkulačka analýzy, proto se může lišit.',
      },
      otevritNavrh: 'Otevřít Návrh v appce',
      prazdnaAnalyza: 'Analýza je prázdná — plán nemá z čeho počítat.',
      prezentace: 'Prezentace',
      profil: 'Profil: {nazev}',
      regulace: 'Modelový plán z návrhu řešení, ne nabídka. Výnos není zaručen.',
      rezerva: {
        bezCile: 'Cíl rezervy nejde spočítat — chybí výdaje',
        dopocetNezbytneFew: 'cíl rezervy · {n} měsíce nezbytných výdajů a splátek',
        dopocetNezbytneMany: 'cíl rezervy · {n} měsíců nezbytných výdajů a splátek',
        dopocetNezbytneOne: 'cíl rezervy · {n} měsíc nezbytných výdajů a splátek',
        dopocetObvykleFew: 'cíl rezervy · {n} měsíce obvyklých výdajů a splátek',
        dopocetObvykleMany: 'cíl rezervy · {n} měsíců obvyklých výdajů a splátek',
        dopocetObvykleOne: 'cíl rezervy · {n} měsíc obvyklých výdajů a splátek',
        jednorazove: 'doplní jednorázově',
        mesicne: 'doplní měsíčně',
        nadpis: 'Rezerva',
        plnaDnes: 'Naplněná už dnes',
        plnaSPlanem: 'S plánem naplněná',
        zadana: 'cíl rezervy zadaný v analýze',
      },
      rozpocet: {
        cile: 'Cíle',
        jednorazove: 'Z úspor jednorázově {prideleno} z {celkem}',
        legendaPlan: 'posílá plán',
        nadPrebytek: 'Pojistné navíc je vyšší než přebytek — chybí {castka} měsíčně',
        nadpis: 'Měsíční rozpočet plánu',
        ochranaNeznama: 'Cenu ochrany zatím nezadal poradce — plán s ní nepočítá',
        ochranaNula: 'Cena ochrany od poradce je 0 — nic se neodečítá',
        ochranaOdmitnuta: 'Klient zajištění příjmu zatím nechce — neodečítá se',
        pojistneNove: 'Pojistné {nova} je mezi povinnými platbami',
        pojistneZmena: 'Pojistné mezi povinnými platbami: dnes {stara} → nově {nova} ({rozdil})',
        prebytek: 'přebytek měsíčně — kam jde',
        prebytekNejisty: 'Z příjmů, výdajů a splátek by vycházelo {castka} měsíčně — odsouhlasený přebytek ověřte v appce.',
        prebytekNezadany: 'Přebytek není zadaný',
        prebytekNula: 'Přebytek je nulový',
        prebytekPoPojistnem: 'přebytek po pojistném měsíčně — kam jde',
        precerpano: 'Plán rozdává víc, než je přebytek',
        renta: 'Investice na rentu',
        rezerva: 'Rezerva',
        vyrovnano: 'Všechny peníze mají úkol',
        zadneZdroje: 'Plán nemá z čeho rozdělovat — chybí přebytek i volné úspory.',
        zbyva: 'Zatím bez úkolu',
      },
      ulozeno: 'Uloženo {datum}',
      vynos: {
        optimisticky: 'Optimistický výnos',
        pesimisticky: 'Pesimistický výnos',
        realisticky: 'Realistický výnos',
      },
      vynosVeVete: {
        optimisticky: 'optimistickém',
        pesimisticky: 'pesimistickém',
        realisticky: 'realistickém',
      },
    },
    prehled: {
      dnes: {
        bezCasuFew: '{n} úkoly bez času',
        bezCasuMany: '{n} úkolů bez času',
        bezCasuOne: '{n} úkol bez času',
        dalsichFew: 'A ještě {n} aktivity dnes',
        dalsichMany: 'A ještě {n} aktivit dnes',
        dalsichOne: 'A ještě {n} aktivita dnes',
        nadpis: 'Dnes',
        nejblizsiCas: 'Nejbližší aktivita v {cas}',
        nejblizsiNadpis: 'Nejbližší v diáři',
        nicDnes: 'Dnes už vás v diáři nic nečeká',
        otevritDiar: 'Otevřít diář',
        poTerminuFew: '{n} po termínu',
        poTerminuMany: '{n} po termínu',
        poTerminuOne: '{n} po termínu',
        seznam: 'Další aktivity dnes',
      },
      klienti: {
        nadpis: 'Poslední klienti',
      },
      obchody: {
        bjVBehu: 'BJ v běhu celkem',
        nadpis: 'Obchody v běhu',
        prazdno: 'Žádné rozpracované obchody',
      },
      pece: {
        bezKontaktu: 'Bez kontaktu',
        dalsichFew: 'a další {n}',
        dalsichMany: 'a dalších {n}',
        dalsichOne: 'a další {n}',
        dniFew: '{n} dny',
        dniMany: '{n} dní',
        dniOne: '{n} den',
        fixace: 'Konec fixace',
        konecSmlouvy: 'Konec smlouvy',
        nadpis: 'Klienti k péči',
        prazdno: 'Žádná fixace do 120 dní a nikdo bez kontaktu přes 90 dní',
        vyroci: 'Výročí smlouvy',
      },
      plan: {
        nadpis: 'Plán měsíce',
      },
      provize: {
        bezPozice: 'Pozice nezadaná',
        koef: '{koef} {mena} za BJ · pozice {pozice}',
        koefVychozi: '{koef} {mena} za BJ (výchozí)',
        nadpis: 'Odhad provize',
      },
      radar: {
        dalsiMezeryFew: '+{n} další mezery',
        dalsiMezeryMany: '+{n} dalších mezer',
        dalsiMezeryOne: '+{n} další mezera',
        dalsichKlientuFew: 'a další {n} klienti s mezerou',
        dalsichKlientuMany: 'a dalších {n} klientů s mezerou',
        dalsichKlientuOne: 'a další {n} klient s mezerou',
        kriticka: 'Kritická mezera',
        krok: 'Doporučený krok',
        nadpis: 'Radar příležitostí',
        otevrit: 'Otevřít Radar v současném CRM',
        prazdno: 'Žádné otevřené příležitosti',
        skore: 'skóre {n}',
      },
    },
    produkt: {
      hypoteka: 'Hypotéka',
      investice: 'Investice',
      majetek: 'Majetek',
      penze: 'Penze',
      uver: 'Úvěr',
      zp: 'Životní pojištění',
    },
    produktObchodu: {
      hypoteka: 'Hypotéka',
      investice: 'Investice',
      jine: 'Jiné',
      koupe_nemovitosti: 'Koupě nemovitosti',
      penzijko: 'Penzijní spoření',
      podnikatelsky_uver: 'Podnikatelský úvěr',
      pojisteni_auta: 'Pojištění auta',
      pojisteni_majetek: 'Pojištění majetku',
      pojisteni_zivot: 'Životní pojištění',
      prodej_nemovitosti: 'Prodej nemovitosti',
      refinancovani: 'Refinancování',
      spotrebitelsky_uver: 'Spotřebitelský úvěr',
      stavebni: 'Stavební spoření',
      uver: 'Úvěr',
    },
    prototyp: 'Prototyp · jen čtení',
    pruvodce: {
      nadpis: 'Tohle je návrh nového CRM',
      rozumim: 'Rozumím',
      text: 'Data jsou skutečná, jen ke čtení. Vzhled a pořadí obrazovek se ještě mohou změnit.',
      zapis: 'Upravovat a zapisovat můžete dál v současném CRM.',
    },
    stav: {
      fazeNezadana: 'Fáze nezadaná',
      nacitam: 'Načítám…',
      nezadano: 'nezadáno',
      nicNeodpovida: 'Nic neodpovídá filtru',
      prazdno: 'Zatím tu nic není',
      starsiData: 'Starší data · {cas}',
    },
    termin: {
      dnes: 'dnes',
      poFew: 'po termínu {n} dny',
      poMany: 'po termínu {n} dní',
      poOne: 'po termínu {n} den',
      zaFew: 'za {n} dny',
      zaMany: 'za {n} dní',
      zaOne: 'za {n} den',
      zitra: 'zítra',
    },
    zalozky: {
      analyza: 'Analýza',
      klient: 'Klient',
      nadpis: 'Sekce klienta',
      plan: 'Plán',
      prezentace: 'Prezentace',
      vAppce: 'otevře současné CRM',
    },
    zastupny: {
      nadpis: 'Obrazovka se připravuje',
      text: 'Tahle část nového CRM se teprve staví. Zatím ji najdete v současném CRM.',
    },
  },
  /* BLOK:novyCrm END */
  /* BLOK:vystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  vystup: {
    bullet: {
      aria: {
        chybi: '{popisek}: potřeba {potreba}, kryto {kryto}, chybí {chybi}.',
        kryto: '{popisek}: potřeba {potreba}, kryto {kryto}. Pokryto.',
        nezadano: '{popisek}: potřeba nezadána.',
        neznameKryti: '{popisek}: potřeba {potreba}, sjednané krytí nezadané.',
      },
      chybi: 'Chybí {castka}',
      krytiNezadane: 'Krytí nezadané',
      kryto: 'Kryto',
      nadRamec: 'Kryto, navíc {castka}',
      potreba: 'Potřeba {castka}',
      potrebaNezadana: 'Potřeba nezadána',
      sjednano: 'Sjednáno {castka}',
      stat: 'Stát {castka}',
    },
    cara: {
      aria: 'Projekce na {roky}: střední scénář {stred}, pásmo {od} až {do}.',
      ariaSrovnani: 'Pro srovnání {popisek}: {hodnota}.',
      pasmo: 'Horší až lepší scénář',
      prazdno: 'Projekce nezadána',
      stred: 'Střední scénář',
    },
    kobliha: {
      aria: 'Rozložení {celkem}: {dily}.',
      celkem: 'Celkem',
      nezadano: 'Bez částky: {polozky}',
      ostatni: 'Ostatní',
      prazdno: 'Nic k rozložení',
    },
    kroky: {
      aktivni: 'právě tady',
      aria: 'Postup: krok {n} z {celkem}, {popisek}',
      ceka: 'čeká',
      hotovo: 'hotovo',
    },
    letFew: '{n} roky',
    letMany: '{n} let',
    letOne: '{n} rok',
    mesicne: 'měsíčně',
    modelNeniGarance: 'Model, ne garance. Skutečný výsledek může být vyšší i nižší.',
    nezadano: 'nezadáno',
    rezim: {
      nazev: 'Režim náhledu',
      obrazovka: 'Obrazovka',
      papir: 'Papír',
      prezentace: 'Prezentace',
    },
    splatka: {
      aria: 'Splátka {splatka} měsíčně, {roky}. Celkem zaplatíte {celkem}, z toho úrok {urok}.',
      ariaUrokNejdriv: 'Na začátku jde většina splátky na úrok, ke konci na jistinu.',
      jistina: 'Jistina',
      popisek: 'Splátka',
      prazdno: 'Úvěr nezadán',
      rok: '{n}. rok',
      souhrn: 'Celkem zaplatíte {celkem}, z toho úrok {urok}.',
      urok: 'Úrok',
    },
    tok: {
      aria: 'Kam jdou peníze: {toky}.',
      krok: '{z} → {do}: {castka}',
      krokKam: '{z} → {do}: {castka}, {kam}',
      nezadano: 'Bez částky: {toky}',
      ostatni: 'Ostatní',
      prazdno: 'Žádný tok peněz',
    },
    ukazka: {
      bullet: 'Potřeba vs. sjednáno',
      cara: 'Projekce s pásmem',
      d: {
        akcie: 'Akcie',
        analyza: 'Analýza',
        bezPlanu: 'Bez plánu',
        deti: 'Investice pro děti',
        dluhopisy: 'Dluhopisy',
        dps: 'penzijní spoření (DPS)',
        fondy: 'podílové fondy',
        hotovost: 'Hotovost',
        hotovostTrida: 'Hotovost',
        hypoteka: 'Splátka hypotéky',
        invalidita: 'Invalidita',
        jednorazove: 'Jednorázově',
        mesicne: 'Měsíčně',
        nemovitosti: 'Nemovitostní fondy',
        nezbytne: 'Nezbytné výdaje',
        plan: 'Plán',
        pn: 'Pracovní neschopnost',
        podminkyUveru: '{castka} · {roky} · úrok {sazba}',
        pojisteni: 'Pojištění',
        prebytek: 'Měsíční přebytek',
        predstaveni: 'Představení',
        prijem: 'Čistý příjem',
        realizace: 'Realizace',
        renta: 'Renta',
        rezerva: 'Rezerva',
        sPlanem: 'S plánem',
        servis: 'Servis',
        smrt: 'Smrt',
        sporiciUcet: 'spořicí účet',
        stavebko: 'Splátka úvěru ze stavebka',
        styl: 'Životní styl',
        volne: 'Volné peníze',
        zlato: 'Zlato',
      },
      kdeBullet: 'Rizika a rezerva v prezentaci plánu',
      kdeCara: 'S plánem vs. bez plánu',
      kdeKobliha: 'Portfolio nejvýš v pěti třídách',
      kdeKroky: 'Cesta klienta',
      kdeSplatka: 'Cíl hypotéka — místo Historické kalkulačky',
      kdeStavebko: 'Zbytek cíle jako úvěr ze stavebního spoření',
      kdeTok: 'Kam jdou peníze — jednorázově a měsíčně zvlášť',
      kdeVelkeCislo: 'Hlavní číslo kalkulačky nebo snímku',
      kdeVlozeno: 'Investice pro děti: jednorázově i pravidelně, pak fáze čerpání',
      kdeVodopad: 'Příjem → výdaje → volné peníze',
      kobliha: 'Kobliha',
      kroky: 'Krokový ukazatel',
      navrh: 'Náhled k odsouhlasení — v plánu, prezentaci ani tisku se zatím nic nevyměnilo.',
      prehrat: 'Přehrát znovu',
      splatka: 'Splátka a úrok',
      tok: 'Tok peněz',
      ucebniCisla: 'Učební čísla, žádný klient.',
      velkeCislo: 'Velké číslo',
      vlozeno: 'Vloženo vs. zhodnocení',
      vodopad: 'Vodopád',
    },
    vlozeno: {
      aria: 'Za {roky} naspoříte {hodnota}: vloženo {vlozeno}, zhodnocení {zhodnoceni}.',
      ariaCerpani: 'Potom {roky} čerpání po {castka} měsíčně.',
      cerpani: 'Čerpání',
      cerpaniVeta: 'Pak {roky} čerpání po {castka} měsíčně',
      pasmo: 'Pásmo scénářů',
      pasmoVeta: 'Horší až lepší scénář: {od} – {do}',
      popisek: 'Za {roky}',
      prazdno: 'Vklad nezadán',
      vlozeno: 'Vloženo',
      zhodnoceni: 'Zhodnocení',
    },
    vodopad: {
      aria: '{kroky}. Výsledek {vysledek}.',
      ariaNelze: '{kroky}. Výsledek nelze spočítat.',
      nelze: 'Výsledek nelze spočítat, chybí: {polozky}',
      vysledek: 'Výsledek',
    },
    zaMesic: '/ měs.',
  },
  /* BLOK:vystup END */
  /* BLOK:vnRodina START — generuje scratchpad/slovnik.py, ručně needitovat */
  vnRodina: {
    cile: {
      bydleni: {
        akontace: 'Vlastní zdroje {pct} %:',
        akontaceHned: 'Vlastní zdroje potřebujete hned',
        cena: 'Bydlení za',
        cenaPole: 'Cena bydlení',
        doRoku: 'do roku {rok}',
        dopocteno: 'splátka dopočtená',
        letPole: 'Kolik let ještě splácet',
        na: 'na',
        nadpis: 'Bydlení',
        odkladatNaAkontaci: 'Na vlastní zdroje odkládat měsíčně',
        otazka: 'Splácíte úvěr, nebo chcete bydlení teprve koupit?',
        pakSplatka: 'pak splátka asi',
        platite: 'Už teď platíte měsíčně',
        rezimDluh: 'Splácíme úvěr',
        rezimKoupit: 'Chceme koupit',
        rezimNic: 'Vyřešeno',
        uver: 'Úvěr',
        vyreseno: 'Bydlení máte vyřešené.',
        za: 'za',
        zaPole: 'Za kolik let chcete kupovat',
        zbytekPole: 'Zbývá doplatit na úvěru',
        zbyva: 'Zbývá doplatit',
      },
      deti: {
        bezDeti: 'Bez dětí do 23 let.',
        naDiteMesicne: 'na jedno dítě měsíčně',
        nadpis: 'Děti do 23 let',
        nakladPole: 'Kolik měsíčně stojí jedno dítě',
        radek: '{n}. dítě · {mesicu} měsíců',
        samostatne: 'Samostatné děti se nepočítají: {pocet}',
        stoji: 'Do 23 let to stojí',
        zVyplaty: 'Dnes z výplaty měsíčně',
      },
      duchod: {
        aria: 'Důchod, kolik dá stát a kolik chybí: {radky}',
        ariaRadek: '{kdo} stát {stat}, chybí {chybi}',
        chybi: 'chybí',
        chybiRadek: 'chybí',
        cilPole: 'Kolik chce mít každý v důchodu měsíčně',
        naOsobu: 'měsíčně na každého',
        nadpis: 'Důchod',
        odchodV: 'Do důchodu ve věku',
        odkladat: 'odkládat měsíčně',
        rezimAria: 'Jak určit cíl důchodu',
        rezimCastka: 'Částka',
        rezimStandard: 'Udržet standard',
        standardText: 'Udržet dnešní úroveň: 80 % dnešního čistého příjmu každého z vás.',
        stat: 'stát (odhad)',
        statRadek: 'stát odhadem',
        uzVDuchodu: 'už je v důchodovém věku',
        vekPole: 'Věk odchodu do důchodu',
      },
      nadpis: 'Cíle rodiny',
      odkladatCelkem: 'Na cíle je potřeba odkládat měsíčně',
      odkladatModelove: '(modelově, výnos není jistý)',
      prijemRodiny: 'Příjem rodiny',
      uvod: 'Bydlení, děti do 23 let a důchod.',
    },
    hlavicka: {
      navAria: 'Části analýzy',
      podtitul: 'Příběh rodiny: cíle a co je podrží',
      poradce: 'Pro poradce',
      priklad: 'Vyplnit příklad',
      promitani: 'Promítat klientovi',
      promitaniKonec: 'Ukončit promítání',
      zpet: 'Zpět na Analýzu pro Vietnamce',
    },
    investice: {
      ariaRozdeleni: 'Z balíčku {balicek} jde {ochrana} na ochranu a {investice} do investic.',
      cenaOdPoradce: 'Cena ochrany od poradce',
      dnesnimaOcima: 'v dnešních penězích {castka}',
      doInvestic: 'do investic',
      doVeku: 'Do věku',
      dopadPoplatku: 'Oba poplatky dohromady sníží modelovou hodnotu o {castka}.',
      grafAria: 'Do {vek} let zaplatíte celkem {zaplaceno}, z toho {ochrana} na ochranu, která se nevrací. Modelová hodnota investic při {vynos} % je {hodnota}, v rozpětí od {od} do {do}. Model, ne slib.',
      hodnotaModel: 'hodnota · model {vynos} %',
      hodnotaPri: 'hodnota při {vynos} %',
      hodnotaVeVeku: 'Hodnota v {vek} letech · model {vynos} %',
      investuje: 'investuje se',
      naOchranu: 'na ochranu (nevrací se)',
      nadpis: 'Když se nic nestane',
      nakladyNaKonci: 'v {vek} letech',
      nakladyNadpis: 'Náklady v čase',
      nakladyPoLetechFew: 'po {n} letech',
      nakladyPoLetechMany: 'po {n} letech',
      nakladyPoLetechOne: 'po {n} roce',
      nezadano: 'nezadáno',
      ochranaPopisek: 'z toho na ochranu {castka}, nevrací se',
      pasmo: 'rozpětí modelů',
      pasmoOdDo: 'při {od}–{do} % od {hodnotaOd} do {hodnotaDo}',
      poplatkyDosud: 'poplatky do té doby',
      poplatkyNadpis: 'Kolik stojí poplatky',
      protiCili: 'Na důchod podle vašich cílů chybí {potreba} v dnešních penězích. Model investice vychází na {pct} % této částky.',
      prubezny: 'Průběžný poplatek',
      prubeznyRadek: '{pct} ročně ze zůstatku investice, celkem za {roky}',
      uvod: 'Z balíčku se zaplatí ochrana, zbytek se investuje až do zvoleného věku.',
      vekTooltip: '{vek} let',
      vstupni: 'Vstupní poplatek',
      vynos: 'Modelový výnos ročně',
      zBalicku: 'Z balíčku {balicek} měsíčně:',
      zTohoOchrana: 'z toho na ochranu',
      zaplaceno: 'Celkem zaplaceno',
      zaplacenoJak: 'celý balíček {balicek} × 12 měsíců × {roky}',
    },
    jednotka: {
      rokFew: 'roky',
      rokMany: 'let',
      rokOne: 'rok',
      vekFew: 'roky',
      vekMany: 'let',
      vekOne: 'rok',
    },
    nav: {
      cile: 'Cíle',
      investice: 'Investice',
      ochrana: 'Ochrana',
      odkladat: 'Odkládání',
      otazky: 'Otázky',
      prijmy: 'Příjmy',
      rodina: 'Rodina',
      srovnani: 'Srovnání',
      vypadek: 'Kdyby příjem vypadl',
      zaver: 'Shrnutí',
    },
    neuplne: {
      cilBydleni: 'cena nebo termín bydlení',
      nadpis: 'Neúplné, chybí:',
      uver: 'zůstatek nebo roky úvěru',
      vekDitete: 'věk {n}. dítěte',
    },
    ochrana: {
      bezMesicne: 'Každý měsíc chybí {castka}. Tahle část nemá žádný zdroj.',
      bezPn: 'Každý den nemoci chybí {castka}.',
      bezZo: 'Léčba trvá měsíce, výdaje běží dál a příjem chybí.',
      detiCastka: 'Každé dítě: {castka}.',
      dil: {
        bydleni: 'Bydlení',
        deti: 'Děti do 23 let',
        dluh: 'Díl úvěru',
        duchod: 'Důchod',
        duchodPozustaleho: 'Důchod partnera',
        renta: 'Příjem pro rodinu',
        zivot: 'Běžný život do důchodu',
      },
      doplniPoradce: 'doplní poradce',
      kazdeDite: 'Každé dítě',
      kdoAria: 'Čí výpočet ukázat',
      krokMetodou: 'Podle výpočtu (potřeba − stát)',
      krokMinimum: 'Minimum = pojistná částka',
      naDen: '/ den',
      naDnesek: 'přepočteno na dnešní peníze (4 % ročně)',
      naNoc: '/ noc',
      nadpis: 'Ochrana rodiny po rizicích',
      nepojistujeSe: 'nepojišťuje se',
      pnBezPrijmu: 'Bez příjmu. Krytí doplní poradce.',
      pnNicNechybi: 'Nemocenská od státu pokryje váš příjem.',
      pnPotreba: 'Váš čistý příjem na den',
      pnStat: 'Nemocenská od státu',
      podRiziko: {
        dou: 'za den léčení úrazu',
        hosp: 'za noc v nemocnici',
        invalidita: 'při plné invaliditě',
        pn: 'za den nemoci nebo úrazu',
        smrt: 'jednorázově rodině',
        tnu: 'po úrazu, podle rozsahu',
        zo: 'jednorázově při diagnóze',
      },
      popis: {
        dou: 'Dávka za každý den, kdy se léčíte po úrazu. Kolik dní se za úraz platí, určuje tabulka pojišťovny.',
        hosp: 'Dávka za každou noc v nemocnici.',
        invalidita: 'Když kvůli zdraví dlouhodobě nemůžete pracovat. Stát to dělí na tři stupně podle toho, o kolik klesla pracovní schopnost.',
        pn: 'Když kvůli nemoci nebo úrazu nějakou dobu nemůžete pracovat. Nemocenská od státu nahradí jen část příjmu.',
        smrt: 'Rodina dostane jednorázovou částku: doplatí díl úvěru a nákladů na děti do 23 let, který nesl tento příjem, a doplní příjem, který chybí.',
      },
      riziko: {
        dou: 'Denní odškodné',
        hosp: 'Hospitalizace',
        invalidita: 'Invalidita',
        pn: 'Pracovní neschopnost',
        smrt: 'Úmrtí',
        tnu: 'Trvalé následky úrazu',
        zo: 'Závažná onemocnění',
      },
      sJednorazove: 'Rodina dostane {castka} a cíle zůstanou.',
      sPn: 'Denní dávka {pn}, při úrazu k tomu odškodné {dou}.',
      sPnBezDou: 'Denní dávka {pn}.',
      sZo: 'Jednorázově {castka} při diagnóze ze seznamu ve smlouvě.',
      stat: {
        invalidita: 'Invalidní důchod (odhad)',
        smrt: 'Vdovský a sirotčí důchod (odhad)',
      },
      statStupen: 'stát odhadem {castka} měsíčně',
      stupen: {
        I: 'I. stupeň · 35–49 %',
        II: 'II. stupeň · 50–69 %',
        III: 'III. stupeň · 70 % a víc',
        nad40: 'pokles nad 40 %',
        nad70: 'pokles nad 70 %',
      },
      tabulkaAria: 'Ochrana po rizicích a osobách',
      tnuPasma: 'Výplata po pásmech:',
      tnuPasmo: '{od}–{do} % ×{k}',
      tnuTabulka: 'Kolik se vyplatí z {castka} podle rozsahu poškození',
      uvod: 'Kolik by rodina dostala při každé události. Rizika se neplní společně, proto se částky nesčítají.',
      vodopadAria: 'Potřeba {potreba}, stát odhadem {stat}, chybí {chybi}.',
      zoRokyFew: '{n} roky čistého příjmu',
      zoRokyMany: '{n} let čistého příjmu',
      zoRokyOne: '{n} rok čistého příjmu',
      zoRucne: 'Částka zadaná poradcem',
    },
    odkladat: {
      ariaVolne: 'Po výdajích a splátkách zbývá {volne}, balíček je {balicek}.',
      celyPlan: 'Balíček je celý plán rodiny: ochrana i investice. Kolik z něj stojí ochrana, spočítá poradce z nabídky pojišťovny.',
      doplnPrijmy: 'Balíčky se ukážou po zadání příjmů.',
      doporuceno: 'doporučeno',
      nadpis: 'Kolik si rodina může odkládat',
      nevejdeSe: 'nevejde se, chybí',
      nevejdeSeKratce: 'nevejde se',
      odkladate: 'odkládáte',
      rozdeleniInvestice: 'a do investic',
      rozdeleniOchrana: 'jde na ochranu',
      rozdeleniZ: 'Z',
      uvod: 'Na cíle rodiny: 10 až 30 % čistého příjmu.',
      uvodDoporuceni: 'Z {prijem} měsíčně doporučujeme odkládat {pct} %.',
      vlastni: 'Vlastní částka:',
      vyberAria: 'Kolik procent příjmu odkládat',
      zVolnych: 'z volných peněz',
      zbyvaVolne: 'zbývá volné',
      zpetNaDoporuceni: 'zpět na doporučení',
    },
    osa: {
      ariaDite: '{n}. dítě samostatné v roce {rok}',
      ariaDospely: '{kdo} do důchodu v roce {rok}',
      ariaUver: 'úvěr splacený v roce {rok}',
      diteZkratka: 'D{n}',
      dnes: 'dnes',
      duchod: 'důchod v {vek} · {rok}',
      prazdno: 'Časová osa se ukáže po zadání věku.',
      samostatne: 'už samostatné',
      samostatneRok: '23 let · {rok}',
      uver: 'Úvěr',
      uverDo: 'splaceno {rok}',
    },
    otazky: {
      faq: {
        dlouho: {
          odpoved: 'V prvních letech se splácí vstupní poplatek, takže při brzkém ukončení dostanete zpět málo nebo nic. Podle smlouvy jde platbu snížit, investování na čas pozastavit nebo z investiční části vybrat. Od smlouvy můžete odstoupit do 30 dnů po uzavření.',
          otazka: 'Proč na dlouho? A co když budu potřebovat platbu pozastavit, upravit nebo vybrat?',
        },
        kamInvest: {
          odpoved: 'Do fondů, které si vyberete ze seznamu pojišťovny: akciových, dluhopisových nebo smíšených. Strategii jde během smlouvy měnit. Hodnota může klesnout i pod vložené peníze.',
          otazka: 'Kam se peníze investují?',
        },
        nemocny: {
          odpoved: 'Záleží na nemoci a na pojišťovně. Může vás přijmout za běžnou cenu, s přirážkou, s výlukou té nemoci, nebo odmítnout. Nemoc uveďte v dotazníku pravdivě, jinak pojišťovna nemusí plnit.',
          otazka: 'Jsem nemocný. Můžu se pojistit?',
        },
        podvod: {
          odpoved: 'Pojišťovna i poradce musí mít povolení a být zapsaní v registru centrální banky — ověříte si to sami podle jména. Před podpisem dostanete písemně podmínky, přehled nákladů a záznam z jednání. Nic nemusíte podepisovat hned.',
          otazka: 'Není to podvod?',
        },
        poplatky: {
          odpoved: 'Vstupní poplatek je procento z cílové částky, průběžný poplatek procento ze zůstatku ročně. U grafu je obojí v penězích a všechny náklady najdete i v dokumentech pojišťovny.',
          odpovedCisla: 'Vstupní poplatek {pct} z cílové částky je {vstupni}. Průběžný poplatek {prubeznyPct} ročně je za celou dobu {prubezne}. Všechny náklady najdete i v dokumentech pojišťovny.',
          otazka: 'Kolik stojí poplatky?',
        },
        vratiSe: {
          odpoved: 'Celé ne. Část, která platí ochranu, je cena za to, že rodina byla celou dobu krytá — ta se nevrací, stejně jako povinné ručení u auta. Peníze na stáří vznikají jen z investiční části a jejich výše není jistá.',
          otazka: 'Když se nic nestane, vrátí se mi, co jsem zaplatil?',
        },
        vybrat: {
          odpoved: 'Z investiční části obvykle ano. Kolik, jak rychle a s jakým poplatkem, určuje smlouva. Ochranná část se nevrací, a proto na rychlé peníze patří rezerva na účtu vedle smlouvy.',
          otazka: 'Když nebudu mít peníze, můžu si je vybrat?',
        },
        vynos: {
          odpoved: 'Protože peníze pracují dlouho a pravidelně. 5, 7 a 9 % jsou modelové sazby, ne slib — skutečný výnos může být nižší i záporný. Proto graf vždy ukazuje i to, kolik celkem zaplatíte.',
          otazka: 'Proč to vydělá tolik?',
        },
      },
      nadpis: 'Vaše otázky',
      vedet: {
        dlouho: 'Je to na dlouho. Při ukončení v prvních letech dostanete zpět málo nebo nic.',
        nadpis: 'Tři věci, které musíte vědět',
        poplatky: 'Poplatky vidíte výš v penězích, ne jen v procentech.',
        vynos: 'Výnos není jistý. Hodnota investice může i klesnout.',
      },
    },
    pomocnik: {
      hledat: 'Hledat otázku',
      nadpis: 'Na co se Vietnamci v Česku ptají',
      nicNenalezeno: 'Nic nenalezeno.',
      otevrit: 'Pomocník pro poradce · {pocet} otázek',
      pravo: 'Odpovědi podle českého práva, ověřeno 30. 9. 2026.',
      zdroj: 'Zdroj: {zdroj}',
    },
    prijmy: {
      ariaPrijem: 'Příjem rodiny {celkem}: {dily}',
      ariaVydaje: 'Kam jde příjem: {dily}',
      chybi: 'chybí',
      doDuchodu: 'do důchodu',
      doplnPrijmy: 'Pruh příjmů se ukáže po zadání věku a příjmu.',
      mesicne: 'měsíčně',
      nadpis: 'Kolik vám projde rukama',
      rocne: 'ročně',
      splatky: 'splátky',
      uvod: 'Příjmy obou dohromady a kam jdou.',
      volne: 'zbývá',
      vydaje: 'výdaje',
      vydajePole: 'Výdaje rodiny měsíčně (bez splátek, včetně dětí)',
      vydajeUpresneni: 'bez splátek úvěrů, včetně dětí',
      vydajeVeta: 'Rodina měsíčně utratí',
    },
    rodina: {
      bezDeti: 'zatím žádné',
      bezPrijmu: 'bez příjmu',
      bezPrijmuPrepinac: 'Teď bez příjmu (rodičovská, doma)',
      deti: 'Děti',
      diteCislo: '{n}. dítě',
      mesicne: 'měsíčně',
      nadpis: 'Vaše rodina',
      odebratDite: 'Odebrat {n}. dítě',
      odebratPartnera: 'Odebrat druhého dospělého',
      osvc: 'OSVČ',
      pridatDite: 'Přidat dítě',
      pridatPartnera: 'Přidat partnera',
      prijem: 'čistý příjem',
      prijemKoho: '{kdo} · čistý příjem měsíčně',
      uvod: 'Kdo je v rodině, kolik je komu let a kolik kdo vydělá.',
      vek: 'věk',
      vekDitete: '{n}. dítě · věk',
      vekKoho: '{kdo} · věk',
    },
    role: {
      bo: 'Táta',
      boZkratka: 'T',
      me: 'Máma',
      meZkratka: 'M',
    },
    srovnani: {
      balicek: 'Balíček',
      cimDriv: 'Kdybyste začali až ve {vek} letech, zaplatíte o {mene} méně, ale modelově budete mít o {cena} méně (v dnešních penězích).',
      legenda: 'V buňce modelová hodnota, pod ní kolik celkem zaplatíte. Částky v {symbol}.',
      mesicne: '{castka} měsíčně',
      nadpis: 'Čím víc a čím dřív',
      ochranaStejna: 'ochrana {castka} měsíčně u každého balíčku',
      prazdno: 'Srovnání se ukáže po zadání příjmů a ceny ochrany.',
      startDnes: 'Začít dnes',
      startZa: 'Za {roky} let',
      tabulkaAria: 'Modelová hodnota v {vek} letech při {vynos} % podle balíčku a začátku',
      uvod: 'Modelová hodnota v {vek} letech při {vynos} %: podle toho, kolik odkládáte a kdy začnete.',
    },
    stitek: {
      bezNarokuInv: 'bez nároku na invalidní důchod',
      bezPrijmuDoplniPoradce: 'bez příjmu, krytí doplní poradce',
      bezPrubeznehoPoplatku: 'bez průběžného poplatku, skutečnost bude nižší',
      bezRustuMzdy: 'v dnešních penězích, bez růstu mzdy',
      bezVstupnihoPoplatku: 'bez vstupního poplatku, skutečnost bude nižší',
      bezVynosuKratkyCil: 'krátký cíl, počítáno bez výnosu',
      dnesniPenize: 'v dnešních penězích (inflace 2,5 %)',
      duchodBezNaroku: 'bez nároku: méně než 5 let pojištění z 10',
      duchodMinimum: 'zákonné minimum',
      duchodOsvcMinimalni: 'OSVČ: důchod z minimálních záloh',
      duchodOveritNarok: 'nárok nevíme, počítá se bez něj: ověřit výpis ČSSZ',
      invaliditaBezPrijmuB: 'rodič bez příjmu: kryje se o 20 % vyšší výdaje mínus invalidní důchod',
      invaliditaPoOdchodu: 'po věku odchodu do důchodu se invalidita nepojišťuje',
      modelovyVynos: 'modelový výnos, ne slib; hodnota může i klesnout',
      narokNeovren: 'nárok neověřen',
      ochranaJeNaklad: 'ochrana je cena krytí, nevrací se',
      osvcBezNemocenske: 'OSVČ bez dobrovolného nemocenského: stát neplatí',
      osvcNeodecteno: 'OSVČ: státní důchod neodečten, výši zná jen ČSSZ',
      overitUPojistovny: 'ověřit u pojišťovny (běžně do {strop})',
      podilNaPrijmu: 'díl cílů podle podílu na příjmu rodiny',
      podlePodminekPojistovny: 'podle pojistných podmínek',
      pozustalostniBezNaroku: 'bez potřebné doby pojištění: vdovský a sirotčí důchod neodečten',
      pozustalostniBezPrijmu: 'bez příjmu: vdovský a sirotčí důchod neodečten, doplní poradce',
      pozustalostniOsvc: 'OSVČ: vdovský a sirotčí důchod neodečten, nárok zná jen ČSSZ',
      sablona: 'šablona, ověří poradce',
      statOdhad: 'odhad, nárok až po 5 letech pojištění v posledních 10',
      statPoradce: 'zadal poradce',
      statSkDoplniPoradce: 'starobní důchod doplní poradce',
      statSkSablona: 'průměr Sociálnej poisťovne, ověří poradce',
      vdovskyJenManzelum: 'vdovský důchod jen manželům: neodečten',
      vdovskyNevime: 'vdovský důchod neodečten: sňatek nezadán',
      zoBezOdectuStatu: 'nemocenská kryje jen pracovní neschopnost, od závažných onemocnění se neodečítá',
    },
    stop: {
      bezBalicku: 'Vyberte balíček nebo zadejte vlastní částku.',
      bezCenyZajisteni: 'Cenu ochrany zadá poradce z modelace pojišťovny.',
      bezCileDuchodu: 'Doplňte, kolik chce mít měsíčně v důchodu.',
      bezHorizontu: 'Cílový věk musí být vyšší než dnešní věk.',
      bezNakladuNaDite: 'Doplňte, kolik měsíčně stojí jedno dítě.',
      bezOsob: 'Zadejte aspoň jednoho dospělého.',
      bezPrijmu: 'Chybí čistý příjem. Když je doma bez příjmu, zapněte „bez příjmu“.',
      bezVeku: 'Chybí věk.',
      bezVydaju: 'Chybí měsíční výdaje rodiny.',
      celyBalicekNaOchranu: 'Celý balíček jde na ochranu. Na stáří z něj nic nevznikne.',
      cilBydleniNeuplny: 'U bydlení chybí cena nebo za kolik let.',
      dluhNeuplny: 'U úvěru chybí zůstatek nebo počet let splácení.',
      nejdrivRozpocet: 'Výdaje jsou vyšší než příjmy. Nejdřív rozpočet, pak balíček.',
      nejmensiNevejde: 'Ani {pct} % ({balicek}) se do volných peněz {volne} nevejde. Zvolte vlastní částku, nebo nejdřív rozpočet.',
      prubeznyMimoRozsah: 'Průběžný poplatek musí být mezi 0 a {max} % ročně.',
      vekMimoRozsah: 'Věk musí být mezi {min} a {max} lety.',
      vekOdchoduMimoRozsah: 'Věk odchodu do důchodu musí být mezi {min} a {max} lety.',
      vynosMimoRozsah: 'Výnos po poplatcích vychází mimo rozsah, se kterým počítáme.',
    },
    suplik: {
      ano: 'Ano',
      balicek: 'Balíček',
      cenaOchrany: 'Cena ochrany měsíčně',
      cenaOchranyNapoveda: 'Z modelace pojišťovny. Appka cenu neodhaduje.',
      davkyNapoveda: 'Prázdné = odhad appky podle zákona.',
      douDospely: 'Denní odškodné dospělého, za den',
      invPodilNad40: 'Pokles nad 40 %: kolik % pojistné částky',
      invalidniDuchod: 'Invalidní důchod při plné invaliditě dle výpisu, měsíčně',
      manzelstvi: 'Manželství',
      nadpis: 'Pro poradce',
      narok: 'Nárok na invalidní důchod (5 let pojištění z posledních 10)',
      ne: 'Ne',
      nevim: 'Nevím',
      ochranaInvestice: 'Ochrana a investice',
      osvc: 'OSVČ',
      prubeznyPoplatek: 'Průběžný poplatek (% ročně)',
      role: 'Kdo to je',
      sazba: 'Úroková sazba',
      sezdani: 'Jsou sezdaní? Vdovský důchod náleží jen manželům.',
      splatka: 'Měsíční splátka',
      splatkaNapoveda: 'Prázdné = splátka se dopočte.',
      statniDuchod: 'Starobní důchod dle výpisu, měsíčně',
      stavDat: 'Stav údajů',
      tnu: 'Trvalé následky úrazu: pojistná částka',
      typ: 'Forma příjmu',
      uver: 'Úvěr ze smlouvy',
      varianta: 'Jak se platí vstupní poplatek',
      vekCil: 'Investovat do věku',
      vlastniBalicek: 'Vlastní částka měsíčně (místo 10–30 %)',
      volbyOchrany: 'Volby ochrany',
      vseZadano: 'Nic nechybí.',
      vstupniPoplatek: 'Vstupní poplatek (% z cílové částky)',
      vynos: 'Modelový výnos ročně',
      zamestnanec: 'Zaměstnanec',
      zavrit: 'Zavřít',
      zoRoky: 'Závažná onemocnění: kolik ročních příjmů',
      zoRokyVolbaFew: '{n} roky',
      zoRokyVolbaMany: '{n} let',
      zoRokyVolbaOne: '{n} rok',
      zoRucne: 'Závažná onemocnění ručně · {kdo}',
    },
    trapeni: {
      cesky: {
        odpoved: 'Dokumenty mohou být česky nebo v jiném dohodnutém jazyce. Všechno vám vysvětlím vietnamsky, ale závazné je znění smlouvy a dostanete záznam z jednání. Nemusíte podepsat dnes — vezměte si dokumenty domů, přečtěte je s někým, komu věříte, a nepodepisujte nic, čemu nerozumíte.',
        otazka: 'Smlouva je celá česky a já jí nerozumím. Musím podepsat dnes?',
        otazkaVi: 'Hợp đồng toàn tiếng Séc, tôi đọc không hiểu thì ký thế nào? Có cần ký luôn hôm nay không?',
        zdroj: '§ 79, 90 zákona o distribuci pojištění; § 2789 OZ; KID (nařízení PRIIPs)',
      },
      dane: {
        odpoved: 'Pojistné na daňově podporované životní pojištění jde odečíst od základu daně, nejvýš 48 000 Kč ročně společně s penzijním spořením a DIP. Podmínkou je výplata nejdřív v roce 60 let (u smluv od 2024 i po 120 měsících); při dřívějším výběru se odečtené částky dodaní až 10 let zpátky. Ušetříte jen daň z odečtené částky, při 15% sazbě nejvýš 7 200 Kč ročně; paušální daň ani nerezident mimo EU odpočet neuplatní.',
        otazka: 'Můžu si to odečíst z daní? Kolik?',
        otazkaVi: 'Mua cái này có được khấu trừ thuế không? Được bao nhiêu?',
        zdroj: '§ 15, 15a, 15b zákona o daních z příjmů; Finanční správa',
      },
      deti: {
        odpoved: 'Nejdřív chráníme příjem rodičů, protože z něj děti žijí. Pojištění dítěte kryje hlavně vážný úraz nebo nemoc, kdy rodič zůstane doma a náklady rostou; výchozí nastavení je závažná onemocnění 2 mil. Kč, trvalé následky 2 mil. Kč, denní odškodné 500 Kč a hospitalizace 1 000 Kč za den. Hranice 23 let je volba plánu — stát bere studující dítě jako nezaopatřené nejdéle do 26.',
        otazka: 'Děti jsou malé. Mám pojistit i je? Do kdy budou potřebovat peníze?',
        otazkaVi: 'Con còn nhỏ, có nên mua cho con không? Con đi học đại học thì cần tiền đến bao giờ?',
        zdroj: '§ 20, 52 zákona o důchodovém pojištění; metodika této analýzy',
      },
      dotaznik: {
        odpoved: 'Ano — na každou otázku pravdivě a úplně, i na drobnosti, na které se pojišťovna ptá. Když se zamlčení prokáže, může od smlouvy odstoupit nebo odmítnout plnění právě ve chvíli, kdy ho rodina potřebuje. Pravdivá odpověď může znamenat přirážku nebo výluku, ale smlouva pak drží.',
        otazka: 'Musím do dotazníku napsat všechno? Co když drobnost nenapíšu?',
        otazkaVi: 'Khai sức khỏe có phải khai hết không? Bệnh vặt không khai có sao không?',
        zdroj: '§ 2788, 2808, 2809 OZ',
      },
      duchodOsvc: {
        odpoved: 'Starobní i invalidní důchod se počítá ze základů, ze kterých jste platil, takže při minimálních zálohách bude nízký. Invalidní důchod navíc vyžaduje dobu pojištění (nad 28 let věku 5 let v posledních 10). Přesný přehled let a plateb dá ČSSZ v informativním osobním listu na ePortálu.',
        otazka: 'Platím sociálku jen minimum. Jaký budu mít důchod? A co mi dá stát při invaliditě?',
        otazkaVi: 'Tôi chỉ đóng bảo hiểm xã hội mức thấp nhất, sau này lương hưu được bao nhiêu? Mất sức lao động thì nhà nước trả gì?',
        zdroj: '§ 16, 40 zákona o důchodovém pojištění; ČSSZ',
      },
      invalidita: {
        odpoved: 'Invalidita je dlouhodobý pokles schopnosti pracovat kvůli zdraví; stát ji dělí na tři stupně: 35–49 %, 50–69 % a 70 % a víc. Pojistka platí podle svých podmínek — některé se řídí rozhodnutím ČSSZ, jiné vlastním posouzením, obvykle až po ustálení zdravotního stavu. Proto vždy ukážu, od kterého stupně a kolik vyplácí.',
        otazka: 'Co to je invalidita? Kdy dostanu peníze?',
        otazkaVi: 'Mất sức lao động là thế nào? Bao giờ thì được trả tiền?',
        zdroj: '§ 39 zákona o důchodovém pojištění; pojistné podmínky',
      },
      kamInvest: {
        odpoved: 'Investiční část kupuje podíly ve fondech, které si vyberete ze seznamu pojišťovny — akciové, dluhopisové, smíšené nebo peněžní. Čím víc akcií, tím vyšší možný výnos i větší výkyvy, a hodnota může klesnout i pod vložené peníze. Strategii lze obvykle měnit, podmínky a poplatky jsou v sazebníku.',
        otazka: 'Do čeho se ty peníze investují? Můžu o všechno přijít?',
        otazkaVi: 'Tiền này đầu tư vào đâu? Có bị mất trắng không?',
        zdroj: '§ 86 zákona o distribuci pojištění; KID (nařízení PRIIPs)',
      },
      kolikStoji: {
        odpoved: 'Cenu ochrany zná až pojišťovna — závisí na věku, zdraví, povolání a výši krytí, proto v analýze stojí jen cena z její modelace, žádný odhad. Před podpisem musí pojišťovna ukázat, kolik z platby jde na krytí rizik (to se spotřebuje), kolik na náklady a kolik se investuje. Balíček 10–30 % příjmu je rámec rozpočtu, ne cena.',
        otazka: 'Kolik budu platit měsíčně? A kolik z toho je pojištění a kolik se investuje?',
        otazkaVi: 'Mỗi tháng phải đóng bao nhiêu? Trong đó bao nhiêu là tiền bảo hiểm, bao nhiêu được đầu tư?',
        zdroj: '§ 84, 86 zákona o distribuci pojištění; KID (nařízení PRIIPs); metodika této analýzy',
      },
      komu: {
        odpoved: 'Ten, koho napíšete do smlouvy jako obmyšleného — může to být i rodič ve Vietnamu (jméno, datum narození, kontakt). Když nikdo určen není, zákon dává přednost manželovi, pak dětem, rodičům a dědicům. Obmyšleného jde kdykoli písemně změnit; výplatu do zahraničí ověříme v podmínkách.',
        otazka: 'Když umřu, kdo dostane peníze? Můžou je dostat rodiče ve Vietnamu?',
        otazkaVi: 'Nếu tôi mất thì ai nhận tiền? Bố mẹ tôi ở Việt Nam có nhận được không?',
        zdroj: '§ 2829, 2831, 2832 OZ',
      },
      krach: {
        odpoved: 'Pojišťovny jsou pod dohledem ČNB a musí držet kapitál a technické rezervy; při likvidaci slouží aktiva kryjící závazky přednostně na nároky z pojištění. Pojištění vkladů jako u bank se na životní pojištění nevztahuje. Investiční část navíc kolísá s hodnotou fondů bez ohledu na pojišťovnu.',
        otazka: 'Co když pojišťovna zkrachuje? Co bude s mými penězi?',
        otazkaVi: 'Nếu công ty bảo hiểm phá sản thì tiền của tôi thế nào?',
        zdroj: '§ 123 zákona o pojišťovnictví',
      },
      nemocny: {
        odpoved: 'Záleží na diagnóze, léčbě a pojišťovně: přijetí za běžnou cenu, přirážka, výluka jen pro tuto nemoc, odklad, nebo odmítnutí. Rozhoduje pojišťovna po dotazníku, případně po lékařské zprávě, a některá připojištění mají čekací dobu. Nemoc proto uveďte hned — předem se nedá nic slíbit.',
        otazka: 'Mám vysoký tlak, cukrovku… Můžu se vůbec pojistit?',
        otazkaVi: 'Tôi đang bị cao huyết áp, tiểu đường… thì có mua bảo hiểm được không?',
        zdroj: '§ 2788 OZ; § 84 zákona o distribuci pojištění; pojistné podmínky',
      },
      nesezdani: {
        odpoved: 'Vdovský nebo vdovecký důchod od státu náleží jen manželovi nebo manželce. V pojistce ale může být obmyšleným kdokoli, proto partnera napište do smlouvy jménem. Bez určení zákon dává peníze manželovi, dětem, rodičům a dědicům — partner bez sňatku mezi nimi není.',
        otazka: 'Žijeme spolu, ale nejsme oddaní. Když umřu, dostane partner něco?',
        otazkaVi: 'Chúng tôi sống với nhau nhưng chưa đăng ký kết hôn. Nếu tôi mất thì người kia có được gì không?',
        zdroj: '§ 49, 50 zákona o důchodovém pojištění; § 2829, 2831 OZ',
      },
      osvcPn: {
        odpoved: 'OSVČ dostane nemocenskou jen tehdy, když si aspoň 3 měsíce před onemocněním dobrovolně platí nemocenské pojištění — a i pak až od 15. dne a z nízkého základu. Bez něj nemocenskou od státu nedostane a výdaje běží dál. Proto u OSVČ počítáme pojištění pracovní neschopnosti; od kterého dne platí, určí podmínky.',
        otazka: 'Mám živnost. Když budu měsíce nemocný, zaplatí mi něco stát?',
        otazkaVi: 'Tôi tự kinh doanh, nếu ốm phải nghỉ mấy tháng thì nhà nước có trả gì không?',
        zdroj: '§ 24, 26, 29 zákona o nemocenském pojištění; ČSSZ',
      },
      podvod: {
        odpoved: 'Pojišťovna musí mít povolení ČNB a poradce musí být zapsaný v jejím registru — ověříte si to sami podle jména. Před podpisem dostanete písemně pojistné podmínky, sdělení klíčových informací (KID) s náklady a záznam z jednání včetně rizik. Nic nemusíte podepsat hned a při sporu se můžete bez poplatku obrátit na finančního arbitra.',
        otazka: 'Není to podvod? Ve Vietnamu lidi koupili pojištění přes banku a přišli o peníze.',
        otazkaVi: 'Cái này có phải lừa đảo không? Ở Việt Nam người ta mua bảo hiểm qua ngân hàng rồi mất tiền đấy.',
        zdroj: 'registr ČNB; § 79, 88 zákona o distribuci pojištění; § 18 zákona o finančním arbitrovi',
      },
      poplatky: {
        odpoved: 'Všechny náklady jsou v dokumentech: struktura pojistného před podpisem, náklady v čase v KID a jednotlivé poplatky v sazebníku. Část nákladů se platí v prvních letech, proto tehdy investiční účet roste pomalu; vstupní poplatek z cílové částky vidíte v analýze zvlášť v penězích. Každý rok přijde výpis s hodnotou účtu, odkupným a náklady.',
        otazka: 'Jaké tam jsou poplatky? Kam jdou peníze v prvních letech?',
        otazkaVi: 'Phí gì mà nhiều thế? Mấy năm đầu tiền của tôi đi đâu?',
        zdroj: '§ 84, 86, 89 zákona o distribuci pojištění; KID (nařízení PRIIPs)',
      },
      provize: {
        odpoved: 'Dostávám odměnu od pojišťovny; její druh vám musím sdělit a najdete ho v informacích před podpisem. Zákon ji rozkládá na 5 let — když smlouva skončí dřív, část odměny vracím. Proto mi jde o smlouvu, kterou budete schopni platit dlouho.',
        otazka: 'Kolik na tom vyděláte vy?',
        otazkaVi: 'Anh/chị bán cái này được hoa hồng bao nhiêu?',
        zdroj: '§ 50, 88 zákona o distribuci pojištění',
      },
      rodice: {
        odpoved: 'Podporu rodičů dáme do výdajů rodiny, aby s ní počítal i výpočet potřebné ochrany. Když nemoc nebo úraz vezme příjem, dávka z pojištění pomůže platit i tuhle položku. Pro případ úmrtí můžete rodiče určit jako obmyšlené; výplatu do Vietnamu ověříme v podmínkách.',
        otazka: 'Každý měsíc posílám peníze rodičům. Kdo jim bude posílat, když onemocním?',
        otazkaVi: 'Tháng nào tôi cũng gửi tiền về cho bố mẹ. Nếu tôi ốm hay có chuyện gì thì ai gửi?',
        zdroj: '§ 2829 OZ; metodika této analýzy',
      },
      rozvod: {
        odpoved: 'Po rozvodu zkontrolujte obmyšleného: bývalý manžel napsaný jménem jím zůstává, dokud to písemně nezměníte. Smlouvu řídí pojistník, a když je pojištěný jiná osoba, ke změně obmyšleného a k odkupnému je potřeba i jeho souhlas. Jak se dělí investiční část, řeší majetkové vypořádání — to ať posoudí advokát.',
        otazka: 'Kdybychom se rozvedli, komu patří smlouva a peníze v ní?',
        otazkaVi: 'Nếu sau này ly hôn thì hợp đồng và tiền trong đó thuộc về ai?',
        zdroj: '§ 2826, 2829, 2830, 2832 OZ',
      },
      sezona: {
        odpoved: 'Jen když to smlouva výslovně umožňuje — co konkrétní produkt dovolí (snížit, dočasně neplatit, strhávat ochranu z investičního účtu), ukážu v podmínkách. Při neplacení přijde upomínka s dodatečnou lhůtou aspoň měsíc, pak pojištění může zaniknout. Platbu proto nastavujeme podle slabých měsíců, ne podle nejlepších.',
        otazka: 'Někdy se daří, někdy ne. Můžu ve slabé sezóně platbu pozastavit nebo snížit?',
        otazkaVi: 'Làm ăn lúc được lúc không, mùa ế thì có tạm ngừng hoặc đóng ít đi được không?',
        zdroj: '§ 2804, 2838 OZ; pojistné podmínky',
      },
      skoncit: {
        odpoved: 'Počáteční náklady se obvykle strhávají v prvních letech, takže krátká smlouva je drahá a odkupné bývá zpočátku nízké. Plánujeme ji podle cíle — na stáří a na roky dětí. Skončit ale jde: do 30 dnů od potvrzení o uzavření odstoupit, do 2 měsíců od uzavření vypovědět a později ukončit s odkupným.',
        otazka: 'Proč se musí platit tak dlouho? Co když budu chtít přestat?',
        otazkaVi: 'Sao phải đóng lâu thế? Nếu muốn dừng giữa chừng thì sao?',
        zdroj: '§ 2805, 2808, 2842 OZ; § 86 zákona o distribuci pojištění',
      },
      staraSmlouva: {
        odpoved: 'Starou smlouvu kvůli nové nerušte, dokud je neporovnáme písemně: znovu se platí počáteční náklady, nový dotazník posuzuje dnešní věk a zdraví a u smlouvy s daňovým odpočtem hrozí dodanění. ČNB před zbytečným rušením smluv výslovně varuje. Často stačí starou upravit nebo doplnit jen to, co chybí.',
        otazka: 'Už mám smlouvu od jiného poradce. Mám ji zrušit a udělat novou?',
        otazkaVi: 'Tôi có hợp đồng cũ với người khác rồi, có nên hủy để làm cái mới không?',
        zdroj: 'upozornění ČNB k rušení smluv; § 15b zákona o daních z příjmů',
      },
      stari: {
        odpoved: 'Pomoc dětí je krásná věc a cílem je, aby byla dar, ne nutnost. Vlastní peníze na stáří dávají volbu: kde bydlet, jestli se vrátit do Vietnamu, jak pomáhat vnoučatům. Částka v grafu je modelová a bez záruky.',
        otazka: 'Máme děti, na stáří se o nás postarají. Proč bych to potřeboval?',
        otazkaVi: 'Có con rồi, về già con nó lo, cần gì phải mua cái này?',
        zdroj: 'metodika této analýzy; § 86 zákona o distribuci pojištění',
      },
      vietnam: {
        odpoved: 'Jestli smlouva po přestěhování pokračuje, jestli platí mimo ČR a jak se platí a vyplácí do zahraničí, určují pojistné podmínky — proto se před podpisem zeptáme pojišťovny písemně a odpověď si schováte. Po odstěhování se mění i daně (nerezident mimo EU odpočet neuplatní). Český důchod jde vyplácet i do Vietnamu, podmínky ověří ČSSZ.',
        otazka: 'Co bude se smlouvou, když se celá rodina vrátí do Vietnamu?',
        otazkaVi: 'Sau này cả nhà về Việt Nam thì hợp đồng thế nào? Có đóng tiếp được không, tiền có chuyển về Việt Nam được không?',
        zdroj: '§ 2789 OZ; § 84 zákona o distribuci pojištění; § 15 zákona o daních z příjmů; ČSSZ',
      },
      vratiSe: {
        odpoved: 'Celé ne. Část, která platí ochranu, je cena za to, že rodina byla celou dobu krytá, a nevrací se — stejně jako pojištění auta. Peníze na stáří vznikají jen z investiční části, po nákladech a bez záruky výnosu.',
        otazka: 'Když se nic nestane, vrátí se mi, co jsem zaplatil?',
        otazkaVi: 'Nếu không có chuyện gì thì tiền đóng bảo hiểm có được trả lại không?',
        zdroj: '§ 86 zákona o distribuci pojištění',
      },
      vybrat: {
        odpoved: 'Z investiční části jde zpravidla udělat mimořádný výběr; minimální zůstatek, poplatek a lhůtu určují podmínky. Při ukončení celé smlouvy vzniká nárok na odkupné (po zaplacení aspoň za dva roky, pokud ho smlouva nevylučuje) a pojišťovna ho vyplatí do tří měsíců. Na rychlé peníze proto patří rezerva na účtu vedle smlouvy.',
        otazka: 'Když budu nutně potřebovat peníze, můžu si je vybrat? Za jak dlouho je mám?',
        otazkaVi: 'Lúc cần tiền gấp thì có rút ra được không? Bao lâu thì nhận được tiền?',
        zdroj: '§ 2842 OZ; § 86 zákona o distribuci pojištění; KID (nařízení PRIIPs)',
      },
      vyluky: {
        odpoved: 'Každé riziko má v podmínkách svou definici a výluky — ukážu je před podpisem. Trvalé následky a denní odškodné kryjí jen úraz; invalidita, závažná onemocnění a pracovní neschopnost podle podmínek i nemoc. Ztráta práce nebo zavření obchodu pojistná událost zpravidla není.',
        otazka: 'Kdy pojišťovna nezaplatí? Platí to i na nemoc, nebo jen na úraz?',
        otazkaVi: 'Trường hợp nào thì bảo hiểm không trả? Ốm có được trả không hay chỉ tai nạn?',
        zdroj: '§ 84 zákona o distribuci pojištění; § 2837 OZ; pojistné podmínky',
      },
      vynos: {
        odpoved: '5, 7 a 9 % jsou modelové sazby pro ilustraci, ne slib. Investice může i ztrácet a riziko nese klient — KID proto ukazuje i nepříznivý a stresový scénář. Delší doba kolísání zmírní, ale neodstraní, a proto graf vždy ukazuje i to, kolik jste celkem zaplatili.',
        otazka: 'Proč to vydělá tolik? Je těch 7 % jistých?',
        otazkaVi: 'Sao lãi được nhiều thế? Có chắc được 7 % một năm không?',
        zdroj: '§ 86 zákona o distribuci pojištění; KID (nařízení PRIIPs)',
      },
      zavazneOnem: {
        odpoved: 'Vyplatí jednorázovou částku, když lékař potvrdí diagnózu ze seznamu v podmínkách; seznam, definice i stadia se mezi pojišťovnami liší. Peníze jde použít na cokoli — výpadek příjmu, péči, cesty k léčbě. V naší analýze je výchozí částka jeden rok čistého příjmu (volitelně dva nebo tři).',
        otazka: 'Co je pojištění závažných onemocnění? Zaplatí, když dostanu rakovinu?',
        otazkaVi: 'Bảo hiểm bệnh hiểm nghèo là gì? Bị ung thư thì có được trả không?',
        zdroj: '§ 84 zákona o distribuci pojištění; pojistné podmínky; metodika této analýzy',
      },
      zdravotniCizinec: {
        odpoved: 'Komerční zdravotní pojištění hradí léčení, ale nenahradí příjem, když nemůžete pracovat, a nic nedá rodině při úmrtí nebo invaliditě. Do veřejného zdravotního pojištění patří hlavně lidé s trvalým pobytem nebo zaměstnanci českého zaměstnavatele. Slovo „bảo hiểm“ znamená obojí, proto vždy řeknu, o kterém mluvíme.',
        otazka: 'Mám komerční zdravotní pojištění pro cizince. To nestačí?',
        otazkaVi: 'Tôi có bảo hiểm y tế thương mại cho người nước ngoài rồi, thế chưa đủ à?',
        zdroj: '§ 2 zákona o veřejném zdravotním pojištění',
      },
      zvlast: {
        odpoved: 'Jde to i tak: rizikové životní pojištění jen na ochranu a investice zvlášť. Rozhoduje, co vás po všech nákladech vyjde líp a co budete opravdu dodržovat — obě cesty můžu spočítat vedle sebe z KID a sazebníků. Rozhodnutí je vaše a zapíšu ho do záznamu z jednání.',
        otazka: 'Proč si nekoupit jen levné rizikové pojištění a investovat zvlášť sám?',
        otazkaVi: 'Sao không mua bảo hiểm rủi ro cho rẻ, còn tiền thì tự đầu tư riêng?',
        zdroj: '§ 78, 79 zákona o distribuci pojištění; KID (nařízení PRIIPs)',
      },
    },
    ui: {
      chybaVypoctu: 'Výpočet se nepovedl. Zkontrolujte zadané údaje.',
      hotovo: 'Hotovo',
      metodika: 'Metodika výpočtu z {verze}.',
      vymazat: 'Vymazat',
    },
    varovani: {
      balicekNadVolne: 'Balíček {pct} % se do rozpočtu nevejde, chybí {chybi} měsíčně.',
      detiSamostatne: 'Děti od {vek} let se nepočítají: {pocet}.',
      duchodNadBalicek: 'Na důchod by bylo potřeba odkládat {odkladat} měsíčně, víc než celý balíček {balicek}.',
      ochranaNadBalicek: 'Ochrana stojí víc než balíček, do investice nezbývá nic.',
      poVekuOdchodu: 'Je v důchodovém věku nebo nad ním.',
      splatkaDopocitana: 'Splátka dopočtená ({splatka} při {sazbaPct} % ročně). Přesnou opište ze smlouvy.',
      vydajeNadPrijmy: 'Výdaje a splátky převyšují příjmy o {chybi}.',
      vynosMimoScenare: 'Výnos {vynos} % není jeden ze scénářů 5 / 7 / 9 %.',
    },
    vypadek: {
      bez: 'Bez pojištění',
      bezZdroje: 'Tahle část nemá žádný zdroj.',
      chybiCastka: 'chybí {castka} měsíčně',
      chybiJednorazove: 'Měsíčně nic nechybí, ale na cíle by chybělo {castka}.',
      chybiMesicne: 'Každý měsíc chybí',
      cip: {
        infarkt: 'Infarkt',
        ledviny: 'Selhání ledvin',
        mrtvice: 'Mrtvice',
        ochrnuti: 'Ochrnutí',
        rakovina: 'Rakovina',
        roztrousena: 'Roztroušená skleróza',
        srdce: 'Operace srdce',
        uraz: 'Vážný úraz',
      },
      cipyAria: 'Příklady nemocí a událostí',
      cipyPoznamka: 'Příklady. Co přesně kryje smlouva, určují pojistné podmínky.',
      jakSpocitano: 'Jak jsme k částce došli',
      kdoAria: 'Čí příjem vypadne',
      krokChybi: 'Co chybí = pojistná částka',
      krokPotreba: 'Co rodina potřebuje (z vašich cílů)',
      krokStat: 'Co dá stát',
      krytoCastka: 'kryto {castka} měsíčně',
      legendaChybi: 'chybí, bez zdroje',
      legendaKryto: 'kryje pojištění',
      legendaPartner: 'dál nese {kdo}',
      nadpis: 'Kdyby jeden příjem vypadl',
      nesePartner: '{kdo} dál nese {pct} % cílů svým příjmem.',
      nicNechybi: 'Příjem druhého z vás by tuhle situaci pokryl.',
      nicNechybiSam: 'Z cílů, které jste zadali, by nic nezůstalo bez zdroje.',
      pojistnaCastka: 'Pojistná částka',
      prazdno: 'Spočítáme, jakmile budou zadané věky, příjmy a výdaje rodiny.',
      radek: {
        bydleni: 'Splátka bydlení',
        deti: 'Děti do 23 let',
        duchod: 'Odkládání na důchod',
        zivot: 'Běžný život rodiny',
      },
      s: 'S pojištěním',
      sZdrojem: 'Díra je zavřená, cíle rodiny zůstanou.',
      udalost: {
        invalidita: 'Nemůže pracovat',
        smrt: 'Úmrtí',
      },
      udalostAria: 'Co se stane',
      uvod: 'Nemoc nebo úraz může přijít nečekaně. Co by se stalo s cíli rodiny a co ji podrží.',
      veta: {
        invalidita: {
          bo: 'Kdyby táta dlouhodobě nemohl pracovat, jeho příjem se zastaví.',
          me: 'Kdyby máma dlouhodobě nemohla pracovat, její příjem se zastaví.',
        },
        smrt: {
          bo: 'Kdyby tu táta nebyl, jeho příjem rodině chybí natrvalo.',
          me: 'Kdyby tu máma nebyla, její příjem rodině chybí natrvalo.',
        },
      },
    },
    zaver: {
      nadpis: 'Dvě cesty',
      nestane: 'Když se nic nestane — máte peníze na stáří a nemusíte spoléhat na děti.',
      nestanePuvod: 'Vzniká jen z investiční části: {investice} měsíčně po dobu {roky}, celkem {zaplaceno}. Výnos není jistý.',
      nestaneVek: 'v {vek} letech · model {vynos} %',
      stane: 'Kdyby se něco stalo — celá rodina je chráněná.',
      stanePuvod: 'Platí se z balíčku {balicek}: {ochrana} měsíčně jde na ochranu. To je cena krytí a nevrací se.',
      staneRiziko: {
        invalidita: '{kdo} · invalidita',
        smrt: '{kdo} · úmrtí',
      },
    },
  },
  /* BLOK:vnRodina END */
  /* BLOK:kalkLista START — generuje scratchpad/slovnik.py, ručně needitovat */
  kalkLista: {
    cekani: {
      aria: 'Hned {hned}, při odkladu {pozdeji}, cena čekání {cena}. Sloupec za každých 5 let, vrstva za každý blok vkladů.',
      blok: 'Vklady {od}.–{do}. rok',
      budeMit: 'Bude mít za {roky}',
      hned: 'Hned',
      horizont: 'Horizont',
      mesicne: 'Měsíčně',
      otazkaHned: 'Když začne hned, bude mít za {roky}',
      otazkaPozde: 'Když začne o {roky} později, přijde o',
      pracuji: 'Peníze, které pracují',
      vetaHned: 'Každých 5 let vkladů je jedna vrstva — spodní pracuje nejdéle.',
      vetaPozde: 'Na tolik by narostly vklady z prvních {roky} — pracují nejdéle.',
      vlozi: 'Vloží',
      vynos: 'Výnos ročně',
      zacne: 'Začne až za',
      ztrata: 'Ztráta čekáním',
    },
    dopl: {
      aria: 'Dluh {dluh} klesá, portfolio po dani roste. Protnou se za {doba}, kdy zbývá doplatit {castka}. Hraniční výnos {hranice}.',
      ariaNikdy: 'Dluh {dluh} klesá, portfolio po dani ho za {roky} nedožene.',
      bublinaMim: 'Dluh s mimořádnými splátkami',
      chybiDo: 'Do doplacení chybí',
      hranice: 'Hraniční výnos',
      hraniceNad: 'nad 30 %',
      hraniceZnacka: 'hranice {pct}',
      investice: 'Investice',
      investiceMes: 'Investice měsíčně',
      jistina: 'Zbývá doplatit',
      konecSplatnosti: 'konec splatnosti',
      lzeDoplatit: 'lze doplatit',
      mimBezDluhu: 'Mimořádné splátky: bez dluhu za',
      mimoradne: 'Mimořádné splátky',
      nadInflaci: 'Nad inflací',
      nastejno: 'Nastejno',
      nelze: 'Se zadanými hodnotami se nedá počítat — zkontrolujte sazbu a splatnost.',
      nesplati: 'Při této splátce se hypotéka nesplatí ani za 80 let.',
      nevyslo: 'Za {roky} portfolio na doplacení nestačí — po prodeji a dani chybí {castka}.',
      nominalne: 'Nominálně',
      nominalnePct: 'nominálně {pct}',
      otazka: 'Při výnosu {vynos} by investice {castka} měsíčně doplatila hypotéku za',
      otazkaRealne: 'Při výnosu {vynos} nad inflací by investice {castka} měsíčně doplatila hypotéku za',
      poDani: 'po dani a poplatcích',
      podleVynosu: 'Podle výnosu',
      poznamka: 'Výnos investice není zaručen, splátka hypotéky ano. Daň z prodeje podle práva platného dnes.',
      poznamkaSk: 'Výnos investice není zaručen, splátka hypotéky ano. Daň z prodeje investice není započítaná (před daní) — slovenská pravidla appka zatím nepočítá.',
      propad: 'Propad 35 %',
      radaDluh: 'Zbývající dluh',
      radaMim: 'Mimořádné splátky',
      radaPortfolio: 'Portfolio po dani',
      realne: 'reálně {pct}',
      rezim: 'Výnos zadán',
      riziko: 'Riziko',
      sazba: 'Sazba hypotéky',
      slRozdil: 'Portfolio − dluh',
      srovnatZa: 'Srovnat za',
      tabulkaPopis: 'Částky v {mena} na konci roku · portfolio po dani a poplatcích (celkem {naklady})',
      ter: 'Roční poplatek (TER)',
      trh: 'Trh v roce porovnání',
      trhNic: 'Trh nedá nic',
      vetaChybi: 'dlužíte {dluh}, portfolio po dani {portfolio}, do doplacení chybí {chybi}.',
      vetaDnes: 'dlužíte {dluh}, investice začíná od nuly.',
      vetaSplaceno: 'hypotéka splacena, portfolio po dani {portfolio}.',
      vetaZbylo: 'dlužíte {dluh}, portfolio po dani {portfolio} — po doplacení by zbylo {zbylo}.',
      vicNez: 'víc než {roky}',
      vstupni: 'Vstupní poplatek',
      vyhodnejsi: 'Výhodnější za {roky}',
      vyhravaInvestice: 'vyhrává investice',
      vyhravaSplaceni: 'vyhrává splácení',
      vynos: 'Výnos ročně',
      vynosPodUrokem: 'Výnos {vynos} nepřekoná úrok hypotéky {sazba} — vyplatí se splácet.',
      zbyloBy: 'Po doplacení by zbylo',
      zbyvaLet: 'Zbývá let',
    },
    historie: {
      aria: 'Skutečný vývoj od {od} do {do}: vloženo {vlozeno}, dnes {hodnota}.',
      dynamicky: 'Dynamické',
      hodnota: 'Hodnota',
      jednorazove: 'Jednorázově',
      konzervativni: 'Konzervativní',
      mesicne: 'Měsíčně',
      otazka: 'Kdyby začal v roce {rok}, dnes by měl',
      otazkaObecna: 'Kolik by dnes měl',
      portfolio: 'Portfolio',
      roky: 'Kolik let zpátky',
      veta: 'Skutečný vývoj trhů {od}–{do}. Minulost nezaručuje budoucnost.',
      vklad: 'vklad',
      vlozeno: 'Vloženo',
      vlozil: 'Vložil',
      vydelal: 'Vydělalo',
      vyvazeny: 'Vyvážené',
      zdroj: 'Zdroj dat: SBBI/Ibbotson (USA)',
    },
    hypo: {
      aria: 'Jistina {uver} klesne za {roky} na nulu; na úrocích zaplatíte celkem {urok}.',
      bezJinychUveru: 'bez jiných úvěrů',
      bezPrijmu: 'příjem nezadán',
      bezUveru: 'Vlastní zdroje pokryjí celou cenu — úvěr není potřeba.',
      bezVeku: 'věk nezadán',
      bezZavazku: 'závazky nezadány',
      bublinaJistina: 'Jistina na konci roku',
      bublinaUroky: 'Úroky zaplacené celkem',
      celkem: 'Celkem zaplatíte',
      cena: 'Cena nemovitosti',
      doporuceniNad: 'nad doporučením ČNB {limit}',
      doporuceniV: 'v rámci doporučení ČNB {limit}',
      dstiCo: 'Splátky k čistému příjmu, doporučení ČNB',
      dstiCoBez: 'Splátky k čistému příjmu',
      dtiCo: 'Dluhy k ročnímu příjmu, doporučení ČNB',
      dtiCoBez: 'Dluhy k ročnímu příjmu',
      dtiCoNbs: 'Všechny úvěry k ročnímu čistému příjmu, závazný limit NBS',
      jineNevyplneno: 'Nevyplněno',
      jineUvery: 'Jiné úvěry klienta',
      jineZadne: 'Žádné',
      ltvCo: 'Úvěr k ceně nemovitosti, závazný limit {regulator}',
      ltvNad: 'nad limitem {limit}',
      ltvV: 'v limitu {limit}',
      minVlastni: 'min. {castka} (LTV {limit})',
      minVlastniRok: 'min. {castka} (LTV {limit} při koupi v roce {rok})',
      nbsLimit: 'limit NBS {limit}',
      nbsLimitNejvys: 'limit NBS nejvýš {limit}',
      nbsMaxUver: 'max. úvěr {castka}',
      nbsMaxUverNejvys: 'max. úvěr nejvýš {castka}',
      nbsNad: 'nad limitem NBS {limit}',
      nbsV: 'v limitu NBS {limit}',
      otazka: 'Měsíční splátka',
      poznamkaCz: 'LTV je závazný limit ČNB, DSTI a DTI jsou jen doporučení ČNB.',
      poznamkaSk: 'LTV je závazný limit NBS.',
      poznamkaSkNbs: 'LTV a DTI jsou závazné limity NBS.',
      radaJistina: 'Jistina',
      radaUroky: 'Zaplacené úroky',
      sazba: 'Sazba',
      slUmor: 'Úmor',
      slUrok: 'Zaplacený úrok',
      splatkaNevyplnena: 'splátka úvěru nevyplněna',
      splatkyNadPrijem: 'Splátky převyšují čistý příjem o {castka} měsíčně.',
      splatnost: 'Splatnost',
      ukazatele: 'Ukazatele úvěru',
      ukazateleCnb: 'Ukazatele ČNB',
      vetaDnes: 'dlužíte {jistina}, splátka {splatka} měsíčně.',
      vetaRoku: 'dlužíte {jistina}, na úrocích zaplaceno {uroky}.',
      vlastni: 'Vlastní zdroje',
      zTohoJistina: 'Z toho jistina',
      zTohoUrok: 'Z toho úrok',
      zustatekNevyplnen: 'zůstatek úvěru nevyplněn',
    },
    jakoVPlanu: 'jako v plánu',
    kostra: {
      celkem: 'Celkem',
      dnes: 'Dnes',
      grafOvladani: 'Šipkami vyberete rok, Home a End skočí na začátek a konec.',
      grafRole: 'interaktivní graf',
      rok: 'Rok {n}',
      sloupecRok: 'Rok',
      tabulka: 'Tabulka po letech',
      tabulkaPopis: 'Částky v {mena}, stav na konci roku',
      zaRoky: 'Za {roky}',
    },
    letFew: '{n} roky',
    letMany: '{n} let',
    letOne: '{n} rok',
    mesFew: '{n} měsíce',
    mesMany: '{n} měsíců',
    mesOne: '{n} měsíc',
    mesicne: 'měsíčně',
    modelova: 'modelová hodnota',
    nezadano: 'nezadáno',
    paticka: 'Orientační výpočet, ne nabídka ani garance. Nic se neukládá do analýzy.',
    prebytek: 'volné CF {castka}',
    prumerTrhu: 'průměr trhu',
    refi: {
      aria: 'Celkem zaplatí dnes {dnes}, po refinancování {nove}.',
      dnes: 'Dnes',
      jistina: 'Zbývá doplatit',
      naklady: 'Náklady převodu',
      nakladyPopisek: '+ {castka} náklady převodu',
      nakladySerie: 'Náklady převodu',
      novaSazba: 'Nová sazba',
      nove: 'Po převodu',
      otazka: 'Po refinancování ušetří',
      otazkaHorsi: 'Nová sazba není nižší — splátka vzroste o',
      splatkaDnes: 'Splátka dnes',
      splatkaNova: 'Nová splátka',
      staraSazba: 'Sazba dnes',
      veta: 'Za {roky} ušetří celkem {castka}; náklady se vrátí za {mesice}.',
      vetaBezNakladu: 'Za {roky} ušetří celkem {castka}.',
      vetaHorsi: 'Za {roky} zaplatí navíc {castka}.',
      zbyvaLet: 'Zbývá',
    },
    renta: {
      aria: 'Kapitál {kapital} na rentu {renta} měsíčně. Za {roky} se vyplatí {vyplaceno}, na konci zbude {zbude}.',
      bublinaKapital: 'Kapitál na konci roku',
      bublinaVyplaceno: 'Vyplaceno celkem',
      cerpani: 'Čerpat',
      cerpaniNavzdy: 'Čerpání navždy',
      cerpaniRoky: 'Čerpání {roky}',
      navzdy: 'Navždy',
      otazka: 'Na rentu {castka} měsíčně potřebuje',
      poznamka: 'Výnos nad inflací, renta je v dnešních penězích. Výnos není zaručen.',
      renta: 'Renta měsíčně',
      slKapital: 'Kapitál',
      slVyplaceno: 'Vyplaceno celkem',
      vetaDnes: 'kapitál {kapital}, renta {renta} měsíčně.',
      vetaNavzdy: 'Renta jde jen z výnosu — kapitál zůstane celý.',
      vetaRoku: 'kapitál {kapital}, vyplaceno celkem {vyplaceno}.',
      vetaRoky: 'Za {roky} se kapitál vyčerpá na nulu.',
      vynos: 'Výnos nad inflací',
      vyplaceno: 'Vyplaceno za {roky}',
      vyplacenoRada: 'Vyplacené renty',
      zbude: 'Na konci zbude',
      zustatek: 'Kapitál',
    },
    splac: {
      aria: 'Zůstatek dluhu v čase: původně do roku {puvodni}, s mimořádnou splátkou do roku {novy}.',
      driv: 'Bez dluhu dřív o',
      mimoradna: 'Mimořádná splátka',
      nad25: 'Nad 25 % jistiny ročně může banka účtovat poplatek.',
      nove: 'S mimořádnou splátkou',
      otazka: 'Mimořádnou splátkou ušetří na úrocích',
      puvodne: 'Původně',
      rezim: 'Po mimořádné splátce',
      snizit: 'Snížit splátku',
      splatkaZustava: 'Splátka zůstává',
      veta: 'Dluh zmizí v roce {novy} místo {puvodni}.',
      vetaDoplaceno: 'Mimořádná splátka pokryje celý dluh.',
      vetaSnizit: 'Splátka klesne o {castka} měsíčně až do konce.',
      zkratit: 'Zkrátit dobu',
    },
    tab: {
      cekani: 'Cena čekání',
      doplaceni: 'Hypotéka s investicí',
      historie: 'Historická',
      hypoteka: 'Hypotéka',
      refinanc: 'Refinancování',
      renta: 'Renta',
      splaceni: 'Splatit dřív',
    },
    upravit: '{popisek}: {hodnota}. Upravit přesně',
    vratitVychozi: 'Vrátit výchozí hodnoty',
    zAnalyzy: 'z analýzy',
    zmensitKlavesa: 'Zmenšit (klávesa Z)',
    zvetsit: 'Zvětšit kalkulačku',
    zvetsitKlavesa: 'Zvětšit (klávesa Z)',
  },
  /* BLOK:kalkLista END */
  /* BLOK:brifink START — generuje scratchpad/slovnik.py, ručně needitovat */
  brifink: {
    poTerminu: 'Po termínu ({datum})',
  },
  /* BLOK:brifink END */
  /* BLOK:planVek START — generuje scratchpad/slovnik.py, ručně needitovat */
  planVek: {
    doplnte: 'Doplňte věk klienta',
    proc: 'Bez data narození nejde ověřit výjimku pro mladé do 36 let, proto se akontace 10 % nenabízí.',
  },
  /* BLOK:planVek END */
  /* BLOK:pojisteniPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniPlan: {
    castCeny: 'zatím jen část ceny',
    cenaCelkemNadpis: 'Pojistné celkem',
    cenaCelkemPopis: 'Plán počítá jen s cenou z nabídky pojišťovny.',
    cenaChybiDeti: 'Cena dětské smlouvy chybí — plán odečítá jen dospělé.',
    cenaChybiOsoba: 'Cena u {jmeno} chybí — plán odečítá jen zadanou část.',
    cenaDeti: 'Cena dětské smlouvy',
    cenaDoplnte: 'Doplňte cenu z pojišťovny',
    cenaOdPojistovny: 'Cena z nabídky pojišťovny',
    chybiCena: 'chybí cena',
    detiZavazneNadStropem: 'Nad upisovacím stropem {strop} — ověřte u pojišťovny.',
    jakProgrese: 'Jak funguje progrese',
    kalkCenyVarianta: 'Ceny pro variantu {varianta} — každá varianta má vlastní nabídku.',
    mesicneProCilePoPojistnem: 'Měsíčně pro cíle (po pojistném)',
    naCile: 'Na cíle',
    nulaZdrojeKryji: 'Částka 0 = zdroje rodiny (příjem partnera, majetek) tuto potřebu pokryjí.',
    orientacne: 'orientačně ≈ {castka} — plán s tím nepočítá',
    platbaNezadana: 'platba nezadaná',
    pojistneZmena: 'Pojistné — změna',
    pouzitProVsechny: 'Použít pro všechny varianty',
    prebytekPoPojistnem: 'Přebytek po pojistném',
    prezBezCenyPozn: 'Částky jsou návrh krytí, ne nabídka pojišťovny. Cenu i rozsah plnění včetně výluk určí pojišťovna ve smlouvě a pojistných podmínkách.',
    prezCenaPozn: 'Cena z nabídky, kterou zadal poradce — konečnou cenu potvrdí pojišťovna ve smlouvě, až posoudí zdravotní stav. Rozsah plnění a výluky určují pojistné podmínky.',
    prezZavazneProc: 'jednorázová výplata na léčbu — dovolí přestat pracovat a léčit se',
    rozpocetPojistne: 'Pojistné: dnes {stara} → nově {nova} ({rozdil})',
    rozpocetPojistneNove: 'Pojistné nově {nova} — je v povinných výdajích',
    rucne: 'ručně',
    rusiSe: 'ruší se',
    skrytProgresi: 'Skrýt progresi',
    staraZustava: 'stará smlouva zůstává',
    stareBezCeny: 'Rozdíl se spočítá, až zadáte cenu nové smlouvy.',
    stareBezKrytiZivota: 'Neodečítá se — nová smlouva této osobě nedává krytí smrti ani invalidity, stará proto zůstává.',
    stareBezNahrady: 'Chybí cena — neodečítá se, tuto osobu nová smlouva zatím nekryje.',
    stareIdd: 'Starou smlouvu rušte až po přijetí nové, k výročí, a důvod zapište do záznamu z jednání.',
    stareMajetekBezCeny: 'Uvolní se po zadání ceny nové smlouvy.',
    stareMajetekBezNahrady: 'Žádná nová smlouva ji nenahrazuje — v plánu se platí dál.',
    stareNadpis: 'Stávající smlouvy',
    stareNespoctenoPartner: 'Neodečítá se — zajištění partnera plán nespočítal (chybí datum narození), smlouva proto zůstává.',
    stareNeznama: 'Doplňte platbu stávající smlouvy {nazev} — zatím se odečítá celá nová cena.',
    stareNic: 'Pojistné nově {nova} — žádná stávající smlouva se neruší, odečte se celé.',
    stareRozdil: 'Pojistné: dnes {stara} → nově {nova} · odečte se jen rozdíl {rozdil}',
    tnuAria: 'Výplata trvalých následků z částky {castka}: při {pct} % poškození se vyplatí {vyplata}, při 100 % nejvýš {max}.',
    tnuOrientacne: 'Orientačně — pásma i násobky se u pojišťoven liší, přesnou tabulku plnění má pojišťovna.',
    tnuPasmo: 'pásmo ×{n}',
    tnuPoskozeni: 'Poškození {pct} %',
    tnuPri: 'při {pct} %',
    tnuVolby: 'Pojistná částka trvalých následků',
    tnuVyplati: 'vyplatí se',
    tnuVysvetleni: 'V našem modelu se každé pásmo násobí zvlášť: do 20 % ×1, 20–40 % ×2, 40–60 % ×3, nad 60 % ×4. Při 100 % je to nejvýš {max}× částky.',
    vetaNad: 'Pojistné navíc {rozdil} je víc než měsíční přebytek {prebytek} — na cíle nezbývá nic.',
    vetaNove: 'Pojistné {nova} · na cíle {naCile}',
    vetaZmena: 'Pojistné: dnes {stara} → nově {nova} ({rozdil}) · na cíle {naCile}',
    vydajeNezbytne: 'nezbytné výdaje',
    vydajeObvykle: 'obvyklé výdaje',
    vydajeSplatkyPojistne: 'Výdaje + splátky + pojistné',
    vydajeZObvyklych: 'Nezbytné výdaje nejsou zadané — varianta {varianta} počítá s 90 % obvyklých.',
    zadanaCast: 'zadaná část',
    zaverOchranaPovinne: 'ochrana {nova} — v povinných výdajích',
    zaverOchranaZmenaPovinne: 'ochrana dnes {stara} → nově {nova} — v povinných výdajích',
    zaverZVolnehoCf: 'Co to stojí z volného cash flow',
    zoVolby: 'Kolik let čistého příjmu',
    zustava: 'zůstává',
  },
  /* BLOK:pojisteniPlan END */
  /* BLOK:minimumSmrti START — generuje scratchpad/slovnik.py, ručně needitovat */
  minimumSmrti: {
    ariaHodnotaNaklad: '{castka} měsíčně',
    ariaNaklad: 'Měsíční náklad na dítě {jmeno}',
    ariaPruh: 'Minimum {castka}: {casti}',
    ariaVek: 'Do kolika let rodina živí dítě {jmeno}',
    bezPrijmu: 'bez příjmu',
    bezPrijmuText: 'Bez příjmu — pojistka na smrt doplatí aspoň dluhy rodiny.',
    dluhy: 'dluhy',
    doVekuFew: '{n} roky',
    doVekuMany: '{n} let',
    doVekuOne: '{n} rok',
    kalkVeta: 'Minimum {castka} = dluhy {dluhy} + 1 rok příjmu rodiny {prijem} + děti {deti}',
    kalkVetaBezDeti: 'Minimum {castka} = dluhy {dluhy} + 1 rok příjmu rodiny {prijem}',
    kalkVetaSablona: 'Minimum {castka} = dluhy {dluhy} + 1 rok příjmu rodiny {prijem} + děti {deti} — u dětí odhad podle šablony ({naklad} měsíčně na dítě do {vek} let), ne údaj z analýzy',
    klientSrovnani: 'Pro případ smrti vychází {smrt}, o {rozdil} víc než na invaliditu. Je to minimum, pod které krytí smrti nejde: dluhy, rok příjmu rodiny a děti do samostatnosti.',
    klientSrovnaniBezDeti: 'Pro případ smrti vychází {smrt}, o {rozdil} víc než na invaliditu. Je to minimum, pod které krytí smrti nejde: dluhy a rok příjmu rodiny.',
    klientSrovnaniSmrtVyssi: 'Pro případ smrti vychází {smrt}, o {rozdil} víc než na invaliditu. Obě částky mají na smlouvě své místo — každá kryje jinou situaci.',
    letFew: '{n} roky',
    letMany: '{n} let',
    letOne: '{n} rok',
    metodou: 'Metodou vychází {castka} — platí minimum:',
    nakladChybi: 'náklad na dítě chybí — doplňte ho do výdajů (kategorie Děti)',
    nakladDite: 'Náklad na dítě / měs',
    nakladHint: 'prázdné = šablona {castka}',
    nakladHintBez: 'doplňte — šablona pro tuto zemi není',
    podMinimem: 'Pod minimem {castka} (dluhy + 1 rok příjmu rodiny + děti) — zadáno ručně, vědomě.',
    podMinimemBezPrijmu: 'Pod minimem {castka} (doplacení dluhů) — zadáno ručně, vědomě.',
    posuvnikNaklad: 'Měsíčně',
    posuvnikVek: 'Do věku',
    pozn: 'Minimum: dluhy + 1 rok příjmu rodiny + děti do samostatnosti',
    poznBezPrijmu: 'Minimum: doplacení dluhů (bez příjmu)',
    prezProc: 'Nejméně tolik: dluhy {dluhy} + 1 rok příjmu rodiny {prijem} + děti do samostatnosti {deti}.',
    prezProcBezDeti: 'Nejméně tolik: dluhy {dluhy} + 1 rok příjmu rodiny {prijem}.',
    prezProcBezPrijmu: 'Nejméně tolik: doplacení dluhů {dluhy}.',
    prezProcSablona: 'Nejméně tolik: dluhy {dluhy} + 1 rok příjmu rodiny {prijem} + děti do samostatnosti {deti} — u dětí odhad podle šablony ({naklad} měsíčně na dítě do {vek} let), ne údaj z analýzy.',
    prijemRok: '1 rok příjmu rodiny',
    radekDite: '{jmeno}, {vek}: {naklad} × {roky} =',
    radekDiteBezVeku: '{jmeno}, věk nezadán: {naklad} × {roky} =',
    radekDluhy: 'Doplatit dluhy',
    radekPrijem: '1 rok příjmu rodiny: {mes} × 12 =',
    sablona: 'šablona {castka} měsíčně na dítě',
    stavMetoda: 'Metodou vychází víc ({castka}) — platí vyšší částka.',
    stavMinimum: 'Metodou vychází {castka} — platí minimum.',
    stitek: 'minimum',
    titul: 'Minimum krytí smrti',
    vekDeti: 'Věk dětí (let)',
    vekDitete: '{n}. dítě',
    vekFew: '{n} roky',
    vekHint: 'prázdné = od narození',
    vekMany: '{n} let',
    vekNeznamy: 'věk dítěte nezadán — počítáno od narození',
    vekOne: '{n} rok',
    vetaBezPrijmu: 'Minimum {castka} = doplacení dluhů — bez příjmu se rok příjmu ani děti nepočítají',
    vratit: 'Vrátit',
    vratitAria: 'Vrátit {jmeno} na hodnotu z analýzy',
    vystupMetodika: 'U smrti platí minimum, když kapitálová metoda vyjde níž.',
    zCeho: 'Z čeho se skládá minimum',
    zCehoSkryt: 'Skrýt složení minima',
    zadano: '{castka} měsíčně na dítě',
    zdrojAnalyza: 'z analýzy',
    zdrojSablona: 'šablona',
    zdrojUpraveno: 'upraveno',
  },
  /* BLOK:minimumSmrti END */
  /* BLOK:analyzaCisla START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaCisla: {
    auto: {
      chybiCil: 'V cílech chybí obměna auta. Vaše auto má dnes hodnotu {castka} — k té se za pár let budete vracet.',
      maCil: 'Cíl na auto máte. Držte ho kolem {castka} — v této cenové hladině jezdíte dnes.',
      nadpis: 'Obměna auta',
    },
    bydleni: {
      bezStropu: 'Cíl na bydlení {cil} je {nasobek}× váš roční příjem.',
      limitNbs: 'Na bydlení potřebujete úvěr {uver}. Limit NBS pro všechny vaše úvěry je {limit} ({max}× roční čistý příjem).',
      limitNbsSDluhy: 'Na bydlení potřebujete úvěr {uver}. Limit NBS pro všechny vaše úvěry je {limit} ({max}× roční čistý příjem), po ostatních úvěrech ({dluhy}) zbývá {strop}.',
      limitNbsVek: 'Podle věku může být limit nižší.',
      nadpis: 'Cena bydlení',
      strop: 'Cíl na bydlení {cil} je {nasobek}× váš roční příjem. Strop je {max}×, tedy {strop}.',
    },
    jednotky: {
      mil: 'mil.',
    },
    odkladani: {
      chybi: 'Do minima {min} % chybí {chybi} měsíčně.',
      dnes: 'Dnes jde stranou {pct} % příjmu.',
      dohodnuto: 'S odsouhlasenými {castka} měsíčně půjde stranou {pct} % příjmu.',
      dohodnutoVklady: 'S odsouhlasenými {castka} měsíčně a pravidelnými vklady {vklady} půjde stranou {pct} % příjmu.',
      ideal: 'To je ideál {ideal} %. Při {rychle} % se cíle plní hodně rychle.',
      minimum: 'Minimum {min} % je splněné, ideál je {ideal} %.',
      nadCilem: 'To je {rychle} % a víc — cíle se plní hodně rychle.',
      nadpis: 'Kolik jde stranou',
      schodek: 'Výdaje a splátky jsou vyšší než příjmy, stranou teď nejde nic.',
    },
    panel: {
      cerpani: 'čerpání',
      kProjednani: '{n} k projednání',
      kapital: 'Potřebný kapitál',
      nadpis: 'Co z čísel vyplývá',
      orientacni: 'orientační',
      orientacniTitle: 'Odhad, ne garantovaná hodnota',
      vseOk: 'vše v pořádku',
    },
    renta: {
      bezHypoteky: 'Hypotéku doplatíte do roku {rok}, v rentě ji nepočítáme.',
      bezSplatek: 'Bez splátek, které do renty doplatíte.',
      bezSplatekISporeni: 'Bez splátek, které do renty doplatíte, a bez dnešního spoření.',
      bezSporeni: 'Bez dnešního spoření.',
      chybiCil: 'V cílech chybí renta. Dnes utratíte {vydaje} měsíčně — tolik by renta měla uživit.',
      chybiCilSplatky: 'V cílech chybí renta. Dnes utratíte {vydaje} a splácíte {splatky} měsíčně — renta by měla uživit {potreba}.',
      doplnUrokHypoteky: 'U hypotéky doplňte úrok — pak spočítáme, jestli skončí před rentou.',
      doplnUrokUveru: 'U úvěru doplňte úrok — pak spočítáme, jestli skončí před rentou.',
      doplnZustatekHypoteky: 'U hypotéky doplňte zůstatek a úrok — pak spočítáme, jestli skončí před rentou.',
      doplnZustatekUveru: 'U úvěru doplňte zůstatek a úrok — pak spočítáme, jestli skončí před rentou.',
      nadpis: 'Cíl renty vs. výdaje',
      nesedi: 'Cíl renty je {zadano}, ale dnes utratíte {vydaje} měsíčně. Chybí {rozdil}.',
      nesediSplatky: 'Cíl renty je {zadano}, ale výdaje se splátkami jsou {potreba} měsíčně. Chybí {rozdil}.',
      odvozena: 'Cíl renty není zadaný — počítáme s dnešními výdaji a splátkami, bez splátek, které do renty doplatíte, a bez dnešního spoření.',
      sedi: 'Cíl renty {zadano} pokryje dnešní výdaje {vydaje}.',
      sediSplatky: 'Cíl renty {zadano} pokryje dnešní výdaje se splátkami {potreba}.',
    },
    rezerva: {
      doplnit: 'Doplníme nezbytné výdaje a spočítáme z nich rezervu.',
      nadpis: 'Likvidní rezerva',
      poRuce: 'Po ruce máte {likvidni}, tedy na {mesicu} měsíce.',
      poRuceBezMesicu: 'Po ruce máte {likvidni}.',
      pravidlo: 'Rezerva ({m}× nezbytné výdaje a splátky) je {potreba}.',
      vlastniCil: 'Váš cíl rezervy je {cil}.',
      vlastniCilPravidlo: 'Podle pravidla {m}× nezbytné výdaje a splátky by to bylo {potreba}.',
    },
    stav: {
      chybi: 'K řešení',
      info: 'Pro informaci',
      ok: 'Splněno',
      pozor: 'Nad limitem',
    },
    zivotni: {
      nadpis: 'Životní pojištění',
      platba: 'Za ochranu příjmu platíte {castka} měsíčně.',
      platbaPodil: 'Za ochranu příjmu platíte {castka} měsíčně, tedy {podil} % příjmu.',
    },
  },
  /* BLOK:analyzaCisla END */
  /* BLOK:analyzaStranka START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaStranka: {
    cesta: {
      orientacniKlient: 'Orientační model, ne garance.',
    },
    coBudeLabel: 'Body, které budou následovat',
    detiFew: '{n} děti',
    detiMany: '{n} dětí',
    detiOne: '{n} dítě',
    firmaNema: 'Klient firmu ani podnikání nemá',
    jmenoKlienta: 'Jméno (Klient {n})',
    kompletnostChybi: 'Pro přesný plán chybí: {seznam}.',
    mostek: '„Pokud vám finanční plán splní **tyto cíle**, bude to pro vás správné řešení?“',
    napoveda: {
      auto: 'Spoří se na rozdíl: cena dalšího auta mínus to, co utržíte za stávající. Až budete mít víc, cíl upravíme.',
      bydleni: '{prijem} čistého × 12 × {nasobek} = {castka} (strop ČNB). Reálně — z dnešního bydlení na podobné, ne palác.',
      bydleniBezRegulatora: 'Cena bydlení má odpovídat čistému příjmu domácnosti. Reálně — z dnešního bydlení na podobné, ne palác.',
      bydleniChybi: 'Férová cena bydlení ≈ {nasobek}× roční čistý příjem. Pro výpočet stropu chybí příjmy.',
      bydleniNad: 'Nad doporučením ČNB ({strop}) — hypotéka nemusí vyjít.',
      bydleniNadNbs: 'Úvěr {uver} je nad limitem NBS ({strop}) — banka ho dá jen výjimečně.',
      bydleniNadNbsVycerpano: 'Na nový úvěr {uver} z limitu NBS nic nezbývá — banka ho dá jen výjimečně.',
      bydleniNadNbsZbyva: 'Úvěr {uver} je víc, než z limitu NBS zbývá ({strop}) — banka ho dá jen výjimečně.',
      bydleniNbs: 'Limit NBS: všechny úvěry dohromady nejvýš {max}× roční čistý příjem = {limit}.',
      bydleniNbsBezDluhu: 'Počítáno bez ostatních úvěrů.',
      bydleniNbsChybiPrijem: 'Limit NBS se počítá jen z prokazatelného a ostatního příjmu klientů — doplňte je.',
      bydleniNbsDluhyChybi: 'Limit NBS platí pro všechny úvěry dohromady — doplňte zůstatky ostatních úvěrů.',
      bydleniNbsPravidlo: 'Limit NBS: všechny úvěry dohromady nejvýš {max}× roční čistý příjem.',
      bydleniNbsSDluhy: 'Limit NBS: všechny úvěry dohromady nejvýš {max}× roční čistý příjem = {limit}. Po odečtení ostatních úvěrů ({dluhy}) zbývá na nový úvěr {strop}.',
      bydleniNbsVek: 'Od 41 let je limit nižší, pokud úvěr končí po 65. roce věku — doplňte datum narození.',
      bydleniNbsVycerpano: 'Ostatní úvěry ({dluhy}) už vyčerpaly celý limit NBS ({max}× roční příjem).',
      bydleniOrientacni: 'Férová cena bydlení ≈ {nasobek} × 12 × {prijem} = {castka}.',
      bydleniPravidlo: 'Férová cena bydlení ≈ {nasobek}× roční čistý příjem.',
      doporucit: 'Doporučit {castka}',
      naHistorii: 'Na historii',
      naHistoriiTitul: 'Ukázat na reálných datech 1928–2025',
      orientacniPrijem: 'Orientačně čistý příjem domácnosti',
      ostatni: 'Co – kdy – kolik, v dnešních cenách.',
      renta: '{vydaje} výdaje + {splatky} splátky = {castka} měsíčně. Renta musí uživit tentýž život, jaký žijete dnes — ne jen to nutné.',
      rentaBezHypoteky: '{vydaje} výdaje + {splatky} splátky = {castka} měsíčně — hypotéku doplatíte do roku {rok}, v rentě není. Renta musí uživit tentýž život, jaký žijete dnes.',
      rentaBezHypotekyBezSplatek: '{vydaje} výdaje = {castka} měsíčně — hypotéku doplatíte do roku {rok}, v rentě není. Renta musí uživit tentýž život, jaký žijete dnes.',
      rentaBezSplatek: '{vydaje} výdaje = {castka} měsíčně. Renta musí uživit tentýž život, jaký žijete dnes — ne jen to nutné.',
      rentaChybi: 'Renta = celé dnešní výdaje včetně splátek a životního stylu. Pro výpočet chybí výdaje.',
      rentaNizka: 'Výdaje se splátkami jsou jen {pct} % příjmu — ve výdajích nejspíš něco chybí.',
      rentaVysoka: 'Výdaje se splátkami jsou {pct} % příjmu — převyšují příjem.',
      rezerva: '({nezbytne} nezbytné výdaje + {splatky} splátky) × {mesicu} = {castka}. Pásmo {min}–{castka} podle toho, jak jistý máte příjem.',
      rezervaBezSplatek: '{nezbytne} nezbytné výdaje × {mesicu} = {castka}. Pásmo {min}–{castka} podle toho, jak jistý máte příjem.',
      rezervaChybi: 'Rezerva = 3–6× nezbytné výdaje + splátky. Pro výpočet chybí nezbytné výdaje.',
      vzdelani: '{mesicne} měsíčně × {mesicu} měsíců × {let} = {castka}. Studium v ČR {od}–{do}, v zahraničí zhruba dvaapůlkrát tolik.',
      vzdelaniDeti: '{mesicne} měsíčně × {mesicu} měsíců × {let} × {deti} = {castka}. Studium v ČR {od}–{do}, v zahraničí zhruba dvaapůlkrát tolik.',
      vzdelaniJednoDite: '{mesicne} měsíčně × {mesicu} měsíců × {let} = {castka} na jedno dítě. Studium v ČR {od}–{do}, v zahraničí zhruba dvaapůlkrát tolik.',
      vzdelaniJinaMena: 'Studium dětí: měsíční náklady × měsíce v roce × roky studia. Studium v zahraničí vychází zhruba dvaapůlkrát dráž.',
    },
    penzijko: {
      dpsDip: '(DPS {dps} + DIP {dip})',
      jenDip: '(DIP — od první koruny)',
      jenDps: '(vklad nad {hranice} měsíčně)',
      nadLimit: 'nad roční strop {limit}: {castka} se neuplatní',
      odpocet: 'Daňově odpočitatelné',
      statni: 'Státní příspěvek (DPS)',
      zaMesic: '{castka}/měs',
      zaRok: '{castka}/rok',
    },
    prebytekSouhlas: '„Souhlasíte, že {castka} měsíčně můžeme použít pro vaše cíle?“',
    skript: {
      cas: 'Po telefonu jsme se domlouvali, že budeme mít **45 minut**. U mě se nic nezměnilo — jen chci ověřit, že také počítáte se 45 minutami.',
      cile: '„Podívejme se na strategické cíle ve struktuře **CO – KDY – KOLIK**. Co vás napadá jako první?“ Pokud klient nezmíní, ověřte **bydlení**, **vzdělání dětí** a **finanční nezávislost**.',
      ocekavani: '„Co očekáváte od dnešní schůzky?“ → zopakujte klientova slova a dodejte: „Mým cílem je ověřit, **co už děláte dobře**, **kde možná přicházíte o peníze** a **co můžete dělat lépe**.“',
      penize: '„Začnu netradiční otázkou: **Čím jsou pro vás peníze důležité?**“ → zopakujte slovo („svoboda… co znamená pro vás?“) a doptejte se: „Co dalšího vás napadne?“',
      pojistky: '„Jaké máte aktuálně **pojistné smlouvy** — životní, úrazové, majetkové, auto? U každé mě zajímá pojišťovna, číslo smlouvy, měsíční platba a výročí.“ Po uložení se smlouvy objeví ve složce klienta a jde z nich rovnou generovat výpověď.',
      prijmy: '„Dalším velmi důležitým zdrojem pro naplnění vašich cílů jsou **vaše příjmy**. Kolik máte měsíčně ze zaměstnání?“ (bonusy = průměr za 2–3 roky)',
      rizika: '„V rámci finančního plánu se podíváme i na vaše **zajištění**. Projdeme, co máte dnes — **co kryje a co ne**. Ověříme, jestli se dá **ušetřit** nebo pojistit chytřeji. A ukážu vám, jak bude zajištění vypadat v **celém plánu**: rodina, cíle, rezerva.“',
      vydaje: '„Kolik si myslíte, že jste schopni měsíčně **ušetřit**?“ — výdaje nepitvejte do detailu. Kontrola: výdaje ≈ požadovaná renta; příjmy − výdaje = volné cash flow.',
      zavazky: '„Důležitou informací pro naplnění cílů jsou **závazky**. Prvními jsou hypoteční úvěry — úvěry na bydlení, potom další.“',
      zaver: '„Napadá vás něco důležitého, na co jsem se zapomněl zeptat? {veta}“',
      zdroje: '„**Dalším zdrojem** pro naplnění vašich cílů jsou **peníze, které už máte**: stavební spoření, penzijko, investice, účty a majetek. Projdeme je spolu — začneme stavebním spořením. Využíváte ho?“',
    },
    smazatDite: 'Smazat dítě',
  },
  /* BLOK:analyzaStranka END */
  /* BLOK:kinoMetodika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoMetodika: {
    APPROVED: 'Z dat klienta',
    CANDIDATE: 'Čeká na schválení metodiky',
    PROVISIONAL: 'Pracovní tvrzení — bez doloženého zdroje',
  },
  /* BLOK:kinoMetodika END */
  /* BLOK:analyzaPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrijmy: {
    bonusy: 'Bonusy / 13. plat (ročně)',
    chybiJmeno: 'chybí jméno',
    domacnost: 'Společné pro domácnost',
    forma: 'Forma příjmu',
    jinaForma: 'zadáno dřív — patří k jiné formě, přesuňte nebo smažte',
    klient: 'Klient {n}',
    osobaCelkem: 'Příjem osoby za měsíc',
    pasivni: 'Pasivní příjmy (nájmy…)',
    pole: {
      davky: 'Důchod, rodičovská, dávky',
      mzdaFirma: 'Čistá mzda z vlastní firmy',
      ostatniJiny: 'Dohody, výživné a ostatní',
      osvcOstatni: 'Podnikání (OSVČ) a ostatní',
      podilyFirma: 'Podíly na zisku a ostatní',
      podnikani: 'Čistý příjem z podnikání',
      vedlejsiOsvc: 'Vedlejší příjmy (mzda, důchod, rodičovská)',
      vedlejsiZam: 'Vedlejší příjmy (dohody, výživné, živnost)',
      zamestnani: 'Čistý příjem ze zaměstnání',
    },
    poleKlient: '{pole} — klient {n}',
    prace: 'Co dělá za práci',
    pracePh: 'např. řidič, účetní, vlastní restaurace',
    pridatDruhou: 'Druhá osoba',
    pridatVedlejsi: 'Vedlejší příjem',
  },
  /* BLOK:analyzaPrijmy END */
  /* BLOK:prebytekModel START — generuje scratchpad/slovnik.py, ručně needitovat */
  prebytekModel: {
    mesicneProCile: 'Měsíčně pro cíle',
    neodsouhlaseno: 'zatím neodsouhlaseno klientem',
    planNespocita: 'Bez příjmů plán řešení nespočítá — doplňte příjmy nebo odsouhlasenou částku.',
    planPocita: 'Plán zatím počítá s {castka}',
    pravidloNula: 'Splátky úvěrů spotřebují celý příjem, takže ani 20 % příjmu plán nemá z čeho vzít. Doplňte v analýze výdaje, nebo částku, kterou jste si s klientem odsouhlasili.',
    zdrojDopocet: 'model: příjmy − výdaje − splátky',
    zdrojPravidlo: 'model: 20 % čistého příjmu',
  },
  /* BLOK:prebytekModel END */
  /* BLOK:vysvetleniInfo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vysvetleniInfo: {
    aria: 'Vysvětlení: {nazev}',
    cipVyberteOsobu: 'vyberte osobu u pojistky',
    jakCistPredAPo: 'Jak číst srovnání',
    jakSeCastkyPocitaji: 'Jak se částky počítají',
    rucniKratce: 'Ceny a částky přepíšete tužkou',
  },
  /* BLOK:vysvetleniInfo END */
  /* BLOK:cilDeti START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilDeti: {
    doAnalyzy: 'Doplnit v analýze',
    pridat: 'Přidat dítě',
    upozorneni: 'Máte cíl pro děti, ale žádné dítě není zapsané — doplňte ho (jméno, narození).',
  },
  /* BLOK:cilDeti END */
  /* BLOK:cilHned START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHned: {
    badgeNavrh: 'návrh',
    bezMesicniInvestice: 'bez měsíční investice',
    bezMesicniInvesticeVelke: 'Bez měsíční investice',
    brzdaChybi: 'Zbytek {chybi} dnešní zdroje nepokryjí — vybrat další zdroj, posunout termín, nebo dospořit z přebytku.',
    coSTim: 'Co s tím:',
    dalsiZdroj: 'další zdroj doplňte v analýze (účty, termínovaný vklad, stavební spoření)',
    doMesKDispozici: 'Do ~{mesicu} měs. k dispozici:',
    dosporeni: 'Dospoření z přebytku',
    dosporitNabidka: 'dospořit {castka} měsíčně po dobu {mesicu} měs.',
    hnedKDispozici: 'Hned k dispozici:',
    jakBezMesicni: 'Řešení: zatím bez měsíční investice.',
    jakDosporit: 'Řešení: {jedn} jednorázově ze zdrojů a {prav} měsíčně po dobu {mesicu} měs.',
    jakDosporitBezZdroju: 'Řešení: {prav} měsíčně po dobu {mesicu} měs.',
    krytoJenZeZdroju: 'cíl „hned“ se kryje jen z peněz, které klient má.',
    mesicu: 'měs.',
    nulaRespektovana: 'Bez měsíční investice — rozhodnutí poradce, návrh se nevrací.',
    odebratZdroj: 'Nebrat tento zdroj na tento cíl',
    poDobu: 'po dobu',
    poMesicich: 'Po {mesicu} měs. dospoření:',
    pocetMesicu: 'Počet měsíců',
    posunoutNaRok: 'posunout termín na 1 rok',
    povinnaRezerva: 'Povinná likvidní rezerva',
    prebytekNestaci: 'na dospoření není volný přebytek',
    pridatZdroj: 'Přidat zdroj:',
    rozdelovnikHned: 'Cíl „hned“ se kryje jen ze zdrojů — dospoření z přebytku se volí v kartě cíle v Návrhu řešení.',
    terminSankce: 'předčasný výběr může stát sankci',
    vychaziDoMes: '— ze zdrojů do ~{mesicu} měs.',
    vychaziHned: '— hned ze zdrojů.',
    vychaziSDosporenim: '— ze zdrojů a z dospoření.',
    vysledekChybi: 'Hned k dispozici {konec} — chybí {chybi} ({pct} % cíle).',
    vysledekChybiDoMes: 'Do ~{doMes} měs. k dispozici {konec} — chybí {chybi} ({pct} % cíle).',
    vysledekDosporitChybi: 'Hned {hned}, po {mesicu} měs. dospoření {konec} — chybí {chybi} ({pct} % cíle).',
    vysledekDosporitChybiDoMes: 'Do ~{doMes} měs. {hned}, po {mesicu} měs. dospoření {konec} — chybí {chybi} ({pct} % cíle).',
    vysledekDosporitOk: 'Hned {hned}, po {mesicu} měs. dospoření {konec} — cíl pokrytý na {pct} %.',
    vysledekDosporitOkDoMes: 'Do ~{doMes} měs. {hned}, po {mesicu} měs. dospoření {konec} — cíl pokrytý na {pct} %.',
    vysledekOk: 'Hned k dispozici {konec} — cíl pokrytý na {pct} %.',
    vysledekOkDoMes: 'Do ~{doMes} měs. k dispozici {konec} — cíl pokrytý na {pct} %.',
    zVasichPenez: 'z vašich peněz',
    zadneZdroje: 'Žádné — klient nemá okamžitě dostupné peníze.',
    zdrojTermin: 'Termínovaný vklad',
  },
  /* BLOK:cilHned END */
  /* BLOK:zdrojNazev START — generuje scratchpad/slovnik.py, ručně needitovat */
  zdrojNazev: {
    bezny: 'běžný účet',
    fondy: 'fondy a investiční životko',
    fondyRezerva: 'doplní se z fondů',
    fondyUzel: 'Fondy a investiční životko',
    fondyZbytek: 'zbytek po doplnění rezervy',
    hotovost: 'hotovost',
    penzijko: 'penzijko (DPS — dostupné v {vek})',
    sporici: 'spořicí účet',
    stavebko: 'stavební spoření',
    stavebkoZruseni: 'zrušení trvá ~{mesicu} měs.',
    termin: 'termínovaný vklad',
  },
  /* BLOK:zdrojNazev END */
  /* BLOK:navrhC9 START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhC9: {
    krokyUvodBezPlanu: 'Co udělat, v tomhle pořadí:',
  },
  /* BLOK:navrhC9 END */
  /* BLOK:metodikaPlanu START — generuje scratchpad/slovnik.py, ručně needitovat */
  metodikaPlanu: {
    bezZmeny: 'U tohoto klienta se čísla nezmění.',
    coJeJinak: 'Co je v nové metodice jinak:',
    coSeZmeni: 'Po přepočtu se u tohoto klienta změní:',
    coSeZmenilo: 'Přepočtem se u tohoto klienta změnilo:',
    dalsiCile: 'Další cíle:',
    dalsiZmeny: 'Další změny a co je v nové metodice jinak',
    mesicne: 'měsíčně',
    prepocitano: 'Přepočítáno podle nové metodiky.',
    prepocitat: 'Přepočítat podle nové metodiky',
    pruhStary: 'Plán je spočítaný podle metodiky před {datum}.',
    vraceno: 'Plán počítá zase podle metodiky před {datum}.',
    vratit: 'Vrátit původní výpočet',
    vratitTitulek: 'Vrátit jde, dokud neodejdete z Návrhu řešení.',
    zmenaAkontaceSK: 'Slovensko: akontace podle NBS — při koupi do konce roku 2026 jistých 80 % LTV, od roku 2027 stačí 10 % jen při prvním bydlení: každému žadateli nejvýš 35 let (druhý klient bez data narození podmínku nesplní), žádný byt ani dům k bydlení ani k pronájmu a žádná hypotéka v závazcích.',
    zmenaAkontaceVek: 'Akontace 10 % (výjimka pro mladé) se posuzuje podle věku v roce koupě (dnešní věk + roky do cíle), ne podle dnešního věku.',
    zmenaCilBezTerminu: 'Cíl bez termínu nedostane peníze z účtů ani měsíční částku — výstupy napíšou „doplňte termín“ a peníze zůstanou cílům s termínem.',
    zmenaCilHned: 'Cíl „hned“ (0 let) se kryje jen z peněz, které klient má — měsíční investici systém sám nepřidá, jen ji nabídne.',
    zmenaDosporeniStupne: 'Po dospoření rezervy za zvolený počet měsíců dostanou další cíle uvolněné peníze od konce dospoření — stupňovitě, ne nejmenší částku na celou dobu. Navýšení i rok, od kdy platí, se tiskne do Plného plánu a na 1 stranu.',
    zmenaFondyDoRenty: 'Podílové fondy, akcie a životko s hodnotou (odkupné), které klient už má, jdou do první renty — jen jednou, i když jsou renty dvě — a do jejího startu rostou podle profilu renty. Poradce je může v toku peněz poslat na jiný cíl. Dřív je plán nepřiřadil k žádnému cíli.',
    zmenaFondyDoRezervy: 'Když klientovi chybí rezerva a má podílové fondy, ETF nebo akcie, plán z nich nejdřív doplní chybějící část rezervy (jen tu, nikdy víc) a až zbytek fondů jde do renty. Investiční životko do rezervy nejde — odkupné je až po výpovědi smlouvy. Dřív šly všechny fondy do renty a rezerva čekala na dospoření z přebytku.',
    zmenaHrubaZCiste: 'Nemocenská (pracovní neschopnost) se počítá z hrubé mzdy dopočtené z čisté podle daní a pojistného 2026 (po pásmech), ne z čisté × 1,39. Výdělečný člověk mladší 22 let má na invalidní důchod nárok.',
    zmenaInvaliditaBezPrijmu: 'Rodič bez příjmu má krytí invalidity jen na o 20 % vyšší výdaje domácnosti mínus invalidní důchod, pokud na něj má nárok — stejně jako první i druhá osoba.',
    zmenaInvaliditaNikdoNevydelava: 'Když v domácnosti nikdo nevydělává, krytí invalidity se nepočítá a plán napíše „bez příjmu – krytí invalidity nepočítáme, doplňte příjem“.',
    zmenaInvaliditaNulaTisk: 'Rodič bez příjmu, kterému invalidní důchod pokryje o 20 % vyšší výdaje domácnosti, má v Plném plánu i na 1 straně u invalidity 0 Kč s důvodem (dřív „—“).',
    zmenaInvalidniDuchod: 'Invalidní důchod od státu: u osoby s příjmem průměr (v Česku 13 000 Kč měsíčně), poradce ho na kartě přepíše — ne výpočet ze mzdy. Bez nároku 0, bez příjmu zákonné minimum.',
    zmenaMajetekMzda: 'Odpovědnost zaměstnance se tiskne s limitem jen z hrubé mzdy, kterou poradce zadal nebo potvrdil — odhad z čisté mzdy zůstává poradci na obrazovce a v plánu stojí „limit po doplnění mzdy“. Cena pojištění majetku po změně pojistné částky do součtu ani do tisku nejde, dokud ji poradce znovu nepotvrdí.',
    zmenaMajetekNahrada: 'Stávající pojištění majetku (domácnost, nemovitost, odpovědnost) se v plánu uvolní, až když má nová majetková smlouva cenu od poradce — pak plán počítá výměnu celou: starou platbu uvolní a cenu nové odečte. Dřív se zrušení počítalo jako uvolněné peníze spolu s životní smlouvou, i když cena nové smlouvy chyběla.',
    zmenaMajetekSmlouvy: 'Pojištění majetku se v plánu tiskne po smlouvách a jen s cenou z nabídky pojišťovny; orientační odhad zůstává jen poradci na obrazovce.',
    zmenaMiraOdkladani: 'Míra odkládání v Návrhu, v rozpočtu plánu i v prezentaci je stejné číslo jako v analýze: odsouhlasená částka (bez ní volné peníze z příjmů a výdajů) plus pravidelné vklady na spoření a investice, děleno čistým příjmem. Dřív jen přebytek po pojistném děleno příjmem, bez vkladů.',
    zmenaOchranaNadPrebytek: 'Když je ochrana dražší než přebytek, chybějící částka je vidět v grafu „Cashflow v čase“, v nápisu o schodku, v rozpočtu plánu, v Průběžném přehledu, v prezentaci i ve Shrnutí. Dřív se pojistné ořízlo na výši přebytku a chybějící peníze se ztratily.',
    zmenaPartnerBezNarozeni: 'Partner bez data narození: jeho zajištění plán nespočítá (smrt, invalidita, nemoc, úraz ani cenu) a výstupy napíšou „nespočteno — chybí datum narození“. Jeho stávající smlouvy plán neruší. Dřív se krytí partnera počítalo i bez data narození.',
    zmenaDveCesty: 'Graf „Bez plánu a s plánem“ porovnává tytéž peníze plánu investované a na spořicím účtu, s pásmem horšího a lepšího scénáře a čarou po poplatcích; plán se schodkem graf nekreslí. Dřív graf investoval celý majetek bez výběrů na cíle.',
    zmenaAlokaceFichtner: 'Rozložení peněz cíle (akcie, dluhopisy, hotovost) se řídí tabulkou podle rizikového profilu a počtu let do cíle, ne plynulým odprodejem akcií. Poslední rok před cílem drží 97 % v hotovosti a 3 % v dluhopisech (u dynamického profilu 71 % a 29 %). Renta má před čerpáním podíl akcií podle profilu a let do začátku čerpání (vyvážený profil 15 a víc let 88 %), dřív se blížila 50 % akcií. Měsíční částky cílů se proto posunou: u konzervativního a vyváženého profilu krátké cíle mírně zdraží, renta u vyváženého a dynamického profilu vyjde levněji.',
    zmenaPenzijkoDoRenty: 'Penzijko se neruší: když renta začíná dřív než výplata penzijka (v Česku 60 let), renta do výplaty jde z ostatních peněz a od výplaty se zvýší o penzijko (4 % ročně z jeho hodnoty) — bez ztráty státních příspěvků. Dřív se penzijko vyplacené po začátku renty do renty nepočítalo vůbec.',
    zmenaPojistneMajetku: 'Cena nového pojištění majetku (domácnost, nemovitost, odpovědnost) od poradce patří mezi povinné platby a odečte se z přebytku celá, stejně jako životní pojištění. Zrušená stará majetková smlouva se dál vrací jako úspora. Dřív se odečítal jen rozdíl při výměně za zrušenou smlouvu.',
    zmenaNizsiVarianty: 'Varianty „Uskromnit se“ a „Řeším jen cenu“ snižují i pracovní neschopnost a závažná onemocnění: denní dávka kryje jen nezbytné výdaje a splátky (místo celého příjmu), závažná onemocnění klesnou stejným poměrem jako invalidita. Dřív zůstávaly jako u varianty „Pro náročné“.',
    zmenaPenzijkoJednou: 'Penzijko a jednorázový příjem bez určeného cíle dostane jen první renta v pořadí — dvě renty si už tutéž korunu nerozdají dvakrát.',
    zmenaPotrebaRenty: 'Renta bez zadaného cíle se počítá jako v analýze: dnešní výdaje bez vlastních vkladů na spoření plus splátky úvěrů, které poběží i v rentě. Hypotéka doplacená před rentou (podle data konce, jinak odhadem z jistiny, úroku a splátky) se nepočítá, ostatní úvěry zůstávají. Dřív renta = celé dnešní výdaje bez splátek.',
    zmenaProfilCile: 'Vlastní rizikový profil cíle platí i ve výpočtu — karta cíle i všechny výstupy ukazují u cíle stejné procento.',
    zmenaRenta13: 'Starý výpočet posílá rentě peníze až od 13. měsíce — první rok bere celý přebytek dorovnání rezervy.',
    zmenaRentaNavyseni: 'Navýšení renty z peněz uvolněných po splnění dřívějších cílů se tiskne do Plného plánu a na 1 stranu i s rokem, od kdy platí — jako u ostatních cílů.',
    zmenaRezervaJednoCislo: 'Rezerva má na celém plánu jedno číslo: cíl přesně podle vzorce z analýzy (bez zaokrouhlení po 10 000) a co klient má, kolik chybí a na kolik procent je naplněná, počítá jedna funkce — i se stavebním spořením, které dorazí do ~4 měsíců.',
    zmenaRucniCastka: 'Ručně zadaná měsíční částka u cíle platí i ve výpočtu — tiskne se do Plného plánu, na 1 stranu, do Shrnutí i prezentace a další cíle dostanou zbytek.',
    zmenaRucniNula: 'Smazaná měsíční částka u cíle platí i ve výpočtu — uvolněné peníze dostanou další cíle.',
    zmenaRustMzdySchodek: 'Když rodina dnes utratí víc, než vydělá, růst mzdy nejdřív pokryje tenhle schodek — cíle a splátka úvěru dostanou až to, co zbude. Dřív šel celý růst mzdy na cíle.',
    zmenaSkoreZajisteni: 'Skóre finančního zdraví nepočítá prázdné řádky majetkových rizik jako zadané zajištění — bez zadané částky se tahle složka skóre nepočítá (dřív 20 bodů za prázdnou šablonu).',
    zmenaSmrtBezMinima: 'Krytí smrti ve velké analýze jen kapitálovou metodou, bez minima (minimum jen v Analýze pro Vietnamce).',
    zmenaSpatneDluhy: 'Krok „Zbavit se špatných dluhů“ počítá jen úvěry v záložce Osobní úvěry — spotřebitelské úvěry, kreditky, kontokorenty, revolving, osobní leasing a starší řádky bez zvoleného druhu. Hypotéka ani úvěry v záložce Firemní úvěry mezi špatné dluhy nepatří.',
    zmenaSplatkaUveru: 'Po čerpání úvěru se splátka odečte z peněz pro ostatní cíle a rentu (u bydlení se přičte nájem z rozpisu výdajů, který koupí odpadne). Když splátka přesáhne rozpočet, plán napíše, od kdy a kolik chybí.',
    zmenaSrovnaniStejnyZaklad: 'Graf „bez plánu a s plánem“ v prezentaci začíná obě křivky ze stejného finančního majetku; nezapojený majetek roste stejně jako zapojený a inflace je 2,5 % z metodiky (dřív zelená začínala jen z peněz přidělených cílům a červená počítala 2,7 %).',
    zmenaUverSpotrebitelsky: 'Auto a další cíle na úvěr mimo bydlení počítají splátku spotřebitelského úvěru nebo úvěru ze stavebního spoření (splatnost nejvýš 12 let, orientační sazba), ne hypotéky na 30 let.',
    zmenaZajisteniVzdy: 'Zajištění příjmu plán řeší vždy — dřívější „Ne“ klienta z analýzy už pojistné z přebytku nevyřadí.',
    zmenaZamestnavatel: 'Příspěvek zaměstnavatele se počítá do odkládání i do příjmu: míra odkládání = (odsouhlasená částka nebo volné peníze + vlastní vklady + příspěvek zaměstnavatele) děleno (čistý příjem + příspěvek zaměstnavatele). Dřív jen do odkládání, takže míra vyšla o kus vyšší.',
    zmenaZdrojeHned: 'Rezerva i cíl s horizontem „hned“ (0 let) berou běžný účet, spořicí účet, hotovost, termínovaný vklad a stavební spoření (v tomto pořadí).',
  },
  /* BLOK:metodikaPlanu END */
  /* BLOK:prahyOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  prahyOdkladani: {
    flagPodMinimem: 'Odkládá ~{pct} % příjmů — minimum je {min} %, ideál {ideal} %',
    hladina: {
      ideal: 'ideál',
      minimum: 'minimum',
      pod: 'pod minimem',
      rychle: 'rychle k cílům',
    },
    novyCrm: {
      chybiDoMinima: 'Do minima {min} % chybí {castka} měsíčně',
      minimumDoIdealu: 'Minimum {min} % splněné · do ideálu {ideal} % chybí {castka}',
    },
    plan: {
      cileIdeal: 'CÍLE — ideál {ideal} %',
      pravidlo503020: 'Pravidlo 50/30/20: ~50 % nezbytné výdaje, 30 % životní styl, 20 % stranou na cíle a rentu. Minimum je {min} %, při {rychle} % se cíle plní hodně rychle. Detailní rozpis výdajů řešíme na servisní schůzce.',
    },
    rozpocet: {
      ideal: '✓ ideál {ideal} %',
      minimum: '✓ minimum {min} % · ideál {ideal} %',
      nezname: 'příjem neznáme · minimum {min} %',
      pod: '▲ pod minimem {min} %',
      rychle: '✓ {rychle} % a víc — cíle se plní rychle',
      vcVkladu: 'vč. vkladů {castka}',
    },
  },
  /* BLOK:prahyOdkladani END */
  /* BLOK:rozpisPanel START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisPanel: {
    hotovo: 'Hotovo',
    kicker: 'Detailní rozpis · položka po položce',
    prijmy: {
      nadpis: 'Příjmy domácnosti',
    },
    vydaje: {
      nadpis: 'Výdaje rodiny',
    },
    zavrit: 'Zavřít',
  },
  /* BLOK:rozpisPanel END */
  /* BLOK:planCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  /* BLOK:rustMzdyEfekt START — generuje scratchpad/slovnik.py, ručně needitovat */
  rustMzdyEfekt: {
    klikNedosahne: 'Po kliknutí na „{tlacitko}“ se renta nezmění — peníze z kroků bere jiný cíl nebo přijdou až po začátku renty.',
    klikUver: 'Po kliknutí na „{tlacitko}“ se renta nezmění — růst mzdy spolkne splátka úvěru: od r. {rok} na ni i s růstem mzdy chybí {chybi} měsíčně.',
    konec: '{horizont}: {bez} → {ted}',
    krokRocne: 'Krok = +{pct} % příjmu jednou za {obdobi} (≈ {rocne} % ročně).',
    nepocitaBezMesicni: 'Renta je bez měsíční investice — kroky růstu mzdy se do ní nepočítají.',
    nepocitaBezTerminu: 'Renta nemá termín — do rozdělení peněz se nepočítá, ani s růstem mzdy.',
    nepocitaHned: 'Renta s termínem hned se nezhodnocuje — růst mzdy ji nezmění.',
    nepocitaNedosahne: 'Růst mzdy, který je teď v plánu, na tuhle rentu nedosáhne — peníze z něj bere jiný cíl nebo přijdou až po začátku renty.',
    nepocitaRezim: 'Renta má zvolený režim řešení — kroky růstu mzdy se do ní nepočítají. Ať se počítají, klikněte u renty na „zpět na původní návrh“.',
    nepocitaSplneno: 'Renta vychází už bez růstu mzdy ({bez} %).',
    nepocitaUver: 'Růst mzdy, který je teď v plánu, do renty nedorazí — spolkne ho splátka úvěru: od r. {rok} na ni i s růstem mzdy chybí {chybi} měsíčně.',
    poHorizontu: 'Kroky od r. {roky} jsou až od začátku renty — do ní se nepočítají.',
    poKliku: 'Po kliknutí na „{tlacitko}“: renta z {pred} % na {po} %',
    poKlikuBezZmeny: 'Po kliknutí na „{tlacitko}“ se renta nezmění.',
    radekNepocita: 'v plánu ({n} kroků), do renty se ale nepočítají',
    toastNepocita: 'Předvyplněno {pocet} kroků růstu mzdy — renta se tím nezmění, proč, píše karta renty u řádku Růst mzdy.',
    toastPredvyplneno: 'Předvyplněno {pocet} kroků růstu mzdy — renta {pred} % → {po} %.',
    toastPredvyplnenoBezRenty: 'Předvyplněno {pocet} kroků růstu mzdy — uprav dle klienta.',
    toastPredvyplnenoVice: 'Předvyplněno {pocet} kroků růstu mzdy — {zmeny}.',
    toastUzVPlanu: 'Kroky růstu mzdy už v plánu jsou a odpovídají nastavení — nic se nemění. Renta s nimi počítá: {ted} % (bez nich {bez} %).',
    toastUzVPlanuBezCisel: 'Kroky růstu mzdy už v plánu jsou a odpovídají nastavení — nic se nemění.',
    toastUzVPlanuNepocita: 'Kroky růstu mzdy už v plánu jsou — nic se nemění. Do renty se ale nepočítají, proč, píše karta renty u řádku Růst mzdy.',
    toastUzVPlanuVice: 'Kroky růstu mzdy už v plánu jsou a odpovídají nastavení — nic se nemění. Bez nich → s nimi: {renty}.',
    vPlanu: 'Růst mzdy v plánu zvedá rentu z {bez} % na {ted} %',
  },
  /* BLOK:rustMzdyEfekt END */
  planCil: {
    akontaceDo2026: 'Při koupi v roce {rok} platí na Slovensku jistých 80 % úvěru (20 % vlastních zdrojů) — věk ani první bydlení nerozhodují.',
    akontaceK2BezVeku: 'Druhý klient nemá datum narození — 10 % musí splnit každý žadatel, proto počítáme 20 %. Doplňte datum narození v analýze.',
    akontaceNemovitost: 'Klient má v analýze byt nebo dům (k bydlení i k pronájmu) nebo splácí hypotéku — 10 % stačí na Slovensku od roku 2027 jen při prvním bydlení, proto 20 %.',
    doplnenoAutomaticky: 'doplněno automaticky',
    jakJednZatim: 'Řešení: {jedn} jednorázově, měsíčně zatím nic navíc.',
    jakZatimNic: 'Řešení: měsíčně zatím nic navíc.',
    krokNavyseni: 'Od {mesic}. měsíce (r. {rok}) navýšit o {o} na {celkem} měsíčně.',
    krokRadek: 'od r. {rok} +{o}',
    krokZacatek: 'Od {mesic}. měsíce (r. {rok}) posílat {celkem} měsíčně.',
    nbsAkontace2027: 'NBS: při koupi do konce roku 2026 jistých 80 % (20 % vlastních zdrojů), 90 % jen v kvótě banky. Od roku 2027 stačí 10 % jen při prvním bydlení do 35 let bez jiné nemovitosti k bydlení ani k pronájmu. 100% financování je rozhodnutí poradce — 10 % ceny kryje úvěr ze stavebního spoření. Splátka se v cashflow projeví až od čerpání úvěru',
    profilMimoVypocet: 'Výpočet i tisk zatím počítají s profilem plánu — vlastní profil cíle se projeví po přepočtu podle nové metodiky.',
    rucniMimoVypocet: 'Výpočet i tisk zatím počítají s {castka} — ruční částka se projeví po přepočtu podle nové metodiky.',
    varianta100: '100% financování',
    variantaAkontace: 'Akontace {pct} %',
    vekVRoceKoupe: 'V roce koupě ({rok}) bude klientovi {vek} let — podle toho se posuzuje akontace 10 %.',
    vekVRoceKoupeK2: 'V roce koupě ({rok}) bude klientovi {vek} let a druhému klientovi {vek2} let — 10 % stačí jen, když je oběma nejvýš 35 let.',
    vyrazenBezTerminu: 'Bez termínu se cíl do rozdělení peněz nepočítá — doplňte termín.',
  },
  /* BLOK:planCil END */
  /* BLOK:kinoOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoOdkladani: {
    a1: {
      aria: 'Jednotlivé výdaje nerozebíráme, hlídáme jen částku stranou',
      kicker: 'Výdaje',
      radek1: 'Výdaje do detailu nerozebíráme.',
      radek2: 'Hlídáme jedno číslo: kolik jde stranou.',
      stranou: 'Stranou',
      stranouPopis: 'jediné číslo, které hlídáme',
      tahak: '„Nebudeme počítat každou korunu. Stačí mi jedno číslo — kolik vám každý měsíc zůstane stranou.“',
      titulek: 'Nejde o každou korunu',
      velkePopis: 'Čistý příjem domácnosti',
    },
    a2: {
      aria: 'Tři hladiny odkládání',
      dnes: 'Dnes odkládáte {pct} %.',
      dnesDohoda: 'S odsouhlasenou částkou jde stranou {pct} %.',
      kicker: 'Kolik stranou',
      radek: 'Při {rychle} % se cíle plní hodně rychle.',
      tahak: '„Deset procent je minimum. Dvacet je ideál. Třicet — a cíle se plní hodně rychle.“',
      titulek: '{min} % minimum, {ideal} % ideál',
      velkePopis: '{pct} % z {prijem}',
    },
    a3: {
      aria: 'Při {pct} % ({castka} měsíčně) naroste za 30 let modelově {fv}, z toho vloženo {vlozeno}.',
      kicker: 'Vaše číslo',
      nejistota: 'Modelace podle profilu plánu ({profil}), v dnešních penězích, bez poplatků a daní. Výnos není jistý — může být vyšší i nižší.',
      radekCas: 'Zbytek dělá čas — modelace, ne slib.',
      radekNula: 'Bez odkládání nenaroste nic.',
      radekVlozite: 'Vložíte {castka}.',
      tahak: '„Tohle je modelace, ne slib. Ale ukazuje, co udělá čas a pravidelnost.“',
      titulek: 'Kolik z toho naroste',
      velkePopis: 'za 30 let · modelace',
      vlozeno: 'vloženo',
      vynos: 'výnos',
    },
    a4: {
      aria: 'Při {pct} %: {popis}.',
      cilBezNazvu: 'Cíl',
      cilRenta: 'Renta',
      cilRezerva: 'Rezerva',
      dalsiCile: '+ další cíle: {n}, z toho k termínu {splneno}',
      dnes: 'dnes',
      hned: 'hned',
      kTerminu: 'k termínu jen {pct} %',
      kTerminuSplneno: 'k termínu',
      kicker: 'Vaše cíle',
      nejistota: 'Stejný výpočet jako Návrh řešení: výnos podle profilu plánu, pořadí cílů podle plánu. Modelace, ne slib.',
      radekHladina: '{pct} % → {n} z {celkem} cílů k termínu',
      radekHladinaVse: '{pct} % → všechny cíle k termínu ✓',
      rezervaZUspor: 'z úspor teď {pct} %',
      tahak: '„Podívejte, jak se s procentem posouvá, kdy máte rezervu, bydlení i rentu.“',
      titulek: 'Co se splní a kdy',
      velke: '{n} z {celkem}',
      velkePopis: 'cílů splníte k termínu',
    },
    a5: {
      aria: 'Z výplaty {prijem} jde den po výplatě {stranou} stranou, {zivot} zbývá na život.',
      denPo: 'den po výplatě',
      kicker: 'Začněte',
      naZivot: 'Na život',
      radek: 'Co zbude, utratíte s klidem.',
      stranou: 'Stranou',
      tahak: '„Nejlíp to funguje automaticky — trvalý příkaz den po výplatě a dál to neřešíte.“',
      titulek: 'Nejdřív sobě, pak účtům',
      velkePopis: 'trvalým příkazem den po výplatě',
      vyplata: 'Výplata',
    },
    doplnPrijmy: 'Doplňte příjmy a spočítáme to',
    jezdec: {
      aria: 'Kolik procent příjmu odkládat',
      dnes: 'dnes',
      mesicne: 'měsíčně',
      odkladate: 'Odkládáte',
      valuetext: '{pct} %, {castka} měsíčně',
    },
    nazev: 'Výdaje a odkládání',
    prezTlacitko: 'Spustit kino: Výdaje a odkládání',
    prijmy: {
      a2Tahak: '„Osvědčené pravidlo: polovina na nezbytnosti, třetina na život a pětina stranou na budoucnost. Minimum je desetina.“',
      a3BezVydaju: 'Doplňte výdaje a spočítáme, kolik reálně odkládáte.',
      a3Ideal: 'Teď odkládáte ~{pct} % — to je ideál. ✓',
      a3Minimum: 'Teď odkládáte ~{pct} % — minimum máte, do ideálu {ideal} % chybí {chybi} měsíčně.',
      a3Pod: 'Teď odkládáte ~{pct} % — do minima {min} % chybí {chybi} měsíčně.',
      a3Rychle: 'Teď odkládáte ~{pct} % — cíle se splní hodně rychle. ✓',
      a3Tahak: '„Výdaje rozepíšeme do detailu až na servisní schůzce. Teď je klíčové jediné — aby šlo stranou aspoň deset procent, ideálně dvacet.“',
      a3VelkePopis: 'Ideálně tolik měsíčně stranou',
      a6Radek3: 'Minimum je {min} %, ideál {ideal} % — hlavně začít.',
    },
    profil: {
      dynamicky: 'dynamický',
      konzervativni: 'konzervativní',
      vychozi: '{profil}, výchozí',
      vyvazeny: 'vyvážený',
    },
    rokyFew: '{n} roky',
    rokyMany: '{n} let',
    rokyOne: '{n} rok',
    tlacitko: 'Kino odkládání',
    tlacitkoTitle: 'Přehrát kino: Výdaje a odkládání',
    utraty: {
      bydleni: 'Bydlení',
      deti: 'Děti',
      doprava: 'Doprava',
      dovolena: 'Dovolená',
      energie: 'Energie',
      jidlo: 'Jídlo',
      obleceni: 'Oblečení',
      restaurace: 'Restaurace',
    },
    zaRokyFew: 'za {n} roky',
    zaRokyMany: 'za {n} let',
    zaRokyOne: 'za {n} rok',
  },
  /* BLOK:kinoOdkladani END */
  /* BLOK:vodopad START — generuje scratchpad/slovnik.py, ručně needitovat */
  vodopad: {
    coKdyby: {
      naBudoucnost: 'Na budoucnost',
      presah: 'O {castka} víc, než zbývá — muselo by se ubrat z výdajů na život.',
      prijmu: 'příjmu',
      startDnes: 'dnes',
      startDohoda: 'dohoda',
      tlacitko: 'Co kdyby šlo na budoucnost víc',
      valuetext: '{pct} % příjmu, {castka} měsíčně',
      zVolnych: 'Z volných peněz',
      zbyva: 'Zbývá volně',
      zpetDnes: 'Zpět na dnešek',
      zpetDohoda: 'Zpět na dohodu',
    },
    grafSelhal: 'Graf se nepodařilo vykreslit — čísla jsou v přehledu.',
    klikRadek: 'Klik na řádek = položky',
    klikSloupec: 'Klik na sloupec = položky',
    majetek: {
      celkem: '= Majetek celkem',
      celkemPod: 'součet obou',
      ciste: '= Čisté jmění',
      cistePod: 'patří rodině',
      cisteZapPod: 'dluh převyšuje majetek',
      dedictvi: 'Dědictví',
      fin: '+ Finanční',
      finPod: 'spoření, investice, účty',
      kat: {
        dedictvi: 'Dědictví',
        firma: 'Firma / podnikání',
        kzp: 'Kapitálové životní pojištění',
        nemovitosti: 'Nemovitost',
        opf: 'Fondy a ETF',
        penzijko: 'Penzijní spoření',
        stavebko: 'Stavební spoření',
        ucty: 'Účet',
        zavazkyB: 'Úvěr na bydlení',
        zavazkyO: 'Úvěr',
      },
      nadpis: 'Souhrn majetku',
      nefin: 'Nefinanční',
      nepocita: 'zatím se nepočítá',
      podily: '{rodina} % majetku patří rodině, {banka} % bance.',
      pointa: 'Po odečtení dluhů vám z majetku zůstává {castka}.',
      pointaBezJistiny: 'U dluhů chybí zůstatek jistiny — o kolik snižují majetek, zatím nevíme.',
      pointaBezZavazku: 'Majetek celkem {castka} — závazky zatím nejsou zadané.',
      pointaPrazdne: 'Majetek ani závazky zatím nejsou zadané.',
      pointaZaporne: 'Dluhy převyšují majetek o {castka}.',
      zavazky: '− Závazky',
      zavazkyPod: 'zůstatky jistin úvěrů',
    },
    navic: 'Položky dávají o {castka} víc než sloupec',
    nerozepsano: 'Bez rozpisu po položkách',
    penize: {
      bonusy: 'Bonusy (měsíčně)',
      chybiPrijmy: 'Doplňte příjmy — bez nich se volné peníze netvrdí.',
      chybiVydaje: 'Doplňte výdaje — bez nich se volné peníze netvrdí.',
      dilNaBudoucnost: 'na budoucnost {castka}',
      dilPrebytek: 'přebytek {castka}',
      dilZbyva: 'zbývá {castka}',
      hrdina: 'Volné peníze',
      hrdinaSchodek: 'Schodek',
      jdeVam: 'jde vám',
      jenUkazka: 'Jen ukázka — do plánu se nepropisuje.',
      kazdyMesic: 'každý měsíc',
      kicker: 'Příjmy a výdaje · měsíčně',
      klient: 'Klient {n}',
      mesicne: 'měsíčně',
      nadVolneCastka: 'nad volné {castka}',
      nezadano: 'nezadáno',
      nezbytne: '− Nezbytné výdaje',
      nezbytnePod: 'bydlení, jídlo, doprava',
      nezbytnePrehled: 'Nezbytné výdaje',
      odkladDnes: 'Stranou dnes jde {castka} = {pct} % příjmu (vklady {vklady} + volné peníze {volne}).',
      odkladDohoda: 'Stranou jde {castka} = {pct} % příjmu (vklady {vklady} + odsouhlasená částka {dohoda}).',
      ostatni: '− Ostatní výdaje',
      ostatniPod: 'volný čas, dovolená, spoření',
      ostatniPrehled: 'Ostatní výdaje',
      pasivni: 'Pasivní příjmy',
      pointa: 'Z {prijmy} příjmu vám po výdajích a splátkách zbývá {volne}.',
      pointaSchodek: 'Výdaje a splátky jsou o {castka} vyšší než příjmy.',
      pokryto: 'Vklady, které už běží ({castka}), cíl pokryjí — z volných peněz nic navíc.',
      posuvnikNeni: 'Teď není z čeho odkládat: měsíčně chybí {castka}. Nejdřív vyrovnat výdaje.',
      prehrat: 'Přehrát znovu',
      prijmy: 'Příjmy',
      prijmyPod: 'čisté, za domácnost',
      prijmyPrehled: 'Příjmy',
      schodek: '= Schodek',
      schodekPod: 'chybí každý měsíc',
      schodekPrehled: 'Schodek',
      splatky: '− Splátky',
      splatkyPod: 'úvěry',
      splatkyPrehled: 'Splátky',
      sporeni: 'Spoření, které už běží',
      sporeniNesedi: 'spoření nesedí',
      sporeniProuzek: 'z toho spoření {castka}',
      stranouDnes: 'stranou dnes jde {pct} % příjmu',
      stranouDohoda: 's odsouhlasenou částkou jde stranou {pct} % příjmu',
      volne: '= Volné peníze',
      volnePod: 'zbývá vám',
      volnePrehled: 'Volné peníze',
      vydaje: '− Výdaje',
      vydajePod: 'nezbytné zatím nezadané',
      vydajePrehled: 'Výdaje',
      zivotniStyl: 'Životní styl',
    },
    prehled: 'Přehled',
    rozkliknuto: 'Rozkliknuto',
    sedi: 'Součet položek sedí: {castka}',
    stovka: {
      kopieChyba: 'Větu se nepodařilo zkopírovat.',
      kopirovano: 'Zkopírováno',
      kopirovat: 'Zkopírovat',
      mesicne: '{castka} měsíčně',
      nadpis: 'Ze 100 {sym} příjmu',
      nazev: {
        budoucnost: 'Budoucnost',
        povinne: 'Povinné',
        vydaje: 'Výdaje a splátky',
        zbyva: 'Zbývá',
        zivot: 'Život',
      },
      nesedi: {
        dohoda: 'Odsouhlasená částka {castka} je o {nad} vyšší než volné peníze, a to je víc, než zbývá na život. Zkontrolujte dohodu.',
        sporeniOstatni: 'Spoření {castka} měsíčně je vyšší než ostatní výdaje {ostatni}. Zkontrolujte, jestli je spoření zapsané ve výdajích.',
        sporeniVydaje: 'Spoření {castka} měsíčně je vyšší než výdaje {ostatni}. Zkontrolujte, jestli je spoření zapsané ve výdajích.',
        titul: 'Stovku zatím nejde rozdělit.',
        ukazka: 'Tolik na budoucnost nejde — nestačily by ani všechny výdaje na život.',
      },
      podNadPrijem: '{pct} nad příjem',
      podNadVolne: '{pct} nad volné peníze',
      podPrijem: 'příjem',
      podZbyva: 'zbývá {pct}',
      pravidlo: 'Pravidlo: povinné 50–60 · budoucnost aspoň 20 · zbytek na život',
      schodekPozn: '{pct} nad příjem · měsíčně chybí {castka}',
      slozeni: {
        nadVolne: 'nad volné {castka}',
        nezbytne: 'nezbytné {castka}',
        nic: 'zatím nic',
        prebytek: 'přebytek {castka}',
        schodek: 'spoření se teď platí z dluhu nebo z úspor',
        splatky: 'splátky {castka}',
        sporeni: 'spoření {castka}',
        volne: 'volné peníze {castka} (zatím bez dohody)',
        vydajeBez: 'výdaje bez spoření {castka}',
        zVolnych: 'z volných peněz {castka}',
        zamestnavatel: 'od zaměstnavatele {castka}',
        zivot: 'ostatní výdaje bez spoření',
        zivotSchodek: 'ostatní výdaje vč. spoření {castka}',
      },
      stav: {
        bezDohodyLatka: '{latka}, pokud se odloží všechno volné',
        bezDohodyPod: 'pod 10 i se vším volným',
        idealSplneno: 'aspoň 20 splněno',
        latkaIdeal: 'aspoň 20',
        latkaMinimum: 'minimum 10',
        minimumSplneno: 'minimum 10 splněno · do 20 chybí {castka}',
        nadVolneLatka: '{latka} jen když se ze života ubere {castka}',
        nadVolnePod: 'pod 10 i s ubráním ze života',
        neniZCeho: 'teď není z čeho',
        nezbytneNezadane: 'nezbytné nezadané',
        pod: 'pod 10 · do 10 chybí {castka}',
        povinneNad: 'nad doporučených 60 o {n}',
        povinnePod: 'pod 50',
        povinneV: 'v doporučených 50–60',
        zivotMene: 'o {castka} méně než dnes',
      },
      ukazka: 'ukázka',
      veta: {
        bezDohody: '{zac} a zbylých {b} můžete dát stranou na budoucnost.',
        bud: '{zac}, {b} dáte stranou na svou budoucnost.',
        budZbyvaFew: '{zac}, {b} dáte stranou na svou budoucnost a {zb} vám zatím zbývají.',
        budZbyvaMany: '{zac}, {b} dáte stranou na svou budoucnost a {zb} vám zatím zbývá.',
        budZbyvaOne: '{zac}, {b} dáte stranou na svou budoucnost a {zb} vám zatím zbývá.',
        domluvime: 'Kolik z volných peněz opravdu odložíte, se teď domluvíme.',
        konecDobre: 'obojí máte, takže jste na tom dobře.',
        konecDobreBez: 'aspoň 20 na budoucnost máte, takže jste na tom dobře.',
        konecMinimum: 'minimum 10 máte, do ideálních 20 chybí {castka} měsíčně.',
        konecMinimumZbytek: 'minimum 10 máte a do ideálních 20 chybí {castka} měsíčně, ty ze zbytku pokryjete.',
        konecNadVolne: '{latka} tím splníte, jen budete na život dávat o {castka} měsíčně méně než dnes.',
        konecNadVolnePod: 'i tak jste pod 10 a na život budete dávat o {castka} měsíčně méně než dnes.',
        konecPod: 'teď jste pod 10, tak pojďme najít {castka} měsíčně.',
        konecPodZbytek: 'teď jste pod 10, chybí {castka} měsíčně, a ty ze zbytku pokryjete.',
        konecPovinnePod: 'povinné máte dokonce pod 50 a budoucnost nad 20, takže jste na tom dobře.',
        pravidlo: 'Doporučuji 50 až 60 na povinné a aspoň 20 na budoucnost, zbytek na život',
        pravidloNad: 'Doporučuji nejvýš 60 na povinné a aspoň 20 na budoucnost, zbytek na život — povinné teď berou víc, proto na budoucnost zbývá jen {b}.',
        schodek: 'Z každých 100 {sym}, které vyděláte, dnes utratíte {celkem} — každý měsíc chybí {castka}, takže nejdřív spolu srovnáme výdaje.',
        zac: 'Z každých 100 {sym}, které vyděláte, jde {povinne} na to, co platit musíte, {zivot} na život',
        zacBez: 'Z každých 100 {sym}, které vyděláte, jde {vydaje} na výdaje a splátky',
      },
      vetaTitul: 'Věta pro klienta',
      zbyvaPozn: '{castka} měsíčně, zatím nerozdělené',
      znackaBudoucnost: 'budoucnost 20+',
      znackaPovinne: 'povinné 50–60',
    },
    zadnePolozky: 'Položky zatím nejsou rozepsané.',
    zpetAria: 'Zpět na přehled',
  },
  /* BLOK:vodopad END */
  /* BLOK:majetekSmlouvy START — generuje scratchpad/slovnik.py, ručně needitovat */
  majetekSmlouvy: {
    bezMzdaPozn: 'V analýze není příjem ze zaměstnání. Mzdu zadejte, jen když má zaměstnavatele.',
    castkaSeZmenila: 'pojistná částka se změnila — ověřte cenu',
    cenaNecitelna: 'Cenu zapište jako číslo, třeba 420.',
    cenaPlati: 'Cena platí',
    cenaPoNabidce: 'cena po nabídce pojišťovny',
    cenaSmlouvy: 'Cena smlouvy',
    cenaZNabidky: 'Cena z nabídky',
    chybiCenaFew: 'chybí cena u {n} smluv',
    chybiCenaMany: 'chybí cena u {n} smluv',
    chybiCenaOne: 'chybí cena u {n} smlouvy',
    cipLimit: 'limit {limit}',
    cipNenabizet: 'nenabízet',
    cipPripojisteni: 'připojištění',
    coKryje_domacnost: 'Věci doma.',
    coKryje_dum: 'Dům — samotnou stavbu.',
    coKryje_dumDomacnost: 'Dům a věci uvnitř.',
    coKryje_dumOdpovednost: 'Dům a škodu, kterou nechtěně způsobíte jiným.',
    coKryje_majetek: 'Věci doma a škodu, kterou nechtěně způsobíte jiným.',
    coKryje_majetekDum: 'Dům, věci uvnitř a škodu, kterou nechtěně způsobíte jiným.',
    coKryje_odpovednost: 'Škodu, kterou nechtěně způsobíte jiným.',
    coKryje_podnik: 'Firmu, zásoby, vybavení a škody zákazníkům.',
    coKryje_pravni: 'Právníka a soud, když dojde na spor.',
    coKryje_zam: 'Škodu, kterou z nedbalosti způsobíte v práci.',
    doplnteCenu: 'Doplňte cenu z pojišťovny',
    infoMajetek: 'Jedna smlouva, jedna cena z nabídky pojišťovny.',
    infoVlastni: 'Samostatná smlouva — položka je sjednaná zvlášť (jiná pojišťovna nebo jiný produkt), proto má vlastní cenu.',
    infoZamJedna: 'Jedna, nebo dvě smlouvy? Podle nabídky pojišťovny: jedno číslo smlouvy a jedna cena = jedna smlouva. Dvě ceny = každý svou. Limit má každý zvlášť podle své hrubé mzdy.',
    kazdaSvouCenu: 'každá má svou cenu',
    kinoBezCenFew: 'bez {n} smluv, cena přijde z nabídky',
    kinoBezCenMany: 'bez {n} smluv, cena přijde z nabídky',
    kinoBezCenOne: 'bez {n} smlouvy, cena přijde z nabídky',
    kinoBezKraceni: 'Na plnou hodnotu — bez krácení',
    kinoBlok: '1 blok = hrubá mzda {mzda}',
    kinoBlokyAria: '{nasobek} krát hrubá mzda {mzda} je nejméně {limit}',
    kinoCelkem: 'Celkem',
    kinoCenuDoplnime: 'cenu doplníme z nabídky',
    kinoChybiHodnota: 'Částky doplníme, až bude známá hodnota — zatím v procentech škody.',
    kinoCyklista: 'Na kole nechtěně srazíte jiného cyklistu',
    kinoDalsi: 'Další',
    kinoHotovo: 'Hotovo',
    kinoJezdecPct: '{pct} procent hodnoty',
    kinoJezdecText: '{castka}, {pct} procent hodnoty',
    kinoKraceni: 'Pojišťovna krátí na {pct} % každé škody',
    kinoKrok: 'Vysvětlení pro klienta · {i} z {n}',
    kinoMisto_doma: 'doma',
    kinoMisto_firma: 've firmě',
    kinoMisto_prace: 'v práci',
    kinoMisto_spor: 'u sporu',
    kinoNazev_odpovednost: 'Proč odpovědnost s vysokým limitem',
    kinoNazev_plna: 'Proč pojistit na plnou hodnotu',
    kinoNazev_prace: 'Odpovědnost v práci',
    kinoNazev_shrnuti: 'Co sjednáme',
    kinoNazev_smlouvy: 'Co kryje která smlouva',
    kinoOdpPozn: 'Ilustrace bez částek. Vytopený soused nebo rozbité zboží v obchodě patří sem taky. Autem? To kryje povinné ručení, ne tahle smlouva.',
    kinoOdpVeta: 'Škodu na zdraví platí ten, kdo ji způsobil. Nejde o jednu fakturu — některé položky se platí roky.',
    kinoOsa1: '1 rok',
    kinoOsa10: '10 let',
    kinoOsa20: '20 let +',
    kinoOsaAria: 'Ilustrace bez částek: léčení a bolest se platí hned, péče i roky, ztráta na výdělku každý měsíc i desítky let.',
    kinoOsaBolest: 'Bolest a ztížení uplatnění',
    kinoOsaLecba: 'Náklady léčení',
    kinoOsaNehoda: 'nehoda',
    kinoOsaPece: 'Péče o zraněného',
    kinoOsaVydelek: 'Ztráta na výdělku — každý měsíc',
    kinoOsobaMzda: '{jmeno} · {mzda}',
    kinoOsobaPodnika: '{jmeno} · podniká, netýká se',
    kinoPlnaDum: 'Postavit dům znovu by stálo {castka}',
    kinoPlnaDumBez: 'Dům · cenu postavení znovu doplníme',
    kinoPlnaVeta: 'Když je pojistná částka nižší, než by stálo pořízení znovu, pojišťovna krátí každou škodu ve stejném poměru — i tu malou.',
    kinoPlnaVybaveni: 'Pořídit vybavení znovu by stálo {castka}',
    kinoPlnaVybaveniBez: 'Vybavení · hodnotu doplníme',
    kinoPlnaVyska: 'plná výška = celá hodnota',
    kinoPojistenoCastka: '{castka} ({pct} %)',
    kinoPojistenoNa: 'Pojištěno na',
    kinoPojistenoPct: '{pct} % hodnoty',
    kinoPojistovna: 'Pojišťovna',
    kinoPoznPodpojisteni: 'Ilustrace podle obecného pravidla podpojištění, bez spoluúčasti. Konkrétní smlouva může být sjednaná jinak.',
    kinoPoznPodpojisteniCZ: 'Ilustrace podle obecného pravidla podpojištění (§ 2854 občanského zákoníku), bez spoluúčasti. Konkrétní smlouva může být sjednaná jinak.',
    kinoPraceKde: '{jmeno} · hrubá mzda {mzda}',
    kinoPraceSmlouva: 'Na to je smlouva s limitem {nasobek}× mzdy. Rozsah a výluky určí pojišťovna.',
    kinoPraceVeta: 'Z nedbalosti poškodí stroj nebo zařízení, se kterým pracuje. Zaměstnavatel smí chtít náhradu. U nedbalosti ji zákon omezuje na {nasobek}násobek průměrného měsíčního výdělku.',
    kinoPraceVyjimky: 'Strop neplatí u škody způsobené úmyslně, v opilosti nebo po návykových látkách, ani u schodku a ztráty svěřených věcí — tam se hradí celá škoda. Předpis: {predpis}.',
    kinoProtoLimit: 'Proto limit v milionech:',
    kinoShrnPozn: 'Částky jsou návrh krytí, ne nabídka. Cenu, rozsah plnění a výluky určí pojišťovna ve smlouvě.',
    kinoSkoda: 'Škoda',
    kinoStropNejmene: 'Zákonný strop z nedbalosti nejméně',
    kinoStropPozn: '— počítá se z průměrného výdělku, s prémiemi vychází víc.',
    kinoTeckaAria: 'Krok {i}: {nazev}',
    kinoVetaJedna: '{mista} to řeší jedna smlouva s jednou cenou.',
    kinoVetaKazde: '{mista} — každé řeší jiná smlouva. Každá má svou cenu.',
    kinoVetaVicFew: '{mista} — {n} smlouvy, každá má svou cenu.',
    kinoVetaVicMany: '{mista} — {n} smluv, každá má svou cenu.',
    kinoVetaVicOne: '{mista} — {n} smlouva, každá má svou cenu.',
    kinoVetaZadna: 'Zatím jsme nevybrali žádnou smlouvu.',
    kinoZavrit: 'Zavřít vysvětlení',
    kinoZeSveho: 'Ze svého',
    kinoZpet: 'Zpět',
    kratceOdpovednost: 'Odpovědnost',
    kratcePodnik: 'Firma a provoz',
    kratceVybaveni: 'Vybavení',
    krytiNemovitostChybi: 'nemovitost — hodnota po doplnění',
    krytiPolozka: '{nazev} {castka}',
    krytiZam: 'limit {limit}',
    krytiZamChybi: 'limit po doplnění mzdy',
    krytiZamChybiOsoba: '{jmeno} — limit po doplnění mzdy',
    krytiZamOsoba: '{jmeno} — limit {limit}',
    limitDoplnte: 'doplňte mzdu',
    limitNetyka: 'netýká se',
    mzdaOdZamestnavatele: 'Mzda od zaměstnavatele — {jmeno}',
    mzdaOsoby: 'Hrubá mzda — {jmeno}',
    mzdaPlati: 'Mzda platí',
    mzdaPlatiAria: 'Hrubá mzda {jmeno} {mzda} platí',
    nabidnoutV: 'Nabídnout',
    nabizetV: 'Nabízet',
    nazevDomacnost: 'Domácnost',
    nazevDomacnostOdpovednost: 'Domácnost a odpovědnost',
    nazevMajetek: 'Majetek',
    nazevMajetekDomacnost: 'Majetek a domácnost',
    nazevNemovitost: 'Nemovitost',
    nazevNemovitostOdpovednost: 'Nemovitost a odpovědnost',
    nazevOdpovednost: 'Odpovědnost občanská',
    nazevPodnik: 'Podnikatelské pojištění',
    nazevPravni: 'Právní ochrana',
    nazevVlastni: '{polozky} — zvlášť',
    nazevZam: 'Odpovědnost zaměstnance — {jmeno}',
    nazevZamDva: 'Odpovědnost zaměstnance — {jmeno1} a {jmeno2}',
    nenabizetV: 'Nenabízet',
    neresitV: 'Neřešit',
    netykaSe: 'netýká se',
    nezadanoPlaceholder: 'nezadáno',
    obsahSeZmenil: 'obsah se změnil — ověřte cenu',
    orientacne: 'orientačně ≈ {cena}, ne nabídka',
    osvcMzdaPozn: 'Příjem v analýze je z podnikání. Mzdu zadejte, jen když má i zaměstnavatele.',
    overitCenuFew: 'ověřit cenu u {n} smluv',
    overitCenuMany: 'ověřit cenu u {n} smluv',
    overitCenuOne: 'ověřit cenu u {n} smlouvy',
    podepiseFew: 'Klient podepíše {n} smlouvy',
    podepiseMany: 'Klient podepíše {n} smluv',
    podepiseOne: 'Klient podepíše {n} smlouvu',
    podnikNeresit: 'Firmu, zásoby a vybavení pojistka domácnosti nekryje.',
    podtitulJedna: 'Jedna smlouva · jedna cena',
    podtitulNenabizime: 'Nenabízíme',
    podtitulNeresime: 'Neřešíme',
    podtitulNetyka: '{jmeno} podniká — nemá zaměstnavatele.',
    podtitulNetykaBez: '{jmeno} nemá v analýze příjem ze zaměstnání.',
    podtitulPrazdna: 'Zatím nic ke krytí — doplňte položky',
    podtitulSamostatna: 'Samostatná smlouva',
    podtitulZam: 'Limit {nasobek}× hrubé mzdy · jedna cena',
    pojistneCelkem: 'Pojistné celkem',
    popisekCastka: 'Pojistná částka',
    popisekLimit: 'Limit',
    popisekVybaveni: 'Hodnota vybavení',
    popisekZasoby: 'Hodnota zásob',
    pravniNabidka: 'Právní ochrana: nabídnout, nebo nenabízet',
    pravniPripojisteni: 'Připojištění ke smlouvě Majetek',
    pravniSamostatna: 'Samostatná smlouva',
    pravniUmisteni: 'Jak je právní ochrana sjednaná',
    prepinacAria: '{nazev}: nabízet, nebo neřešit',
    presunAria: '{nazev}: patří do smlouvy',
    presunNova: '+ Nová samostatná smlouva',
    presunPopisek: 'Sjednáno jinak? Patří do smlouvy',
    prezSmlouvyFew: '{n} smlouvy',
    prezSmlouvyMany: '{n} smluv',
    prezSmlouvyOne: '{n} smlouva',
    prezSouhrnBezCen: '{smlouvy} · ceny po nabídce',
    prezSouhrnCast: '{smlouvy} · {cena} + další ceny po nabídce',
    prezSouhrnCena: '{smlouvy} · {cena}',
    proc_majetek: 'Jedna škoda na nemovitosti nebo způsobená jiným stáhne celý plán ke dnu.',
    proc_podnik: 'Pojistka domácnosti podnikání nekryje.',
    proc_pravni: 'Spor o peníze nebo práci stojí právníka a soud.',
    proc_vlastni: 'Sjednáno zvlášť — vlastní smlouva a vlastní cena.',
    proc_zam: 'Škodu z nedbalosti v práci může zaměstnavatel chtít po zaměstnanci; zákonný strop neplatí vždy.',
    radekSmlouvy: '{nazev} ({kryti}) — {cena}',
    radekSmlouvyBezKryti: '{nazev} — {cena}',
    regul: 'Do součtu jde jen cena z nabídky. Částky jsou návrh krytí, ne nabídka — cenu, rozsah plnění a výluky určí pojišťovna ve smlouvě.',
    resitV: 'Řešit',
    smlouvaAria: 'Smlouva {cislo}: {nazev}',
    staraMetodika: 'Plán má starší metodiku: do tisku jde postaru jeden řádek — orientačně {cena}. Smlouvy, ceny a „Neřešit“ odsud se do tisku propíšou až po „{prepocitat}“.',
    staraMetodikaBezTisku: 'Plán má starší metodiku: pojištění majetku se do tisku nedostane. Smlouvy a ceny odsud se propíšou až po „{prepocitat}“.',
    stavChybiHodnota: 'chybí hodnota',
    stavChybiMzda: 'chybí hrubá mzda',
    stavNeresit: 'neřešit',
    stavNetyka: 'netýká se — podniká',
    stavNetykaBez: 'netýká se — bez zaměstnání',
    stavNevlastni: 'nevlastní',
    stavNezadano: 'nezadáno',
    stavOdhadMzdy: 'odhad z čisté — ověřte',
    ukolSmlouvyFew: 'Sjednat majetkové pojištění — {n} smlouvy:',
    ukolSmlouvyMany: 'Sjednat majetkové pojištění — {n} smluv:',
    ukolSmlouvyOne: 'Sjednat majetkové pojištění — {n} smlouva:',
    ulozit: 'Uložit',
    upravitCenu: 'Upravit cenu: {nazev}',
    vetaSjednat: 'Sjednat {nazev} ({kryti}) — {cena}',
    vetaSjednatBezKryti: 'Sjednat {nazev} — {cena}',
    vsechnyCeny: 'všechny ceny z nabídek',
    vysvetlitKlientovi: 'Vysvětlit klientovi',
    zNabidky: 'z nabídky',
    zadatMzdu: 'Má i zaměstnání? Zadat mzdu',
    zadnaKPodpisu: 'Zatím žádná smlouva k podpisu',
    zamJakPoznat: 'Jak poznat jednu, nebo dvě smlouvy',
    zamJakText: 'Podívejte se do nabídky pojišťovny: jedno číslo smlouvy a jedna cena = jedna smlouva pro oba. Dvě ceny = každý svou. Limit má každý zvlášť podle své hrubé mzdy.',
    zamKazdy: 'Každý svou smlouvu',
    zamSkupina: 'Odpovědnost zaměstnance',
    zamSpolecna: 'Jedna smlouva pro oba',
  },
  /* BLOK:majetekSmlouvy END */
  /* BLOK:duchodInvalidni START — generuje scratchpad/slovnik.py, ručně needitovat */
  duchodInvalidni: {
    ano: 'Ano',
    bezPrijmuB: 'Rodič bez příjmu: o 20 % vyšší výdaje ({narust}) mínus invalidní důchod ({duchod}).',
    bezPrijmuDomacnosti: 'Bez příjmu – krytí invalidity nepočítáme, doplňte příjem.',
    narok: 'Nárok na invalidní důchod',
    narokPozn: 'Nad 28 let 5 let pojištění z posledních 10. Péče o dítě se počítá jen ve veřejném zdravotním pojištění. „Nevím“ = počítá se bez nároku.',
    ne: 'Ne',
    nevim: 'Nevím',
    odStatu: 'Invalidní důchod od státu {castka}',
    odStatuLabel: 'Invalidní důchod od státu',
    stitek: {
      bezNaroku: 'bez nároku: méně než 5 let pojištění z 10',
      bezNarokuPoradce: 'bez nároku',
      chybiNarozeni: 'doplňte datum narození',
      minimum: 'zákonné minimum',
      osvcMinimalni: 'OSVČ z minimálních záloh',
      overitNarok: 'ověřit výpis ČSSZ',
      prumer: 'průměr',
    },
  },
  /* BLOK:duchodInvalidni END */
  /* BLOK:kinoCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoCile: {
    bydleni: {
      a1: {
        kicker: 'Nájem vs. vlastní',
        l1: 'Nájem: nižší vstupní náklad, snadnější stěhování, opravy řeší majitel — majetek si ale nebudujete.',
        l2: 'Hypotéka: potřebná akontace a dlouhodobý závazek, část splátky ale umořuje jistinu — nemovitost postupně vlastníte.',
        l3: 'Rozhoduje flexibilita, měsíční cashflow a to, jestli chcete budovat majetek.',
        nar: '„Nájem není vyhozený — platíte za bydlení a za flexibilitu. Rozdíl je v tom, že u hypotéky část splátky umořuje jistinu, takže postupně budujete majetek. Pojďme se podívat na čísla i na předpoklady modelu.“',
        title: 'Nájem a hypotéka: v čem se liší',
      },
      a5: {
        big: 'Co si začneme odkládat',
        nar: '„Pojďme rozjet plán už dnes — ať klíče držíte vy, ne nájemní smlouva.“',
        title: 'Domov má svůj plán',
        titleVek: 'Domov za {roky} let, ve vašich {vek}',
      },
      cnb: {
        bigCena: 'Reálná cena bydlení',
        bigNad: '{nasobek}× roční příjem — nad doporučením',
        bigOk: '{nasobek}× roční příjem — v pásmu doporučení',
        kicker: 'Zdravá hranice ceny',
        lBezCeny1: 'Doplňte REÁLNOU cenu nemovitosti — jinak plán nebude sedět.',
        lBezCeny2: 'Z dnešního bydlení na podobné, ne palác.',
        lBezPrijmu: 'Doplňte příjmy a zkontrolujeme poměr ceny k příjmu.',
        lCena: 'Cena nemovitosti: {cena} (reálná, ať plán sedí).',
        lCenaHola: 'Cena nemovitosti: {cena}.',
        lNad: 'To je {nasobek}× váš roční příjem — nad zdravou hranicí!',
        lOk: 'To je {nasobek}× váš roční příjem — v pořádku.',
        nar: '„Zdravá cena je zhruba do devíti ročních příjmů. Musíme počítat s reálnou cenou, jinak celý plán nesedí.“',
        title: 'Zdravá cena ≈ 9× roční příjem',
      },
      nbs: {
        bigNad: 'Úvěr nad limitem NBS',
        bigOk: 'Úvěr v limitu NBS',
        bigUver: 'Potřebný úvěr',
        kicker: 'Limit NBS',
        lLimit: 'Limit pro všechny vaše úvěry: {limit}.',
        lLimitNejvys: 'Limit pro všechny vaše úvěry: nejvýš {limit}.',
        lUver: 'Potřebný úvěr: {uver}.',
        lUverNad: 'Potřebný úvěr: {uver} — nad limitem NBS!',
        lUverOk: 'Potřebný úvěr: {uver} — v pořádku.',
        lVek: 'Podle věku může být limit nižší.',
        lZbyva: 'Po ostatních úvěrech zbývá: {strop}.',
        nar: '„Na Slovensku hlídá NBS všechny vaše úvěry dohromady — nejvýš osminásobek ročního čistého příjmu, od 41 let méně. Pojďme se podívat, kam se vejdete.“',
        title: 'Všechny úvěry ≤ {max}× roční příjem',
      },
      paka: {
        bigHotove: 'Cena celkem',
        bigUver: 'Potřebná akontace ({pct})',
        kicker: 'Páka hypotéky',
        lAkontace: 'Akontace {pct}: {castka}.',
        lHotove: 'Hotově = celá částka teď.',
        lSHypotekou: 'S hypotékou stačí ~{pct} akontace a zbytek peněz investujete.',
        lZbytek: 'Zbytek dofinancuje hypotéka — vaše peníze pracují jinde.',
        narHotove: '„Zvážíme hotově versus hypotéka. Páka umí být váš přítel.“',
        narUver: '„S hypotékou nepotřebujete celou částku — jen akontaci. Zbytek peněz může dál růst.“',
        titleHotove: 'Hotově, nebo s pákou?',
        titleUver: 'Investujete jen {pct} akontace',
      },
    },
    ostatni: {
      a1: {
        big: 'Pojďme to rozpočítat',
        kicker: 'Váš cíl',
        l1: 'Každý velký sen potřebuje plán a číslo.',
        l2: 'Pojmenujeme, kolik a kdy.',
        nar: '„Každý cíl si zaslouží jasné číslo a termín. Pojďme na to.“',
        title: 'Váš sen',
      },
      a2: {
        big: 'Cílová částka',
        kicker: 'Kolik a kdy',
        lHorizont: 'Horizont {roky} let.',
        lHorizontVek: 'Horizont {roky} let — ve vašich {vek}.',
        nar: '„Tady je číslo a termín. Z toho už umíme spočítat měsíční odkládání.“',
        titleRoky: '{castka} za {roky} let',
      },
      a3: {
        big: 'Cíl na dosah',
        kicker: 'Tři páky',
        l1: 'Čím dřív začnete, tím méně musíte odkládat.',
        l2: 'Pravidelnost poráží jednorázové pokusy.',
        nar: '„Fungují tři páky: čas, pravidelnost a výnos. Všechny umíme zapnout.“',
        title: 'Čas × pravidelnost × výnos',
      },
      a4: {
        big: 'Váš cíl',
        l1: 'Naplánujeme měsíční odkládání hned.',
        l2: 'Malý krok dnes = velký cíl zítra.',
        nar: '„Sen bez plánu je jen přání. Pojďme z něj udělat plán.“',
        title: 'Z plánu se stane realita',
      },
    },
    renta: {
      a1: {
        big: 'Kolik je „dost“ podle VAŠICH výdajů?',
        kicker: 'Vrchol plánu',
        l1: 'Den, kdy práce je volba, ne povinnost.',
        l2: 'Renta musí utáhnout celý váš životní styl — nadosmrti a nad inflací.',
        nar: '„Cílová meta: den, kdy nemusíte pracovat pro peníze. Renta musí pokrýt celý váš dnešní život, ne se uskromňovat.“',
        title: 'Finanční nezávislost',
      },
      a2: {
        big: 'Renta, kterou potřebujete (dnešní ceny)',
        kicker: 'Váš životní styl',
        lBez1: 'Renta musí pokrýt vaše CELKOVÉ měsíční výdaje (životní styl).',
        lBez2: 'Doplňte výdaje v analýze, ať částka sedí.',
        lRenta: 'Renta zadaná v cíli: {renta}.',
        lVydaje: 'Vaše celkové měsíční výdaje podle analýzy: {vydaje}.',
        nar: '„Tohle jsou vaše dnešní výdaje z analýzy a renta, kterou jste si u cíle zadali. Od těchhle dvou čísel se odvíjí všechno další.“',
        title: 'Vaše dnešní měsíční výdaje',
      },
      a3: {
        big: 'Potřebný kapitál (v dnešních cenách)',
        kicker: 'Pravidlo 4 %',
        l2: '4 % je reálný výnos NAD inflací — jistina zůstává, čerpáte napořád.',
        lRocne: '{renta}/měs = {rocne} ročně.',
        nar: '„Bezpečně lze ročně čerpat ~4 % majetku nad inflací napořád. Z vašich výdajů spočítáme potřebný kapitál.“',
        title: 'Renta × 12 ÷ 4 % = kapitál',
      },
      a4: {
        big: 'Cílový kapitál pro svobodu',
        l1: 'Pravidelná investice + čas = sněhová koule, renta nadosmrti.',
        lCil: 'Cíl za {roky} let.',
        lCilVek: 'Cíl za {roky} let, ve vašich {vek}.',
        lKazdy: 'Každý měsíc odkladu je měsíc svobody navíc.',
        nar: '„Nezávislost se nekupuje penězi naráz, ale časem a pravidelností. Sněhová koule složeného úročení udělá zbytek.“',
        title: 'Svoboda se kupuje časem',
      },
    },
    rezerva: {
      a1: {
        big: 'Měsíce klidu, které teď máte?',
        kicker: 'Co kdyby…',
        l1: 'Auto, výpověď, nemoc, rozbitá lednička.',
        l2: 'Bez rezervy přichází dluh — kreditka, půjčka, stres.',
        nar: '„Představte si, že zítra vypadne příjem. Jak dlouho ustojíte běžný život beze změny?“',
        title: 'Co když zítra přijdete o příjem?',
      },
      a2: {
        big: 'Čechů nemá rezervu ani na měsíc',
        kicker: 'Realita v ČR',
        l1: '14 % nemá žádnou rezervu.',
        l2: 'Téměř třetina nemá stranou ani jeden měsíční příjem.',
        l3: 'Zdroj: STEM/MARK pro Home Credit, 2024.',
        nar: '„Nejste v tom sami — ale právě proto je rezerva první krok. 14 % lidí nemá vůbec nic, třetina nepřežije měsíc.“',
        title: 'Skoro třetina Čechů nevydrží ani měsíc',
      },
      a3: {
        bigCil: 'Cílová rezerva',
        bigMes: '= {mes} měsíců klidu',
        kicker: 'Pravidlo',
        lBez1: '3–6 měsíců výdajů stranou = klid v zádech.',
        lBez2: 'Doplňte nezbytné výdaje a spočítáme měsíce přesně.',
        lCil: 'Cíl {cil} = {mes} měsíců klidu v zádech.',
        lNez: 'Vaše nezbytné výdaje: {nez}/měs.',
        nar: '„Cílem jsou 3 až 6 měsíců nezbytných výdajů. U vás to vychází na tuhle částku.“',
        title: 'Rezerva = 3–6× nezbytné výdaje',
      },
      a4: {
        big: 'Váš štít proti smůle',
        lDnes: 'Termín: dnes — rezerva se řeší jako první.',
        lTermin: 'Termín: za {roky} let.',
        nar: '„Nemusíte to mít hned. Začneme po troškách — důležité je začít. Rezerva je základ, na kterém stojí celý plán.“',
        title: 'Polštář se staví po troškách',
      },
    },
    spolecne: {
      cenaZadani: 'Cena podle zadání: {castka}.',
      cilovaCastka: 'Cílová částka podle zadání: {castka}.',
      dejstvi: 'Dějství {n}',
      hotovo: 'Hotovo ✓',
      modelNajmu: 'Model: nájem 0,35 % ceny měsíčně s růstem 3 % ročně; u hypotéky rovnoměrné umořování ceny bez úroků a nákladů na údržbu. Skutečnost se liší podle lokality, sazby a stavu nemovitosti.',
      osaDnes: 'DNES',
      osaVek: 've věku {vek}',
      osaZa: 'za {n} let',
      pauza: 'Pauza',
      termin: 'Termín: za {roky} let.',
      terminNeni: 'Termín zatím není stanovený.',
      terminVek: 'Termín: za {roky} let, ve vašich {vek}.',
      zacniDnes: 'Začněte dnes',
    },
    vzdelani: {
      a1: {
        big: 'Kolik bude studium stát?',
        kicker: 'Největší dar',
        l1: 'Diplom, jazyky, zahraničí, rozjezd kariéry.',
        l2: 'To nejlepší, co dětem můžete dát — a stojí to peníze.',
        nar: '„Nejlepší investice je do vlastních dětí. Pojďme se podívat, co je čeká.“',
        title: 'Vzdělání = start do života',
      },
      a2: {
        big: 'Váš cíl pro {deti}',
        kicker: 'Cena vzdělání',
        l1: 'Studium v ČR ≈ 300–600 tis. (bydlení, strava, materiály).',
        l2: 'Zahraniční univerzita ≈ 1–3 mil. Kč.',
        nar: '„Domácí studium vyjde na statisíce, zahraniční klidně na miliony. Dobré to vědět dopředu.“',
        title: 'ČR statisíce, zahraničí miliony',
      },
      a3: {
        big: 'Cílová částka',
        bigRoky: 'Stihnete za {roky} let',
        kicker: 'Čas běží',
        nar: '„Čas hraje pro vás. Začít včas znamená odkládat výrazně méně.“',
        title: 'Čas je váš spojenec',
        titleRoky: 'Potřeba za {roky} let',
      },
      a4: {
        big: 'Budoucnost dětí',
        l1: 'Pravidelné investice od dneška = klid, až přijde čas.',
        l2: 'Naplánujeme měsíční odkládání na vzdělání.',
        nar: '„Pár stovek měsíčně dnes = otevřené dveře pro vaše děti zítra.“',
        title: 'Malá částka, velký diplom',
      },
      deti: 'děti',
      dite: 'dítě',
    },
    zdroj: {
      akontaceCZ: 'ČNB, opatření obecné povahy č. I/2021 (LTV: mladší 36 let 90 %, jinak 80 %), ověřeno {datum}',
      akontaceSK: 'NBS, opatrenie č. 10/2016 § 7 a § 9d (LTV: do konce roku 2026 jistých 80 %, od 2027 první bydlení do 35 let 90 %), ověřeno {datum}',
      cnb: 'ČNB — doporučení k úvěrovým ukazatelům',
      ctyriProcenta: 'Pravidlo bezpečného čerpání 4 % (Trinity study)',
      klient: 'Údaje z analýzy klienta',
      najemModel: 'Modelové porovnání nájmu a hypotéky (předpoklady u grafu)',
      nbs: 'NBS — opatrenie č. 10/2016 § 8a (limit DTI)',
      rezervaPravidlo: 'Interní metodika — likvidní rezerva 3–6× nezbytné výdaje',
      stem: 'STEM/MARK pro Home Credit',
    },
  },
  /* BLOK:kinoCile END */
  /* BLOK:invaliditaVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  invaliditaVysvetleni: {
    aria: 'Po invaliditě potřebujete {potreba}, přijde {prijde}, chybí {chybi}.',
    ariaPrebyva: 'Po invaliditě potřebujete {potreba}, přijde {prijde}, zbude {prebyva}.',
    bezVydaju: 'Krytí invalidity nejde spočítat — v analýze chybí výdaje.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} v dnešních cenách. Počítáme, že vyplacené peníze budou uložené s modelovým výnosem 4 % nad inflaci (model, ne garance). Proto dnes stačí {kapital}.',
    chybiVeta: 'chybí {castka} každý měsíc · {roky}',
    cilBezHorizontu: 'cíl {nazev} bez horizontu, nezapočten',
    duchod: 'invalidní důchod od státu',
    duchodSablona: 'invalidní důchod (šablona země)',
    jenUkazka: 'Jen ukázka — do plánu se nic nezapisuje.',
    krok1: 'Výdaje po invaliditě',
    krok1B: 'O kolik vzrostou výdaje domácnosti',
    krok1BPod: '+20 % z {vydaje}',
    krok1Pod: 'léčení, péče, úpravy bydlení',
    krok2: 'Co rodině přijde',
    krok2B: 'Co dá stát',
    krok3: 'Co chybí — až do renty ({roky})',
    krok3B: 'Co chybí — na {roky}',
    krok4: 'Limit invalidity',
    krok4BPod: 'dluhy, cíle a rentu kryje invalidita živitele',
    krok4Pod: 'co chybí + dluhy + cíle + renta − co už máte',
    model: 'Orientační model, ne garance: počítá s výnosem 4 % nad inflaci, při nižším výnosu vychází limit vyšší. Invalidní důchod je pro III. stupeň (plná invalidita), u I. a II. stupně je nižší. Plnění určují pojistné podmínky.',
    nepotreba: 'Rodině by zůstal dostatečný příjem — krytí invalidity není nutné.',
    nicNechybi: 'Příjmy pokryjí výdaje rodiny přesně.',
    odvozenaRenta: 'odvozeno: renta = dnešní výdaje',
    odvozenaRentaPotreba: 'odvozeno: renta = dnešní výdaje a splátky bez spoření a splátek doplacených do renty',
    odvozeneRoky: 'odvozeno: horizont renty {roky} podle šablony',
    orezano: 'Příjmy a majetek rodině vystačí — krytí invalidity není nutné.',
    partner: '{jmeno} dál vydělává',
    pasivniAria: 'Pasivní příjem {castka}, limit invalidity {limit}',
    pasivniTitul: 'Kdybyste dnes měli pasivní příjem',
    pasivniVeta: 'Pojištění je cena za to, že zatím nemáme pasivní příjem.',
    prahMezera: 'pokryje mezeru',
    prahNula: 'pojistka není potřeba',
    prebyvaVeta: 'Příjmy rodině vystačí a zbude {castka} — o to je limit nižší.',
    rada: {
      chybi: 'chybí',
      dnes: 'dnes',
      duchod: 'invalidní důchod',
      narust: '+20 % po invaliditě',
      partner: 'příjem partnera',
      pasivni: 'pasivní příjem',
    },
    radekChybi: 'Co chybí až do renty',
    radekCile: 'Zainvestovat na cíle (dnešní hodnota)',
    radekDluhy: 'Doplatit dluhy',
    radekMajetek: 'Co už máte na účtech',
    radekPrebytek: 'Co rodině z příjmů zbude navíc — až do renty ({roky})',
    radekRenta: 'Zainvestovat na rentu (dnešní hodnota)',
    radekRentaPod: '{castka} v dnešních cenách za {roky}, čerpání 4 %',
    rucne: 'Na kartě je ručně {rucni}, spočítáno {spocitano}.',
    skryt: 'Skrýt výpočet',
    titul: 'Jak vzniká částka invalidity',
    toggle: 'Jak se počítá invalidita',
    vysledek: 'Limit invalidity',
    zaokrouhleni: 'Řádky jsou zaokrouhlené, jejich součet se může nepatrně lišit.',
  },
  /* BLOK:invaliditaVysvetleni END */
  /* BLOK:staraZtrata START — generuje scratchpad/slovnik.py, ručně needitovat */
  staraZtrata: {
    invalidita: 'Stará smlouva má invaliditu {castka}, nová ji nemá.',
    jine: 'Stará smlouva má {riziko} {castka}, nová ho nemá.',
    smrt: 'Stará smlouva má krytí smrti {castka}, nová ho nemá.',
  },
  /* BLOK:staraZtrata END */
  /* BLOK:schodPoSchodu START — generuje scratchpad/slovnik.py, ručně needitovat */
  schodPoSchodu: {
    bezDat: 'Z téhle analýzy se zatím nedá nic spočítat.',
    bezPrijmu: 'Bez příjmů a výdajů se pořadí spočítat nedá. Doplňte je v analýze.',
    e: {
      doporucene: 'Doporučené pořadí',
      hlasDoporucene: 'Vráceno doporučené pořadí.',
      hlasPosun: '{nazev} je teď na {n}. místě.',
      nadpis: 'Co je pro vás nejdůležitější?',
      niz: '{nazev} níž',
      podnadpis: 'Nahoře je to, co chcete mít nejdřív.',
      renta: 'Renta · dostane, co zbude',
      rovne: 'Všechno je pro mě stejně důležité',
      seznam: 'Pořadí cílů',
      tahnout: 'Přetáhnout: {nazev}',
      ulozit: 'Uložit pořadí',
      vys: '{nazev} výš',
      zaklad: 'Základ: rezerva a zajištění příjmu · vždy první',
      zakladRezerva: 'Základ: rezerva · vždy první',
      zakladZajisteni: 'Základ: zajištění příjmu · vždy první',
      zrusit: 'Zrušit',
    },
    k: {
      cilCast: '{nazev}: do roku {rok} naspořeno {pct}, chybí {chybi}.',
      cilHotovo: '{nazev}: do roku {rok} splněno, včas.',
      cileFew: '{vcas} z {celkem} cílů včas',
      cileMany: '{vcas} z {celkem} cílů včas',
      cileOne: '{vcas} z {celkem} cíle včas',
      dalsiCast: 'Další cíle ({n}): k termínům naspořeno {pct}, chybí {chybi}.',
      dalsiHotovo: 'Další cíle ({n}): k termínům splněno.',
      nezadaneFew: '{n} cíle nemají částku nebo termín.',
      nezadaneMany: '{n} cílů nemá částku nebo termín.',
      nezadaneOne: '{n} cíl nemá částku nebo termín.',
      renta: 'Renta od roku {rok}: modelově připraveno {pct} (pesimisticky {pes}), chybí {chybi}.',
      rentaHotovo: 'Renta od roku {rok}: modelově připraveno {pct} (pesimisticky {pes}).',
      shrnuti: 'Při {castka} měsíčně: {cile}, renta {renta}.',
      shrnutiBezRenty: 'Při {castka} měsíčně: {cile}.',
      shrnutiJenRenta: 'Při {castka} měsíčně: renta {renta}.',
      srovnani: 'Při {castka} měsíčně: {cile} (dřív {vcasDrive}), renta {renta} místo {rentaDrive}.',
      srovnaniBezRenty: 'Při {castka} měsíčně: {cile} (dřív {vcasDrive}).',
      srovnaniJenRenta: 'Při {castka} měsíčně: renta {renta} místo {rentaDrive}.',
      uvod: 'Odkládáte {castka} měsíčně. Kolik bude k termínům, které chcete?',
      zajisteni: 'Zajištění příjmu sjednáme po schůzce.',
      zaklad: 'Nejdřív základ.',
      zakladCast: 'Nejdřív základ: rezerva do roku {rok} na {pct}, chybí {chybi}.',
      zakladHotovo: 'Nejdřív základ: rezerva doplněná do roku {rok}.',
      zakladMa: 'Nejdřív základ: rezervu máte už dnes.',
    },
    nadpis: 'Schod po schodu',
    neodsouhlaseno: 'zatím neodsouhlaseno klientem',
    o: {
      dal: 'Další krok',
      dalsi: 'Další',
      krok: 'Krok {n}: {nazev}',
      kroky: 'Kroky přehrání',
      otazka: 'Pořadí',
      pauza: 'Pauza',
      pokracovat: 'Pokračovat',
      prehrat: 'Přehrát',
      preskocit: 'Přeskočit',
      uvod: 'Start',
      zaklad: 'Základ',
      znovu: 'Znovu',
      zpet: 'Krok zpět',
    },
    odkladani: 'Odkládání měsíčně',
    p: {
      bezPojistneho: 'Cena pojištění zatím není zadaná, z přebytku se nic neodečítá.',
      dnes: '„Dnes“ = co dnes pravidelně posíláte stranou (spoření, penzijko, fondy).',
      model: 'Modelově, ne garance. Stejný výpočet jako Návrh řešení: cíl dostává peníze jen do svého termínu a ukáže se, kolik bude k termínu. Pesimisticky = horší výnosy.',
      pojistne: 'Přebytek po pojistném = volný přebytek minus cena pojištění od poradce.',
    },
    precerpano: 'Ruční částky u cílů: přečerpáno o {castka} — počítáme jen s {dostupne} měsíčně.',
    prehravac: 'přehrávač',
    q: {
      ano: 'Ano',
      nemeniCisla: 'Čísla výš počítá Návrh řešení podle termínů. Pořadí klienta je zapsané, výpočet zatím nemění.',
      otazka: 'Souhlasíte s tímhle pořadím?',
      popis: 'Základ → {cile} → renta',
      popisBezCilu: 'Základ → renta',
      popisBezRenty: 'Základ → {cile}',
      popisRovne: 'Základ, pak všechno stejně důležité: {cile}, zbytek na rentu',
      popisRovneBezRenty: 'Základ, pak všechno stejně důležité: {cile}',
      potvrzeno: 'Pořadí potvrzeno {datum}',
      upraveno: 'Pořadí klienta zapsáno {datum}',
      upravit: 'Upravit',
      zmenit: 'Změnit',
    },
    s: {
      bezUdaju: 'bez údajů',
      castkaNezadana: 'částka nezadána',
      chybi: 'chybí {castka}',
      cil: 'cíl',
      cileFew: '{n} cíle',
      cileMany: '{n} cílů',
      cileOne: '{n} cíl',
      dalsiFew: '{n} další',
      dalsiMany: '{n} dalších',
      dalsiOne: '{n} další',
      doplneno: 'doplněno',
      doplnit: 'doplňte',
      drive: 'dřív {pct}',
      kRoku: 'k {rok}',
      maDnes: 'máte už dnes',
      mesicne: '{castka}/měs.',
      nepocitaSe: 'nepočítá se',
      pesimisticky: 'pesimisticky {pct}',
      poSchuzce: 'po schůzce',
      pojisteni: 'Pojištění',
      potreba: 'potřeba',
      pripraveno: 'připraveno',
      renta: 'Renta',
      rezerva: 'Rezerva',
      sjednat: 'sjednat',
      ted: 'teď',
      terminNezadan: 'termín nezadán',
      vcas: 'včas',
    },
    schodyAria: 'Schody cílů. {shrnuti}',
    stitek: 'Modelově',
    tlacitko: 'Přehrát',
    tlacitkoPopis: 'schod po schodu',
    tlacitkoTitul: 'Krátká animace: kolik bude k termínům podle pořadí cílů',
    vekFew: '{n} roky',
    vekMany: '{n} let',
    vekOne: '{n} rok',
    volbaDnes: 'Dnes {castka}',
    volbaPlan: 'Přebytek {castka}',
    volbaPlanPoPojistnem: 'Přebytek po pojistném {castka}',
    zavrit: 'Zavřít přehrání',
  },
  /* BLOK:schodPoSchodu END */
  /* BLOK:smlouvaEditor START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaEditor: {
    celkova: 'Celková částka ({mena})',
    chybaPoli: 'Server údaje nepřijal — zkontrolujte vyplněná pole.',
    chybaServeru: {
      jenPojistne: 'Výpověď lze generovat jen pro pojistné smlouvy',
      klientNenalezen: 'Klient nenalezen',
      neplatneId: 'Neplatný odkaz — obnov stránku a zkus to znovu.',
      smlouvaNenalezena: 'Smlouva nenalezena',
    },
    cislo: 'Číslo smlouvy',
    fixace: 'Konec fixace',
    hodnota: 'Aktuální hodnota ({mena})',
    instituce: 'Banka / pojišťovna',
    mazaniSelhalo: 'Smazání selhalo',
    mesicni: 'Měsíční částka ({mena})',
    nadpisEditace: 'Editace smlouvy',
    nadpisNova: 'Nová smlouva',
    napr: 'např. {x}',
    nasporeno: 'Naspořeno ({mena})',
    poznamky: 'Poznámky',
    poznamkyNapr: 'Co je důležité k této smlouvě…',
    pridano: 'Smlouva přidána',
    pridat: 'Přidat smlouvu',
    sazba: 'Úroková sazba (%)',
    smazano: 'Smlouva smazána',
    smazat: 'Smazat',
    smazatPotvrzeni: 'Opravdu smazat tuto smlouvu? Smažou se i navázané úkoly v diáři.',
    stav: 'Stav',
    stavActive: 'Aktivní',
    stavCancelled: 'Zrušena',
    stavExpired: 'Skončila',
    typChybi: 'Vyber typ smlouvy',
    typSmlouvy: 'Typ smlouvy *',
    typy: {
      hypoteka: 'Hypotéka',
      investice: 'Investice',
      jine: 'Jiné',
      penzijko: 'Důchod (DPS/DIP)',
      pojisteni_auta: 'Pojištění auta',
      pojisteni_majetek: 'Pojištění majetku',
      pojisteni_odpovednost: 'Pojištění odpovědnosti',
      pojisteni_ostatni: 'Ostatní pojištění (právní ochrana, cestovní…)',
      pojisteni_zivot: 'Životní pojištění',
      stavebni: 'Stavební spoření',
      uver: 'Úvěr',
      zdravotni: 'Zdravotní',
    },
    ukladaniSelhalo: 'Ukládání selhalo',
    ulozeno: 'Smlouva uložena',
    ulozenoJakoJine: 'Uloženo jako „Jiné“ — tento druh smlouvy server zatím nezná.',
    ulozitZmeny: 'Uložit změny',
    vyber: '— Vyber —',
    vyroci: 'Výročí smlouvy',
    zacatek: 'Začátek smlouvy',
    zavrit: 'Zavřít',
    zbyva: 'Zbývá splatit ({mena})',
    zrusit: 'Zrušit',
  },
  /* BLOK:smlouvaEditor END */
  /* BLOK:cilHistorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHistorie: {
    cilCastka: 'cíl {castka}',
    hero: '{roky}letých období historie (1946–2026) by cíl [[vyšel]]',
    heroPozn: '{ok} z {n} klouzavých oken. Vše reálně, po odečtení dobové inflace.',
    jednotka: {
      milion: 'M',
      tisic: 'tis.',
    },
    legenda: {
      median: 'medián',
      nejhorsi: 'nejhorší okno',
      nejlepsi: 'nejlepší okno',
      projekce: 'projekce ({varianta})',
    },
    nadpis: 'Historická kalkulačka — kdyby takto investoval v minulosti',
    tip: {
      median: 'Medián',
      nejhorsi: 'Nejhorší okno',
      nejlepsi: 'Nejlepší okno',
      projekce: 'Projekce',
    },
    tipRok: 'Rok {rok} · +{n} let',
  },
  /* BLOK:cilHistorie END */
  /* BLOK:smlouvaKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaKarta: {
    aktualniHodnota: 'Aktuální hodnota',
    bezCisla: 'číslo nevyplněno',
    celkem: 'Celkem',
    cislo: 'č. {cislo}',
    druh: {
      hypoteka: 'Hypotéka',
      investice: 'Investice',
      jine: 'Jiné',
      penzijko: 'Penzijní spoření (DPS)',
      pojisteni_auta: 'Pojištění auta',
      pojisteni_majetek: 'Pojištění majetku',
      pojisteni_odpovednost: 'Pojištění odpovědnosti',
      pojisteni_ostatni: 'Ostatní pojištění',
      pojisteni_zivot: 'Životní pojištění',
      stavebni: 'Stavební spoření',
      uver: 'Úvěr',
      zdravotni: 'Zdravotní',
    },
    fixaceDo: 'Fixace do',
    generuji: 'Generuji…',
    kratce: {
      hypoteka: 'Hypotéka',
      investice: 'Investice',
      jine: 'Jiné',
      penzijko: 'Penze',
      pojisteni_auta: 'Auto poj.',
      pojisteni_majetek: 'Majetek poj.',
      pojisteni_odpovednost: 'Odpovědnost',
      pojisteni_ostatni: 'Ostatní poj.',
      pojisteni_zivot: 'Životní poj.',
      stavebni: 'Stavební',
      uver: 'Úvěr',
      zdravotni: 'Zdravotní',
    },
    mesicne: 'Měsíčně',
    nasporeno: 'Naspořeno',
    okno: {
      datumMinulo: 'Datum ukončení {datum} už minulo — v dopise ho oprav na konec aktuálního pojistného období.',
      jazyk: {
        cs: 'čeština',
        sk: 'slovenština',
      },
      jazykDopisu: 'Text výpovědi je v jazyce pojišťovny ({jazyk}).',
      kopirovat: 'Kopírovat text',
      lhutySK: 'Výpověď ku koncu poistného obdobia nejpozději 6 týdnů předem (§ 800 ods. 1). Do 2 měsíců od uzavření jen když to smlouva dovoluje, s 8denní lhůtou (§ 800 ods. 2).',
      sablona: 'Šablona — před podpisem ověř údaje, lhůty a adresu pojišťovny v pojistné smlouvě a podmínkách.',
      staryServer: 'Server zatím vrátil český vzor. Slovenské znění bude po aktualizaci serveru — do té doby text před odesláním uprav.',
      tisk: 'Vytisknout / uložit PDF',
      titulek: 'Výpověď — {pojistovna} / {klient}',
      zaklad: 'Právní základ: {zaklad}',
      zavrit: 'Zavřít',
      zkopirovano: 'Zkopírováno do schránky',
    },
    pocetFew: '{n} smlouvy',
    pocetMany: '{n} smluv',
    pocetOne: '{n} smlouva',
    poznamkaZAnalyzy: 'Z analýzy — smlouva před analýzou',
    prazdnoNadpis: 'Žádné smlouvy',
    prazdnoText: 'Přidej první smlouvu klienta — hypotéku, pojištění, investici…',
    predAnalyzou: 'před analýzou',
    predAnalyzouTitle: 'Smlouva přenesená z finanční analýzy — klient ji měl sjednanou před analýzou',
    prehled: {
      fixaceLet: 'fix {n} r.',
      mesicne: '{castka} / měs.',
      smlouvy: 'Smlouvy',
      smlouvyPocet: 'Smlouvy ({n})',
      zadneSmlouvyZatim: 'Žádné smlouvy zatím — přidej je v záložce Smlouvy.',
      zobrazitDalsi: '+ Zobrazit dalších {n}',
    },
    pridat: 'Přidat smlouvu',
    toastChyba: 'Výpověď se nepodařilo vygenerovat',
    toastHotovo: 'Výpověď vygenerována — vytiskni nebo ulož jako PDF',
    toastPopup: 'Prohlížeč zablokoval okno — povol vyskakovací okna.',
    toastStaryServer: 'Server zatím umí jen český vzor — před odesláním text uprav podle slovenského práva.',
    upravit: 'Upravit smlouvu',
    vypoved: 'Výpověď do pojišťovny',
    vypovedTitle: 'Vygeneruje vzor výpovědi do pojišťovny dle {zakon} — vytiskneš nebo uložíš jako PDF',
    vyroci: 'Výročí',
    zAnalyzy: 'Z analýzy: {popis}',
    zacatek: 'Začátek',
    zakon: {
      CZ: '§ 2807 NOZ',
      SK: '§ 800 slovenského OZ',
    },
    zbyvaSplatit: 'Zbývá splatit',
  },
  /* BLOK:smlouvaKarta END */
  /* BLOK:navrhDavky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhDavky: {
    invalidniMes: 'Invalidní důchod (měs.)',
    starobniMes: 'Starobní důchod (měs.)',
  },
  /* BLOK:navrhDavky END */
  /* BLOK:variantaVynosu START — generuje scratchpad/slovnik.py, ručně needitovat */
  variantaVynosu: {
    optimisticky: 'Optimisticky',
    pesimisticky: 'Pesimisticky',
    realisticky: 'Realisticky',
  },
  /* BLOK:variantaVynosu END */
  /* BLOK:penze2 START — generuje scratchpad/slovnik.py, ručně needitovat */
  penze2: {
    chyby: {
      bezData: 'Datum narození: vyplňte ho, nebo zapněte ruční zadání roků spoření.',
      cele: '{pole}: zadejte celé číslo.',
      cislo: '{pole}: zadejte číslo.',
      datum: 'Datum narození: nesmí být v budoucnosti ani neplatné.',
      nadpis: 'Opravte zvýrazněná pole. Výsledky zatím odpovídají poslednímu platnému zadání.',
      prazdne: '{pole}: vyplňte hodnotu.',
      rozsah: '{pole}: zadejte hodnotu od {min} do {max}.',
      vPenzi: 'Klient už je ve věku odchodu do penze. Zapněte ruční zadání roků spoření.',
    },
    f: {
      bezDat: 'Pro tento výběr nejsou v období žádná data.',
      dataDo: 'data jen do {rok}',
      dataOd: 'data od {rok}',
      grafAria: 'Čárový graf vývoje 100 Kč ve fondech za {obdobi}. Nejvýš {fond}: {hodnota}',
      grafNadpis: 'Vývoj 100 Kč, {obdobi}',
      grafPopis: 'Index 100 = hodnota na konci roku {rok}',
      historie: 'Historie',
      kontext: 'Ostatní vybrané fondy šedě v pozadí',
      maxZvyr: 'Zvýraznit lze nejvýš {max} fondů. Nejdřív některý odznačte.',
      mimoVyber: 'mimo výběr',
      nic: 'Zrušit výběr',
      o10: '10 let',
      o3: '3 roky',
      o5: '5 let',
      oVse: 'Vše',
      obdobi: 'Období',
      pocet: 'Fondy: {n} · zvýrazněno {z} z {max}',
      prumery: 'Průměr strategie (čárkovaně)',
      slAkce: 'Akce',
      slCelkem: 'Za období celkem',
      slFond: 'Fond / průměr',
      slPa: 'Výnos p. a.',
      slRust: 'Růst 1 Kč',
      slStrategie: 'Strategie',
      slVolatilita: 'Volatilita',
      spolecnost: 'Penzijní společnost',
      strategie: 'Strategie',
      tabulka: 'Fondy',
      tabulkaInfo: 'Zvýraznit můžete až 5 fondů zaškrtnutím. Hvězdička = fond nemá data za celé období; jeho výnos p. a. se počítá od vzniku a čára začíná v roce vzniku.',
      uvod: 'Jak rostlo 100 Kč ve fondech penzijních společností. Roční výnosy po poplatcích (APS ČR, banky.cz).',
      vse: 'Vybrat vše',
      vsechnySpolecnosti: 'všechny společnosti',
      vyber: 'Výběr fondů',
      vyberteAspon: 'Vyberte aspoň jednu strategii a jednu penzijní společnost.',
      vysvetlivky: 'Jak číst tabulku',
      vysvetlivkyInfo: 'Výnos p. a. = průměrné roční zhodnocení za období (geometrický průměr). Za období celkem = o kolik procent vzrostla hodnota. Volatilita = směrodatná odchylka ročních výnosů. Transformované fondy (staré penzijní připojištění) nemají záporný výsledek, protože ho ze zákona hradí penzijní společnost.',
      vznik: 'vznik {datum}, první rok jen zčásti',
      zadnyZvyr: 'Žádný fond není zvýrazněný. Zaškrtněte ho v tabulce.',
      zrusitZvyr: 'Zrušit zvýraznění: {fond}',
    },
    h: {
      chybaCastka: '{pole}: zadejte číslo 0 nebo větší, např. 1 000.',
      chybaObdobi: 'Začátek spoření musí být dřív než konec.',
      chybaRok: '{fond}: pro rok {rok} nejsou výnosy. Data má od roku {od}.',
      danVyber: 'Daň při jednorázovém výběru (orientačně)',
      danVyberInfo: 'Při jednorázovém výběru se z výnosu a příspěvků zaměstnavatele odvádí 15 % daň. Při rentě na 10 a více let se daň neplatí.',
      dipFond: 'Do čeho DIP investuje',
      dipInfo: 'DIP existuje od roku 2024. Pro starší roky jde o simulaci stejných vkladů do zvoleného fondu bez státního příspěvku. Daňová úspora (odpočet do 48 000 Kč ročně, 15 %) se počítá až od roku 2024.',
      dipPozn: 'U DIP stát nepřispívá.',
      dipPoznInfo: 'Při výběru po 60. roce věku a 10 letech trvání se výnos nedaní.',
      doMesice: 'Do měsíce',
      doRoku: 'Do roku',
      drive: 'dříve {nazev}',
      duchod: 'Klient pobírá starobní důchod',
      fond: 'Fond nebo průměr',
      grafAria: 'Vývoj hodnoty účtu {od}–{do}: nejvýš {fond} {castka}, vlastní vklady {vklady}',
      grafNadpis: 'Hodnota účtu na konci roku',
      grafNadpisMesic: 'Hodnota účtu na konci roku (poslední rok k vybranému měsíci)',
      kpiNasporeno: 'Naspořeno',
      kpiNove: 'Nové penzijko',
      kpiRozdil: 'Rozdíl',
      kpiStare: 'Staré penzijko',
      kpiStat: 'Stát celkem',
      kpiUsporaDip: 'Daňová úspora celkem',
      kpiVDip: 'Naspořeno v DIP',
      kpiVklady: 'Vlastní vklady',
      kpiZhod: 'Zhodnocení vlastních peněz',
      mesicuStat: '{mesicu}, stát {stat}',
      nove: 'Nové penzijko (fond nebo průměr)',
      noveOd2013: 'Nové penzijko existuje od roku 2013.',
      od: 'od {rok}',
      odMesice: 'Od měsíce',
      odRoku: 'Od roku',
      pohled: {
        cmp: 'Staré vs. nové penzijko',
        dip: 'DIP',
        fund: 'Konkrétní fond',
        str: 'Srovnání strategií',
      },
      pohledy: 'Pohled',
      pole: {
        emp: 'Příspěvek zaměstnavatele měsíčně',
        lump: 'Jednorázový vklad na začátku',
        own: 'Vlastní vklad měsíčně',
      },
      pravidlaInfo: 'Od 7/2024 bez státního příspěvku. Státní příspěvek: 2000–2012 max. 150 Kč (stupnice orientační), 2013–6/2024 max. 230 Kč (od 1 000 Kč), od 7/2024 20 % z vkladu, max. 340 Kč. Daňová úspora se počítá od roku 2013, sazba 15 %.',
      skupinaNove: 'Nové penzijko – {spolecnost}',
      skupinaPrumery: 'Průměry',
      skupinaStare: 'Staré penzijko',
      slHodnota: '{fond} – hodnota',
      slVynos: '{fond} – výnos',
      slozeni: 'Z čeho se skládá',
      stare: 'Staré penzijko (transformovaný fond)',
      statSub: 'příspěvky {stat} + daňová úspora {uspora}',
      tfZkratka: 'TF',
      transformovany: 'transformovaný fond',
      usporaDipSub: 'odpočet do 48 000 Kč ročně, od roku 2024',
      usporaObdobi: 'Daňová úspora z odpočtů za celé období',
      vProspechNoveho: 've prospěch nového penzijka',
      vProspechStareho: 've prospěch starého penzijka',
      vlastniVklady: 'Vlastní vklady',
      vynosFondu: 'výnos fondu {pct} ročně',
      zadani: 'Zadání',
      zdroje: 'Zdroje: APS ČR, banky.cz. Výnosy po poplatcích.',
      zdrojeInfo: 'APS ČR (účastnické fondy 2017–2025, transformované fondy 2013–2025, penzijní fondy 1995–2012), banky.cz (účastnické fondy 2013–2016). Vklady na začátku měsíce, roční výnos rozložený rovnoměrně do měsíců, státní příspěvek ve stejném měsíci. Minulé výnosy nejsou zárukou budoucích. Nejde o nabídku ani investiční doporučení.',
      ztrata: 'Ztráta',
    },
    m: {
      dalsi: 'Stávající smlouva a další předpoklady',
      danZVynosu: 'Započítat daň z výnosu penzijka',
      danZVynosuInfo: '15 % z výnosu (a příspěvků zaměstnavatele) při jednorázovém výběru z penzijka. Při rentě na 10 a více let se neplatí. DIP po splnění podmínek bez daně.',
      danZVynosuOdectena: 'Daň z výnosu (už odečtená)',
      danZam: 'Danit i příspěvky zaměstnavatele do penzijka',
      danZamInfo: 'Při jednorázovém výběru se 15 % daní výnos i příspěvky zaměstnavatele do penzijka (tak počítá zadání kalkulačky). Na DIP se nevztahuje.',
      dip: 'DIP',
      dip2: 'DIP 2',
      dipKratce: 'DIP',
      doMaxima: 'do maxima chybí {castka}',
      dodaneni: 'Dodanění odpočtů při nesplnění podmínek',
      duchod: 'Klient má přiznaný starobní důchod',
      duchodInfo: 'Od 7/2024 poživatel starobního důchodu státní příspěvek nedostává.',
      duchodceNe: 'důchodce: příspěvek nenáleží',
      grafAria: 'Skládaný sloupcový graf naspořené částky po letech, v roce {rok} celkem {castka}',
      grafNadpis: 'Naspořeno na konci každého roku',
      jednotkaLet: 'let',
      jednotkaMesicu: 'měsíců',
      jizInfo: 'Započítá se do podmínky minimální doby spoření. Zůstatek stávající smlouvy zadejte jako jednorázový vklad nebo převod.',
      kategorie: {
        dite: 'Dítě',
        dospely: 'Dospělý',
        senior: 'Senior',
      },
      klient: 'Klient',
      kpiNasporeno: 'Celkem naspořeno v penzi',
      kpiNavic: 'Získám navíc',
      kpiRenta: 'Měsíční renta',
      kpiVynos: 'Výnos p. a.**',
      letFew: '{n} roky',
      letMany: '{n} let',
      letOne: '{n} rok',
      maxVyuzito: 'maximum {castka} využito',
      mesicuFew: '{n} měsíce',
      mesicuMany: '{n} měsíců',
      mesicuOne: '{n} měsíc',
      naKonci: 'na konci spoření',
      nadVklady: 'nad vlastní vklady {castka}',
      narozeni: 'Datum narození',
      nelze: 'nelze',
      nesplneno: 'Nesplněno',
      odStatu: 'Od státu celkem ročně',
      odchod: 'Odchod do penze',
      odebratDip2: 'Odebrat druhou strategii DIP',
      odpocty: 'Klient využije daňové odpočty',
      odpoctyInfo: 'Z vlastních vkladů do penzijka nad 1 700 Kč měsíčně a z DIP, dohromady max. 48 000 Kč ročně. Úspora = odpočet × 15 %; do naspořené částky se nepřičítá.',
      odpoctyNe: 'odpočty nejsou započítané',
      penzeVRoce: 'Penze v roce',
      penzijko: 'Penzijko (DPS)',
      penzijkoKratce: 'Penzijko',
      plnaPodpora: 'Plná podpora: {a} měsíčně do penzijka na státní příspěvek a dalších {b} měsíčně do penzijka nebo DIP na daňový odpočet.',
      poDani: 'po dani z výnosu {castka}',
      pocatek: 'Jednorázový vklad nebo převod',
      pocatekInfo: 'Zůstatek stávající smlouvy nebo jednorázový vklad. Do Výnosu* se počítá jako vlastní peníze vložené na začátku.',
      podminky: 'Podmínky a daně',
      podpora: 'Využití státní podpory',
      podporaInfo: 'Státní příspěvek: 20 % z vlastního vkladu od 500 Kč, max. 340 Kč měsíčně (při vkladu 1 700 Kč). Daňová úspora: 15 % z odpočtu, max. 7 200 Kč ročně. Maximum od státu je 11 280 Kč ročně.',
      pole: {
        dip2Vlastni: 'DIP 2 – vlastní vklady',
        dip2Vynos: 'DIP 2 – výnos',
        dip2Zam: 'DIP 2 – zaměstnavatel',
        dipVlastni: 'DIP – vlastní vklady',
        dipVynos: 'DIP – výnos',
        dipZam: 'DIP – zaměstnavatel',
        dpsPocatek: 'Penzijko – jednorázový vklad',
        dpsVlastni: 'Penzijko – vlastní vklady',
        dpsVynos: 'Penzijko – výnos',
        dpsZam: 'Penzijko – zaměstnavatel',
        jizMesicu: 'Na stávající smlouvě už spořeno',
        narozeni: 'Datum narození',
        rentaLet: 'Počet let v penzi',
        rentaVynos: 'Zhodnocení v penzi',
        roky: 'Roky spoření',
      },
      pravidlo: 'Pravidlo 60 let + 120 (60) měsíců',
      pravidloAno: 'Splněno',
      pravidloAuto: 'Vyhodnotit z věku a doby spoření',
      pravidloDetail: 'věk při výběru {vek}, spoření {mesicu} (minimum {min} měsíců)',
      pravidloInfo: 'Výplata bez vrácení podpory: věk 60 let a doba spoření aspoň 120 měsíců (smlouvy do 2023: 60 měsíců). Při nesplnění kalkulačka orientačně vrátí státní příspěvky, zdaní výnos a dodaní odpočty za posledních 10 let.',
      pravidloNe: 'Nesplněno (předčasný výběr)',
      pravidloPredpoklad: 'věk není zadaný, počítá se se splněním',
      pravidloRucne: 'zadáno ručně (minimum {min} měsíců)',
      predpoklady: 'Modelový výpočet, ne garance.',
      predpokladyInfo: 'Předpoklad výnosu po poplatcích po celou dobu spoření, měsíční úročení (roční výnos / 12), vklady na začátku měsíce. Renta je anuita s výplatou na začátku měsíce. Pravidla státní podpory platná od 1. 7. 2024 beze změny po celou dobu. Daňová úspora se do naspořené částky nepřičítá. Minulé výnosy nejsou zárukou budoucích a nejde o investiční doporučení.',
      pridatDip2: 'Přidat druhou strategii DIP',
      priklad: 'Příklad',
      produkty: 'Výsledky podle produktu',
      produktyInfo: 'Výnos* = roční zhodnocení vlastních vkladů včetně státního příspěvku. Výnos** = navíc včetně příspěvku zaměstnavatele. V řádcích produktů je počítaný z částky před daní, v řádku Celkem z částky po dani.',
      renta: 'Renta v penzi',
      rentaBezZhod: '{roky}, bez dalšího zhodnocení',
      rentaInfo: 'Renta je anuita s výplatou na začátku měsíce. Při 0 % se naspořená částka jen rozdělí na stejné měsíční výplaty.',
      rentaSeZhod: '{roky}, zhodnocení {pct} ročně',
      rokyDoPenze: 'Roky do penze',
      rokyRucne: 'Zadat roky spoření ručně',
      rokyRucneInfo: 'Když datum narození neznáte nebo chce klient spořit jinak dlouho než do 60 / 65 let.',
      slozeni: 'Z čeho se skládá naspořená částka',
      smlouva2024: 'Smlouva uzavřená po 1. 1. 2024',
      smlouva2024Info: 'Smlouva uzavřená od 1. 1. 2024 potřebuje pro výplatu bez sankce aspoň 120 měsíců spoření, starší smlouva 60 měsíců.',
      splneno: 'Splněno',
      statMes: 'Státní příspěvek měsíčně',
      strategie: 'Strategie',
      strategieInfo: 'Předvolba doplní výnos podle průměru fondů dané strategie za {od}–{do} (po poplatcích). Jen pomůcka k zadání, ne předpověď.',
      usporaCelkem: 'Daňová úspora za celou dobu (vrací se na dani, v účtu není)',
      usporaRok: 'Daňová úspora ročně',
      v60: 'v 60 letech',
      v65: 'v 65 letech',
      vRoce: 'v roce {rok}',
      vek: 'Věk',
      vklady: 'Vklady měsíčně a výnos',
      vkladyInfo: 'Měsíční vklady do penzijka (DPS) a DIP. Výnos je předpoklad po poplatcích, úročí se měsíčně (roční výnos / 12), vklady na začátku měsíce.',
      vlastni: 'Vlastní vklady',
      vlastniVynos: 'Vlastní výnos',
      vlastniZadani: 'Vlastní zadání',
      vynos: 'Výnos ročně',
      vyuzitoAria: 'Využito {pct} % maxima',
      vzorPokrocily: 'Příklad: penzijko + DIP',
      vzorZakladni: 'Příklad: 1 000 Kč do penzijka',
      zMaxima: 'z max. {castka} · {pct}',
      zamestnavatel: 'Zaměstnavatel',
      zhodVlastnich: 'zhodnocení vlastních peněz',
    },
    prumer: {
      dynamicky: 'Průměr dynamických fondů',
      jina: 'Průměr',
      konzervativni: 'Průměr konzervativních fondů',
      transformovany: 'Průměr transformovaných fondů',
      vyvazeny: 'Průměr vyvážených fondů',
    },
    prumerKratce: {
      dynamicky: 'Ø dynamické',
      jina: 'Ø',
      konzervativni: 'Ø konzervativní',
      transformovany: 'Ø transformované',
      vyvazeny: 'Ø vyvážené',
    },
    r: {
      coPocitat: 'Co počítat',
      dan: 'Odečíst 15 % daň z výnosu',
      dostavat: 'Kolik budu dostávat',
      f: {
        castka: 'Naspořeno na začátku penze',
        let: 'Roky čerpání',
        letS: 'Roky spoření',
        pocatek: 'Už naspořeno',
        renta: 'Požadovaná měsíční renta',
        vynos: 'Zhodnocení v penzi',
        vynosS: 'Zhodnocení při spoření',
        zam: 'Zaměstnavatel měsíčně',
      },
      grafCerpani: 'Zůstatek během čerpání',
      grafCerpaniAria: 'Plošný graf zůstatku během {roky} čerpání renty {renta} měsíčně',
      grafSporeni: 'Spoření a čerpání renty',
      grafSporeniAria: 'Plošný graf: spoření {sporeni} na {castka}, potom {roky} čerpání renty {renta}',
      kpiNasporeno: 'Naspořeno při tomto vkladu',
      kpiPotreba: 'Potřebná částka v penzi',
      kpiRenta: 'Měsíční renta',
      kpiSporit: 'Měsíčně spořit',
      kpiStatZam: 'Stát a zaměstnavatel měsíčně',
      kpiVyplaceno: 'Vyplaceno celkem',
      kpiZUroku: 'Z toho výnos v penzi',
      kpiZtrata: 'Ztráta v penzi',
      letRenty: '{roky} renty',
      letRentyPo: '{roky} renty po {renta}',
      nadCastku: 'nad naspořenou částku {castka}',
      nelze: {
        nedosazitelne: 'Při zadaném zhodnocení nelze dosáhnout. Zkuste delší dobu spoření nebo vyšší zhodnocení.',
        nulovaDoba: 'Doba spoření je 0 měsíců. Zkuste delší dobu spoření.',
      },
      nelzeSpocitat: 'nelze spočítat',
      nicKPrevzeti: 'Modelace zatím nemá platný výsledek.',
      odchod: 'Odchod do penze {rok}',
      osaRokPenze: 'Osa: rok penze (0 = začátek penze)',
      pokryto: 'Na požadovanou rentu stačí už zadané úspory a příspěvky zaměstnavatele. Vlastní měsíční vklad není potřeba.',
      pozn: 'Modelový výpočet, ne garance.',
      poznDostavatInfo: 'Renta je anuita s výplatou na začátku měsíce: měsíční sazba = roční zhodnocení / 12, na konci doby čerpání je zůstatek nulový. Při 0 % se částka jen rozdělí na stejné výplaty. Inflace a daně z výplat se neuvažují.',
      poznSporitInfo: 'Měsíční vklad je nejmenší celá částka v Kč, při které naspořená suma pokryje požadovanou rentu. Spoření: měsíční úročení (roční výnos / 12), vklady na začátku měsíce, státní příspěvek podle pravidel od 7/2024. Renta je anuita s výplatou na začátku měsíce. Inflace se neuvažuje.',
      prevzato: 'Převzato z modelace.',
      prevzit: 'Převzít z modelace',
      rentaMes: 'renta {renta} měsíčně',
      rokRenty: '{n}. rok renty',
      rokSporeni: '{n}. rok spoření',
      slCelkem: 'Vyplaceno celkem',
      slFaze: 'Fáze',
      slRokPenze: 'Rok penze',
      slVklady: 'Vklady za rok',
      slVyplaty: 'Výplaty za rok',
      slZaRok: 'Vyplaceno za rok',
      slZustatek: 'Zůstatek na konci roku',
      sporit: 'Kolik spořit',
      staciUspory: 'stačí už zadané úspory a příspěvky',
      stat: 'Spořit v penzijku se státním příspěvkem',
      statInfo: '20 % z vlastního vkladu od 500 Kč, max. 340 Kč měsíčně.',
      statZamSub: 'stát {stat}, zaměstnavatel {zam}',
      uvod: 'Kolik bude klient dostávat z naspořené částky, nebo kolik musí spořit pro požadovanou rentu.',
      vyplatFew: '{n} měsíční výplaty',
      vyplatMany: '{n} měsíčních výplat',
      vyplatOne: '{n} měsíční výplata',
      zaokrouhleno: 'vlastní vklad, zaokrouhleno nahoru',
      zustatek: 'Zůstatek',
    },
    sdileni: {
      doba: 'Doba spoření',
      mesicne: '{castka} měsíčně',
      uvod: 'Dobrý den, posílám modelaci penzijka a DIP — kolik měsíčně a co z toho může být v penzi. Mrkněte a kdyžtak se ozvěte.',
      veta1: 'Penze je běh na dlouhou trať: čím dřív se začne, tím víc pracuje složené úročení.',
      veta2: 'Jde o modelový výpočet s předpokládaným výnosem, ne o garanci. Skutečný výsledek se bude lišit.',
    },
    sl: {
      celkem: 'Celkem',
      danPriVyberu: 'Daň při výběru',
      danZVynosu: 'Daň z výnosu',
      nasporeno: 'Naspořeno',
      predDani: 'Naspořeno před daní',
      produkt: 'Produkt',
      rok: 'Rok',
      vek: 'Věk',
      vynos1: 'Výnos*',
      vynos2: 'Výnos**',
      vynosFondu: 'Výnos fondu',
    },
    slozky: {
      stat: 'Stát',
      vlastni: 'Vlastní vklady',
      zamestnavatel: 'Zaměstnavatel',
      zhodnoceni: 'Zhodnocení',
      zhodnoceniPoDani: 'Zhodnocení po dani',
    },
    stranka: {
      nadpis: 'Penzijko a DIP',
      paticka1: 'Modelace, ne garance. Minulé výnosy nezaručují budoucí. Nejde o investiční doporučení.',
      paticka2: 'Výnosy fondů jsou po poplatcích (APS ČR, banky.cz). Pravidla státní podpory platná od 1. 7. 2024, stav k říjnu 2026. Výpočet není návrhem na uzavření smlouvy.',
      podnadpis: 'Modelace do budoucna, historie fondů, srovnání fondů a plán renty.',
      poslat: 'Poslat klientovi',
      skVeta: 'Kalkulačka počítá české penzijko (DPS) a DIP podle pravidel ČR, částky jsou v Kč.',
      stitek: 'Penzijní kalkulačka',
      tisk: 'Tisk / PDF',
      zalozky: {
        fondy: 'Srovnání fondů',
        historie: 'Historická',
        modelace: 'Modelace DPS + DIP',
        renta: 'Plán renty',
      },
      zalozkyAria: 'Penzijní kalkulačky',
    },
    strategieNazev: {
      dynamicky: 'Dynamická',
      jina: 'Jiná',
      konzervativni: 'Konzervativní',
      transformovany: 'Transformované fondy',
      vyvazeny: 'Vyvážená',
    },
    tabulkaPoLetech: 'Tabulka po letech',
    upozorneni: {
      duchodceBezStatu: 'Poživatel starobního důchodu státní příspěvek nedostává (od 7/2024).',
      pravidloNesplneno: 'Pravidlo 60 let + {min} měsíců není splněno: státní příspěvky se vracejí, výnos a příspěvky zaměstnavatele se daní 15 %, odpočty se dodaňují (orientační výpočet).',
      zamNadLimit: 'Příspěvek zaměstnavatele {rocne} ročně je nad osvobozeným limitem {limit} (DPS + DIP + životní pojištění dohromady).',
    },
  },
  /* BLOK:penze2 END */
  /* BLOK:vydajePravidlo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vydajePravidlo: {
    tip: 'Výdaje jsou vyplněné z pravidla ({pct} %) — je to odhad z příjmu, ne čísla od klienta. Klidně je přepište.',
    tipNazev: 'Výdaje z pravidla',
  },
  /* BLOK:vydajePravidlo END */
  /* BLOK:rozpisKategorii START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisKategorii: {
    planPocita: 'plán teď počítá s tímto číslem',
    pouzit: 'Použít jako obvyklé výdaje',
    prepis: 'Rozpis po kategoriích ({castka}) se tím přepíše součty z detailu — plán jinak počítá s vyšším z obou čísel.',
    radek: 'Z rozpisu po kategoriích',
    sedi: 'sedí s obvyklými výdaji',
    smazano: 'Rozpis po kategoriích smazán',
    smazat: 'Smazat rozpis',
    vratit: 'Vrátit',
  },
  /* BLOK:rozpisKategorii END */
  /* BLOK:smrtVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  smrtVysvetleni: {
    aria: 'Po úmrtí rodina potřebuje {potreba}, přijde {prijde}, chybí {chybi}.',
    ariaPrebyva: 'Po úmrtí rodina potřebuje {potreba}, přijde {prijde}, zbude {prebyva}.',
    bezVydaju: 'Krytí smrti nejde spočítat — v analýze chybí výdaje.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} v dnešních cenách. Počítáme, že vyplacené peníze budou uložené s modelovým výnosem 4 % nad inflaci (model, ne garance). Proto dnes stačí {kapital}.',
    chybiVeta: 'chybí {castka} každý měsíc · {roky}',
    cilBezHorizontu: 'cíl {nazev} bez horizontu, nezapočten',
    duchod: 'vdovský a sirotčí důchod od státu',
    duchodBezDeti: 'vdovský důchod od státu',
    duchodSablona: 'pozůstalostní důchod (šablona země)',
    jenUkazka: 'Jen ukázka — do plánu se nic nezapisuje.',
    krok1: 'Výdaje rodiny po úmrtí',
    krok1Pod: 'o {pct} % méně než dnes ({vydaje})',
    krok2: 'Co rodině přijde',
    krok3: 'Co chybí — na {roky}',
    krok4: 'Limit smrti',
    krok4Metoda: 'Kapitálová metoda',
    krok4Pod: 'co chybí + dluhy + cíle − co už máte',
    krok5Minimum: 'Starší metodika: nejméně dluhy + roční příjem + děti do samostatnosti',
    krok5MinimumBezPrijmu: 'Starší metodika: nejméně doplacení dluhů',
    mezisoucet: 'kapitálovou metodou',
    minimumDite: '{jmeno} do {vek} let',
    minimumDiteBezJmena: 'dítě',
    minimumPrijem: 'Roční příjem rodiny',
    minimumVeta: 'Vyšlo víc než kapitálovou metodou, proto platí tohle.',
    model: 'Orientační model, ne garance: počítá s výnosem 4 % nad inflaci, při nižším výnosu vychází limit vyšší. Vdovský a sirotčí důchod je orientační šablona, skutečnou výši určí stát. Renta (finanční nezávislost) se do smrti nezapočítává — po úmrtí ji už nikdo nečerpá; společné cíle zůstávají. Plnění určují pojistné podmínky.',
    nepotreba: 'Rodině by zůstal dostatečný příjem — krytí smrti není nutné.',
    nicNechybi: 'Příjmy pokryjí výdaje rodiny přesně.',
    odvozeneRoky: 'odvozeno: horizont {roky} podle šablony',
    orezano: 'Příjmy a majetek rodině vystačí — krytí smrti není nutné.',
    partner: '{jmeno} dál vydělává',
    pasivniAria: 'Pasivní příjem {castka}, limit smrti {limit}',
    pasivniTitul: 'Kdybyste dnes měli pasivní příjem',
    pasivniVeta: 'Pojištění je cena za to, že zatím nemáme pasivní příjem.',
    poPrepoctu: 'Po přepočtu podle nové metodiky platí kapitálová metoda ({castka}).',
    prahMezera: 'pokryje mezeru',
    prahNula: 'pojistka není potřeba',
    prebyvaVeta: 'Příjmy rodině vystačí a zbude {castka} — o to je limit nižší.',
    rada: {
      chybi: 'chybí',
      dnes: 'výdaje po úmrtí',
      duchod: 'důchod od státu',
      partner: 'příjem partnera',
      pasivni: 'pasivní příjem',
    },
    radekChybi: 'Co chybí na {roky}',
    radekCile: 'Zainvestovat na cíle (dnešní hodnota)',
    radekDluhy: 'Doplatit dluhy',
    radekMajetek: 'Co už máte na účtech',
    radekPrebytek: 'Co rodině z příjmů zbude navíc — za {roky}',
    rucne: 'Na kartě je ručně {rucni}, spočítáno {spocitano}.',
    skryt: 'Skrýt výpočet',
    staraMetodika: 'Starší metodika — platí minimum.',
    titul: 'Jak vzniká částka smrti',
    toggle: 'Jak se počítá smrt',
    vysledek: 'Limit smrti',
    zaokrouhleni: 'Řádky jsou zaokrouhlené, jejich součet se může nepatrně lišit.',
  },
  /* BLOK:smrtVysvetleni END */
  /* BLOK:poradiRizik START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiRizik: {
    invaliditaSmrt: 'invalidita / smrt',
  },
  /* BLOK:poradiRizik END */
  /* BLOK:splatkaUveru START — generuje scratchpad/slovnik.py, ručně needitovat */
  splatkaUveru: {
    infoNazev: 'Z čeho se částka skládá',
    rozpad: 'Od r. {rok}: splátka úvěru {uver}/měs + cíle zadané ručně nad rozpočet {rucni}/měs.',
    rozpadOchrana: 'Od r. {rok}: splátka úvěru {uver}/měs + ochrana nad přebytek {ochrana}/měs.',
    rozpadOchranaRucni: 'Od r. {rok}: splátka úvěru {uver}/měs + ochrana nad přebytek {ochrana}/měs + cíle zadané ručně nad rozpočet {rucni}/měs.',
    schodek: 'Od r. {rok} chybí {castka}/měs — splátka je vyšší, než dovoluje rozpočet.',
    schodekNejvic: 'Nejvíc chybí {castka}/měs od r. {rok}.',
  },
  /* BLOK:splatkaUveru END */
  /* BLOK:kartaCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kartaCile: {
    akontace: 'Akontace',
    bezUveru: 'Celou částku zaplatíte z vlastních peněz — úvěr není potřeba.',
    cashflowBezNajmu: 'Od r. {rok} splátka {splatka} po dobu {roky}.',
    cashflowDvaUvery: 'Od r. {rok} splátka {splatka} — z toho stavebko {stavebko} jen {rokyStavebko}, hypotéka {roky}.',
    cashflowGraf: 'cashflow v čase',
    cashflowKlesne: 'Od r. {rok} splátka {splatka}, nájem {najem} odpadne — přebytek klesne o {zmena}.',
    cashflowSNajmem: 'Od r. {rok} splátka {splatka}, nájem {najem} odpadne — přebytek {zmena}.',
    cashflowStoupne: 'Od r. {rok} splátka {splatka}, nájem {najem} odpadne — přebytek stoupne o {zmena}.',
    celkem: 'celkem',
    celkemZaplatite: 'Celkem zaplatíte',
    celyText: 'celý text',
    cerpani: 'čerpání',
    cilCara: 'cíl {castka}',
    cnbKratce: 'do 36 let stačí 10 % vlastních zdrojů, jinak 20 %',
    detailInvestice: 'Detail investice',
    detailInvesticePod: 'rozložení v čase, historie',
    dofDopadProdej: 'Vlastní zdroje se sníží o {snizeni} — k naspoření zbývá {zbyva}.',
    dofDopadZastava: 'Banka posuzuje úvěr k oběma nemovitostem: až {uver} ({ltv} % z {zaklad}) → vlastní zdroje {vlastni}. Souhlas zástavce, odhad i bonitu ověřit u banky.',
    dofHodnotaZastavy: 'hodnota zástavy',
    dofJiny: 'jiný majetek',
    dofNe: 'ne',
    dofOdebrat: 'odebrat',
    dofPouzitZastavu: 'použít jako zástavu',
    dofPouzitoU: 'použito u cíle {cil}',
    dofProdej: 'prodej nemovitosti',
    dofStaraMetodika: 'Plán je spočítaný podle starší metodiky — dofinancování se projeví po přepočtu podle nové metodiky.',
    dofStitekOcekavane: 'očekávané',
    dofStitekOverteDruh: 'ověřte druh',
    dofStitekStehovani: 'jen při stěhování',
    dofStitekZatizeni: 'ověřte zatížení (hypotéka {castka})',
    dofStitekZatizeniBez: 'ověřte zatížení hypotékou',
    dofVynos: 'výnos z prodeje',
    dofZAnalyzy: 'V analýze zvoleno jako zástava: {nazev} · {hodnota}',
    dofZadnaZastava: 'V analýze není nemovitost — zadejte hodnotu ručně.',
    dofZadnyJiny: 'V analýze není nic k prodeji — částku zadejte ručně.',
    dofZadnyProdej: 'V analýze není nemovitost k prodeji — částku zadejte ručně.',
    dofZastava: 'zástava nemovitosti (vlastní nebo rodičů)',
    dofZbyde: 'Z prodeje zbyde {castka}.',
    dofZrusenoChybi: '„{nazev}“ už v analýze není — uložená volba se nepočítá.',
    dofZrusenoJiny: '„{nazev}“ je nemovitost — patří k prodeji nebo zástavě. Uložená volba se nepočítá.',
    dofZrusenoPouzito: '„{nazev}“ už je započtené u cíle {cil} — jedna položka jen jednou. Uložená volba se nepočítá.',
    dofZrusenoProdej: '„{nazev}“ není v analýze nemovitost — uložený prodej se nepočítá.',
    dofZrusenoUver: 'Zástava u spotřebitelského úvěru nejde — uložená volba se nepočítá.',
    dofZrusenoZastava: '„{nazev}“ zastavit nejde — zástava jen u nemovitosti. Uložená volba se nepočítá.',
    doporuceno: 'doporučeno',
    grafAriaModel: 'Vložíte {vlozeno}, za {roky} modelově {hodnota}, výnos {vynos} — modelace, ne záruka.',
    hotove: 'hotově',
    hotovePct: 'hotově {pct} %',
    hypoVychozi: 'Prázdné pole = výchozích {sazba} % na {roky} let, ne nabídka banky.',
    hypotekaVyse: 'Hypotéka',
    hypotekaZaRoky: 'Hypotéka za {roky}',
    jednorazoveDnes: 'Jednorázově dnes',
    jenHypotekaAria: 'Graf ukazuje jen hypotéku, bez úvěru ze stavebka.',
    kolikHotove: 'Kolik zaplatíte hotově',
    kombinace: 'Vaše volné peníze + zbytek měsíčně',
    kombinacePod: '{jedn} jednorázově z vašich peněz, zbytek {mes} měsíčně',
    kombinacePodNestaci: '{jedn} jednorázově z vašich peněz, zbytek {mes} měsíčně — víc, než přebytek na cíl dává',
    krok1: 'Naspořit',
    krok1Hotove: 'Naspořit, co zaplatíte hotově',
    krok1Rezerva: 'Naplnit rezervu',
    rezervaBezVydaju: 'Rezervu nejde spočítat — v analýze chybí výdaje.',
    krok1Vlastni: 'Naspořit vlastní zdroje',
    krok2Hypo: 'Půjčit si hypotékou',
    krok2Uver: 'Půjčit si úvěrem',
    krok3: 'Dofinancovat z majetku',
    krytoZeZdroju: 'Kryto z vašich peněz — nic navíc není potřeba.',
    mesNestaci: 'přebytek na to dává {prideleno} — chybí {chybi}',
    mesNestaciKroky: 'v plánu od teď {prideleno}, pak víc — viz popořadě',
    mesPakVic: 'dnes, pak víc — viz popořadě',
    modelovaHodnota: 'Modelová hodnota',
    modelove: 'modelově',
    nadPrebytek: 'víc, než je volný přebytek',
    nbsKratce: '20 % vlastních zdrojů, 10 % jen výjimečně',
    neboMesicne: 'nebo měsíčně',
    neboMesicneRenta: 'nebo měsíčně',
    nejistota: 'Modelace ({scenar}) v dnešních cenách, ne záruka — skutečný výnos se bude lišit.',
    nicSporit: 'Není co spořit.',
    nicSporitUver: 'Není co spořit — celou cenu řeší úvěr a majetek (krok 2 a 3).',
    obaUvery: 'Oba úvěry dohromady',
    obojiUlozene: 'Jednorázově i měsíčně (uloženo v plánu)',
    odRoku: 'od {rok}',
    odTed: 'od teď',
    osaJednorazove: 'jednorázově — {zdroj}',
    osaJednorazovePoCili: 'jednorázově — {zdroj} · až po termínu cíle, nepočítá se',
    osaJednorazovePoRente: 'jednorázově — {zdroj} · až po začátku renty, nepočítá se',
    osaMzdaNedorazi: '{rust} — do renty nedorazí',
    osaMzdaPoCili: '{rust} — až po termínu cíle, nepočítá se',
    osaMzdaPoRente: '{rust} — až po začátku renty, nepočítá se',
    osaMzdaSplatka: '{rust} — celý ho spotřebuje splátka úvěru, do renty nedorazí',
    osaRustMzdy: 'růst mzdy',
    osaRustMzdyPozde: '{rust} od {rok} — do té doby ho spotřebuje splátka úvěru',
    osaRustMzdyPozdeObecne: '{rust} od {rok}',
    osaRustMzdySablona: 'růst mzdy (odhad)',
    osaUverSplacen: 'doplatí se úvěr na {cil}',
    osaUvolneno: 'uvolněné peníze z přebytku',
    osaZCile: 'uvolní se z cíle {cil} (naspořeno)',
    osaZaklad: 'pravidelná investice',
    osaZakladMzda: 'z toho +{castka} díky růstu mzdy od {rok}',
    pasmo: 'horší až lepší scénář',
    pasmoBublina: 'Horší – lepší scénář',
    pasmoSouhrn: 'horší až lepší scénář {od} – {do}',
    pctZ: '{pct} % z {cena}',
    plneniZa: 'Plnění cíle {kdy} ({scenar})',
    plusStavebko: '+ úvěr ze stavebního spoření {castka} na {roky} let = {splatka}{mes} (vlastní sazba)',
    poporade: 'Popořadě',
    proVsechnyCile: 'Pro všechny cíle:',
    pujcite: 'Půjčíte si',
    puvodniNavrh: 'zpět na původní návrh',
    realne: 'reálně',
    resiSeUveremHotove: 'Spoří se jen to, co zaplatíte hotově, zbytek řeší úvěr — splátka nastupuje od čerpání.',
    rezimBezSchodu: 'Zvolená cesta počítá rovnou platbu — navýšení z původního návrhu',
    rokSplaceni: '{n}. rok splácení',
    rustBez: 'bez růstu',
    rustBezRustu: 'Plán s růstem vkladu nepočítá — a nastavení žádný nepředepisuje.',
    rustChybi: 'Růst mzdy se zatím NEPOČÍTÁ — v plánu žádné kroky nejsou. Klikněte na Započítat růst mzdy.',
    rustLisi: 'Kroky růstu mzdy v plánu se od nastavení LIŠÍ — plán počítá z nich. Srovnejte je tlačítkem Započítat růst mzdy.',
    rustLisiKratce: 'v plánu jsou jiné kroky',
    rustLisiZahod: 'Plán počítá z kroků růstu mzdy, ale z nastavení žádný růst nevyjde — zahoďte je, ať plán odpovídá nastavení.',
    rustMzdy: 'Růst mzdy',
    rustNepocita: 'zatím se nepočítá',
    rustPopis: '{pct} {baze} každých {krok} let',
    rustRealne: 'reálně, nad inflací — plán počítá v dnešních cenách a inflaci nepřičítá.',
    rustRucniPolozka: '+{castka} od {rok}',
    rustSablonaNeRucniAno: 'šablona zatím ne · v plánu je ruční {rucni}',
    rustSedi: 'S tímhle tempem plán počítá — kroky růstu mzdy v plánu nastavení odpovídají.',
    rustVPlanu: 'v plánu ({n} kroků)',
    rustVPlanuPo: 'v plánu: {n} do renty, {po} až po jejím začátku',
    schodyAria: 'Měsíční vklad roste z {od} na {do}.',
    seZastavou: 'se zástavou',
    sjednotit: 'sjednotit s plánem',
    skrytGraf: 'skrýt graf',
    splatkaMesicne: 'Splátka měsíčně',
    splatkaRozpis: 'hypotéka {hypo} + stavebko {stavebko} ({roky})',
    spotrVychozi: 'Prázdné pole = orientačních {sazba} % na {roky} let (nejvýš {max} let) — ověřit u banky.',
    srovnatRust: 'Srovnat s nastavením',
    stavebkoZaRoky: 'Úvěr ze stavebka {castka} za {roky}',
    upravit: 'upravit',
    upravitRucne: 'upravit částky ručně',
    uverSpotrebitelsky: 'spotřebitelský úvěr',
    uverStavebko: 'úvěr ze stavebního spoření',
    uzMate: 'Už máte',
    vPlanuNestaci: 'v plánu — nestačí',
    vRoce: 'v r. {rok}',
    vetaRoku: 'vloženo {vlozeno} · hodnota {hodnota} · výnos {vynos}',
    vlastniProfil: 'vlastní profil: {profil}',
    vlastniZdroje: 'vlastní zdroje',
    vlozeno: 'Vloženo',
    vlozite: 'Vložíte',
    volitelne: 'volitelné',
    volnychJen: 'volných máte {volne}',
    vybrano: 'vybráno',
    vynos: 'výnos',
    zPrebytku: 'z měsíčního přebytku',
    zTohoHotove: 'z toho hotově',
    zVolnych: 'z volných peněz (máte {volne})',
    zahoditKrokyTitul: 'Smaže z plánu kroky růstu mzdy ze šablony — plán pak počítá bez nich, přesně jak je nastaveno.',
    zapocitatRust: 'Započítat růst mzdy',
  },
  /* BLOK:kartaCile END */
  /* BLOK:klientEmail START — generuje scratchpad/slovnik.py, ručně needitovat */
  klientEmail: {
    chybaAdresa: 'Zkontroluj e-mailovou adresu klienta.',
    chybaPredmet: 'Doplň předmět.',
    chybaTelo: 'Doplň text zprávy.',
    crmBezEmailu: 'U klienta v CRM není e-mail — doplň ho ručně.',
    dalsiOdkaz: 'Vytvořit další odkaz',
    introFixace: 'Dobrý den, posílám modelaci fixace hypotéky. Klíčové je to druhé číslo — splátka po skončení fixace. Kdyby něco, ozvěte se.',
    introHistoricka: 'Dobrý den, posílám slíbenou modelaci historického vývoje investice. Mrkněte na čísla — a kdyby něco, ozvěte se.',
    introModelace: 'Dobrý den, posílám slíbenou modelaci. Mrkněte a kdyžtak se ozvěte.',
    klientNepovinne: 'Klient (nepovinné)',
    komu: 'Komu',
    kopirovaniChyba: 'Kopírování se nepovedlo.',
    kopirovat: 'Kopírovat',
    modelaceVPdf: 'Modelace v PDF',
    nadpis: 'Poslat klientovi',
    najdiKlienta: 'Najdi klienta podle jména…',
    neniEmail: 'Tohle nevypadá jako e-mailová adresa.',
    nepropojeny: 'E-mail v aplikaci zatím není propojený. Otevřu tvůj poštovní program s předvyplněnou zprávou — odeslání potvrdíš tam. (Propojit se dá v Nastavení.)',
    neznamyTransport: 'Nepodařilo se zjistit, jestli je e-mail v aplikaci propojený. Otevřu tvůj poštovní program s předvyplněnou zprávou — odeslání potvrdíš tam.',
    odejdeGmail: 'Odejde z tvého Gmailu.',
    odejdeGmailAdresa: 'Odejde z tvého Gmailu {email}.',
    odejdeSmtp: 'Odejde z tvého firemního e-mailu.',
    odejdeSmtpAdresa: 'Odejde z tvého firemního e-mailu {email}.',
    odesilam: 'Odesílám…',
    odeslanToast: 'E-mail odeslán klientovi.',
    odeslanoKlientovi: 'Odesláno klientovi.',
    odeslatChyba: 'E-mail se nepodařilo odeslat.',
    odeslatNa: 'Odeslat na {adresa}',
    odkazChyba: 'Odkaz se teď nepodařilo vytvořit. Zkuste to prosím znovu.',
    otevrete: 'Otevřete si ji tady:',
    otevrit: 'Otevřít',
    otevritPostu: 'Otevřít poštovní program',
    ozveteSe: 'Kdyby cokoli nesedělo nebo vás něco napadlo, ozvěte se — v klidu to spolu projdeme.',
    pdfChyba: 'PDF se nepodařilo vytvořit.',
    pdfStazenoToast: 'PDF staženo — přilož ho k e-mailu.',
    pdfVeStazenych: 'PDF je stažené ve tvých Souborech ke stažení.',
    popis: 'Vyber klienta, přidej úvodní zprávu a vytvoř odkaz na tuto modelaci.',
    popisHotovo: 'Odkaz je připravený — pošli ho klientovi.',
    poslatEmailem: 'Poslat e-mailem',
    postaOtevrena: 'Zpráva se otevřela v tvém poštovním programu. Aplikace ji NEODESLALA — odešli ji tam.',
    pozdrav: 'Dobrý den,',
    pozdravJmeno: 'Dobrý den, {osloveni},',
    predmet: 'Předmět',
    predmetVychozi: 'Modelace pro vás',
    priloha: 'V příloze posílám to samé v PDF.',
    prilohyNeumi: 'E-mail z aplikace zatím neumí přílohy. PDF se stáhne k tobě — přilož ho ručně, nebo klientovi stačí odkaz na modelaci, který je v textu výš.',
    sPozdravem: 'S pozdravem',
    schuzka: 'Domluvit schůzku',
    spojitSe: 'Spojit se',
    stahnoutPdf: 'Stáhnout PDF',
    textPrecti: 'Text — přečti si ho, než odešleš',
    titulFixace: 'Fixace hypotéky — co se stane po ní',
    titulHistoricka: 'Historický vývoj investice',
    titulHypoteka: 'Hypoteční modelace',
    titulInvestice: 'Investiční modelace',
    uvodVychozi: 'posílám modelaci, kterou jsme si procházeli.',
    uvodniPh: 'Dobrý den, posílám slíbenou modelaci…',
    uvodniZprava: 'Úvodní zpráva',
    vytvarim: 'Vytvářím…',
    vytvarimOdkaz: 'Vytvářím odkaz…',
    vytvoritOdkaz: 'Vytvořit odkaz',
    whatsapp: 'Napsat na WhatsApp',
    zavolejte: 'Nebo mi rovnou zavolejte: {tel}',
    zjistuji: 'Zjišťuji, kudy e-mail odejde…',
    zkopirovano: 'Zkopírováno',
  },
  /* BLOK:klientEmail END */
  /* BLOK:pdfVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  pdfVystup: {
    ctaVychozi: 'Domluvte si schůzku',
    dalsiKrok: 'Další krok',
    disclaimer: 'Modelace je orientační a vychází z historických dat. Minulé výnosy nejsou zárukou budoucích. Investice na kapitálových trzích nesou riziko ztráty části nebo celé investované částky.',
    financniPoradenstvi: 'Finanční poradenství',
    inv: {
      hero: 'Očekávaná hodnota',
      projekce: 'Projekce po letech',
      scenare: 'Scénáře na konci období',
      thOcekavany: 'Očekávaný',
      thOptimisticky: 'Optimistický',
      thPesimisticky: 'Pesimistický',
      thRok: 'Rok',
      thVklady: 'Vklady',
      titul: 'Investiční modelace',
    },
    jakTomuRozumet: 'Jak tomu rozumět',
    modelace: 'Modelace',
    modelaceDisclaimer: 'Nezávazná orientační modelace. Konkrétní podmínky a ceny upřesníme společně.',
    platnaDo: 'Platná do',
    pripravenoPro: 'Připraveno pro',
    qrAlt: 'QR kód',
    qrNavod: 'Naskenujte QR kód fotoaparátem mobilu — otevře se odkaz pro spojení s poradcem.',
    rozpis: 'Detailní rozpis',
    souhrn: 'Souhrn',
    vstupy: 'Vstupní parametry',
    vypracoval: 'Vypracoval',
  },
  /* BLOK:pdfVystup END */
  /* BLOK:zivotkoPdf START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoPdf: {
    cenaChybi: 'Konkrétní cenu doplní poradce podle vybrané pojišťovny — v tomhle dokumentu proto žádná není.',
    cenaDen: 'Rozpočítáno na den to dělá {den}.',
    cenaHlava: 'Na jednoho člena rodiny {hlava} denně.',
    cenaPct: 'To je {pct} % příjmu rodiny.',
    cenaStoji: 'Celá tahle ochrana stojí {cena} měsíčně.',
    cilMesicne: '{nazev} {castka}/měs',
    cilVychozi: 'cíl',
    disclaimer: 'Orientační doporučené krytí dle metodiky beplan. Konkrétní pojistné a podmínky dle vybrané pojišťovny. Poradce má poslední slovo.',
    heroLabel: 'Kolik rodina potřebuje, kdyby živitel zemřel',
    heroLabelInvalidita: 'Kolik rodina potřebuje, kdyby živitel nemohl pracovat',
    inCena: 'Cena krytí / měs',
    inNezbytne: 'Nezbytné výdaje / měs',
    inOsob: 'Osob v rodině',
    inPrijem: 'Příjem rodiny / měs',
    inVarianta: 'Varianta krytí',
    inZajistitNa: 'Zajistit na',
    metodika: 'Metodika {verze}.',
    naDen: '{castka}/den',
    nar1: 'Dnes má rodina {prijem} měsíčně. Představte si, že o část z toho přijde.',
    nar2: 'Když příjem klesne o 5 % ({p5} měsíčně), naštve to — ale ustojíte to. Při poklesu o 25 % ({p25}) se to dá zvládnout, jen se utahují opasky. Pokles o 50 % ({p50}) už rozpočet nedopne. A pokles o 100 % ({p100}) je konec plánů, ne jen utažený opasek.',
    nar3: 'Právě tyhle dva těžké konce žebříku návrh řeší: {inval} pro případ invalidity, {smrt} pro případ smrti a {pn} za každý den nemoci nebo úrazu. Spočítáno na {roky} dopředu, z vašich vlastních čísel — ne z tabulky průměrného Čecha.',
    nar4: 'K tomu {tnu} na trvalé následky úrazu (čím vážnější, tím vyšší výplata) a {zav} při vážné nemoci — rakovina, infarkt, mrtvice. To jsou peníze na léčbu a na čas, ne na účty.',
    nar5: 'Ochrana řeší, co se stane, když se něco pokazí. Cíle rodiny řeší, co se stane, když všechno vyjde: {cile}. Dohromady {suma} měsíčně.',
    narrativeTitle: 'Proč zrovna tolik',
    rokyFew: '{n} roky',
    rokyMany: '{n} let',
    rokyOne: '{n} rok',
    sumInval: 'Kdyby nemohl pracovat (invalidita)',
    sumPn: 'Krátká nemoc / úraz (PN)',
    sumSmrt: 'Kdyby se nevrátil (smrt)',
    summaryTitle: 'Co se stane, když…',
    tableTitle: 'Krytí po osobách',
    thInvalidita: 'Invalidita',
    thOsoba: 'Osoba',
    thPn: 'PN/den',
    thSmrt: 'Smrt',
    thTrvale: 'Trvalé následky',
    thVazna: 'Vážná nemoc',
    titul: 'Návrh ochrany rodiny',
    vic10: 'V tabulce je prvních 5 a posledních 5 osob z celkem {n} — souhrnná čísla nahoře jsou za celou rodinu.',
  },
  /* BLOK:zivotkoPdf END */
  /* BLOK:vzhledKontrola START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzhledKontrola: {
    ariaHistVyvoj: 'Vývoj hodnoty investice {od}–{do}: vloženo {vlozeno}, hodnota {hodnota}, spořicí účet {sporeni}',
    ariaRozlozeni: 'Rozložení portfolia',
    smazatCil: 'Odebrat cíl',
    smazatOsobu: 'Odebrat osobu',
    snizit: 'Snížit',
    zrusitVyber: 'Zrušit výběr období',
    zvysit: 'Zvýšit',
  },
  /* BLOK:vzhledKontrola END */
  /* BLOK:odkladaniZam START — generuje scratchpad/slovnik.py, ručně needitovat */
  odkladaniZam: {
    kino: {
      a5Zam: '+ {castka} pošle zaměstnavatel rovnou na penzijko',
      prijem503020: 'Čistý měsíční příjem vč. příspěvku zaměstnavatele',
      tokAria: 'Z výplaty {prijem} a příspěvku zaměstnavatele {zam} jde {stranou} stranou, {zivot} zbývá na život.',
      vyplataPlus: '+ příspěvek zaměstnavatele {castka}',
    },
    novyCrmOdklada: 'Odkládá {pct} % příjmů vč. příspěvku zaměstnavatele · ideál 20 % = {castka}',
    pochvala: 'Odkládáte {pct} % příjmů vč. příspěvku zaměstnavatele ({castka})',
    vc: 'vč. příspěvku zaměstnavatele',
    vodopad: {
      nejvys: 'Nejvýš jde stranou {castka} = {pct} % příjmu vč. příspěvku zaměstnavatele',
      odkladDnes: 'Stranou dnes jde {castka} = {pct} % příjmu vč. příspěvku zaměstnavatele (vlastní vklady {vklady} + příspěvek zaměstnavatele {zam} + volné peníze {volne}).',
      odkladDohoda: 'Stranou jde {castka} = {pct} % příjmu vč. příspěvku zaměstnavatele (vlastní vklady {vklady} + příspěvek zaměstnavatele {zam} + odsouhlasená částka {dohoda}).',
      posuvnikPct: '{pct} % příjmu vč. příspěvku zaměstnavatele =',
      posuvnikPrazdny: '{pct} % příjmu vč. příspěvku zaměstnavatele = —',
      stranouDnes: 'stranou dnes jde {pct} % příjmu vč. příspěvku zaměstnavatele',
      stranouDohoda: 's odsouhlasenou částkou jde stranou {pct} % příjmu vč. příspěvku zaměstnavatele',
      uzBezi: 'Už běží {castka} (vklady na spoření {vklady} + příspěvek zaměstnavatele {zam})',
    },
    zaklad: 'z {zaklad} vč. příspěvku zaměstnavatele {zam}',
  },
  /* BLOK:odkladaniZam END */
  /* BLOK:fixaceVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  fixaceVystup: {
    disclaimer: 'Historie sazeb vychází z měsíční statistiky ČNB (nové úvěry na bydlení podle délky fixace, 2006–2026). Sazba po skončení fixace je MODELOVANÁ hodnota, ne předpověď — skutečnou sazbu určí trh a banka v době refixace.',
    dlouha: 'Dlouhá fixace',
    fixaceZa: '{roky} za {sazba}',
    hero: 'Splátka po {po} při sazbě {sazba}',
    kratka: 'Krátká fixace',
    nar1: 'Graf ukazuje, jak se bude vaše splátka vyvíjet po celou dobu splatnosti — ne jen v prvních letech fixace. Krátká fixace má dnes nižší splátku, ale po skončení fixace se splátka přepočítá podle sazby, která bude platit tehdy. Tu dnes nikdo nezná.',
    nar2: 'Červená čára v grafu je váš rozpočet. Pokud ji splátka po refixaci přeleze, znamená to problém — a to je přesně to riziko, které nižší dnešní splátka skrývá.',
    nar3: 'Historie sazeb v nástroji je reálná měsíční statistika České národní banky. Není to předpověď: je to doklad o tom, jak často a jak silně se sazby v Česku pohybovaly.',
    pdfChyba: 'PDF se nepodařilo vygenerovat',
    poLetechFew: '{n} letech',
    poLetechMany: '{n} letech',
    poLetechOne: '{n} roce',
    rokyFew: '{n} roky',
    rokyMany: '{n} let',
    rokyOne: '{n} rok',
    sazbaPo: 'Sazba po refixaci (modelovaná)',
    sazbaUnese: 'Sazba, kterou rozpočet ještě unese',
    splatkaDlouha: 'Splátka u fixace na {roky}',
    splatkaPo: 'Splátka po {po} při {sazba}',
    splatkaTed: 'Splátka teď (krátká fixace)',
    splatnost: 'Splatnost',
    unese: 'Na splátku unese',
    unesePct: '{castka} ({pct} % příjmu)',
    vyse: 'Výše hypotéky',
  },
  /* BLOK:fixaceVystup END */
  /* BLOK:kinoPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoPrijmy: {
    a1BigDoplnte: 'Doplňte příjmy a rozdělíme je',
    a1BigPrijem: 'Váš čistý měsíční příjem',
    a1Kicker: 'Kde mizí peníze',
    a1L1: 'Většina lidí netuší, kolik a kam utratí.',
    a1L2: 'Bez systému zůstane na konci měsíce nula.',
    a1Nar: '„Pojďme se podívat, jak vaše peníze rozdělit, aby z nich něco zůstalo i na sny.“',
    a1Title: 'Kam každý měsíc utečou peníze?',
    a2Big: 'Jednoduchý systém, který funguje',
    a2Kicker: 'Pravidlo',
    a2L1: '50 % nezbytné výdaje — bydlení, jídlo, energie, splátky.',
    a2L2: '30 % životní styl — radosti, koníčky, restaurace.',
    a2L3: '20 % stranou na cíle — rezerva, investice, renta.',
    a2Title: 'Pravidlo 50 / 30 / 20',
    a3Kicker: 'Kolik u VÁS',
    a3L2: '20 % = {castka} na dlouhodobé cíle.',
    a3Title: '20 % je váš motor nezávislosti',
    a6Big: 'Vaše cesta ke svobodě',
    a6Kicker: 'Začněte dnes',
    a6L1: 'Z těch 20 % se časem stane vaše renta.',
    a6L2: 'Pravidelnost + čas = peníze začnou pracovat za vás.',
    a6Nar: '„Těch 20 % dnes je vaše finanční nezávislost zítra. Pojďme to rozjet.“',
    a6Title: '20 % pravidelně = finanční nezávislost',
    dejstviAria: 'Dějství {n}',
    nazev: 'Příjmy a výdaje',
  },
  /* BLOK:kinoPrijmy END */
  /* BLOK:kinoRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoRizika: {
    a1: {
      aria: 'Cesta k vašim cílům: {cile}.',
      ariaBezCilu: 'Cesta k cílům, které si teprve doplníme.',
      ariaDalsi: 'Cesta k vašim cílům: {cile} a {n} dalších.',
      cile: '{cile}.',
      cileADalsi: '{cile} a další.',
      dalsiCilFew: 'a {n} další cíle',
      dalsiCilMany: 'a {n} dalších cílů',
      dalsiCilOne: 'a {n} další cíl',
      kicker: 'Váš plán',
      radekBezCilu: 'Cíle si spolu doplníme.',
      radekKrok: 'Krok za krokem, jak jsme si řekli.',
      rezie: 'Nechte klienta chvíli koukat.',
      tahak: '„Tohle je váš plán: {cile}. Krok za krokem.“',
      tahakBezCilu: '„Než začneme plánovat, řekněte mi, co chcete dokázat.“',
      tahakDalsi: '„Tohle je váš plán: {cile} a další. Krok za krokem.“',
      tahakHned: '{cil} hned',
      tahakVRoce: '{cil} v roce {rok}',
      titulek: 'Tohle je váš plán',
      titulekBezCilu: 'Plán stavíme na vašich cílech',
    },
    a1Big: 'Co může plán ohrozit?',
    a1Kicker: 'Nejdřív zajistit',
    a1L1: 'Plán musí stát na pevných základech — na ochraně.',
    a1L2: 'Jeden výpadek umí zbořit všechny cíle naráz.',
    a1Nar: '„Než začneme stavět sny, musíme zajistit základ. Jinak jedna nehoda smete celý plán.“',
    a1Title: 'Nejdřív zajistíme, pak budujeme',
    a2: {
      aria: 'Nad cestou k cílům jsou tři mraky: výpadek příjmu (nemoc, úraz, invalidita, úmrtí) — největší, ztráta majetku (požár, voda, krádež) a odpovědnost za škodu jinému.',
      invalidita: 'Invalidita',
      kicker: 'Rizika',
      kradez: 'Krádež',
      majetek: 'Ztráta majetku',
      nejvetsi: 'Největší',
      nemoc: 'Nemoc',
      pozar: 'Požár',
      radek1: 'Rizik je spousta.',
      radek2: 'Hlavní jsou tři: příjem, majetek a odpovědnost.',
      rezie: 'Nehodnoťte a nestrašte.',
      skodaJinemu: 'Škoda jinému',
      tahak: '„Plán počítá s tím, že všechno půjde podle představ. Život ale občas přinese mrak. Rizik je spousta — hlavní jsou tři: příjem, majetek a odpovědnost.“',
      titulek: 'Co může plán ohrozit?',
      umrti: 'Úmrtí',
      uraz: 'Úraz',
      voda: 'Voda',
    },
    a2BezDeti: 'Váš příjem živí celou domácnost.',
    a2BezHypo: 'Bez příjmu se zastaví všechno ostatní.',
    a2Big: 'Příjem = motor celého plánu',
    a2DetiFew: 'Máte {n} děti — rodina stojí na vašem příjmu.',
    a2DetiMany: 'Máte {n} dětí — rodina stojí na vašem příjmu.',
    a2DetiOne: 'Máte {n} dítě — rodina stojí na vašem příjmu.',
    a2Hypo: 'Hypotéku je nutné ufinancovat i při výpadku.',
    a2Kicker: 'Riziko č. 1',
    a2L2: 'Invalidita, dlouhodobá nemoc, úmrtí — pojištění příjmu.',
    a2Nar: '„Největší riziko není trh — je to ztráta schopnosti vydělávat. To řešíme jako první.“',
    a3: {
      ariaBezPrijmu: 'Plán stojí na příjmu, který zatím neznáme.',
      ariaDopad: 'Když {jmeno} dlouho nemůže pracovat: {dopad} ({pozn}).',
      ariaMensiDil: '{jmeno} nese menší díl.',
      ariaNese: 'Nese ho {jmeno}.',
      ariaNevime: 'Když {jmeno} dlouho nemůže pracovat, kolik zbyde na cíle, spočítáme příště i s dávkami od státu.',
      ariaVetsiDil: '{jmeno} nese větší díl.',
      ariaZaklad: 'Plán stojí na příjmu {castka} měsíčně.',
      bezDavek: 'bez dávek od státu',
      jede: 'Plán pojede dál',
      kicker: 'Největší riziko',
      klient1: 'Klient 1',
      klient2: 'Klient 2',
      mene: 'Na cíle zbyde méně',
      nemuze: '{jmeno} dlouho nemůže pracovat',
      nevime: 'Co zbyde, spočítáme příště',
      nevimePozn: 'i s dávkami od státu',
      nezbyde: 'Na cíle nezbyde',
      obaPracuji: 'Oba pracují',
      pasivni: 'Pasivní příjem',
      pracuje: '{jmeno} pracuje',
      prijemDoplnime: 'Příjem doplníme',
      radek: 'Celý plán stojí na vašem příjmu.',
      radekBezPrijmu1: 'Celý plán stojí na příjmu.',
      radekBezPrijmu2: 'Příjmy zatím chybí — doplníme je.',
      rezie: 'Klepněte na tlačítka pod obrázkem. Krytí dnes nepočítejte.',
      skupinaAria: 'Co kdyby',
      tahakBezPrijmu: '„Celý plán stojí na příjmu. Doplníme ho a příště si ukážeme, co ho drží.“',
      tahakJede: '„Celý plán stojí na vašem příjmu. Když {jmeno} dlouho nemůže pracovat, plán pojede dál. Část by nahradil stát — kolik, si spočítáme příště.“',
      tahakMene: '„Celý plán stojí na vašem příjmu. Když {jmeno} dlouho nemůže pracovat, na cíle zbyde méně. Část by nahradil stát — kolik, si spočítáme příště.“',
      tahakNevime: '„Celý plán stojí na vašem příjmu. Když {jmeno} dlouho nemůže pracovat, příjem klesne. Kolik zbyde na cíle a kolik nahradí stát, si spočítáme příště.“',
      tahakNezbyde: '„Celý plán stojí na vašem příjmu. Když {jmeno} dlouho nemůže pracovat, na cíle nezbyde. Část by nahradil stát — kolik, si spočítáme příště.“',
      vasPlan: 'VÁŠ PLÁN',
      velkePopis: 'měsíčně nese celý plán',
      vychoziBezPrijmu: 'Bez příjmů nevíme, co plán nese',
      vychoziJede: 'Příjem běží, plán jede',
      vychoziMene: 'Na cíle teď zbývá méně, probereme v plánu',
      vychoziNezbyva: 'Na cíle teď nezbývá, probereme v plánu',
    },
    a3Auto: 'Auto → povinné ručení + havarijní.',
    a3Big: 'Kompletní štít rodiny',
    a3Domacnost: 'Domácnost a vybavení — pojištění majetku.',
    a3Firma: 'Firma → firemní pojištění a přerušení provozu.',
    a3Kicker: 'Majetek & odpovědnost',
    a3L2: 'Odpovědnost (i vůči zaměstnavateli), právní ochrana.',
    a3Nar: '„Kromě příjmu hlídáme majetek, odpovědnost, auto, právní ochranu a u podnikatelů i firmu.“',
    a3Nemovitost: 'Nemovitost + domácnost — pojištění majetku.',
    a3Title: 'Co všechno chráníme',
    a4: {
      aria: 'Vaše cíle pod čárkovaným štítem: zajištění doplníme na příští schůzce.',
      coKryje: 'Co to kryje a co ne',
      coMate: 'Co máte',
      domluveno: '(domluveno)',
      jakZapadne: 'Jak to zapadne do plánu',
      kicker: 'Příště',
      naDalsiSchuzce: 'Na další schůzce',
      pojistneSmlouvy: 'pojistné smlouvy',
      radek: 'Dnes nic neřešíme.',
      rezie: 'Pak v Závěru zaškrtněte podklad Pojistné smlouvy.',
      rezieHotovo: 'Podklad Pojistné smlouvy už je v Závěru zaškrtnutý.',
      sSebou: 'S sebou:',
      tahak: '„V rámci finančního plánu se podíváme i na vaše zajištění — co máte dnes, co kryje a co ne. Ověříme, jestli se dá ušetřit nebo pojistit chytřeji, a ukážeme, jak to zapadne do celého plánu.“',
      titulek: 'Na další schůzce si je projdeme',
    },
    a4Big: 'Zajištění = klid pro celý plán',
    a4Kicker: 'Závěr',
    a4L1: 'Projdeme každé krytí — ať rodina nikdy nestojí na vodě.',
    a4L2: 'Teprve dobře zajištěný plán má smysl stavět.',
    a4L3: 'Je to nudné, ale je to úplný základ.',
    a4Nar: '„Tohle je možná nejdůležitější část. Pojďme společně projít, co máte pokryté a kde jsou díry.“',
    a4Title: 'Na tohle se společně mrkneme',
    cil: {
      auto: 'Auto',
      bydleni: 'Bydlení',
      cil: 'Cíl',
      deti: 'Děti',
      dnes: 'dnes',
      investice: 'Investice',
      podnikani: 'Podnikání',
      rekonstrukce: 'Rekonstrukce',
      renta: 'Renta',
      rezerva: 'Rezerva',
    },
    iAuto: 'Auto (PR + hav.)',
    iDomacnost: 'Domácnost',
    iFirma: 'Firma / provoz',
    iInvalidita: 'Invalidita / nemoc',
    iNemovitost: 'Nemovitost',
    iOdpovednost: 'Odpovědnost',
    iPravni: 'Právní ochrana',
    iUmrti: 'Úmrtí (rodina)',
    iVypadek: 'Výpadek příjmu',
    iZamestnani: 'Zaměstnání',
    nazev: 'Zajištění rizik',
  },
  /* BLOK:kinoRizika END */
  /* BLOK:histKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  histKalk: {
    alokacePomery: 'Alokace · poměry',
    bezPoplatku: 'Bez poplatků. Zadej je, ať klient vidí, kolik z jeho peněz odejde na náklady.',
    bezpecnaRenta: 'Bezpečná měsíční renta',
    brzdaBez: 'Bez brzdy',
    brzdaCil: 'Na cíl',
    brzdaNadpis: 'Brzda (postupné odrizikování)',
    brzdaPopisBez: 'Alokace konstantní celou dobu.',
    brzdaPopisCil: 'Posledních ~10 let přesun do hotovosti (jednorázový cíl).',
    brzdaPopisRenta: 'Mírné odrizikování, drží víc akcií (renta).',
    brzdaRenta: 'Na rentu',
    cilovaCastka: 'Cílová částka za daný horizont',
    disclaimer: 'Modelace vychází z reálných historických dat 1926–2026. Minulé výnosy nejsou zárukou budoucích. Investice nese riziko ztráty.',
    doba: 'Doba',
    dobaInvestice: 'Doba investice',
    dobaVyplaty: 'Doba výplaty (let)',
    hodnotaDnes: 'Hodnota dnes',
    hodnotaRealne: 'Hodnota reálně',
    jednorazove: 'Jednorázově',
    jednorazovyVklad: 'Jednorázový vklad',
    koncova: 'Koncová hodnota portfolia',
    krize: {
      k1929: 'Krach 1929',
      k1973: 'Ropná krize',
      k1987: 'Černé pondělí',
      k2000: 'Dot-com',
      k2008: 'Finanční krize',
      k2011: 'Dluhová krize',
      k2020: 'Covid',
      k2022: 'Ukrajina',
    },
    krizeKonec: 'V těchto datech se trh pokaždé vrátil.',
    krizeVetaFew: 'Investice za tu dobu prošla {n} krizemi — a přesto skončila na {castka}.',
    krizeVetaMany: 'Investice za tu dobu prošla {n} krizemi — a přesto skončila na {castka}.',
    krizeVetaOne: 'Investice za tu dobu prošla {n} krizí — a přesto skončila na {castka}.',
    legInvestice: 'Investice',
    legSporici: 'Spořicí účet',
    legVlozeno: 'Vloženo',
    letZkratka: 'let',
    mesicne: 'Měsíčně',
    mesicneHodnota: '{castka}/měs',
    modCil: 'Cíl',
    modRenta: 'Renta',
    nar1: 'Graf ukazuje, jak by se vaše peníze vyvíjely na reálných historických datech trhů, ne na slibech. V průběhu let přišly krize i propady — a hodnota přesto v dlouhém období rostla. Nejdůležitější je začít a vydržet.',
    nar2: 'Minulé výnosy nejsou zárukou těch budoucích. Trhy krátkodobě kolísají a hodnota investice může i klesnout. Modelace slouží k pochopení principu, ne jako příslib konkrétního výnosu.',
    nar3: 'Největším spojencem je čas — díky složenému úročení pracuje každý další rok ve váš prospěch. Proto se vyplatí začít co nejdřív, klidně i s menší částkou.',
    nastroje: 'Nástroje',
    navicVeta: 'Oproti spořicímu účtu (peněžní trh) {castka} navíc — tolik stála „jistota“ hotovosti.',
    nejhorsim: 'nejhorším',
    nom: 'nom.',
    nominalne: 'nominálně',
    obdobi: 'Období',
    obdobiDvojtecka: 'Období:',
    pdfChyba: 'PDF se nepodařilo vygenerovat',
    poplatky: 'Poplatky',
    poplatkyCelkem: 'Poplatky celkem vás připraví o {castka} — včetně výnosu, který ty peníze už nevydělaly.',
    portfolio: 'Portfolio',
    portfolioMix: 'Portfolio mix',
    potrebujeteMesicne: 'Potřebujete měsíčně',
    pouzit: 'Použít do výpočtu',
    pravidelneMesicne: 'Pravidelně měsíčně',
    preset: {
      dynamicky: 'Dynamický',
      konzervativni: 'Konzervativní',
      moderni: 'Moderní',
      vyvazeny: 'Vyvážený',
      zlaty: 'Se zlatem',
    },
    priJednorazovem: 'Při jednorázovém vkladu {castka} a alokaci {alokace}.',
    prubeznyPct: 'Průběžný % (ročně)',
    real: 'reál.',
    realne: 'reálně',
    realneOd: 'reálně až od 8/1946 (dřívější inflace v datech chybí)',
    rentaMaloHistorie: 'Pro tuhle alokaci není dost historie na otestování celé doby výplaty ({roky}) — zkrať dobu, nebo uber mladé třídy (BTC, REIT, MSCI).',
    rentaVydrzi: 'Z naspořených {castka} by vám to vydrželo {roky} i v {nejhorsim} historickém období (jinak víc).',
    rokyFew: '{n} roky',
    rokyMany: '{n} let',
    rokyOne: '{n} rok',
    souhrnReal: 'Modelace na reálné historii (8/1946–2026, {n} období, po inflaci):',
    sporiciByDal: 'Spořicí účet by dal',
    staciJednorazovy: '0 {mena} (stačí jednorázový)',
    titul: 'Historická kalkulačka',
    trida: {
      akcie: 'Akcie',
      btc: 'Bitcoin',
      dluhopisy: 'Dluhopisy',
      em: 'Emerging Markets',
      msci: 'MSCI World',
      ndx: 'NASDAQ-100',
      pt: 'Peněžní trh',
      reit: 'Nemovitosti',
      zlato: 'Zlato',
    },
    typ: 'Typ:',
    vlozenoCelkem: 'Vloženo celkem',
    vstupniPct: 'Vstupní %',
    vstupniPoplatek: 'Vstupní poplatek: {castka} z vložených {vlozeno}.',
    vynosPa: 'Výnos p.a.',
    vyvojNadpis: 'Vývoj hodnoty investice',
    zdrojDat1: 'Data: SBBI/Ibbotson US měsíčně 1926–2026 (Akcie = S&P 500 vč. dividend, Dluhopisy = US dlouhodobé státní, Peněžní trh = T-Bills, Inflace = US CPI). Zlato = LBMA od 1968 · MSCI World od 1985 (vč. odhadu dividend 2 % p.a.) · Nemovitosti = REIT index od 2004 · Bitcoin od 2010.',
    zdrojDat2: 'Výnos p.a. = vnitřní výnosové procento toků. Minulé výnosy nezaručují budoucí.',
    zhodnoceni: 'Zhodnocení',
    zkraceno: 'zkráceno na {roky} (mladá třída aktiv)',
  },
  /* BLOK:histKalk END */
  /* BLOK:alokaceGraf START — generuje scratchpad/slovnik.py, ručně needitovat */
  alokaceGraf: {
    celkem: 'Celkem',
    faze: {
      drzeni: 'Držíme. Trh kolísá, plán ne.',
      hotovost: 'Peníze jsou v hotovosti. Žádné tržní riziko.',
      odprodej: 'Odprodáváme akcie a kupujeme dluhopisy — blíží se cíl.',
      start: 'Nakupujeme — peníze jdou do akcií.',
    },
    mesicuFew: '{n} měsíce',
    mesicuMany: '{n} měsíců',
    mesicuOne: '{n} měsíc',
    nadpis: 'Kam peníze tečou v čase',
    pauza: 'Pauza',
    prehrat: 'Přehrát',
    rok: '{n}. rok',
    zpetNaCelek: 'Zpět na celek',
  },
  /* BLOK:alokaceGraf END */
  /* BLOK:fondyRenta START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondyRenta: {
    mimo: ' (ostatní účty a fondy, které žádný cíl nedostal) — celý finanční majetek ',
    prehled: 'Fondy → renta',
    prehledRezerva: 'Fondy → rezerva',
    prerozdeluje: 'Plán jednorázově přerozděluje likvidní účty, stavební spoření, penzijko a fondy. Mimo zůstává ',
    rozpocetDoRenty: ' jsou fondy a investiční životko, které klient už má — plán je počítá do renty.',
    rozpocetKCilum: ' jsou fondy a investiční životko, které klient už má — plán je přiřadil k cílům podle toku peněz.',
    rozpocetRezervaRenta: ' jsou fondy a investiční životko, které klient už má — plán z nich nejdřív doplní rezervu ({rezerva}), zbytek počítá do renty.',
  },
  /* BLOK:fondyRenta END */
  /* BLOK:kinoZavazky START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZavazky: {
    a0: {
      radek: 'V analýze není žádný úvěr.',
      tahak: '„Žádný úvěr nesplácíte. Peníze, které by šly bance, můžou pracovat pro vás.“',
      titulek: 'Dluhy nemáte',
    },
    a1: {
      ariaChybi: '{nazev}: {stav}.',
      ariaDluzite: 'Dlužíte {castka}.',
      ariaUroky: 'Na úrocích ještě zaplatíte {castka}.',
      ariaUrokyCast: 'Na úrocích ještě zaplatíte {castka} u úvěrů se známým úrokem.',
      ariaUver: '{nazev}: dluh {dluh}, úroky {uroky}, splaceno v roce {rok}.',
      dluh: 'dluh',
      dluhNeklesa: 'Dluh neklesá',
      dluhZnamy: 'dluh se známým úrokem',
      doplnteSplatku: 'Doplňte splátku',
      doplnteUrok: 'Doplňte úrok',
      doplnteZustatek: 'Doplňte zůstatek',
      kicker: 'Vaše dluhy',
      popisNespocitame: 'úroky zatím nespočítáme',
      popisNikdy: 'splátka nepokryje ani úrok',
      radekChybi: '{nazev}: {stav}, v součtu chybí.',
      radekChybiBez: '{nazev}: {stav}.',
      radekDluzite: 'Dlužíte {castka}.',
      radekNaSto: 'Ke každým {sto} dluhu přidáte bance {kolik}.',
      subDluh: 'dluh {castka}',
      tahak: '„Dluh nestojí jen to, co jste si půjčili. Tohle je, kolik k tomu ještě zaplatíte bance.“',
      tahakDoplnte: '„Podíváme se do smlouvy na úrok. Pak hned uvidíte, kolik k dluhu zaplatíte bance.“',
      tip: 'Zapište úrok ze smlouvy. Kino pak spočítá úroky a konec splácení.',
      titulek: 'Kolik vás stojí dluhy',
      urokyBance: 'úroky bance',
      velkePopis: 'ještě zaplatíte bance na úrocích',
    },
    a2: {
      ariaDobry: 'Dobrý dluh na bydlení {castka}.',
      ariaDobrySazba: 'Dobrý dluh na bydlení {castka} za {sazba}.',
      ariaJenBydleni: 'Jen dluh na bydlení {castka}.',
      ariaPolozka: '{nazev} {sazba} ročně',
      ariaPolozkaBez: '{nazev}, úrok nezapsaný',
      ariaSpatny: 'Špatný dluh {castka}: {seznam}.',
      ariaZadny: 'Špatné dluhy nemáte.',
      bydlite: 'Bydlíte v něm · nemovitost {castka}',
      dobry: 'Dobrý dluh',
      dobryProc: 'bydlení',
      firemni: 'Firemní úvěr',
      firemniProc: 'podnikání · do kroku nepatří',
      kicker: 'Dobrý a špatný dluh',
      radekChybiUrok: 'U špatných dluhů chybí úrok.',
      radekHypo: 'Hypotéka {sazba}.',
      radekJenBydleni: 'Máte jen dluh na bydlení.',
      radekNetyka: 'Krok „Zbavit se špatných dluhů“ se vás netýká.',
      radekPrvni: 'Špatné dluhy se splácejí první.',
      radekSazba: '{druh} stojí {sazba} ročně.',
      radekZadnaSpotreba: 'Žádný úvěr na spotřebu.',
      spatny: 'Špatný dluh',
      spatnyProc: 'spotřeba',
      spatnyZadnyProc: 'spotřebák, kreditka, kontokorent',
      tahak: '„Drahé úvěry a kreditky umažeme první. Úrok platíte jistě, výnos investic jistý není.“',
      tahakZadny: '„Hypotéka je dluh, ve kterém bydlíte. Spotřebák ani kreditku nemáte, to je dobrá zpráva.“',
      titulek: 'Ne každý dluh je stejný',
      titulekZadny: 'Špatné dluhy nemáte',
      velkePopis: 'špatný dluh · {druhy}',
      velkePopisZadny: 'špatný dluh',
      zadny: 'Žádný',
    },
    a3: {
      ariaBez: 'Bez peněz navíc: špatné dluhy splacené za {za}, úroky {urok}.',
      ariaNavic: 'S {castka} navíc měsíčně: bez špatných dluhů za {za} místo {puvodne}, na úrocích ušetříte {usetreno}.',
      ariaNesplati: 'Ani s {castka} navíc měsíčně se špatné dluhy nesplatí.',
      jezdecAria: 'Kolik poslat navíc na špatné dluhy měsíčně',
      kicker: 'Co kdyby',
      mesZkr: '{n} měs.',
      navicMesicne: 'Navíc měsíčně',
      navicNejdrivSem: 'navíc nejdřív sem',
      nic: 'Nic',
      nikdy: 'nikdy',
      nikdyPopis: 'splátka nepokryje úrok · dluh roste',
      popisPosunte: 'posuňte, kolik pošlete navíc',
      popisRoste: 'ani s tolika navíc dluh neklesá',
      popisSplaceno: 'splaceno za {za}',
      popisUsetrite: 'ušetříte na úrocích',
      pozn: 'Počítáno ze splátky a úroku ve smlouvě. Splátka splaceného úvěru se uvolní pro vás, navíc pak jde na další dluh.',
      radekDnes: 'Dnes bez špatných dluhů za {za}.',
      radekDriv: 'O {kolik} dřív.',
      radekNejdrazsi: 'Navíc jde nejdřív na nejdražší dluh.',
      radekNikdy: '{nazev}: splátka nepokryje ani úrok.',
      radekZa: 'Bez špatných dluhů za {za} místo {puvodne}.',
      rychlaVolba: 'Rychlá volba',
      tahak: '„Každá koruna navíc jde na nejdražší dluh. Co nezaplatíte bance, zůstane vám.“',
      titulek: 'Splatit špatné dluhy dřív',
      valuetext: '{castka} měsíčně',
      velkeRoste: 'Pořád roste',
      velkeZastavi: 'Dluh se zastaví',
      volne: 'Volné {castka}',
      zCilu: '{castka} z toho by šlo z peněz na cíle, než se dluhy splatí.',
    },
    a4: {
      aria: 'Po konci fixace při sazbě {sazba} bude splátka {po} místo {pred}.',
      dnes: 'Dnes · {sazba}',
      jakoDnes: 'jako dnes',
      jezdecAria: 'Sazba hypotéky po konci fixace',
      kicker: 'Hypotéka',
      oDvaBody: 'o 2 body víc',
      po: 'Po fixaci · {sazba}',
      pozn: 'Sazbu po fixaci dnes nikdo nezná. Doba splácení zůstává, mění se splátka.',
      poznTrh: 'Průměr trhu dnes: Swiss Life Hypoindex {obdobi}.',
      prumerTrhu: 'průměr trhu dnes',
      radekSplatka: 'Splátka se přepočítá: {pred} → {po}.',
      radekZustatek: 'Na konci fixace zbude {castka} dluhu.',
      sazbaPoFixaci: 'Sazba po fixaci',
      tahak: '„Fixace jednou skončí. Teď víme, co udělá splátka, když sazba půjde nahoru.“',
      titulek: 'Konec fixace: {kdy}',
      velkePopis: 'splátka měsíčně při sazbě {sazba}',
    },
    a5: {
      ariaDnes: 'Na cíle dnes {castka} měsíčně.',
      ariaOd: 'Od roku {rok} {castka}.',
      ariaRenta: 'Renta od roku {rok}.',
      dnes: 'dnes',
      kicker: 'Po splacení',
      naCile: 'na cíle měsíčně',
      navicNaDluhy: '{castka} navíc na dluhy',
      poRenteFew: 'Hypotéka doběhne {n} roky po startu renty.',
      poRenteMany: 'Hypotéka doběhne {n} let po startu renty.',
      poRenteOne: 'Hypotéka doběhne {n} rok po startu renty.',
      popisDoplnte: 'bez nich nevíme, kdy dluhy doběhnou',
      poznModel: 'Dnes na cíle {castka} měsíčně z volných peněz, zatím neodsouhlaseno. Uvolněné splátky jsou ze smluv. Ostatní příjmy a výdaje počítáme jako dnes.',
      poznOdsouhlaseno: 'Dnes na cíle {castka} měsíčně, jak je odsouhlaseno v analýze. Uvolněné splátky jsou ze smluv. Ostatní příjmy a výdaje počítáme jako dnes.',
      predRentouFew: 'Doběhne {n} roky před rentou.',
      predRentouMany: 'Doběhne {n} let před rentou.',
      predRentouOne: 'Doběhne {n} rok před rentou.',
      radekHypo: 'V roce {rok} doběhne hypotéka. Dalších {castka}.',
      radekUsetreno: 'Ušetřené úroky {castka} zůstanou vám.',
      splaceno: '{nazev}: splaceno',
      startRenty: 'start renty',
      tahak: '„Až dluhy doběhnou, tyhle peníze budou pracovat pro vás.“',
      tip: 'Zapište konec splácení hypotéky ze smlouvy.',
      titulek: 'Peníze, které se uvolní',
      velkeDoplnte: 'Doplňte splátky',
      velkePopis: 'měsíčně navíc na cíle · od roku {rok}',
    },
    mesiceFew: '{n} měsíce',
    mesiceMany: '{n} měsíců',
    mesiceOne: '{n} měsíc',
    nazev: 'Závazky',
    prezTlacitko: 'Spustit kino: Kolik vás stojí dluhy',
    splacenoVRoce: 'splaceno v roce {rok}',
    stav: {
      bezJistiny: 'zůstatek nezapsaný',
      bezSplatky: 'splátka nezapsaná',
      bezUroku: 'úrok nezapsaný',
      nikdy: 'splátka nepokryje ani úrok',
    },
    tlacitko: 'Kino závazků',
    uver: 'Úvěr',
  },
  /* BLOK:kinoZavazky END */
  /* BLOK:rizikoVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  rizikoVysvetleni: {
    dite: {
      potreba: 'celá potřeba',
      sablonaKrok: 'Vzor pro dětskou smlouvu',
      sablonaTitul: 'Šablona: proč tahle částka',
      sablonaToggle: 'Proč tahle částka',
      sablonaVeta: 'Vzor z praxe poradce, ne výpočet z čísel klienta — přepíšete ho tužkou podle nabídky pojišťovny.',
      strop: 'Strop pojistitelnosti',
      stropPod: 'dětské smlouvy upíšou řádově do {strop}, zbytek {zbytek} patří do rezervy',
      trvaleTitul: 'Jak vzniká pojistná částka dítěte',
      trvaleToggle: 'Jak se počítá pojistná částka dítěte',
      vypadekPod: '{kdo}: {prijem} na {roky}, dnešní hodnota s výnosem 4 % nad inflaci',
      zavazneKrok1: 'Roční příjem pečujícího rodiče',
      zavazneKrok1Pod: '{kdo}: {prijem} × 12',
      zavazneStropPod: 'dětské smlouvy kryjí řádově do {strop}, zbytek {zbytek} patří do rezervy',
    },
    odskodne: {
      krok1: 'Výpadek, který nic nekryje',
      krok1PodOdZacatku: 'rezerva nepokryje ani měsíc: {prijem} − nemocenská {stat}',
      krok1PodRezerva: 'první měsíce drží rezerva, pak platí pracovní neschopnost — odškodné by krylo totéž',
      krok1PodVypnuto: 'odškodné je vypnuté',
      krok2: 'Strop: dávky nejvýš do čistého příjmu',
      krok2Pod: '{prijem} − nemocenská {stat} − pracovní neschopnost {pn}',
      model: 'Odškodné kryje dny, kdy pracovní neschopnost ještě neplatí a rezerva nestačí. Dávky dohromady nesmí být vyšší než čistý příjem — to žádná pojišťovna neupíše.',
      titul: 'Jak vzniká denní odškodné',
      toggle: 'Jak se počítá denní odškodné',
      vysledek: 'Limit denního odškodného',
      vysledekPod: 'menší z obou čísel, zaokrouhleno na desítky',
    },
    pn: {
      krok1: 'Čistý příjem',
      krok1Vydaje: 'Podíl nezbytných výdajů',
      krok1VydajeSplatky: 'Podíl nezbytných výdajů a splátek',
      krok2: 'Co dá stát',
      krok3: 'Výpadek příjmu',
      krok3Pod: '{prijem} − {stat}',
      krok4: 'Denní dávka',
      krok4Pod: '{vypadek} ÷ {dni} dní',
      krok5: 'Od kdy pojistka platí',
      krok5Hodnota: 'od {mesic}. měsíce',
      krok5Info: 'Čekací doba = kolik celých měsíců utáhne rezerva, nejvýš 3. Delší čekací doba = levnější pojistka.',
      krok5Pod: 'rezerva {rezerva} = {nasobek}× nezbytné výdaje ({vydaje}) — do té doby drží ona',
      krok5PodNula: 'rezerva {rezerva} nepokryje ani jeden měsíc nezbytných výdajů ({vydaje})',
      model: 'Orientační model, ne garance: nemocenská podle pravidel roku 2026, skutečnou výši určí stát. Čekací dobu a plnění určují pojistné podmínky.',
      odDneOsvc: 'vyplácí se od {den}. dne',
      odDneZam: 'vyplácí se od {den}. dne, do té doby platí náhradu mzdy zaměstnavatel',
      omezeno: 'nejvýš do výše čistého příjmu',
      predpoklad: 'počítáme s povinným nemocenským pojištěním',
      sazbaInfo: 'Počítáme 60 % — sazbu prvních 30 dní. Od 31. dne stát platí 66 %, od 61. dne 72 %, model je tedy opatrný.',
      statBez: 'Bez nemocenského pojištění — nemocenská se nevyplácí.',
      statOsvc: 'OSVČ bez nemocenského pojištění — nemocenská se nevyplácí.',
      statRozpad: 'hrubá mzda ≈ {hruba} → denní základ {dvz} → po redukci {rdvz} → {sazba} % = {den} × 30 dní',
      statRozpadSK: 'hrubá mzda ≈ {hruba} → denní vyměřovací základ {dvz} → {sazba} % = {den} × 30 dní',
      strop: 'strop: nejvýš {strop} — z denního základu nad {hranice} se nepočítá nic',
      stropSK: 'strop: denní vyměřovací základ nejvýš {hranice}',
      titul: 'Jak vzniká denní dávka',
      toggle: 'Jak se počítá pracovní neschopnost',
      varianty: 'Stejné ve všech variantách krytí — krátký výpadek se neuskromňuje.',
      vysledek: 'Limit pracovní neschopnosti',
    },
    rucne: 'Na kartě je ručně {rucni}, spočítáno {spocitano}.',
    skryt: 'Skrýt výpočet',
    zaokrouhleni: 'Řádky jsou zaokrouhlené, jejich součet se může nepatrně lišit.',
    zavazne: {
      krok1: 'Roční čistý příjem',
      krok1Pod: '{prijem} × 12',
      krok2: 'Na kolik let',
      krok2Hodnota: '× {roky}',
      krok2Pod: 'volba 1 / 2 / 3 roky pod řádkem',
      titul: 'Jak vzniká částka závažných onemocnění',
      toggle: 'Jak se počítají závažná onemocnění',
      vysledek: 'Limit závažných onemocnění',
    },
  },
  /* BLOK:rizikoVysvetleni END */
  /* BLOK:fondKategorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondKategorie: {
    'akcie-em': 'Akcie – rozvíjející se trhy',
    'akcie-eu': 'Akcie – Evropa',
    'akcie-svet': 'Akcie – svět',
    'akcie-tech': 'Akcie – technologie',
    'akcie-usa': 'Akcie – USA',
    dluhopisy: 'Dluhopisy',
    fond: 'Fond',
    fondA: 'Fond A',
    fondB: 'Fond B',
    krypto: 'Krypto (ETP)',
    nemovitosti: 'Nemovitostní fondy',
    penizni: 'Peněžní / konzervativní',
    smisene: 'Smíšené',
    zlato: 'Zlato / komodity',
  },
  /* BLOK:fondKategorie END */
  /* BLOK:kino503020 START — generuje scratchpad/slovnik.py, ručně needitovat */
  kino503020: {
    a1: {
      aria: 'Pravidlo 50/30/20: z příjmu {prijem} jde stranou {stranou}, na život {styl}, na nezbytné včetně splátek {nezbytne}.',
      bezPrijmu: 'Bez příjmu pravidlo nerozdělíme.',
      kat: {
        bonusy: 'bonusy',
        pasivni: 'pasivní příjem',
      },
      kicker: 'Pravidlo',
      osoba: 'Osoba {n}',
      prijem: 'čistý příjem',
      prijemDomacnosti: 'čistý příjem domácnosti',
      radek1: 'Polovina na nezbytné.',
      radek2: 'Necelá třetina na život.',
      radek3: 'Pětina stranou.',
      splatkyNadRozpocet: 'Splátky dnes zaberou víc, než pravidlo nechá na výdaje.',
      tahak: '„Osvědčené pravidlo: z {prijem} polovina na nezbytnosti, necelá třetina na život a pětina stranou na budoucnost. Minimum je desetina.“',
      titulek: '50 / 30 / 20',
      zamestnavatel: 'zaměstnavatel {castka}',
    },
    a2: {
      aria: 'Dnes jde stranou {pct} % ({stranou}). {radek} {dily}.',
      ariaPravidlo: 'Pravidlo: stranou 20 %, na život 30 %, nezbytné a splátky 50 %.',
      ariaSchodek: 'Dnes měsíčně chybí {chybi}: výdaje a splátky přesahují příjem. Stranou nejde nic, vklady do spoření jsou ve výdajích.',
      bezVydaju: 'Doplňte výdaje a spočítáme, kolik reálně odkládáte.',
      bezVydajuVizual: 'Bez výdajů procento netvrdíme.',
      dohodaNad: 'Dohoda je o {castka} vyšší než volné peníze.',
      kicker: 'Vy dnes',
      nesoulad: 'Vklady jsou vyšší než výdaje, zkontrolujte rozpis výdajů.',
      poznVklady: 'vč. vkladů do spoření',
      poznZam: 'vč. {castka} od zaměstnavatele',
      pravidlo: 'Pravidlo',
      prepinacAria: 'Co ukázat',
      radekIdeal: 'To je ideál. ✓',
      radekMinimum: 'Minimum máte. Do ideálu chybí {chybi}.',
      radekPod: 'Do minima chybí {chybi} měsíčně.',
      radekRychle: 'Cíle se plní hodně rychle. ✓',
      radekSchodek: 'Než začneme odkládat, je potřeba tenhle rozdíl zavřít.',
      tahakBezVydaju: '„Než řekneme procento, doplníme spolu výdaje.“',
      tahakCastVolne: 'Z toho {zbyva} máte ve volných penězích, zbytek bychom hledali ve výdajích.',
      tahakIdeal: '„Stranou dáváte {pct} % příjmu. To je ideál. Teď jde o to, kam ty peníze pošleme.“',
      tahakMinimum: 'Stranou dáváte {pct} % příjmu. Minimum máte, do ideálu chybí {chybi}.',
      tahakPod: 'Stranou dáváte {pct} % příjmu. Do minima chybí {chybi}.',
      tahakRychle: '„Stranou dáváte {pct} % příjmu. Cíle se tak plní hodně rychle. Pohlídejme, ať vám zbývá i na život.“',
      tahakSchodek: '„Dnes měsíčně chybí {chybi}. Než začneme odkládat, musíme tenhle rozdíl zavřít.“',
      tahakVolne: 'Ty máte ve volných penězích, škrtat nemusíte.',
      tahakVydaje: 'Volné peníze na to dnes nejsou, budeme je hledat ve výdajích.',
      titulek: 'Kde jste dnes',
      velkeBezVydaju: 'výdaje nejsou zadané',
      velkePopis: 'příjmu jde stranou · {castka}',
      velkeSchodek: 'měsíčně chybí',
      vyDnes: 'Vy dnes',
      zbyvaPred: 'Volně zbývá',
    },
    a3: {
      aria: 'Při {pct} % jde stranou {stranou}, volně zbývá {zbyva}. Nezbytné a splátky se nemění.',
      ariaStyl: 'Při {pct} % jde stranou {stranou}, z toho {styl} ze životního stylu. Nezbytné a splátky se nemění.',
      kicker: 'Co kdyby',
      pct: {
        necelych: 'necelých {pct} %',
        pres: 'přes {pct} %',
        presne: '{pct} %',
      },
      pokryto: 'Pokryjí to vklady, které už běží ({vklady}).',
      radekSchodek: 'Při schodku nejdřív výdaje, pak procenta.',
      staci: 'Stačí volné peníze.',
      tahak: '„Zkuste si to sami. Z vkladů a volných peněz jde nejvýš {max} měsíčně, to je {pct}. Nad to už bychom brali z vašeho života.“',
      tahakSchodek: '„Odkládat z dluhu nedává smysl. Nejdřív najdeme těch {chybi}, pak se vrátíme k procentům.“',
      titulek: 'Kde na to vzít',
      velkePopis: 'měsíčně stranou',
      velkeSchodek: 'není z čeho odkládat',
      zbyva: 'Zbývá {castka}.',
      zeStylu: 'Ze životního stylu ubrat {castka} měsíčně.',
    },
    a4: {
      ariaBezCile: 'Renta v cílech zatím není.',
      ariaChybi: 'Do renty, která rodinu uživí, chybí {chybi} měsíčně.',
      ariaPotreba: 'Rodina potřebuje {potreba} měsíčně.',
      ariaSedi: 'Renta v cílech {zadano} rodinu uživí.',
      ariaSplatky: 'Z toho {nazev} {splatky} ({proc}).',
      bezSporeni: 'Bez dnešního spoření {castka}, v rentě už nespoříte.',
      bezUveru: 'Bez úvěrů doplacených před rentou.',
      bezUveruRok: 'Bez úvěrů doplacených do roku {rok}.',
      chybiMesicne: 'chybí {chybi} měsíčně',
      kapital: 'Na rentu {potreba} v dnešních cenách je potřeba kapitál zhruba',
      kicker: 'Rentiér',
      potrebuje: 'Rodina potřebuje',
      pravni: 'Modelace podle sazby čerpání zhruba {sazba} ročně ({profil} profil). Není to výnos ani záruka, skutečnost se může lišit.',
      radekPotreba: 'Rodina potřebuje {potreba} měsíčně.',
      radekSoucet: 'Výdaje {vydaje} + {nazev} {splatky} = {potreba} měsíčně.',
      splatky: 'splátky',
      splatkyBezi: 'běží i v rentě',
      splatkyNeznamyKonec: 'konec nejde spočítat, doplňte úrok',
      tahak: '„Rentiér není ten, kdo hodně vydělává. Je to ten, komu majetek platí účty místo něj.“',
      tahakUrok: '(Doplňte u úvěru úrok nebo zůstatek, appka pak spočítá, jestli skončí před rentou.)',
      titulek: 'Kolik musí renta unést?',
      vCilech: 'Renta v cílech',
      vCilechJe: 'V cílech je {zadano}.',
      vCilechNeni: 'V cílech renta zatím není.',
      velkeBezCile: 'měsíčně by renta měla být',
      velkeChybi: 'měsíčně chybí do renty, která rodinu uživí',
      velkeSedi: 'renta v cílech rodinu uživí ✓',
      zTohoSplatky: 'z toho {nazev}',
    },
    ctverecek: '1 čtvereček = 1 % příjmu ({castka} měsíčně)',
    dil: {
      nad: 'Z toho nad příjem',
      nezbytne: 'Nezbytné',
      nezbytneVse: 'Nezbytné vč. splátek',
      splatky: 'Splátky',
      stranou: 'Stranou',
      styl: 'Životní styl',
      volne: 'Zbývá volně',
      vydaje: 'Výdaje (bez rozpisu)',
      zVkladu: 'Z vkladů a volných peněz',
      zestylu: 'Ze životního stylu',
    },
    doplnPrijmy: 'Doplňte příjmy',
    nazev: 'Příjmy · 50/30/20',
    prah: {
      ideal: '{pct} % ideál',
      minimum: '{pct} % minimum',
      rychle: '{pct} % rychle',
    },
    prahPrijem: 'příjem',
    profil: {
      dynamicky: 'dynamický',
      konzervativni: 'konzervativní',
      vyvazeny: 'vyvážený',
    },
    uvozovky: '„{text}“',
  },
  /* BLOK:kino503020 END */
  /* BLOK:portfolioKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  portfolioKarta: {
    investice: 'Investice',
    odhadBj: '* odhad z podepsaných BJ',
    penze: 'Penze',
    pojisteni: 'Pojištění',
    proviceYtd: 'Provize YTD',
    rezerva: 'Rezerva',
    rocniVynos: 'Roční výnos',
    titul: 'Portfolio klienta',
    zadnyProdukt: 'Žádný investiční produkt',
  },
  /* BLOK:portfolioKarta END */
  /* BLOK:kinoZdroje START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZdroje: {
    a1: {
      ariaFin: 'Finanční majetek {castka}.',
      ariaKapsa: '{nazev} {castka}, {kdy}.',
      ariaNefin: '{nazev} {castka}: do cílů se nepočítá.',
      ariaPrazdna: '{nazev}: nic nezapsáno.',
      doplnte: 'Doplňte majetek',
      kicker: 'Vaše peníze',
      nefinPopis: 'do cílů se nepočítá',
      nemovitost: 'Nemovitost',
      nevime: 'Zatím nevíme, kde peníze leží.',
      podil: '{pct} % leží {misto}.',
      polovina: 'Polovina leží {misto}.',
      radek2: 'Ne všechno je po ruce stejně rychle.',
      tahak: '„Než začneme spořit nové peníze, podívejme se, co už máte. Bývá to víc, než si lidé myslí.“',
      titulek: 'Peníze, které už máte',
      velkePopis: 'finanční majetek',
      vse: 'Všechno leží {misto}.',
    },
    a2: {
      ariaZisk: 'Za 10 let koupí {castka} na účtu tolik, co dnes {za}; úrok je nad inflací {inflace}.',
      ariaZtrata: 'Za 10 let koupí {castka} na účtu jen tolik, co dnes {za}, při inflaci {inflace} ročně.',
      bezUroku: 'Účet bez úroku.',
      dnes: 'dnes {castka}',
      kicker: 'Inflace',
      pilulkyAria: 'Jaká inflace',
      radekZisk: '{castka} za 10 let koupí to, co dnes {za}.',
      radekZtrata: '{castka} za 10 let koupí jen to, co dnes {za}.',
      tahak: '„Inflace je tichý zloděj. Číslo na výpisu nezmizí, ale koupíte si za něj čím dál méně.“',
      titulek: 'Na účtu peníze tiše ztrácejí',
      titulekStaci: 'Úrok inflaci zatím stačí',
      urok: 'Úrok na účtu {urok}.',
      urokNezadan: 'Úrok u účtu není zapsaný, počítáme 0 %.',
      velkePopis: 'kupní síla za 10 let · inflace {inflace}',
      volba: {
        cil: {
          cnb: 'cíl ČNB',
          ecb: 'cíl ECB',
        },
        historie: 'jako {od}–{do}',
        plan: 'předpoklad plánu',
      },
      zdrojCZK: 'Plán počítá s {plan} (předpoklad). ČSÚ: {rok} {posledni}, průměr 2016–2025 {prumer}. Cíl ČNB 2 %.',
      zdrojEUR: 'Plán počítá s {plan} (předpoklad). Cíl ECB 2 %.',
      zdrojJiny: 'Plán počítá s inflací {plan} (předpoklad).',
    },
    a3: {
      ariaNic: 'Nic nepracuje.',
      ariaPodRezervou: '{rezerva}: na účtu {ucet}, chybí {chybi}.',
      ariaSrovnani: 'Výhled {roky}: když {x} zůstane na účtu, koupí jako dnes {ucet}. Když pracuje podle profilu plánu, je to modelově {model}, v horším scénáři {horsi}, v lepším {lepsi}. Výnos není zaručen.',
      chybi: 'chybí {castka}',
      dlouhyCil: 'dlouhý cíl (renta)',
      jenNad: 'Jen nad rezervu',
      jezdecAria: 'Kolik peněz z účtu by mohlo pracovat',
      kicker: 'Co kdyby',
      model: 'Model: {roky} jako cíl {cil}, profil {profil}, v dnešních penězích, bez poplatků a daní. Výnos není zaručen, čárka nad pruhem = horší a lepší scénář plánu. Účet: úrok {urok}, inflace {inflace}.',
      naUctu: 'na účtu {castka}',
      nadRezervu: 'nad rezervu {castka}',
      nic: 'Nic',
      pasmo: 'horší scénář {horsi} · lepší {lepsi}',
      pracuje: 'Pracuje',
      pracujeModel: 'Pracuje · model',
      radekJenNad: 'Nad ní je jen {castka}.',
      radekKlesla: 'Rezerva by klesla na {castka}.',
      radekNaUctu: 'Na účtu je {castka}.',
      radekNad: 'Nad ní je {castka}.',
      radekRezerva: 'Rezerva je {castka}.',
      radekRezervaNa: 'Rezerva na {n} měs. je {castka}.',
      radekRezervaZustava: 'Rezerva {castka} zůstává na účtu.',
      rezerva: 'rezerva · {castka}',
      rezervaNa: 'rezerva na {n} měs. · {castka}',
      sniInflace: 'sní inflace',
      tahak: '„Rezervu necháme na účtu, na tu nesaháme. Peníze nad ní můžou pracovat.“',
      titulek: 'Rezerva zůstane, zbytek může pracovat',
      titulekPodRezervou: 'Nejdřív celá rezerva',
      titulekRezerva: 'Část rezervy by pracovala',
      urokNad: 'z úroku nad inflací',
      valuetextRezerva: '{x}, z toho {rezerva} z rezervy',
      varovani: '{castka} by šlo z rezervy. Ta by pak nebyla celá.',
      velkeChybiRezerva: 'chybí do rezervy',
      velkeNic: 'nic nepracuje',
      velkePasmo: 'horší scénář {horsi} · lepší {lepsi}',
      velkePopis: '{roky} navíc · model, výnos není zaručen',
      velkeZRezervy: 'by chybělo v rezervě',
      vlozenoVynos: 'vloženo {x} + modelový výnos {vynos}',
      zUctu: 'z účtu',
      zustaneNaUctu: 'Zůstane na účtu',
    },
    a4: {
      ariaBez: 'Bez peněz, které máte: {popis}.',
      ariaS: 'S penězi, které máte: {popis}.',
      bezNich: 'Bez nich',
      cil: 'Cíl',
      dnesPct: 'dnes {pct} %',
      hotovaDoMes: 'hotová do {n} měs.',
      hotovaHned: 'hotová hned',
      hotovaZaMes: 'hotová za {n} měs.',
      kTerminu: 'k termínu',
      kTerminuPct: 'k termínu {pct} %',
      kicker: 'Vaše cíle',
      mesicne: '{castka}/měs.',
      nepriradeno: {
        investice: 'Investice',
        stavebko: 'Zbytek stavebního spoření',
        ucty: 'Zbytek na účtech',
      },
      nepriradenoPopis: 'plán je zatím k žádnému cíli nepřiřadí',
      plusOdkladani: '+ odkládání',
      plusVynos: '+ výnos (model)',
      poMesicne: 'po {castka} měsíčně',
      pozn: 'Stejný výpočet jako Návrh řešení, v dnešních penězích. Výnos je model, ne slib.',
      radekBez: '{cil} by k termínu mělo {bez} % místo {s} %.',
      radekS: '{cil} k termínu {s} % místo {bez} %.',
      radekStejne: 'Bez nich by plán vyšel stejně.',
      renta: 'Renta',
      rezerva: 'Rezerva',
      sPenezi: 'S penězi, které máte',
      segmentAria: 'Srovnání',
      tahak: '„Dalším zdrojem pro naplnění vašich cílů jsou peníze, které už máte.“',
      titulek: 'Další zdroj pro vaše cíle',
      vVeku: 'v {vek} letech',
      vVekuPoStartu: 'v {vek} letech · po startu renty',
      velkeNic: 'Zatím nic',
      velkeNicPopis: 'do termínu cílů z majetku nic nedorazí',
      velkePopis: 'plán přiřadí k cílům do jejich termínu',
      vetaRezervaBez: 'Bez nich by se rezerva spořila {n} měs.',
      vetaRezervaDoMes: 'Rezerva je hotová do {n} měs.',
      vetaRezervaHned: 'Rezerva je hotová hned.',
      vetaRezervaPct: 'Rezerva je dnes na {pct} %.',
      vetaRezervaZa: 'Rezerva bude hotová za {n} měs.',
      vlastniZdroje: 'vlastní zdroje {castka}',
      zaMes: 'za {n} měs.',
      zatimNic: 'zatím nic',
      zdrojPenzijko: 'penzijní spoření',
    },
    kapsa: {
      investice: 'Investice',
      nezapsano: 'nic nezapsáno',
      penzijko: 'Penzijní spoření',
      stavebko: 'Stavební spoření',
      ucty: {
        bezny: 'Běžný účet',
        hotovost: 'Hotovost',
        sporici: 'Spořicí účet',
        ucty: 'Účty',
      },
    },
    kdy: {
      castHned: 'část hned',
      hned: 'hned',
      investice: 'za pár dní',
      penzijko: 'v {vek} letech',
      stavebko: 'do {n} měs.',
    },
    misto: {
      investice: 'v investicích',
      penzijko: 'v penzijním spoření',
      stavebko: 've stavebním spoření',
      ucty: {
        bezny: 'na běžném účtu',
        hotovost: 'v hotovosti',
        sporici: 'na spořicím účtu',
        ucty: 'na účtech',
      },
    },
    nazev: 'Zdroje',
    osa: {
      dnes: 'dnes',
      zaRokyFew: 'za {n} roky',
      zaRokyMany: 'za {n} let',
      zaRokyOne: 'za {n} rok',
    },
    prezTlacitko: 'Spustit kino: Peníze, které už máte',
    rokyFew: '{n} roky',
    rokyMany: '{n} let',
    rokyOne: '{n} rok',
    tlacitko: 'Kino Zdroje',
    tlacitkoTitle: 'Přehrát kino: Peníze, které už máte',
    zaRokyFew: 'za {n} roky',
    zaRokyMany: 'za {n} let',
    zaRokyOne: 'za {n} rok',
  },
  /* BLOK:kinoZdroje END */
  /* BLOK:predAPo START — generuje scratchpad/slovnik.py, ručně needitovat */
  predAPo: {
    cena: 'Cena',
    hlavicka: {
      dnes: 'Dnes',
      kryti: 'Krytí ×',
      nove: 'Nově',
    },
    infoDalsiRizika: 'Limity všech rizik (invalidita, smrt, pracovní neschopnost, závažná onemocnění, trvalé následky, odškodné) doplníte v analýze po osobách: Pojistné smlouvy → Rizika ve smlouvách.',
    infoNema: '„nemá“ = žádná zapsaná smlouva to riziko nekryje. „nezadáno“ = smlouva je, ale limit u ní chybí.',
    infoRozsah: 'U domácnosti bez vybrané osoby násobek krytí neukazujeme — srovnávala by se smlouva jednoho člověka s novým krytím obou.',
    mene: 'méně',
    nema: 'nemá',
    spolecna: 'vč. společné smlouvy',
    spolecnaU: 'společná smlouva · platba u {kdo}',
    stitekNove: 'nové',
    ztrata: 'ztráta',
  },
  /* BLOK:predAPo END */
  /* BLOK:podkladyKlienta START — generuje scratchpad/slovnik.py, ručně needitovat */
  podkladyKlienta: {
    dny: {
      '0': 'v neděli',
      '1': 'v pondělí',
      '2': 'v úterý',
      '3': 've středu',
      '4': 've čtvrtek',
      '5': 'v pátek',
      '6': 'v sobotu',
    },
    dok: {
      leasing: 'leasingová smlouva',
      naSchuzce: 'vyplníme spolu na schůzce',
      pojistna: 'pojistná smlouva',
      portfolio: 'výpis z portfolia',
      smlouvaVypis: 'smlouva a poslední výpis',
      triMesice: 'za poslední 3 měsíce',
      uverova: 'úvěrová smlouva a výpis zůstatku',
      vypis: 'poslední výpis',
      vypisUctu: 'výpis z účtu',
      zustatek: 'aktuální zůstatek',
    },
    nazev: {
      akcie: 'Akcie',
      cennosti: 'Pojištění cenností',
      cizimena: 'Účet v cizí měně',
      danove: 'Daňové přiznání za rok {rok}',
      dip: 'Dlouhodobý investiční produkt (DIP)',
      dluhopisy: 'Dluhopisy',
      dps: 'Penzijní spoření (DPS)',
      fondy: 'Fondy / ETF',
      investice: 'Investice',
      krypto: 'Kryptoměny',
      kzp: 'Kapitálové životní pojištění',
      pojistka: 'Pojistná smlouva',
      pripojisteni: 'Penzijní připojištění',
      sporici: 'Spořicí účet',
      stavebko: 'Stavební spoření',
      terminovany: 'Termínovaný vklad',
      uver: 'Úvěr',
      vypisy: 'Výpisy z běžného účtu',
    },
    platno: {
      emailem: 'Seznam vám pošlu i e-mailem',
      idealne: 'Ideálně před schůzkou',
      kicker: 'Závěr',
      papiry: 'Papíry můžete přinést i na schůzku',
      pod: 'Stačí sken nebo fotka z telefonu.',
      posleteNa: 'Pošlete na',
      prazdne: 'Zatím nic — doplníme na příští schůzce.',
      titul: 'Co od vás budu potřebovat',
      zpravou: 'Seznam vám pošlu i zprávou',
    },
    pocetSmluvFew: '{n} smlouvy',
    pocetSmluvMany: '{n} smluv',
    pocetSmluvOne: '{n} smlouva',
    ui: {
      bezEmailu: '{kdo} nemá e-mail.',
      bezKontaktu: 'bez kontaktu',
      bezTelefonu: '{kdo} nemá telefon.',
      chybaRada: 'Zkuste to znovu, nebo zprávu otevřete ve svém poštovním programu.',
      chybaTitul: 'Odeslání se nepovedlo — nic neodešlo',
      chybiMujEmail: 'Ve zprávě chybí váš e-mail, klient by nevěděl, kam skeny poslat.',
      cisloVarovani: 'vypadá to na číslo smlouvy — do zprávy ho raději nepište',
      detailEmail: 'Odesláno {kdy} e-mailem · {komu}',
      detailMailto: 'Otevřeno v poštovním programu {kdy} · {komu} · odešlete tam',
      detailWa: 'Otevřeno ve WhatsAppu {kdy} · {komu} · odešlete tam',
      dokumentFew: 'dokumenty',
      dokumentMany: 'dokumentů',
      dokumentOne: 'dokument',
      doplnitEmail: 'Doplnit e-mail v Úvodu',
      doplnitNastaveni: 'Doplnit veřejný e-mail v Nastavení',
      doplnitTelefon: 'Doplnit telefon v Úvodu',
      emailUctu: 'Ve zprávě je e-mail propojeného účtu',
      instituceChybi: 'instituce nevyplněná',
      jazyk: 'Jazyk zprávy',
      jen: 'jen {kanal}',
      kanalEmail: 'e-mail',
      kanalEmailSpatny: 'e-mail ve špatném tvaru',
      kanalTelefon: 'telefon',
      kdyCas: '{den} v {cas}',
      klient: 'Klient',
      komu: 'Komu poslat',
      kopirovaniChyba: 'Kopírování se nepovedlo — označte text a zkopírujte ho ručně.',
      kopirovat: 'Kopírovat',
      neodeslano: 'Zatím neodesláno',
      nicVybrano: 'Nic není vybráno — zpráva se neodešle',
      odebrat: 'Odebrat: {nazev}',
      odesilam: 'Odesílám…',
      odeslanoEmail: 'Odesláno {den} e-mailem',
      odeslanoToast: 'E-mail odešel klientovi.',
      odeslatChyba: 'Odeslání selhalo.',
      opravitEmail: 'Opravit e-mail v Úvodu',
      otevritPostu: 'Otevřít v poštovním programu',
      plusDotaznik: '+ dotazník na schůzku',
      pocetPred: 'Do zprávy půjde',
      pod: 'Sestaveno ze Zdrojů, Závazků a majetku v analýze',
      podleMajetku: 'podle majetku: {nazev}',
      polozkaMajetku: 'položka majetku',
      poslatEmail: 'Poslat e-mailem',
      poslatWa: 'Poslat přes WhatsApp',
      pozdeji: 'dodá později',
      poznGmail: 'Odejde z vašeho Gmailu {email}',
      poznGmailBez: 'Odejde z vašeho Gmailu',
      poznMailto: 'Otevře váš poštovní program — odešlete tam',
      poznSmtp: 'Odejde z vašeho firemního e-mailu {email}',
      poznSmtpBez: 'Odejde z vašeho firemního e-mailu',
      poznWa: 'Otevře WhatsApp s hotovým textem — odešlete tam',
      poznZjistuji: 'Zjišťuji, kudy e-mail odejde…',
      predanoWa: 'Předáno do WhatsAppu {den}',
      predmet: 'Předmět',
      pridat: 'Přidat',
      pridatLabel: 'Vlastní položka',
      pridatPh: 'např. kupní smlouva k bytu',
      pripravenoEmail: 'Připraveno v e-mailu {den}',
      rozbalit: 'Zobrazit celou zprávu',
      sbalit: 'Sbalit zprávu',
      skupina: {
        dalsi: 'Další',
        pojisteni: 'Pojištění',
        sporeni: 'Spoření a investice',
        uvery: 'Úvěry',
      },
      spatnyEmail: '{kdo} má e-mail ve špatném tvaru ({email}).',
      terminAnalyza: 'Termín zapsaný v analýze: {kdy}',
      terminDiar: 'Termín z diáře: {kdy}',
      terminProbehl: 'Termín v analýze ({kdy}) už proběhl — ve zprávě není',
      terminZadny: 'V diáři není další schůzka — termín ve zprávě není',
      titul: 'Co má dodat klient',
      vlastni: 'vlastní položka',
      waBezEmailu: 'Bez vašeho e-mailu by klient poslal skeny do WhatsAppu.',
      zkopirovano: 'Text zprávy je zkopírovaný.',
      zkusitZnovu: 'Zkusit znovu',
      zmena: 'Od odeslání se zpráva změnila — pošlete ji znovu.',
      znovuEmail: 'Poslat znovu e-mailem',
      znovuWa: 'Poslat znovu přes WhatsApp',
      zpravaPod: 'Klient pošle skeny na váš e-mail',
      zpravaTitul: 'Zpráva pro klienta',
    },
    viceFew: '{n} smlouvy: {dok} ke každé',
    viceMany: '{n} smluv: {dok} ke každé',
    viceOne: '{n} smlouva: {dok}',
    zprava: {
      dotaznik: 'Investiční dotazník vyplníme spolu na schůzce.',
      fotka: 'Stačí fotka z telefonu, hlavně ať je čitelná.',
      kamEmail: 'Pošlete je prosím na můj e-mail {email}, až budete mít chvilku.',
      kamEmailTermin: 'Pošlete je prosím na můj e-mail {email}, ideálně před naší další schůzkou {den}',
      kamOdpoved: 'Pošlete je prosím odpovědí na tento e-mail, až budete mít chvilku.',
      kamOdpovedTermin: 'Pošlete je prosím odpovědí na tento e-mail, ideálně před naší další schůzkou {den}',
      nevadi: 'Když něco nenajdete, nevadí — projdeme to spolu. Papíry můžete přinést i na schůzku.',
      pozdrav: 'Dobrý den,',
      pozdravJmeno: 'Dobrý den, {osloveni},',
      predmet: 'Podklady k přípravě návrhu',
      predmetTermin: 'Podklady k naší další schůzce',
      uvod: 'děkuji za naši schůzku. Pro přípravu návrhu mi prosím pošlete skeny nebo fotky těchto dokumentů:',
    },
  },
  /* BLOK:podkladyKlienta END */
  /* BLOK:vykonTymu START — generuje scratchpad/slovnik.py, ručně needitovat */
  vykonTymu: {
    aktivita: {
      aria: '{metrika} za posledních {tydnu} týdnů: odškrtnuto celkem {soucet}, týdenní cíl {cil}, pod cílem {pod} z {ukoncenych} ukončených týdnů.',
      ariaBezCile: '{metrika} za posledních {tydnu} týdnů: odškrtnuto celkem {soucet}, týdenní cíl není nastavený.',
      ariaCast: '{metrika} za posledních {tydnu} týdnů: odškrtnuto celkem {soucet}. Týdenní cíl má jen {s} z {celkem} lidí, plnění týmu proto nehodnotíme.',
      ariaNovyCil: '{metrika} za posledních {tydnu} týdnů: odškrtnuto celkem {soucet}, týdenní cíl {cil}, zatím žádný ukončený týden s cílem.',
      cil: 'cíl {n}',
      cilCast: 'cíl má jen {s} z {celkem} lidí, týmový cíl nekreslíme',
      cilDrive: 'dřív cíl {n}',
      hovory: 'Hovory',
      nadpis: 'Aktivita po týdnech',
      neodskrtnuto: 'Neodškrtnuté v diáři, do sloupce ani cíle se nepočítají: {n}',
      prazdno: 'Za posledních {tydnu} týdnů není u klientů odškrtnutý žádný hovor ani schůzka.',
      probiha: 'probíhá',
      radekZalohy: '{datum}: {n}',
      schuzky: 'Schůzky',
      typNeznamy: 'Bez typu, nepočítáno: {n}',
    },
    bezJmena: 'Bez jména',
    cil: {
      chyba: 'Cíl se nepodařilo uložit.',
      hodnoty: 'Hovorů týdně: {hovory} · schůzek týdně: {schuzky}',
      hovory: 'Hovorů týdně',
      jenPrimy: 'Cíl nastavuje přímý manažer.',
      nadpis: 'Týdenní cíl aktivit',
      nastavil: 'Nastavil {jmeno}, {datum}',
      neplatny: 'Zadej celé číslo od 0 do 200.',
      prazdne: 'Prázdné pole znamená bez cíle.',
      schuzky: 'Schůzek týdně',
      ukladam: 'Ukládám…',
      ulozeno: 'Týdenní cíl uložen.',
      ulozit: 'Uložit cíl',
      zpet: 'Zpět',
      zrusit: 'Zrušit cíl',
      zrusitPotvrdit: 'Opravdu zrušit týdenní cíl?',
    },
    detail: {
      chyba: 'Výkon poradce se nepodařilo načíst.',
      hlubsi: 'Klienty a obchody otevře jeho přímý manažer.',
      koucink: 'Koučink',
      nacitam: 'Načítám výkon poradce…',
      nadpis: 'Výkon: {jmeno}',
      pipelineObchody: 'Klienti a obchody',
      zavrit: 'Zavřít',
    },
    drobecky: {
      aria: 'Patra týmu',
      ja: 'Já',
      zpet: 'Zpět na můj tým',
    },
    faze: {
      a1: 'Představení',
      a2: 'Analýza',
      p1: 'Finanční plán',
      p2: 'Prezentace',
      volani: 'Volání',
    },
    informace: {
      odpojeni: 'Odpojit tě může jen manažer — v Mém týmu tě odebere. Sám se odpojit nelze.',
      potvrzeno: 'Tvůj manažer i manažeři nad ním vidí tvoje klienty, pipeline, cíle a výkon (hovory a schůzky u klientů po týdnech). Soukromé položky v diáři nikdy, celý diář jen s tvým souhlasem. Manažer ti může nastavit týdenní cíl hovorů a schůzek.',
      pozvat: 'Zadej jeho email. Vytvoří se pozvánka, kterou musí sám přijmout v Nastavení — teprve pak uvidíš jeho klienty, obchody, cíle a výkon (hovory a schůzky u klientů po týdnech). Celý diář jen s jeho souhlasem, soukromé položky nikdy. E-mail neposíláme, odkaz mu pošli sám.',
      prijeti: 'Přijetím uvidí tvůj manažer i manažeři nad ním tvoje klienty, pipeline, cíle a výkon: kolik hovorů a schůzek u klientů máš týdně a kdy jsi byl s klientem naposledy v kontaktu. Soukromé položky v diáři nikdy, celý diář jen s tvým souhlasem.',
      rozumim: 'Rozumím',
      vzdy: 'Bez ohledu na tuto volbu vidí manažer výkon: kolik hovorů a schůzek u klientů máš týdně a kdy jsi byl s klientem naposledy v kontaktu. Bez názvů, časů a míst. Soukromé položky nikdy.',
      zvonecek: 'Tvůj manažer i manažeři nad ním vidí tvoje klienty, pipeline, cíle a výkon: kolik hovorů a schůzek u klientů máš týdně a kdy jsi byl s klientem naposledy v kontaktu. Soukromé položky v diáři nikdy, celý diář jen s tvým souhlasem.',
      zvonecekNadpis: 'Co vidí tvůj manažer',
    },
    kontrola: {
      dniBezFew: '{n} dny bez zapsané aktivity',
      dniBezMany: '{n} dní bez zapsané aktivity',
      dniBezOne: '{n} den bez zapsané aktivity',
      krokAno: 'Naplánovaný',
      krokNe: 'Chybí',
      krokPoTerminu: 'Po termínu',
      mene: 'Zobrazit méně',
      nadpis: 'Ke kontrole',
      nicZaOkno: 'Nic za posledních {dni} dní',
      nicZapsano: 'Nic zapsáno',
      oriznuto: 'Ukazujeme {zobrazeno} z {celkem}.',
      popis: 'Klienti v aktivitě, u kterých {prah} a více dní není zapsaná žádná aktivita.',
      prazdno: 'Nikdo nečeká déle než {prah} dní.',
      sloupecFaze: 'Fáze',
      sloupecKlient: 'Klient',
      sloupecKrok: 'Další krok',
      sloupecPoradce: 'Poradce',
      sloupecPosledni: 'Poslední zapsaná aktivita',
      sloupecVeFazi: 'Ve fázi',
      veFaziFew: '{n} dny',
      veFaziMany: '{n} dní',
      veFaziNevime: 'sledujeme od {datum}',
      veFaziOne: '{n} den',
      vice: 'Zobrazit všech {n}',
    },
    kpi: {
      bezKroku: 'Bez dalšího kroku',
      bezKrokuPod: 'klienti v aktivitě bez naplánované aktivity',
      pipelineBj: 'Pipeline BJ',
      pipelineBjPod: 'Představení až Prezentace',
      schuzkyTyden: 'Schůzky tento týden',
      schuzkyTydenPod: 'u klientů, odškrtnuté v diáři',
      vAktivite: 'Klienti v aktivitě',
      vAktivitePod: 'Volání až Prezentace',
    },
    nadpis: 'Výkon týmu',
    pipeline: {
      aria: 'Pipeline po poradcích: nejvíc klientů v aktivitě má {jmeno} ({pocet}).',
      detail: 'Detail',
      klientuFew: '{n} klienti',
      klientuMany: '{n} klientů',
      klientuOne: '{n} klient',
      nadpis: 'Pipeline po poradcích',
      prazdny: 'Žádný klient v aktivitě',
      radekAria: '{jmeno}: klienti v aktivitě {pocet}, pipeline {bj} BJ. {rozpad}',
      segment: '{faze} {pocet}',
      tym: 'Tým · {pocet}',
    },
    poznamka: {
      kratce: 'Jen zapsané pracovní aktivity.',
      cyklus: 'V týmu je kruh vztahů, každého ukazujeme jen jednou.',
      faze: 'Od {datum} sledujeme přechody mezi fázemi.',
      hloubka: 'Tým je hlubší než 5 pater, hlubší patra nezobrazujeme.',
      oriznuto: 'Dat je víc, než umíme najednou spočítat, čísla jsou spodní odhad.',
      patra: 'Čísla nahoře jsou za celý tým včetně pater pod ním, řádky poradců za jejich vlastní klienty.',
      zdroj: 'Počítáme jen pracovní aktivity zapsané u klienta v diáři a v časové ose klienta. Hovory, schůzky a plnění cíle jen odškrtnuté jako hotové. Soukromé položky nikdy. Co poradce nezapsal, nevidíme, a to ještě neznamená, že nepracuje.',
    },
    stav: {
      bezCile: 'Cíl nenastaven',
      chyba: 'Hluboko pod cílem',
      minulyChyba: 'Minulý týden: hluboko pod cílem',
      minulyOk: 'Minulý týden: cíl splněn',
      minulyPozor: 'Minulý týden: pod cílem',
      ok: 'Plní týdenní cíl',
      pozor: 'Pod cílem',
    },
    stavy: {
      bezPristupu: 'K tomuto týmu už nemáš přístup.',
      chyba: 'Výkon týmu se nepodařilo načíst.',
      nacitam: 'Načítám výkon týmu…',
      nedostupne: 'Výkon týmu se zapne po aktualizaci serveru.',
      prazdnyTym: 'Přímo pod vámi zatím nikdo není — žebříček níže ukazuje celou síť.',
      vrcholy: 'Týmy v systému',
      vrcholyPopis: 'Vyber tým, který chceš zobrazit.',
      znovu: 'Zkusit znovu',
    },
    zebricek: {
      jenObsazenost: 'Diář sdílí jen obsazenost — schůzky u klientů z něj nepoznáme.',
    },
  },
  /* BLOK:vykonTymu END */
  /* BLOK:pruvodce START — generuje scratchpad/slovnik.py, ručně needitovat */
  pruvodce: {
    akce: {
      domluvitTermin: 'Domluvit termín',
      jeToSpravne: 'Je to správně',
      kinoRizik: 'Pustit Kino rizik',
      nemaMajetek: 'Bez majetku',
      nemaZavazky: 'Bez závazků a pojistek',
      opraveno: 'Opraveno na {hodnota}',
      opravit: 'Opravit na {hodnota}',
      oznaceno: 'Označeno jako správné',
      prejit: 'Přejít',
      prejitNezbytne: 'Přejít na nezbytné',
      prejitObvykle: 'Přejít na obvyklé',
      prejitPrijmy: 'Přejít na příjmy',
      prejitVydaje: 'Přejít na výdaje',
      prohodit: 'Prohodit',
      prohozeno: 'Prohozeno',
      vratit: 'Vrátit',
    },
    brana: {
      dalsi: 'a další {n}',
      duvod: {
        dalsiSchuzka: 'Doplníme na další schůzce',
        jiny: 'Jiný důvod',
        nechce: 'Na přání klienta bez údaje',
        podklady: 'Klient dodá podklady',
      },
      min: {
        cil: 'Cíl s částkou a termínem',
        osoby: 'Osoby a data narození',
        prijmy: 'Příjmy',
        vydaje: 'Výdaje',
      },
      minimum: 'Povinné minimum',
      minimumSplneno: 'Povinné minimum splněno',
      nadpis: 'Připraveno na plán?',
      planOrientacni: 'Plán je orientační — chybí:',
      podezrele: 'Podezřelá čísla',
      pokracovat: 'Pokračovat do plánu',
      poradiNezapsano: 'Souhlas s pořadím cílů: nezapsán',
      poradiZapsano: 'Souhlas s pořadím cílů: zapsán {datum}',
      pozdeji: 'Chybí, ale jde pokračovat',
      poznamka: 'Poznámka (nepovinné)',
      proc: 'Proč pokračujete? (nepovinné)',
      slozka: 'Pro složku klienta: {n}',
      zaznamy: 'Záznamy ze schůzky',
      zbyvaFew: 'Chybí {n} věci — plán se spočítá, ale čísla budou orientační. Doplňte je, až budete moct.',
      zbyvaMany: 'Chybí {n} věcí — plán se spočítá, ale čísla budou orientační. Doplňte je, až budete moct.',
      zbyvaOne: 'Chybí {n} věc — plán se spočítá, ale čísla budou orientační. Doplňte ji, až budete moct.',
      zbyvaSeznamFew: 'Ještě {n} věci: {seznam}',
      zbyvaSeznamMany: 'Ještě {n} věcí: {seznam}',
      zbyvaSeznamOne: 'Ještě {n} věc: {seznam}',
      zpet: 'Zpět do analýzy',
    },
    chybi: {
      castka: 'částka',
      cil: '{nazev}: {co}',
      cilBezNazvu: 'Cíl bez názvu',
      diteKCili: 'Cíl pro děti, ale žádné dítě',
      dodaPozdeji: '{smlouva}: klient dodá',
      doplnRizika: 'Doplňte rizika: {smlouva}',
      jmenoK1: 'Jméno a příjmení klienta',
      komuPatri: 'Komu patří rizika: {smlouva}',
      narozeniDite: 'Datum narození dítěte {jmeno}',
      narozeniK1: 'Datum narození klienta',
      narozeniPartner: 'Datum narození partnera — bez něj pojištění partnera nespočteme',
      nezbytne: 'Nezbytné výdaje',
      prazdneDite: 'Prázdný řádek dítěte',
      prijemBezOsoby: 'Příjem 2. osoby bez osoby',
      smlouva: 'Smlouva',
      termin: 'termín',
      titul: 'Chybí:',
    },
    jednotka: {
      letFew: '{n} roky',
      letMany: '{n} let',
      letOne: '{n} rok',
    },
    kontrola: {
      V1: {
        hlaska: 'Výdaje {V} jsou víc než 5× příjmy {P}.',
        hlaskaBezOpravy: 'Výdaje {V} jsou víc než 5× příjmy {P}. Sedí obě čísla?',
        kratce: 'Výdaje vysoko nad příjmy',
        otazka: 'Kolik vás stojí běžný měsíc, bez splátek?',
      },
      V10: {
        hlaska: 'Datum narození {datum} je v budoucnosti.',
        kratce: 'Narození v budoucnosti',
        otazka: 'Můžete mi zopakovat datum narození?',
      },
      V11: {
        hlaska: 'Vychází věk {n}. Sedí rok narození?',
        kratce: 'Věk nesedí',
        otazka: 'Můžete mi zopakovat datum narození?',
      },
      V12: {
        hlaska: 'Datum narození dítěte {datum} nesedí k rodičům.',
        kratce: 'Dítě starší než rodič',
        otazka: 'Jaké je datum narození dítěte?',
      },
      V13: {
        hlaska: 'Z příjmů zbývá {Z}, odkládáte {X}. Sedí výdaje?',
        kratce: 'Nevysvětlený zbytek',
        otazka: 'Kam jdou peníze, které zbydou?',
      },
      V14: {
        hlaska: 'Výdaje {V} jsou víc než 2,5× příjmy {P}. Sedí obě čísla?',
        kratce: 'Výdaje nad příjmy',
        otazka: 'Kolik vás stojí běžný měsíc, bez splátek?',
      },
      V15: {
        hlaska: 'Výdaje {V} jsou jen {x} % příjmů {P}. Sedí výdaje?',
        kratce: 'Výdaje nízko pod příjmy',
        otazka: 'Kolik vás stojí běžný měsíc, bez splátek?',
      },
      V2: {
        hlaska: 'Nezbytné výdaje {N} jsou vyšší než obvyklé {V}.',
        hlaskaBezOpravy: 'Nezbytné výdaje {N} jsou vyšší než obvyklé {V}. Sedí obě čísla?',
        hlaskaObvykle: 'Obvyklé výdaje {V} jsou nižší než nezbytné {N}.',
        kratce: 'Nezbytné výdaje nad obvyklými',
        otazka: 'Kolik byste měsíčně nutně potřebovali, kdybyste museli šetřit?',
      },
      V3: {
        hlaska: 'Příjem {X} je víc než 10× výdaje {V}.',
        hlaskaBezOpravy: 'Příjem {X} je víc než 10× výdaje {V}. Není to za rok? Měsíčně {mesicne}.',
        hlaskaNejiste: 'Příjem {X} je víc než 10× výdaje {V}. Sedí obě čísla?',
        kratce: 'Příjem nejspíš za rok',
        otazka: 'Je to čistý příjem za měsíc, nebo za rok?',
      },
      V4: {
        hlaska: 'Odsouhlasený přebytek {X} je vyšší než příjmy {P}.',
        hlaskaBezOpravy: 'Odsouhlasený přebytek {X} je vyšší než příjmy {P}. Sedí přebytek?',
        kratce: 'Přebytek nad příjmy',
        otazka: 'Kolik můžete měsíčně odkládat, aniž by vás to omezilo?',
      },
      V5: {
        hlaska: 'Termín {roky} let vypadá jako letopočet.',
        hlaskaBezOpravy: 'Termín {roky} let vypadá jako letopočet. Za kolik let to je?',
        kratce: 'Termín zapsaný jako rok',
        otazka: 'Za kolik let to chcete mít?',
      },
      V6: {
        hlaska: 'Renta {X} měsíčně je víc než 20× příjem. Není to celková částka?',
        kratce: 'Renta vypadá jako kapitál',
        otazka: 'Kolik byste chtěli měsíčně dostávat?',
      },
      V7: {
        hlaska: 'Úrok {u} % vypadá jako desetinné číslo.',
        hlaskaBezOpravy: 'Úrok {u} % je nezvykle nízký. Sedí?',
        kratce: 'Úrok jako desetinné číslo',
        otazka: 'Jaký úrok máte ve smlouvě?',
      },
      V8: {
        hlaska: 'Úrok {u} % u úvěru na bydlení je nezvykle vysoký.',
        hlaskaBezOpravy: 'Úrok {u} % u úvěru na bydlení je nezvykle vysoký. Sedí?',
        kratce: 'Vysoký úrok u bydlení',
        otazka: 'Jaký úrok máte ve smlouvě?',
      },
      V9: {
        hlaska: 'Splátka {s} je víc než 20× zůstatek {j}.',
        hlaskaBezOpravy: 'Splátka {s} je víc než 20× zůstatek {j}. Nejsou prohozené?',
        kratce: 'Splátka a zůstatek prohozené',
        otazka: 'Kolik vám zbývá doplatit a kolik platíte měsíčně?',
      },
    },
    kratce: {
      bezNazvu: 'Bez názvu',
      cislo: 'číslo smlouvy',
      instituce: 'instituce',
      investiceUdaje: '{nazev}: {co}',
      menaDatum: '{nazev}: datum kurzu {mena}',
      menaKurz: '{nazev}: kurz {mena}',
      menaStary: '{nazev}: starý kurz {mena}',
      nemovitostPojisteni: '{nazev}: pojištění nemovitosti',
      obe: 'instituce a číslo smlouvy',
      obecne: 'Doplnit údaj',
      vozidloPojistka: '{nazev}: povinné ručení',
      vozidloVyroci: '{nazev}: výročí pojištění',
      zavazekCisla: '{nazev}: zůstatek a splátka',
    },
    krok: {
      cile: 'Cíle',
      hodnoty: 'Očekávání a hodnoty',
      majetek: 'Majetek',
      predstaveni: 'Čas',
      prijmy: 'Příjmy a výdaje',
      rizika: 'Rizika',
      rodina: 'Rodina',
      zavazky: 'Závazky',
      zaver: 'Závěr',
    },
    nav: 'Kroky analýzy',
    otazka: {
      prepinac: 'Otázky pro klienta',
      skryt: 'Skrýt otázky',
      titul: 'Otázka pro klienta',
      zobrazit: 'Zobrazit otázky',
    },
    otevrit: 'Zobrazit kroky analýzy',
    souhrn: '{hotovo} z {celkem} hotovo',
    stav: {
      chybiFew: 'chybí {n}',
      chybiMany: 'chybí {n}',
      chybiOne: 'chybí {n}',
      hotovo: 'hotovo',
      keKontroleFew: '{n} ke kontrole',
      keKontroleMany: '{n} ke kontrole',
      keKontroleOne: '{n} ke kontrole',
      nezacato: 'nezačato',
    },
    zde: 'jste tady',
  },
  /* BLOK:pruvodce END */
  /* VÝSTUP PLÁNU PRO KLIENTA — struktura podle etalonu Fichtner (25. 10. 2026, N1):
   * číslované sekce, detailní rozpis příjmů a výdajů, alokace, výpis majetku. */
  planVystup: {
    financniPlan: 'Finanční plán',
    obsah: 'Obsah',
    upozorneniNadpis: 'Důležitá upozornění',
    upozorneni1: 'Tento finanční plán analyzuje vaše úspory a investice, upřesňuje vaše finanční cíle a navrhuje cestu k jejich dosažení s ohledem na vaši toleranci k riziku.',
    upozorneni2: 'Všechna doporučení vycházejí z údajů, které jste nám poskytli. Kalkulace výkonnosti investic slouží jen pro ilustraci — minulá výkonnost nezaručuje budoucí.',
    upozorneni3: 'Plán je sestaven z údajů známých k datu vytvoření a je potřeba ho pravidelně aktualizovat, zejména když se změní okolnosti, za kterých vznikl.',
    upozorneni4: 'Konečné rozhodnutí o realizaci doporučení je vždy jen vaše. Transakce mohou mít daňové dopady — doporučujeme je probrat s daňovým poradcem.',
    bezZmenNadpis: 'Splnění vašich cílů, pokud nic nezměníte',
    bezZmenPopis: 'Na kolik procent dnes pokryjí vaše cíle peníze, které už máte — bez nových vkladů. Cíl má být na 100 %.',
    bezZmenCoUkazuje: 'Graf ukazuje: 1. jak máte naplněnou likvidní rezervu na neočekávané situace, 2. na kolik procent zafinancujete strategické cíle, které se pořizují za peníze, 3. na kolik procent dosáhnete na požadovanou životní úroveň od okamžiku, kdy chcete být finančně nezávislí.',
    vychazimeNadpis: 'V plánu vycházíme z následujících informací',
    vychazimePopis: 'Stejně jako v jiných oblastech života je i v osobních financích důležité vědět proč. Proto nejdřív vaše hodnoty a velké strategické cíle — jen s nimi dává každý krok plánu smysl.',
    cileNadpis: 'Vaše strategické cíle, které se pořizují za peníze',
    popisCile: 'Popis cíle',
    majetek: 'Majetek',
    hodnota: 'Hodnota',
    cisteJmeni: 'Čisté jmění (majetek − dluhy)',
    rozpisNadpis: 'Detailní rozpis příjmů a výdajů',
    prijmy: 'Příjmy',
    vydaje: 'Výdaje',
    rocniCastka: 'Roční částka',
    mesicniPrumer: 'Měsíční průměr',
    procentoZCelku: 'Procento z celku',
    procentoZPrijmu: 'Procento z příjmů',
    cistyPrijem: 'Čistý příjem — {jmeno}',
    ostatniPrijem: 'Ostatní příjmy — {jmeno}',
    pasivniPrijem: 'Pasivní příjmy (nájem, výnosy)',
    bonusy: 'Bonusy a odměny (ročně ÷ 12)',
    vydajeCelkem: 'Výdaje a splátky celkem',
    prebytekDeficit: 'Přebytek / deficit',
    mesicne: 'měsíčně',
    zajisteniNadpis: 'Pojištění — zajištění potřeb v případě nečekané události',
    investiceNadpis: 'Investice — ve spojení se zajištěním osobních cílů',
    alokaceSouhrn: 'Alokace portfolia — souhrn',
    tridaAktiv: 'Třída aktiv',
    aktualne: 'Aktuálně',
    zmena: 'Změna',
    doporuceno: 'Doporučeno',
    celkem: 'Celkem',
    nezarazeno: 'Nezařazeno (penzijní, pojistné a alternativní produkty)',
    nezarazenoPozn: 'Procenta tří tříd se počítají jen z peněžního trhu, dluhopisů a akcií. Nezařazené produkty plán řeší u jednotlivých cílů podle toho, kdy jsou peníze dostupné.',
    alokaceDleCilu: 'Alokace dle cílů',
    alokaceDleCiluPopis: 'Strategické rozložení prostředků přiřazených jednotlivým cílům podle jejich horizontu. Součet řádků je rozložení celého plánu; nezohledňuje likviditu produktů ani jejich momentální ocenění na trhu.',
    penezniTrh: 'Peněžní trh',
    penezniTrhKratce: 'Peněžní',
    dluhopisy: 'Dluhopisy',
    akcie: 'Akcie',
    zdrojeCilu: 'Z čeho se cíle platí',
    zdrojeCiluPopis: 'Které účty a produkty plán přiřazuje kterému cíli a kolik se na něj měsíčně odkládá. Jednorázový vklad = peníze, které je třeba na cíl teprve vložit.',
    dumNadpis: 'Váš plán v jednom obrázku',
    dumPopis: 'Základy (rezerva a zajištění) nesou patra s vašimi cíli seřazenými podle termínu, nahoře je finanční nezávislost. Zelená = kolik z cíle plán po realizaci pokryje.',
    dumAria: 'Dům plánu: {pointa}.',
    dumZaklady: 'Základy',
    dumRezerva: 'Rezerva {castka}',
    dumRezervaRadek: 'Rezerva',
    dumRenta: 'renta {castka}',
    dumVlastniZdroje: 'z toho vlastní zdroje {castka}',
    dumZajisteniVse: 'zajištění podle návrhu: kryto',
    dumZajisteniChybi: 'zajištění chybí: {seznam}',
    dumZajisteniChybiVeta: 'Zajištění podle návrhu zatím nekryje: {seznam}.',
    dumZdrojMajetek: 'Majetek · jednorázově',
    dumZdrojPrebytek: 'Přebytek · měsíčně',
    dumZbyva: 'zbývá {castka}',
    dumPrecerpano: 'přečerpáno o {castka}',
    dumLegMate: 'máte / splněno',
    dumLegChybi: 'chybí',
    dumLegNezname: 'nelze spočítat',
    dumLegTok: 'tok peněz z majetku a přebytku',
    dumLegVyska: 'výška patra podle částky, výš = později',
    dumHotoveNadpis: 'Co je hotové',
    dumHotove: 'Po realizaci plán pokryje celé: {seznam}.',
    dumHotoveNic: 'Zatím plán nepokryje celý žádný cíl.',
    dumVolne: 'Volných zůstává {castka}.',
    dumChybiNadpis: 'Co chybí',
    dumChybi: 'Plán zatím nepokryje celé: {seznam}.',
    dumChybiNic: 'Nic, plán po realizaci pokryje všechny cíle.',
    dumNezname: 'Nelze spočítat: {seznam}.',
    dumKrokNadpis: 'Další krok',
    dumKrokRealizace: 'Zrealizovat plán: z dnešního majetku {jednorazove} jednorázově a z přebytku {mesicne} na cíle.',
    dumKrokCil: 'Potom u cíle {nazev} ({pct}) upravit částku, termín nebo měsíční vklad, aby ho plán pokryl celý.',
    dumKrokPrecerpano: 'Plán bere víc peněz, než je k dispozici (přečerpáno o {castka}). Snižte některý cíl nebo posuňte termín.',
    dumCil: 'Cíl',
    dumKdy: 'Kdy',
    dumCastka: 'Částka',
    dumJednorazove: 'Jednorázově',
    dumMesicne: 'Měsíčně',
    dumSplneno: 'Splněno',
    tokyJednorazove: 'Tok peněz: jednorázově z majetku',
    tokyMesicne: 'Tok peněz: měsíčně z přebytku',
    tokyAria: '{druh}: {seznam}.',
    pravidelneMesicne: 'pravidelná investice',
    pritok: 'budoucí přítok',
    diverzifikace: 'Diverzifikace',
    diverzifikacePopis: 'Čím z více úhlů pohledu je portfolio rozložené (měny, správci, emitenti), tím lépe je chráněné před jedním průšvihem. Metodika: nejvýš 5 % majetku u jednoho korporátního emitenta.',
    menyChip: 'Měny: {pocet} ({meny}) · domácí měna {pct} %',
    spravciChip: 'Instituce a správci: {pocet} · největší {nazev} {pct} %',
    emitentChip: 'Nad {limit} % u jednoho emitenta: {polozky}',
    zrealizujeteNadpis: 'Splnění vašich cílů, pokud naše doporučení zrealizujete',
    zrealizujetePopis: 'Vlevo stav dnes, vpravo po realizaci plánu. Cíl má být na 100 %.',
    vyvojNadpis: 'Analýza majetku a cash flow rok po roce',
    vyvojPopis: 'Portfolio na finanční nezávislost podle plánu: kolik bude celkem vloženo a jakou hodnotu bude mít (v dnešních cenách, podle očekávaného výnosu zvolené alokace).',
    rok: 'Rok',
    vlozenoCelkem: 'Vloženo celkem',
    hodnotaPortfolia: 'Hodnota portfolia',
    podilCile: 'Podíl z cíle',
    vyvojPozn: 'Výsledky jsou orientační a nelze je pokládat za příslib budoucnosti.',
    vypisNadpis: 'Výpis majetku',
    vypisPopis: 'struktura majetku k datu plánu — podle tříd aktiv, měn a institucí',
    majetekCelkem: 'Majetek celkem',
    financniAktiva: 'Finanční aktiva',
    nefinancniMajetek: 'Nefinanční majetek',
    dluhy: 'Dluhy',
    podleTrid: 'Podle tříd aktiv',
    podleMen: 'Podle měn',
    podleInstituci: 'Podle institucí a správců (finanční aktiva)',
    pokracovani: 'pokračování',
    ostatni: 'ostatní',
    krytoZdroji: 'kryto zdroji',
    neuvedeno: 'instituce neuvedena',
    nezapocteno: 'Nezapočteno — chybí platný kurz: {polozky}',
    polozky: 'Položky',
    polozka: 'Položka',
    instituce: 'Instituce',
    cilovaAlokace: 'Cílová alokace × současná (finanční aktiva)',
    rozdil: 'Rozdíl',
    tridaPenezni: 'Peněžní trh (účty, spoření)',
    tridaDluhopisy: 'Dluhopisy',
    tridaAkcie: 'Akcie',
    tridaAlternativni: 'Alternativní a ostatní investice',
    tridaPenzijni: 'Penzijní produkty',
    tridaPojisteni: 'Životní pojištění s hodnotou',
    tridaNemovitosti: 'Nemovitosti, auto, cennosti',
    tridaFirma: 'Firma / podnikání',
    vytvoreno: 'Vytvořeno',
    strana: 'Strana',
  },
  /* BLOK:navrhV2 START — Návrh řešení v 9 krocích (15. 10. 2026). Zdroj: lib/navrh/texty/*.js,
     shodu hlídá lib/navrh/__tests__/slovnikNavrhV2.test.js — needitovat ručně, upravit text v lib/navrh/texty. */
  navrhV2: {
    dilna: {
      titul: 'Dílna',
      podtitul: 'pracovní stůl poradce · klient ji nevidí',
      sekce: {
        pripraveno: 'Připraveno pro klienta?',
        penize: 'Rozdělení peněz',
        penizePod: 'dřív Tabulka / Shrnutí',
        texty: 'Texty pro klienta',
        textyPod: 'návrh systému, dokud nenapíšete vlastní',
        produkty: 'Alokace, poplatky a produkty',
        nastaveni: 'Nastavení výpočtu a metodika',
        poznamka: 'Poznámka a dávky',
      },
      znacka: {
        chyba: 'chyba',
        pozor: 'pozor',
        info: 'chybí podklad',
      },
      pripraveno: {
        vecOne: '{n} věc',
        vecFew: '{n} věci',
        vecMany: '{n} věcí',
        nicNeblokujeKratce: 'nic neblokuje',
        blokujeKratce: 'blokuje prezentaci',
        vsePripraveno: 'vše připraveno',
        blokujeNadpis: 'Blokuje prezentaci',
        chybiNadpis: 'Chybí, ale jde pokračovat',
        tiskNadpis: 'Pro tištěný plán',
        nicNeblokuje: 'Nic neblokuje — příjmy i plán jsou spočítané podle aktuální metodiky',
        nicNeblokujePostaru: 'Nic neblokuje — příjmy jsou zadané, plán je zatím spočítaný postaru',
        nicNechybi: 'Nic nechybí.',
        prejit: 'Přejít',
        doplnitVAnalyze: 'Doplnit v analýze',
        otevrit: 'Otevřít',
      },
      polozka: {
        prijemPrijmy: 'Chybí příjmy — bez nich plán nespočítá',
        prijemNula: 'Přebytek je nula — plán nemá co rozdělit',
        cenaOchrany: 'Cena ochrany pro variantu {varianta} chybí — krok 8 i Před a po jsou zatím bez ceny',
        cenaOchranyCast: 'Cena ochrany pro variantu {varianta} je zadaná jen u části osob',
        majetekOne: 'Majetek a odpovědnost: {n} smlouva čeká na cenu pojišťovny',
        majetekFew: 'Majetek a odpovědnost: {n} smlouvy čekají na cenu pojišťovny',
        majetekMany: 'Majetek a odpovědnost: {n} smluv čeká na cenu pojišťovny',
        majetekOverit: 'Majetek a odpovědnost: obsah smlouvy se od zadání ceny změnil — ověřte cenu (smluv: {n})',
        uverDnes: 'Úvěr dnes ({nazev}): chybí {co}',
        coUrok: 'úrok',
        coKonec: 'konec splácení',
        coOba: 'úrok a konec splácení',
        bydleni: '{nazev}: financování {pct} % je zatím jen návrh systému — vyberte ho s klientem',
        bydleniBezPct: '{nazev}: financování je zatím jen návrh systému — vyberte ho s klientem',
        schodek: 'Schodek po čerpání úvěrů: {kroky} měsíčně',
        schodekKrok: 'od {rok} {castka}',
        partner: '{jmeno}: chybí datum narození — zajištění se nespočítá',
        staryPlan: 'Plán je spočítaný postaru (metodika {datum}) — přepočet je v Nastavení výpočtu',
        nadPrebytek: 'Plán chce z přebytku {plan}, přebytek je {prebytek} — měsíčně chybí {chybi}. Upravte částky v Rozdělení peněz',
        rezervaDosporit: 'Rezerva bude s plánem jen na {pct} % — z přebytku jde dospořit {castkaMes} měsíčně po dobu {mesicu} měs. (krok 4)',
        rezerva: 'Rezerva bude s plánem jen na {pct} % — na dospoření není volný přebytek',
        cilBezCastky: 'Cíl „{nazev}“ nemá částku — plán ho nepočítá',
        cilBezTerminu: 'Cíl „{nazev}“ nemá termín — plán na něj nespoří',
        cilBezObojiho: 'Cíl „{nazev}“ nemá částku ani termín — plán ho nepočítá',
        zivotPod20: 'Na volné výdaje zbude jen {pct} % příjmu ({castka} měsíčně) — doporučujeme 20 až 30 %. Klient to uvidí v kroku 8',
      },
      tisk: {
        produkty: 'Produkty',
        coKdyProc: 'Co / Kdy / Proč',
        poznamka: 'Poznámka k návrhu',
        starobni: 'Starobní důchod',
        navrhSystemu: 'návrh systému',
        upraveno: 'upraveno poradcem',
        zadnyRadek: 'žádný řádek',
        prazdna: 'prázdná',
        vyplnena: 'vyplněná',
        nezadano: 'nezadaný — do tisku se nepíše',
        rucne: 'zadaný ručně',
        radkuOne: '{n} řádek',
        radkuFew: '{n} řádky',
        radkuMany: '{n} řádků',
      },
      penize: {
        prebytek: 'Přebytek',
        naPlan: 'Na plán dnes',
        zbyva: 'Zbývá trvale',
        presuny: 'Přesuny z úspor',
        drziSplatka: 'dnes {castka}, pak ho drží splátka',
        odkud: 'Odkud peníze jdou',
        kam: 'Kam',
        podlePlanu: 'podle plánu',
        rozdelenoRucne: 'rozděleno ručně po částkách',
        zatimNikam: 'zatím nikam',
        vLetech: 'v {vek} letech',
        zadneZdroje: 'Klient nemá úspory, které by šlo přidělit.',
        rust: 'Růst mzdy a přítoky',
        pritokyCile: 'Jednorázové přítoky k cílům',
        tabulka: 'Tabulka A4 naležato',
        tabulkaNeulozeno: 'Návrh se nepodařilo uložit — tabulka by ukázala starou verzi.',
        prehled: 'Rozdělení po cílech',
        sloupec: {
          cil: 'Cíl',
          kdy: 'Kdy',
          kolik: 'Kolik',
          jednorazove: 'Jednorázově',
          mesicne: 'Měsíčně',
          dosazeno: 'Dosaženo',
        },
        plusKroky: '+ navýšení v čase',
        rucne: 'Upravit rozdělení ručně',
        rucnePod: 'jednorázově a měsíčně po cílech, odkud peníze jdou',
      },
      texty: {
        cile: 'Texty k cílům',
        coKdyProc: 'Co / Kdy / Proč pro tištěný plán',
        co: 'Co',
        kdy: 'Kdy',
        proc: 'Proč',
        coPlaceholder: 'Co doporučujeme',
        pridatRadek: 'Přidat řádek',
        smazatRadek: 'Smazat řádek',
        pojistky: 'Řešení u pojistek',
      },
      produkty: {
        alokace: 'Alokace',
        alokaceZProfilu: 'Alokace z profilu {profil}',
        alokaceRucne: 'Alokace upravená ručně',
        akcie: 'Akcie',
        dluhopisy: 'Dluhopisy',
        hotovost: 'Hotovost',
        upravitAlokaci: 'Upravit alokaci',
        hotovo: 'Hotovo',
        soucet: 'Součet {pct} %',
        soucetSpatne: 'Součet {pct} % — má být 100 %',
        zpetNaProfil: 'Zpět na profil',
        vstupni: 'Vstupní poplatek % ({min}–{max})',
        sprava: 'Správa % ročně ({min}–{max})',
        nezadano: 'nezadáno',
        spravaVychozi: 'Prázdné pole = v grafech výchozí správa {pct} %.',
        titul: 'Produkty',
        nazev: 'Název produktu',
        castka: 'Částka',
        akce: 'Akce',
        koupit: 'Koupit',
        prodat: 'Prodat',
        ponechat: 'Ponechat',
        navysit: 'Navýšit',
        pridat: 'Přidat produkt',
        smazat: 'Smazat produkt',
        zadnyRadek: 'Zatím žádný řádek.',
        sjednat: 'Sjednat → Smlouva',
        sjednatPopis: 'Klient souhlasí? Produkty se předvyplní do smlouvy.',
      },
      nastaveni: {
        profil: 'Profil',
        scenar: 'Scénář',
        metodikaAktualni: 'Metodika {datum} — aktuální, nic k přepočtu.',
        metodikaBezZmen: 'Metodika {datum} — u tohoto klienta nová metodika nic nemění.',
      },
      poznamka: {
        placeholder: 'Poznámka k řešení — vytiskne se v plném plánu',
        davky: 'Sociální dávky pro tištěný plán',
        odhad: 'odhad z příjmu',
        rucne: 'zadáno ručně',
        zpetNaOdhad: 'Zpět na odhad',
        starobniNezadano: 'Starobní důchod: nezadaný — tištěný plán ho neuvede.',
      },
    },
    kroky14: {
      krok1: {
        nadpis: 'Proč to děláme',
        citace: '„{text}“',
        analyza: '{jmena}, analýza {datum}',
        spojka: 'a',
        cileAria: 'Vaše cíle',
        mesicneOd: '{castka} měsíčně · od {rok}',
        vDnesnichCenach: 'v dnešních cenách',
        renta: 'Finanční nezávislost',
        uverem: 'úvěrem',
        castkaNezadana: 'částka nezadaná',
        bezTerminu: 'bez termínu',
      },
      krok2: {
        nadpis: 'Kde jste dnes',
        majetek: 'Majetek',
        naUctech: 'Na účtech',
        sporeni: 'Spoření a investice',
        nemovitosti: 'Nemovitosti',
        celkem: 'Celkem',
        dluhy: 'dluhy {castka}',
        bezDluhu: 'bez dluhů',
        ze100: 'Z každých 100 {sym} příjmu',
        dnes: 'Dnes',
        sPrebytkem: 'S přebytkem',
        prebytek: 'Přebytek {castka} měsíčně',
        odsouhlaseny: 'odsouhlasený',
        nadVolne: '{castka} z něj ubereme z výdajů na život (Život {a} → {b})',
        dobre: 'Co děláte dobře',
        odklad: 'Odkládáte {pct} % příjmu ({castka}) · s přebytkem {pctPo} %',
        odkladJen: 'Odkládáte {pct} % příjmu ({castka})',
        rezerva: 'Rezerva je ze {pct} % hotová',
        rezervaHotova: 'Rezervu máte hotovou',
        most: 'Když {jmeno} nemůže pracovat, chybí rodině {castka} měsíčně',
        mostJeden: 'Při invaliditě chybí {castka} měsíčně',
        mostAkce: 'Zajištění',
        detail: 'Složení majetku a úvěry',
        budouci: 'Budoucí majetek: {nazev}',
        uvery: 'Úvěry dnes',
        zbyva: 'zbývá {castka}',
        splatka: 'splátka {castka}',
        hypoChybi: 'U hypotéky chybí úrok a konec splácení — modelace se ukáže po doplnění.',
      },
      krok3: {
        nadpis: 'Zajištění příjmu',
        rucniOne: '{n} ruční úprava',
        rucniFew: '{n} ruční úpravy',
        rucniMany: '{n} ručních úprav',
        vratitVse: 'Vrátit vše',
        invalidita: 'Nejhorší riziko je invalidita',
        dnes: 'Dnes',
        nemuze: '{jmeno} nemůže pracovat',
        nemuzeJeden: 'Když nemůžete pracovat',
        duchod: 'invalidní důchod',
        potreba: 'potřeba {castka}',
        chybi: 'Chybí {castka} měsíčně',
        nicNechybi: 'Příjmy pokryjí potřebu, nic nechybí',
        prumer: 'invalidní důchod {castka} je průměr',
        aria: 'Dnes přichází {dnes}. Když {jmeno} nemůže pracovat, přijde {prijde} a potřeba je {potreba} měsíčně.',
        ariaJeden: 'Dnes přichází {dnes}. Když nemůžete pracovat, přijde {prijde} a potřeba je {potreba} měsíčně.',
        pojistka: 'Vy už máte nějakou pojistku?',
        platba: '{castka} měsíčně',
        platbaNezadana: 'platba nezadaná',
        predApo: 'Před a po',
        veta: 'Když {jmeno} přijde o zdraví, rodina dostane {nove} místo {dnes}.',
        vetaJeden: 'Když přijdete o zdraví, dostanete {nove} místo {dnes}.',
        vetaNema: 'Když {jmeno} přijde o zdraví, rodina dostane {nove}. Dnes nic.',
        vetaNemaJeden: 'Když přijdete o zdraví, dostanete {nove}. Dnes nic.',
        vetaBez: 'Když {jmeno} přijde o zdraví, rodina dostane {nove}.',
        vetaBezJeden: 'Když přijdete o zdraví, dostanete {nove}.',
        dovetek: 'Nově = na začátku, s lety klesá.',
        vetaCena: 'Platíte {dnes} měsíčně, nově {nove}.',
        vetaCenaJen: 'Nově budete platit {nove} měsíčně.',
        dalsiRizika: 'Další rizika · {n}',
        pojistne: 'pojistné {dnes} → {nove}',
        pojistneNove: 'pojistné {nove}',
        rizikOne: '{n} riziko',
        rizikFew: '{n} rizika',
        rizikMany: '{n} rizik',
        dnesNezadano: 'dnes nezadáno',
        jakSePocita: 'Jak se počítá',
        nespocteno: '{jmeno}: nespočteno — chybí datum narození',
        doplnit: 'Doplnit v analýze',
        varianty: 'Jak velké krytí chcete?',
        invaliditaKoho: 'Invalidita · {jmeno}',
        invaliditaSloupec: 'Invalidita',
        variantaSloupec: 'Varianta',
        cena: 'Cena',
        cenaNezadana: 'cena zatím nezadaná',
        mesicne: '{castka} měsíčně',
        zvoleno: 'zvoleno',
        ulozeno: 'Uloženo: {nazev}',
        vratit: 'Vrátit',
        coZnamenaji: 'Co varianty znamenají',
        majetek: 'Majetek a odpovědnost',
        bezSmluvMajetku: 'Žádná smlouva na majetek',
        vysvetlitMajetek: 'Vysvětlit majetek',
        upravitKryti: 'Upravit částky a volby krytí',
      },
      krok4: {
        nadpis: 'Rezerva',
        cil: 'Cíl {castka}',
        zakladOne: '{n} měsíc nezbytných výdajů a splátek ({castka})',
        zakladFew: '{n} měsíce nezbytných výdajů a splátek ({castka})',
        zakladMany: '{n} měsíců nezbytných výdajů a splátek ({castka})',
        mate: 'Máte',
        chybi: 'Chybí',
        zFondu: 'Doplníme z fondů',
        zaOne: 'za {n} měsíc',
        zaFew: 'za {n} měsíce',
        zaMany: 'za {n} měsíců',
        kde: 'Na spořicím účtu nebo ve fondu peněžního trhu, ne v akciích.',
        hotova: 'Rezerva je hotová',
        aria: 'Rezerva dnes {dnes} %, s plánem {po} %',
        dnesPct: 'dnes {pct} %',
        poPct: 's plánem {pct} %',
        dosporitNabidka: 'Dospořit {castka} měsíčně po dobu {mesicu} měs.',
        dosporeni: 'Dospoříme z přebytku {castka} měsíčně po dobu {mesicu} měs.',
        dosporitZrusit: 'Zrušit dospoření',
      },
      nezadano: 'nezadáno',
    },
    kroky56: {
      k5: {
        nadpis: 'Vaše cíle',
        cipyAria: 'Vaše cíle v pořadí let',
        uverem: 'úvěrem',
        renta: 'Renta',
        profilRadek: 'Profil: {profil} · {scenar} · s brzdou před cílem',
        zmenitVDilne: 'Změnit v Dílně',
        zadneCile: 'Kromě rezervy a renty nejsou v plánu další cíle.',
      },
      profil: {
        dynamicky: 'Dynamický',
        vyvazeny: 'Vyvážený',
        konzervativni: 'Konzervativní',
      },
      karta: {
        castkaRok: '{castka} · {rok}',
        vek: '{jmeno} v {vek} letech',
        plneni: 'dnes {dnes} % → s plánem {po} %',
        sPlanem: 's plánem {po} %',
        mesicne: 'Měsíčně',
        jednorazove: 'Jednorázově',
        splatkaOd: 'Splátka od {rok}',
        bezPenez: 'Zatím bez peněz',
        chybi: 'chybí {castka}',
        modelove: 'Modelově v {rok}',
        cil: 'Cíl',
        splneno: 'splněno',
        chybiNadpis: 'Chybí',
        upravitCil: 'Upravit částku a rok cíle',
        castkaPole: 'Částka cíle',
        rokPole: 'Rok cíle',
        pouzit: 'Použít',
        zrusit: 'Zrušit',
        vratit: 'Vrátit hodnoty z analýzy',
        upraveno: 'upraveno',
        detail: 'Detail',
        glideNadpis: 'Jak se mění složení',
        prvni: 'První rok',
        polovina: 'V polovině',
        posledni: 'Poslední rok',
        slozeni: 'akcie {akcie} % · dluhopisy {dluhopisy} % · hotovost {cash} %',
        jakInvestovat: 'Jak investovat',
        jakInvestovatText: 'Podle plánu, profil {profil}: před cílem se akcie postupně prodávají, poslední rok je vše v hotovosti.',
      },
      duvod: {
        splatka: 'Od {rok} spolkne celý přebytek splátka úvěru „{popis}“ — měsíčně sem nezbývá.',
        drivejsi: 'Přebytek dnes berou dřívější cíle.',
        bezTerminu: 'Cíl zatím nemá termín — plán na něj nespoří.',
        jine: 'Plán sem zatím nic nedává.',
      },
      fin: {
        krok1: 'Jak koupi zafinancujete',
        jakZaplatit: 'Jak zaplatíte',
        zaplatitSporenim: 'Naspořit celé',
        zaplatitUverem: 'Úvěrem',
        krok2: 'Naspořit vlastní zdroje',
        uver: 'Úvěr',
        hypoteka: 'Hypotéka',
        uverem100: '100 % úvěrem',
        hotove: 'Hotově',
        hotovePct: '{pct} %',
        produkt: 'Druh úvěru',
        spotrebitelsky: 'Spotřebitelský',
        stavebko: 'Ze stavebka',
        splatnost: 'Splatnost',
        urokRocne: 'Úrok ročně',
        volba: 'Volba',
        vlastniZdroje: 'Vlastní zdroje',
        mesicneDoKoupe: 'Měsíčně do koupě',
        splatka: 'Splátka',
        a10: '10 % vlastní',
        a20: '20 % vlastní',
        a30: '30 % vlastní',
        a100: '100 % ze stavebka',
        zastava: '100 % zástavou nemovitosti',
        duvodVek: 'jen do 36 let · {jmeno} bude v roce {rok} mít {vek} let',
        duvodVekNbs: 'jen první bydlení do 35 let · {jmeno} bude v roce {rok} mít {vek} let',
        duvodDo2026: 'při koupi do konce roku 2026 jen 20 % vlastních zdrojů',
        duvodNemovitost: 'jen první bydlení bez jiné nemovitosti',
        duvodK2: 'chybí datum narození druhého žadatele',
        duvodVekNeznamy: 'chybí datum narození',
        duvodNelze: 'tuto volbu plán neumí spočítat',
        a100Rozpis: 'hypotéka {hypo} + stavebko {stavebko}',
        zastavaRadek: 'zástava: {nazev} {castka}',
        zatizeni: 'ověřte zatížení — na nemovitosti je hypotéka',
        hypoInfo: 'Hypotéka {sazba} % na {roky}',
        dalsiMoznosti: 'Další možnosti financování',
        klientVolba: '{volba} · {uver} na {roky}',
        sporitVysledek: 'Modelově za {roky} {hodnota} z {cil}',
        bezVlastnich: 'Vlastní zdroje nejsou potřeba — celou cenu kryje úvěr.',
        schodek: 'Od {rok} chybí v rozpočtu {castka} měsíčně.',
      },
      k6: {
        nadpis: 'Renta',
        nazev: 'Finanční nezávislost',
        podnadpis: '{castka} měsíčně v dnešních cenách · od {rok}',
        kapital: 'Potřebný kapitál',
        kapitalPozn: 'čerpání 4 % ročně, nekonečná renta',
        planDava: 'Plán dává modelově',
        pasmo: '{od} – {do}',
        pasmoPozn: 'horší až lepší scénář',
        poPoplatcichCastka: 'po poplatcích {castka}',
        poPoplatcichPct: 'po poplatcích {pct} %',
        dnes: 'dnes',
        zdrojRadek: '{popis} · {kdy}',
        zdrojVek: '{rok}, v {vek}',
        mesicneOdDneska: 'Měsíčně od dneška',
        mesicnePopo: 'Měsíčně {kroky}',
        mesicneOd: 'Měsíčně od {rok}',
        az: 'až {castka}',
        zdrojeDoRenty: 'Stavebko a penzijko do renty',
        ano: 'ano',
        ne: 'ne',
        doCeho: 'Do čeho investujeme',
        rentier: 'Rentiérské portfolio: akcie {akcie} % · dluhopisy {dluhopisy} % · hotovost {cash} %. Drží se i při čerpání renty.',
        bezRenty: 'Renta zatím v analýze zadaná není.',
      },
      graf: {
        vlozeno: 'Vloženo',
        modelove: 'Modelově',
        poPoplatcich: 'Po poplatcích',
        pasmo: 'horší až lepší scénář',
        pasmoBublina: 'Horší – lepší scénář',
        cil: 'Cíl {castka}',
        kapital: 'Kapitál {castka}',
        aria: '{nazev}: modelově {hodnota} v roce {rok} z {cil}, v horším scénáři {od}, v lepším {do}, po poplatcích {po}. Modelace, ne záruka.',
        vetaRoku: 'Vloženo {vlozeno} · modelově {hodnota} · po poplatcích {po}',
        dnes: 'dnes',
      },
      letOne: '{n} rok',
      letFew: '{n} roky',
      letMany: '{n} let',
    },
    kroky79: {
      k7: {
        sPlanem: 'S plánem',
        naUctu: 'Na spořicím účtu',
        poPoplatcich: 'po poplatcích',
        pasmo: 'horší až lepší scénář',
        pasmoBublina: 'Horší – lepší scénář',
        veta: 'Stejné peníze, stejné cíle: za {roky} modelově {sPlanem} s plánem (v horším scénáři {horsi}), {naUctu} na spořicím účtu.',
        vetaSPoplatky: 'Stejné peníze, stejné cíle: za {roky} modelově {sPlanem} s plánem před poplatky ({poPoplatcich} po poplatcích, v horším scénáři {horsi}), {naUctu} na spořicím účtu.',
        vetaUcet: 'Na spořicím účtu = tytéž peníze ve stejný den, sazba spořicího účtu {sazba} % ročně nad inflaci (v dnešních cenách).',
        chybiNaUctu: 'Na spořicím účtu by v roce {rok} na „{cil}“ chybělo {castka}.',
        vetaRoku: 'S plánem {sPlanem} · na spořicím účtu {naUctu}',
        aria: 'Za {roky} modelově {sPlanem} s plánem před poplatky, {poPoplatcich} po poplatcích, v horším scénáři {horsi}, na spořicím účtu {naUctu}. Model, ne garance.',
        dnes: 'dnes',
        schodek: 'Plánu po čerpání úvěrů chybí {seznam} měsíčně — nejdřív to vyřešíme (krok 8).',
        schodekPrez: 'Plánu po čerpání úvěrů chybí {seznam} měsíčně — nejdřív to vyřešíme.',
        postaru: 'Spočítáno postaru — srovnání se ukáže po přepočtu.',
        prepocitat: 'Přepočítat',
        bezCilu: 'Plán zatím neposílá peníze do žádného cíle — není co srovnat.',
        odklad: 'Co stojí odklad',
        odkladUvod: 'Kolik měsíčně je potřeba na rentu {renta}:',
        odkladDnes: 'když začnete dnes',
        odkladZa: 'když začnete za {roky}',
        mesicneCastka: '{castka} měsíčně',
      },
      k8: {
        mesicne: 'Měsíčně',
        mesicneRozpad: 'ochrana {ochrana} (dnes {dnes}) · investice {investice}',
        mesicneBezCeny: 'investice {investice} · ochrana zatím bez ceny',
        mesicneBezNove: 'investice {investice} · bez nové ochrany',
        bezNoveOchrany: 'bez nové ochrany',
        vicNezDnes: 'o {castka} víc než dnes',
        orientacne: 'orientačně {castka} · odhad appky, neodečítá se',
        jednorazove: 'Nové peníze jednorázově',
        presunyUvod: 'Přesuneme z vašich úspor:',
        presun: '{odkud} → {kam}',
        vRoce: 'v roce {rok}',
        zaMesicu: 'za {n} měs.',
        odkud: {
          ucty: 'účty a stavebko',
          fondy: 'fondy',
          penzijko: 'penzijko',
          pritok: 'budoucí příjem',
          dopocet: 'vklad navíc',
        },
        kam: {
          rezerva: 'rezerva',
          renta: 'renta',
        },
        vetaPrebytek: 'Z přebytku {prebytek} jde na plán {plan}, zbývá {zbyva}.',
        vetaPrebytekDrzi: 'Z přebytku {prebytek} jde na plán {plan}.',
        vetaNadPrebytek: 'Plán chce z přebytku {plan}, přebytek je {prebytek} — měsíčně chybí {chybi}.',
        vetaDrzi: 'Zbylých {castka} plán na cíle nepoužije: od roku {rok} je spolkne splátka úvěru „{uver}“.',
        schodek: 'Po čerpání úvěrů chybí {seznam} měsíčně.',
        schodekPolozka: 'od roku {rok} {castka}',
        stovka: 'Na volné výdaje (mimo povinné) vám zbude {pct} % příjmu ({castka} měsíčně) — doporučujeme 20 až 30 %.',
        ochranaOsob: 'Ochrana osob',
        cenaOsoby: '{jmeno} · měsíčně',
        cenaDeti: 'Děti · měsíčně',
        cenaPh: 'cena od pojišťovny',
        pojistne: 'Pojistné: dnes {dnes} → {nove}',
        pojistneRozdil: '({rozdil})',
        cenaNezadana: 'cena zatím nezadaná',
        majetek: 'Majetek a odpovědnost',
        smlouvyOne: '{n} smlouva',
        smlouvyFew: '{n} smlouvy',
        smlouvyMany: '{n} smluv',
        investice: 'Investice',
        poplatky: 'vstupní poplatek {vstupni} % · správa {sprava} % ročně',
        poplatkyNezadane: 'vstupní poplatek a správa: nezadané',
        mesicneCastka: '{castka} měsíčně',
        rozdeleni: 'Rozdělení přebytku',
        zUspor: 'Jednorázově z úspor',
        zPrebytku: 'Měsíčně z přebytku {prebytek}',
        ochranaRozdil: 'ochrana (rozdíl proti dnešku)',
        zbyvaDnes: 'zbývá dnes',
        udalostSplatka: 'od roku {rok} · splátka úvěru „{popis}“',
        udalostDoplaceno: 'v roce {rok} · doplaceno „{popis}“',
        udalostRenta: 'od roku {rok} · renta navíc',
        uvolniSe: 'uvolní se',
        cashflow: 'Cash flow v čase',
        cashflowAria: 'Graf cash flow plánu: dnes zbývá {dnes} měsíčně, v nejhorším roce {nejhorsi}.',
        zmenitVDilne: 'Upravit v Dílně',
      },
      k9: {
        tri: {
          zajistit: 'Zajistit příjem a majetek',
          rezervaDluhy: 'Rezerva a drahé dluhy',
          investovat: 'Investovat',
        },
        ochrana: '{varianta} · {cena} měsíčně',
        ochranaBezCeny: '{varianta} · cena zatím nezadaná',
        ochranaBezNove: '{varianta} · bez nové ochrany',
        majetek: 'majetek {smlouvy}',
        majetekCena: 'majetek {smlouvy} · {cena} měsíčně',
        rezerva: 'Rezerva {castka}',
        rezervaHotovo: 'Rezerva {castka} · hotovo',
        dluhy: 'splatit úvěr {castka}',
        investice: '{castka} měsíčně na cíle',
        investiceSchodek: 'Zatím {castka} měsíčně · od roku {rok} chybí {chybi}',
        chybiPodklad: 'chybí podklad',
        smysl: 'Dává vám to smysl?',
        citace: 'Na začátku jste řekli: „{hodnoty}“',
        domluveno: 'Domluveno',
        ja: 'Já (poradce)',
        vy: 'Vy',
        vyJmena: 'Vy ({jmena})',
        a: 'a',
      },
      doma: {
        tlacitko: 'Promyslíme to doma',
        ukladam: 'Ukládám…',
        neulozeno: 'Plán se nepodařilo uložit. Zkuste to prosím znovu.',
        titul: 'Váš finanční plán',
        intro: 'Dobrý den, posílám plán, který jsme spolu prošli. V klidu si ho doma projděte a dejte mi vědět.',
      },
      snimek: {
        hero: 'Plán měsíčně',
        heroBezCeny: 'Investice měsíčně (ochrana zatím bez ceny)',
        poPoplatcich: 'Po poplatcích za {roky}',
        pro: 'Pro',
        prebytek: 'Přebytek',
        naPlan: 'Z přebytku na plán',
        presuny: 'Přesuny z úspor',
        ochrana: 'Ochrana · {varianta}',
        investice: 'Investice měsíčně',
        sPlanem: 'S plánem za {roky}',
        naUctu: 'Na spořicím účtu',
        garance: 'Model z vašich čísel, ne garance.',
      },
    },
    ramec: {
      analyza: 'Analýza',
      zpetNaAnalyzu: 'Zpět na analýzu',
      navrhDatum: 'Návrh řešení · {datum}',
      klient: 'Klient',
      spojka: 'a',
      pasek: {
        popis: 'Měsíčně',
        prebytek: 'Přebytek',
        plan: 'plán',
        splatky: 'splátky',
        zbyva: 'zbývá',
        chybi: 'chybí',
      },
      pohled: {
        skupina: 'Pohled',
        dilna: 'Dílna',
        plan: 'Plán',
        klient: 'Pro klienta',
      },
      kDoplneni: 'K doplnění: {n}',
      ulozeni: {
        neulozeno: 'Neuloženo',
        uklada: 'Ukládám…',
        ulozeno: 'Uloženo {cas}',
        chyba: 'Neuloženo',
        offline: 'Offline',
        zkusitZnovu: 'Zkusit znovu',
        chybaText: 'Změny se nepodařilo uložit.',
      },
      prezentovat: 'Prezentovat',
      prezentovatBlokuje: 'Prezentovat zatím nejde: {duvod}',
      zpetDoUprav: 'Zpět do úprav',
      dalsiKrok: 'Další krok',
      krokZ: 'Krok {n} z {z}',
      krokyPlanu: 'Kroky plánu',
      znacka: {
        chyba: 'chyba',
        pozor: 'pozor',
        info: 'chybí podklad',
      },
      nacitani: 'Načítám návrh…',
      chybaNacteni: 'Návrh se nepodařilo načíst.',
      bezPrijmu: {
        kroky: 'Kroky 3–9',
        veta: 'Bez příjmů plán nespočítá — doplňte příjmy v analýze.',
        vetaNula: 'Přebytek je nulový nebo záporný — plán nemá z čeho platit. Upravte výdaje nebo přebytek v analýze.',
        akce: 'Přejít na příjmy',
      },
      dialogChybi: {
        nadpis: 'Klient uvidí, co ještě chybí',
        dalsi: 'Další v Dílně: {n}',
        doplnit: 'Doplnit',
        prezentovat: 'Prezentovat i tak',
        zrusit: 'Zpět',
      },
      staryPlan: {
        veta: 'Spočítáno postaru ({datum})',
        vetaBezData: 'Spočítáno postaru',
        prepocitat: 'Přepočítat',
        coSeZmeni: 'Co se změní',
      },
      offline: 'Offline · změny se uloží po připojení.',
      prezentace: {
        oblast: 'Prezentace plánu',
        krokZ: 'krok {n} z {z}',
        cilZ: 'cíl {n} z {z}',
        dalsi: 'Další',
        predchozi: 'Předchozí',
        konec: 'Ukončit prezentaci',
        dokoncit: 'Dokončit',
      },
      uvod: {
        nadpis: 'Váš finanční plán',
        veta: 'Projdeme ho spolu krok za krokem.',
      },
      dveZpravy: {
        nadpis: 'Mám pro vás dvě zprávy',
        dobraCile: 'První je dobrá: [[vaše cíle se podaří naplnit.]]',
        dobraPlan: 'Dobrá zpráva: [[máte plán.]]',
        lepsiCesta: 'Ta ještě lepší: jdete k nim [[bezpečnější cestou]].',
        lepsiDrive: 'Ta ještě lepší: na rentu můžete přejít [[už za {za}]] — o {o} dřív.',
        rentaNa: 'Renta je zatím na [[{pct} %]] — a přesně vidíme, co s tím udělat.',
        rentaNezadana: 'Cíl renty zatím není zadaný.',
      },
      dialogStary: {
        nadpis: 'Plán je spočítaný postaru ({datum})',
        nadpisBezData: 'Plán je spočítaný postaru',
        text: 'Starý výpočet zůstává, dokud ho nepřepočítáte. Krok 7 se v prezentaci ukáže až po přepočtu.',
        postaru: 'Prezentovat postaru',
        prepocitat: 'Přepočítat a prezentovat',
        zrusit: 'Zpět',
      },
    },
    kroky: {
      proc: 'Proč',
      dnes: 'Kde jste dnes',
      zajisteni: 'Zajištění',
      rezerva: 'Rezerva',
      cile: 'Cíle',
      renta: 'Renta',
      dveCesty: 'Dvě cesty',
      kolik: 'Kolik to stojí',
      triKroky: 'Tři kroky',
    },
    zaklad: {
      krokCislo: 'Krok {n}',
      stitek: {
        nezadano: 'nezadáno',
        navrh: 'návrh',
        postaru: 'spočítáno postaru',
        odhad: 'odhad',
        poplatky: 'poplatky nezadané',
      },
      model: {
        veta: 'Modelově · {scenar} · v dnešních cenách · před poplatky',
        cara: 'tečkovaná čára',
        scenar: {
          realisticky: 'realistický scénář',
          pesimisticky: 'pesimistický scénář',
          optimisticky: 'optimistický scénář',
        },
        garance: 'Model z vašich čísel, ne garance.',
      },
      poplatky: {
        vychozi: 'po výchozím poplatku za správu {sprava} %',
        zadane: 'po poplatcích: vstupní {vstupni} %, správa {sprava} %',
        legenda: '{cara} = {popis}',
        legendaCastka: '{cara} = {popis}: {castka}',
      },
      nacitani: 'Načítám čísla plánu…',
    },
  },
  /* BLOK:navrhV2 END */
  /* Trychtýř od A do Z (/nastroje/trychtyr) — jen ovládání; šablony cs+sk jsou v data/trychtyrBuilder.js. */
  trychtyrBuilder: {
    title: "Trychtýř od A do Z",
    info: "Sedm kroků podle metodiky Konverzky: magnet → stránka → děkovačka → hovor → mini-webinář → e-maily → reklama a měření. Šablony vyplníš sám, nic negeneruje AI; ukládá se na server pro tebe.",
    krokN: "Krok {n}", hotovo: "Hotovo", rozpracovano: "Rozpracováno", nezacato: "Nezačato", postup: "Postup", hotovychKroku: "{h} z {n} hotovo",
    ulozit: "Uložit", ukladam: "Ukládám…", ulozeno: "Uloženo {cas}", ulozenoBezCasu: "Uloženo", neulozeno: "Neuloženo", ulozeniSelhalo: "Uložení selhalo", zkusitZnovu: "Zkusit znovu",
    mistniKopie: "Server nedostupný — pracuješ s místní kopií z tohoto prohlížeče. Uložení zkusím znovu.",
    nacitam: "Načítám…", povinne: "povinné", vyber: "— vyber —",
    vlozitSablonu: "Vložit šablonu", pouzitNavrh: "Použít návrh do prázdných polí", dosaditTitulek: "Dosadit do titulku", pravidlaTitulku: "Pravidla titulku",
    mojeOdkazy: "Moje odkazy ke sdílení", nahledBezSlugu: "Zatím jen náhled — pro ostrý odkaz si nastav odkaz vizitky v", nastaveni: "Nastavení",
    otevrit: "Otevřít", kopirovat: "Kopírovat", zkopirovano: "Zkopírováno", kopieSelhala: "Kopírování selhalo", tisk: "Tisk / PDF", tiskSelhal: "Tisk se nepodařilo otevřít",
    zasady: "6 zásad obchodního systému", krokyHovoru: "9 kroků hovoru", beaty: "Scénář beat po beatu (pořadí je závazné)",
    emailyOblouk: "Oteplovací oblouk — 6 dní + doručení", emailyNoBooking: "Když si po poptávce nerezervuje termín", emailySekvence: "E-mailová sekvence",
    den: "Den", cil: "Cíl", predmet: "Předmět", nahledRadek: "Náhledový řádek", telo: "Text", ctaTlacitko: "Text odkazu (CTA)", testPraveRuky: "Test pravé ruky", kopirovatSekvenci: "Kopírovat celou sekvenci",
    uhly: "Reklamní úhly — reklama prodává proklik", kanaly: "Kanály a nastavení", navodMereni: "Měření krok za krokem", otevritNastaveni: "Nastavení webu → Měření", idNastaveno: "ID nastaveno", idChybi: "ID chybí", format: "formát",
    checklist: "Kontrola před spuštěním", predchozi: "Předchozí", dalsi: "Další krok",
  },
};
export default cs;
